/* jshint -W097 */
/* jshint -W034 */
'use strict';
(function () {
    angular.module('App.ETWPages', ['ngSanitize', 'ui.router', 'App']);
    angular.module('App.Templates', []);
    // OPTIONAL MODULES
    angular.module('MockETWServices', []).constant('IS_MOCKED', false);
    angular.module('App.Meetings', []);
    angular.module('App.ActionItems', []);
    /**
     * Stages of the app:
     * 1. AngularJS config - providers only, no services
     * 2. ETW Config - blocks controllers (step 4) (ui-router waits to call components/controllers)
     * 3. AngularJS run - code to run first, with services, but doesn't block controllers, et alia from running
     * 4. Everything else
     *
     * Step 2 runs before—but doesn't block—step 3. Step 4 doesn't run until step 2 resolves.
     * ETW Config is in the getConfig() method in routes.js
     */
    angular
        .module('App', [
        'ui.router',
        'App.TrayNav',
        'App.ActionItems',
        'App.Meetings',
        'App.Routes',
        'App.Templates',
        'App.Layout',
        'App.Util',
        'App.ETWPages',
        'cgNotify',
        'as.sortable',
        'angular.filter',
        'nya.bootstrap.select',
        'ngAnimate',
        'focus-if',
        'ngFileUpload',
        'uiCropper',
        'http-auth-interceptor',
        'ya.nouislider',
        'ui.mask',
        'ngIdle',
    ])
        .value('CLIENT_SETTINGS', {})
        .config([
        '$animateProvider',
        // @ts-ignore ts-migrate(7006) FIXME: Parameter '$animateProvider' implicitly has an 'an... Remove this comment to see the full error message
        function ($animateProvider) {
            //disable animations for elements with class of ng-animate-disabled
            //http://davidchin.me/blog/disable-nganimate-for-selected-elements/
            $animateProvider.classNameFilter(/^(?:(?!ng-animate-disabled).)*$/);
        },
    ]);
})();

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
(function () {
    angular
        .module('App')
        .run(['$window', 'ENVIRONMENT', 'GOOGLE_ANALYTICS', 'IS_MOCKED', runAnalytics])
        .factory('Analytics', [
        '$window',
        'ENVIRONMENT',
        'GOOGLE_ANALYTICS',
        'IS_MOCKED',
        AnalyticsService,
    ]);
    /**
     * @function runAnalytics
     * @constructor
     * A separate run method for embedding Google Analytics
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$window' implicitly has an 'any' type.
    function runAnalytics($window, ENVIRONMENT, GOOGLE_ANALYTICS, IS_MOCKED) {
        if (!IS_MOCKED) {
            // Only if not mocked
            //GOOGLE ANALYTICS
            var googleProperty = GOOGLE_ANALYTICS[ENVIRONMENT].property;
            if (googleProperty) {
                //google code does not comply with jshint!
                /* jshint ignore:start */
                (function (i, s, o, g, r, a, m) {
                    i['GoogleAnalyticsObject'] = r;
                    (i[r] =
                        i[r] ||
                            function () {
                                (i[r].q = i[r].q || []).push(arguments);
                            }),
                        // @ts-ignore ts-migrate(2363) FIXME: The right-hand side of an arithmetic operation mus... Remove this comment to see the full error message
                        (i[r].l = 1 * new Date());
                    // @ts-ignore ts-migrate(2322) FIXME: Type 'HTMLElement' is not assignable to type 'unde... Remove this comment to see the full error message
                    (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
                    // @ts-ignore ts-migrate(2532) FIXME: Object is possibly 'undefined'.
                    a.async = 1;
                    // @ts-ignore ts-migrate(2532) FIXME: Object is possibly 'undefined'.
                    a.src = g;
                    // @ts-ignore ts-migrate(2532) FIXME: Object is possibly 'undefined'.
                    m.parentNode.insertBefore(a, m);
                })($window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
                // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'ga'.
                ga('create', googleProperty, 'auto');
                /* jshint ignore:end */
            }
        }
    }
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$window' implicitly has an 'any' type.
    function AnalyticsService($window, ENVIRONMENT, GOOGLE_ANALYTICS, IS_MOCKED) {
        var methods = {
            hardcodedDiscussionPointTemplate: hardcodedDiscussionPointTemplate,
            dynamicDiscussionPointTemplate: dynamicDiscussionPointTemplate,
            copyDiscussionPointFromPreviousMeetingInstance: copyDiscussionPointFromPreviousMeetingInstance,
            meetingsSortToggle: meetingsSortToggle,
            inlineReplyToNoteOnStream: inlineReplyToNoteOnStream,
            inlineReplyToNoteOnStreamSave: inlineReplyToNoteOnStreamSave,
            inlineReplyToNoteOnStreamSaveAndArchive: inlineReplyToNoteOnStreamSaveAndArchive,
        };
        var methodNames = Object.keys(methods);
        return __assign(__assign({}, methods), { wrap: wrap });
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'analyticFn' implicitly has an 'any' typ... Remove this comment to see the full error message
        function wrap(analyticFn, wrappedFn) {
            // @ts-ignore ts-migrate(2550) FIXME: Property 'includes' does not exist on type 'string... Remove this comment to see the full error message
            if (!methodNames.includes(analyticFn.name)) {
                console.log(analyticFn.name + " is not a supported Analytic.");
            }
            // @ts-ignore ts-migrate(7019) FIXME: Rest parameter 'args' implicitly has an 'any[]' ty... Remove this comment to see the full error message
            return function _wrap() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                analyticFn();
                return wrappedFn.apply(void 0, args);
            };
        }
        function hardcodedDiscussionPointTemplate() {
            // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'ga'.
            ga('send', {
                hitType: 'event',
                eventCategory: 'discussion_point',
                eventAction: 'more_options',
                eventLabel: 'apply_template_hardcoded_checkin',
            });
        }
        function dynamicDiscussionPointTemplate() {
            // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'ga'.
            ga('send', {
                hitType: 'event',
                eventCategory: 'discussion_point',
                eventAction: 'more_options',
                eventLabel: 'apply_template_dynamic',
            });
        }
        function copyDiscussionPointFromPreviousMeetingInstance() {
            // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'ga'.
            ga('send', {
                hitType: 'event',
                eventCategory: 'discussion_point',
                eventAction: 'more_options',
                eventLabel: 'copy_previous',
            });
        }
        function meetingsSortToggle() {
            // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'ga'.
            ga('send', {
                hitType: 'event',
                eventCategory: 'meetings_homepage',
                eventAction: 'more_options',
                eventLabel: 'toggle_meeting_sort_type',
            });
        }
        function inlineReplyToNoteOnStream() {
            // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'ga'.
            ga('send', {
                hitType: 'event',
                eventCategory: 'stream_homepage',
                eventAction: 'more_options',
                eventLabel: 'inline_reply_to_note_on_stream',
            });
        }
        function inlineReplyToNoteOnStreamSave() {
            // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'ga'.
            ga('send', {
                hitType: 'event',
                eventCategory: 'stream_homepage',
                eventAction: 'more_options',
                eventLabel: 'inline_reply_to_note_on_stream_save',
            });
        }
        function inlineReplyToNoteOnStreamSaveAndArchive() {
            // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'ga'.
            ga('send', {
                hitType: 'event',
                eventCategory: 'stream_homepage',
                eventAction: 'more_options',
                eventLabel: 'inline_reply_to_note_on_stream_save_and_archive',
            });
        }
    }
})();

(function () {
    /**
     * @property stateHistory
     * @type {Array}
     * Collection of past states used for contextual back buttons.
     * This needs to be outside the app because it is referenced by both
     * the config and run stages.
     * Viz., $state.go (decorator) and $rootScope.goBack both reference this array.
     */
    var stateHistory = [];
    /**
// @ts-ignore ts-migrate(7034) FIXME: Variable 'stateHistory' implicitly has type 'any[]... Remove this comment to see the full error message
     * @function addToStateHistory
     * @param name {string}
     * @param [params] {object}
     * This function needs to be outside the app because it is referenced by $state.go and $stateChangeSuccess
     */
    function addToStateHistory(name, params) {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'name' implicitly has an 'any' type.
        // Prepend an entry to the state history. Strip params of "undefined" properties. All values must be strings.
        stateHistory.unshift({
            name: name,
            params: _(params)
                .omitBy(_.isNil)
                .mapValues(String)
                .value(),
        });
        // Truncate the state history to 5 items.
        stateHistory.splice(25);
    }
    angular
        .module('App')
        .config(['$provide', StateHistoryConfig])
        .run([
        '$location',
        // @ts-ignore ts-migrate(7005) FIXME: Variable 'stateHistory' implicitly has an 'any[]' ... Remove this comment to see the full error message
        '$rootScope',
        '$state',
        '$window',
        'AuthenticationService',
        'NotificationService',
        'notify',
        'TEMPLATE_PATH',
        AppRun,
    ]);
    /**
     * @function AppRun
     * @constructor
     * Runs after the angular code has been initialized
     */
    function AppRun($location, $rootScope, $state, $window, AuthenticationService, NotificationService, notify, TEMPLATE_PATH) {
        // Start up communications
        NotificationService.init();
        // @ts-ignore ts-migrate(7006) FIXME: Parameter '$location' implicitly has an 'any' type... Remove this comment to see the full error message
        //get the title generated from the index.*.html file
        // @ts-ignore ts-migrate(7006) FIXME: Parameter '$window' implicitly has an 'any' type.
        var indexTitle = $window.document.title, 
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'notify' implicitly has an 'any' type.
        appLoaderElement = $window.document.querySelector('#app_loader');
        /**
         * @property previousNotification
         * @type {object}
         * Used to compare two consecutive notifications to make sure they aren't duplicates, e.g. from an infinite loop
         */
        var previousNotification = {};
        // AngularNotify settings
        notify.config({ maximumOpen: 5 });
        // hide the view loader
        if (appLoaderElement) {
            // NOTE: element doesn't exist in unit tests
            appLoaderElement.style.display = 'none';
        }
        /**
         * @method getStateHistory
         * @param [steps] {number}
         * @returns {object} - { name, params }
         * @deprecated - Was replaced by shiftStateHistory. Probably won't be needed for anything else.
         * See the current state and the past 4.
         * Used to determine where back arrows link to.
         */
        $rootScope.getStateHistory = function (steps) {
            return stateHistory[steps || 0];
        };
        /**
         * @method shiftStateHistory
         * @returns {object} - state, represented by {name, params}
         * Gets the last state from history AND deletes it from history.
         * Use by goBack() method used by the back arrows in the app.
         */
        $rootScope.shiftStateHistory = function () {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'steps' implicitly has an 'any' type.
            return stateHistory.shift();
        };
        /**
// @ts-ignore ts-migrate(7005) FIXME: Variable 'stateHistory' implicitly has an 'any[]' ... Remove this comment to see the full error message
         * @method goBack
         * @param defaultRoute {string}
         * @param [defaultRouteParams] {object}
         * @param [isAllowRecursiveRoutes] {boolean}
         * @param [options] {object} - ui-sref-opts
         * Determine which state "back" is.
         * Note: E.g. app.about.index and app.about.stuff are both in the same "route group."
// @ts-ignore ts-migrate(7005) FIXME: Variable 'stateHistory' implicitly has an 'any[]' ... Remove this comment to see the full error message
         *       If the default route doesn't match the previous route, then the function
         *       keeps going back until a route is found _outside_ the route group.
         * Note: The current state will always be the first lastState.
         * Note: Wouldn't work with relative (e.g. ^) routes, so $state.go decorator resolves them first.
         *
         * "Recursive routes" are parent-child routes like plans and subplans. Pass true to allow the
         * user to navigate to a route with the same name but different parameters.
         * (If this doesn't work, then the next step would be replace the boolean with the parameter that matters.)
         */
        $rootScope.goBack = function (defaultRoute, defaultRouteParams, isAllowRecursiveRoutes, options) {
            var lastStateGroup, currentStateGroup, isCurrentStateGroupInLastStateGroup;
            // Get only the defined params, cast as strings
            var currentParams = _($state.params)
                .omitBy(_.isNil)
                .mapValues(String)
                .value();
            // Get the last state by removing it from the history list. This prevents infinite loops.
            var lastState = $rootScope.shiftStateHistory();
            if (!angular.isObject(options)) {
                options = {};
            }
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'defaultRoute' implicitly has an 'any' t... Remove this comment to see the full error message
            // url parameters are always strings, its hard to cast strings in the templates.
            defaultRouteParams = _.mapValues(defaultRouteParams, String);
            if (lastState &&
                (lastState.name !== defaultRoute || !_.isEqual(lastState.params, defaultRouteParams))) {
                lastStateGroup = lastState.name.replace(/\.[-_a-z]+$/, '');
                currentStateGroup = $state.current.name.replace(/\.[-_a-z]+$/, '');
                isCurrentStateGroupInLastStateGroup = lastStateGroup.indexOf(currentStateGroup) === 0;
                // old way: previous state is not the same as the default
                // old way: if( ! isAllowRecursiveRoutes && lastState.name.replace(/\.[-_a-z]+$/, '') === $state.current.name.replace(/\.[-_a-z]+$/, '') ) {
                // Is the current state a child of the last state? If so, skip. goBack shouldn't drill down.
                if (!isAllowRecursiveRoutes && isCurrentStateGroupInLastStateGroup) {
                    // If previous state was in the same route group, keep iterating back
                    $rootScope.goBack(defaultRoute, defaultRouteParams, isAllowRecursiveRoutes, options);
                }
                else if (isAllowRecursiveRoutes &&
                    lastState.name === $state.current.name &&
                    _.isEqual(lastState.params, currentParams)) {
                    // name is same as current and params are the same
                    $rootScope.goBack(defaultRoute, defaultRouteParams, isAllowRecursiveRoutes, options);
                }
                else {
                    // state is different enough
                    $state.go(lastState.name, lastState.params, options);
                }
            }
            else {
                // If no lastState, or lastState is the default, go to the default
                // inherit:false clears the query parameters
                _.defaults(options, { inherit: false });
                $state.go(defaultRoute, defaultRouteParams, options);
            }
        };
        /**
         * @listener $stateChangeStart
         * Invoked before a state has loaded
         */
        $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
            if (toState.name === 'signin') {
                // Internal auth
                if (AuthenticationService.isAuthenticated()) {
                    redirect(event, 'app.index');
                }
                return;
            }
            // Check to make sure the user is still signed in
            if (!AuthenticationService.isAuthenticated() && !toState.public) {
                event.preventDefault();
                AuthenticationService.init().then(function () {
                    if (!AuthenticationService.isAuthenticated()) {
                        AuthenticationService.logout();
                    }
                    else {
                        $state.go(toState, toParams);
                    }
                });
                return;
            }
            if (toState.redirectTo) {
                redirect(event, toState.redirectTo);
                return;
            }
            // access by module then by permissions
            if (toState.data) {
                if (!checkModule(toState)) {
                    event.preventDefault();
                    notifyRouteError(toState.data.moduleMessage);
                }
                else if (!checkPermissions(toState)) {
                    event.preventDefault();
                    notifyRouteError(toState.data.permissionMessage);
                }
            }
        });
        /**
         * @listener $stateChangeSuccess
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
         * Invoked after a state has been loaded
         */
        $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState) {
            // Google Analtyics
            if ($window.ga) {
                $window.ga('send', 'pageview', { page: $location.path() });
            }
            // update the title as defined by the .state() object.
            $window.document.title = (toState.title || '') + (toState.title ? ' | ' : '') + indexTitle;
            // If there isn't a from state, this must be something outside of a $state.go call
            // Add state to history manually.
            if (!fromState || !fromState.name) {
                addToStateHistory(toState.name, toParams);
            }
            // Close all notifications when the state changes.
            notify.closeAll();
        });
        /**
         * @listener $stateChangeError
         * Log routing errors
         */
        $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
            var from = AuthenticationService.encodeReferrer();
            console.error('STATE CHANGE ERROR', error);
            console.info('toState', toState);
            console.info('fromState', fromState);
            console.trace();
            if ((!fromState || !fromState.name) && toState && toState.name != 'error') {
                // Fatal error, go to the error route.
                $state.go('error', { from: from });
            }
        });
        /**
         * @listener notify
         * @param event {Event}
         * @param message {string}
         * @param [type] {string} - [error|success|info] maps directly to CSS classes of .cg-notify-message
         * Global notification listener
         * Usage:
         *   $rootScope.$emit('notify', 'My message', 'error')
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
        $rootScope.$on('notify', function (event, message, type) {
            var notifyScope, now = new Date().getTime();
            // Make sure the notification isn't identical to the previous one.
            if (
            // @ts-ignore
            previousNotification.message !== message ||
                // @ts-ignore
                previousNotification.type !== type ||
                // @ts-ignore
                !previousNotification.time ||
                // @ts-ignore
                previousNotification.time < now - 9000) {
                notifyScope = $rootScope.$new(true);
                notifyScope.type = type || 'info';
                notify({
                    message: message,
                    scope: notifyScope,
                    templateUrl: TEMPLATE_PATH + '/notifications/angular-notify.html',
                });
                previousNotification = {
                    message: message,
                    type: type,
                    time: now,
                };
            }
        });
        /**
         * @listener event:auth-loginRequired
         * Listen for when API responses come back 'unauthorized'
         * Emitted by angular-http-auth vendor dependency
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
        $rootScope.$on('event:auth-loginRequired', AuthenticationService.refresh);
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'fromState' implicitly has an 'any' type... Remove this comment to see the full error message
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'fromParams' implicitly has an 'any' typ... Remove this comment to see the full error message
         * @function checkModule
         * @param toState {object}
         * Note: This only checks the JWT which only means a client is allowed to turn a module on.
         * CLIENT_SETTINGS, which might not be loaded yet, must also be checked. Do that at the component level.
         */
        function checkModule(toState) {
            return !toState.data.module || AuthenticationService.hasModule(toState.data.module);
        }
        /**
         * @function checkPermissions
         * @param toState {object}
         */
        function checkPermissions(toState) {
            var isPermitted = true;
            if (angular.isArray(toState.data.permission)) {
                isPermitted = _.every(toState.data.permission, AuthenticationService.hasPermission);
            }
            return isPermitted;
        }
        /**
         * @function notifyRouteError
         * @param message {string}
         * @private
         */
        function notifyRouteError(message) {
            $rootScope.$emit('notify', message, 'error');
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'message' implicitly has an 'any' type.
         * @function redirect()
         * @param event {object}
         * @param stateName {string}
         */
        function redirect(event, stateName) {
            event.preventDefault();
            $state.go(stateName);
        }
    }
    function StateHistoryConfig($provide) {
        /**
         * @decorator $state.go
         * Add logic to AngularUI Router's go() method to keep a proprietary version of
         * navigation state history.
         * State history is used by the custom left arrow button to determine where to go.
         *
         * Some route transitions cannot "notify" the app, because this would reload controllers,
         * possibly losing some user-entered data. The problem with this is the state history can't
         * be updated because the app doesn't know the route changed.
         *
         * Since all routes are changed by $state.go(), the solution is to decorate it to update
         * state history no matter what.
         *
         * Also, some routes need to be replaced, but that option isn't passed to the "notify" events.
         *
         * The history logic can't handle relative routes (e.g. "^.foo"). In these cases,
         * the decorator pulls in $state.get() to determine the full state name.
         * (This was originally introduced to handle paths to tabs within a goal modal that could be anywhere.)
         */
        $provide.decorator('$state', [
            '$delegate',
            function ($delegate) {
                // original $state.go method
                var original$stateGo = $delegate.go;
                $delegate.go = function (to, params, options) {
                    if (options && options.location && options.location == 'replace') {
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'toState' implicitly has an 'any' type.
                        // If previous route is to be 'replaced', remove it from stateHistory.
                        // Note: do this before addToStateHistory
                        stateHistory.shift();
                    }
                    if (to[0] == '^') {
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'toState' implicitly has an 'any' type.
                        // If path is relative, resolve it before adding to history (initially for the goal modal)
                        // Use $state.get():
                        to = $delegate.get(to).name;
                    }
                    // Add state to history
                    addToStateHistory(to, params);
                    // Call original $state.go method
                    return original$stateGo.apply($delegate, arguments);
                };
                return $delegate;
            },
        ]);
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'message' implicitly has an 'any' type.

(function () {
    angular
        .module('App')
        .run([
        '$rootScope',
        '$window',
        'AccountSettingsService',
        'AuthenticationService',
        'CLIENT_SETTINGS',
        ClientSettingsRun,
    ]);
    /**
     * @function ClientSettingsRun
     * @constructor
     * A separate run method for subscribing to CLIENT_SETTINGS changes.
     * Settings are fetched as a route resolve.
     */
    function ClientSettingsRun(
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$rootScope' implicitly has an 'any' typ... Remove this comment to see the full error message
    $rootScope, 
    // @ts-ignore ts-migrate(7006)
    $window, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AccountSettingsService' implicitly has ... Remove this comment to see the full error message
    AccountSettingsService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AuthenticationService' implicitly has a... Remove this comment to see the full error message
    AuthenticationService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'CLIENT_SETTINGS' implicitly has an 'any... Remove this comment to see the full error message
    CLIENT_SETTINGS) {
        // Listen to settings changes.
        // Run lives forever, so no reason to unsubscribe.
        AccountSettingsService.subscribe(getSettings);
        $rootScope.$on('user:change', getSettings);
        /**
         * @function getSettings()
         * Get the client settings object and make it accessible to the app via CLIENT_SETTINGS.
         */
        function getSettings() {
            AuthenticationService.init()
                .then(function () {
                return AccountSettingsService.get();
            })
                .then(updateClientSettings);
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
        function updateClientSettings(response) {
            _.assign(CLIENT_SETTINGS, response.data);
            // FEATURE ALIASES
            // These aliases are used for the "feature" directive.
            CLIENT_SETTINGS.ACTION_ITEMS = AuthenticationService.hasModule('ACTION_ITEMS');
            CLIENT_SETTINGS.COMMUNICATION = AuthenticationService.hasModule('COMMUNICATION');
            CLIENT_SETTINGS.ENGAGEMENT = !!CLIENT_SETTINGS.enableEngagement;
            CLIENT_SETTINGS.EVALUATIONS =
                AuthenticationService.hasModule('EVALUATION') && !!CLIENT_SETTINGS.enableEvaluations;
            CLIENT_SETTINGS.LINK_CATEGORIES = AuthenticationService.hasModule('GOAL_AUTO_LINK');
            CLIENT_SETTINGS.MEETINGS = AuthenticationService.hasModule('MEETINGS');
            CLIENT_SETTINGS.NEW_HOME_PAGE = AuthenticationService.hasModule('NEW_HOME_PAGE');
            CLIENT_SETTINGS.PLANS =
                AuthenticationService.hasModule('PLAN') && !!CLIENT_SETTINGS.enablePlans;
            CLIENT_SETTINGS.REPORTS = AuthenticationService.hasModule('REPORT');
            // Simplify tray feature for <tray-nav> in the 'app' route template
            CLIENT_SETTINGS.TRAY = CLIENT_SETTINGS.ACTION_ITEMS || CLIENT_SETTINGS.MEETINGS;
            // Tell the app the config is loaded
            // Necessary for layout-header and tray-navigation since they are above the router.
            $rootScope.$emit('config:loaded');
        }
    }
})();

(function () {
    angular.module('App').run(['$window', 'ENVIRONMENT', 'GOOGLE_ANALYTICS', runTranslate]);
    /**
     * @function runTranslate
     * @constructor
     * Add a global function for Google Translate.
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$window' implicitly has an 'any' type.
    function runTranslate($window, ENVIRONMENT, GOOGLE_ANALYTICS) {
        var script = document.createElement('script');
        // Add method to the global scope for Google Translate
        $window.googleTranslateElementInit = function () {
            try {
                new $window.google.translate.TranslateElement({
                    pageLanguage: 'en',
                    layout: $window.google.translate.TranslateElement.InlineLayout.SIMPLE,
                    gaTrack: true,
                    gaId: GOOGLE_ANALYTICS[ENVIRONMENT].property,
                }, 'google_translate_element');
            }
            catch (e) {
                console.error('LayoutFooterController: Could not initialize Google Translator');
                console.error(e);
            }
        };
        // Set the source of the Google JS file
        script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
        $window.document.body.appendChild(script);
    }
})();

(function () {
    angular
        .module('App')
        .config(['KeepaliveProvider', 'IdleProvider', IdleWatcherConfig])
        .run([
        '$rootScope',
        '$uibModal',
        'Idle',
        'AuthenticationService',
        'AccountSettingsService',
        'TEMPLATE_PATH',
        RunIdleWatcher,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'KeepaliveProvider' implicitly has an 'a... Remove this comment to see the full error message
    function IdleWatcherConfig(KeepaliveProvider, IdleProvider) {
        // How long to wait before prompting the user
        IdleProvider.idle(1200);
        // How long to wait from prompt to signout
        IdleProvider.timeout(60);
        IdleProvider.keepalive(false);
        // TODO will eventually want to also include a keep alive ping to get refresh token
        // KeepaliveProvider.interval(600);
    }
    /**
     * @function RunIdleWatcher
     * @constructor
     * A separate run method for starting the Idle user watch process and watching for events to warn the user or time them out.
     */
    function RunIdleWatcher(
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$rootScope' implicitly has an 'any' typ... Remove this comment to see the full error message
    $rootScope, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$uibModal' implicitly has an 'any' type... Remove this comment to see the full error message
    $uibModal, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'Idle' implicitly has an 'any' type.
    Idle, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AuthenticationService' implicitly has a... Remove this comment to see the full error message
    AuthenticationService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AccountSettingsService' implicitly has ... Remove this comment to see the full error message
    AccountSettingsService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TEMPLATE_PATH' implicitly has an 'any' ... Remove this comment to see the full error message
    TEMPLATE_PATH) {
        //cannot assume the settings is loaded at this point of app run
        AuthenticationService.init().then(function () {
            if (AuthenticationService.isAuthenticated()) {
                AccountSettingsService.get().then(start);
            }
        });
        /**
         * @function start
         * @param response {object} - $http response that contains account settings
         * @private
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
        function start(response) {
            var settings = response.data;
            if (settings.sessionTimeout) {
                //set the idle session timeout value based upon the account settings - in seconds
                Idle.setIdle(settings.sessionTimeout * 60);
            }
            //once authenticated we need to begin watching for Idle users.
            Idle.watch();
            //on timeout from idle log the user out
            $rootScope.$on('IdleTimeout', function () {
                AuthenticationService.logout();
            });
            $rootScope.$on('IdleStart', function () {
                // open the timeout warning modal
                $uibModal
                    .open({
                    animation: true,
                    controller: 'IdleModalController',
                    controllerAs: 'modalVm',
                    templateUrl: TEMPLATE_PATH + '/util/idle-modal/util.idle-modal.html',
                    size: 'md',
                })
                    .result.then(angular.noop, angular.noop);
            });
        }
    }
})();

(function () {
    angular.module('App').run(['$window', 'AuthenticationService', 'IS_MOCKED', 'INTERCOM_APP', runIntercom]);
    /**
     * @function runZendesk
     * @constructor
     * A separate run method for embedding Intercom Help Widget
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$window' implicitly has an 'any' type.
    function runIntercom($window, AuthenticationService, IS_MOCKED, INTERCOM_APP) {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'IS_MOCKED' implicitly has an 'any' type... Remove this comment to see the full error message
        if (!IS_MOCKED) {
            AuthenticationService.init().then(start);
        }
        /**
         * @function start
         * @private
         */
        function start() {
            if (AuthenticationService.isAuthenticated()) {
                var window_1 = $window;
                var currentUser = AuthenticationService.getAccount();
                window_1.Intercom('boot', {
                    app_id: INTERCOM_APP,
                    user_id: currentUser.userId,
                    user_hash: currentUser.intercom,
                    name: currentUser.firstName + ' ' + currentUser.lastName,
                    vertical_padding: 60,
                    horizontal_padding: 100,
                });
            }
        }
    }
})();
// @ts-ignore ts-migrate(7005) FIXME: Variable 'n' implicitly has an 'any' type.

(function () {
    angular.module('App').config(['$ocLazyLoadProvider', 'SRC_PATH', LazyLoadConfig]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$ocLazyLoadProvider' implicitly has an ... Remove this comment to see the full error message
    function LazyLoadConfig($ocLazyLoadProvider, SRC_PATH) {
        var config = {
            debug: false,
            serie: true,
            modules: [
                {
                    name: 'app.stream',
                    files: ['/execution-utils.module.js', '/goals-utils.module.js', '/resources.module.js', '/stream.module.js'],
                    serie: true,
                },
                {
                    name: 'app.goals',
                    files: ['/execution-utils.module.js', '/goals-utils.module.js', '/goals.module.js'],
                    serie: true,
                },
                {
                    name: 'app.people.utils',
                    files: [
                        '/execution-utils.module.js',
                        '/goals-utils.module.js',
                        '/people-utils.module.js',
                    ],
                    serie: false,
                },
                {
                    name: 'app.resources',
                    files: ['/resources.module.js'],
                    serie: true,
                },
                {
                    name: 'app.people',
                    files: ['/plans.module.js', '/teams.module.js', '/stream.module.js', '/people.module.js', '/admin-responsibilities.module.js', '/admin-roles.module.js'],
                    serie: true,
                },
                {
                    name: 'app.people.person-goals',
                    files: ['/goals.module.js'],
                },
                {
                    name: 'app.people.evaluations',
                    files: ['/goals-utils.module.js', '/evaluations.module.js', '/admin-responsibilities.module.js', '/people.module.js'],
                    serie: true,
                },
                {
                    name: 'app.teams',
                    files: ['/people-utils.module.js', '/teams.module.js'],
                    serie: true,
                },
                {
                    name: 'app.reports',
                    files: ['/reports.module.js'],
                },
                {
                    name: 'app.drivers',
                    files: ['/drivers.module.js'],
                    serie: true,
                },
                {
                    name: 'app.plans',
                    files: [
                        '/execution-utils.module.js',
                        '/goals-utils.module.js',
                        '/plans.module.js',
                    ],
                    serie: true,
                },
                {
                    name: 'app.plans.kpi',
                    files: ['/execution-utils.module.js', '/kpis.module.js'],
                    serie: true,
                },
                {
                    name: 'admin',
                    files: ['/admin.module.js'],
                },
                {
                    name: 'admin.attributes',
                    files: ['/admin-attributes.module.js'],
                },
                {
                    name: 'admin.goal-groups',
                    files: ['/execution-utils.module.js', '/goals-utils.module.js', '/admin-goals.module.js'],
                    serie: true,
                },
                {
                    name: 'admin.permissions',
                    files: ['/admin-permissions.module.js'],
                },
                {
                    name: 'admin.people',
                    files: ['/admin-people.module.js'],
                },
                {
                    name: 'admin.resources',
                    files: ['/admin-resources.module.js'],
                },
                {
                    name: 'admin.responsibilities',
                    files: ['/admin-responsibilities.module.js'],
                },
                {
                    name: 'admin.roles',
                    files: ['/admin-roles.module.js', '/admin-responsibilities.module.js'],
                },
                {
                    name: 'admin.settings',
                    files: ['/admin-settings.module.js'],
                },
                {
                    // Admin Meeting Templates
                    name: 'admin.meeting-templates',
                    files: ['/admin-meeting-templates.module.js'],
                },
                {
                    name: 'admin.janus',
                    files: ['/janus-services.module.js', '/admin-janus.module.js'],
                    serie: true,
                },
                {
                    name: 'admin.janus.levels',
                    files: ['/admin-janus-levels.module.js'],
                },
                {
                    name: 'admin.janus.competencies',
                    files: ['/admin-janus-competencies.module.js'],
                },
                {
                    name: 'janus',
                    files: ['/janus-services.module.js'],
                },
            ],
        };
        // Add the SRC_PATH to all file paths.
        config.modules = _.map(config.modules, function (module) {
            module.files = _.map(module.files, function (path) {
                return SRC_PATH + path;
            });
            return module;
        });
        $ocLazyLoadProvider.config(config);
    }
})();

(function () {
    angular
        .module('App')
        .run(['$window', 'AuthenticationService', 'ENVIRONMENT', 'WALK_ME', 'IS_MOCKED', runWalkMe]);
    /**
     * @function runWalkMe
     * @constructor
     * A separate run method for embedding WalkMe
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$window' implicitly has an 'any' type.
    function runWalkMe($window, AuthenticationService, ENVIRONMENT, WALK_ME, IS_MOCKED) {
    }
})();

'use strict';
(function () {
    angular.module('App.ActionItems', ['App', 'App.Util', 'ETWServices']);
})();

var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
(function () {
    angular.module('App.ActionItems').component('actionItemGenerators', {
        bindings: {
            actionStatus: '@',
            assigneeOptions: '=?',
            canEdit: '<?',
            create: '&',
            contextName: '<',
            getGeneratorBlank: '&',
            typeData: '=',
            actionContext: '<',
        },
        controller: [
            '$filter',
            '$sce',
            '$scope',
            '$state',
            '$timeout',
            'AccessModal',
            'ActionItemsService',
            'DeleteWithChallengeModal',
            'RecurrenceModal',
            'TrayRouter',
            ActionItemsGeneratorsController,
        ],
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return TEMPLATE_PATH + '/action-items/action-item-generators/action-item-generators.html';
            },
        ],
    });
    function ActionItemsGeneratorsController($filter, $sce, $scope, $state, $timeout, AccessModal, ActionItemsService, DeleteWithChallengeModal, RecurrenceModal, TrayRouter) {
        var vm = this;
        vm.$onInit = init;
        /**
         * @property cadenceOptions
         * @type {Array}
         */
        vm.cadenceOptionsOneTime = [
            'One Day',
            'One Week',
            'Two Weeks',
            'One Month',
            'Two Months',
            'Three Months',
            'Six Months',
            'One Year',
        ];
        vm.cadenceOptions = [
            {
                text: 'Every weekday (Monday to Friday)', current: false, recurrence: {
                    startDate: new Date(),
                    ends: 'never',
                    endDate: new Date(),
                    repeatEvery: 0,
                    repeatFrequency: 1,
                    days: {
                        'sun': false,
                        'mon': true,
                        'tue': true,
                        'wed': true,
                        'thu': true,
                        'fri': true,
                        'sat': false,
                    }
                }
            },
            { text: 'Custom...', current: false },
        ];
        vm.customSelection = {};
        /**
         * @property dueInOptions
         * @type {Array}
         */
        vm.dueInOptions = [
            'One Day',
            'One Week',
            'Two Weeks',
            'One Month',
            'Two Months',
            'Three Months',
            'Six Months',
            'One Year',
        ];
        /**
         * @property expandedActionItems
         * @type {Object}
         */
        vm.expandedActionItems = {
            oneTime: {},
            recurring: {},
        };
        /**
         * @property isCreating
         * @type {boolean}
         */
        vm.isCreating = false;
        /**
         * @property newActionItem
         * @type {Object}
         */
        vm.newActionItem = {};
        /**
         * @property roleTitle
         * @type {string}
         */
        vm.roleTitle = '';
        vm.generators = [];
        /**
         * @property recurringAdminAI
         * @type {Array}
         */
        vm.recurringAdminAI = [];
        /**
         * @property oneTimeAdminAI
         * @type {Array}
         */
        vm.oneTimeAdminAI = [];
        /**
         * @property userCache
         * @type {Object}
         * Map of assignees and assignors so they are only fetched from the API once.
         */
        vm.userCache = {};
        vm.fn = {
            close: TrayRouter('action-items').close,
            create: create,
            canAddNewActionItem: canAddNewActionItem,
            focusCreateInput: focusCreateInput,
            getAssigneeTooltip: getAssigneeTooltip,
            getIconTooltip: ActionItemsService.getIconTooltip,
            onChangeCadence: onChangeCadence,
            onChangeCadenceV1: onChangeCadenceV1,
            onChangeAppearsOnDate: onChangeAppearsOnDate,
            onChangeFirstDueDate: onChangeFirstDueDate,
            onChangeDescription: onChangeDescription,
            onChangeActionItemCadence: onChangeActionItemCadence,
            onChangeNewActionItemCadence: onChangeNewActionItemCadence,
            onChangeNewActionItemUser: onChangeNewActionItemUser,
            onChangeRoleAIView: onChangeRoleAIView,
            onChangeTitle: onChangeTitle,
            onChangeUser: onChangeUser,
            onNewActionItemKeyUp: onNewActionItemKeyUp,
            onSortByChange: onSortByChange,
            remove: remove,
            toggleExpand: toggleExpand,
        };
        /**
         * @property tomorrow
         * @type {Date}
         * Used to prevent the start date from allowing selections in the past.
         */
        vm.tomorrow = new Date();
        vm.tomorrow.setDate(vm.tomorrow.getDate() + 1);
        vm.tomorrow.setHours(0, 0, 0, 0);
        /**
         * @property view
         * @type {string}
         */
        vm.view = 'oneTime';
        function init() {
            var generators, partitions;
            if (angular.isUndefined(vm.canEdit)) {
                vm.canEdit = true;
            }
            vm.view = vm.actionStatus || 'oneTime';
            vm.newActionItem = vm.getGeneratorBlank();
            buildCadenceTypes();
            if (vm.contextName === 'roles') {
                vm.roleTitle = vm.typeData.title;
                generators = vm.typeData.actionItemGenerators;
                // Partition generators into two groups: 0=recurring is truthy, 1=recurring is falsey.
                partitions = _.partition(generators, 'isRecurring');
                vm.oneTimeAdminAI = partitions[1];
                vm.recurringAdminAI = addLocalPropertiesToCollection(partitions[0]);
                if (vm.view === 'oneTime') {
                    vm.generators = vm.oneTimeAdminAI;
                }
                else {
                    vm.generators = vm.recurringAdminAI;
                }
            }
            else {
                vm.generators = addLocalPropertiesToCollection(vm.typeData);
            }
        }
        /**
         * @function actionItemCreateError
         * @private
         * @param error {error}
         */
        function actionItemCreateError(error) {
            console.error('ERROR CREATING PERSONAL ACTION ITEM', error);
        }
        /**
         * @function actionItemCreateSuccess
         * @private
         * @param savedActionItem {object}
         * Adds saved Action item to visible list.
         * Resets `vm.newActionItem`.
         */
        function actionItemCreateSuccess(savedActionItem) {
            highlight(savedActionItem);
            addLocalProperties(savedActionItem);
            if (vm.contextName === 'roles') {
                vm.typeData.actionItemGenerators.unshift(savedActionItem);
            }
            else {
                vm.typeData.unshift(savedActionItem);
            }
            vm.generators.unshift(savedActionItem);
            vm.newActionItem = vm.getGeneratorBlank();
            if (vm.view === 'recurring') {
                vm.newActionItem.isRecurring = true;
            }
        }
        /**
         * @function actionItemRemoveError
         * @private
         * @param error {error}
         */
        function actionItemRemoveError(error) {
            console.error('ERROR REMOVING PERSONAL ACTION ITEM', error);
        }
        /**
         * @function addLocalProperties
         * @private
         * @param actionItem {object}
         * @returns {object} actionItem
         */
        function addLocalProperties(actionItem) {
            var expandCollectionKey = vm.view;
            if (!_.has(vm.expandedActionItems, [expandCollectionKey, actionItem.id])) {
                vm.expandedActionItems[expandCollectionKey][actionItem.id] = false;
            }
            actionItem.cadenceOptions = __spreadArray([], vm.cadenceOptions);
            actionItem.recurrenceDescriptionSelect = { text: actionItem.recurrenceDescription, current: true };
            actionItem.cadenceOptions = actionItem.cadenceOptions.filter(function (item, idx) {
                return item.text !== actionItem.recurrenceDescription;
            });
            actionItem.cadenceOptions.unshift(actionItem.recurrenceDescriptionSelect);
            return actionItem;
        }
        /**
         * @function addLocalPropertiesToCollection
         * @private
         * @param actionItems {array}
         * @returns {array} transformed items
         */
        function addLocalPropertiesToCollection(actionItems) {
            return _.map(actionItems, addLocalProperties);
        }
        /**
         * @method canAddNewActionItem
         * @returns {boolean}
         */
        function canAddNewActionItem() {
            if (vm.isCreating)
                return false;
            if (vm.newActionItem.isRecurring)
                return vm.newActionItem.user && vm.newActionItem.title && vm.newActionItem.recurrence;
            return vm.newActionItem.cadenceType && vm.newActionItem.title;
        }
        /**
         * @method create
         * Sends `vm.newActionItem` to backend for creation.
         * Toggles `vm.isCreating` to prevent multiple saves.
         */
        function create() {
            vm.isCreating = true;
            if (vm.newActionItem.isRecurring) {
                delete vm.newActionItem.cadenceType;
            }
            var record = {
                actionItem: vm.newActionItem,
                contextName: vm.contextName,
            };
            // @ts-ignore ts-migrate(2339) FIXME: Property 'ownerEntityId' does not exist on type '{... Remove this comment to see the full error message
            record.ownerEntityId = vm.typeData.id;
            vm.create({ actionItem: record })
                .then(actionItemCreateSuccess, actionItemCreateError)
                .finally(function actionItemCreateFinally() {
                vm.isCreating = false;
            });
        }
        /**
         * @method focusCreateInput
         */
        function focusCreateInput() {
            $scope.$broadcast('inlineEdit:edit', 'NewActionItem');
        }
        /**
         * @property oneTimeInfoTemplate
         * @type {string}
         * Content for
         */
        vm.oneTimeInfoTemplate = $sce.trustAsHtml('<div><dl class="m-b-0"><dd>Our generators run nightly and it may take up to one full day to see new action items.</dd><dt> Existing assignees to the role</dt><dd>Will see new action items one day after the generator is created.</dd><dt>Future assignees to the role</dt><dd>Will see new action items one day after they are added to the role</dd></dl></div>');
        /**
         * @function getAssigneeTooltip
         * @returns {string}
         */
        function getAssigneeTooltip(userId) {
            var user = vm.userCache[userId];
            if (user) {
                return user.firstName + " " + user.lastName;
            }
            return "Action Item Assignee";
        }
        /**
         * @function highlight
         * @private
         * @param actionItem {object}
         */
        function highlight(actionItem) {
            actionItem._highlighted = true;
            $timeout(function () {
                actionItem._highlighted = false;
            }, 2000);
            return actionItem;
        }
        /**
         * @method onChangeCadence
         * @param actionItem {object}
         */
        function onChangeCadence(actionItem) {
            if (vm.contextName === 'roles') {
                actionItem.ownerEntityId = actionItem.assignedBy;
            }
            else {
                actionItem.ownerEntityId = actionItem.user;
            }
            buildRecurrence(actionItem);
            ActionItemsService.updateAIGenerator(actionItem, vm.contextName, [
                'cadenceType.text',
                'recurrence',
                'isRecurring',
            ]);
        }
        function onChangeCadenceV1(actionItem) {
            if (vm.contextName === 'roles') {
                actionItem.ownerEntityId = actionItem.assignedBy;
            }
            else {
                actionItem.ownerEntityId = actionItem.user;
            }
            ActionItemsService.updateAIGenerator(actionItem, vm.contextName, [
                'cadenceType',
            ]);
        }
        /**
         * @method onChangeAppearsOnDate
         * @param actionItem {object}
         * @param date {Date}
         */
        function onChangeAppearsOnDate(actionItem, date) {
            var changedProperties = ['startDate'];
            actionItem.startDate = date;
            if (actionItem.startDate.getTime() > actionItem.firstDueDate.getTime()) {
                actionItem.firstDueDate = new Date(actionItem.startDate.getTime());
                changedProperties.push('firstDueDate');
            }
            if (vm.contextName === 'roles') {
                actionItem.ownerEntityId = actionItem.assignedBy;
            }
            else {
                actionItem.ownerEntityId = actionItem.user;
            }
            ActionItemsService.updateAIGenerator(actionItem, vm.contextName, changedProperties);
        }
        /**
         * @method onChangeFirstDueDate
         * @param actionItem {object}
         * @param date {Date}
         */
        function onChangeFirstDueDate(actionItem, date) {
            var rec = angular.copy(actionItem);
            actionItem.firstDueDate = date;
            if (vm.contextName === 'roles') {
                actionItem.ownerEntityId = actionItem.assignedBy;
            }
            else {
                actionItem.ownerEntityId = actionItem.user;
            }
            ActionItemsService.updateAIGenerator(actionItem, vm.contextName, ['firstDueDate']).finally(function actionItemUpdateFinally() {
                if (actionItem.startDate.getTime() > actionItem.firstDueDate.getTime()) {
                    actionItem.firstDueDate = rec.firstDueDate;
                }
            });
        }
        /**
         * @method onChangeDescription
         * @param actionItem {object}
         */
        function onChangeDescription(actionItem) {
            if (vm.contextName === 'roles') {
                actionItem.ownerEntityId = actionItem.assignedBy;
            }
            else {
                actionItem.ownerEntityId = actionItem.user;
            }
            ActionItemsService.updateAIGenerator(actionItem, vm.contextName, ['description']);
        }
        function buildCadenceTypes() {
            var recurrence = {
                startDate: new Date(),
                ends: 'never',
                endDate: new Date(),
                //occurrences: 0,
                repeatEvery: 0,
                repeatFrequency: 0,
                days: {
                    'sun': false,
                    'mon': false,
                    'tue': false,
                    'wed': false,
                    'thu': false,
                    'fri': false,
                    'sat': false,
                }
            };
            var today = new Date();
            var day = $filter('date')(today, 'EEEE');
            var month = $filter('date')(today, 'LLLL');
            var date = $filter('date')(today, 'dd');
            var week = ActionItemsService.getNth(today);
            var monthNum = $filter('date')(today, 'M');
            var yearRecurrence = JSON.parse(JSON.stringify(recurrence));
            yearRecurrence.repeatFrequency = 3;
            yearRecurrence.yearMonth = monthNum - 1;
            yearRecurrence.yearMonthDate = date;
            yearRecurrence.repeatEvery = 1;
            vm.cadenceOptions.unshift({
                text: 'Annually on ' + month + ' ' + date,
                current: false,
                recurrence: yearRecurrence
            });
            var monthRecurrence = JSON.parse(JSON.stringify(recurrence));
            monthRecurrence.repeatFrequency = 2;
            ActionItemsService.setRecurrenceDay(monthRecurrence);
            monthRecurrence.monthNthDay = ActionItemsService.getNth(today);
            monthRecurrence.repeatEvery = 1;
            vm.cadenceOptions.unshift({
                text: 'Monthly on the ' + ActionItemsService.getNumberExtension(week, new Date()) + ' ' + day,
                current: false,
                recurrence: monthRecurrence
            });
            var weekRecurrence = JSON.parse(JSON.stringify(recurrence));
            weekRecurrence.repeatEvery = 1;
            weekRecurrence.repeatFrequency = 1;
            ActionItemsService.setRecurrenceDay(weekRecurrence);
            vm.cadenceOptions.unshift({ text: 'Weekly on ' + day, recurrence: weekRecurrence, current: false });
            var dayRecurrence = JSON.parse(JSON.stringify(recurrence));
            dayRecurrence.days.sun = true;
            dayRecurrence.days.mon = true;
            dayRecurrence.days.tue = true;
            dayRecurrence.days.wed = true;
            dayRecurrence.days.thu = true;
            dayRecurrence.days.fri = true;
            dayRecurrence.days.sat = true;
            vm.cadenceOptions.unshift({ text: 'Daily', current: false, recurrence: dayRecurrence });
        }
        /**
         *
         * @param actionItem
         */
        function onChangeActionItemCadence(actionItem) {
            if (vm.contextName === 'roles') {
                actionItem.ownerEntityId = actionItem.assignedBy;
            }
            else {
                actionItem.ownerEntityId = actionItem.user;
            }
            if (actionItem.recurrenceDescriptionSelect.text.startsWith('Custom')) {
                actionItem.cadenceType = { text: actionItem.recurrenceDescriptionSelect.text };
                RecurrenceModal.open({
                    actionItem: actionItem,
                    customSelection: vm.customSelection,
                }).then(function (result) {
                    actionItem.recurrence = result.recurrence;
                    actionItem.cadenceType = { text: result.description, current: false };
                    ActionItemsService.updateAIGenerator(actionItem, vm.contextName, [
                        'recurrence',
                        'recurrenceDescription',
                    ]).then(function (resp) {
                        actionItem.cadenceOptions.unshift(actionItem.cadenceType);
                        actionItem.recurrenceDescriptionSelect = actionItem.cadenceType;
                    });
                });
            }
            else {
                var changedProperties = [];
                if (actionItem.isRecurring) {
                    actionItem.recurrenceDescription = actionItem.recurrenceDescriptionSelect.text;
                    actionItem.recurrence = actionItem.recurrenceDescriptionSelect.recurrence;
                    if (actionItem.cadenceType) {
                        actionItem.cadenceType = actionItem.cadenceType.text;
                    }
                    changedProperties.push('recurrence');
                    changedProperties.push('recurrenceDescription');
                }
                else {
                    changedProperties.push('cadenceType');
                }
                ActionItemsService.updateAIGenerator(actionItem, vm.contextName, changedProperties);
            }
        }
        /**
         * @method onChangeNewActionItemCadence
         * @param newActionItem {object}
         */
        function onChangeNewActionItemCadence(newActionItem) {
            buildRecurrence(newActionItem);
        }
        /**
         *
         * @param actionItem
         * @param forUpdate boolean
         */
        function buildRecurrence(actionItem) {
            if (actionItem.cadenceType.text === 'Custom...') {
                RecurrenceModal.open({
                    actionItem: actionItem,
                    customSelection: vm.customSelection,
                }).then(function (result) {
                    actionItem.recurrence = result.recurrence;
                    actionItem.cadenceType = { text: result.description, current: false, recurrence: result.recurrence };
                    vm.cadenceOptions.unshift(actionItem.cadenceType);
                }, function () {
                    actionItem.cadenceType = vm.cadenceOptions[0];
                });
            }
            else {
                if (vm.view === 'recurring') {
                    vm.newActionItem.recurrenceDescription = actionItem.cadenceType.text;
                    actionItem.recurrence = vm.newActionItem.cadenceType.recurrence;
                    vm.newActionItem.recurrence = vm.newActionItem.cadenceType.recurrence;
                    vm.newActionItem.isRecurring = true;
                }
                else {
                    vm.newActionItem.isRecurring = false;
                    vm.newActionItem.cadenceType = actionItem.cadenceType;
                }
            }
        }
        /**
         * @method onChangeNewActionItemUser
         */
        function onChangeNewActionItemUser() {
            openSelectUserModal(vm.newActionItem, function primaryPersonHandler(personId) {
                vm.newActionItem.user = personId;
            });
        }
        /**
         * @method onChangeUser
         * @param actionItem {object}
         */
        function onChangeUser(actionItem) {
            //if (actionItem.canEdit) {
            openSelectUserModal(actionItem, function primaryPersonHandler(personId) {
                actionItem.user = personId;
                //ActionItemsService.update(actionItem, ['user'], vm.contextName);
            });
            //}
        }
        /**
         * @function onChangeRoleAIView
         * @private
         *  @param view {string}
         */
        function onChangeRoleAIView(view) {
            vm.view = view;
            vm.newActionItem = vm.getGeneratorBlank();
            if (vm.view === 'oneTime') {
                vm.generators = vm.oneTimeAdminAI;
                vm.newActionItem.isRecurring = false;
            }
            else {
                vm.generators = vm.recurringAdminAI;
                vm.newActionItem.isRecurring = true;
            }
        }
        /**
         * @method onChangeTitle
         * @param actionItem {object}
         */
        function onChangeTitle(actionItem) {
            if (vm.contextName === 'roles') {
                actionItem.ownerEntityId = actionItem.assignedBy;
            }
            else {
                actionItem.ownerEntityId = actionItem.user;
            }
            ActionItemsService.updateAIGenerator(actionItem, vm.contextName, ['title']);
        }
        /**
         * @method onNewActionItemKeyUp
         * @param event {Event}
         * Allow the user to create a new generator when they hit the enter/return key.
         */
        function onNewActionItemKeyUp(event) {
            if (event.which === 13 && canAddNewActionItem()) {
                create();
            }
        }
        /**
         * @function openSelectUserModal
         * @private
         * @param actionItem {object}
         * @param changePrimaryPersonIdHandler {Function}
         */
        function openSelectUserModal(actionItem, changePrimaryPersonIdHandler) {
            vm.assigneeOptions.getAssignableUsers().then(function (allPeopleIds) {
                AccessModal.openEdit(_.assign({}, vm.assigneeOptions.getDefaults(), {
                    title: 'Assignee',
                    columnHeaderPrefix: 'Available',
                    primaryPersonLabel: 'Assigned',
                    primaryPersonId: actionItem.user,
                    peopleIds: allPeopleIds,
                    closeOnSelect: true,
                    changePrimaryPersonId: changePrimaryPersonIdHandler,
                    initialFilters: {
                        peopleValues: allPeopleIds,
                    },
                }));
            });
        }
        /**
         * @method onSortByChange
         */
        function onSortByChange() {
            var descending = vm.sortMenu.isDescending ? '-' : '', column = vm.sortMenu.column;
            vm.sortMenu.sortOrder = descending + column;
        }
        /**
         * @method remove
         * @param actionItem {object}
         */
        function remove(actionItem) {
            DeleteWithChallengeModal.open({
                instructions: 'Confirm you are deleting an Action Item',
                itemType: 'Action Item',
                componentTitle: actionItem.title,
            }).then(function deleteConfirmed() {
                if (vm.contextName === 'roles') {
                    actionItem.ownerEntityId = actionItem.assignedBy;
                }
                else {
                    actionItem.ownerEntityId = actionItem.user;
                }
                ActionItemsService.destroyAIGenerator(actionItem, vm.contextName).then(function actionItemRemoveSuccess() {
                    return removeFromLists(actionItem);
                }, actionItemRemoveError);
            }, angular.noop);
        }
        /**
         * @function removeFromLists
         * @private
         * @param actionItem {object}
         * @returns {object} removed actionItem.
         * Removes from both lists. We don't know why, just that it needs to be gone.
         */
        function removeFromLists(actionItem) {
            _.remove(vm.generators, { id: actionItem.id });
            return actionItem;
        }
        /**
         * @method toggleExpand
         * @param actionItem {object}
         */
        function toggleExpand(actionItem) {
            var collectionName = vm.view, allExpandKey = collectionName + 'All', isItemExpanded = vm.expandedActionItems[collectionName][actionItem.id];
            vm.expandedActionItems[collectionName][actionItem.id] = !isItemExpanded;
            vm.expandedActionItems[allExpandKey] = _.every(_.values(vm.expandedActionItems[collectionName]));
        }
    }
})();

(function () {
    angular.module('App.ActionItems').component('adminActionItemGenerator', {
        bindings: {
            contextName: '<',
            typeData: '=',
        },
        controller: ['ActionItemsService', AdminActionItemGeneratorController],
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return (TEMPLATE_PATH + '/action-items/action-item-generators/action-item-generators-wrapper.html');
            },
        ],
    });
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ActionItemsService' implicitly has an '... Remove this comment to see the full error message
    function AdminActionItemGeneratorController(ActionItemsService) {
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        vm.fn = {
            create: create,
            getBlank: getBlank,
        };
        vm.userCanCreate = true;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function create(actionItem) {
            return ActionItemsService.createAIGenerator(actionItem, vm.contextName);
        }
        function getBlank() {
            return _.assign(ActionItemsService.getBlankAIGenerator(), {
                cadenceType: null,
            });
        }
    }
})();

(function () {
    angular.module('App.ActionItems').component('delegatedActionItems', {
        bindings: {
            contextName: '<?',
            getComplete: '&',
            getIncomplete: '&',
            filterMenuOptions: '=',
        },
        controller: [
            '$scope',
            '$state',
            '$timeout',
            'AccessModal',
            'ActionItemsService',
            'AuthenticationService',
            'DeleteWithChallengeModal',
            'PeopleService',
            'TrayRouter',
            DelegateActionItemsController,
        ],
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return TEMPLATE_PATH + '/action-items/delegated-action-items/delegated-action-items.html';
            },
        ],
    });
    function DelegateActionItemsController(
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$scope' implicitly has an 'any' type.
    $scope, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$state' implicitly has an 'any' type.
    $state, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$timeout' implicitly has an 'any' type.
    $timeout, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AccessModal' implicitly has an 'any' ty... Remove this comment to see the full error message
    AccessModal, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ActionItemsService' implicitly has an '... Remove this comment to see the full error message
    ActionItemsService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AuthenticationService' implicitly has a... Remove this comment to see the full error message
    AuthenticationService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'DeleteWithChallengeModal' implicitly ha... Remove this comment to see the full error message
    DeleteWithChallengeModal, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'PeopleService' implicitly has an 'any' ... Remove this comment to see the full error message
    PeopleService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TrayRouter' implicitly has an 'any' typ... Remove this comment to see the full error message
    TrayRouter) {
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        /**
         * @parameter currentUserId
         * @type {Number}
         */
        var currentUserId = AuthenticationService.getAccount().userId;
        /**
         * @parameter listeners
         * @type {object}
         */
        var listeners = {
            destroy: null,
            localUpdate: null,
            pubnubUpdate: null,
        };
        /**
         * @property setDatepickerEditing
         * @private
         * @type {Function}
         * Trying to hide the due date icon when editing a date.
         * When a datepicker is activated it broadcasts an event.
         * After its done and calls its onChange handler it rebroadcast
         *  the same editing event.
         */
        var setDatepickerEditing = _.throttle(function _setDatepickerEditing(actionItemId, isEditing) {
            vm.datepickerInEditMode[actionItemId] = isEditing;
        }, 100, { trailing: false });
        vm.$onInit = init;
        vm.$onDestroy = destroyComponent;
        /**
         * @property incompleteActionItems
         * @type {Array}
         */
        vm.incompleteActionItems = [];
        /**
         * @property completeActionItems
         * @type {Array}
         */
        vm.completeActionItems = [];
        /**
         * @property expandedActionItems
         * @type {Object}
         */
        vm.expandedActionItems = {
            complete: {},
            incomplete: {},
            completeAllExpanded: false,
            incompleteAllExpanded: false,
        };
        /**
         * @property pagination
         * @type {Object}
         */
        vm.pagination = {
            pageSize: 5,
            pageNumber: 1,
        };
        /**
         * @property sortMenu
         * @type {object}
         */
        vm.sortMenu = {
            sortOrder: 'dueDate',
            defaultColumn: 'dueDate',
            options: [
                {
                    column: 'dueDate',
                    label: 'Due Date',
                },
            ],
        };
        vm.fn = {
            close: TrayRouter('action-items').close,
            canComplete: canComplete,
            getIconTooltip: ActionItemsService.getIconTooltip,
            getMoreCompleted: getMoreCompleted,
            goToMeetingSeries: goToMeetingSeries,
            isMatchFilter: isMatchFilter,
            onChangeCompleted: onChangeCompleted,
            onChangeDate: onChangeDate,
            onChangeDescription: onChangeDescription,
            onChangeProgress: onChangeProgress,
            onChangeTitle: onChangeTitle,
            remove: remove,
            toggleExpand: toggleExpand,
        };
        /**
         * @property datepickerInEditMode
         * @type {Object}
         * Need to keep track of which datepickers are in edit mode
         * so we can show/hide an items duedate icon.
         */
        vm.datepickerInEditMode = {};
        /**
         * @property userCache
         * @type {Object}
         * Map of assignees and assignors so they are only fetched from the API once.
         */
        vm.userCache = {};
        /**
         * @listener datepicker:isEditing
         * @param event {Event}
         * @param listenerKey {string}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
        $scope.$on('datepicker:isEditing', function (event, listenerKey) {
            var parts = listenerKey.split('|'), actionItemId = Number(parts[1]);
            setDatepickerEditing(actionItemId, true);
        });
        function init() {
            getIncomplete();
            getComplete();
            listeners.destroy = ActionItemsService.subscribeToOperation('destroy', removeFromLists);
            listeners.pubnubUpdate = ActionItemsService.subscribeToOperation('pubnubUpdate', ifActionItemExistsLocally(refetch, getIncomplete));
            listeners.localUpdate = ActionItemsService.subscribeToOperation('localUpdate', ifActionItemExistsLocally(acceptUpdate, getIncomplete));
        }
        /**
         * @function acceptUpdate
         * @private
         * @param {object} actionItem
         * @param {string} contextName
         * @param {Array} [changedProperties]
         * Merge updates from event into existing action item and resort.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function acceptUpdate(actionItem, contextName, changedProperties) {
            var originalActionItem, safeActionItem;
            originalActionItem = _.find(vm.completeActionItems, {
                id: actionItem.id,
            });
            if (!originalActionItem) {
                originalActionItem = _.find(vm.incompleteActionItems, {
                    id: actionItem.id,
                });
            }
            if (contextName === vm.contextName && changedProperties) {
                // If update comes from the same context, then just update properties
                // the user is not currently editing.
                safeActionItem = _.omit(actionItem, changedProperties);
            }
            else {
                // If the change comes from a different context, completely overwrite the item
                safeActionItem = actionItem;
            }
            _.assign(originalActionItem, safeActionItem);
            removeFromLists(originalActionItem);
            storeByCompletedStatus(originalActionItem);
            // If someone else changed the date, we don't
            // want to think our user is editing the date.
            setDatepickerEditing(originalActionItem.id, false);
        }
        /**
         * @function actionItemRemoveError
         * @private
         * @param error {error}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'error' implicitly has an 'any' type.
        function actionItemRemoveError(error) {
            console.error('ERROR REMOVING PERSONAL ACTION ITEM', error);
        }
        /**
         * @function addLocalProperties
         * @private
         * @param actionItem {object}
         * @returns {object} actionItem
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function addLocalProperties(actionItem) {
            actionItem._relativeDueDate = ActionItemsService.getRelativeDueDate(actionItem.dueDate);
            var expandCollectionKey = actionItem.completed ? 'complete' : 'incomplete';
            if (!_.has(vm.expandedActionItems, [expandCollectionKey, actionItem.id])) {
                vm.expandedActionItems[expandCollectionKey][actionItem.id] = false;
            }
            return actionItem;
        }
        /**
         * @function addLocalPropertiesToCollection
         * @private
         * @param actionItems {array}
         * @returns {array} transformed items
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItems' implicitly has an 'any' ty... Remove this comment to see the full error message
        function addLocalPropertiesToCollection(actionItems) {
            _.forEach(actionItems, addLocalProperties);
            return actionItems;
        }
        /**
         * @function cacheUsers
         * @param records {Array}
         * @returns {Object} - promise
         * Gleans the User IDs for assignors and assignees and fetches the basic user details.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'records' implicitly has an 'any' type.
        function cacheUsers(records) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'r' implicitly has an 'any' type.
            var iteratee = function (r) {
                return [r.user, r.assignedBy];
            };
            var existingIds = Object.keys(vm.userCache);
            var ids = _(records)
                .map(iteratee)
                .flatten()
                .compact()
                .uniq()
                .difference(existingIds)
                .value();
            return PeopleService.getBasicByIds(ids).then(
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            function (response) {
                _.merge(vm.userCache, _.keyBy(response.data, 'id'));
                return records;
            }, 
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            function (response) {
                console.error('ACTION ITEMS - GET PEOPLE INFO', response);
            });
        }
        /**
         * @method canComplete
         * @param actionItem {object}
         * @returns {boolean}
         * Can the current user complete or update the progress of an action item?
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function canComplete(actionItem) {
            return actionItem.canEdit || actionItem.user === currentUserId;
        }
        /**
         * @function concatToVmProperty
         * @private
         * @param name {string}
         * @returns {function}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'name' implicitly has an 'any' type.
        function concatToVmProperty(name) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'records' implicitly has an 'any' type.
            return function (records) {
                vm[name] = _.uniqBy(_.concat(vm[name], records), 'id');
                return vm[name];
            };
        }
        /**
         * @function destroyComponent
         * @private
         */
        function destroyComponent() {
            // @ts-ignore ts-migrate(2721) FIXME: Cannot invoke an object which is possibly 'null'.
            listeners.destroy();
            // @ts-ignore ts-migrate(2721) FIXME: Cannot invoke an object which is possibly 'null'.
            listeners.localUpdate();
            // @ts-ignore ts-migrate(2721) FIXME: Cannot invoke an object which is possibly 'null'.
            listeners.pubnubUpdate();
        }
        /**
         * @function getIncomplete
         * @private
         */
        function getIncomplete() {
            vm.getIncomplete()
                .then(getRecords)
                .then(cacheUsers)
                .then(addLocalPropertiesToCollection)
                .then(concatToVmProperty('incompleteActionItems'));
        }
        /**
         * @method goToMeetingSeries
         * @param seriesId {number}
         * @param personId {number}
         * Close the drawer, open the Meetings drawer, redirect to the given series.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'seriesId' implicitly has an 'any' type.
        function goToMeetingSeries(seriesId, personId) {
            TrayRouter('meetings').open('meeting-series', {
                seriesId: seriesId,
                personId: personId,
            });
        }
        /**
         * @function getComplete
         * @private
         */
        function getComplete() {
            vm.getComplete({ pagination: vm.pagination })
                .then(updatePagination)
                .then(getRecords)
                .then(cacheUsers)
                .then(addLocalPropertiesToCollection)
                .then(concatToVmProperty('completeActionItems'));
        }
        /**
         * @method getMoreCompleted
         * Gets the next available completed items.
         */
        function getMoreCompleted() {
            vm.getComplete({ pagination: vm.pagination })
                .then(updatePagination)
                .then(getRecords)
                .then(cacheUsers)
                .then(addLocalPropertiesToCollection)
                .then(concatToVmProperty('completeActionItems'));
        }
        /**
         * @function getRecords
         * @private
         * @param response {object}
         * @returns {array}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
        function getRecords(response) {
            return response.records;
        }
        /**
         * @function highlight
         * @private
         * @param actionItem {object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function highlight(actionItem) {
            actionItem._highlighted = true;
            $timeout(function () {
                actionItem._highlighted = false;
            }, 2000);
            return actionItem;
        }
        /**
         * @function ifActionItemExistsLocally
         * @private
         * @param {function} existsCallback
         * @param {function} fallbackCallback
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'existsCallback' implicitly has an 'any'... Remove this comment to see the full error message
        function ifActionItemExistsLocally(existsCallback, fallbackCallback) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
            return function (actionItem, contextName, changedProperties) {
                var all = _.concat(vm.completeActionItems, vm.incompleteActionItems);
                if (_.find(all, { id: actionItem.id })) {
                    existsCallback(actionItem, contextName, changedProperties);
                }
                else {
                    // Action item isn't listed, so maybe it's new
                    // New action items are incomplete, so fetch incomplete items
                    fallbackCallback(actionItem);
                }
            };
        }
        /**
         * @method isMatchFilter
         * @param actionItem {Object} - action item
         * @returns {Boolean}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function isMatchFilter(actionItem) {
            return (!!vm.filterMenuOptions.activeFilters[actionItem.type] ||
                _.isEmpty(vm.filterMenuOptions.activeFilters));
        }
        /**
         * @method onChangeDate
         * @param actionItem {object}
         * @param date {Date}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function onChangeDate(actionItem, date) {
            actionItem.dueDate = date;
            actionItem._relativeDueDate = ActionItemsService.getRelativeDueDate(actionItem.dueDate);
            setDatepickerEditing(actionItem.id, false);
            ActionItemsService.update(actionItem, ['dueDate'], vm.contextName);
        }
        /**
         * @method onChangeDescription
         * @param actionItem {object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function onChangeDescription(actionItem) {
            ActionItemsService.update(actionItem, ['description'], vm.contextName);
        }
        /**
         * @method onChangeTitle
         * @param actionItem {object}
         * @param text {string}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function onChangeTitle(actionItem, text) {
            ActionItemsService.update(actionItem, ['title'], vm.contextName);
        }
        /**
         * @method onChangeProgress
         * @param actionItem {object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function onChangeProgress(actionItem) {
            ActionItemsService.update(actionItem, ['progress'], vm.contextName);
            if (actionItem.progress === 100) {
                onChangeCompleted(actionItem, true);
            }
        }
        /**
         * @method onChangeCompleted
         * @param actionItem {object}
         * @param isChecked {boolean}
         * Updates with the backend, then resorts the item.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function onChangeCompleted(actionItem, isChecked) {
            actionItem.completed = isChecked;
            ActionItemsService.update(actionItem, ['completed'], vm.contextName).then(highlight);
        }
        /**
         * @function refetch
         * @private
         * @param actionItem {object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function refetch(actionItem) {
            ActionItemsService.getById(actionItem.id)
                .then(addLocalProperties)
                .then(removeFromLists)
                .then(storeByCompletedStatus)
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
                .then(function (actionItem) {
                // If someone else changed the date, we don't
                // want to think our user is editing the date.
                setDatepickerEditing(actionItem.id, false);
            });
        }
        /**
         * @method remove
         * @param actionItem {object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function remove(actionItem) {
            DeleteWithChallengeModal.open({
                instructions: 'Confirm you are deleting an Action Item',
                itemType: 'Action Item',
                componentTitle: actionItem.title,
            }).then(function deleteConfirmed() {
                ActionItemsService.destroy(actionItem).then(function actionItemRemoveSuccess() {
                    if (actionItem.completed) {
                        vm.pagination.totalCompleteActionItems -= 1;
                    }
                    return removeFromLists(actionItem);
                }, actionItemRemoveError);
            }, angular.noop);
        }
        /**
         * @function removeFromLists
         * @private
         * @param actionItem {object}
         * @returns {object} removed actionItem.
         * Removes from both lists. We don't know why, just that it needs to be gone.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function removeFromLists(actionItem) {
            _.remove(vm.completeActionItems, { id: actionItem.id });
            _.remove(vm.incompleteActionItems, { id: actionItem.id });
            return actionItem;
        }
        /**
         * @function storeByCompletedStatus
         * @private
         * @param actionItem {object}
         * @returns {object} actionItem added
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function storeByCompletedStatus(actionItem) {
            if (actionItem.completed) {
                vm.pagination.totalCompleteActionItems += 1;
                vm.completeActionItems.push(actionItem);
            }
            else {
                vm.pagination.totalCompleteActionItems -= 1;
                vm.incompleteActionItems.push(addLocalProperties(actionItem));
            }
            return actionItem;
        }
        /**
         * @method toggleExpand
         * @param actionItem {object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function toggleExpand(actionItem) {
            var collectionName = actionItem.completed ? 'complete' : 'incomplete', allExpandKey = collectionName + 'AllExpanded', isItemExpanded = vm.expandedActionItems[collectionName][actionItem.id];
            vm.expandedActionItems[collectionName][actionItem.id] = !isItemExpanded;
            vm.expandedActionItems[allExpandKey] = _.every(_.values(vm.expandedActionItems[collectionName]));
        }
        /**
         * @function updatePagination
         * @private
         * @param response {object}
         * @returns {object} original response
         * Grabs the total number of items, so we know if we can fetch more.
         * First up the page size, then go to the next page.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
        function updatePagination(response) {
            if (vm.pagination.pageSize === 5) {
                vm.pagination.pageSize = 25;
            }
            else {
                vm.pagination.pageNumber += 1;
            }
            vm.pagination.totalCompleteActionItems = response.totalRecords;
            return response;
        }
    }
})();

(function () {
    angular.module('App.ActionItems').component('drawerActionItems', {
        bindings: {
            tab: '='
        },
        controller: ['AuthenticationService', 'ActionItemsService', DrawerActionItemsController],
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return TEMPLATE_PATH + '/action-items/action-items-wrapper.html';
            },
        ],
    });
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AuthenticationService' implicitly has a... Remove this comment to see the full error message
    function DrawerActionItemsController(AuthenticationService, ActionItemsService) {
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        /**
         * @property currentUser
         * @type {Object}
         */
        var currentUser = AuthenticationService.getAccount();
        vm.actionContext = 'standard';
        /**
         * @property contextName
         * @type {string}
         */
        vm.contextName = 'drawer';
        vm.fn = {
            create: create,
            createRecurring: createRecurring,
            getBlank: getBlank,
            getGeneratorBlank: getGeneratorBlank,
            getComplete: getComplete,
            getDelegatedComplete: getDelegatedComplete,
            getDelegatedIncomplete: getDelegatedIncomplete,
            getIncomplete: getIncomplete,
            getRecurring: getRecurring,
        };
        /**
         * @property isShowFilteringMenu
         * @type {boolean}
         * Whether to show the filter dropdown menu
         */
        vm.isShowFilteringMenu = true;
        /**
         * @property isShowSortingMenu
         * @type {boolean}
         * Whether to show the options to sort action items.
         */
        vm.isShowSortingMenu = true;
        /**
         * @property userCanCreate
         * @type {boolean}
         */
        vm.userCanCreate = true;
        /**
         * @method create
         * @param actionItem {Object}
         * @returns {Object} - promise
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function create(actionItem) {
            return ActionItemsService.create(actionItem);
        }
        /**
         * @method createRecurring
         * @param actionItem {Object}
         * @returns {actionItem}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function createRecurring(actionItem) {
            return ActionItemsService.createAIGenerator(actionItem, vm.contextName);
        }
        /**
         * @method getBlank
         * @returns {Object}
         */
        function getBlank() {
            return _.assign(ActionItemsService.getBlank(), {
                user: currentUser.userId,
                type: 'PERSONAL',
            });
        }
        /**
         * @method getGeneratorBlank
         * @returns {Object}
         */
        function getGeneratorBlank() {
            return _.assign(ActionItemsService.getBlankAIGenerator(), {
                cadenceType: null,
                user: currentUser.userId,
                type: 'PERSONAL',
                isRecurring: true,
            });
        }
        /**
         * @method getCompleted
         * @param pagination {Object}
         * @returns {Object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'pagination' implicitly has an 'any' typ... Remove this comment to see the full error message
        function getComplete(pagination) {
            return ActionItemsService.getUsersComplete(currentUser.userId, pagination);
        }
        /**
         * @method getDelegatedComplete
         * @param pagination {Object}
         * @returns {Object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'pagination' implicitly has an 'any' typ... Remove this comment to see the full error message
        function getDelegatedComplete(pagination) {
            return ActionItemsService.getUsersCompleteDelegate(currentUser.userId, pagination);
        }
        /**
         * @method getDelegatedIncomplete
         * @returns {Object}
         */
        function getDelegatedIncomplete() {
            return ActionItemsService.getUsersInCompleteDelegate(currentUser.userId);
        }
        /**
         * @method getIncomplete
         * @returns {Object}
         */
        function getIncomplete() {
            return ActionItemsService.getUsersIncomplete(currentUser.userId);
        }
        /**
         * @method getIncomplete
         * @returns {Object}
         */
        function getRecurring() {
            return ActionItemsService.getUsersRecurring(currentUser.userId);
        }
    }
})();

(function () {
    angular.module('App.ActionItems').component('driverActionItems', {
        bindings: {
            actionContext: '<',
            driver: '<',
            isOwner: '<',
            onActionItems: '&',
        },
        controller: ['ActionItemsService', 'AuthenticationService', DriverActionItemsController],
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return TEMPLATE_PATH + '/action-items/action-items-wrapper.html';
            },
        ],
    });
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ActionItemsService' implicitly has an '... Remove this comment to see the full error message
    function DriverActionItemsController(ActionItemsService, AuthenticationService) {
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        // @ts-ignore ts-migrate(7034) FIXME: Variable 'actionItemDestroyListener' implicitly ha... Remove this comment to see the full error message
        var actionItemDestroyListener;
        // @ts-ignore ts-migrate(7034) FIXME: Variable 'actionItemCompletedListener' implicitly ... Remove this comment to see the full error message
        var actionItemCompletedListener;
        // @ts-ignore ts-migrate(7034) FIXME: Variable 'actionItemDuedateListener' implicitly ha... Remove this comment to see the full error message
        var actionItemDuedateListener;
        vm.$onInit = init;
        vm.$onDestroy = function () {
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'actionItemDestroyListener' implicitly ha... Remove this comment to see the full error message
            if (angular.isFunction(actionItemDestroyListener)) {
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'actionItemDestroyListener' implicitly ha... Remove this comment to see the full error message
                actionItemDestroyListener();
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'actionItemCompletedListener' implicitly ... Remove this comment to see the full error message
                actionItemCompletedListener();
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'actionItemDuedateListener' implicitly ha... Remove this comment to see the full error message
                actionItemDuedateListener();
            }
        };
        /**
         * @property actionItems
         * @type {Array}
         */
        vm.actionItems = [];
        /**
         * @property assigneeOptions
         * @type {Object}
         * assignee modal options
         */
        vm.assigneeOptions = {
            getDefaults: function () {
                return {
                    isActionItemAssignment: true,
                    hasPrimaryPerson: true,
                    hasReceiveCommunications: false,
                    hasAddRemove: true,
                    isReadOnly: false,
                };
            },
            getAssignableUsers: function () {
                return ActionItemsService.assignableUsersForDriver(vm.driver.id);
            },
        };
        /**
         * @property contextName
         * @type {string}
         */
        vm.contextName = 'driver';
        vm.fn = {
            create: create,
            createRecurring: createRecurring,
            getBlank: getBlank,
            getComplete: getComplete,
            getGeneratorBlank: getGeneratorBlank,
            getIncomplete: getIncomplete,
            getRecurring: getRecurring,
            onOwnerChange: onOwnerChange,
        };
        /**
         * @property isShowFilteringMenu
         * @type {boolean}
         * Whether to show the filter dropdown menu
         */
        vm.isShowFilteringMenu = false;
        /**
         * @property isShowSortingMenu
         * @type {boolean}
         * Whether to show the options to sort action items.
         */
        vm.isShowSortingMenu = true;
        /**
         * @property userCanCreate
         * @type {boolean}
         */
        vm.userCanCreate = false;
        /**
         * @property hideOnEmpty
         * @type {boolean}
         * hides zero states in driver action items
         */
        vm.hideOnEmpty = true;
        vm.recurringActionItems = [];
        vm.lastActionOwner = -1;
        vm.tab = 'active';
        /**
         * @method create
         * @param actionItem {object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function create(actionItem) {
            actionItem.driverId = vm.driver.id;
            return ActionItemsService.create(actionItem);
        }
        /**
         * @method createRecurring
         * @param actionItem {Object}
         * @returns {actionItem}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function createRecurring(actionItem) {
            return ActionItemsService.createAIGenerator(actionItem, vm.contextName);
        }
        /**
         * @method getBlank
         * @returns {Object}
         */
        function getBlank() {
            return _.assign(ActionItemsService.getBlank(), {
                type: 'DRIVER',
                driverId: vm.driver.id,
                cadenceType: null,
                user: vm.lastActionOwner,
            });
        }
        /**
         * @method getGeneratorBlank
         * @returns {Object}
         */
        function getGeneratorBlank() {
            return _.assign(ActionItemsService.getBlankAIGenerator(), {
                cadenceType: null,
                type: 'DRIVER',
                driverId: vm.driver.id,
                isRecurring: true,
            });
        }
        /**
         * @function storeActionItemIds
         * @param actionItemPage {object}
         * @returns {object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItemPage' implicitly has an 'any'... Remove this comment to see the full error message
        function storeActionItemIds(actionItemPage) {
            vm.actionItems = _.uniqBy(actionItemPage.records.concat(vm.actionItems), 'id');
            return actionItemPage;
        }
        /**
         * @method getComplete
         * @returns {Object} - promise
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'pagination' implicitly has an 'any' typ... Remove this comment to see the full error message
        function getComplete(pagination) {
            return ActionItemsService.getDriversComplete(vm.driver.id, pagination).then(storeActionItemIds);
        }
        /**
         * @method getIncomplete
         * @returns {Object} - promise
         */
        function getIncomplete() {
            return ActionItemsService.getDriversIncomplete(vm.driver.id)
                .then(storeActionItemIds)
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                .then(function (response) {
                getIncompleteItems();
                return response;
            });
        }
        function getIncompleteItems() {
            var incomplete = _.filter(vm.actionItems, function (a) {
                return !a.completed;
            });
            vm.onActionItems({ items: incomplete });
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function recountIncomplete(actionItem) {
            var localAi = _.find(vm.actionItems, { id: actionItem.id });
            if (localAi) {
                storeActionItemIds({ records: [actionItem] });
                getIncompleteItems();
            }
        }
        /**
         * @method getRecurring
         * @returns {Object}
         */
        function getRecurring() {
            return ActionItemsService.getDriversRecurring(vm.driver.id);
        }
        // @ts-ignore ts-migrate(7006)
        function onOwnerChange(personId) {
            vm.lastActionOwner = personId;
        }
        /**
         * @function init
         */
        function init() {
            vm.userCanCreate = vm.isOwner;
            vm.lastActionOwner = vm.driver.primaryOwnerId;
            vm.recurringActionItems = vm.driver.recurringActionItems;
            actionItemCompletedListener = ActionItemsService.subscribeToProperty('completed', recountIncomplete);
            actionItemDuedateListener = ActionItemsService.subscribeToProperty('dueDate', recountIncomplete);
            actionItemDestroyListener = ActionItemsService.subscribeToOperation('destroy', function (
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
            actionItem) {
                _.pull(vm.actionItems, { id: actionItem.id });
            });
        }
    }
})();

(function () {
    angular.module('App.ActionItems').component('goalTabActionItems', {
        bindings: {
            goal: '<',
        },
        controller: [
            '$rootScope',
            '$state',
            'ActionItemsService',
            'AccessModal',
            'GoalsService',
            GoalTabActionItemsController,
        ],
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return TEMPLATE_PATH + '/action-items/action-items-wrapper.html';
            },
        ],
    });
    function GoalTabActionItemsController($rootScope, $state, ActionItemsService, AccessModal, GoalsService) {
        var vm = this;
        vm.$onInit = init;
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter '$rootScope' implicitly has an 'any' typ... Remove this comment to see the full error message
         * @property goalType
// @ts-ignore ts-migrate(7006) FIXME: Parameter '$state' implicitly has an 'any' type.
         * @type {string}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'AccessModal' implicitly has an 'any' ty... Remove this comment to see the full error message
         * Used in fetching goals action items.
         */
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var goalType = GoalsService.asType($state.params.goalType);
        /**
         * @property contextName
         * @type {string}
         */
        vm.contextName = 'goal';
        vm.fn = {
            create: ActionItemsService.create,
            getBlank: getBlank,
            getComplete: getComplete,
            getIncomplete: getIncomplete,
        };
        /**
         * @property isShowFilteringMenu
         * @type {boolean}
         * Whether to show the filter dropdown menu
         */
        vm.isShowFilteringMenu = false;
        /**
         * @property isShowSortingMenu
         * @type {boolean}
         * Whether to show the options to sort action items.
         */
        vm.isShowSortingMenu = true;
        /**
         * @property userCanCreate
         * @type {boolean}
         */
        vm.userCanCreate = false;
        /**
         * @property assigneeOptions
         * @type {Object}
         */
        vm.assigneeOptions = {
            getDefaults: function () {
                return {
                    isActionItemAssignment: true,
                    hasPrimaryPerson: true,
                    hasReceiveCommunications: false,
                    hasAddRemove: false,
                    isReadOnly: false,
                };
            },
            getAssignableUsers: function () {
                return ActionItemsService.assignableUsersForGoal(vm.goal.id, goalType);
            },
        };
        /**
         * @function init
         */
        function init() {
            ActionItemsService.userCanCreateForGoal(vm.goal.id, goalType).then(function (canCreate) {
                vm.userCanCreate = canCreate;
            });
        }
        /**
         * @method getBlank
         * @returns {Object}
         */
        function getBlank() {
            var blank = { type: 'PERFORMANCE_GOAL' }, goalTypeKey = 'performanceGoalType', goalIdKey = 'performanceGoalId';
            if (vm.goal.alignmentGoalType) {
                blank.type = 'ALIGNMENT_GOAL';
                goalIdKey = 'alignmentGoalId';
                goalTypeKey = 'alignmentGoalType';
            }
            blank[goalTypeKey] = GoalsService.getTypeFromGoal(vm.goal);
            blank[goalIdKey] = vm.goal.id;
            if (vm.goal.assignees.length === 1) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'canCreate' implicitly has an 'any' type... Remove this comment to see the full error message
                blank.user = vm.goal.assignees[0];
            }
            else if ($state.params.personId) {
                // People > Goals > Goal > Action Items
                // @ts-ignore
                blank.user = Number($state.params.personId);
            }
            return _.assign(ActionItemsService.getBlank(), blank);
        }
        /**
         * @method getComplete
         * @param pagination {object}
         * @returns {Object}
         */
        function getComplete(pagination) {
            return ActionItemsService.getGoalsComplete(vm.goal.id, goalType, pagination);
        }
        /**
         * @method getIncomplete
         * @returns {Object}
         */
        function getIncomplete() {
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            return ActionItemsService.getGoalsIncomplete(vm.goal.id, goalType);
        }
    }
    // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'pagination' implicitly has an 'any' typ... Remove this comment to see the full error message

(function () {
    angular.module('App.ActionItems').component('meetingActionItems', {
        bindings: {
            onChange: '&',
            meeting: '<',
            person: '<',
            participants: '<',
            isCompleted: '<',
            onBeforeCreate: '&',
        },
        controller: ['AuthenticationService', 'ActionItemsService', MeetingActionItemsController],
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return TEMPLATE_PATH + '/action-items/action-items-wrapper.html';
            },
        ],
    });
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ActionItemsService' implicitly has an '... Remove this comment to see the full error message
    function MeetingActionItemsController(AuthenticationService, ActionItemsService) {
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        // @ts-ignore ts-migrate(7034) FIXME: Variable 'actionItemCompletedListener' implicitly ... Remove this comment to see the full error message
        var actionItemCompletedListener;
        // @ts-ignore ts-migrate(7034) FIXME: Variable 'actionItemDestroyListener' implicitly ha... Remove this comment to see the full error message
        var actionItemDestroyListener;
        // @ts-ignore ts-migrate(7034) FIXME: Variable 'actionItemDuedateListener' implicitly ha... Remove this comment to see the full error message
        var actionItemDuedateListener;
        vm.$onInit = init;
        vm.$onDestroy = function () {
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'actionItemDestroyListener' implicitly ha... Remove this comment to see the full error message
            if (angular.isFunction(actionItemDestroyListener)) {
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'actionItemCompletedListener' implicitly ... Remove this comment to see the full error message
                actionItemCompletedListener();
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'actionItemDestroyListener' implicitly ha... Remove this comment to see the full error message
                actionItemDestroyListener();
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'actionItemDuedateListener' implicitly ha... Remove this comment to see the full error message
                actionItemDuedateListener();
            }
        };
        vm.actionContext = 'standard';
        /**
         * @property actionItems
         * @type {Array}
         */
        vm.actionItems = [];
        /**
         * @property assigneeOptions
         * @type {Object}
         * assignee modal options
         */
        vm.assigneeOptions = {
            getDefaults: function () {
                return {
                    isActionItemAssignment: true,
                    hasPrimaryPerson: true,
                    hasReceiveCommunications: false,
                    hasAddRemove: false,
                    isReadOnly: !vm.canEdit,
                };
            },
            getAssignableUsers: function () {
                return ActionItemsService.resolve(vm.participants);
            },
        };
        /**
         * @property canEdit
         * @type {boolean}
         * If the meeting instance is complete, the action items are immutable.
         */
        vm.canEdit = false;
        /**
         * @property contextName
         * @type {string}
         */
        vm.contextName = 'meeting';
        vm.fn = {
            create: create,
            getBlank: getBlank,
            getComplete: getComplete,
            getIncomplete: getIncomplete,
            onOwnerChange: onOwnerChange,
        };
        /**
         * @property isShowFilteringMenu
         * @type {boolean}
         * Whether to show the filter dropdown menu
         */
        vm.isShowFilteringMenu = false;
        /**
         * @property isShowSortingMenu
         * @type {boolean}
         * Whether to show the options to sort action items.
         */
        vm.isShowSortingMenu = false;
        /**
         * @property userCanCreate
         * @type {boolean}
         */
        vm.userCanCreate = true;
        /**
         * Allow the user to complete AI in meetings
         * @type {Boolean}
         */
        vm.userCanComplete = true;
        /**
         * @property hideOnEmpty
         * @type {boolean}
         * hides zero states in meeting action items
         */
        vm.hideOnEmpty = true;
        vm.lastActionOwner = AuthenticationService.getAccount().userId;
        vm.tab = 'active';
        /**
         * @method create
         * @param actionItem {object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function create(actionItem) {
            vm.onBeforeCreate();
            vm.meeting.hasActionItems = true;
            return ActionItemsService.create(actionItem);
        }
        /**
         * @method getBlank
         * @returns {Object}
         */
        function getBlank() {
            return _.assign(ActionItemsService.getBlank(), {
                type: 'MEETING',
                meeting: vm.meeting,
                meetingSeriesId: vm.meeting.seriesId,
                user: vm.lastActionOwner,
            });
        }
        /**
         * @function storeActionItemIds
         * @param actionItemPage {object}
         * @returns {object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItemPage' implicitly has an 'any'... Remove this comment to see the full error message
        function storeActionItemIds(actionItemPage) {
            vm.actionItems = _.uniqBy(actionItemPage.records.concat(vm.actionItems), 'id');
            vm.onChange({ actionItems: vm.actionItems });
            return actionItemPage;
        }
        /**
         * @method getComplete
         * @returns {Object} - promise
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'pagination' implicitly has an 'any' typ... Remove this comment to see the full error message
        function getComplete(pagination) {
            return ActionItemsService.getMeetingComplete(vm.meeting.id, pagination).then(storeActionItemIds);
        }
        /**
         * @method getIncomplete
         * @returns {Object} - promise
         */
        function getIncomplete() {
            return ActionItemsService.getMeetingIncomplete(vm.meeting.id).then(storeActionItemIds);
        }
        // @ts-ignore ts-migrate(7006)
        function onOwnerChange(personId) {
            vm.lastActionOwner = personId;
        }
        /**
         * @function init
         */
        function init() {
            vm.canEdit = !vm.isCompleted;
            vm.userCanCreate = !vm.isCompleted;
            vm.lastActionOwner = AuthenticationService.getAccount().userId;
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'item' implicitly has an 'any' type.
            actionItemDuedateListener = ActionItemsService.subscribeToProperty('dueDate', function (item) {
                return storeActionItemIds({ records: [item] });
            });
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'item' implicitly has an 'any' type.
            actionItemCompletedListener = ActionItemsService.subscribeToProperty('completed', function (item) {
                return storeActionItemIds({ records: [item] });
            });
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
            actionItemDestroyListener = ActionItemsService.subscribeToOperation('destroy', function (actionItem) {
                _.pull(vm.actionItems, actionItem.id);
                vm.onChange({ actionItems: vm.actionItems });
            });
        }
    }
})();

(function () {
    angular.module('App.ActionItems').component('peopleTabActionItems', {
        bindings: {
            person: '<',
        },
        controller: ['ActionItemsService', PeopleTabActionItemsController],
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return TEMPLATE_PATH + '/action-items/action-items-wrapper.html';
            },
        ],
    });
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ActionItemsService' implicitly has an '... Remove this comment to see the full error message
    function PeopleTabActionItemsController(ActionItemsService) {
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        vm.actionContext = 'standard';
        /**
         * @property contextName
         * @type {string}
         */
        vm.contextName = 'person';
        vm.fn = {
            create: create,
            createRecurring: createRecurring,
            getBlank: getBlank,
            getGeneratorBlank: getGeneratorBlank,
            getComplete: getComplete,
            getDelegatedComplete: getDelegatedComplete,
            getDelegatedIncomplete: getDelegatedIncomplete,
            getIncomplete: getIncomplete,
            getRecurring: getRecurring,
        };
        /**
         * @property isShowFilteringMenu
         * @type {boolean}
         * Whether to show the filter dropdown menu
         */
        vm.isShowFilteringMenu = true;
        /**
         * @property isShowSortingMenu
         * @type {boolean}
         * Whether to show the options to sort action items.
         */
        vm.isShowSortingMenu = true;
        /**
         * @property userCanCreate
         * @type {boolean}
         */
        vm.userCanCreate = true;
        vm.tab = 'active';
        /**
         * @method create
         * @param actionItem {Object}
         * @returns {actionItem}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function create(actionItem) {
            return ActionItemsService.create(actionItem);
        }
        /**
         * @method createRecurring
         * @param actionItem {Object}
         * @returns {actionItem}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function createRecurring(actionItem) {
            return ActionItemsService.createAIGenerator(actionItem, vm.contextName);
        }
        /**
         * @method getBlank
         * @returns {Object}
         */
        function getBlank() {
            return _.assign(ActionItemsService.getBlank(), {
                user: vm.person.id,
                type: 'MANAGER_ASSIGNED',
            });
        }
        /**
         * @method getGeneratorBlank
         * @returns {Object}
         */
        function getGeneratorBlank() {
            return _.assign(ActionItemsService.getBlankAIGenerator(), {
                cadenceType: null,
                user: vm.person.id,
                type: 'MANAGER_ASSIGNED',
            });
        }
        /**
         * @method getComplete
         * @param pagination {Object}
         * @returns {Object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'pagination' implicitly has an 'any' typ... Remove this comment to see the full error message
        function getComplete(pagination) {
            return ActionItemsService.getUsersComplete(vm.person.id, pagination);
        }
        /**
         * @method getDelegatedComplete
         * @param pagination {Object}
         * @returns {Object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'pagination' implicitly has an 'any' typ... Remove this comment to see the full error message
        function getDelegatedComplete(pagination) {
            return ActionItemsService.getUsersCompleteDelegate(vm.person.id, pagination);
        }
        /**
         * @method getDelegatedIncomplete
         * @returns {Object}
         */
        function getDelegatedIncomplete() {
            return ActionItemsService.getUsersInCompleteDelegate(vm.person.id);
        }
        /**
         * @method getIncomplete
         * @returns {Object}
         */
        function getIncomplete() {
            return ActionItemsService.getUsersIncomplete(vm.person.id);
        }
        /**
         * @method getRecurring
         * @returns {Object}
         */
        function getRecurring() {
            return ActionItemsService.getUsersRecurring(vm.person.id);
        }
    }
})();

(function () {
    angular
        .module('App.ActionItems')
        .controller('RecurrenceModalController', [
        '$filter',
        '$scope',
        '$uibModalInstance',
        'ActionItemsService',
        RecurrenceModalController,
    ])
        .factory('RecurrenceModal', [
        '$rootScope',
        '$uibModal',
        'TEMPLATE_PATH',
        RecurrenceModalFactory,
    ]);
    function RecurrenceModalFactory($rootScope, $uibModal, TEMPLATE_PATH) {
        return {
            open: open,
        };
        function open(options) {
            var modalScope = $rootScope.$new(true);
            _.assign(modalScope, options);
            return $uibModal.open({
                controllerAs: 'modalVm',
                controller: 'RecurrenceModalController',
                animation: true,
                scope: modalScope,
                size: 'md',
                windowClass: 'action-recurrence-modal',
                templateUrl: TEMPLATE_PATH + '/action-items/action-item-generators/recurrence-modal/recurrence-modal.html',
            }).result;
        }
    }
    function RecurrenceModalController($filter, $scope, $uibModalInstance, ActionItemsService) {
        var vm = this;
        vm.$onInit = init;
        vm.fn = {
            cancel: $uibModalInstance.dismiss,
            done: done,
            onBlurOccurences: onBlurOccurences,
            onChangeEndDate: onChangeEndDate,
            onChangeFrequency: onChangeFrequency,
            onChangeStartDate: onChangeStartDate,
            onSelectDay: onSelectDay,
            onSelectMonth: onSelectMonth,
            onStartDateKeyUp: onStartDateKeyUp,
        };
        vm.repeatValues = [
            { id: '0', name: 'days' },
            { id: '1', name: 'weeks' },
            { id: '2', name: 'months' },
            { id: '3', name: 'years' }
        ];
        vm.repeatMonthlySelectValues = [];
        vm.repeatYearlySelectValues = [];
        vm.selectedOption = { id: '0', name: 'days' };
        vm.selectedMonthOption = {};
        vm.selectedYearOption = {};
        vm.recurrence = {
            startDate: new Date(),
            ends: 'never',
            endDate: new Date(),
            //occurrences: 13,
            repeatEvery: 1,
            repeatFrequency: 0,
            monthNthDay: 0,
            days: {
                'sun': false,
                'mon': false,
                'tue': false,
                'wed': false,
                'thu': false,
                'fri': false,
                'sat': false,
            }
        };
        vm.monthNDay = 0;
        vm.startDate = new Date();
        $scope.endsOn = 'never';
        $scope.$watch('endsOn', function (a) {
            vm.recurrence.ends = a;
        });
        /**
         * @property tomorrow
         * @type {Date}
         * Used to prevent the start date from allowing selections in the past.
         */
        vm.tomorrow = new Date();
        vm.tomorrow.setDate(vm.tomorrow.getDate() + 1);
        vm.tomorrow.setHours(0, 0, 0, 0);
        function init() {
            buildMonthSelection(new Date());
        }
        function done() {
            $scope.actionItem.recurrence = vm.recurrence;
            buildRecurrenceDescription();
            // set date to UTC date
            vm.recurrence.startDate.setUTCDate(vm.recurrence.startDate.getDate());
            $uibModalInstance.close({ description: $scope.actionItem.recurrenceDescription, recurrence: vm.recurrence });
        }
        function buildRecurrenceDescription() {
            var description;
            if (vm.recurrence.ends === 'on') {
            }
            if (vm.recurrence.repeatFrequency === 0) {
                if (vm.recurrence.repeatEvery > 1) {
                    description = 'Every ' + vm.recurrence.repeatEvery + ' days ';
                }
                else {
                    description = 'Every day';
                }
                $scope.actionItem.recurrenceDescription = description;
            }
            else if (vm.recurrence.repeatFrequency === 1) {
                // weekly
                if (vm.recurrence.repeatEvery > 1) {
                    description = 'Every ' + vm.recurrence.repeatEvery + ' weeks ';
                }
                else {
                    description = 'Weekly on ';
                }
                // days
                var days = [];
                var isWeekdays = true;
                if (vm.recurrence.days.sun) {
                    days.push('Sun');
                    isWeekdays = false;
                }
                if (vm.recurrence.days.mon) {
                    days.push('Mon');
                }
                if (vm.recurrence.days.tue) {
                    days.push('Tue');
                }
                if (vm.recurrence.days.wed) {
                    days.push('Wed');
                }
                if (vm.recurrence.days.thu) {
                    days.push('Thu');
                }
                if (vm.recurrence.days.fri) {
                    days.push('Fri');
                }
                if (vm.recurrence.days.sat) {
                    days.push('Sat');
                    isWeekdays = false;
                }
                if (days.length === 5 && isWeekdays) {
                    description += 'weekdays';
                }
                else {
                    var count_1 = 0;
                    days.forEach(function (day) {
                        if (count_1 < 3) {
                            description += day + ' ';
                        }
                        else if (count_1 === 3) {
                            description += '...';
                        }
                        count_1++;
                    });
                }
                $scope.actionItem.recurrenceDescription = description;
            }
            else if (vm.recurrence.repeatFrequency === 2) {
                // monthly
                $scope.actionItem.recurrenceDescription = vm.selectedMonthOption.name;
            }
            else if (vm.recurrence.repeatFrequency === 3) {
                if (vm.recurrence.repeatEvery > 1) {
                    description = 'Every ' + vm.recurrence.repeatEvery + ' years on ' + vm.recurrence.yearMonth + '/' + vm.recurrence.yearMonthDate;
                }
                else {
                    description = 'Annually on ' + vm.recurrence.yearMonth + '/' + vm.recurrence.yearMonthDate;
                }
                $scope.actionItem.recurrenceDescription = description;
            }
            return description;
        }
        function onBlurOccurences(e) {
        }
        function onChangeFrequency(e) {
            switch (e.id) {
                case '0':
                    vm.recurrence.monthNthDay = 0;
                    break;
                case '1':
                    vm.recurrence.repeatFrequency = 1;
                    vm.recurrence.monthNthDay = 0;
                    break;
                case '2':
                    vm.recurrence.repeatFrequency = 2;
                    vm.recurrence.monthNthDay = vm.monthNDay;
                    break;
                case '3':
                    vm.recurrence.repeatFrequency = 3;
                    vm.recurrence.monthNthDay = 0;
                    var month = $filter('date')(new Date(), 'M');
                    var date = $filter('date')(new Date(), 'dd');
                    vm.recurrence.yearMonth = month - 1;
                    vm.recurrence.yearMonthDate = date;
                    break;
            }
        }
        function onSelectDay(day) {
            if (angular.isDefined(vm.recurrence.days[day])) {
                vm.recurrence.days[day] = !vm.recurrence.days[day];
            }
        }
        function onSelectMonth() {
            if (vm.selectedMonthOption.monthWeek > 0) {
                vm.recurrence.monthNthDay = vm.selectedMonthOption.monthWeek;
                ActionItemsService.setRecurrenceDay(vm.recurrence, vm.selectedMonthOption.dayOfWeek);
            }
            else if (vm.selectedMonthOption.monthDay > 0) {
                vm.recurrence.monthNthDay = vm.selectedMonthOption.monthDay;
            }
        }
        function buildMonthSelection(selectedDate) {
            var day = $filter('date')(selectedDate, 'EEEE');
            var date = $filter('date')(selectedDate, 'd');
            var week = ActionItemsService.getNth(selectedDate);
            // clear old values
            vm.repeatMonthlySelectValues = [];
            var option1 = {
                id: '0',
                name: 'Monthly on day ' + date,
                monthWeek: 0,
                monthDay: parseInt(date),
            };
            vm.repeatMonthlySelectValues.push(option1);
            var option2 = {
                id: '1',
                name: 'Monthly on the ' + ActionItemsService.getNumberExtension(week, selectedDate) + ' ' + day,
                monthWeek: week,
                monthDay: 0,
                dayOfWeek: day,
            };
            vm.repeatMonthlySelectValues.push(option2);
            vm.selectedMonthOption = option1;
            vm.monthNDay = parseInt(date);
        }
        function onChangeEndDate(date) {
            vm.recurrence.endDate = date;
        }
        function onChangeStartDate(date) {
            vm.recurrence.startDate = date;
            buildMonthSelection(date);
        }
        function onStartDateKeyUp(event) {
        }
    }
})();

(function () {
    var ACTION_ITEM_TYPES = {
        PERSONAL: {
            class: 'icon-person',
            contexts: ['drawer', 'person'],
            group: 'type',
            title: 'Personal',
            value: 'PERSONAL',
        },
        ROLE: {
            class: 'icon-gears',
            contexts: ['drawer', 'person', 'roles'],
            group: 'type',
            title: 'Role',
            value: 'ROLE',
        },
        ALIGNMENT_GOAL: {
            class: 'icon-goals',
            contexts: ['drawer', 'goal', 'person'],
            group: 'type',
            title: 'Goal',
            value: 'ALIGNMENT_GOAL',
        },
        PERFORMANCE_GOAL: {
            class: 'icon-goals',
            contexts: ['drawer', 'goal', 'person'],
            group: 'type',
            title: 'Goal',
            value: 'PERFORMANCE_GOAL',
        },
        MANAGER_ASSIGNED: {
            class: 'icon-leader',
            contexts: ['drawer', 'person'],
            group: 'type',
            title: 'Manager Assigned',
            value: 'MANAGER_ASSIGNED',
        },
        MEETING: {
            class: 'icon-meeting-agenda',
            contexts: ['drawer', 'person', 'topic'],
            group: 'type',
            title: 'Meeting',
            value: 'MEETING',
        },
        DRIVER: {
            class: 'icon-driver',
            contexts: ['drawer', 'person', 'driver'],
            group: 'type',
            title: 'Driver',
            value: 'DRIVER',
        },
    };
    angular
        .module('App.ActionItems')
        .component('actionItems', {
        bindings: {
            actionContext: '<',
            assigneeOptions: '=?',
            canEdit: '<?',
            contextName: '<?',
            create: '&',
            createRecurring: '&',
            filtering: '<',
            getBlank: '&',
            getGeneratorBlank: '&',
            getComplete: '&',
            getDelegatedComplete: '&',
            getDelegatedIncomplete: '&',
            getIncomplete: '&',
            getRecurring: '&',
            hideOnEmpty: '=?',
            onOwnerChange: '&',
            sorting: '<',
            userCanCreate: '=',
            userCanComplete: '=?',
            view: '='
        },
        controller: [
            'CLIENT_SETTINGS',
            '$anchorScroll',
            '$scope',
            '$state',
            '$timeout',
            '$window',
            'AccessModal',
            'ActionItemsService',
            'AuthenticationService',
            'DeleteWithChallengeModal',
            'GoalsService',
            'PeopleService',
            'TrayRouter',
            ActionItemsController,
        ],
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return TEMPLATE_PATH + '/action-items/action-items.html';
            },
        ],
    });
    function ActionItemsController(
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'CLIENT_SETTINGS implicitly has an 'any' ... Remove this comment to see the full error message
    CLIENT_SETTINGS, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$anchorScroll' implicitly has an 'any' ... Remove this comment to see the full error message
    $anchorScroll, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$scope' implicitly has an 'any' type.
    $scope, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$state' implicitly has an 'any' type.
    $state, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$timeout' implicitly has an 'any' type.
    $timeout, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$timeout' implicitly has an 'any' type.
    $window, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AccessModal' implicitly has an 'any' ty... Remove this comment to see the full error message
    AccessModal, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ActionItemsService' implicitly has an '... Remove this comment to see the full error message
    ActionItemsService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AuthenticationService' implicitly has a... Remove this comment to see the full error message
    AuthenticationService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'DeleteWithChallengeModal' implicitly ha... Remove this comment to see the full error message
    DeleteWithChallengeModal, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'GoalsService' implicitly has an 'any' t... Remove this comment to see the full error message
    GoalsService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'PeopleService' implicitly has an 'any' ... Remove this comment to see the full error message
    PeopleService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TrayRouter' implicitly has an 'any' typ... Remove this comment to see the full error message
    TrayRouter) {
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        /**
         * @parameter currentUserId
         * @type {Number}
         */
        var currentUserId = AuthenticationService.getAccount().userId;
        /**
         * @parameter expandId
         * @type {Number}
         * action item id to expand
         */
        var expandId = _.parseInt($state.params.expandId);
        /**
         * @property setDatepickerEditing
         * @private
         * @type {Function}
         * Trying to hide the due date icon when editing a date.
         * When a datepicker is activated it broadcasts an event.
         * After its done and calls its onChange handler it rebroadcast
         *  the same editing event.
         */
        var setDatepickerEditing = _.throttle(function _setDatepickerEditing(actionItemId, isEditing) {
            vm.datepickerInEditMode[actionItemId] = isEditing;
        }, 100, { trailing: false });
        vm.$onInit = init;
        vm.view = 'active';
        /**
         * @property incompleteActionItems
         * @type {Array}
         */
        vm.incompleteActionItems = [];
        /**
         * @property recurringActionItems
         * @type {Array}
         */
        vm.recurringActionItems = [];
        /**
         * @property completeActionItems
         * @type {Array}
         */
        vm.completeActionItems = [];
        vm.hasDriverRecurring = true;
        /**
         * @property isCreating
         * @type {boolean}
         */
        vm.isCreating = false;
        /**
         * @property newActionItem
         * @type {Object}
         */
        vm.newActionItem = {};
        /**
         * @property expandedActionItems
         * @type {Object}
         */
        vm.expandedActionItems = {
            complete: {},
            incomplete: {},
            completeAllExpanded: false,
            incompleteAllExpanded: false,
        };
        /**
         * @property pagination
         * @type {Object}
         */
        vm.pagination = {
            pageSize: 5,
            pageNumber: 1,
        };
        /**
         * @property sortMenu
         * @type {object}
         */
        vm.sortMenu = {
            sortOrder: 'dueDate',
            defaultColumn: 'dueDate',
            options: [
                {
                    column: 'dueDate',
                    label: 'Due Date',
                },
            ],
        };
        /**
         * @property filterMenu
         * @type {Object}
         * @key availableOptions {object} all possible filters options
         * @key activeOptions {array} filter options for present actionItems
         * @key activeFilters {object} map of filters turned on
         */
        vm.filterMenuOptions = {
            availableOptions: ACTION_ITEM_TYPES,
            activeOptions: _(ACTION_ITEM_TYPES)
                .values()
                .uniqBy('title')
                .value()
                .filter(function (option) {
                if (!CLIENT_SETTINGS.enableUIPlanActions && option.title === 'Goal' ||
                    !CLIENT_SETTINGS.enableUIRoleActions && option.title === 'Role') {
                    return false;
                }
                return true;
            }),
            activeFilters: {},
        };
        vm.fn = {
            close: TrayRouter('action-items').close,
            create: create,
            canAddNewActionItem: canAddNewActionItem,
            canComplete: canComplete,
            focusCreateInput: focusCreateInput,
            getAssigneeTooltip: getAssigneeTooltip,
            getIconClass: ActionItemsService.getIconClass,
            getIconTooltip: ActionItemsService.getIconTooltip,
            getMoreCompleted: getMoreCompleted,
            goToMeetingSeries: goToMeetingSeries,
            isMatchFilter: isMatchFilter,
            onChangeActionStatus: onChangeActionStatus,
            onChangeCompleted: onChangeCompleted,
            onChangeDate: onChangeDate,
            onChangeDescription: onChangeDescription,
            onChangeNewActionItemDate: onChangeNewActionItemDate,
            onChangeNewActionItemUser: onChangeNewActionItemUser,
            onChangeProgress: onChangeProgress,
            onChangeTitle: onChangeTitle,
            onChangeUser: onChangeUser,
            onFilterChange: onFilterChange,
            onNewActionItemKeyUp: onNewActionItemKeyUp,
            onSortByChange: onSortByChange,
            remove: remove,
            toggleExpand: toggleExpand,
        };
        /**
         * @property datepickerInEditMode
         * @type {Object}
         * Need to keep track of which datepickers are in edit mode
         * so we can show/hide an items duedate icon.
         */
        vm.datepickerInEditMode = {};
        /**
         * @property userCache
         * @type {Object}
         * Map of assignees and assignors so they are only fetched from the API once.
         */
        vm.userCache = {};
        /**
         * @listener datepicker:isEditing
         * @param event {Event}
         * @param listenerKey {string}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
        $scope.$on('datepicker:isEditing', function (event, listenerKey) {
            var parts = listenerKey.split('|'), actionItemId = Number(parts[1]);
            setDatepickerEditing(actionItemId, true);
        });
        function init() {
            if (angular.isUndefined(vm.canEdit)) {
                vm.canEdit = true;
            }
            vm.newActionItem = vm.getBlank();
            if (vm.filtering) {
                onFilterChange(_.values(vm.filterMenuOptions.availableOptions));
            }
            getIncomplete();
            getComplete();
            if (vm.contextName === 'person' || vm.contextName === 'drawer' || vm.contextName === 'driver') {
                getRecurring();
            }
        }
        /**
         * @function actionItemCreateError
         * @private
         * @param error {error}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'error' implicitly has an 'any' type.
        function actionItemCreateError(error) {
            console.error('ERROR CREATING PERSONAL ACTION ITEM', error);
        }
        /**
         * @function actionItemCreateSuccess
         * @private
         * @param savedActionItem {object}
         * Adds saved Action item to visible list.
         * Resets `vm.newActionItem`.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'savedActionItem' implicitly has an 'any... Remove this comment to see the full error message
        function actionItemCreateSuccess(savedActionItem) {
            highlight(savedActionItem);
            addLocalProperties(savedActionItem);
            vm.incompleteActionItems.unshift(savedActionItem);
            vm.newActionItem = vm.getBlank();
        }
        /**
         * @function actionItemRemoveError
         * @private
         * @param error {error}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'error' implicitly has an 'any' type.
        function actionItemRemoveError(error) {
            console.error('ERROR REMOVING PERSONAL ACTION ITEM', error);
        }
        /**
         * @function addLocalProperties
         * @private
         * @param actionItem {object}
         * @returns {object} actionItem
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function addLocalProperties(actionItem) {
            actionItem._relativeDueDate = ActionItemsService.getRelativeDueDate(actionItem.dueDate);
            var expandCollectionKey = actionItem.completed ? 'complete' : 'incomplete';
            if (!_.has(vm.expandedActionItems, [expandCollectionKey, actionItem.id])) {
                vm.expandedActionItems[expandCollectionKey][actionItem.id] = false;
            }
            if (actionItem.dueDate) {
                var d = new Date(actionItem.dueDate);
                d.setDate(actionItem.dueDate.getUTCDate());
                d.setMonth(actionItem.dueDate.getUTCMonth());
                d.setFullYear(actionItem.dueDate.getUTCFullYear());
                actionItem.dueDate = d;
            }
            return actionItem;
        }
        /**
         * @function addLocalPropertiesToCollection
         * @private
         * @param actionItems {array}
         * @returns {array} transformed items
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItems' implicitly has an 'any' ty... Remove this comment to see the full error message
        function addLocalPropertiesToCollection(actionItems) {
            _.forEach(actionItems, addLocalProperties);
            return actionItems;
        }
        /**
         * @function cacheUsers
         * @param records {Array}
         * @returns {Object} - promise
         * Gleans the User IDs for assignors and assignees and fetches the basic user details.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'records' implicitly has an 'any' type.
        function cacheUsers(records) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'r' implicitly has an 'any' type.
            var iteratee = function (r) {
                return [r.user, r.assignedBy];
            };
            var existingIds = Object.keys(vm.userCache);
            var ids = _(records)
                .map(iteratee)
                .flatten()
                .compact()
                .uniq()
                .difference(existingIds)
                .value();
            return PeopleService.getBasicByIds(ids).then(
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            function (response) {
                _.merge(vm.userCache, _.keyBy(response.data, 'id'));
                return records;
            }, 
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            function (response) {
                console.error('ACTION ITEMS - GET PEOPLE INFO', response);
            });
        }
        /**
         * @method canAddNewActionItem
         * @returns {boolean}
         */
        function canAddNewActionItem() {
            if (vm.isCreating)
                return false;
            return vm.newActionItem.user && vm.newActionItem.title && vm.newActionItem.dueDate;
        }
        /**
         * @method canComplete
         * @param actionItem {object}
         * @returns {boolean}
         * Can the current user complete or update the progress of an action item?
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function canComplete(actionItem) {
            if (angular.isDefined(vm.userCanComplete)) {
                return vm.userCanComplete;
            }
            return actionItem.canEdit || actionItem.user === currentUserId;
        }
        /**
         * @method create
         * Sends `vm.newActionItem` to backend for creation.
         * Toggles `vm.isCreating` to prevent multiple saves.
         */
        function create() {
            vm.isCreating = true;
            vm.create({ actionItem: vm.newActionItem })
                .then(actionItemCreateSuccess, actionItemCreateError)
                .finally(function actionItemCreateFinally() {
                vm.isCreating = false;
            });
        }
        /**
         * @function concatToVmProperty
         * @private
         * @param name {string}
         * @returns {function}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'name' implicitly has an 'any' type.
        function concatToVmProperty(name) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'records' implicitly has an 'any' type.
            return function (records) {
                vm[name] = _.uniqBy(_.concat(vm[name], records), 'id');
                return vm[name];
            };
        }
        /**
         * @method focusCreateInput
         */
        function focusCreateInput() {
            $scope.$broadcast('inlineEdit:edit', 'NewActionItem');
        }
        /**
         * @function getIncomplete
         * @private
         */
        function getIncomplete() {
            vm.getIncomplete()
                .then(getRecords)
                .then(cacheUsers)
                .then(addLocalPropertiesToCollection)
                .then(concatToVmProperty('incompleteActionItems'))
                .then(sortActionItems)
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                .then(function (response) {
                if (expandId) {
                    toggleExpand(_.find(response, { id: expandId }));
                    $anchorScroll.yOffset = 150;
                    scrollToActionItem();
                }
            });
        }
        /**
         * @function getRecurring
         * @private
         */
        function getRecurring() {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            vm.getRecurring().then(function (response) {
                vm.recurringActionItems = response;
            });
        }
        /**
         * @function getComplete
         * @private
         */
        function getComplete() {
            vm.getComplete({ pagination: vm.pagination })
                .then(updatePagination)
                .then(getRecords)
                .then(cacheUsers)
                .then(addLocalPropertiesToCollection)
                .then(concatToVmProperty('completeActionItems'));
        }
        /**
         * @function getAssigneeTooltip
         * @returns {string}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'userId' implicitly has an 'any' type.
        function getAssigneeTooltip(userId) {
            var user = vm.userCache[userId];
            if (user) {
                return user.firstName + " " + user.lastName;
            }
            return "Action Item Assignee";
        }
        /**
         * @method getMoreCompleted
         * Gets the next available completed items.
         */
        function getMoreCompleted() {
            vm.getComplete({ pagination: vm.pagination })
                .then(updatePagination)
                .then(getRecords)
                .then(cacheUsers)
                .then(addLocalPropertiesToCollection)
                .then(concatToVmProperty('completeActionItems'));
        }
        /**
         * @function getRecords
         * @private
         * @param response {object}
         * @returns {array}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
        function getRecords(response) {
            return response.records;
        }
        function sortActionItems() {
            // @ts-ignore
            vm.incompleteActionItems.sort(function (a, b) { return new Date(a.dueDate) - new Date(b.dueDate); });
        }
        /**
         * @method goToMeetingSeries
         * @param seriesId {number}
         * @param personId {number}
         * Close the drawer, open the Meetings drawer, redirect to the given series.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'seriesId' implicitly has an 'any' type.
        function goToMeetingSeries(seriesId, personId) {
            TrayRouter('meetings').open('meeting-series', {
                seriesId: seriesId,
                personId: personId,
            });
        }
        /**
         * @function highlight
         * @private
         * @param actionItem {object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function highlight(actionItem) {
            actionItem._highlighted = true;
            $timeout(function () {
                actionItem._highlighted = false;
            }, 2000);
            return actionItem;
        }
        /**
         * @method isMatchFilter
         * @param actionItem {Object} - action item
         * @returns {Boolean}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function isMatchFilter(actionItem) {
            return (!!vm.filterMenuOptions.activeFilters[actionItem.type] ||
                _.isEmpty(vm.filterMenuOptions.activeFilters));
        }
        /**
         * @method onChangeActionStatus
         * @return {status} status of the action item
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'status' implicitly has an 'any' type.
        function onChangeActionStatus(status) {
            vm.view = status;
        }
        /**
         * @method onChangeDate
         * @param actionItem {object}
         * @param date {Date}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function onChangeDate(actionItem, date) {
            var d = new Date(date);
            d.setUTCMonth(date.getMonth());
            d.setUTCDate(date.getDate());
            d.setUTCFullYear(date.getFullYear());
            actionItem.dueDate = d;
            actionItem._relativeDueDate = ActionItemsService.getRelativeDueDate(actionItem.dueDate);
            setDatepickerEditing(actionItem.id, false);
            ActionItemsService.update(actionItem, ['dueDate'], vm.contextName);
            // send adjusted date to db, but show the selected date in the UI immediately
            actionItem.dueDate = date;
        }
        /**
         * @method onChangeDescription
         * @param actionItem {object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function onChangeDescription(actionItem) {
            ActionItemsService.update(actionItem, ['description'], vm.contextName);
        }
        /**
         * @method onChangeNewActionItemDate
         * @param newActionItem {object}
         * @param date {Date}
         * Keeps local `vm.newActionItem.dueDate` in sync with datepicker.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'newActionItem' implicitly has an 'any' ... Remove this comment to see the full error message
        function onChangeNewActionItemDate(newActionItem, date) {
            newActionItem.dueDate = date;
        }
        /**
         * @method onChangeNewActionItemUser
         */
        function onChangeNewActionItemUser() {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'personId' implicitly has an 'any' type.
            openSelectUserModal(vm.newActionItem, function primaryPersonHandler(personId) {
                vm.newActionItem.user = personId;
                vm.onOwnerChange({ personId: personId });
            });
        }
        /**
         * @method onChangeTitle
         * @param actionItem {object}
         * @param text {string}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function onChangeTitle(actionItem, text) {
            ActionItemsService.update(actionItem, ['title'], vm.contextName);
        }
        /**
         * @method onChangeProgress
         * @param actionItem {object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function onChangeProgress(actionItem) {
            ActionItemsService.update(actionItem, ['progress'], vm.contextName);
            if (actionItem.progress === 100) {
                onChangeCompleted(actionItem, true);
            }
        }
        /**
         * @method onChangeCompleted
         * @param actionItem {object}
         * @param isChecked {boolean}
         * Updates with the backend, then resorts the item.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function onChangeCompleted(actionItem, isChecked) {
            actionItem.completed = isChecked;
            ActionItemsService.update(actionItem, ['completed'], vm.contextName).then(highlight);
            if (actionItem.completed) {
                vm.incompleteActionItems = vm.incompleteActionItems.filter(function (action) { return !action.completed; });
                vm.completeActionItems.unshift(actionItem);
            }
            else {
                vm.completeActionItems = vm.completeActionItems.filter(function (action) { return action.completed; });
                vm.incompleteActionItems.unshift(actionItem);
            }
        }
        /**
         * @method onChangeUser
         * @param actionItem {object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function onChangeUser(actionItem) {
            if (actionItem.canEdit) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'personId' implicitly has an 'any' type.
                openSelectUserModal(actionItem, function primaryPersonHandler(personId) {
                    actionItem.user = personId;
                    ActionItemsService.update(actionItem, ['user'], vm.contextName);
                });
            }
        }
        /**
         * @method onSortByChange
         */
        function onSortByChange() {
            var descending = vm.sortMenu.isDescending ? '-' : '', column = vm.sortMenu.column;
            vm.sortMenu.sortOrder = descending + column;
        }
        /**
         * @function openSelectUserModal
         * @private
         * @param actionItem {object}
         * @param changePrimaryPersonIdHandler {Function}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function openSelectUserModal(actionItem, changePrimaryPersonIdHandler) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'allPeopleIds' implicitly has an 'any' t... Remove this comment to see the full error message
            vm.assigneeOptions.getAssignableUsers().then(function (allPeopleIds) {
                AccessModal.openEdit(_.assign({}, vm.assigneeOptions.getDefaults(), {
                    title: 'Assignee',
                    columnHeaderPrefix: 'Available',
                    primaryPersonLabel: 'Assigned',
                    primaryPersonId: actionItem.user,
                    actionItem: actionItem,
                    peopleIds: allPeopleIds,
                    closeOnSelect: true,
                    changePrimaryPersonId: changePrimaryPersonIdHandler,
                    refreshOnDuplicate: refreshOnDuplicate,
                    initialFilters: {
                        peopleValues: allPeopleIds,
                    },
                }));
            });
        }
        function refreshOnDuplicate() {
            getComplete();
            getIncomplete();
        }
        /**
         * @method remove
         * @param actionItem {object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function remove(actionItem) {
            DeleteWithChallengeModal.open({
                instructions: 'Confirm you are deleting an Action Item',
                itemType: 'Action Item',
                componentTitle: actionItem.title,
            }).then(function deleteConfirmed() {
                ActionItemsService.destroy(actionItem).then(function actionItemRemoveSuccess() {
                    if (actionItem.completed) {
                        vm.pagination.totalCompleteActionItems -= 1;
                    }
                    return removeFromLists(actionItem);
                }, actionItemRemoveError);
            }, angular.noop);
        }
        /**
         * @function removeFromLists
         * @private
         * @param actionItem {object}
         * @returns {object} removed actionItem.
         * Removes from both lists. We don't know why, just that it needs to be gone.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function removeFromLists(actionItem) {
            _.remove(vm.completeActionItems, { id: actionItem.id });
            _.remove(vm.incompleteActionItems, { id: actionItem.id });
            return actionItem;
        }
        /**
         * @function scrollToActionItem
         * @private
         */
        function scrollToActionItem() {
            $timeout(function () {
                // Scroll to the highlighted note
                $anchorScroll('actionItem-' + expandId);
            }, 100);
        }
        /**
         * @method toggleExpand
         * @param actionItem {object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function toggleExpand(actionItem) {
            var collectionName = actionItem.completed ? 'complete' : 'incomplete', allExpandKey = collectionName + 'AllExpanded', isItemExpanded = vm.expandedActionItems[collectionName][actionItem.id];
            vm.expandedActionItems[collectionName][actionItem.id] = !isItemExpanded;
            vm.expandedActionItems[allExpandKey] = _.every(_.values(vm.expandedActionItems[collectionName]));
        }
        /**
         * @method onFilterChange
         * @param filters {array}
         * If no filters are given,
         *  show everything by using all available options.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'filters' implicitly has an 'any' type.
        function onFilterChange(filters) {
            if (!filters.length) {
                filters = _.values(vm.filterMenuOptions.availableOptions);
            }
            else if (_.find(filters, { title: 'Goal' })) {
                var allGoalFilters = _.filter(vm.filterMenuOptions.availableOptions, {
                    title: 'Goal',
                });
                filters = filters.concat(allGoalFilters);
            }
            vm.filterMenuOptions.activeFilters = _.reduce(filters, function (result, filter) {
                // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                result[filter.value] = true;
                return result;
            }, {});
        }
        /**
         * @method onNewActionItemKeyUp
         * @param event {Event}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
        function onNewActionItemKeyUp(event) {
            switch (event.which) {
                case 13: // return key
                    if (canAddNewActionItem()) {
                        create();
                    }
                    break;
            }
        }
        /**
         * @function updatePagination
         * @private
         * @param response {object}
         * @returns {object} original response
         * Grabs the total number of items, so we know if we can fetch more.
         * First up the page size, then go to the next page.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
        function updatePagination(response) {
            if (vm.pagination.pageSize === 5) {
                vm.pagination.pageSize = 25;
            }
            else {
                vm.pagination.pageNumber += 1;
            }
            vm.pagination.totalCompleteActionItems = response.totalRecords;
            return response;
        }
    }
})();

'use strict';
(function () {
    angular.module('App.Meetings', ['App', 'App.Util', 'ETWServices', 'App.TrayNav']);
})();

(function () {
    angular.module('App.Meetings').component('meetings', {
        bindings: {
            toggleFab: '&',
        },
        controller: ['TrayRouter', MeetingsComponentController],
        controllerAs: 'meetingsVm',
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return TEMPLATE_PATH + '/meetings/meetings.html';
            },
        ],
    });
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TrayRouter' implicitly has an 'any' typ... Remove this comment to see the full error message
    function MeetingsComponentController(TrayRouter) {
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        /**
         * @property router
         * @type {object}
         * Get the router instance for the meetings drawer.
         */
        var router = TrayRouter('meetings');
        /**
         * @property routerSubscribeIndex
         * @type {number}
         * Unique ID used to unsubscribe from the router.
         *
         */
        var routerSubscribeIndex = router.subscribe(onRouteChange);
        /**
         * @listener $onInit
         */
        vm.$onDestroy = destroyComponent;
        /**
         * @listener $onInit
         */
        vm.$onInit = init;
        vm.fn = {
            go: router.go,
        };
        /**
         * @property components
         * @type {object}
         * Map of meta information about each component that is shown/hidden.
         * Components are only loaded once they are added to this object
         *   to prevent every component from initializing when the app loads.
         * See go().
         */
        vm.components = {};
        /**
         * @function destroyComponent
         * @private
         */
        function destroyComponent() {
            router.unsubscribe(routerSubscribeIndex);
        }
        /**
         * @function init
         * @private
         */
        function init() {
            // Initial route for the meetings drawer
            router.init('meeting-series-list', {});
            vm.component = router.component;
        }
        /**
         * @function onRouteChange
         * @param component {string}
         * @param params {object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'component' implicitly has an 'any' type... Remove this comment to see the full error message
        function onRouteChange(component, params) {
            vm.components[component] = true;
            if (component) {
                vm.component = component;
            }
            vm.params = params;
            if (vm.component == 'meeting-series-list') {
                vm.toggleFab({ value: true });
            }
            else {
                vm.toggleFab({ value: false });
            }
        }
    }
})();

(function () {
    angular
        .module('App.Meetings')
        .controller('CompleteMeetingModalController', [
        '$scope',
        '$uibModalInstance',
        CompleteMeetingModalController,
    ])
        .factory('CompleteMeetingModal', [
        '$rootScope',
        '$uibModal',
        'TEMPLATE_PATH',
        CompleteMeetingModalFactory,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$rootScope' implicitly has an 'any' typ... Remove this comment to see the full error message
    function CompleteMeetingModalFactory($rootScope, $uibModal, TEMPLATE_PATH) {
        var service = {
            open: open,
        };
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'options' implicitly has an 'any' type.
        function open(options) {
            var ms = $rootScope.$new(true);
            ms.options = options;
            var modalInstance = $uibModal.open({
                animation: true,
                controller: 'CompleteMeetingModalController',
                controllerAs: 'modalVm',
                scope: ms,
                size: 'md',
                templateUrl: TEMPLATE_PATH + '/meetings/complete-meeting-modal/complete-meeting-modal.html',
                windowClass: 'complete-meeting-modal',
            });
            return modalInstance.result;
        }
        return service;
    }
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$scope' implicitly has an 'any' type.
    function CompleteMeetingModalController($scope, $uibModalInstance) {
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        /**
         * @listener $onInit
         */
        vm.$onInit = init;
        vm.fn = {
            ok: ok,
            cancel: cancel,
        };
        vm.topics = $scope.options.topics;
        /**
         * @function init
         */
        function init() { }
        /**
         * @method cancel
         * When the user clicks ok.
         */
        function cancel() {
            $uibModalInstance.dismiss();
        }
        /**
         * @method ok
         * When the user clicks ok.
         */
        function ok() {
            $uibModalInstance.close();
        }
    }
})();

(function () {
    angular.module('App.Meetings').component('meetingDiscussionComments', {
        bindings: {
            currentUserId: '<',
            instance: '<',
            topicId: '<',
            discussion: '=',
            onBeforeComment: '&',
            isCompleted: '<',
            previousDiscussion: '<',
        },
        controller: [
            '$rootScope',
            '$scope',
            'DraftsService',
            'PubnubService',
            'TopicsService',
            MeetingDiscussionCommentsController,
        ],
        controllerAs: 'commentVm',
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return (TEMPLATE_PATH + '/meetings/meeting-discussion-comments/meeting-discussion-comments.html');
            },
        ],
    });
    function MeetingDiscussionCommentsController(
    // @ts-ignore ts-migrate(7006)
    $rootScope, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$scope' implicitly has an 'any' type.
    $scope, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'DraftsService' implicitly has an 'any' ... Remove this comment to see the full error message
    DraftsService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'PubnubService' implicitly has an 'any' ... Remove this comment to see the full error message
    PubnubService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TopicsService' implicitly has an 'any' ... Remove this comment to see the full error message
    TopicsService) {
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        // @ts-ignore ts-migrate(7034) FIXME: Variable 'draftKey' implicitly has type 'any' in s... Remove this comment to see the full error message
        var draftKey;
        /**
         * @listener $onDestroy
         */
        vm.$onDestroy = onDestroy;
        /**
         * @listener $onInit
         */
        vm.$onInit = init;
        vm.fn = {
            countComments: countComments,
            onDeleteComment: onDeleteComment,
            onDraftComment: onDraftComment,
            onSubmitComment: onSubmitComment,
            showCommentEditor: showCommentEditor,
            toggleCollapsedComment: toggleCollapsedComment,
        };
        vm.commentCount = 0;
        /**
         * @property addComment
         * @type {boolean}
         * true to show text area.
         */
        vm.addComment = false;
        /**
         * @property message
         * @type {string}
         * new comment on editor.
         */
        vm.message = '';
        /**
         * @property pubnubSubscriptionKey
         * @type {Number}
         */
        // @ts-ignore ts-migrate(7034) FIXME: Variable 'pubnubSubscriptionKey' implicitly has ty... Remove this comment to see the full error message
        var pubnubSubscriptionKey;
        /**
         * @function init
         * @private
         */
        function init() {
            //Defaults to false (expanded) for active meetings and true (collapsed) for completed meetings by default.
            vm.isCollapsedComment = !!(vm.isCompleted || vm.previousDiscussionPoints);
            countComments();
            draftKey = 'comment-' + vm.instance.id + vm.topicId + '-0';
            vm.message = DraftsService.get(draftKey, vm.discussion.id);
            if (vm.instance.state !== 1) {
                pubnubSubscriptionKey = PubnubService.registerListener('realtime-messaging:onMessage', onPubnubMessage);
            }
        }
        /**
         * @function countComments
         * Counts all comments including replies.
         */
        function countComments() {
            if (vm.discussion.discussionComments) {
                vm.commentCount = vm.discussion.discussionComments.length;
                //must count replies to each comment
                _.forEach(vm.discussion.discussionComments, function (comment) {
                    if (comment && comment.replies)
                        vm.commentCount += comment.replies.length;
                });
            }
        }
        /**
         * @method onDeleteComment
         */
        function onDeleteComment() {
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'draftKey' implicitly has an 'any' type.
            DraftsService.remove(draftKey, vm.discussion.id);
            vm.addComment = false;
        }
        /**
         * @function onDestroy
         * When the component is destroyed, unsubscribe any listeners.
         */
        function onDestroy() {
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'pubnubSubscriptionKey' implicitly has an... Remove this comment to see the full error message
            if (pubnubSubscriptionKey) {
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'pubnubSubscriptionKey' implicitly has an... Remove this comment to see the full error message
                PubnubService.deregisterListener(pubnubSubscriptionKey);
            }
        }
        /**
         * @method onDraftComment
         */
        function onDraftComment() {
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'draftKey' implicitly has an 'any' type.
            DraftsService.store(draftKey, vm.discussion.id, vm.message);
        }
        /**
         * @function onPubnubMessage
         * @param payload
         * @private
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'payload' implicitly has an 'any' type.
        function onPubnubMessage(payload) {
            var props = {
                discussionPointId: vm.discussion.id,
                meetingId: vm.instance.id,
                topicId: vm.topicId,
            };
            var isNewComment;
            var isNewReply = PubnubService.match(payload, 'replyComment', props);
            if (isNewReply) {
                // REPLIES
                var comment = _.find(vm.discussion.discussionComments, {
                    id: payload.body.commentId,
                });
                $scope.$evalAsync(function () {
                    comment.replies.unshift(payload.body.discussionCommentDTO);
                    countComments();
                });
            }
            else {
                isNewComment = PubnubService.match(payload, 'discussionComment', props);
                if (isNewComment && payload.message.action === 'new') {
                    // COMMENTS
                    $scope.$evalAsync(function () {
                        vm.discussion.discussionComments.unshift(payload.body.discussionCommentDTO);
                        countComments();
                    });
                }
            }
        }
        /**
         * @method onSubmitComment
         * comment are saved for specific comment
         */
        function onSubmitComment() {
            vm.addComment = false;
            // Do not add new comment with an empty string.
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'draftKey' implicitly has an 'any' type.
            var msg = DraftsService.get(draftKey, vm.discussion.id);
            if (vm.discussion.id && msg.length) {
                vm.onBeforeComment().then(function () {
                    //add comment
                    TopicsService.addDiscussionComment(vm.instance.id, vm.topicId, vm.discussion.id, msg).then(
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                    function saveCommentSuccess(response) {
                        _.assign(vm.discussion, response.data);
                        //remove from draft
                        // @ts-ignore ts-migrate(7005) FIXME: Variable 'draftKey' implicitly has an 'any' type.
                        DraftsService.remove(draftKey, vm.discussion.id);
                        countComments();
                        vm.addComment = false;
                    }, 
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                    function saveCommentError(response) {
                        $rootScope.$emit('notify', 'Save failed. Network not responding.', 'error');
                    });
                });
            }
        }
        /**
         * @method showCommentEditor
         */
        function showCommentEditor() {
            vm.message = '';
            vm.addComment = true;
        }
        /**
         * expand collapse comment
         */
        function toggleCollapsedComment() {
            vm.isCollapsedComment = !vm.isCollapsedComment;
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'draftKey' implicitly has an 'any' type.
            var msg = DraftsService.get(draftKey, vm.discussion.id);
            if (msg && msg.length) {
                vm.addComment = true;
            }
        }
    }
})();

(function () {
    angular.module('App.Meetings').component('meetingDiscussionPoints', {
        bindings: {
            currentUserId: '<',
            discussionPoints: '=',
            instance: '<',
            isCompleted: '<',
            onBeforeDiscussion: '&',
            onChange: '&',
            showAddDiscussion: '<',
            resetAddDiscussion: '&',
            topic: '=',
            templates: '<',
        },
        controller: [
            '$rootScope',
            'AuthenticationService',
            'TopicsService',
            'Analytics',
            MeetingDiscussionPointsController,
        ],
        controllerAs: 'discussionVm',
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return TEMPLATE_PATH + '/meetings/meeting-discussion-points/meeting-discussion-points.html';
            },
        ],
    });
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AuthenticationService' implicitly has a... Remove this comment to see the full error message
    function MeetingDiscussionPointsController($rootScope, AuthenticationService, TopicsService, Analytics) {
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        vm.hasAdmin = AuthenticationService.hasPermission('VIEW_ADMIN');
        /**
         * @listener $onChanges
         * @param bindings {Object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'bindings' implicitly has an 'any' type.
        vm.$onChanges = function (bindings) {
            if (bindings.showAddDiscussion) {
                if (bindings.showAddDiscussion.currentValue) {
                    // @ts-ignore ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
                    add();
                }
            }
        };
        vm.fn = {
            add: add,
            addCheckInTemplate: Analytics.wrap(Analytics.hardcodedDiscussionPointTemplate, addCheckInTemplate),
            addDynamicTemplate: Analytics.wrap(Analytics.dynamicDiscussionPointTemplate, addDynamicTemplate),
            copyDiscussionPoint: Analytics.wrap(Analytics.copyDiscussionPointFromPreviousMeetingInstance, copyDiscussionPoint),
            create: create,
            onEditModeDiscussionPoint: onEditModeDiscussionPoint,
            remove: remove,
            save: save,
        };
        /**
         * @function add
         * Create a new, empty discussion point.
         * ID is required for ng-repeat.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'discussionText' implicitly has an 'any'... Remove this comment to see the full error message
        function add(discussionText) {
            var participants = _.map(vm.instance.participantSet, 'userId');
            var point = TopicsService.getNewDiscussionPoint(vm.currentUserId, vm.instance.id, vm.topic.id, participants);
            if (discussionText) {
                point.discussionPoint = discussionText;
            }
            return vm.onBeforeDiscussion().then(function () {
                vm.resetAddDiscussion();
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'discussionPoint' implicitly has an 'any... Remove this comment to see the full error message
                create(point).then(function (discussionPoint) {
                    discussionPoint.editOn = true;
                    vm.topic.discussionPoints.unshift(discussionPoint);
                });
            });
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'discussion' implicitly has an 'any' typ... Remove this comment to see the full error message
        function addDynamicTemplate(discussion, template) {
            discussion.editOn = true;
            var orig = discussion.discussionPoint || '';
            discussion.discussionPoint = orig + template.content;
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'discussion' implicitly has an 'any' typ... Remove this comment to see the full error message
        function addCheckInTemplate(discussion) {
            discussion.editOn = true;
            var orig = discussion.discussionPoint || '';
            var harcodedTemplate = "\n<p><strong>Biggest win:</strong></p>\n<ul>\n<li></li>\n</ul>\n<p><strong>What this team needs to know in order to make better decisions:</strong></p>\n<ul>\n<li></li>\n</ul>\n<p><strong>What I need help with:</strong></p>\n<ul>\n<li></li>\n</ul>\n";
            discussion.discussionPoint = orig + harcodedTemplate;
        }
        /**
         * @function copyDiscussionPoint
         * @param discussion
         * Copies the discussion point from the previous meeting to the current meeting.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'discussion' implicitly has an 'any' typ... Remove this comment to see the full error message
        function copyDiscussionPoint(discussion) {
            add(discussion.discussionPoint);
        }
        /**
         * @function create
         * @param point {object}
         * Use the first change to create a discussion point
         * Subsequent updates are batched up in a promise chain
         * to update the discussion point after its created.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'point' implicitly has an 'any' type.
        function create(point) {
            return TopicsService.saveDiscussionPoint(vm.instance.id, vm.topic.id, point.discussionPoint).then(
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            function createDiscussionSuccess(response) {
                var newPoint = response.data;
                newPoint.editOn = true;
                vm.onChange({ point: response.data });
                return newPoint;
            }, 
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            function createDiscussionError(response) {
                console.error('CREATE DISCUSSION POINT ERROR', response);
                $rootScope.$emit('notify', 'Save failed. Network not responding.', 'error');
            });
        }
        /**
         * @method onEditModeDiscussionPoint
         *  @param [discussion] {object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'discussion' implicitly has an 'any' typ... Remove this comment to see the full error message
        function onEditModeDiscussionPoint(discussion) {
            discussion.editOn = !discussion.editOn;
        }
        /**
         * @function remove
         * @param point {Object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'point' implicitly has an 'any' type.
        function remove(point) {
            _.remove(vm.discussionPoints, { id: point.id });
            TopicsService.destroyDiscussionPoint(vm.instance.id, vm.topic.id, point.id).then(function deleteDiscussionSuccess() {
                vm.onChange({ point: point });
            }, 
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            function deleteDiscussionError(response) {
                console.error('DELETE DISCUSSION POINT ERROR', response);
            });
        }
        /**
         * @method save
         * @param point {Object}
         * Discussion points are saved separately from the topic.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'point' implicitly has an 'any' type.
        function save(point) {
            return TopicsService.saveDiscussionPoint(vm.instance.id, vm.topic.id, point.discussionPoint, point.id).then(
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            function updateDiscussionSuccess(response) {
                var updatedDiscussion = _.find(vm.discussionPoints, {
                    id: response.data.id,
                });
                if (updatedDiscussion) {
                    updatedDiscussion.updatedDate = response.data.updatedDate;
                }
                vm.onChange({ point: response.data });
                return updatedDiscussion;
            }, 
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            function updateDiscussionError(response) {
                console.error('SAVE DISCUSSION POINT ERROR', response);
                $rootScope.$emit('notify', 'Save failed. Network not responding.', 'error');
            });
        }
    }
})();

(function () {
    angular.module('App.Meetings').component('meetingDiscussionReplies', {
        bindings: {
            currentUserId: '<',
            instance: '<',
            topicId: '<',
            discussion: '=',
            comment: '=',
            onBeforeReply: '&',
            isCompleted: '<',
            previousDiscussion: '<',
            onAfterReply: '&',
        },
        controller: ['TopicsService', 'DraftsService', MeetingDiscussionRepliesController],
        controllerAs: 'replyVm',
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return (TEMPLATE_PATH + '/meetings/meeting-discussion-replies/meeting-discussion-replies.html');
            },
        ],
    });
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TopicsService' implicitly has an 'any' ... Remove this comment to see the full error message
    function MeetingDiscussionRepliesController(TopicsService, DraftsService) {
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        // @ts-ignore ts-migrate(7034) FIXME: Variable 'replyDraftKey' implicitly has type 'any'... Remove this comment to see the full error message
        var replyDraftKey;
        /**
         * @listener $onInit
         */
        vm.$onInit = init;
        vm.fn = {
            onDeleteReply: onDeleteReply,
            onDraftReply: onDraftReply,
            onSubmitReply: onSubmitReply,
            showReplyEditor: showReplyEditor,
        };
        /**
         * @property addReply
         * @type {boolean}
         * true to show text area.
         */
        vm.addReply = false;
        /**
         * @property replyMessage
         * @type {string}
         * new comment on editor.
         */
        vm.replyMessage = '';
        /**
         * @function init
         * @private
         */
        function init() {
            replyDraftKey = 'commentReply-' + vm.instance.id + vm.topicId + '-0';
            vm.replyMessage = DraftsService.get(replyDraftKey, vm.comment.id);
            //message is drafted open in editor
            if (vm.replyMessage) {
                vm.addReply = true;
            }
        }
        /**
         * @method onDeleteReply
         */
        function onDeleteReply() {
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'replyDraftKey' implicitly has an 'any' t... Remove this comment to see the full error message
            DraftsService.remove(replyDraftKey, vm.comment.id);
            vm.addReply = false;
            vm.replyMessage = '';
        }
        /**
         * @method onDraftReply
         */
        function onDraftReply() {
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'replyDraftKey' implicitly has an 'any' t... Remove this comment to see the full error message
            DraftsService.store(replyDraftKey, vm.comment.id, vm.replyMessage);
        }
        /**
         * @method onSubmitReply
         */
        function onSubmitReply() {
            vm.addReply = false;
            // Do not add reply with an empty string.
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'replyDraftKey' implicitly has an 'any' t... Remove this comment to see the full error message
            var msg = DraftsService.get(replyDraftKey, vm.comment.id);
            if (vm.comment.id && msg.length) {
                vm.onBeforeReply().then(function () {
                    //add reply
                    TopicsService.addDiscussionCommentReply(vm.instance.id, vm.topicId, vm.discussion.id, vm.comment.id, msg).then(
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                    function saveReplySuccess(response) {
                        _.assign(vm.discussion, response.data);
                        //remove from draft
                        // @ts-ignore ts-migrate(7005) FIXME: Variable 'replyDraftKey' implicitly has an 'any' t... Remove this comment to see the full error message
                        DraftsService.remove(replyDraftKey, vm.comment.id);
                        vm.replyMessage = '';
                        vm.onAfterReply();
                        vm.addReply = false;
                    }, 
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                    function saveReplyError(response) {
                        console.error('SAVE reply ERROR', response);
                    });
                });
            }
        }
        /**
         * @method showReplyEditor
         */
        function showReplyEditor() {
            vm.addReply = true;
        }
    }
})();

var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
(function () {
    angular.module('App.Meetings').component('meetingInstance', {
        controller: [
            '$anchorScroll',
            '$filter',
            '$scope',
            '$state',
            '$window',
            'AccessModal',
            'ActionItemsService',
            'AuthenticationService',
            'CLIENT_SETTINGS',
            'CompleteMeetingModal',
            'ETWServicesUtils',
            'MeetingInstancesService',
            'MeetingSeriesService',
            'PeopleService',
            'PlansService',
            'TopicsService',
            'TrayRouter',
            MeetingInstanceComponentController,
        ],
        controllerAs: 'instanceVm',
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return TEMPLATE_PATH + '/meetings/meeting-instance/meeting-instance.html';
            },
        ],
    });
    function MeetingInstanceComponentController($anchorScroll, $filter, $scope, $state, $window, AccessModal, ActionItemsService, AuthenticationService, CLIENT_SETTINGS, CompleteMeetingModal, ETWServicesUtils, MeetingInstancesService, MeetingSeriesService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$anchorScroll' implicitly has an 'any' ... Remove this comment to see the full error message
    PeopleService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$scope' implicitly has an 'any' type.
    PlansService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ActionItemsService' implicitly has an '... Remove this comment to see the full error message
    TopicsService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TrayRouter' implicitly has an 'any' ... Remove this comment to see the full error message
    TrayRouter) {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AuthenticationService' implicitly has a... Remove this comment to see the full error message
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'CLIENT_SETTINGS' implicitly has an 'any... Remove this comment to see the full error message
         * @property hasDelegateManagerialAuth
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'ETWServicesUtils' implicitly has an 'an... Remove this comment to see the full error message
         * @type {boolean}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'MeetingInstancesService' implicitly has... Remove this comment to see the full error message
        var hasDelegateManagerialAuth = AuthenticationService.hasPermission(
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'PlansService' implicitly has an 'any' t... Remove this comment to see the full error message
        'DELEGATE_MANAGERIAL_AUTHORITY');
        /**
         * @property hasPlanAdmin
         * @type {boolean}
         */
        var hasPlanAdmin = AuthenticationService.hasPermission('ADMIN_PLANS');
        /**
         * @property lastCompletedInstance
         * @type {object}
         */
        var lastCompletedInstance;
        var ls = $window.localStorage;
        var localStorageDefaultActionUserKey = "action.item.last.owner";
        /**
         * @property router
         * @type {object}
         * Get the router instance for the meetings drawer.
         */
        var router = TrayRouter('meetings');
        /**
         * @property routerSubscribeIndex
         * @type {number}
// @ts-ignore ts-migrate(7034) FIXME: Variable 'lastCompletedInstance' implicitly has ty... Remove this comment to see the full error message
         * Unique ID used to unsubscribe from the router.
         */
        var routerSubscribeIndex;
        /**
         * @property targetPersonId
         * @type {number}
         * The participant that this Meeting Instance is being fetched for.
         * By default this will be the current user ID.
         * Used for when the current user is looking at Meeting Instances of a subordinate.
         */
        var targetPersonId;
        /**
// @ts-ignore ts-migrate(7034) FIXME: Variable 'routerSubscribeIndex' implicitly has typ... Remove this comment to see the full error message
         * @property topicsServiceSubscribeIndex
         * @type: {number}
         */
        var topicsServiceSubscribeIndex;
        /**
         * @property trayOpenSubscriptionIndex
         * @type {number}
         * ID used to unsubscribe the tray opening.
         */
        var trayOpenSubscriptionIndex;
        var vm = this;
        /**
         * @listener $onDestroy
         */
        vm.$onDestroy = destroyComponent;
        /**
// @ts-ignore ts-migrate(7034) FIXME: Variable 'targetPersonId' implicitly has type 'any... Remove this comment to see the full error message
         * @listener $onInit
         */
        vm.$onInit = init;
        vm.fn = {
            addTopic: addTopic,
            close: router.close,
            exit: exit,
            // @ts-ignore ts-migrate(7034) FIXME: Variable 'topicsServiceSubscribeIndex' implicitly ... Remove this comment to see the full error message
            focusOnTopicTitle: focusOnTopicTitle,
            go: router.go,
            goToSeriesBreadcrumb: goToSeriesBreadcrumb,
            onBeforeChangeTopic: onBeforeChangeTopic,
            onChangeActionItems: onChangeActionItems,
            // @ts-ignore ts-migrate(7034) FIXME: Variable 'trayOpenSubscriptionIndex' implicitly ha... Remove this comment to see the full error message
            onChangeDate: onChangeDate,
            // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
            openAccessModal: openAccessModal,
            promptComplete: promptComplete,
            save: save,
            toggleTopics: toggleTopics,
            changeMessage: changeMessage,
        };
        vm.actionItems = [];
        vm.actionItemCount = 0;
        vm.actionItemOverdueCount = 0;
        /**
         * @property currentUserId
         * @type {number}
         */
        vm.currentUserId = AuthenticationService.getAccount().userId;
        /**
         * @property highlightedTopicId
         * @type {number}
         * Used to tell a new topic to highlight itself.
         * Used when adding a new topic.
         */
        vm.highlightedTopicId = -1;
        /**
         * @property isCollapsed
         * @type {boolean}
         * Tells the template whether or not to collapse the topics.
         * Originally implemented to aid drag-and-drop sort.
         */
        vm.isCollapsed = true;
        /**
         * @property isError
         * @type {boolean}
         * Hides the Instance info and shows an error message.
         * Originally added for when a user is not allowed to view a suggested Instance.
         */
        vm.isError = false;
        /**
         * @property isLoaded
         * @type {boolean}
         */
        vm.isLoaded = false;
        /**
         * @property isCompletableByUser
         * @type {boolean}
         * show or hides the complete button
         */
        vm.isCompletableByUser = false;
        /**
         * @property isShowVisibleOnly
         * @type {boolean}
         */
        vm.isShowVisibleOnly = false;
        /**
         * instance date in adjusted to be the same 'day' as the original
         * so that the local timezone does not set it forward or back by a day
         */
        vm.localDate = new Date();
        /**
         * @property newTopicTitle
         * @type {string}
         * Used by inline-edit when creating a new topic.
         */
        vm.newTopicTitle = '';
        /**
         * @property sortableConfig
         * @type {object}
         */
        vm.sortableConfig = {
            containment: '.template-topics',
            //restrict move across columns. move only within column.
            accept: function (sourceItemHandleScope, destSortableScope) {
                return sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id;
            },
            orderChanged: setCustomSort,
        };
        /**
         * @property topics
         * @type {Array}
         */
        vm.topics = [];
        /**
         * @property changes
         * @type {Array}
         */
        vm.changes = [];
        vm.isViewingChanges = false;
        /**
         * @property discussionPointTemplates
         * @type {Array}
         * Templates pulled from Purpose & Rules of Engagement. This is the last
         * time in the component structure we have access to the
         * series.
         */
        vm.discussionPointTemplates = [];
        /**
         * @function changeMessage
         * @param {TopicDiff} change
         * @returns {String}
         */
        function changeMessage(change) {
            if (change.type == 'add') {
                return "Topic '" + change.topic.title + "' was added.";
            }
            else if (change.type == 'rename') {
                return "Topic '" + change.prevTopic.title + "' was renamed to '" + change.topic.title + ".'";
            }
            else {
                return 'Unsupported Change';
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'sourceItemHandleScope' implicitly has a... Remove this comment to see the full error message
            }
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'destSortableScope' implicitly has an 'a... Remove this comment to see the full error message
         * @function diffChangesInTopics
         * @param {array<Topic>} prevTopics
         * @param {array<Topic>} currTopics
         * @returns {array<TopicDiff>}
         */
        function diffChangesInTopics(prevTopics, currTopics) {
            var prevIds = _.map(prevTopics, 'id');
            var currIds = _.map(currTopics, 'id');
            var isFromTemplate = function (topic) { return !!topic.templateTopicId; };
            var newIds = _.difference(currIds, prevIds);
            var additions = currTopics
                .filter(isFromTemplate)
                .filter(function (topic) { return newIds.includes(topic.id); })
                .map(function (topic) { return ({
                type: 'add',
                topic: topic,
            }); });
            return additions;
        }
        /**
         * @method addTopic
         * Adds an empty Topic object to the list of Topics.
         */
        function addTopic(title) {
            var newTopic = {
                instanceId: vm.instance.id,
                title: title,
            };
            // @ts-ignore
            save().then(function () {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'change' implicitly has an 'any' type.
                TopicsService.save(vm.instance.id, newTopic).then(function createTopicSuccess(response) {
                    vm.newTopicTitle = '';
                    // Highlight the newly added topic
                    vm.highlightedTopicId = response.data.id;
                    // Scroll into view
                    $anchorScroll('meeting-topic-' + vm.instance.id + '-' + vm.highlightedTopicId);
                });
            });
        }
        /**
         * @method assignParticipants
         * @param action {string}
         * @returns {object} - promise
         */
        function assignParticipants(action) {
            return function (personOrPeople) {
                var peopleIds = personOrPeople;
                if (action !== 'unassign-all') {
                    // personOrPeople is either an object for one or an array for multiple
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'prevTopics' implicitly has an 'any' typ... Remove this comment to see the full error message
                    peopleIds = _(personOrPeople)
                        .castArray()
                        .map('id')
                        .value();
                }
                peopleIds = _.difference(peopleIds, vm.series.ownerSet);
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'topic' implicitly has an 'any' type.
                if (action == 'assign') {
                    vm.participants = _.union(vm.participants, peopleIds);
                    _.forEach(peopleIds, function (id) {
                        vm.instance.participantSet.push({ userId: id, isAttendee: true });
                    });
                }
                else {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'topic' implicitly has an 'any' type.
                    vm.participants = _.difference(vm.participants, peopleIds);
                    _.forEach(peopleIds, function (id) {
                        _.remove(vm.instance.participantSet, function (participant) {
                            // @ts-ignore
                            return participant.userId == id;
                        });
                    });
                }
                saveParticipants();
            };
        }
        /**
         * @function complete
         * @private
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
         * Set the state to 'completed'
         * Save the instance
         * Redirect to the series detail.
         */
        function complete() {
            vm.instance.state = 1;
            save('state').then(function saveCompleteFinal() {
                goToTargetPersonRoute('meeting-series', {
                    seriesId: vm.instance.seriesId,
                });
            });
        }
        /**
         * @function destroyComponent
         * @private
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'action' implicitly has an 'any' type.
        function destroyComponent() {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'personOrPeople' implicitly has an 'any'... Remove this comment to see the full error message
            router.unsubscribe(routerSubscribeIndex);
            TopicsService.unsubscribe(topicsServiceSubscribeIndex);
            // TODO: Migrate this event to the TrayRouter. (ETWServicesUtils should only be used in the ETWServices module.)
            ETWServicesUtils.unsubscribe('TrayOpen')(trayOpenSubscriptionIndex);
            if (ls && ls.getItem) {
                ls.removeItem(localStorageDefaultActionUserKey);
            }
        }
        /**
         * @method exit
         * If instance doesn't exist, create it.
         * Redirect to the series detail.
         */
        function exit() {
            // @ts-ignore
            save().then(function () {
                goToTargetPersonRoute('meeting-series', {
                    seriesId: vm.instance.seriesId,
                });
            });
        }
        /**
         * @method focusOnTopicTitle
         * Tells the inline-edit directive to go into edit mode.
         * Used when the '+' is clicked to add a topic.
         */
        function focusOnTopicTitle() {
            $scope.$broadcast('inlineEdit:edit', 'newTopicTitle');
        }
        /**
         * @function getBossChain
         * @private
         * Determine if the current user is in the boss chain of the *participant*.
         * Owner boss chain doesn't matter.
         * This should only be checked for 1:1 meetings.
         */
        function getBossChain() {
            var subordinateId = vm.series.participantSet.length ? vm.series.participantSet[0] : undefined;
            return PeopleService.getBossChainLevelForIds([subordinateId], vm.currentUserId).then(function getTeamBossChainSuccess(bossChainLevel) {
                // 0 is if the subordinate is the current user.
                return bossChainLevel > 0;
            }, function getTeamBossChainError(response) {
                console.error('GET BOSS CHAIN ERROR', response);
            });
        }
        /**
         * @function getInstance()
         * @private
         */
        function getInstance() {
            var promise;
            if (router.params.instanceId) {
                // Existing Meeting Instance
                promise = MeetingInstancesService.getById(targetPersonId, router.params.instanceId);
            }
            else {
                promise = getNewInstance();
            }
            return promise.then(
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'routerSubscribeIndex' implicitly has an ... Remove this comment to see the full error message
            function getInstanceSuccess(response) {
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'topicsServiceSubscribeIndex' implicitly ... Remove this comment to see the full error message
                vm.instance = response.data;
                vm.isCompleted = vm.instance.state == 1;
                vm.participants = _.map(vm.instance.participantSet, 'userId');
                getLocalDate();
            }, function getInstanceError(response) {
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'trayOpenSubscriptionIndex' implicitly ha... Remove this comment to see the full error message
                console.error('GET MEETING INSTANCE ERROR', response);
                vm.isError = true;
            });
        }
        /**
         * @function getLastCompletedInstance
         * @returns {object} - promise, Meeting Instance
         * @private
// @ts-ignore ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
         * Gets the most recent completed instance.
         * Returns the instance object, not a response.
         */
        function getLastCompletedInstance() {
            return MeetingInstancesService.getLastCompletedForSeries(targetPersonId, router.params.seriesId).then(function whenLastCompletedExists(response) {
                return response.data;
            }, function whenLastCompletedDoesNotExist(response) {
                // If the error status is 404, then there aren't any completed instances.
                // If the error status is 403, there are instances, but you are not invited. Return a rejection.
                if (response.status === 403) {
                    return MeetingInstancesService.reject({});
                }
                else if (response.status !== 404) {
                    console.error('GET LAST INSTANCE FOR THIS SERIES ERROR');
                }
            });
        }
        // @ts-ignore ts-migrate(7006)
        function getLocalDate() {
            var existingDate = new Date(vm.instance.date);
            var d = new Date(vm.instance.date);
            d.setDate(existingDate.getUTCDate());
            d.setMonth(existingDate.getUTCMonth());
            d.setFullYear(existingDate.getUTCFullYear());
            vm.localDate = d;
        }
        /**
         * @function getNewInstance
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
         * @returns {object} - promise
         * @private
         * Gets a new Meeting Instance by first checking the date of the last completed instance.
         */
        function getNewInstance() {
            return getLastCompletedInstance().then(function getLastCompleted(instance) {
                var lastDate, lastParticipantSet = [], options = {
                    seriesId: router.params.seriesId,
                    state: null,
                };
                if (instance) {
                    lastCompletedInstance = instance;
                    lastDate = lastCompletedInstance.date;
                    //Plan meetings with adhoc only are concerned with series participants and owners not the last completed this will be handled in backend
                    lastParticipantSet =
                        vm.series.type !== 'PLAN' ? _.map(lastCompletedInstance.participantSet, 'userId') : [];
                }
                return MeetingInstancesService.getNew(options, vm.series, lastDate, lastParticipantSet);
            });
        }
        /**
         * @function getPlanAssignments
         * @returns {object} - plan
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'bossChainLevel' implicitly has an 'any'... Remove this comment to see the full error message
         * @private
         * Gets an associated plan assignments for the meeting if the type is a plan meeting.
         */
        function getPlanAssignments() {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            return PlansService.getPlanAssignments(vm.series.planId).then(function getPlanAssignmentsSuccess(response) {
                return response.data;
            }, function getPlanAssignmentsSuccess(response) {
                console.error('GET PLAN FOR INSTANCE ERROR', response);
            });
        }
        /**
         * @function getSeries
         * @private
         * Fetch the series.
         * Originally just for the bread crumb.
         */
        // @ts-ignore ts-migrate(7005) FIXME: Variable 'targetPersonId' implicitly has an 'any' ... Remove this comment to see the full error message
        function getSeries() {
            return MeetingSeriesService.getById(router.params.seriesId).then(function getSeriesSuccess(response) {
                vm.series = response.data;
            }, function getSeriesError(response) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                console.error('GET SERIES FOR INSTANCE ERROR', response);
            });
        }
        /**
         * @function getSeriesAndInstanceAndTopics
         * @private
         * Since the router notifies on all route changes,
         * only fetch the series, instance, and topics when a route matches this specific component.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
        function getSeriesAndInstanceAndTopics() {
            var promise = getSeries()
                .then(getInstance)
                .then(getUserAccess);
            if (router.params.instanceId) {
                // Don't wait for fetching topics
                getTopics(router.params.instanceId);
            }
            else {
                // Topics for a new instance need to wait for last completed to complete.
                promise.then(getTopicsForNewInstance);
            }
            return promise.finally(function getInstanceFinal() {
                vm.isLoaded = true;
            });
        }
        /**
// @ts-ignore ts-migrate(7005) FIXME: Variable 'targetPersonId' implicitly has an 'any' ... Remove this comment to see the full error message
         * @function getTopics
         * @param instanceId {number}
         * @private
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
        function getTopics(instanceId) {
            TopicsService.getAllForInstance(instanceId)
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                .then(function getTopicsSuccess(response) {
                vm.topics = response.data;
                _.forEach(vm.topics, function (topic) {
                    topic.series = vm.series;
                });
            })
                .then(function () {
                getLastCompletedInstance()
                    .then(function (lastInstance) {
                    // Status codes were used to communicate
                    // why a previous instance didn't
                    // exist. To simplify the endless chain of
                    // checking if things are null, I'm
                    // providing an empty value to the next
                    // step and it can run as if everything is
                    // fine.
                    if (lastInstance) {
                        return TopicsService.copyAllFromInstance(lastInstance.id);
                    }
                    return {
                        data: [],
                    };
                })
                    .then(function (response) {
                    var prevTopics = response.data;
                    if (!prevTopics.length)
                        return;
                    var oldTopics = prevTopics;
                    var newTopics = vm.topics;
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'instance' implicitly has an 'any' type.
                    vm.changes = diffChangesInTopics(oldTopics, newTopics);
                });
            });
        }
        /**
         * @function getTopicsForNewInstance
         * @private
         */
        function getTopicsForNewInstance() {
            if (lastCompletedInstance && lastCompletedInstance.id) {
                TopicsService.copyAllFromInstance(lastCompletedInstance.id).then(function copyTopicsSuccess(response) {
                    vm.topics = response.data;
                }, function copyTopicsError(response) {
                    console.error('COPY TOPICS FROM INSTANCE ERROR', response);
                });
            }
        }
        /**
         * @method goToSeriesBreadcrumb
         * Navigates to another screen in the Meetings drawer.
         * If current user is viewing the Meetings of a subordinate, pass the personId.
         */
        function goToSeriesBreadcrumb() {
            goToTargetPersonRoute('meeting-series', { seriesId: vm.series.id });
        }
        /**
         * @function goToTargetPersonRoute
         * @param component {string}
         * @param params {object}
         * @private
         * For specific routes that need to pass a person ID when the current user is viewing meetings of a subordinate.
         * Do not pass the person ID when it is the current user.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
        function goToTargetPersonRoute(component, params) {
            if (targetPersonId !== vm.currentUserId) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                // Do not pass the personId if it is the same as the current user ID since assumptions might be made elsewhere if it is present.
                params.personId = targetPersonId;
            }
            router.go(component, params);
        }
        /**
         * @function getUserAccess
         * @returns {*}
         */
        function getUserAccess() {
            var isCurrentUserAnOwner = _.includes(vm.series.ownerSet, vm.currentUserId), 
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            isCurrentUserAParticipant = _.includes(vm.series.participantSet, vm.currentUserId), 
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            isPlanAdmin = AuthenticationService.hasPermission('ADMIN_PLANS'), isMeetingParticipant = _.includes(vm.participants, vm.currentUserId), promise;
            // Only plan admins, owners, participants can click on the plan link; not boss chain.
            vm.isPlanClickable = isPlanAdmin || isCurrentUserAnOwner || isCurrentUserAParticipant;
            if (vm.series.type == 'ONE_TO_ONE') {
                //One to One - owners, participants, DMA, or boss chain of participant can complete
                if (hasDelegateManagerialAuth || isCurrentUserAnOwner || isCurrentUserAParticipant || isMeetingParticipant) {
                    vm.isCompletableByUser = true;
                }
                else if (vm.series.participantSet.length) {
                    // Since not an owner nor DMA, do the hard work of asking the API for the boss chain.
                    // Boss chain is based on the *participant*; if there are none, don't bother.
                    promise = getBossChain().then(function (isLeaderOrBossChain) {
                        vm.isCompletableByUser = isLeaderOrBossChain;
                    });
                }
            }
            else if (vm.series.type == 'PLAN') {
                //Plan - Plan Admin and owners can complete
                vm.isCompletableByUser = isCurrentUserAnOwner || hasPlanAdmin || isCurrentUserAParticipant || isMeetingParticipant;
            }
            else {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'instanceId' implicitly has an 'any' typ... Remove this comment to see the full error message
                //General - Owners can complete
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                vm.isCompletableByUser = isCurrentUserAnOwner || isCurrentUserAParticipant || isMeetingParticipant;
            }
            return promise || MeetingInstancesService.resolve();
        }
        /**
         * @function init
         * @private
         */
        function init() {
            targetPersonId = router.params.personId || vm.currentUserId;
            getSeriesAndInstanceAndTopics()
                .then(function () {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'lastInstance' implicitly has an 'any' t... Remove this comment to see the full error message
                if (vm.instance.state === null) {
                    vm.fn
                        .save()
                        .then(getInstance)
                        .then(function () { return getTopics(vm.instance.id); });
                }
            })
                .then(function () {
                vm.discussionPointTemplates = __spreadArray(__spreadArray([], MeetingSeriesService.findTemplates(vm.series.rulesOfEngagement)), MeetingSeriesService.findTemplates(vm.series.templateRulesOfEngagement));
            });
            routerSubscribeIndex = router.subscribe(onRouteChange);
            // Subscribe to topic changes (originally for attachments)
            topicsServiceSubscribeIndex = TopicsService.subscribe(function () {
                getTopics(vm.instance.id);
            });
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            // TODO: Migrate this event to the TrayRouter. (ETWServicesUtils should only be used in the ETWServices module.)
            trayOpenSubscriptionIndex = ETWServicesUtils.subscribe('TrayOpen')(getInstance);
        }
        /**
         * @method onBeforeChangeTopic
         * @returns {object} - promise
         * Called before a topic is saved so this instance could be created first.
         */
        function onBeforeChangeTopic() {
            // @ts-ignore
            return save();
        }
        /**
         * @function onChangeActionItems
         * @param records {Array}
         * When action items are changed, store the list.
         */
        function onChangeActionItems(records) {
            // vm.actionItemNearDueCount = 0;
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'lastCompletedInstance' implicitly has an... Remove this comment to see the full error message
            vm.actionItems = records;
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'lastCompletedInstance' implicitly has an... Remove this comment to see the full error message
            vm.actionItemCount = records.filter(function (x) { return !x.completed; }).length;
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'lastCompletedInstance' implicitly has an... Remove this comment to see the full error message
            vm.actionItemOverdueCount = records.filter(function (x) { return !x.completed && ActionItemsService.getRelativeDueDate(x.dueDate).overDue; }).length;
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'lastCompletedInstance' implicitly has an... Remove this comment to see the full error message
            vm.actionItemNearDueCount = records.filter(function (x) { return !x.completed && ActionItemsService.getRelativeDueDate(x.dueDate).nearDue; }).length;
        }
        /**
         * @method onChangeDate
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
         * @param date {string}
         * Save the date set by the datepicker.
         * If the update fails, reset the date to the original value.
         */
        function onChangeDate(date) {
            var originalDate = vm.instance.date;
            var d = new Date(date);
            d.setUTCMonth(date.getMonth());
            d.setUTCDate(date.getDate());
            d.setUTCFullYear(date.getFullYear());
            vm.instance.date = d;
            save('date').catch(function onChangeDateError() {
                // Reset date back to the original value;
                vm.instance.date = originalDate;
            });
        }
        /**
         * @function onRouteChange
         * Determine whether or not the route change applies to this component.
         */
        function onRouteChange() {
            // Only respond for this component and an existing series
            if (router.component == 'meeting-instance' && router.params.seriesId) {
                targetPersonId = router.params.personId || vm.currentUserId;
                // Only respond if router navigated to a different instance (save() updates the ID)
                if (!router.params.instanceId ||
                    !vm.instance ||
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'component' implicitly has an 'any' type... Remove this comment to see the full error message
                    router.params.instanceId !== vm.instance.id) {
                    getSeriesAndInstanceAndTopics();
                }
            }
        }
        /**
         * @method openAccessModal
         * Open the AccessModal to add/remove participants.
         */
        function openAccessModal() {
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'targetPersonId' implicitly has an 'any' ... Remove this comment to see the full error message
            var participantIds = _.map(vm.instance.participantSet, 'userId');
            var peopleIds = _([vm.series.ownerSet, participantIds])
                .filter(_.isArray)
                .flatten()
                .concat()
                .uniq()
                .value();
            if (vm.series.type == 'GENERAL' && vm.instance.state != 1) {
                AccessModal.openEdit({
                    peopleIds: peopleIds,
                    title: 'Participants',
                    isRequired: true,
                    hasPrimaryPerson: false,
                    immutablePeopleIds: vm.series.ownerSet,
                    isReadOnly: false,
                    addAllPeople: assignParticipants('assign'),
                    addPerson: assignParticipants('assign'),
                    removePerson: assignParticipants('unassign'),
                    removePeople: assignParticipants('unassign-all'),
                });
            }
            else if (vm.series.type == 'PLAN' && vm.instance.state != 1) {
                getPlanAssignments().then(function (assignments) {
                    //only ad hoc participants are allowed to be removed - add to immutablePeopleIds
                    var planParticipants = _.map(assignments.participantAssignments, 'userId');
                    AccessModal.openEdit({
                        peopleIds: peopleIds,
                        title: 'Participants',
                        isRequired: true,
                        hasPrimaryPerson: false,
                        immutablePeopleIds: vm.series.ownerSet.concat(planParticipants),
                        isReadOnly: false,
                        addAllPeople: assignParticipants('assign'),
                        addPerson: assignParticipants('assign'),
                        removePerson: assignParticipants('unassign'),
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'isLeaderOrBossChain' implicitly has an ... Remove this comment to see the full error message
                        removePeople: assignParticipants('unassign-all'),
                    });
                });
            }
            else if (vm.series.type == 'ONE_TO_ONE' && vm.instance.state != 1) {
                AccessModal.openEdit({
                    peopleIds: peopleIds,
                    title: 'Participants',
                    isRequired: true,
                    hasPrimaryPerson: false,
                    immutablePeopleIds: vm.series.ownerSet.concat(vm.series.participantSet),
                    isReadOnly: false,
                    addAllPeople: assignParticipants('assign'),
                    addPerson: assignParticipants('assign'),
                    removePerson: assignParticipants('unassign'),
                    removePeople: assignParticipants('unassign-all'),
                });
            }
            else {
                //read only
                AccessModal.open({
                    accessGroups: {
                        owners: [],
                        participants: [],
                        assignees: participantIds,
                    },
                    title: 'Participants',
                    primaryPersonLabel: 'Participants',
                    isKpiView: true,
                    peopleIds: peopleIds,
                });
            }
        }
        /**
         * @method promptComplete
         * Open a modal for the user to confirm if topics are recurring.
         */
        function promptComplete() {
            // Note: creating an instance causes a route change, as does complete()
            CompleteMeetingModal.open({
                topics: _.filter(vm.topics, { state: 0 }),
            })
                .then(save)
                .then(complete, angular.noop);
        }
        /**
         * @method save
         * @param [property] {string} - name of the property to save
         * @returns {object} - promise
         * Creates a new Meeting Instance or updates an existing one.
         * If two creates happen in parallel, subsequent creates wait and turn into updates.
         */
        function save(property) {
            var data = _.cloneDeep(vm.instance), promise;
            // @ts-ignore ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
            if (vm.instance.id && property) {
                promise = saveAsync(data, property);
            }
            else if (vm.instance.id && !property) {
                // There is nothing to save
                promise = MeetingInstancesService.resolve();
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'records' implicitly has an 'any' type.
            }
            else if (save.promise) {
                // @ts-ignore
                promise = save.promise.then(function () {
                    return save(property);
                });
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'x' implicitly has an 'any' type.
            }
            else {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'x' implicitly has an 'any' type.
                promise = save.promise = saveAsync(data, property).finally(function () {
                    // @ts-ignore
                    delete save.promise;
                });
            }
            return promise;
        }
        /**
         * @function saveAsync
         * @param data {object} - CLONE of instance at the point of saving
         * @param [property] {string}
         * @returns {object} - Promise, object
         * @private
         * NOTE: Do NOT call this except via save()
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'date' implicitly has an 'any' type.
         * This function is to solve the problem of creating multiple new records in parallel.
         */
        function saveAsync(data, property) {
            if (!data.id && vm.instance.id) {
                data.id = vm.instance.id;
            }
            return MeetingInstancesService.save(targetPersonId, data, property && [property]).then(function (response) {
                if (!vm.instance.id) {
                    vm.instance.id = response.data.id;
                    // router set seriesId
                    goToTargetPersonRoute('meeting-instance', {
                        seriesId: vm.instance.seriesId,
                        instanceId: vm.instance.id,
                    });
                }
            }, function (response) {
                console.error('SAVE MEETING SERIES ERROR', response);
                return MeetingInstancesService.reject(response);
            });
        }
        /**
         * @function saveParticipants
         * @returns {object} - promise
         * @private
         * Participants info is not accepted by the API when creating an Instance.
         * If the Instance doesn't exist, create it first, then do another update for participants.
         */
        function saveParticipants() {
            // @ts-ignore
            return save().then(function () {
                return save('participantSet');
            });
        }
        /**
         * @function setCustomSort
         * @param event
         */
        function setCustomSort(event) {
            var index = event.dest.index, currentTopic = vm.topics[index], sortId = 0;
            if (vm.topics.length > index + 1) {
                sortId = vm.topics[index + 1].id;
            }
            currentTopic.sortId = sortId;
            // @ts-ignore
            save().then(function () {
                TopicsService.save(vm.instance.id, currentTopic, ['sortId']);
            });
        }
        /**
         * @method toggleTopics
         * Collapses all topics to make it easier for drag-and-drop.
         */
        function toggleTopics() {
            vm.isCollapsed = !vm.isCollapsed;
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'assignments' implicitly has an 'any' ty... Remove this comment to see the full error message

(function () {
    angular.module('App.Meetings').component('meetingInstanceList', {
        bindings: {
            canUncompleteLastCompleted: '<',
            instances: '<',
            onChangePage: '&?',
            paginationInfo: '<?',
            personId: '<',
            series: '<',
        },
        controller: ['$filter', 'MeetingInstancesService', 'TrayRouter', MeetingInstanceListComponentController],
        controllerAs: 'listVm',
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return TEMPLATE_PATH + '/meetings/meeting-instance-list/meeting-instance-list.html';
            },
        ],
    });
    // @ts-ignore ts-migrate(7006) FIXME:
    function MeetingInstanceListComponentController($filter, MeetingInstancesService, TrayRouter) {
        /**
         * @property router
         * @type {object}
         */
        var router = TrayRouter('meetings');
        // @ts-ignore ts-migrate(7006) FIXME:
        var vm = this;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TrayRouter' implicitly has an 'any' typ... Remove this comment to see the full error message
        /**
         * @listener $onInit
         */
        vm.$onInit = init;
        vm.fn = {
            countAttendees: countAttendees,
            go: go,
            advance: advance,
            localDate: localDate,
            saveState: saveState,
            uncompleteMeeting: uncompleteMeeting,
        };
        /**
// @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
         * @property initialRecordLimit
         * @type {number}
         * Original requirement is to show a maximum of 5 results at first, then show pages of 25 after.
         * Since the API doesn't allow mixing of page sizes, the UI fetches 25, shows 5, then 20 more.
         */
        vm.initialRecordLimit = undefined;
        /**
         * @method advance
         * Tells the parent to get a different page of results.
         * The parent needs to handle the results so it can calculate the "suggested" instance.
         */
        function advance() {
            if (vm.initialRecordLimit) {
                // showing first 5, show the rest of the page; 20 more
                vm.initialRecordLimit = undefined;
            }
            else {
                vm.onChangePage();
            }
        }
        /**
         * @method countAttendees
         * @param participants {Array}
         * @returns {number}
         * Counts how many participants attended a Meeting Instance.
         * Should only be used on completed instances.
         */
        // @ts-ignore ts-migrate(7006) FIXME:
        function countAttendees(participants) {
            return _.filter(participants, { isAttendee: true }).length;
        }
        /**
         * @method go
         * @param instance {object}
         * Redirect to the instance detail screen.
         * Add the state so tray-tab-meetings knows if a non-completed instance is the current screen in the drawer.
         */
        // @ts-ignore ts-migrate(7006) FIXME:
        function go(instance) {
            var params = { seriesId: vm.series.id, state: instance.state };
            if (instance.id) {
                // @ts-ignore ts-migrate(7006) FIXME:
                params.instanceId = instance.id;
            }
            if (vm.personId) {
                // @ts-ignore
                params.personId = vm.personId;
            }
            router.go('meeting-instance', params);
        }
        // @ts-ignore ts-migrate(7006)
        function localDate(instance) {
            var existingDate = new Date(instance.date);
            var d = new Date(instance.date);
            d.setDate(existingDate.getUTCDate());
            d.setMonth(existingDate.getUTCMonth());
            d.setFullYear(existingDate.getUTCFullYear());
            return $filter('date')(d, ['MM/dd/yyyy']);
        }
        /**
         * @function goToTargetPersonRoute
         * @param component {string}
         * @param params {object}
         * @private
         * For specific routes that need to pass a person ID when the current user is viewing meetings of a subordinate.
         * Do not pass the person ID when it is the current user.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
        function goToTargetPersonRoute(component, params) {
            router.go(component, params);
        }
        /**
         * @function init
         * @private
         */
        function init() {
            if (vm.paginationInfo && vm.paginationInfo.total > 5) {
                // List is paginated and there are more than 5 records, so just show the first 5.
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'instance' implicitly has an 'any' type.
                vm.initialRecordLimit = 5;
            }
        }
        /**
         * @method saveState
         * @param id
         * @param seriesId
         * @returns {object} - promise
         * Creates a new Meeting Instance or updates an existing one.
         * If two creates happen in parallel, subsequent creates wait and turn into updates.
         */
        // @ts-ignore ts-migrate(7006)
        function saveState(id, seriesId) {
            var data = {
                id: id,
                seriesId: seriesId,
                state: 0
            }, promise;
            // @ts-ignore ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
            if (id && 'state') {
                promise = saveAsync(data, 'state');
                // @ts-ignore
            }
            else if (save.promise) {
                // @ts-ignore
                promise = save.promise.then(function () {
                    return saveState(id, seriesId);
                });
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'x' implicitly has an 'any' type.
            }
            else {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'x' implicitly has an 'any' type.
                promise = save.promise = saveAsync(data, property).finally(function () {
                    // @ts-ignore
                    delete save.promise;
                });
            }
            return promise;
        }
        /**
         * @function saveAsync
         * @param data {object} - CLONE of instance at the point of saving
         * @param [property] {string}
         * @returns {object} - Promise, object
         * @private
         * NOTE: Do NOT call this except via save()
         // @ts-ignore ts-migrate(7006) FIXME: Parameter 'date' implicitly has an 'any' type.
         * This function is to solve the problem of creating multiple new records in parallel.
         */
        // @ts-ignore ts-migrate(7006)
        function saveAsync(data, property) {
            if (!data.id && vm.instance.id) {
                data.id = vm.instance.id;
            }
            return MeetingInstancesService.save(data.id, data, property && [property]).then(
            // @ts-ignore ts-migrate(7006)
            function (response) {
                console.log(response);
                goToTargetPersonRoute('meeting-series', {
                    seriesId: data.seriesId,
                });
            }, 
            // @ts-ignore ts-migrate(7006)
            function (response) {
                console.error('SAVE MEETING SERIES ERROR', response);
                return MeetingInstancesService.reject(response);
            });
        }
        function uncompleteMeeting(id, seriesId) {
            return saveState(id, seriesId);
        }
    }
})();

(function () {
    angular.module('App.Meetings').component('meetingSeries', {
        controller: [
            '$location',
            'AuthenticationService',
            'ETWServicesUtils',
            'MeetingInstancesService',
            'MeetingSeriesService',
            'PeopleService',
            'ShareMeetingModal',
            'TrayRouter',
            MeetingSeriesComponentController,
        ],
        controllerAs: 'seriesVm',
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return TEMPLATE_PATH + '/meetings/meeting-series/meeting-series.html';
            },
        ],
    });
    function MeetingSeriesComponentController(
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$location' implicitly has an 'any' type... Remove this comment to see the full error message
    $location, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AuthenticationService' implicitly has a... Remove this comment to see the full error message
    AuthenticationService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ETWServicesUtils' implicitly has an 'an... Remove this comment to see the full error message
    ETWServicesUtils, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'MeetingInstancesService' implicitly has... Remove this comment to see the full error message
    MeetingInstancesService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'MeetingSeriesService' implicitly has an... Remove this comment to see the full error message
    MeetingSeriesService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'PeopleService' implicitly has an 'any' ... Remove this comment to see the full error message
    PeopleService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ShareMeetingModal' implicitly has an 'a... Remove this comment to see the full error message
    ShareMeetingModal, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TrayRouter' implicitly has an 'any' typ... Remove this comment to see the full error message
    TrayRouter) {
        /**
         * @property currentUserId
         * @type {number}
         */
        var currentUserId = AuthenticationService.getAccount().userId;
        /**
         * @property isCurrentUserAnOwner
         * @type {boolean}
         */
        // @ts-ignore ts-migrate(7034) FIXME: Variable 'isCurrentUserAnOwner' implicitly has typ... Remove this comment to see the full error message
        var isCurrentUserAnOwner;
        /**
         * @property isCurrentUserAParticipant
         * @type {boolean}
         */
        // @ts-ignore ts-migrate(7034) FIXME: Variable 'isCurrentUserAParticipant' implicitly ha... Remove this comment to see the full error message
        var isCurrentUserAParticipant;
        /**
         * @property isCurrentUserInBossChain
         * @type {boolean}
         */
        var isCurrentUserInBossChain;
        /**
         * @property isPlanAdmin
         * @type {boolean}
         */
        var isPlanAdmin = AuthenticationService.hasPermission('ADMIN_PLANS');
        /**
         * @property lastCompletedInstance
         * @type {object}
         * This instance is used to suggest the date of of the next instance.
         */
        // @ts-ignore ts-migrate(7034) FIXME: Variable 'lastCompletedInstance' implicitly has ty... Remove this comment to see the full error message
        var lastCompletedInstance;
        /**
         * @property pageIndex
         * @type {number}
         * Keeps track of what page of results was last fetched.
         */
        var pageIndex = 0;
        /**
         * @property router
         * @type {object}
         * Get the router instance for the meetings drawer.
         */
        var router = TrayRouter('meetings');
        /**
         * @property routerSubscribeIndex
         * @type {number}
         * Unique ID used to unsubscribe from the router.
         */
        // @ts-ignore ts-migrate(7034) FIXME: Variable 'routerSubscribeIndex' implicitly has typ... Remove this comment to see the full error message
        var routerSubscribeIndex;
        /**
         * @property trayOpenSubscriptionIndex
         * @type {number}
         * ID used to unsubscribe the tray opening.
         */
        // @ts-ignore ts-migrate(7034) FIXME: Variable 'trayOpenSubscriptionIndex' implicitly ha... Remove this comment to see the full error message
        var trayOpenSubscriptionIndex;
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        /**
         * @listener $onDestroy
         */
        vm.$onDestroy = destroyComponent;
        /**
         * @listener $onInit
         */
        vm.$onInit = init;
        /**
         *
         */
        vm.canUncompleteLastCompleted = false;
        /**
         * @property completedInstances
         * @type {Array}
         */
        vm.completedInstances = [];
        /**
         * @property completedInstancesInfo
         * @type {object}
         * Pagination information for completed Meeting Instances.
         */
        vm.completedInstancesInfo = {};
        vm.fn = {
            advance: advance,
            close: router.close,
            go: router.go,
            onChangeTab: onChangeTab,
            onShare: onShare,
        };
        /**
         * @property isEditable
         * @type {boolean}
         */
        vm.isEditable = false;
        /**
         * @property isLoaded
         * @type {boolean}
         */
        vm.isLoaded = false;
        /**
         * @property isShowInstances
         * @type {boolean}
         * If the series is missing some information, do not allow the user to create an instance.
         * (Originally for missing type or frequency.)
         */
        vm.isShowInstances = false;
        /**
         * @property pendingInstances
         * @type {Array}
         */
        vm.pendingInstances = [];
        /**
         * @property subnav
         * @type {object}
         * Configuration for the tabbed navigation directive.
         */
        vm.subnav = {
            instances: {
                title: 'Instances',
            },
            purpose: {
                title: 'Purpose & Rules of Engagement',
            },
        };
        /**
         * @property tab
         * @type {string}
         */
        vm.tab = 'instances';
        /**
         * @property targetPersonId
         * @type {number}
         * The owner/participant that the instances are being fetched for.
         * By default this is the current user ID.
         * When the current user is viewing meetings for a subordinate, the API needs to know the subordinate ID.
         */
        vm.targetPersonId = -1;
        /**
         * @method advance
         * Ask parent to fetch the next page of results.
         */
        function advance() {
            pageIndex += 1;
            getCompletedInstances(pageIndex);
        }
        /**
         * @function checkIfReadyForInstances
         * @param series {object}
         * @returns {boolean}
         * @private
         * Instances cannot be created for series that lack required information.
         * Step through the prerequisites and return if the series is allowed to have suggested or pending instances.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'series' implicitly has an 'any' type.
        function checkIfReadyForInstances(series) {
            var isPass = true;
            if (!series.type || !series.frequency) {
                isPass = false;
            }
            else if (series.type == 'ONE_TO_ONE' && series.participantSet.length === 0) {
                isPass = false;
            }
            else if (series.type == 'PLAN' && !series.planId) {
                isPass = false;
            }
            return isPass;
        }
        /**
         * @function destroyComponent
         * @private
         */
        function destroyComponent() {
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'routerSubscribeIndex' implicitly has an ... Remove this comment to see the full error message
            router.unsubscribe(routerSubscribeIndex);
            // TODO: Migrate this event to the TrayRouter. (ETWServicesUtils should only be used in the ETWServices module.)
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'trayOpenSubscriptionIndex' implicitly ha... Remove this comment to see the full error message
            ETWServicesUtils.unsubscribe('TrayOpen')(trayOpenSubscriptionIndex);
        }
        /**
         * @function checkIfInBossChain
         * @param series {object}
         * @returns {object} promise
         * @private
         * Sets isEditable if current user is in the boss chain of the (first) owner or (first) participant.
         * Note: Used for 1:1 which only have one owner and one participant.
         * TODO: This might be unnecessary now that we track vm.targetPersonId.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'series' implicitly has an 'any' type.
        function checkIfInBossChain(series) {
            var promises = {
                ofOwner: series.ownerSet.length !== 0 && getViewPermissionForPerson(series.ownerSet[0]),
                ofParticipant: series.participantSet.length !== 0 &&
                    getViewPermissionForPerson(series.participantSet[0]),
            };
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'responses' implicitly has an 'any' type... Remove this comment to see the full error message
            return MeetingSeriesService.all(promises).then(function getBossChainsSuccess(responses) {
                vm.isEditable = responses.ofOwner || responses.ofParticipant;
            });
        }
        /**
         * @function getCompletedInstances
         * @param page {number} - 0-index
         * @returns {object} - promise, Array
         * @private
         * Get a paginated list of completed instances.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'page' implicitly has an 'any' type.
        function getCompletedInstances(page) {
            return MeetingInstancesService.getCompletedForSeries(vm.targetPersonId, router.params.seriesId, page).then(
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            function getCompletedInstancesSuccess(response) {
                if (page == 0) {
                    // If this is the first page, clear the existing instances.
                    // This is in case the user clicks on a given series to open the drawer, closes the drawer, and clicks the same series again.
                    vm.completedInstances.length = 0;
                }
                Array.prototype.push.apply(vm.completedInstances, response.data.records);
                vm.completedInstancesInfo = _.assign({}, response.data.paginationDTO, {
                    index: response.data.paginationDTO.pageNumber + 1,
                    total: response.data.totalRecords,
                });
            }, 
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            function getCompletedInstancesError(response) {
                console.error('GET COMPLETED INSTANCES ERROR', response);
            });
        }
        /**
         * @function getLastCompletedInstance
         * @returns {object} - promise
         * @private
         * Fetch the last completed instance.
         * Originally added since the 'last' instance might have an earlier date than the 'latest'.
         */
        function getLastCompletedInstance() {
            return MeetingInstancesService.getLastCompletedForSeries(vm.targetPersonId, router.params.seriesId).then(
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            function getLastCompletedInstanceSuccess(response) {
                lastCompletedInstance = response.data;
            }, 
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            function getLastCompletedInstanceError(response) {
                if (response.status == 403 || response.status === 404) {
                    // targetPerson cannot see the suggested Instance or there are no completed instances
                    lastCompletedInstance = undefined;
                }
                else {
                    // Otherwise, this must be an error.
                    console.error('GET LAST INSTANCE FOR THIS SERIES ERROR', response);
                }
            });
        }
        /**
         * @function getPendingInstances
         * @returns {object} - promise, Array
         * @orivate
         * Expected to return 0 or 1 pending instances, but still as a paginated array.
         */
        function getPendingInstances() {
            return MeetingInstancesService.getPendingForSeries(vm.targetPersonId, router.params.seriesId, 0).then(
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            function getPendingInstancesSuccess(response) {
                vm.pendingInstances = response.data.records;
            }, 
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            function getPendingInstancesError(response) {
                console.error('GET PENDING INSTANCES ERROR', response);
                vm.hasAccess = false;
                vm.isLoaded = true;
            });
        }
        /**
         * @function getSeries
         * @private
         * Note: When called from router (via subscribe), two arguments are passed, name and params.
         */
        function getSeries() {
            return MeetingSeriesService.getById(router.params.seriesId).then(
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            function getSeriesSuccess(response) {
                var promise;
                vm.series = response.data;
                isCurrentUserAnOwner = _.includes(vm.series.ownerSet, currentUserId);
                isCurrentUserAParticipant =
                    isCurrentUserAnOwner || _.includes(vm.series.participantSet, currentUserId);
                vm.isEditable =
                    vm.series.type === 'PLAN' ? isPlanAdmin || isCurrentUserAnOwner : isCurrentUserAnOwner;
                // Only plan admins, owners, participants can click on the plan link; not boss chain.
                vm.isPlanClickable = isPlanAdmin || isCurrentUserAnOwner || isCurrentUserAParticipant;
                vm.isShowInstances = checkIfReadyForInstances(vm.series);
                if (vm.series.type === 'ONE_TO_ONE' && !vm.isEditable && !isCurrentUserAParticipant) {
                    // Boss chain is allowed to edit 1:1 Meeting Series
                    promise = checkIfInBossChain(vm.series);
                }
                $location.search('tray-component', 'meeting-series');
                $location.search('tray-component-id', vm.series.id);
                return promise;
            }, 
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            function getSeriesError(response) {
                console.error('GET SERIES BY ID ERROR', response);
                vm.hasAccess = false;
                vm.isLoaded = true;
            });
        }
        /**
         * @function getSuggestedInstance
         * @private
         * If there are no pending instances, suggest a new one.
         * If there are completed instances but the 'last' completed instance is undefined, user isn't allowed to see a suggested instance.
         * The suggested instance should determine what the next date should be based on the series frequency.
         * If the next date is in the past, default to today.
         */
        function getSuggestedInstance() {
            var showSuggested, previousInstanceTimestamp;
            if (vm.series.type === 'PLAN') {
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'isCurrentUserAnOwner' implicitly has an ... Remove this comment to see the full error message
                showSuggested = isPlanAdmin || isCurrentUserAnOwner || isCurrentUserAParticipant;
            }
            else {
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'lastCompletedInstance' implicitly has an... Remove this comment to see the full error message
                showSuggested = lastCompletedInstance || vm.completedInstances.length === 0;
            }
            if (vm.pendingInstances.length === 0 && showSuggested) {
                var options = {
                    participantSet: [],
                    seriesId: vm.series.id,
                    state: 2,
                };
                // If there are completed instances, grab the date from the last one
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'lastCompletedInstance' implicitly has an... Remove this comment to see the full error message
                if (lastCompletedInstance) {
                    // @ts-ignore ts-migrate(7005) FIXME: Variable 'lastCompletedInstance' implicitly has an... Remove this comment to see the full error message
                    previousInstanceTimestamp = lastCompletedInstance.date;
                }
                MeetingInstancesService.getNew(options, vm.series, previousInstanceTimestamp).then(
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                function getNewInstanceSuccess(response) {
                    vm.suggestedInstances = [response.data];
                });
                vm.canUncompleteLastCompleted = true;
            }
            else {
                vm.suggestedInstances = [];
                // @ts-ignore ts-migrate(7005)
                if ((isPlanAdmin || isCurrentUserAnOwner) && vm.pendingInstances.length > 0) {
                    vm.canUncompleteLastCompleted = vm.pendingInstances[0].canDelete;
                }
            }
        }
        /**
         * @function getViewPermissionForPerson
         * @param ownerOrParticipantId {number}
         * @returns {object} - promise, boolean
         * Checks to see if the currentUserId is in the boss chain of ownerOrParticipantId.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ownerOrParticipantId' implicitly has an... Remove this comment to see the full error message
        function getViewPermissionForPerson(ownerOrParticipantId) {
            return PeopleService.canViewUser(currentUserId, ownerOrParticipantId);
        }
        /**
         * @function init
         * @private
         */
        function init() {
            load();
            routerSubscribeIndex = router.subscribe(load);
            // TODO: Migrate this event to the TrayRouter. (ETWServicesUtils should only be used in the ETWServices module.)
            trayOpenSubscriptionIndex = ETWServicesUtils.subscribe('TrayOpen')(load);
        }
        /**
         * @function load
         * @private
         * When the route changes, check route to see if this component matches.
         */
        function load() {
            var promises;
            if (router.component === 'meeting-series' && router.params.seriesId) {
                vm.targetPersonId = router.params.personId || currentUserId;
                promises = {
                    series: getSeries(),
                    completed: getCompletedInstances(0),
                    lastCompleted: getLastCompletedInstance(),
                    pending: getPendingInstances(),
                };
                // After the series and the pending instances are fetched,
                // create a suggested instance if no pending instances exist
                MeetingSeriesService.all(promises)
                    .then(getSuggestedInstance)
                    .finally(function () {
                    MeetingSeriesService.canView(vm.series.id).then(
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                    function (response) {
                        vm.hasAccess = response.data;
                        vm.isLoaded = true;
                    });
                });
            }
        }
        /**
         * @method onChangeTab
         * @param tab {string}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'tab' implicitly has an 'any' type.
        function onChangeTab(tab) {
            vm.tab = tab;
        }
        /**
         * @method onShare
         */
        function onShare() {
            ShareMeetingModal.open({ meetingSeriesId: vm.series.id });
        }
    }
})();

(function () {
    angular.module('App.Meetings').component('meetingSeriesList', {
        bindings: {
            plan: '<',
            personId: '<?',
            target: '@?',
        },
        controller: [
            '$location',
            'AuthenticationService',
            'ETWServicesUtils',
            'MeetingSeriesService',
            'TrayRouter',
            MeetingSeriesListComponentController,
        ],
        controllerAs: 'listVm',
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return TEMPLATE_PATH + '/meetings/meeting-series-list/meeting-series-list.html';
            },
        ],
    });
    function MeetingSeriesListComponentController(
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$location' implicitly has an 'any' type... Remove this comment to see the full error message
    $location, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ETWServicesUtils' implicitly has an 'an... Remove this comment to see the full error message
    AuthenticationService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ETWServicesUtils' implicitly has an 'an... Remove this comment to see the full error message
    ETWServicesUtils, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'MeetingSeriesService' implicitly has an... Remove this comment to see the full error message
    MeetingSeriesService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TrayRouter' implicitly has an 'any' typ... Remove this comment to see the full error message
    TrayRouter) {
        /**
         * @property meetingSeriesSubscriptionIndex
         * @type {number}
         * ID used to unsubscribe from the MeetingSeriesService.
         */
        // @ts-ignore ts-migrate(7034) FIXME: Variable 'meetingSeriesSubscriptionIndex' implicit... Remove this comment to see the full error message
        var meetingSeriesSubscriptionIndex;
        /**
         * @property router
         * @type {object}
         * Get the router instance for the meetings drawer.
         */
        var router = TrayRouter('meetings');
        /**
         * @property trayOpenSubscriptionIndex
         * @type {number}
         * ID used to unsubscribe the tray opening.
         */
        // @ts-ignore ts-migrate(7034) FIXME: Variable 'trayOpenSubscriptionIndex' implicitly ha... Remove this comment to see the full error message
        var trayOpenSubscriptionIndex;
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        /**
         * @listener $onDestroy
         */
        vm.$onDestroy = destroyComponent;
        /**
         * @listener $onInit
         */
        vm.$onInit = init;
        vm.fn = {
            go: go,
            onChangeIsHidden: onChangeIsHidden,
            onChangeIsHiddenAll: onChangeIsHiddenAll,
            onFilterControlsLoaded: onFilterControlsLoaded,
        };
        /**
         * @property filteredList
         * @type {object}
         * Configuration object passed to the filtered-list directive archipelago.
         * getSeriesList() passes in items, directive populates filteredItems, ng-repeat in template renders items.
         */
        vm.filteredList = {
            columns: ['title'],
            filteredItems: [],
        };
        /**
         * @property filterMenuOptions
         * @type {Array}
         * Array of different filters to filter the list.
         * Passed to <filtered-list-menu>
         */
        vm.filterMenuOptions = [
            {
                group: 'Visibility',
                title: 'Hidden',
                property: 'hidden',
                value: 1,
            },
            {
                group: 'Visibility',
                title: 'Visible',
                property: 'hidden',
                value: 0,
                preselected: true,
            },
        ];
        /**
         * @property isLoaded
         * @type {boolean}
         * Tell the template the series, etc have been loaded.
         */
        vm.isLoaded = false;
        /**
         * Is user the designated client admin
         */
        vm.isClientAdmin = false;
        /**
         * @property seriesTypes
         * @type {object}
         */
        vm.seriesTypes = MeetingSeriesService.TYPES;
        /**
         * @property query
         * @type {object}
         */
        vm.query = {
            text: '',
        };
        /**
         * @property sortMenuOptions
         * @type {object}
         * Configuration for the sort directive.
         */
        vm.sortMenuOptions = {
            options: [
                {
                    column: 'title',
                    label: 'Title',
                },
                {
                    column: 'type',
                    label: 'Type',
                },
                {
                    column: '_frequencyValue',
                    label: 'Cadence',
                },
            ],
        };
        /**
         * @function destroyComponent
         * @private
         */
        function destroyComponent() {
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'meetingSeriesSubscriptionIndex' implicit... Remove this comment to see the full error message
            MeetingSeriesService.unsubscribe(meetingSeriesSubscriptionIndex);
            // TODO: Migrate this event to the TrayRouter. (ETWServicesUtils should only be used in the ETWServices module.)
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'trayOpenSubscriptionIndex' implicitly ha... Remove this comment to see the full error message
            ETWServicesUtils.unsubscribe('TrayOpen')(trayOpenSubscriptionIndex);
        }
        /**
         * @function getSeriesList
         * @private
         */
        function getSeriesList() {
            var promise;
            if (vm.plan && vm.plan.id) {
                // Plan
                promise = MeetingSeriesService.getAllForPlan(vm.plan.id);
            }
            else if (vm.personId) {
                // Direct Report
                promise = MeetingSeriesService.getAllForPerson(vm.personId);
            }
            else {
                // Current user
                promise = MeetingSeriesService.getAll();
            }
            promise
                .then(
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            function getAllSuccess(response) {
                vm.filteredList.items = response.data;
                _.forEach(vm.filteredList.items, function (item) {
                    var freq = MeetingSeriesService.FREQUENCIES[item.frequency];
                    if (!item.title) {
                        // Sort takes `null` literally
                        item.title = '';
                    }
                    item._frequencyTitle = (freq && freq.title) || '-';
                    item._frequencyValue = freq ? freq.sortValue : -1;
                });
            }, 
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            function getAllError(response) {
                console.error('GET ALL MEETING SERIES ERROR', response);
            })
                .finally(function getAllFinal() {
                vm.isLoaded = true;
            });
        }
        /**
         * @method go
         * @param component {string}
         * @param params {object}
         * If target is 'self', then use router.go
         * router.open first opens the drawer, then navigates to the appropriate meetings screen.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'component' implicitly has an 'any' type... Remove this comment to see the full error message
        function go(component, params) {
            if (vm.target == 'self') {
                router.go(component, params);
            }
            else {
                router.open(component, params);
            }
        }
        /**
         * @function init
         * @private
         */
        function init() {
            // Tell filtered-list which controls to wait for.
            // The menu filter is currently only used for the current user's list.
            vm.filteredListControls = vm.plan || vm.personId ? 'query' : 'query,menu';
            getSeriesList();
            var currentUser = AuthenticationService.getAccount();
            vm.isClientAdmin = currentUser.adminUser === "1";
            $location.search('tray-component-id', null);
            // Listen for any changes to any series
            // meetingSeriesSubscriptionIndex = MeetingSeriesService.subscribe(getSeriesList);
            // // TODO: Migrate this event to the TrayRouter. (ETWServicesUtils should only be used in the ETWServices module.)
            // trayOpenSubscriptionIndex = ETWServicesUtils.subscribe('TrayOpen')(getSeriesList);
        }
        /**
         * @method onChangeIsHidden
         * @param series {object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'series' implicitly has an 'any' type.
        function onChangeIsHidden(series) {
            series.hidden = !series.hidden;
            MeetingSeriesService.hideUsersSeries(series);
        }
        /**
         * @method onChangeIsHiddenAll
         * @param series {object}
         * @param hidden - boolean
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'series' implicitly has an 'any' type.
        function onChangeIsHiddenAll(series, hidden) {
            series.hidden = hidden;
            MeetingSeriesService.hideUsersSeriesAll(series);
        }
        /**
         * @method onFilterControlsLoaded
         * Callback passed to filtered-list for when all the filter controls are initialized.
         */
        function onFilterControlsLoaded() {
            vm.isFilterControlsLoaded = true;
        }
    }
})();

var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
(function () {
    angular.module('App.Meetings').component('meetingSeriesSettings', {
        controller: [
            'AccessModal',
            'AuthenticationService',
            'CLIENT_SETTINGS',
            'DeleteWithChallengeModal',
            'MeetingSeriesService',
            'PeopleService',
            'PlansService',
            'TrayRouter',
            MeetingSeriesSettingsComponentController,
        ],
        controllerAs: 'settingsVm',
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return TEMPLATE_PATH + '/meetings/meeting-series-settings/meeting-series-settings.html';
            },
        ],
    });
    function MeetingSeriesSettingsComponentController(AccessModal, AuthenticationService, CLIENT_SETTINGS, DeleteWithChallengeModal, MeetingSeriesService, PeopleService, PlansService, TrayRouter
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AccessModal' implicitly has an 'any' ty... Remove this comment to see the full error message
    ) {
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'AuthenticationService' implicitly has a... Remove this comment to see the full error message
         * @property currentUserId
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'DeleteWithChallengeModal' implicitly ha... Remove this comment to see the full error message
         * @type {number}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'MeetingSeriesService' implicitly has an... Remove this comment to see the full error message
        var currentUserId = AuthenticationService.getAccount().userId;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TrayRouter' implicitly has an 'any' typ... Remove this comment to see the full error message
        /**
         * @property isDestroyed
         * @type {boolean}
         * Used to prevent the component from navigating the tray when the component has been destroyed.
         * E.g. when the user creates a new series, but navigates the drawer somewhere else before the POST completes, this component will navigate to the new series.
         */
        var isDestroyed = false;
        /**
         * @property router
         * @type {object}
         */
        var router = TrayRouter('meetings');
        /**
         * @property routerSubscriptionIndex
         * @type {number}
         */
        var routerSubscriptionIndex;
        /**
         * @property directReports
         * @type {Array}
         * Holds list of direct reports that are fetched when assigning a participant.
         */
        var directReports;
        var vm = this;
        /**
         * @listener $onDestroy
         */
        // @ts-ignore ts-migrate(7034) FIXME: Variable 'routerSubscriptionIndex' implicitly has ... Remove this comment to see the full error message
        vm.$onDestroy = destroyComponent;
        /**
         * @listener $onInit
         */
        vm.$onInit = init;
        /**
         * @property recognizedTemplates
         * @type {Array}
         */
        vm.recognizedTemplates = [];
        vm.fn = {
            addTemplate: addTemplate,
            // @ts-ignore ts-migrate(7034) FIXME: Variable 'directReports' implicitly has type 'any'... Remove this comment to see the full error message
            updateTemplateName: updateTemplateName,
            go: router.go,
            // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
            onChangeFrequency: onChangeFrequency,
            onChangeTemplate: onChangeTemplate,
            onChangePlan: onChangePlan,
            onChangePurpose: onChangePurpose,
            onChangeType: onChangeType,
            onPromptDestroy: onPromptDestroy,
            openMeetingOwnerAccess: openMeetingOwnerAccess,
            openParticipantAccess: openParticipantAccess,
            save: save,
        };
        /**
         * @property frequencies
         * @type {Array}
         */
        vm.frequencies = MeetingSeriesService.getFrequencies();
        /**
         * @property hideAccessAdd
         * @type {boolean}
         */
        vm.hideAccessAdd = false;
        /**
         * @property isLoaded
         * @type {boolean}
         * Tell the template the series, etc have been loaded.
         */
        vm.isLoaded = false;
        /**
         * @property isMeetingTemplateLoaded
         * @type {boolean}
         */
        vm.isMeetingTemplateLoaded = false;
        /**
         * @property isPlansLoaded
         * @type {boolean}
         */
        vm.isPlansLoaded = false;
        /**
         * @property meetingType
         * @type {Array}
         */
        vm.meetingTypes = MeetingSeriesService.TYPES;
        /**
         * @property plans
         * @type {Array}
         */
        vm.plans = [];
        /**
         * @property meetingTemplates
         * @type {Array}
         */
        vm.meetingTemplates = [];
        /**
         * @property selections
         * @type {object}
         * @key frequency {object} - selected cadence
         * Holds selected values from drop down menus.
         */
        vm.selections = {
            frequency: undefined,
        };
        /**
         * @function addTemplate
         */
        function addTemplate() {
            var template = "\n<p>:TEMPLATE:</p>\n<p>:NAME: Template Name :END_NAME:</p>\n<p>Template Content</p>\n<p>:END_TEMPLATE:</p>\n";
            var orig = vm.series.rulesOfEngagement || '';
            vm.series.rulesOfEngagement = orig + template;
        }
        /**
         * @function updateTemplateName
         * @param {Template} template
         */
        function updateTemplateName(template) {
            vm.series.rulesOfEngagement = MeetingSeriesService.replaceName(vm.series.rulesOfEngagement, template, template.name);
            vm.recognizedTemplates = MeetingSeriesService.findTemplates(vm.series.rulesOfEngagement);
            onChangePurpose();
        }
        /**
         * @function assignOwners
         * @param action {string}
         * @returns {Function}
         * @private
         * Function that returns a callback for assigning/unassigning an owner or owners.
         */
        function assignOwners(action) {
            return function (personOrPeople) {
                var peopleIds = personOrPeople;
                if (action !== 'unassign-all') {
                    // personOrPeople is either an object for one or an array for multiple
                    peopleIds = _(personOrPeople)
                        .castArray()
                        .map('id')
                        .value();
                }
                if (action == 'assign') {
                    vm.series.ownerSet = _.union(vm.series.ownerSet, peopleIds);
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'template' implicitly has an 'any' type.
                }
                else {
                    vm.series.ownerSet = _.difference(vm.series.ownerSet, peopleIds);
                }
                save('ownerSet');
            };
        }
        /**
         * @method assignParticipant
         * @param person {object}
         * Callback used by the AccessModal
         * Since there can only be 0 or 1 participants, assigning a participant replaces any existing ones.
         */
        function assignParticipant(person) {
            if (person.id) {
                vm.series.participantSet = [person.id];
                save('participantSet');
            }
        }
        /**
         * @function checkUserPermissions
         * @private
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'action' implicitly has an 'any' type.
         * Fetch the Person object for the current user to use for permissions.
         * Originally added to remove the 1:1 type from non-managers.
         */
        function checkUserPermissions() {
            if (!CLIENT_SETTINGS.PLANS && !vm.series.planId) {
                // Remove plan option if client has it off. Leave if plan series already exists.
                delete vm.meetingTypes.PLAN;
            }
            // remove 1-1 as option for new series
            if (!vm.series.id) {
                delete vm.meetingTypes.ONE_TO_ONE;
            }
        }
        /**
         * @function destroyComponent
         * @private
         */
        function destroyComponent() {
            isDestroyed = true;
            router.unsubscribe(routerSubscriptionIndex);
        }
        /**
         * @function destroySeries
         * @param seriesId {number}
         * @private
         */
        function destroySeries(seriesId) {
            MeetingSeriesService.destroy(seriesId).then(function deleteSeriesSuccess() {
                router.go('meeting-series-list', {});
            }, 
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'person' implicitly has an 'any' type.
            function deleteSeriesError(response) {
                console.error('DELETE SERIES ERROR', response);
            });
        }
        /**
         * @function getMeetingTemplates
         * @private
         */
        function getMeetingTemplates() {
            if (vm.meetingTemplates.length === 0) {
                //Add Default value 'No Meeting Template' to meeting templates drop-down list
                var noMeetingTemplate_1 = {
                    clientId: 0,
                    id: 0,
                    title: 'No Meeting Template',
                };
                MeetingSeriesService.getMeetingTemplates()
                    .then(function getMeetingTemplatesSuccess(response) {
                    vm.meetingTemplates = __spreadArray([noMeetingTemplate_1], response.data);
                }, function getMeetingTemplatesError(response) {
                    console.error('GET MEETING TEMPLATES ERROR', response);
                })
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'person' implicitly has an 'any' type.
                    .finally(function getMeetingTemplatesFinal() {
                    vm.isMeetingTemplateLoaded = true;
                });
            }
        }
        /**
         * @function getPlans
         * @private
         */
        function getPlans() {
            if (vm.plans.length === 0) {
                //Add Default value 'No Plan' to plans drop-down list
                var noMeetingPlan_1 = {
                    clientId: 0,
                    id: 0,
                    title: 'No Plan',
                };
                PlansService.getActiveForPerson(currentUserId)
                    .then(
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'routerSubscriptionIndex' implicitly has ... Remove this comment to see the full error message
                function getPlansSuccess(response) {
                    vm.plans = __spreadArray([noMeetingPlan_1], response.data);
                    if (vm.series.planId && angular.isUndefined(vm.series.id)) {
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'seriesId' implicitly has an 'any' type.
                        // If a plan is selected, pull the details from the list
                        var selectedPlan = _.find(vm.plans, { id: vm.series.planId });
                        // If this is a new Series, replace the owners with the Plan owners.
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                        vm.series.ownerSet = (selectedPlan && selectedPlan.ownerSet) || [];
                    }
                }, function getPlansError(response) {
                    console.error('GET PLANS ERROR', response);
                })
                    .finally(function getPlansFinal() {
                    vm.isPlansLoaded = true;
                });
            }
        }
        /**
         * @function getSeries
         * @private
         * This is called every time the router sends a notification while this component exists.
         * Check for a component/params match before continuing.
         */
        function getSeries() {
            var promise = MeetingSeriesService.resolve(), seriesId = router.params.seriesId, isSameComponent = router.component == 'meeting-series-settings', 
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            isSameId = angular.isDefined(seriesId) && vm.series && vm.series.id === seriesId, newSeriesDefaults = { type: 'GENERAL' };
            if (isSameComponent && !isSameId) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                // Only fetch a series if the router id is different than the current id
                vm.isLoaded = false;
                vm.isPlansLoaded = false;
                if (seriesId) {
                    // Fetch existing series
                    promise = MeetingSeriesService.getById(seriesId);
                }
                else {
                    // Create new series
                    if (router.params.planId) {
                        newSeriesDefaults.type = 'PLAN';
                        // @ts-ignore
                        newSeriesDefaults.planId = Number(router.params.planId);
                    }
                    else if (router.params.personId) {
                        newSeriesDefaults.type = 'ONE_TO_ONE';
                        // @ts-ignore
                        newSeriesDefaults.participantSet = [Number(router.params.personId)];
                    }
                    promise = MeetingSeriesService.getNew(newSeriesDefaults);
                }
                promise = promise
                    .then(function getMeetingSeriesSuccess(response) {
                    vm.series = response.data;
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                    vm.selections.frequency = _.find(vm.frequencies, {
                        id: vm.series.frequency,
                    });
                    vm.hasInstances = vm.series.instanceCount > 0;
                    getPlans();
                    // Fetch active meeting templates list
                    getMeetingTemplates();
                    checkUserPermissions();
                })
                    .finally(function getSeriesFinal() {
                    vm.hideAccessAdd = vm.series.type === 'PLAN';
                    vm.isLoaded = true;
                });
            }
            return promise;
        }
        /**
         * @function init
         * @private
         */
        function init() {
            getSeries().then(function () {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                vm.recognizedTemplates = MeetingSeriesService.findTemplates(vm.series.rulesOfEngagement);
            });
            // Fetch the meeting if route/params change
            routerSubscriptionIndex = router.subscribe(getSeries);
        }
        /**
         * @method onChangeFrequency
         * Update the series frequency (cadence).
         * Note: nya-select needs a selected frequency object to show a human readable title.
         */
        function onChangeFrequency() {
            vm.series.frequency = vm.selections.frequency.id;
            save('frequency');
        }
        /**
         * @method onChangeTemplate
         * Update the meeting template.
         * Note: nya-select needs a selected meeting template object to show the title of the selected template.
         */
        function onChangeTemplate(meetingTemplate) {
            vm.series.meetingTemplateId = meetingTemplate.id;
            save('meetingTemplateId');
        }
        /**
         * @method onChangePlan
         * Update the series plan.
         * Note: nya-select needs a selected plan object to show the title of the selected plan.
         */
        function onChangePlan(plan) {
            vm.series.planId = plan.id;
            save('planId');
        }
        /**
         * @method onChangePurpose
         * @returns {object} - promise, object
         */
        function onChangePurpose() {
            if (vm.series.id || _.trim(vm.series.rulesOfEngagement).length) {
                save('rulesOfEngagement');
                vm.recognizedTemplates = MeetingSeriesService.findTemplates(vm.series.rulesOfEngagement);
            }
        }
        /**
         * @method onChangeType
         * Checks if the type has been changed to PLAN
         *   If so, fetch and cache plans
         * Then save the type.
         */
        function onChangeType() {
            vm.hideAccessAdd = vm.series.type === 'PLAN';
            getPlans();
            save('type');
        }
        /**
         * @method onPromptDestroy
         * @returns {object} - promise
         * Displays delete with challenge modal.
         * Then destroys the goal.
         * Then redirects to the parent goal, plan or goals screen.
         */
        function onPromptDestroy() {
            // Open modal
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            return DeleteWithChallengeModal.open({
                instructions: 'Deleting the meeting series will remove all meetings and is a permanent action.',
                title: 'Delete Meeting Series',
                itemType: 'meeting-series',
                componentTitle: vm.series.title || 'Untitled',
            }).then(
            // confirm
            function () {
                destroySeries(vm.series.id);
            }, 
            // dismiss
            angular.noop);
        }
        /**
         * @method openMeetingOwnerAccess
         * Fetch people for owner ids before opening the modal.
         */
        function openMeetingOwnerAccess() {
            var options = {
                peopleIds: vm.series.ownerSet,
                title: 'Owners',
                isRequired: true,
                hasPrimaryPerson: false,
                immutablePeopleIds: [],
                isReadOnly: vm.hideAccessAdd,
                addAllPeople: assignOwners('assign'),
                addPerson: assignOwners('assign'),
                removePerson: assignOwners('unassign'),
                removePeople: assignOwners('unassign-all'),
            };
            return AccessModal.openEdit(options);
        }
        /**
         * @method openParticipantAccess
         */
        function openParticipantAccess() {
            if (!directReports) {
                PeopleService.getDirectReportsForId(currentUserId).then(function getDirectReportsSuccess(response) {
                    directReports = response.data;
                    openParticipantAccessModal();
                }, function getDirectReportsError(response) {
                    console.error('GET DIRECT REPORTS AS PARTICIPANTS ERROR', response);
                });
            }
            else {
                openParticipantAccessModal();
            }
        }
        /**
         * @method openParticipantAccessModal
         */
        function openParticipantAccessModal() {
            var options = {
                changePrimaryPersonId: function (i, p) {
                    assignParticipant(p);
                },
                addPerson: assignParticipant,
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'meetingTemplate' implicitly has an 'any... Remove this comment to see the full error message
                hasAddRemove: true,
                hasPrimaryPerson: false,
                isSubordinatesOnly: true,
                isReadOnly: vm.hasInstances,
                isRequired: true,
                maximumPeople: 1,
                peopleIds: vm.series.participantSet || [],
                suggestedPeople: vm.hasInstances ? [] : directReports,
                primaryPersonLabel: 'Assignee',
                title: 'Participants',
            };
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'plan' implicitly has an 'any' type.
            return AccessModal.openEdit(options);
        }
        /**
         * @method save
         * @param [property] {string} - name of the property to save
         * @returns void
         * Creates new Series.
         * Updates existing Series.
         * If two creates happen in parallel, subsequent creates wait and turn into updates.
         */
        function save(property) {
            var data = _.cloneDeep(vm.series);
            if (vm.series.id) {
                saveAsync(data, property);
                // @ts-ignore
            }
            else if (save.promise) {
                // @ts-ignore
                save.promise.then(function () {
                    return save(property);
                });
            }
            else {
                // @ts-ignore
                save.promise = saveAsync(data, property).finally(function () {
                    // @ts-ignore
                    delete save.promise;
                });
            }
        }
        /**
         * @function saveAsync
         * @param data {object} - CLONE of series at the point of saving
         * @param [property] {string}
         * @returns {object} - Promise, object
         * @private
         * NOTE: Do NOT call this except via save()
         * This function is to solve the problem of creating multiple new records in parallel.
         */
        function saveAsync(data, property) {
            if (!data.id && vm.series.id) {
                data.id = vm.series.id;
            }
            return MeetingSeriesService.save(data, property && [property]).then(function (response) {
                if (!vm.series.id && !isDestroyed) {
                    vm.series.id = response.data.id;
                    // router set seriesId
                    router.go('meeting-series-settings', { seriesId: vm.series.id });
                }
                //update series owner set & templateRulesOfEngagement
                updateAccess(response.data);
            }, function (response) {
                console.error('SAVE MEETING SERIES ERROR', response);
            });
        }
        /**
         * @function updateAccess
         * @private
         * updates access
         */
        function updateAccess(updatedSeries) {
            //update series owner set
            vm.series.ownerSet = updatedSeries.ownerSet;
            //update series template title and templateRulesOfEngagement for selected meeting template
            vm.series.templateRulesOfEngagement = updatedSeries.templateRulesOfEngagement;
            vm.series.meetingTemplateTitle = updatedSeries.meetingTemplateTitle;
        }
    }
})();
// @ts-ignore ts-migrate(7005) FIXME: Variable 'directReports' implicitly has an 'any' t... Remove this comment to see the full error message

(function () {
    angular.module('App.Meetings').component('meetingTopic', {
        bindings: {
            currentUserId: '<',
            instance: '<',
            isCollapsed: '<',
            isCompleted: '<',
            templateTopicId: '<',
            isHighlighted: '<',
            onBeforeCreate: '&',
            participants: '<',
            topic: '=',
            topicList: '=',
            discussionPointTemplates: '<',
        },
        controller: [
            '$scope',
            'AttachmentsModal',
            'CLIENT_SETTINGS',
            'PubnubService',
            'TopicsService',
            'DeleteWithChallengeModal',
            MeetingTopicComponentController,
        ],
        controllerAs: 'topicVm',
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return TEMPLATE_PATH + '/meetings/meeting-topic/meeting-topic.html';
            },
        ],
    });
    function MeetingTopicComponentController($scope, AttachmentsModal, CLIENT_SETTINGS, PubnubService, TopicsService, DeleteWithChallengeModal) {
        /**
         * @property isNoteExtant
         * @type {boolean}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'AttachmentsModal' implicitly has an 'an... Remove this comment to see the full error message
         * Since a note is saved separately from its topic, yet doesn't have an ID, the service needs to know
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'CLIENT_SETTINGS' implicitly has an 'any... Remove this comment to see the full error message
         *   if the note exists yet.
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'PubnubService' implicitly has an 'any' ... Remove this comment to see the full error message
         * True if note is not null.
         */
        var isNoteExtant = false;
        /**
         * @property pubnubSubscriptionKey
         * @type {number}
         * Used to unsubscribe to pubnub events.
         */
        var pubnubSubscriptionKey;
        var vm = this;
        /**
         * @listener $onInit
         */
        vm.$onDestroy = onDestroy;
        /**
         * @listener $onInit
         */
        vm.$onInit = init;
        /**
         * @property addDiscussion
         * @type {boolean}
         * true to show discussion.
         */
        vm.addDiscussion = false;
        /**
// @ts-ignore ts-migrate(7034) FIXME: Variable 'pubnubSubscriptionKey' implicitly has ty... Remove this comment to see the full error message
         * @property isTemplateTopicApplied
// @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
         * @type {boolean}
         * true then add lock icon in attachmentmodal for template topic from admin meeting template.
         */
        vm.isTemplateTopicApplied = false;
        vm.fn = {
            onChangeDiscussionPoints: onChangeDiscussionPoints,
            openAttachmentsModal: openAttachmentsModal,
            onDeleteTopic: onDeleteTopic,
            resetAddDiscussion: resetAddDiscussion,
            save: save,
            toggleCollapsed: toggleCollapsed,
            toggleCollapsedPreviousMeeting: toggleCollapsedPreviousMeeting,
            toggleRecurring: toggleRecurring,
            toggleVisible: toggleVisible,
            showDiscussionEditor: _.debounce(showDiscussionEditor, 500, {
                leading: true,
                trailing: false,
            }),
        };
        /**
         * @property isDeletable
         * @type {boolean}
         * true when topic has no notes or action items.
         */
        vm.isDeletable = false;
        /**
         * @property isPreviousCollapsed
         * @type {boolean}
         * true when the previous meetings notes are collapsed
         */
        vm.isPreviousCollapsed = true;
        /**
         * @property isShowNotRecurringLabel
         * @type {boolean}
         * True when the state is 'complete' and completedId refers to this instance.
         * A topic might be 'not recurring', but the label should only show on the last instance to have this topic.
         */
        vm.isShowNotRecurringLabel = false;
        /**
         * @property legacyNoteCount
         * @type {number}
         * Used to say there is one note on legacy instances that don't have discussion points.
         */
        vm.legacyNoteCount = 0;
        /**
         * @property person
         * @type {object}
         */
        vm.person = {
            id: vm.currentUserId,
        };
        /**
         * @function checkIfDeletable
         * @returns {boolean}
         * Steps through the various conditions to determine whether a user is allowed to delete this topic.
         */
        function checkIfDeletable() {
            // if (vm.topic.discussionPoints.length) return false;
            // if (vm.topic.previousDiscussionPoints) return false;
            // if (vm.topic.previousNote) return false;
            if (vm.topic.templateTopicId)
                return false;
            return true;
        }
        /**
         * @function init
         * @private
         */
        function init() {
            vm.isShowNotRecurringLabel = Boolean(vm.instance.id && vm.topic.state === 1 && vm.topic.completedId === vm.instance.id);
            isNoteExtant = vm.topic.note && !_.isNull(vm.topic.note.note);
            vm.isTemplateTopicApplied = vm.topic.id && !_.isNull(vm.topic.templateTopicId);
            if (vm.instance.state !== 1) {
                // In progress and suggested meeting instances
                // Listen to updates
                pubnubSubscriptionKey = PubnubService.registerListener('realtime-messaging:onMessage', onMessageEvent);
                // See if the topic can be deleted
                vm.isDeletable = checkIfDeletable();
            }
            else {
                // Legacy completed meetings that don't have discussion points but a note
                // should say there is 1 point.
                if (vm.topic.discussionPoints.length === 0 && vm.topic.note && vm.topic.note.note) {
                    vm.legacyNoteCount = 1;
                }
            }
        }
        /**
         * @function onChangeDiscussionPoints
         * @param point {Object}
         * Reevaluate if this topic can be deleted when discussion points change.
         */
        function onChangeDiscussionPoints(point) {
            vm.isDeletable = checkIfDeletable();
        }
        /**
         * @method onDeleteTopic
         */
        function onDeleteTopic() {
            DeleteWithChallengeModal.open({
                instructions: 'Please confirm you are deleting this Topic which will delete all associated discussion points and comments for this meeting instance as well.',
                title: 'Delete Topic',
                itemType: 'Topic',
                componentTitle: vm.topic.title,
            }).then(function onDeleteModal() {
                //delete the topic
                return TopicsService.destroyForInstance(vm.instance.id, vm.topic);
            });
        }
        /**
         * @function onDestroy
         */
        function onDestroy() {
            if (pubnubSubscriptionKey) {
                PubnubService.deregisterListener(pubnubSubscriptionKey);
            }
        }
        /**
         * @method onDestroyAttachment
         */
        function onDestroyAttachment(type, attachment, isAdminEntity) {
            return vm.onBeforeCreate().then(function () {
                return TopicsService.attachmentDestroy(vm.topic.id)(type, attachment, isAdminEntity);
            });
        }
        /**
         * @function onMessageEvent
         * @param payload {object} - Pubnub event
         * @returns {void}
         * @private
         * Invoked for every pubnub event, responds when event matches type and props.
         */
        function onMessageEvent(payload) {
            var props = {
                topicId: vm.topic.id,
                meetingId: vm.instance.id,
            };
            if (PubnubService.match(payload, 'discussionPoint', props)) {
                switch (payload.message.action) {
                    case 'delete':
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'point' implicitly has an 'any' type.
                        $scope.$evalAsync(function () {
                            _.remove(vm.topic.discussionPoints, { id: payload.body.id });
                        });
                        break;
                    case 'new':
                        $scope.$evalAsync(function () {
                            vm.topic.discussionPoints.unshift(payload.body);
                        });
                        break;
                    case 'update':
                        var discussionPoint = _.find(vm.topic.discussionPoints, {
                            id: payload.body.id,
                        });
                        console.log(discussionPoint); // zzmatt
                        if (discussionPoint) {
                            $scope.$evalAsync(function () {
                                discussionPoint.discussionPoint = payload.body.discussionPoint;
                                // @ts-ignore ts-migrate(7005) FIXME: Variable 'pubnubSubscriptionKey' implicitly has an... Remove this comment to see the full error message
                                discussionPoint.updatedDate = payload.body.updatedDate;
                            });
                        }
                        break;
                }
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'pubnubSubscriptionKey' implicitly has an... Remove this comment to see the full error message
                vm.isDeletable = checkIfDeletable();
            }
        }
        /**
         * @method onSaveAttachment
         */
        function onSaveAttachment(type, attachment, isAdminEntity) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
            return vm.onBeforeCreate().then(function () {
                return TopicsService.attachmentSave(vm.topic.id)(type, attachment, isAdminEntity);
            });
        }
        /**
         * @method onUploadAttachment
         */
        function onUploadAttachment(type, attachment, isAdminEntity) {
            return vm.onBeforeCreate().then(function () {
                return TopicsService.attachmentUpload(vm.topic.id)(type, attachment, isAdminEntity);
            });
        }
        /**
         * @method openAttachmentsModal
         * Get details about the files, open the modal.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'payload' implicitly has an 'any' type.
        function openAttachmentsModal() {
            TopicsService.getFiles(vm.topic.id).then(function getFilesSuccess(response) {
                var files = response.data;
                AttachmentsModal.open({
                    isTemplateTopic: vm.isTemplateTopicApplied,
                    isAdminContext: false,
                    isReadOnly: vm.instance.state == 1,
                    onDestroy: onDestroyAttachment,
                    onChange: onSaveAttachment,
                    onUpload: onUploadAttachment,
                    files: files,
                    links: vm.topic.links,
                });
            }, function getFilesError(response) {
                console.error('GET TOPIC FILES ERROR', response);
            });
        }
        /**
         * @method resetAddDiscussion
         */
        function resetAddDiscussion() {
            vm.addDiscussion = false;
        }
        /**
         * @method save
         * @param [property] {string}
         * Creates a new Topic.
         * Ensures that only one topic is created no matter how many parallel attempts to create a topic.
         */
        function save(property) {
            var data = _.cloneDeep(vm.topic);
            // Make sure the instance exists
            vm.onBeforeCreate().then(function () {
                if (vm.topic.id) {
                    saveAsync(data, property);
                    // @ts-ignore
                }
                else if (save.promise) {
                    // @ts-ignore
                    save.promise.then(function () {
                        return save(property);
                    });
                }
                else {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
                    save.promise = saveAsync(data, property).finally(function () {
                        // @ts-ignore
                        delete save.promise;
                    });
                }
            });
        }
        /**
         * @function saveAsyc
         * @param data {object}
         * @param [property] {string}
         * @returns {object} - promise, Object
         * Note: Should only be called by save()
         */
        function saveAsync(data, property) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
            if (!data.id && vm.topic.id) {
                data.id = vm.topic.id;
            }
            return TopicsService.save(vm.instance.id, data, property && [property]).then(function saveSuccess(response) {
                if (!vm.topic.id) {
                    vm.topic.id = response.data.id;
                }
            }, function saveError(response) {
                console.error('SAVE TOPIC FOR MEETING INSTANCE ERROR', response);
            });
        }
        /**
         * Show hide this specific meeting topic
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
        function toggleCollapsed() {
            vm.isCollapsed = !vm.isCollapsed;
        }
        /**
         * Show hide previous meeting notes
         */
        function toggleCollapsedPreviousMeeting() {
            vm.isPreviousCollapsed = !vm.isPreviousCollapsed;
        }
        /**
         * @method toggleRecurring
         */
        function toggleRecurring() {
            // completed: 1, active: 0
            vm.topic.state = vm.topic.state === 1 ? 0 : 1;
            // completedId doesn't matter if state is currently editable.
            vm.isShowNotRecurringLabel = vm.topic.state === 1;
            save('state');
        }
        /**
         * @method toggleVisible
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
        function toggleVisible() {
            vm.topic.isVisible = !vm.topic.isVisible;
            save('isVisible');
        }
        /**
         * @method showDiscussionEditor
         */
        function showDiscussionEditor() {
            vm.addDiscussion = true;
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'property' implicitly has an 'any' type.

(function () {
    angular
        .module('App.Meetings')
        .controller('ShareMeetingModalController', [
        '$rootScope',
        '$scope',
        '$state',
        '$uibModalInstance',
        'PRODUCT_URLS',
        ShareMeetingModalController,
    ])
        .factory('ShareMeetingModal', [
        '$rootScope',
        '$uibModal',
        'TEMPLATE_PATH',
        ShareMeetingModalFactory,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$rootScope' implicitly has an 'any' typ... Remove this comment to see the full error message
    function ShareMeetingModalFactory($rootScope, $uibModal, TEMPLATE_PATH) {
        var service = {
            open: open,
        };
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'options' implicitly has an 'any' type.
        function open(options) {
            var ms = $rootScope.$new(true);
            ms.options = options;
            var modalInstance = $uibModal.open({
                animation: true,
                controller: 'ShareMeetingModalController',
                controllerAs: 'modalVm',
                scope: ms,
                size: 'md',
                templateUrl: TEMPLATE_PATH + '/meetings/share-meeting-modal/share-meeting-modal.html',
                windowClass: 'share-meeting-modal',
            });
            return modalInstance.result;
        }
        return service;
    }
    function ShareMeetingModalController(
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$rootScope' implicitly has an 'any' typ... Remove this comment to see the full error message
    $rootScope, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$scope' implicitly has an 'any' type.
    $scope, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$state' implicitly has an 'any' type.
    $state, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$uibModalInstance' implicitly has an 'a... Remove this comment to see the full error message
    $uibModalInstance, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'PRODUCT_URLS' implicitly has an 'any' t... Remove this comment to see the full error message
    PRODUCT_URLS) {
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        vm.link = '';
        /**
         * @listener $onInit
         */
        vm.$onInit = init;
        vm.fn = {
            ok: ok,
            cancel: cancel,
            copy: copy,
        };
        /**
         * @function init
         */
        function init() {
            //create link for meeting series
            if (!_.includes(PRODUCT_URLS.hermes, 'https')) {
                vm.link =
                    window.location.protocol +
                        PRODUCT_URLS.hermes +
                        '/#!/home?tray=meetings&tray-component=meeting-series&tray-component-id=' +
                        $scope.options.meetingSeriesId;
            }
            else {
                vm.link =
                    PRODUCT_URLS.hermes +
                        '/#!/home?tray=meetings&tray-component=meeting-series&tray-component-id=' +
                        $scope.options.meetingSeriesId;
            }
        }
        /**
         * @method cancel
         * When the user clicks cancel.
         */
        function cancel() {
            $uibModalInstance.dismiss();
        }
        /**
         * @method copy
         * When the user clicks copy link.
         * https://stackoverflow.com/questions/43139185/how-to-copy-a-string-to-clipboard-with-ng-click-in-angularjs
         */
        function copy() {
            var copyElement = document.createElement('textarea');
            copyElement.style.position = 'fixed';
            copyElement.style.opacity = '0';
            copyElement.textContent = vm.link;
            var body = document.getElementsByTagName('body')[0];
            body.appendChild(copyElement);
            copyElement.select();
            document.execCommand('copy');
            body.removeChild(copyElement);
            $rootScope.$emit('notify', 'Copied to Clipboard', 'success');
        }
        /**
         * @method ok
         * When the user clicks ok.
         */
        function ok() {
            $uibModalInstance.close();
        }
    }
})();

(function () {
    angular.module('App.Layout', ['ui.router', 'ui.bootstrap']);
})();

(function () {
    angular.module('App.Layout').component('layoutFooter', {
        controller: ['ENVIRONMENT', 'VERSION', LayoutFooterController],
        controllerAs: 'footerVm',
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return TEMPLATE_PATH + '/layout/footer/layout-footer.html';
            },
        ],
    });
    /**
     * @controller LayoutFooterController
     * @constructor
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ENVIRONMENT' implicitly has an 'any' ty... Remove this comment to see the full error message
    function LayoutFooterController(ENVIRONMENT, VERSION) {
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        /**
         * @property currentYear
         * @type {number}
         */
        vm.currentYear = new Date().getFullYear();
        /**
         * @property deployedEnvironment
         * @type {String}
         */
        vm.environment = ENVIRONMENT;
        /**
         * @property gitTag
         * @type {String}
         */
        vm.version = VERSION || 'DEV';
    }
})();

(function () {
    angular.module('App.Layout').component('layoutHeader', {
        controller: [
            '$window',
            '$rootScope',
            '$state',
            '$location',
            'AuthenticationService',
            'ETWServicesUtils',
            'FaviconService',
            'LayoutHeaderClientModal',
            'LayoutHeaderSearchModal',
            'PeopleService',
            'MessagingService',
            'PubnubService',
            'LogoService',
            'CLIENT_SETTINGS',
            'TrayRouter',
            LayoutHeaderController,
        ],
        controllerAs: 'headerVm',
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return TEMPLATE_PATH + '/layout/header/layout-header.html';
            },
        ],
    });
    function LayoutHeaderController(
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$window' implicitly has an 'any' type.
    $window, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$rootScope' implicitly has an 'any' typ... Remove this comment to see the full error message
    $rootScope, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$state' implicitly has an 'any' type.
    $state, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$state' implicitly has an 'any' type.
    $location, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AuthenticationService' implicitly has a... Remove this comment to see the full error message
    AuthenticationService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AuthenticationService' implicitly has a... Remove this comment to see the full error message
    ETWServicesUtils, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'FaviconService' implicitly has an 'any'... Remove this comment to see the full error message
    FaviconService, 
    // @ts-ignore ts-migrate(7006)
    LayoutHeaderClientModal, 
    // @ts-ignore ts-migrate(7006)
    LayoutHeaderSearchModal, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'PeopleService' implicitly has an 'any' ... Remove this comment to see the full error message
    PeopleService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'MessagingService' implicitly has an 'an... Remove this comment to see the full error message
    MessagingService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'PubnubService' implicitly has an 'any' ... Remove this comment to see the full error message
    PubnubService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'LogoService' implicitly has an 'any' ty... Remove this comment to see the full error message
    LogoService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'CLIENT_SETTINGS' implicitly has an 'any... Remove this comment to see the full error message
    CLIENT_SETTINGS, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TrayRouter' implicitly has an 'any' typ... Remove this comment to see the full error message
    TrayRouter) {
        /**
         * @listener config:loaded
         * Wait for config to load.
         * Save callback to destroy the listener later since $rootScope is never destroyed.
         * Note: If the browser window is hidden, this event happens BEFORE this controller is loaded
         * If client settings are already loaded in init(), destroy this listener.
         */
        var destroyConfigLoaderListener = $rootScope.$on('config:loaded', function () {
            vm.isLoaded = AuthenticationService.isAuthenticated();
            // Only listen once.
            destroyConfigLoaderListener();
        });
        /**
         * @listener user:change
         * Listen for when the user signs in/out or changes permissions.
         * Save callback to destroy the listener later since $rootScope is never destroyed.
         */
        var destroyUserChangeListener = $rootScope.$on('user:change', init);
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        /**
         * @listener $onDestroy
         * Called when this component is removed from the DOM.
         */
        vm.$onDestroy = function () {
            // Destroy the user:change listener since it is attached to the $rootScope
            destroyUserChangeListener();
            if (vm.messageListenerUid) {
                PubnubService.deregisterListener(vm.messageListenerUid);
            }
            if (vm.messageListenerOnReadUid) {
                PubnubService.deregisterListener(vm.messageListenerOnReadUid);
            }
        };
        /**
         * @listener $onInit
         */
        vm.$onInit = init;
        vm.fn = {
            close: close,
            endImpersonation: endImpersonation,
            impersonateClient: impersonateClient,
            impersonateUser: impersonateUser,
            onSelectPerson: onSelectPerson,
            searchPeople: searchPeople,
            showIntercomMessenger: showIntercomMessenger,
            signout: signout,
            toggleTray: toggleTray,
        };
        /**
         * @property isPersonError
         * @type {boolean}
         * Used to tell the template there was a problem accessing the API
         */
        vm.isPersonError = false;
        /**
         * @property notification
         * @type {boolean}
         * Used to tell the layout-nav-app directive that there is a notification that messages exist.
         */
        vm.notification = false;
        /**
         * Is the current user allowed to impersonate another user
         */
        vm.impersonationAllowed = false;
        /**
         * Is the current user allowed to impersonate another client
         */
        vm.clientImpersonationAllowed = false;
        /**
         * will be > 0 and the id of the original user if the user is impersonating
         */
        vm.isImpersonating = {
            user: -1,
            client: -1,
        };
        /**
         * @property isPersonLoaded
         * @type {boolean}
         * Used to tell the template the person object has been loaded.
         */
        vm.isPersonLoaded = false;
        /**
         * @property isShowPeople
         * @type {boolean}
         * Whether or not to show the people tab in the APP nav.
         */
        vm.isShowPeople = false;
        /**
         * @property mobileLinksVisible
         * @type {boolean}
         */
        vm.mobileLinksVisible = false;
        /**
         * @property navSection
         * @type {string}
         * The section name of the app, derived from the second part of the state name.
         */
        vm.navSection = null;
        /**
         * @property router
         * @type {object}
         * Use special 'all' name to be notified for all links that need to open a drawer.
         */
        var router = TrayRouter('all');
        /**
         * @property routerSubscribeIndex
         * @type {number}
         * Unique ID used to unsubscribe from the router.
         */
        // @ts-ignore ts-migrate(7034) FIXME: Variable 'routerSubscribeIndex' implicitly has typ... Remove this comment to see the full error message
        var routerSubscribeIndex;
        /**
         * @listener $onDestroy
         */
        vm.$onDestroy = destroyComponent;
        /**
         * @listener $onInit
         */
        vm.$onInit = init;
        /**
         * @property isShowFab
         * @type {bool}
         */
        vm.isShowFab = true;
        /**
         * @property selectedTray
         * @type {string}
         */
        vm.selectedTray = '';
        /**
         * @listener $stateChangeSuccess
         * @param event {Event}
         * @param toState {object}
         * When navigating to a new page, check if the user is logged in.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
        $rootScope.$on('$stateChangeSuccess', function (event, toState) {
            var parts = toState.name.split('.');
            //if the user is logged in, and the page is not public
            vm.navSection = parts.length > 1 ? parts[1] : '';
            if (vm.navSection == 'stream') {
                // When user navigates to home screen, clear notification
                vm.notification = false;
            }
            //hide the mobile link navigation
            vm.mobileLinksVisible = false;
        });
        /**
         * @function init
         * @private
         */
        function init() {
            if (AuthenticationService.isAuthenticated()) {
                // If user is authenticated, get the Person object
                getUser();
                // fetch the company logo
                updateLogo();
                vm.accessToken = AuthenticationService.loadAccessToken();
                // If the client settings are already loaded, destroy the listener and set as loaded.
                if (CLIENT_SETTINGS.id) {
                    destroyConfigLoaderListener();
                    destroyUserChangeListener();
                    vm.isLoaded = true;
                }
                AuthenticationService.canSwitchClient()
                    .then(function (response) {
                    vm.clientImpersonationAllowed = response.data.response;
                });
                vm.impersonationAllowed = AuthenticationService.canImpersonate();
                vm.isImpersonating = AuthenticationService.isImpersonating();
                // This is to notify the user that a new message
                // is available on the home page
                MessagingService.connect().then(function connectSuccess() {
                    vm.messageListenerUid = PubnubService.registerListener('realtime-messaging:onMessage', onMessageEvent);
                    vm.messageListenerOnReadUid = PubnubService.registerListener('realtime-messaging:onMessagesRead', onMessageReadEvent);
                    setTotalUnreadMessageCount();
                }, 
                // If the user isn't signed in, or the client doesn't have communication, connect() will be rejected
                angular.noop);
                //watch for future logo updates
                LogoService.subscribe(updateLogo);
            }
        }
        function endImpersonation() {
            // @ts-ignore ts-migrate(7006)
            PeopleService.impersonateUser(vm.isImpersonating.user, vm.isImpersonating.client)
                .then(function (response) {
                AuthenticationService.authenticateImpersonation(response.access_token, response.refresh_token);
            }, function (error) {
                console.log(error);
            });
        }
        function impersonateClient() {
            // Note: creating an instance causes a route change, as does complete()
            LayoutHeaderClientModal.open({});
            // .then(save)
            // .then(complete, angular.noop);
        }
        /**
         *
         */
        function impersonateUser() {
            // Note: creating an instance causes a route change, as does complete()
            LayoutHeaderSearchModal.open({});
            // .then(save)
            // .then(complete, angular.noop);
        }
        //loads the latest company logo
        function updateLogo() {
            //request the current logo
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'image' implicitly has an 'any' type.
            LogoService.getImageUrl('lg').then(function (image) {
                vm.companyLogo = image; //load the company's logo
                vm.logoIsLoaded = true;
            });
        }
        /**
         * @function getUser
         * Called when user status changes.
         * Gets the auth/admin/person based on the JWT
         * Note: Can run multiple times; see user:change event above.
         */
        function getUser() {
            vm.person = null;
            AuthenticationService.getUserPerson()
                .then(
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            function getPersonSuccess(response) {
                vm.person = response;
                vm.isPersonError = false;
                // People section is visible to leaders and people who can view peer
                vm.isShowPeople =
                    !!vm.person.leader ||
                        AuthenticationService.hasPermission('VIEW_PEOPLE_PEERS') ||
                        AuthenticationService.hasPermission('DELEGATE_MANAGERIAL_AUTHORITY');
            }, function getPersonError() {
                vm.isPersonError = true;
            })
                .finally(function getPersonFinal() {
                try {
                    vm.isPersonLoaded = true;
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @function searchPeople
         * Allows for searching people.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'query' implicitly has an 'any' type.
        function searchPeople(query) {
            return PeopleService.search(query);
        }
        /**
         * @method onSelectPerson
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'person' implicitly has an 'any' type.
        function onSelectPerson(person) {
            $state.go('app.people.show', { personId: person.id });
        }
        /**
         * This fires when a new message comes in for the user
         * and the user is not on the Home page. This will add
         * a small indicator in the header nav.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'msg' implicitly has an 'any' type.
        function onMessageEvent(msg) {
            if (vm.navSection != 'stream' && msg.message.type != 'actionItem') {
                vm.notification = true;
                $rootScope.$applyAsync();
            }
            setTotalUnreadMessageCount();
        }
        /**
         * @method onMessageReadEvent
         * @return {none}
         * When the person hits the home page and the messages
         * are marked as read, this will fire to update the counter
         * on the favicon
         */
        function onMessageReadEvent() {
            setTotalUnreadMessageCount();
        }
        /**
         * @method setTotalUnreadMessageCount
         * Updates the favicon with the counter for unread messages
         */
        function setTotalUnreadMessageCount() {
            var unreadMessagesCount = 0;
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'channel' implicitly has an 'any' type.
            MessagingService.getRoomChannels().forEach(function (channel) {
                unreadMessagesCount += PubnubService.fetchUnreadMessagesCount(channel.uuid);
            });
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'channel' implicitly has an 'any' type.
            MessagingService.getDirectMessageChannels().forEach(function (channel) {
                unreadMessagesCount += PubnubService.fetchUnreadMessagesCount(channel.uuid);
            });
            FaviconService.setTotalUnreadMessages(unreadMessagesCount);
        }
        /**
         * @function showIntercomMessenger
         * Activates Intercom embedded help widget.
         */
        function showIntercomMessenger() {
            //$window.Intercom('show');
        }
        /**
         * @method signout
         * Clear the session and sign in.
         */
        function signout() {
            AuthenticationService.logout();
        }
        /**
         * @function destroyComponent
         * @private
         */
        function destroyComponent() {
            // Remove callback from the router
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'routerSubscribeIndex' implicitly has an ... Remove this comment to see the full error message
            router.unsubscribe(routerSubscribeIndex);
        }
        /**
         * @function openTray
         * @private
         * @param name {string}
         * Attempts to lazy load a module if drawer is not loaded.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'name' implicitly has an 'any' type.
        function openTray(name) {
            vm.selectedTray = name;
            TrayRouter(name).open();
            if (vm.selectedTray === 'meetings') {
                ETWServicesUtils.notify('TrayOpen');
            }
        }
        /**
         * @function closeTray
         * @private
         */
        function closeTray() {
            vm.selectedTray = '';
            TrayRouter().close();
        }
        /**
         * @method toggleTray
         * @param name {string}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'name' implicitly has an 'any' type.
        function toggleTray(name) {
            vm.switchTrays = false;
            if (!vm.selectedTray && name) {
                vm.trayFlag = false;
            }
            else if (vm.selectedTray && name && vm.selectedTray !== name) {
                vm.switchTrays = true;
            }
            else if (vm.selectedTray && !name) {
                vm.trayFlag = false;
            }
            if (vm.selectedTray === name) {
                $location.search('tray', null);
                $location.search('tray-component', null);
                $location.search('tray-component-id', null);
                closeTray();
            }
            else {
                if (name === 'meetings') {
                    $location.search('tray', 'meetings');
                }
                else {
                    $location.search('tray', null);
                    $location.search('tray-component', null);
                    $location.search('tray-component-id', null);
                }
                openTray(name);
            }
        }
        /**
         * @method closeTray
         * closes tray when clicking in the navbar
         */
        function close() {
            if (vm.selectedTray && !vm.trayFlag) {
                vm.trayFlag = true;
                return;
            }
            if (vm.switchTrays) {
                vm.switchTrays = false;
                return;
            }
            if (!vm.selectedTray) {
                closeTray();
            }
            else {
                openTray(vm.selectedTray);
            }
        }
    }
})();

(function () {
    angular
        .module('App.Layout')
        .directive('layoutNavAdmin', ['TEMPLATE_PATH', LayoutNavAdminDirective]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TEMPLATE_PATH' implicitly has an 'any' ... Remove this comment to see the full error message
    function LayoutNavAdminDirective(TEMPLATE_PATH) {
        var DirectiveDefinitionObject = {
            restrict: 'E',
            link: link,
            templateUrl: TEMPLATE_PATH + '/layout/nav-admin/layout-nav-admin.html',
        };
        return DirectiveDefinitionObject;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope) {
            scope.disableLink = false;
        }
    }
})();

(function () {
    angular.module('App.Layout')
        .directive('layoutNavApp', [
        '$location',
        '$window',
        'CLIENT_SETTINGS',
        'ETWServicesUtils',
        'TrayRouter',
        'AuthenticationService',
        'MeetingSeriesService',
        'PlansService',
        'GoalsService',
        'ActionItemsService',
        'TEMPLATE_PATH',
        'PRODUCT_URLS',
        LayoutNavAppDirective
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TEMPLATE_PATH' implicitly has an 'any' ... Remove this comment to see the full error message
    function LayoutNavAppDirective($location, $window, CLIENT_SETTINGS, ETWServicesUtils, TrayRouter, AuthenticationService, MeetingSeriesService, PlansService, GoalsService, ActionItemsService, TEMPLATE_PATH, PRODUCT_URLS) {
        var DirectiveDefinitionObject = {
            link: link,
            scope: {
                notification: '=',
                person: '=',
                section: '=',
                showPeople: '=',
                selectedTray: '=',
                closeTray: '&',
                toggleTray: '&',
            },
            restrict: 'E',
            templateUrl: TEMPLATE_PATH + '/layout/nav-app/layout-nav-app.html',
        };
        return DirectiveDefinitionObject;
        function link(scope) {
            scope.isPlansLoaded = false;
            scope.dropdownFlag = false;
            /**
         * @property userId
         * @type {number}
         */
            scope.currentUserId = AuthenticationService.getAccount().userId;
            scope.fn = {
                getPinnedPlans: getPinnedPlans,
                getMeetings: getMeetings,
                toggleMeetingsTray: toggleMeetingsTray,
                openMeetingsTray: openMeetingsTray,
                openActionsTray: openActionsTray,
                openMeetingSeries: openMeetingSeries,
                toggleTray: toggleTray,
                dropdownCloseFlag: dropdownCloseFlag,
                dropdownOpenFlag: dropdownOpenFlag,
                navClick: navClick,
                gotoDrive: gotoDrive,
            };
            scope.JANUS_URL = PRODUCT_URLS.janus;
            scope.access = {
                admin: AuthenticationService.hasPermission('VIEW_ADMIN'),
                janus: AuthenticationService.hasScope('janus'),
            };
            scope.showTeams = CLIENT_SETTINGS.enableUITeamManaged;
            scope.showPeople = CLIENT_SETTINGS.enableUIPeoplePage;
            scope.showResources = CLIENT_SETTINGS.enableUIResources;
            init();
            function init() {
                getPinnedPlans();
                getIncompleteActions();
                getActionsStatus();
            }
            function gotoDrive() {
                AuthenticationService.setAuthCookie()
                    // @ts-ignore ts-migrate(7006)
                    .then(function () {
                    console.log('set the cookie');
                    console.log(PRODUCT_URLS.janus);
                    $window.location.href = PRODUCT_URLS.janus;
                });
            }
            function getPinnedPlans() {
                PlansService.getPinnedPlans().then(
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                function getPinnedPlansSuccess(response) {
                    if (!response.data.length) {
                        scope.pinnedPlans = [];
                        getTopLevelPlan();
                        return;
                    }
                    // pinned plans that are active
                    scope.pinnedPlans = response.data.filter(function (plan) { return plan.state === 2; });
                    scope.isPlansLoaded = true;
                    getTopLevelPlan();
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                    scope.pinnedPlans.map(function (plan, i) {
                        getPlanGoals(plan.id, i);
                    });
                }, 
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                function getPinnedPlansError(response) {
                    console.error('GET PINNED PLANS ERROR', response);
                });
            }
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
            function getPlanGoals(planId, i) {
                if (i === void 0) { i = -1; }
                var promise;
                promise = GoalsService.getAllForPlan(planId).then(
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                function getParentPlanGoalsSuccess(response) {
                    if (!response.data.length) {
                        return;
                    }
                    var primaryKpiId = response.data[0].primaryKpiId;
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'kpi' implicitly has an 'any' type.
                    var primaryKpi = response.data[0].kpis.filter(function (kpi) {
                        return kpi.id === primaryKpiId;
                    });
                    if (primaryKpi.length && primaryKpi[0].actualSeries.newestPoint && primaryKpi[0].actualSeries.newestPoint.number.toString().length > 3) {
                        var number = primaryKpi[0].actualSeries.newestPoint.number;
                        var neg = number < 0 ? -1 : 1;
                        number = Math.abs(number);
                        var cutoffNum = 4;
                        if (number / 1000000000 >= 1) {
                            if ((number / 1000000000).toFixed(2).toString().substring(0, 4).split("")[3] === '.') {
                                if (neg === 1)
                                    cutoffNum = 3;
                            }
                            number = number * neg;
                            primaryKpi[0].actualSeries.newestPoint.number = (number / 1000000000).toFixed(2).toString().substring(0, cutoffNum) + 'B';
                        }
                        else if (number / 1000000 >= 1) {
                            if ((number / 1000000).toFixed(2).toString().substring(0, 4).split("")[3] === '.') {
                                if (neg === 1)
                                    cutoffNum = 3;
                            }
                            number = number * neg;
                            primaryKpi[0].actualSeries.newestPoint.number = (number / 1000000).toFixed(2).toString().substring(0, cutoffNum) + 'M';
                        }
                        else if (number / 1000 >= 1) {
                            if ((number / 1000).toFixed(2).toString().substring(0, 4).split("")[3] === '.') {
                                if (neg === 1)
                                    cutoffNum = 3;
                            }
                            number = number * neg;
                            primaryKpi[0].actualSeries.newestPoint.number = (number / 1000).toFixed(2).toString().substring(0, cutoffNum) + 'K';
                        }
                    }
                    response.data[0].kpis = primaryKpi;
                    if (i > -1) {
                        scope.pinnedPlans[i].goals = response.data;
                    }
                    else {
                        scope.topLevelPlan[0].goals = response.data;
                    }
                }, 
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                function getParentPlanGoalsError(response) {
                    console.error('GET PARENT PLAN GOALS ERROR', response);
                });
                return promise;
            }
            /**
         * @function getTopLevelPlan
         * @returns {object} - promise, array
         * @private
         * Get all plans that are not supporting plans of any plan the user has access to.
         */
            function getTopLevelPlan() {
                return PlansService.getAllTopLevel()
                    .then(
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                function getTopLevelPlanSuccess(response) {
                    scope.topLevelPlan = _.filter(response.data, function (plan) {
                        return plan.isOwner || plan.state !== 1;
                    });
                    getPlanGoals(scope.topLevelPlan[0].id);
                }, 
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                function getTopLevelPlanError(response) {
                    console.error('GET TOP LEVEL PLANS ERROR', response);
                });
            }
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'name' implicitly has an 'any' ... Remove this comment to see the full error message
            function toggleTray(name) {
                scope.toggleTray(name);
            }
            function dropdownCloseFlag() {
                scope.dropdownFlag = true;
            }
            function dropdownOpenFlag() {
                scope.dropdownFlag = false;
            }
            function getActionsStatus() {
                ActionItemsService.getUsersStatus(scope.currentUserId).then(userStatusSuccess, userStatusError);
            }
            /**
             * @function userStatusSuccess
             * @private
             * @param status {object}
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'status' implicitly has an 'any' type.
            function userStatusSuccess(status) {
                scope.status = null;
                if (status.itemsOverdue) {
                    scope.status = 'pulse-danger';
                }
                else if (status.itemsDueToday) {
                    scope.status = 'pulse-warning';
                }
                else if (status.hasNewItems) {
                    scope.status = 'pulse-info';
                }
            }
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'error' implicitly has an 'any' type.
            function userStatusError(error) {
                console.error('USER STATUS ERROR:', error);
            }
            function getIncompleteActions() {
                var promise;
                promise = ActionItemsService.getUsersIncomplete(scope.currentUserId).then(
                // @ts-ignore
                function getIncompleteActionsSuccess(response) {
                    // @ts-ignore
                    scope.overdueActions = response.records.filter(function (action) { return new Date(action.dueDate).getTime() < new Date().getTime(); });
                }, 
                // @ts-ignore
                function getIncompleteActionsError(response) {
                    console.error('GET INCOMPLETE ACTIONS ERROR', response);
                });
            }
            /**
         * @function getMeetings
         * @private
         * Fetches meetings for meeting dropdown
         */
            function getMeetings() {
                var promise;
                promise = MeetingSeriesService.getAllForPerson(scope.currentUserId)
                    .then(
                // @ts-ignore
                function getMeetingsSuccess(response) {
                    // @ts-ignore
                    var discussionPointMeetings = response.data.filter(function (meeting) { return meeting.discussionPoints && !meeting.hidden; });
                    if (discussionPointMeetings.length >= 3) {
                        scope.meetings = discussionPointMeetings;
                    }
                    else {
                        var meetingsNeeded = 3 - discussionPointMeetings.length;
                        // @ts-ignore
                        var nextMeetings = response.data
                            // @ts-ignore
                            .filter(function (meeting) { return !discussionPointMeetings.includes(meeting); })
                            // @ts-ignore
                            .sort(function (a, b) { return a.nextMeetingDate - b.nextMeetingDate; });
                        scope.meetings = discussionPointMeetings.concat(nextMeetings.slice(0, meetingsNeeded));
                    }
                }, 
                // @ts-ignore
                function getMeetingsError(response) {
                    console.error('GET MEETINGS ERROR', response);
                });
            }
            /**
         * @function openActionsTray
         * @private
         * opens/toggles actions tab from actions nav
         */
            function openActionsTray(location) {
                // dropdownCloseFlag();
                if (location === void 0) { location = null; }
                // if (location) {
                // 	TrayRouter('action-items').open('action-items', { location: location });
                // } else {
                // 	toggleTray({ name: 'action-items' })
                // }
                if (!scope.actionFlag) {
                    TrayRouter('action-items').open('action-items', { location: 'active' });
                    scope.actionFlag = true;
                }
                else {
                    toggleTray({ name: 'action-items' });
                }
            }
            /**
         * @function toggleMeetingsTray
         * @private
         * toggles meetings tab from meeting nav
         */
            function toggleMeetingsTray() {
                dropdownCloseFlag();
                toggleTray({ name: 'meetings' });
            }
            /**
         * @function openMeetingsTray
         * @private
         * opens meetings tab from meeting nav
         */
            function openMeetingsTray() {
                dropdownCloseFlag();
                TrayRouter('meetings').open('meeting-series-list', {});
            }
            /**
         * @function openMeetingSeries
         * @private
         * opens meetings tab at a specific series from meeting nav
         */
            // @ts-ignore
            function openMeetingSeries(seriesId) {
                dropdownCloseFlag();
                TrayRouter('meetings').open('meeting-series', {
                    seriesId: seriesId,
                    personId: scope.currentUserId,
                });
            }
            /**
         * @function onActionItems
         * @private
         * Sets action item count for each driver
         */
            // @ts-ignore
            function onActionItems(items, index) {
                scope.focusedDrivers[index].actionItemCount = items.length;
                scope.focusedDrivers[index].actionItemOverdueCount = _.filter(items, function (a) {
                    return ActionItemsService.getRelativeDueDate(new Date(a.dueDate)).overDue;
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                }).length;
            }
            /**
         * @function navClick
         * @private
         * Closes tray when clicking on another item in nav
         */
            function navClick() {
                dropdownCloseFlag();
                scope.selectedTray = '';
                scope.closeTray();
            }
        }
    }
})();

(function () {
    angular
        .module('App.Layout')
        .controller('LayoutHeaderClientModalController', [
        '$scope',
        '$state',
        '$uibModalInstance',
        'AuthenticationService',
        'ClientService',
        'PeopleService',
        LayoutHeaderClientModalController,
    ])
        .factory('LayoutHeaderClientModal', [
        '$rootScope',
        '$uibModal',
        'TEMPLATE_PATH',
        LayoutHeaderClientModalFactory,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$rootScope' implicitly has an 'any' typ... Remove this comment to see the full error message
    function LayoutHeaderClientModalFactory($rootScope, $uibModal, TEMPLATE_PATH) {
        var service = {
            open: open
        };
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'options' implicitly has an 'any' type.
        function open(options) {
            var ms = $rootScope.$new(true);
            ms.options = options;
            var modalInstance = $uibModal.open({
                animation: true,
                controller: 'LayoutHeaderClientModalController',
                controllerAs: 'modalVm',
                scope: ms,
                size: 'md',
                templateUrl: TEMPLATE_PATH + '/layout/header/layout-header-client-modal/layout-header-client-modal.html',
                windowClass: 'layout-header-search-modal',
            });
            return modalInstance.result;
        }
        return service;
    }
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$scope' implicitly has an 'any' type.
    function LayoutHeaderClientModalController($scope, $state, $uibModalInstance, AuthenticationService, ClientService, PeopleService) {
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        /**
         * @listener $onInit
         */
        vm.$onInit = init;
        vm.fn = {
            cancel: cancel,
            onSelectClient: onSelectClient,
            searchClients: searchClients,
        };
        /**
         * @function init
         */
        function init() { vm.accessToken = AuthenticationService.loadAccessToken(); }
        /**
         * @method cancel
         * When the user clicks ok.
         */
        function cancel() {
            $uibModalInstance.dismiss();
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'person' implicitly has an 'any' type.
        function onSelectClient(client) {
            // @ts-ignore ts-migrate(7006)
            PeopleService.impersonateClient(client.id)
                // @ts-ignore
                .then(function (response) {
                AuthenticationService.authenticateImpersonation(response.access_token, response.refresh_token);
            }, 
            // @ts-ignore
            function (error) {
                console.log(error);
            });
        }
        function searchClients(query) {
            return ClientService.search(query);
        }
    }
})();

(function () {
    angular
        .module('App.Layout')
        .controller('LayoutHeaderSearchModalController', [
        '$scope',
        '$state',
        '$uibModalInstance',
        'AuthenticationService',
        'PeopleService',
        LayoutHeaderSearchModalController,
    ])
        .factory('LayoutHeaderSearchModal', [
        '$rootScope',
        '$uibModal',
        'TEMPLATE_PATH',
        LayoutHeaderSearchModalFactory,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$rootScope' implicitly has an 'any' typ... Remove this comment to see the full error message
    function LayoutHeaderSearchModalFactory($rootScope, $uibModal, TEMPLATE_PATH) {
        var service = {
            open: open
        };
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'options' implicitly has an 'any' type.
        function open(options) {
            var ms = $rootScope.$new(true);
            ms.options = options;
            var modalInstance = $uibModal.open({
                animation: true,
                controller: 'LayoutHeaderSearchModalController',
                controllerAs: 'modalVm',
                scope: ms,
                size: 'md',
                templateUrl: TEMPLATE_PATH + '/layout/header/layout-header-search-modal/layout-header-search-modal.html',
                windowClass: 'layout-header-search-modal',
            });
            return modalInstance.result;
        }
        return service;
    }
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$scope' implicitly has an 'any' type.
    function LayoutHeaderSearchModalController($scope, $state, $uibModalInstance, AuthenticationService, PeopleService) {
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        /**
         * @listener $onInit
         */
        vm.$onInit = init;
        vm.fn = {
            cancel: cancel,
            onSelectPerson: onSelectPerson,
            searchPeople: searchPeople,
        };
        /**
         * @function init
         */
        function init() { vm.accessToken = AuthenticationService.loadAccessToken(); }
        /**
         * @method cancel
         * When the user clicks ok.
         */
        function cancel() {
            $uibModalInstance.dismiss();
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'person' implicitly has an 'any' type.
        function onSelectPerson(person) {
            // $state.go('app.people.show', { personId: person.id });
            // @ts-ignore ts-migrate(7006)
            PeopleService.impersonateUser(person.id, vm.accessToken.clientIdNum)
                // @ts-ignore
                .then(function (response) {
                AuthenticationService.authenticateImpersonation(response.access_token, response.refresh_token);
            }, 
            // @ts-ignore
            function (error) {
                console.log(error);
            });
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'query' implicitly has an 'any' type.
        function searchPeople(query) {
            return PeopleService.search(query);
        }
    }
})();

// use strict set in app.js
(function () {
    angular
        .module('App.Routes', ['oc.lazyLoad', 'ngCookies', 'ETWServices'])
        .config(['$locationProvider', '$stateProvider', '$urlRouterProvider', RoutesConfig]);
    /**
     * @function RoutesConfig
     * @param $locationProvider {object} - from Angular, control html5mode, hash, etc.
     * @param $stateProvider {object} - from ui.router
     * @param $urlRouterProvider {object} - from Angular, use to catch default route
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$locationProvider' implicitly has an 'a... Remove this comment to see the full error message
    function RoutesConfig($locationProvider, $stateProvider, $urlRouterProvider) {
        /**
         * @property peopleSearchUrlPattern
         * @type {string}
         * Long mapping of acceptable URL parameters for admin.people.index
         */
        var peopleSearchUrlPattern = '?' +
            [
                '{anyAttributes:[0-9,]*}',
                '{allAttributes:[0-9,]*}',
                '{noneAttributes:[0-9,]*}',
                '{onlyAttributes:[0-9,]*}',
                '{anyRoles:[0-9,]*}',
                '{allRoles:[0-9,]*}',
                '{noneRoles:[0-9,]*}',
                '{onlyRoles:[0-9,]*}',
                '{anyPermissions:[0-9,]*}',
                '{allPermissions:[0-9,]*}',
                '{nonePermissions:[0-9,]*}',
                '{onlyPermissions:[0-9,]*}',
                '{showActive:[a-z]*}',
                '{showInactive:[a-z]*}',
                '{showTerminated:[a-z]*}',
                '{showOrphaned:[a-z]*}',
                '{showAttributeless:[a-z]*}',
                '{showPermissionless:[a-z]*}',
                '{showRoleless:[a-z]*}',
                '{onlyPeople:[0-9,]*}',
                '{query}',
            ].join('');
        /**
         * @property goalFilterUrlPattern
         * @type {string}
         * Acceptable URL parameters for filtering goals.
         * Originally for app.people.person-goals
         */
        var goalFilterUrlPattern = '?' +
            [
                '{access:[a-z]*}',
                '{category:[0-9,]*}',
                '{enableEvaluation:[a-z]*}',
                '{performanceGoalType:[a-z,]*}',
                '{alignmentGoalType:[a-z,]*}',
                '{status:[0-9,]*}',
                '{state:[0-9,]*}',
            ].join('');
        $locationProvider.html5Mode(false).hashPrefix('!');
        $urlRouterProvider
            .when('', '/home')
            // When ui-router bombs it sends the user to /null. Send them home or to ∞
            .when('/null', '/home')
            .when('/admin/', '/admin');
        // Simple error state. Usually caused by state change error.
        $stateProvider.state('error', {
            controller: 'RouteController',
            url: '/error?{message}&{from}',
            template: '<div class="container"><div class="alert alert-danger"><strong>Error</strong><div>There is a problem with this app that we did not expect.</div></div><a ng-if="from" ng-href="{{from}}" class="btn btn-primary">Try Again</a> <a href="/" class="btn btn-secondary">Home</a></div>',
        });
        $stateProvider.state('icons', {
            title: 'ETW ICON REFERENCE',
            url: '/icons',
            template: '<icons-reference></icons-reference>',
        });
        $stateProvider.state('sso', {
            controller: 'SSOController',
            public: true,
            template: '<div class="container"></div>',
            title: 'Single Sign On',
            url: '/sso',
        });
        // APP: INDEX
        $stateProvider
            .state('app', {
            url: '',
            abstract: true,
            resolve: {
                clientSettings: getConfig(),
            },
            template: '<layout-header></layout-header><div class="content-container"><ui-view class="state-view"></ui-view></div>',
        })
            .state('app.index', {
            title: 'Home',
            url: '/',
            redirectTo: 'app.stream.index',
        });
        // APP: STREAM
        $stateProvider
            .state('app.stream', {
            abstract: true,
            resolve: {
                // @ts-ignore ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
                // @ts-ignore
                dependencies: moduleLoader('app.stream'),
            },
            template: '<ui-view class="state-view stream"></ui-view>',
            url: '/home',
        })
            .state('app.stream.index', {
            template: '<stream class="component"></stream>',
            title: 'Home',
            url: '?{tray:[a-z]*}{tray-component:[a-z]*}{tray-component-id:[0-9]*}',
        })
            .state('app.stream.stream-settings', {
            template: '<home-settings class="component"></home-settings>',
            title: 'Home Settings',
            url: '/settings',
        })
            //Notes Archive
            .state('app.stream.notes-archive', {
            template: '<notes-archive class="component"></notes-archive>',
            title: 'Notes Archive',
            url: '/notes-archive',
        })
            .state('app.stream.alert-archive', {
            template: '<alert-archive class="component"></alert-archive>',
            title: 'Alerts Archive',
            url: '/alert-archive',
        })
            .state('app.stream.rooms', {
            data: {
                module: 'COMMUNICATION',
                moduleMessage: 'You do not have access to view the Communication Module.',
            },
            template: '<ui-view class="state-view rooms"></ui-view>',
            title: '',
            url: '/rooms',
            redirectTo: 'app.stream.index',
        })
            .state('app.stream.rooms.index', {
            template: '<room class="component"></room>',
            title: 'Rooms',
            url: '',
            redirectTo: 'app.stream.index',
        })
            .state('app.stream.rooms.show', {
            template: '<room class="component"></room>',
            title: 'Rooms',
            url: '/{roomId:[0-9]+}',
        })
            .state('app.stream.rooms.settings', {
            template: '<room-settings class="component"></room-settings>',
            title: 'Room Settings',
            url: '/{roomId:[0-9]+}/settings',
        })
            .state('app.stream.rooms.new', {
            template: '<room class="component"></room>',
            title: 'Rooms',
            url: '/new',
        })
            .state('app.stream.direct-messages', {
            data: {
                module: 'COMMUNICATION',
                moduleMessage: 'You do not have access to view the Communication Module.',
            },
            template: '<ui-view class="state-view direct-messages"></ui-view>',
            title: '',
            url: '/direct-messages',
            redirectTo: 'app.stream.index',
        })
            .state('app.stream.direct-messages.index', {
            title: '',
            url: '/direct-messages',
            redirectTo: 'app.stream.index',
        })
            .state('app.stream.direct-messages.show', {
            template: '<room class="component"></room>',
            title: 'Direct Messages',
            url: '/{roomId:[0-9]+}',
        })
            .state('app.stream.direct-messages.new', {
            template: '<room class="component"></room>',
            title: 'New Direct Message',
            url: '/new',
        });
        // APP: GOALS
        $stateProvider
            .state('app.goals', {
            abstract: true,
            resolve: {
                // @ts-ignore ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
                // @ts-ignore
                dependencies: moduleLoader('app.goals'),
            },
            template: '<ui-view class="state-view goals"></ui-view>',
            url: '/goals',
        })
            .state('app.goals.index', {
            template: '<goals class="component" tab="goals"></goals>',
            title: 'Goals',
            url: '',
        })
            // GOALS GOAL (show = notes tab)
            .state('app.goals.action-items', {
            template: '<goal class="component"></goal>',
            title: 'Goal',
            url: '/{parentGoalType:[a-z_]+}/{parentGoalId:[0-9]+}/action-items/{goalType:[a-z_]+}/{goalId:[0-9]+}',
        })
            .state('app.goals.supporting-goal', {
            template: '<goal class="component"></goal>',
            title: 'Supporting Goal',
            url: '/{parentGoalType:[a-z_]+}/{parentGoalId:[0-9]+}/supporting-goals/{goalType:[a-z_]+}/{goalId:[0-9]+}',
        })
            .state('app.goals.supporting-goal-settings', {
            template: '<goal-settings class="component"></goal-settings>',
            title: 'Goal',
            url: '/{parentGoalType:[a-z_]+}/{parentGoalId:[0-9]+}/supporting-goals/{goalType:[a-z_]+}/{goalId:[0-9]+}/settings',
        })
            .state('app.goals.supporting-goal-tab', {
            template: '<goal class="component"></goal>',
            title: 'Goal',
            url: '/{parentGoalType:[a-z_]+}/{parentGoalId:[0-9]+}/supporting-goals/{goalType:[a-z_]+}/{goalId:[0-9]+}/{tab:[-a-z]*}',
        })
            .state('app.goals.new', {
            template: '<goal-settings class="component"></goal-settings>',
            title: 'Goal',
            url: '/new?{assigneeId:[0-9]+}{parentId:[0-9]+}{planId:[0-9]+}',
        })
            .state('app.goals.show', {
            template: '<goal class="component"></goal>',
            title: 'Goal',
            url: '/{goalType:[a-z_]+}/{goalId:[0-9]+}?={noteId:[0-9a-zA-Z-]*}',
        })
            .state('app.goals.settings', {
            template: '<goal-settings class="component"></goal-settings>',
            title: 'Goal Settings',
            url: '/{goalType:[a-z_]+}/{goalId:[0-9]+}/settings',
        })
            .state('app.goals.show-tab', {
            template: '<goal class="component"></goal>',
            title: 'Goal',
            url: '/{goalType:[a-z_]+}/{goalId:[0-9]+}/{tab:[-a-z]*}?{expandId:[0-9]+}',
        })
            // Goals > KPIs (not the kpis for a goal)
            .state('app.goals.kpis', {
            template: '<goals class="component" tab="kpis"></goals>',
            title: 'KPI',
            url: '/kpi',
        });
        // APP: PEOPLE
        $stateProvider
            .state('app.people', {
            abstract: true,
            resolve: {
                // @ts-ignore ts-migrate(2554) FIXME: Expected 0 arguments, but got 2.
                // @ts-ignore
                dependencies: moduleLoader('app.people.utils', 'app.people', 'app.resources'),
            },
            template: '<ui-view class="state-view people"></ui-view>',
            url: '/people',
        })
            .state('app.people.index', {
            template: '<people class="component" tab="groups"></people>',
            title: 'People',
            url: '?{primaryAttribute:[0-9]*}{secondaryAttribute:[0-9]*}',
        })
            .state('app.people.all', {
            template: '<people class="component" tab="all"></people>',
            title: 'All People',
            url: '/all' + peopleSearchUrlPattern,
        })
            // default person tab is 'profile'
            .state('app.people.show', {
            template: '<person class="component" tab="profile"></person>',
            title: 'Person',
            url: '/{personId:[0-9]+}?{scroll:[a-z]*}',
        })
            .state('app.people.person-career', {
            template: '<person class="component" tab="career"></person>',
            title: 'Person',
            url: '/{personId:[0-9]+}/career',
        })
            // Past Evaluations
            .state('app.people.person-evaluations', {
            template: '<person class="component" tab="evaluations"></person>',
            title: 'Person',
            url: '/{personId:[0-9]+}/evaluations',
        })
            .state('app.people.person-evaluation', {
            template: '<person class="component" tab="evaluations"></person>',
            title: 'Person',
            url: '/{personId:[0-9]+}/evaluations/{evaluationId:[0-9]+}',
        })
            // Person Goals
            .state('app.people.person-goals', {
            abstract: true,
            resolve: {
                // @ts-ignore ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
                // @ts-ignore
                dependencies: moduleLoader('app.people.person-goals'),
            },
            template: '<person class="component" tab="goals"></person>',
            title: 'Person',
            url: '/{personId:[0-9]+}/goals',
        })
            .state('app.people.person-goals.index', {
            template: '<goals-list-zero-state></goals-list-zero-state>',
            title: 'Person Goals',
            url: goalFilterUrlPattern,
        })
            .state('app.people.person-goals.new', {
            template: '<goal-settings class="component"></goal-settings>',
            title: 'Person Goal',
            url: '/new',
        })
            .state('app.people.person-goals.show', {
            template: '<goal class="component"></goal>',
            title: 'Person Goal',
            url: '/{goalType:[a-z_]+}/{goalId:[0-9]+}' + goalFilterUrlPattern,
        })
            .state('app.people.person-goals.settings', {
            template: '<goal-settings class="component"></goal-settings>',
            title: 'Person Goal Settings',
            url: '/{goalType:[a-z_]+}/{goalId:[0-9]+}/settings',
        })
            .state('app.people.person-goals.show-tab', {
            template: '<goal class="component"></goal>',
            title: 'Person Goal',
            url: '/{goalType:[a-z_]+}/{goalId:[0-9]+}/{tab:[-a-z]*}',
        })
            // Action Items
            .state('app.people.person-actionitems', {
            template: '<person class="component" tab="actionitems"></person>',
            title: 'Person',
            url: '/{personId:[0-9]+}/actionitems',
        })
            // Meetings
            .state('app.people.person-meetings', {
            template: '<person class="component" tab="meetings"></person>',
            title: 'Person',
            url: '/{personId:[0-9]+}/meetings',
        })
            // Plans
            .state('app.people.person-plans', {
            template: '<person class="component" tab="plans"></person>',
            title: 'Person',
            url: '/{personId:[0-9]+}/plans',
        })
            // Drivers
            .state('app.people.person-drivers', {
            template: '<person class="component" tab="drivers"></person>',
            title: 'Person',
            url: '/{personId:[0-9]+}/drivers',
        })
            // Teams
            .state('app.people.person-teams', {
            template: '<person class="component" tab="teams"></person>',
            title: 'Person',
            url: '/{personId:[0-9]+}/teams',
        })
            // KPIs
            .state('app.people.person-kpis', {
            template: '<person class="component" tab="kpis"></person>',
            title: 'KPI',
            url: '/{personId:[0-9]+}/kpi',
        })
            // Communications
            .state('app.people.person-communications', {
            template: '<person class="component" tab="communications"></person>',
            title: 'Person',
            url: '/{personId:[0-9]+}/communications',
        })
            // Responsibilities
            .state('app.people.person-responsibilities', {
            template: '<person class="component" tab="responsibilities"></person>',
            title: 'Person',
            url: '/{personId:[0-9]+}/responsibilities',
        })
            // Action Items
            .state('app.people.person-action-items', {
            template: '<person class="component" tab="action-items"></person>',
            title: 'Person',
            url: '/{personId:[0-9]+}/action-items',
        });
        // APP: CURRENT EVALUATIONS
        $stateProvider
            .state('app.people.evaluations', {
            abstract: true,
            data: {
                module: 'EVALUATION',
                moduleMessage: 'You do not have access to view the Evaluations Module.',
            },
            resolve: {
                // @ts-ignore ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
                // @ts-ignore
                dependencies: moduleLoader('app.people.evaluations'),
            },
            template: '<ui-view class="state-view evaluations"></ui-view>',
            url: '/evaluations',
        })
            .state('app.people.evaluations.index', {
            redirectTo: 'app.people.index',
            url: '',
        })
            .state('app.people.evaluations.show', {
            template: '<evaluation class="component"></evaluation>',
            title: 'Evaluation',
            url: '/{evaluationId:[0-9]+}',
        });
        // APP: TEAMS
        $stateProvider
            .state('app.teams', {
            abstract: true,
            data: {
                permission: ['VIEW_TEAM'],
                permissionMessage: 'You do not have permission to view the team section.',
            },
            resolve: {
                // @ts-ignore ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
                // @ts-ignore
                dependencies: moduleLoader('app.teams'),
            },
            template: '<ui-view class="state-view teams"></ui-view>',
            url: '/teams',
        })
            .state('app.teams.index', {
            template: '<teams class="component"></teams>',
            title: 'Teams',
            url: '',
        })
            .state('app.teams.new', {
            // TODO Check permission to view this page
            template: '<team-settings class="component" tab="details"></team-settings>',
            title: 'New Team Settings',
            url: '/new?{parentId:[0-9]+}',
        })
            .state('app.teams.show', {
            template: '<team class="component" tab="dashboard"></team>',
            title: 'Team',
            url: '/{teamId:[0-9]+}',
        })
            .state('app.teams.attributes', {
            template: '<team class="component" tab="attributes"></team>',
            title: 'Team Attributes',
            url: '/{teamId:[0-9]+}/attributes',
        })
            .state('app.teams.engagement', {
            template: '<team class="component" tab="engagement"></team>',
            title: 'Team Engagement',
            url: '/{teamId:[0-9]+}/engagement',
        })
            .state('app.teams.description', {
            template: '<team class="component" tab="description"></team>',
            title: 'Team',
            url: '/{teamId:[0-9]+}/description',
        })
            .state('app.teams.settings', {
            // TODO Check permission to view this page
            template: '<team-settings class="component"></team-settings>',
            title: 'Team',
            url: '/{teamId:[0-9]+}/settings',
        });
        // APP: TEAM
        $stateProvider
            .state('app.team', {
            abstract: true,
            data: {
                permission: ['VIEW_TEAM'],
                permissionMessage: 'You do not have permission to view the team section.',
            },
            resolve: {
                // @ts-ignore ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
                // @ts-ignore
                dependencies: moduleLoader('app.teams'),
            },
            template: '<ui-view class="state-view team"></ui-view>',
            url: '/team',
        })
            .state('app.team.index', {
            template: '<team class="component" tab="dashboard"></team>',
            title: 'Team',
            url: '',
        });
        // APP: REPORTS
        $stateProvider
            .state('app.reports', {
            abstract: true,
            data: {
                module: 'REPORT',
                moduleMessage: 'You do not have access to view the Reports Module.',
                permission: ['VIEW_REPORTS'],
                permissionMessage: 'You do not have permission to view reports.',
            },
            resolve: {
                // @ts-ignore ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
                // @ts-ignore
                dependencies: moduleLoader('app.reports'),
            },
            template: '<ui-view class="state-view reports"></ui-view>',
            url: '/reports',
        })
            .state('app.reports.index', {
            template: '<reports class="component" tab="people"></reports>',
            title: 'Reports',
            url: '',
        })
            .state('app.reports.people', {
            template: '<reports class="component" tab="people"></reports>',
            title: 'Reports',
            url: '/people',
        })
            .state('app.reports.people-no-team', {
            template: '<no-team-people class="component" tab="people"></no-team-people>',
            title: 'No Team People Report',
            url: '/people/no-team',
        })
            .state('app.reports.people-no-performance-goals', {
            template: '<no-performance-goals-people class="component" tab="people"></no-performance-goals-people>',
            title: 'No Goals People Report',
            url: '/people/no-performance-goals',
        })
            .state('app.reports.people-all', {
            template: '<all-people class="component" tab="people"></all-people>',
            title: 'All People Report',
            url: '/people/all',
        })
            .state('app.reports.people-org-chart', {
            template: '<all-people-org-chart class="component" tab="people"></all-people-org-chart>',
            title: 'Organization Chart',
            url: '/people/org-chart',
        })
            .state('app.reports.evaluation', {
            template: '<reports class="component" tab="evaluation"></reports>',
            title: 'Reports',
            url: '/evaluation',
        })
            .state('app.reports.people-late-eval', {
            template: '<late-eval-people class="component" tab="evaluation"></late-eval-people>',
            title: 'Late Evaluation People Report',
            url: '/evaluation/late-evaluations',
        })
            .state('app.reports.evaluations-all', {
            template: '<all-evaluations class="component" tab="evaluation"></all-evaluations>',
            title: 'Latest Evaluation Report',
            url: '/evaluation/all',
        });
        // APP: DRIVERS
        $stateProvider
            .state('app.drivers', {
            abstract: true,
            // data: {
            // 	module: 'DRIVER',
            // 	permission: true,
            // 	moduleMessage: 'You do not have access to view the Drivers Module.',
            // },
            resolve: {
                // @ts-ignore ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
                // @ts-ignore
                dependencies: moduleLoader('app.drivers', 'app.plans'),
            },
            template: '<ui-view class="state-view drivers"></ui-view>',
            url: '/drivers',
        })
            .state('app.drivers.all', {
            template: '<drivers class="component" tab="all"></drivers>',
            title: 'Drivers',
            url: '/all',
        })
            .state('app.drivers.focused', {
            template: '<drivers class="component" tab="inFocus"></drivers>',
            title: 'Drivers',
            url: '/focused',
        })
            .state('app.drivers.my-drivers', {
            template: '<drivers class="component" tab="myDrivers"></drivers>',
            title: 'Drivers',
            url: '/my-drivers',
        });
        // APP: RESOURCES
        $stateProvider
            .state('app.resources', {
            abstract: true,
            resolve: {
                // @ts-ignore ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
                // @ts-ignore
                dependencies: moduleLoader('app.resources'),
            },
            template: '<ui-view class="state-view resources"></ui-view>',
            url: '/resources',
        })
            .state('app.resources.index', {
            template: '<resources class="component"></resources>',
            title: 'Resources',
            url: '',
        });
        // APP: PLANS
        $stateProvider
            .state('app.plans', {
            abstract: true,
            data: {
                module: 'PLAN',
                moduleMessage: 'You do not have access to view the Plans Module.',
            },
            resolve: {
                // @ts-ignore ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
                // @ts-ignore
                dependencies: moduleLoader('app.plans'),
            },
            template: '<ui-view class="state-view plans"></ui-view>',
            url: '/plans',
        })
            .state('app.plans.index', {
            template: '<plans class="component" tab="overview"></plans>',
            title: 'Plans',
            url: '',
        })
            .state('app.plans.all', {
            template: '<plans class="component" tab="plans"></plans>',
            title: 'Plans',
            url: '/all',
        })
            .state('app.plans.new', {
            data: {
                permission: ['EDIT_PLANS'],
                permissionMessage: 'You do not have permission to create a new plan.',
            },
            template: '<plan-settings class="component" tab="details"></plan-settings>',
            title: 'New Plan Settings',
            url: '/new?{parentId:[0-9]+}',
        })
            .state('app.plans.show', {
            template: '<plan class="component" tab="details"></plan>',
            title: 'Plan',
            url: '/{planId:[0-9]+}',
        })
            .state('app.plans.drivers', {
            template: '<plan class="component" drivers="true" tab="details"></plan>',
            title: 'Plan',
            url: '/{planId:[0-9]+}/drivers/{driverId:[0-9]+}',
        })
            .state('app.plans.show-kpi', {
            template: '<plan class="component" tab="kpi"></plan>',
            title: 'Plan',
            url: '/{planId:[0-9]+}/kpis',
        })
            .state('app.plans.goal-new', {
            template: '<plan class="component" tab="details"></plan>',
            title: 'New Plan Goal',
            url: '/{planId:[0-9]+}/goals/new',
        })
            .state('app.plans.goal', {
            template: '<plan class="component" tab="details"></plan>',
            title: 'Plan Goal',
            url: '/{planId:[0-9]+}/goals/{goalId:[0-9]+}',
        })
            .state('app.plans.goal-settings', {
            template: '<plan class="component" tab="details"></plan>',
            title: 'Plan Goal',
            url: '/{planId:[0-9]+}/goals/{goalId:[0-9]+}/settings',
        })
            .state('app.plans.goal-details', {
            template: '<plan class="component" tab="details"></plan>',
            title: 'Plan Goal',
            url: '/{planId:[0-9]+}/goals/{goalId:[0-9]+}/{tab:[-_a-z]+}',
        })
            .state('app.plans.outcomes', {
            template: '<plan class="component" tab="outcomes"></plan>',
            title: 'Plan Outcomes',
            url: '/{planId:[0-9]+}/outcomes',
        })
            .state('app.plans.strategy', {
            template: '<plan class="component" tab="strategy"></plan>',
            title: 'Plan Strategy',
            url: '/{planId:[0-9]+}/strategy',
        })
            .state('app.plans.description', {
            template: '<plan class="component" tab="description"></plan>',
            title: 'Plan Description',
            url: '/{planId:[0-9]+}/description',
        })
            .state('app.plans.mos', {
            template: '<plan class="component" tab="mos"></plan>',
            title: 'Plan MOS',
            url: '/{planId:[0-9]+}/mos',
        })
            .state('app.plans.meetings', {
            resolve: {
                optional: optionalModuleLoader('MEETINGS', 'meetings'),
            },
            template: '<plan class="component" tab="meetings"></plan>',
            title: 'Plan Meetings',
            url: '/{planId:[0-9]+}/meetings',
        })
            .state('app.plans.actions', {
            template: '<plan class="component" tab="actions"></plan>',
            title: 'Plan Actions',
            url: '/{planId:[0-9]+}/actions'
        })
            .state('app.plans.settings', {
            data: {
                permission: ['EDIT_PLANS'],
                permissionMessage: 'You do not have permission to edit a plan.',
            },
            template: '<plan-settings class="component"></plan-settings>',
            title: 'Plan Settings',
            url: '/{planId:[0-9]+}/settings',
        });
        // APP: PLANS > KPIS
        $stateProvider
            .state('app.plans.kpi', {
            abstract: true,
            resolve: {
                // @ts-ignore ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
                // @ts-ignore
                dependencies: moduleLoader('app.plans.kpi'),
            },
            template: '<ui-view class="state-view kpis"></ui-view>',
            url: '/{planId:[0-9]+}/kpi',
        })
            .state('app.plans.kpi.new', {
            template: '<kpi-settings class="component" tab="data"></kpi-settings>',
            title: 'New Key Performance Indicator | Plans',
            url: '/new',
        })
            .state('app.plans.kpi.show', {
            template: '<kpi class="component" tab="data"></kpi>',
            title: 'Key Performance Indicator | Plans',
            url: '/{kpiId:[0-9]+}',
        })
            .state('app.plans.kpi.settings', {
            template: '<kpi-settings class="component"></kpi-settings>',
            title: 'Settings | Key Performance Indicator | Plans',
            url: '/{kpiId:[0-9]+}/settings',
        });
        // ADMIN
        $stateProvider
            .state('admin', {
            abstract: true,
            controller: 'RouteController',
            resolve: {
                // @ts-ignore ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
                // @ts-ignore
                dependencies: moduleLoader('admin'),
                clientSettings: getConfig(),
            },
            template: '<layout-header></layout-header><div class="content-container"><ui-view class="state-view admin"></ui-view><error-screen></error-screen></div>',
            url: '/admin',
        })
            .state('admin.index', {
            template: '<admin class="state-view"></admin>',
            title: 'ETW Admin',
            url: '',
        })
            .state('admin.hermes', {
            abstract: true,
            template: '<ui-view class="state-view"></ui-view>',
            title: 'Home | Admin',
            url: '/home',
        })
            .state('admin.hermes.index', {
            template: '<hermes class="state-view"></hermes>',
            title: 'Home | Admin',
            url: '',
        })
            .state('admin.settings', {
            parent: 'admin.hermes',
            abstract: true,
            resolve: {
                // @ts-ignore ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
                // @ts-ignore
                dependencies: moduleLoader('admin.settings'),
            },
            template: '<ui-view></ui-view>',
            title: 'Settings | Home | Admin',
            url: '/settings',
        })
            .state('admin.settings.index', {
            template: '<admin-home-settings class="state-view" tab="modules"></admin-home-settings>',
            title: 'Settings | Home | Admin',
            url: '',
        })
            .state('admin.settings.components', {
            template: '<admin-home-settings class="state-view" tab="components"></admin-home-settings>',
            title: 'Components | Settings | Home | Admin',
            url: '/settings/components',
        })
            .state('admin.settings.general', {
            template: '<admin-home-settings class="state-view" tab="general"></admin-home-settings>',
            title: 'General | Settings | Home | Admin',
            url: '/settings/general',
        })
            .state('admin.settings.ui', {
            template: '<admin-home-settings class="state-view" tab="ui"></admin-home-settings>',
            title: 'General | Settings | Home | Admin',
            url: '/settings/ui',
        });
        // ADMIN: ATTRIBUTES
        $stateProvider
            .state('admin.attributes', {
            parent: 'admin.hermes',
            abstract: true,
            data: {
                permission: ['VIEW_ADMIN_ATTRIBUTES'],
                permissionMessage: 'You do not have permission to view attributes.',
            },
            resolve: {
                // @ts-ignore ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
                // @ts-ignore
                dependencies: moduleLoader('admin.attributes'),
            },
            template: '<ui-view class="state-view"></ui-view>',
            url: '/attributes',
        })
            .state('admin.attributes.index', {
            template: '<admin-attributes class="state-view"></admin-attributes>',
            title: 'Attributes | Admin',
            url: '',
        })
            .state('admin.attributes.new', {
            data: {
                permission: ['VIEW_ADMIN_ATTRIBUTES', 'EDIT_ADMIN_ATTRIBUTES'],
                permissionMessage: 'You do not have permission to edit attributes.',
            },
            template: '<admin-attribute class="state-view"></admin-attribute>',
            title: 'Values | Attributes | Admin',
            url: '/new',
        })
            .state('admin.attributes.show', {
            data: {
                permission: ['VIEW_ADMIN_ATTRIBUTES'],
                permissionMessage: 'You do not have permission to view attributes.',
            },
            template: '<admin-attribute class="state-view"></admin-attribute>',
            title: 'Values | Attributes | Admin',
            url: '/{attrId:[0-9]+}',
        })
            .state('admin.attributes.new-settings', {
            data: {
                permission: ['VIEW_ADMIN_ATTRIBUTES', 'EDIT_ADMIN_ATTRIBUTES'],
                permissionMessage: 'You do not have permission to edit attributes.',
            },
            template: '<admin-attribute-settings class="state-view"></admin-attribute-settings>',
            title: 'Settings | Attributes | Admin',
            url: '/new/settings',
        })
            .state('admin.attributes.settings', {
            data: {
                permission: ['VIEW_ADMIN_ATTRIBUTES', 'EDIT_ADMIN_ATTRIBUTES'],
                permissionMessage: 'You do not have permission to edit attributes.',
            },
            template: '<admin-attribute-settings class="state-view"></admin-attribute-settings>',
            title: 'Settings | Attributes | Admin',
            url: '/{attrId:[0-9]+}/settings',
        });
        // ADMIN: GOALS
        $stateProvider
            // Goal Groups
            .state('admin.goal-groups', {
            abstract: true,
            parent: 'admin.hermes',
            data: {
                permission: ['VIEW_ADMIN_GOALS'],
                permissionMessage: 'You do not have permission to view goals.',
            },
            resolve: {
                // @ts-ignore ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
                // @ts-ignore
                dependencies: moduleLoader('admin.goal-groups'),
            },
            template: '<ui-view class="state-view admin-goal-groups"></ui-view>',
            url: '/goal-groups',
        })
            .state('admin.goal-groups.index', {
            template: '<admin-goal-groups class="component"></admin-goal-groups>',
            title: 'Goals | Admin',
            url: '',
        })
            .state('admin.goal-groups.new', {
            data: {
                permission: ['VIEW_ADMIN_GOALS', 'EDIT_ADMIN_GOALS'],
                permissionMessage: 'You do not have permission to edit goals.',
            },
            template: '<admin-goal-group class="component"></admin-goal-group>',
            url: '/new',
        })
            .state('admin.goal-groups.new-goal', {
            // New Group *and* new Goal
            data: {
                permission: ['VIEW_ADMIN_GOALS', 'EDIT_ADMIN_GOALS'],
                permissionMessage: 'You do not have permission to edit goals.',
            },
            template: '<admin-goal-group class="component"></admin-goal-group>',
            url: '/new/goals/new',
        })
            .state('admin.goal-groups.show', {
            template: '<admin-goal-group class="component"></admin-goal-group>',
            url: '/{groupId:[0-9]+}',
        })
            // Goals
            .state('admin.goal-groups.goals', {
            abstract: true,
            template: '<admin-goal-group class="component"></admin-goal-group>',
            url: '/{groupId:[0-9]+}/goals',
        })
            .state('admin.goal-groups.goals.index', {
            url: '',
        })
            .state('admin.goal-groups.goals.new', {
            url: '/new',
        })
            .state('admin.goal-groups.goals.show', {
            url: '/{goalType:[a-z_]+}/{goalId:[0-9]+}',
        });
        // ADMIN: PERMISSIONS
        $stateProvider
            .state('admin.permissions', {
            abstract: true,
            parent: 'admin.hermes',
            data: {
                permission: ['VIEW_ADMIN_PERMISSIONS'],
                permissionMessage: 'You do not have permission to view permissions.',
            },
            resolve: {
                // @ts-ignore ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
                // @ts-ignore
                dependencies: moduleLoader('admin.permissions'),
            },
            template: '<ui-view class="state-view"></ui-view>',
            url: '/permissions',
        })
            .state('admin.permissions.index', {
            template: '<admin-permission-groups class="state-view"></admin-permission-groups>',
            title: 'Permissions | Admin',
            url: '',
        })
            .state('admin.permissions.new', {
            data: {
                permission: ['VIEW_ADMIN_PERMISSIONS', 'EDIT_ADMIN_PERMISSIONS'],
                permissionMessage: 'You do not have permission to edit permissions.',
            },
            template: '<admin-permission-group class="state-view"></admin-permission-group>',
            title: 'Permissions | New Permissions Group | Admin',
            url: '/new',
        })
            .state('admin.permissions.edit', {
            template: '<admin-permission-group class="state-view"></admin-permission-group>',
            title: 'Permissions | Edit Permission Group | Admin',
            url: '/:permId',
        });
        // ADMIN: PEOPLE
        $stateProvider
            .state('admin.people', {
            abstract: true,
            data: {
                permission: ['VIEW_ADMIN_PEOPLE'],
                permissionMessage: 'You do not have permission to view people.',
            },
            resolve: {
                // @ts-ignore ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
                // @ts-ignore
                dependencies: moduleLoader('admin.people'),
            },
            template: '<ui-view class="state-view admin-people"></ui-view>',
            url: '/people',
        })
            .state('admin.people.index', {
            template: '<admin-people class="component"></admin-people>',
            title: 'People | Admin',
            url: peopleSearchUrlPattern,
        })
            .state('admin.people.new', {
            data: {
                permission: ['VIEW_ADMIN_PEOPLE', 'EDIT_ADMIN_PEOPLE'],
                permissionMessage: 'You do not have permission to edit people.',
            },
            template: '<admin-person class="component"></admin-person>',
            title: 'People | New Person | Admin',
            url: '/new',
        })
            .state('admin.people.edit', {
            data: {
                permission: ['VIEW_ADMIN_PEOPLE', 'EDIT_ADMIN_PEOPLE'],
                permissionMessage: 'You do not have permission to edit people.',
            },
            template: '<admin-person class="component"></admin-person>',
            title: 'People | Edit Person | Admin',
            url: '/{personId:[0-9]+}',
        });
        // ADMIN: ROLES
        $stateProvider
            .state('admin.roles', {
            abstract: true,
            parent: 'admin.hermes',
            data: {
                permission: ['VIEW_ADMIN_ROLES'],
                permissionMessage: 'You do not have permission to view roles.',
            },
            resolve: {
                // @ts-ignore ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
                // @ts-ignore
                dependencies: moduleLoader('admin.roles'),
            },
            template: '<ui-view class="state-view admin-roles"></ui-view>',
            url: '/roles',
        })
            .state('admin.roles.index', {
            template: '<admin-roles class="component"></admin-roles>',
            title: 'Roles | Admin',
            url: '?{goalGroupId:[0-9]+}?{permissionGroupId:[0-9]+}',
        })
            .state('admin.roles.new', {
            data: {
                permission: ['VIEW_ADMIN_ROLES', 'EDIT_ADMIN_ROLES'],
                permissionMessage: 'You do not have permission to edit roles.',
            },
            template: '<admin-role class="component"></admin-role>',
            title: 'Roles | New Role | Admin',
            url: '/new',
        })
            .state('admin.roles.new-settings', {
            data: {
                permission: ['VIEW_ADMIN_ROLES', 'EDIT_ADMIN_ROLES'],
                permissionMessage: 'You do not have permission to edit roles.',
            },
            template: '<admin-role-settings class="state-view"></admin-role-settings>',
            title: 'Settings | Roles | Admin',
            url: '/new/settings',
        })
            .state('admin.roles.edit', {
            data: {
                permission: ['VIEW_ADMIN_ROLES', 'EDIT_ADMIN_ROLES'],
                permissionMessage: 'You do not have permission to edit roles.',
            },
            template: '<admin-role class="component"></admin-role>',
            title: 'Roles | Edit Role',
            url: '/{roleId:[0-9]+}',
        })
            .state('admin.roles.settings', {
            data: {
                permission: ['VIEW_ADMIN_ROLES', 'EDIT_ADMIN_ROLES'],
                permissionMessage: 'You do not have permission to edit roles.',
            },
            template: '<admin-role-settings class="state-view"></admin-role-settings>',
            title: 'Settings | Roles | Admin',
            url: '/{roleId:[0-9]+}/settings',
        })
            .state('admin.roles.actionitems', {
            template: '<admin-role class="component" tab="actionitems"></admin-role>',
            title: 'Roles | Admin',
            url: '/{roleId:[0-9]+}/action-items',
        });
        // ADMIN: Resources
        $stateProvider
            .state('admin.resources', {
            abstract: true,
            parent: 'admin.hermes',
            resolve: {
                // @ts-ignore ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
                // @ts-ignore
                dependencies: moduleLoader('admin.resources'),
            },
            template: '<ui-view class="state-view admin.resources"></ui-view>',
            url: '/admin-resources',
        })
            .state('admin.resources.index', {
            template: '<admin-resources class="component"></admin-resources>',
            title: 'Resources | Admin',
            url: '',
        });
        // ADMIN: Responsibilities
        $stateProvider
            .state('admin.responsibilities', {
            abstract: true,
            parent: 'admin.hermes',
            data: {
                permission: ['VIEW_ADMIN_ROLES'],
                permissionMessage: 'You do not have permission to view responsibilities page.',
            },
            resolve: {
                // @ts-ignore ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
                // @ts-ignore
                dependencies: moduleLoader('admin.responsibilities'),
            },
            template: '<ui-view class="state-view admin.responsibilities"></ui-view>',
            url: '/responsibilities',
        })
            .state('admin.responsibilities.index', {
            template: '<admin-responsibilities class="component"></admin-responsibilities>',
            title: 'Responsibilities | Admin',
            url: '',
        })
            .state('admin.responsibilities.new', {
            data: {
                permission: ['VIEW_ADMIN_ROLES', 'EDIT_ADMIN_ROLES'],
                permissionMessage: 'You do not have permission to edit responsibilities.',
            },
            template: '<admin-responsibility class="component"></admin-responsibility>',
            title: 'Responsibilities | New Responsibility | Admin',
            url: '/new',
        });
        // ADMIN: Meeting Template
        $stateProvider
            .state('admin.meeting-templates', {
            abstract: true,
            parent: 'admin.hermes',
            data: {
                permission: ['VIEW_ADMIN_MEETING_TEMPLATE'],
                permissionMessage: 'You do not have permission to view meeting templates page.',
            },
            resolve: {
                // @ts-ignore ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
                // @ts-ignore
                dependencies: moduleLoader('admin.meeting-templates'),
            },
            template: '<ui-view class="state-view admin.meeting-templates"></ui-view>',
            url: '/meeting-templates',
        })
            .state('admin.meeting-templates.index', {
            template: '<admin-meeting-templates class="component"></admin-meeting-templates>',
            title: 'Meeting Template | Admin',
            url: '',
        })
            .state('admin.meeting-templates.new', {
            data: {
                permission: ['VIEW_ADMIN_MEETING_TEMPLATE', 'EDIT_ADMIN_MEETING_TEMPLATE'],
                permissionMessage: 'You do not have permission to edit meeting templates.',
            },
            template: '<admin-meeting-template class="component"></admin-meeting-template>',
            url: '/new',
        })
            .state('admin.meeting-templates.show', {
            data: {
                permission: ['VIEW_ADMIN_MEETING_TEMPLATE', 'EDIT_ADMIN_MEETING_TEMPLATE'],
                permissionMessage: 'You do not have permission to edit meeting templates.',
            },
            template: '<admin-meeting-template class="component"></admin-meeting-template>',
            url: '/{mTemplateId:[0-9]+}',
        })
            .state('admin.meeting-templates.settings', {
            data: {
                permission: ['VIEW_ADMIN_MEETING_TEMPLATE', 'EDIT_ADMIN_MEETING_TEMPLATE'],
                permissionMessage: 'You do not have permission to edit meeting templates.',
            },
            template: '<admin-meeting-template-settings class="state-view"></admin-meeting-template-settings>',
            title: 'Settings | Meeting Templates | Admin',
            url: '/{mTemplateId:[0-9]+}/settings',
        });
        //// JANUS ADMIN ////
        $stateProvider
            .state('admin.janus', {
            abstract: true,
            resolve: {
                // @ts-ignore ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
                // @ts-ignore
                dependencies: moduleLoader('admin.janus'),
            },
            template: '<ui-view class="state-view"></ui-view>',
            url: '/janus',
        })
            .state('admin.janus.index', {
            template: '<hermes class="state-view" tab="drive"></hermes>',
            title: 'Home | Janus | Admin',
            url: '',
        });
        // JANUS ADMIN: LEVELS
        $stateProvider
            .state('admin.janus.levels', {
            abstract: true,
            resolve: {
                // @ts-ignore ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
                // @ts-ignore
                dependencies: moduleLoader('admin.janus.levels'),
            },
            template: '<ui-view class="state-view"></ui-view>',
        })
            .state('admin.janus.levels.leadership', {
            abstract: true,
            template: '<ui-view class="state-view"></ui-view>',
            url: '/leadership-levels',
        })
            .state('admin.janus.levels.leadership.index', {
            template: '<leadership-levels class="component"></leadership-levels>',
            url: '',
        })
            .state('admin.janus.levels.leadership.new', {
            template: '<leadership-level class="component"></leadership-level>',
            title: 'Leadership Levels | New Level | Admin',
            url: '/new',
        })
            .state('admin.janus.levels.leadership.edit', {
            template: '<leadership-level class="component"></leadership-level>',
            title: 'Leadership Levels | Edit Level',
            url: '/{levelId:[0-9]+}',
        });
        // JANUS ADMIN: COMPETENCIES
        $stateProvider
            .state('admin.janus.competencies', {
            abstract: true,
            resolve: {
                // @ts-ignore ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
                // @ts-ignore
                dependencies: moduleLoader('admin.janus.competencies'),
            },
            template: '<ui-view class="state-view"></ui-view>',
            url: '/competencies',
        })
            .state('admin.janus.competencies.index', {
            template: '<competencies class="state-view"></competencies>',
            url: '',
        })
            .state('admin.janus.competencies.new', {
            template: '<competency class="component"></competency>',
            title: 'Competencies | New Competency | Admin',
            url: '/new',
        })
            .state('admin.janus.competencies.edit', {
            template: '<competency class="component"></competency>',
            title: 'Competencies | Edit Competency',
            url: '/{competencyId:[0-9]+}',
        });
    }
    /**
     * @function moduleLoader
     * @param {...*} {string} - module name(s)
     * @returns {Array}
     * @private
     * Lazy loads a module declared with $ocLazyLoadProvider. Used with state resolve.
     * Modules will load in series in the order you specify.
     * If a particular module declares the ``serie`` attribute, the files in that
     *   module will load in the order specified.
     *
     * To load a module:
     * 	moduleLoader('moduleOne');
     *
     * To load multiple modules in series:
     * 	moduleLoader('moduleOne', 'moduleTwo');
     *
     * To load multiple modules in parallel:
     * 	moduleLoader(['moduleOne', 'moduleTwo']);
     */
    function moduleLoader() {
        var modules = Array.prototype.slice.call(arguments);
        return [
            '$ocLazyLoad',
            // @ts-ignore ts-migrate(7006) FIXME: Parameter '$ocLazyLoad' implicitly has an 'any' ty... Remove this comment to see the full error message
            function ($ocLazyLoad) {
                return $ocLazyLoad.load(modules);
            },
        ];
    }
    /**
     * @function optionalModuleLoader
     * @param feature {string}
     * @param lazyLoadConfigName {string}
     * @returns {object} - promise if there is something to load. Otherwise true.
     * Used to download optional modules for features a client might not have turned on.
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'feature' implicitly has an 'any' type.
    // @ts-ignore
    function optionalModuleLoader(feature, lazyLoadConfigName) {
        return [
            '$ocLazyLoad',
            'AuthenticationService',
            // @ts-ignore ts-migrate(7006) FIXME: Parameter '$ocLazyLoad' implicitly has an 'any' ty... Remove this comment to see the full error message
            // @ts-ignore
            function ($ocLazyLoad, AuthenticationService) {
                if (AuthenticationService.hasModule(feature)) {
                    return $ocLazyLoad.load(lazyLoadConfigName);
                }
                else {
                    return true;
                }
            },
        ];
    }
    /**
     * @function getConfig()
     * @private
     * Make the app wait until settings are loaded.
     * Full settings are the Account settings + jwt.
     * This runs after the AngularJS run phase and before any controllers run.
     * A run block in app.js subscribes to AccountSettings changes.
     */
    function getConfig() {
        return [
            '$q',
            'AccountSettingsService',
            'AuthenticationService',
            'CLIENT_SETTINGS',
            // @ts-ignore ts-migrate(7006) FIXME: Parameter '$q' implicitly has an 'any' type.
            function ($q, AccountSettingsService, AuthenticationService) {
                return $q.all([AuthenticationService.init(), AccountSettingsService.get()]);
            },
        ];
    }
})();

(function () {
    angular
        .module('App.Routes')
        .controller('RouteController', [
        '$rootScope',
        '$scope',
        '$state',
        '$window',
        'AuthenticationService',
        RouteController,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$rootScope' implicitly has an 'any' typ... Remove this comment to see the full error message
    function RouteController($rootScope, $scope, $state, $window, AuthenticationService) {
        /**
         * @property from
         * @type {Object}
         */
        var from;
        /**
         * This could alternately be handled by the 'permission' directive on the components in the routes.
         */
        // When user doesn't have access to admin
        if ($state.current.name.indexOf('admin') === 0 &&
            !AuthenticationService.hasPermission('VIEW_ADMIN')) {
            $state.go('app.index').finally(function () {
                try {
                    $rootScope.$emit('notify', 'You do not have permission to access the Administration area.', 'error');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        else {
            // Permission based fallback routes for Admin
            // Fallback in this order:
            //  1. Hermes
            //  2. Janus
            //  3. People
            var hermesPermission = AuthenticationService.hasScope('hermes'), janusPermission = AuthenticationService.hasScope('janus'), urlHas = _.partial(_.includes, $state.current.name);
            var shouldRedirect = (function () {
                if (urlHas('hermes') && !hermesPermission)
                    return true;
                if (urlHas('janus') && !janusPermission)
                    return true;
                return false;
            })();
            var firstAvailableUrl = (function () {
                if (hermesPermission)
                    return 'admin.hermes.index';
                if (janusPermission)
                    return 'admin.janus.index';
                return 'admin.people.index';
            })();
            if (shouldRedirect) {
                $state.go(firstAvailableUrl);
            }
        }
        // When there is a state change error (see app.js)
        if ($state.params.from) {
            from = AuthenticationService.decodeReferrer($state.params.from);
            if (from.path) {
                $scope.from = from.path;
            }
        }
    }
})();

(function () {
    angular
        .module('App.Routes')
        .controller('SSOController', ['$cookies', 'AuthenticationService', SSOController]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$cookies' implicitly has an 'any' type.
    function SSOController($cookies, AuthenticationService) {
        //The backend on an sso saml redirect will set two cookies - auth & refresh tokens
        var ssoAuthToken = $cookies.get('SSOAuthorization');
        var ssoRefreshToken = $cookies.get('SSORefresh');
        console.log("In SSO controller");
        //now that we have the tokens we need to also delete the cookies
        $cookies.remove('SSOAuthorization', { path: '/', domain: 'etw.com' });
        $cookies.remove('SSORefresh', { path: '/', domain: 'etw.com' });
        //now that we have the tokens we need to perform an sso authentication
        AuthenticationService.authenticateSSO(ssoAuthToken, ssoRefreshToken);
    }
})();

// use strict set in app.js
(function () {
    angular.module('App.Util', ['App', 'ETWServices', 'ngNumeraljs']);
})();

(function () {
    angular.module('App.Util').directive('accessGroup', ['TEMPLATE_PATH', AccessGroupDirective]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TEMPLATE_PATH' implicitly has an 'any' ... Remove this comment to see the full error message
    function AccessGroupDirective(TEMPLATE_PATH) {
        var DirectiveDefinitionGroup = {
            restrict: 'E',
            scope: {
                people: '=',
                onOpen: '&',
                hideAdd: '=',
                iconClass: '@?',
            },
            templateUrl: TEMPLATE_PATH + '/util/access-group/access-group.html',
            transclude: true,
        };
        return DirectiveDefinitionGroup;
    }
})();

(function () {
    angular
        .module('App.Util')
        .controller('AccessModalController', [
        '$rootScope',
        '$scope',
        '$state',
        '$uibModalInstance',
        'AuthenticationService',
        'CLIENT_SETTINGS',
        'PeopleService',
        'RolesService',
        'ActionItemsService',
        AccessModalController,
    ]);
    function AccessModalController($rootScope, $scope, $state, $uibModalInstance, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$rootScope' implicitly has an 'any' typ... Remove this comment to see the full error message
    AuthenticationService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$uibModalInstance' implicitly has an 'a... Remove this comment to see the full error message
    CLIENT_SETTINGS, 
    // @ts-ignore ts-migrate(7006)
    PeopleService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AuthenticationService' implicitly has a... Remove this comment to see the full error message
    RolesService, 
    // @ts-ignore
    ActionItemsService) {
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'PeopleService' implicitly has an 'any' ... Remove this comment to see the full error message
         * @property addedAccessPeople
         * @type {Array}
         */
        var addedAccessPeople = [];
        /**
         * @property queryParams
// @ts-ignore ts-migrate(7034) FIXME: Variable 'addedAccessPeople' implicitly has type '... Remove this comment to see the full error message
         * @type {object}
         * @private
         * Array of names of properties that can be passed to the People API.
         */
        var queryParams = {};
        /**
         * @property sortParams
         * @type {object}
         * Parameters that are sent to the API to change the sortBy column and direction.
         * Note: Kept separate here, but combined with queryParams and paginationParams in PeopleService.
         */
        var sortParams = {};
        /**
         * @listener $stateChangeStart
         * If the user navigates away, close the modal.
         * Initially implemented for when the user interacts with the avatar flyout menu.
         */
        var stateChangeListener = $rootScope.$on('$stateChangeStart', function () {
            $uibModalInstance.dismiss();
        });
        /**
         * @listener $destroy
         * When the controller is destroyed, unregister the $stateChangeStart listener.
         * $onDestroy doesn't work here.
         */
        $scope.$on('$destroy', stateChangeListener);
        /**
         * @property subnav
         * @type {object}
         * Subnav config for Goals.
         */
        var subnav = {
            owners: {
                title: ($scope.tabs && $scope.tabs.owners) || 'Assignees',
            },
            participants: {
                title: 'Participants',
            },
        };
        var vm = this;
        /**
         * @listener $onInit
         */
        vm.$onInit = init;
        /**
         * @property assignments
         * @type {Array}
         */
        vm.assignments = $scope.assignments || [];
        /**
         * @property assignedPersonId
         * @type {string}
         * Used by radio buttons when only one person can be assigned at a time.
         * Cf. maximumPeople.
// @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
         * Note: Template does a string comparison.
         */
        vm.assignedPersonId = undefined;
        /**
         * @property attributes
         * @type {Array}
         * list of attributes with attribute values
         */
        vm.attributes = $scope.attributes || [];
        /**
         * @property attributesQuery
         * @type {string}
         * attribute values search query
         */
        vm.attributesQuery = '';
        /**
         * @property blacklist
         * @type {Array}
         * list of user ids
         */
        vm.blacklist = $scope.blacklist || [];
        vm.closeOnSelect = $scope.closeOnSelect;
        /**
         * @property columnHeader
         * @type {string}
         * used for title in table header
         */
        vm.columnHeader = null;
        /**
         * @property filters
         * @type {object}
         * Aggregate of all filters used on the list of people.
         */
        vm.filters = $scope.initialFilters || {};
        /**
         * @property actionItem
         * @type {object}
         * Needed in the modal to duplicate action items
         */
        vm.actionItem = $scope.actionItem || null;
        vm.fn = {
            addAllPeople: addAllPeople,
            addAttributeValue: addAttributeValue,
            addPerson: addPerson,
            addRole: addRole,
            onClearAttributeFilters: onClearAttributeFilters,
            filterAttributeValues: filterAttributeValues,
            filterRoles: filterRoles,
            filterPeople: filterPeople,
            filterPeopleBy: filterPeopleBy,
            isPersonAssignable: isPersonAssignable,
            isPersonRemovable: isPersonRemovable,
            ok: ok,
            onChangeTab: onChangeTab,
            onSelectPrimaryPerson: onSelectPrimaryPerson,
            onSelectPerson: onSelectPerson,
            getSelectorClass: getSelectorClass,
            removeAttributeValue: removeAttributeValue,
            removeRole: removeRole,
            removePeople: removePeople,
            removePerson: removePerson,
            updateAssignment: updateAssignment,
            duplicateAction: duplicateAction,
        };
        /**
         * @property hasPeopleColumn
         * @type {boolean}
         */
        vm.hasPeopleColumn = false;
        /**
         * @property hasPrimaryPerson
         * @type {boolean}
         * From passed scope
         */
        vm.hasPrimaryPerson = Boolean($scope.hasPrimaryPerson);
        /**
         * @property hasReceiveCommunications
         * @type {boolean}
         */
        vm.hasReceiveCommunications = Boolean($scope.hasReceiveCommunications);
        /**
         * @property hasAddRemove
         * @type {boolean}
         */
        vm.hasAddRemove = Boolean($scope.hasAddRemove);
        /**
         * @property immutablePeopleIds
         * @type {Array}
         */
        vm.immutablePeopleIds =
            $scope.immutablePeopleIds instanceof Array ? $scope.immutablePeopleIds : [];
        /**
         * @property isEditTabView
         * @type {boolean}
         */
        vm.isEditTabView = $scope.isEditTabView;
        /**
         * @property isReadOnly
         * @type {boolean}
         */
        vm.isReadOnly = $scope.isReadOnly;
        /**
         * @property isRequired
         * @type {boolean}
         * Default false.
         * Won't allow the last person to be deleted.
         */
        vm.isRequired = !!$scope.isRequired;
        /**
         * @property isSubordinatesOnly
         * @type {boolean}
         * Default false.
         * Determines if people search should be restricted to subordinates only.
         */
        vm.isSubordinatesOnly = !!$scope.isSubordinatesOnly;
        /**
         * @property maximumPeople
         * @type {number}
         */
        vm.maximumPeople = $scope.maximumPeople || 0;
        /**
         * @property peopleListView
         * @type {boolean}
         */
        vm.peopleListView = true;
        /**
         * @property primaryPersonLabel
         * @type {string}
         */
        vm.primaryPersonLabel = '';
        /**
         * @property parentPlanAccess
         * @type {object}
         */
        vm.parentPlanAccess = $scope.parentPlanAccess;
        /**
         * @property people
         * @type {Array}
         */
        vm.people = [];
        /**
         * @property planId
         * @type {number}
         */
        vm.planId = $state.params.planId;
        /**
         * @property primaryPersonId
         * @type {string}
         * Needs to be a string because it is tied to a radio button which only handles strings.
         */
        vm.primaryPersonId = String($scope.primaryPersonId || -1);
        /**
         * @property rolesQuery
         * @type {string}
         * roles search query
         */
        vm.rolesQuery = '';
        /**
         * @property selectedAttributes
         * @type {array}
         * array of selected attributes
         */
        vm.selectedAttributes = $scope.initialAttribute || [];
        vm.showAttributes = true;
        vm.showCommunications = true;
        /**
         * @property subNav
         * @type {object}
         * Configuration for the tabbed navigation directive... groups and people.
         * Will be set differently depending on the access type of goals or plans.
         */
        vm.subNav = {};
        /**
         * @property tab
         * @type {string}
         * Default tab
         */
        vm.tab = 'owners';
        /**
         * @property title
         */
        vm.title = $scope.title;
        /**
         * @property columnHeaderPrefix
         */
        vm.columnHeaderPrefix = $scope.columnHeaderPrefix;
        /**
         * @property userId
         * @type {Number}
         */
        vm.userId = AuthenticationService.getAccount().userId;
        /**
         * @property viewNotesIds
         * @type {Array}
         */
        vm.viewNotesIds = $scope.viewNotesIds;
        /**
         * @method addAllPeople
         * Adds all people
         */
        function addAllPeople() {
            //clears the added access list
            var peopleToAdd = _.reject(vm.people, { _isAdded: true });
            if ($scope.addAllPeople && peopleToAdd.length > 0) {
                $scope.addAllPeople(peopleToAdd);
            }
            //filter out people already added
            _.forEach(vm.people, function (person) {
                //add person that's not already on the list
                if (person._isSubscribed == undefined) {
                    person._isSubscribed = true;
                }
                if (!person._isAdded) {
                    person._isAdded = true;
                    //updates settings
                    addedAccessPeople.push(person);
                }
            });
        }
        /**
         * @function addAttributeValue
         * @parama selectedAttributeValue {object}
         */
        function addAttributeValue(selectedAttributeValue) {
            selectedAttributeValue._isAdded = true;
            $scope.addAttributeValue(selectedAttributeValue);
        }
        /**
         * @function addRole
         * @parama selectedRole {object}
         */
        function addRole(selectedRole) {
            selectedRole._isAdded = true;
            $scope.addRole(selectedRole);
        }
        /**
         * @function init
         */
        function init() {
            vm.showAttributes = CLIENT_SETTINGS.enableUIAccessAttributes;
            vm.showCommunications = CLIENT_SETTINGS.enableUIAccessCommunications;
            setPeople();
            setSubNav();
            if (vm.isEditTabView) {
                setAttributes();
                setRoles();
            }
            initializeHeaders();
        }
        /**
         * @function initializeHeaders
         * @private
         */
        function initializeHeaders() {
            var ownerOrAssignee = 'Primary';
            // TODO: pass in labels instead of all the is*View variables
            vm.columnHeader = vm.title;
            if ($scope.primaryPersonLabel) {
                ownerOrAssignee = $scope.primaryPersonLabel;
            }
            else if ($scope.isPlanView) {
                vm.columnHeader = 'Owners';
            }
            else if ($scope.isGoalView) {
                vm.columnHeader = 'Assignees';
            }
            else if ($scope.isKpiView) {
                vm.columnHeader = 'Assignees';
                ownerOrAssignee = 'Primary Assignee';
            }
            vm.primaryPersonLabel = ownerOrAssignee;
        }
        /**
         * @method isPersonRemovable
         * @param person {object}
         * @returns {boolean}
         * Returns true if the given person can be unassigned.
         * > When maximumPeople is 1, users can only be replaced, not removed
         * > When there has to be a primary person, that person cannot be removed
         * > If assignees are required, the last one cannot be removed
         * > If the person is listed in immutablePeopleIds, they cannot be removed
         * Template never shows the trash icon next to people that are not removable.
         */
        function isPersonRemovable(person) {
            return (vm.maximumPeople !== 1 &&
                (!vm.hasPrimaryPerson || vm.primaryPersonId != person.id) &&
                (!vm.isRequired || vm.people.length > 1) &&
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'selectedAttributeValue' implicitly has ... Remove this comment to see the full error message
                (!vm.immutablePeopleIds.length || vm.immutablePeopleIds.indexOf(person.id) === -1));
        }
        /**
         * @method isPersonAssignable
         * @param {object} person
         * @returns {boolean}
         * Helper method for determining if the Assignable radio button should
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'selectedRole' implicitly has an 'any' t... Remove this comment to see the full error message
         * show up.  Action items is starting to be a special case where we want
         * to let people assign them to anybody they have access to retrieve.
         * This may lead to users being presented links to things they don't have
         * access to, but we can spot check those as they happen. Removing
         * restrictions.
         */
        function isPersonAssignable(person) {
            if ($scope.isActionItemAssignment) {
                return true;
            }
            return !vm.isReadOnly && (person._isAdded || !vm.fn.isPersonRemovable(person));
        }
        /**
         * @method filterAttributeValues
         */
        function filterAttributeValues() {
            var filteredAttributeValues = [], selectedAttributes = _.map(vm.selectedAttributes, 'id'), isQueryEmpty = vm.attributesQuery == '', isAttributeFilterEmpty = _.isEmpty(vm.selectedAttributes);
            //get filter attribute values by selected attributes
            _.forEach(vm.suggestedAttributeValues, function (attributeValue) {
                if (_.includes(selectedAttributes, attributeValue.attributeId)) {
                    filteredAttributeValues.push(attributeValue);
                }
            });
            //both filter and query
            if (!isAttributeFilterEmpty || !isQueryEmpty) {
                if (isAttributeFilterEmpty && !isQueryEmpty) {
                    vm.filteredAttributeValues = vm.suggestedAttributeValues;
                }
                else {
                    vm.filteredAttributeValues = filteredAttributeValues;
                }
                //both filter and query are empty
            }
            else if (isAttributeFilterEmpty && isQueryEmpty) {
                vm.filteredAttributeValues = _.filter(vm.suggestedAttributeValues, {
                    _isAdded: true,
                });
            }
            else {
                vm.filteredAttributeValues = filteredAttributeValues;
            }
        }
        /**
         * @method filterPeople
         * @param filters {object} - Keys of the object overwrite matching keys of vm.filters
         * Filter the people list.
         * Filters:
         *   attributeValues {array} ids
         *   permissions {array} ids
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'person' implicitly has an 'any' type.
         *   roles {array} ids
         *   isExact {boolean} - true for exact matches only
         *
         * NOTE: TODO isExact is FALSE when filters are changed by list-filters because there isn't a UI for the flag.
         *       The flag is currently only set via URL variable.
         *       If any of the filters are exact (e.g. onlyRoles) then they all are made exclusive.
         */
        function filterPeople(filters) {
            //Merge the filters. Leave existing filters in tact unless they exist in incoming filters.
            _.assign(vm.filters, filters);
            setParameters();
            if (_.isEmpty(queryParams)) {
                setPeople();
            }
            else {
                getPeople();
            }
        }
        /**
         * @method filterPeopleBy
         * @param id {number}
         * @param type {string} what to filter by
         * Filters the people list by attribute values or roles.
         *
         **/
        function filterPeopleBy(id, type) {
            var filters = {
                attributeValues: [],
                roles: [],
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'person' implicitly has an 'any' type.
                query: '',
                more: [],
            };
            if (type == 'attribute') {
                filters.attributeValues = [id];
            }
            if (type == 'role') {
                filters.roles = [id];
            }
            if (!vm.showAttributes) {
                // @ts-ignore
                delete filters.attributeValues;
            }
            filterPeople(filters);
            onChangeTab('people');
        }
        /**
         * @method filterRoles
         */
        function filterRoles() {
            var isQueryEmpty = vm.rolesQuery == '';
            // @ts-ignore ts-migrate(7034) FIXME: Variable 'filteredAttributeValues' implicitly has ... Remove this comment to see the full error message
            if (isQueryEmpty) {
                vm.filteredRoles = _.filter(vm.roles, { _isAdded: true });
            }
            else {
                vm.filteredRoles = vm.roles;
            }
        }
        /**
         * @function moreFilter
         * @private
         * handles more filters both direct reports and plan access
         */
        function moreFilter() {
            var planAccess = [];
            var filterDirectReports = _.find(vm.filters.more, {
                name: 'directReports',
            });
            //direct reports
            if (filterDirectReports) {
                vm.people = _.filter(vm.people, function (p) {
                    return p.reportsToId === vm.userId;
                });
            }
            //plan access
            if (_.find(vm.filters.more, { name: 'owners' })) {
                planAccess = _.union(planAccess, vm.parentPlanAccess.owners);
            }
            if (_.find(vm.filters.more, { name: 'participants' })) {
                planAccess = _.union(planAccess, vm.parentPlanAccess.participants);
            }
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'filteredAttributeValues' implicitly has ... Remove this comment to see the full error message
            if (_.find(vm.filters.more, { name: 'viewOnly' })) {
                planAccess = _.union(planAccess, vm.parentPlanAccess.viewOnly);
            }
            if (!_.isEmpty(planAccess)) {
                vm.people = _.filter(vm.people, function (p) {
                    return _.includes(planAccess, p.id);
                });
            }
            else if (_.isEmpty(planAccess) && !filterDirectReports) {
                vm.people = [];
            }
        }
        /**
         * @function getPeople
// @ts-ignore ts-migrate(7005) FIXME: Variable 'filteredAttributeValues' implicitly has ... Remove this comment to see the full error message
         * @returns {object} - promise, Array
         * @private
         * Get people for the list.
         * Could be peers, subordinates or both.
         */
        function getPeople() {
            // Currently, there is no pagination, so pass undefined.
            var promise;
            if (vm.isSubordinatesOnly) {
                promise = PeopleService.getAllForPerson(queryParams, sortParams, undefined, false, vm.blacklist);
            }
            else {
                promise = PeopleService.getAll(queryParams, sortParams, undefined, vm.blacklist);
            }
            return promise.then(function getAllPeopleSuccess(response) {
                var records;
                if (angular.isArray(response.data)) {
                    // Not paginated. TEMPORARY
                    records = PeopleService.sort(response.data);
                }
                else {
                    // Paginated
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'filters' implicitly has an 'any' type.
                    records = PeopleService.sort(response.data.records);
                    vm.pagination = {
                        index: response.data.paginationDTO.pageNumber,
                        size: response.data.paginationDTO.pageSize,
                        total: response.data.totalRecords,
                    };
                }
                _.forEach(addedAccessPeople, function (person) {
                    person._isAdded = true;
                });
                vm.people = _.map(records, function (person) {
                    var assigned = _.find(addedAccessPeople, { id: person.id });
                    return assigned || person;
                });
                if (!_.isEmpty(vm.filters.more)) {
                    moreFilter();
                }
            }, 
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
            function getPeopleError(response) {
                console.error('GET ' + (vm.isSubordinatesOnly ? 'SUBORDINATES' : 'ALL PEOPLE') + ' FOR ACCESS ERROR', response);
            });
        }
        /**
         * @method ok
         * When the user clicks ok.
         */
        function ok() {
            // @ts-ignore ts-migrate(2322) FIXME: Type 'any' is not assignable to type 'never'.
            $uibModalInstance.close(vm.people);
        }
        /**
         * @method onChangeTab
         * @param tab {string}
// @ts-ignore ts-migrate(2322) FIXME: Type 'any' is not assignable to type 'never'.
         */
        function onChangeTab(tab) {
            if ($scope.isPlanView) {
                switch (tab) {
                    case 'owners':
                        vm.people = $scope.access.owners;
                        vm.columnHeader = 'Owners';
                        vm.hasPrimaryPerson = true;
                        break;
                    default:
                        vm.people = $scope.access.participants;
                        vm.columnHeader = 'Participants';
                        vm.hasPrimaryPerson = false;
                }
            }
            else if ($scope.isGoalView) {
                switch (tab) {
                    case 'owners':
                        vm.people = $scope.access.assignees;
                        vm.columnHeader = 'Assignees';
                        break;
                    default:
                        vm.people = $scope.access.participants;
                        vm.columnHeader = 'Participants';
                }
                // @ts-ignore ts-migrate(7034) FIXME: Variable 'planAccess' implicitly has type 'any[]' ... Remove this comment to see the full error message
            }
            else if ($scope.isEditTabView) {
                switch (tab) {
                    case 'attributes':
                        vm.columnHeader = 'Attributes and Values';
                        vm.hasReceiveCommunications = false;
                        vm.hasPeopleColumn = true;
                        vm.peopleListView = false;
                        break;
                    case 'roles':
                        vm.columnHeader = 'Roles';
                        vm.hasReceiveCommunications = false;
                        vm.hasPeopleColumn = true;
                        vm.peopleListView = false;
                        break;
                    default:
                        vm.columnHeader = vm.title;
                        // @ts-ignore ts-migrate(7005) FIXME: Variable 'planAccess' implicitly has an 'any[]' ty... Remove this comment to see the full error message
                        vm.hasReceiveCommunications = true;
                        vm.hasPeopleColumn = false;
                        vm.peopleListView = true;
                        break;
                }
                vm.tab = tab;
            }
        }
        /**
         * @method onClearAttributeFilters
         * clears query and filters for attribute values
         */
        function onClearAttributeFilters() {
            vm.selectedAttributes = [];
            vm.attributesQuery = '';
            filterAttributeValues();
        }
        /**
         * @method addPerson
         * @param selectedPerson {object}
         * Update the UI when a person is selected.
         */
        // @ts-ignore ts-migrate(7005) FIXME: Variable 'planAccess' implicitly has an 'any[]' ty... Remove this comment to see the full error message
        function addPerson(selectedPerson) {
            if (vm.maximumPeople === 0) {
                addedAccessPeople.push(selectedPerson);
            }
            else if (vm.maximumPeople === 1) {
                // Remove _isAdded from other users
                _.forEach(addedAccessPeople, function (p) {
                    p._isAdded = false;
                });
                // Replace with selected person
                addedAccessPeople = [selectedPerson];
            }
            else if (addedAccessPeople.length < vm.maximumPeople) {
                addedAccessPeople.push(selectedPerson);
            }
            selectedPerson._isAdded = true;
            if ($scope.addPerson) {
                $scope.addPerson(selectedPerson);
            }
            if ($scope.assignOwners) {
                // TODO: how is this not addPerson or addAllPeople
                $scope.assignOwners([selectedPerson]);
            }
        }
        /**
         * @method onSelectPrimaryPerson
         * @param person {object}
         * Called when primary person radio buttons change
         * TODO: Remove legacy behavior of just returning the ID and instead return the person object.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
        function onSelectPrimaryPerson(person) {
            if ($scope.changePrimaryPersonId) {
                $scope.changePrimaryPersonId(Number(vm.primaryPersonId), person);
                if ($scope.closeOnSelect) {
                    ok();
                }
            }
        }
        /**
         * @method onSelectPerson
         * @param person {object}
         * Called when person selector is clicked
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'person' implicitly has an 'any' type.
        function onSelectPerson(person) {
            if (!vm.isReadOnly && vm.hasAddRemove && !person.attributeAssigned && !person.roleAssigned && !vm.actionItem) {
                // Add Person
                if (vm.maximumPeople !== 1 && !person._isAdded) {
                    addPerson(person);
                }
            }
            // Duplicate action
            else if ((vm.actionItem || vm.actionItem.id) && !person.isDuplicated) {
                vm.primaryPersonId = person.id;
                onSelectPrimaryPerson(person);
            }
        }
        /**
         * @method getSelectorClass
         * @param person {object}
         * gets class for person selector
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'person' implicitly has an 'any' type.
        function getSelectorClass(person) {
            if ((vm.maximumPeople !== 1 && !person._isAdded) ||
                (vm.actionItem && !person.isDuplicated &&
                    (person.id != vm.primaryPersonId))) {
                return 'person-selector';
            }
        }
        /**
         * @method removePeople
         * Remove everyone other than the primary owner.
         */
        function removePeople() {
            var removedPeople = [];
            if (!_.isEmpty(vm.people)) {
                _.forEach(vm.people, function (person) {
                    if (person._isAdded &&
                        !person.attributeAssigned &&
                        !person.roleAssigned &&
                        isPersonRemovable(person)) {
                        _.remove(addedAccessPeople, { id: person.id });
                        // @ts-ignore ts-migrate(7005) FIXME: Variable 'addedAccessPeople' implicitly has an 'an... Remove this comment to see the full error message
                        removedPeople.push(person.id);
                        person._isAdded = false;
                    }
                });
                //Update in backend
                if ($scope.removePeople && removedPeople.length != 0) {
                    $scope.removePeople(removedPeople);
                    // @ts-ignore ts-migrate(7005) FIXME: Variable 'addedAccessPeople' implicitly has an 'an... Remove this comment to see the full error message
                }
            }
        }
        /**
         * @method removeAttribute
         * @param selectedAttributeValue {object}
         */
        function removeAttributeValue(selectedAttributeValue) {
            selectedAttributeValue._isAdded = false;
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            $scope.removeAttributeValue(selectedAttributeValue.id);
        }
        /**
         * @method removePerson
         * @param selectedPerson {object}
         * Update the UI when a person is removed.
         */
        function removePerson(selectedPerson) {
            _.remove(addedAccessPeople, { id: selectedPerson.id });
            selectedPerson._isAdded = false;
            //update backend
            if ($scope.removePerson) {
                $scope.removePerson(selectedPerson);
            }
        }
        /**
         * @method removeRole
         * @param selectedRole {object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'tab' implicitly has an 'any' type.
        function removeRole(selectedRole) {
            selectedRole._isAdded = false;
            $scope.removeRole(selectedRole.id);
        }
        /**
         * @function setParameters
         * @private
         * Iterate through allowed query parameters,
         * find which ones are defined,
         * convert them to arrays of integers to then be formatted for the API.
         * Note: Only used to update the URL
         */
        function setParameters() {
            // TODO: use setParameters in the access modal service
            // Clone the current parameters to determine if there are any changes later.
            var originalQueryParams = _.clone(queryParams);
            queryParams = {};
            if (angular.isArray(vm.filters.more) && vm.filters.more.length) {
                // @ts-ignore
                queryParams.more = vm.filters.more;
            }
            if (angular.isArray(vm.filters.attributeValues) && vm.filters.attributeValues.length) {
                var paramKey = vm.isExact ? 'onlyAttributes' : 'allAttributes';
                // @ts-ignore
                queryParams[paramKey] = vm.filters.attributeValues.join(',');
            }
            if (!$scope.isActionItemAssignment) {
                if (angular.isArray(vm.filters.peopleValues) && vm.filters.peopleValues.length) {
                    // @ts-ignore
                    queryParams.onlyPeople = vm.filters.peopleValues.join(',');
                }
            }
            if (angular.isArray(vm.filters.permissions) && vm.filters.permissions.length) {
                var paramKey = vm.isExact ? 'onlyPermissions' : 'allPermissions';
                // @ts-ignore
                queryParams[paramKey] = vm.filters.permissions.join(',');
            }
            if (angular.isArray(vm.filters.roles) && vm.filters.roles.length) {
                var paramKey = vm.isExact ? 'onlyRoles' : 'allRoles';
                // @ts-ignore
                queryParams[paramKey] = vm.filters.roles.join(',');
            }
            if (vm.filters.isAttributeless) {
                // @ts-ignore
                queryParams.showAttributeless = 'true';
            }
            if (vm.filters.isActiveOnly) {
                // @ts-ignore
                queryParams.showActive = 'true';
            }
            if (vm.filters.isInactiveOnly) {
                // @ts-ignore
                queryParams.showInactive = 'true';
            }
            if (vm.filters.isOrphaned) {
                // @ts-ignore
                queryParams.showOrphaned = 'true';
            }
            if (vm.filters.isPermissionless) {
                // @ts-ignore
                queryParams.showPermissionless = 'true';
            }
            if (vm.filters.isRoleless) {
                // @ts-ignore
                queryParams.showRoleless = 'true';
            }
            if (vm.filters.isTerminated) {
                // @ts-ignore
                queryParams.showTerminated = 'true';
            }
            if (vm.filters.query) {
                // @ts-ignore
                queryParams.query = vm.filters.query;
            }
            // Contrast the current with the original to see if the URL should be updated.
            if (!_.isEqual(queryParams, originalQueryParams)) {
                vm.isFiltered = !_.isEmpty(queryParams);
            }
            else if (!_.isEmpty(queryParams)) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'selectedPerson' implicitly has an 'any'... Remove this comment to see the full error message
                vm.isFiltered = true;
            }
        }
        /**
         * @function setAttributes
         * @private
         */
        function setAttributes() {
            // @ts-ignore
            var addedAttributesIds = [], 
            // @ts-ignore
            addedAttributesValueIds = [], attributeValues = $scope.attributeValues, 
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'addedAccessPeople' implicitly has an 'an... Remove this comment to see the full error message
            selectedAttributePeopleCount = $scope.peopleCount.selectedAttributePeopleCount;
            vm.attributes = $scope.attributes;
            //mark attribute values already added
            _.forEach(attributeValues, function (attributeValue) {
                addedAttributesValueIds.push(attributeValue.id);
                addedAttributesIds.push(attributeValue.attributeId);
            });
            vm.filteredAttributeValues = [];
            vm.suggestedAttributeValues = [];
            _.forEach(vm.attributes, function (attribute) {
                //mark hidden attributes
                attribute._isHidden =
                    attribute.hidden == 1 && !_.includes(addedAttributesIds, attribute.id);
                //only add attribute values that do not have hidden attributes
                if (!attribute._isHidden) {
                    vm.suggestedAttributeValues = _.concat(vm.suggestedAttributeValues, attribute.attributeValues);
                }
                _.forEach(attribute.attributeValues, function (attributeValue) {
                    attributeValue._isAdded = false;
                    if (_.includes(addedAttributesValueIds, attributeValue.id)) {
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'person' implicitly has an 'any' type.
                        attributeValue._isAdded = true;
                        if (selectedAttributePeopleCount[attributeValue.id]) {
                            attributeValue.peopleCount = selectedAttributePeopleCount[attributeValue.id].length;
                        }
                    }
                    // removes blacklisted attributes
                    if (_.includes($scope.blacklistedAttributes, attributeValue.id)) {
                        _.pull(vm.suggestedAttributeValues, attributeValue);
                    }
                });
            });
            // @ts-ignore ts-migrate(7034) FIXME: Variable 'removedPeople' implicitly has type 'any[... Remove this comment to see the full error message
            vm.filteredAttributeValues = attributeValues;
        }
        /**
         * @function setPeople
         * @private
         */
        function setPeople() {
            var people;
            if (vm.maximumPeople === 1 && $scope.peopleIds.length) {
                vm.assignedPersonId = String($scope.peopleIds[0]);
            }
            //If modal is tabbed we only want to display the relevant people
            if ($scope.access && $scope.isPlanView) {
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'addedAccessPeople' implicitly has an 'an... Remove this comment to see the full error message
                // Plan Detail
                people = $scope.access.owners;
            }
            else if ($scope.access && ($scope.isGoalView || $scope.isKpiView)) {
                // KPI Detail
                // Goal Detail
                people = $scope.access.assignees;
            }
            else if ($scope.isActionItemAssignment) {
                // Default to people provided
                people = $scope.people;
            }
            else {
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'removedPeople' implicitly has an 'any[]'... Remove this comment to see the full error message
                // Plan Settings: owners, participants, viewers
                // KPI Settings: assignees
                // Goal Settings: assignees, participants, view only
                people = $scope.people;
            }
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'selectedAttributeValue' implicitly has ... Remove this comment to see the full error message
            // Mark list of people as already assigned
            _.forEach(people, function (person) {
                person._isAdded = true;
            });
            if ($scope.suggestedPeople) {
                // Include a list of non-added people that are suggested to be assigned.
                // Existing people are assumed to be already assigned.
                // Only add suggested people that aren't assigned.
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'selectedPerson' implicitly has an 'any'... Remove this comment to see the full error message
                people = _.unionWith(people, $scope.suggestedPeople, function (a, b) {
                    // @ts-ignore
                    return a.id === b.id;
                });
            }
            vm.people = PeopleService.sort(people);
            addedAccessPeople = people;
        }
        /**
         * @function setRoles
         * @private
         */
        function setRoles() {
            var addedRoleIds = [], rolesToRemove = [], selectedRolePeopleCount = $scope.peopleCount.selectedRolePeopleCount;
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'selectedRole' implicitly has an 'any' t... Remove this comment to see the full error message
            vm.selectedRoles = $scope.selectedRoles;
            _.forEach(vm.selectedRoles, function (selectedRole) {
                selectedRole._isAdded = true;
                addedRoleIds.push(selectedRole.id);
            });
            vm.roles = $scope.roles;
            _.forEach(vm.roles, function (role) {
                role._isAdded = false;
                // @ts-ignore
                if (_.includes(addedRoleIds, role.id)) {
                    role._isAdded = true;
                    if (selectedRolePeopleCount[role.id]) {
                        role.peopleCount = selectedRolePeopleCount[role.id].length;
                    }
                }
                //keep track of blacklisted roles
                if (_.includes($scope.blacklistedRoles, role.id)) {
                    rolesToRemove.push(role);
                }
            });
            //remove blacklisted roles
            // @ts-ignore
            _.forEach(rolesToRemove, function (role) {
                _.pull(vm.roles, role);
            });
            vm.filteredRoles = vm.selectedRoles;
        }
        /**
         * @function setSubNav
         */
        function setSubNav() {
            if (vm.isReadOnly) {
                if ($scope.isPlanView || $scope.isGoalView) {
                    vm.subNav = subnav;
                }
            }
            if (vm.isEditTabView) {
                vm.tab = 'people';
                vm.subNav = {
                    people: {
                        title: 'People',
                    },
                    attributes: {
                        // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                        title: 'Attributes',
                    },
                    roles: {
                        title: 'Dynamic Roles',
                    },
                };
                if (!vm.showAttributes) {
                    delete vm.subNav.attributes;
                }
            }
        }
        /**
         * @method updateAssignment
         * @param  {object} person
         * When selecting 'Receive Communications', this
         * will update the assignment object
         */
        // @ts-ignore
        function updateAssignment(person) {
            if (person._isSubscribed) {
                vm.viewNotesIds.push(person.id);
            }
            else {
                vm.viewNotesIds = _.remove(vm.viewNotesIds, function (id) {
                    return id !== person.id;
                });
            }
            if ($scope.updateAssignment) {
                // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                $scope.updateAssignment(person);
            }
        }
        /**
         * @method duplicateAction
         * @param  {object} person
         * When 'duplicate action' button is clicked, this
         * will duplicate the action and assign it to the new person
         */
        // @ts-ignore
        function duplicateAction(personId) {
            ActionItemsService.duplicate(personId, vm.actionItem.id).then(function () {
                $scope.refreshOnDuplicate();
            });
            // @ts-ignore
            vm.people.map(function (person, i) {
                if (person.id === personId) {
                    vm.people[i].isDuplicated = true;
                }
            });
        }
    }
})();
// @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message

(function () {
    angular
        .module('App.Util')
        .factory('AccessModal', [
        '$rootScope',
        '$uibModal',
        'PeopleService',
        'TEMPLATE_PATH',
        AccessModalFactory,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$rootScope' implicitly has an 'any' typ... Remove this comment to see the full error message
    function AccessModalFactory($rootScope, $uibModal, PeopleService, TEMPLATE_PATH) {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter '$uibModal' implicitly has an 'any' type... Remove this comment to see the full error message
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'PeopleService' implicitly has an 'any' ... Remove this comment to see the full error message
         * @property allowedOptions
         * @type {Array}
         * Whitelist of modal options.
         */
        var allowedOptions = [
            // goals + kpis (plans: people)
            'blacklist',
            'isRequired',
            'people',
            'title',
            'parentPlanAccess',
            'addAllPeople',
            'addPerson',
            'removePerson',
            'removePeople',
            'removeAllPeople',
            'columnHeaderPrefix',
            // kpis + plans
            'changePrimaryPersonId',
            'hasPrimaryPerson',
            'primaryPersonId',
            // kpis
            'isKpiView',
            // goals
            'accessGroups',
            'isGoalView',
            // plans
            'assignments',
            'currentUser',
            'hasReceiveCommunications',
            'isReadOnly',
            'updateAssignment',
            'isPlanView',
            'tabs',
            'isEditTabView',
            'attributes',
            'attributeValues',
            'addAttributeValue',
            'addRole',
            'removeAttributeValue',
            'removeRole',
            'blacklistedAttributes',
            'viewNotesIds',
            'roles',
            'selectedRoles',
            'blacklistedRoles',
            'peopleCount',
            // action items
            'actionItem',
            'refreshOnDuplicate',
            'hasAddRemove',
            'peopleIds',
            'primaryPersonLabel',
            'initialFilters',
            'isActionItemAssignment',
            'closeOnSelect',
            // meeting series
            'maximumPeople',
            'suggestedPeople',
            'immutablePeopleIds',
            'isSubordinatesOnly',
        ];
        /**
         * @property defaults
         * @type {object}
         */
        var defaults = {
            hasAddRemove: true,
            isSubordinatesOnly: false,
            maximumPeople: 0,
            tabs: {
                owners: 'Assignees',
            },
        };
        var service = {
            open: open,
            openEdit: openEdit,
            setParameters: setParameters,
        };
        return service;
        /**
         * @method open
         * @param options {object}
         */
        function open(options) {
            var modalScope = $rootScope.$new();
            var config = _.pick(options, allowedOptions);
            modalScope.isReadOnly = true;
            _.assign(modalScope, config);
            _.defaults(modalScope, defaults);
            return PeopleService.getBasicByIds(modalScope.peopleIds).then(function getBasicByIdsSuccess(response) {
                modalScope.access = getAccessFromPeople(response.data, modalScope.accessGroups, modalScope.isPlanView);
                return openModal(modalScope);
            }, function getBasicByIdsError(response) {
                console.error('GET ALL USERS FOR IDS ERROR', response);
            });
        }
        /**
         * @method openEdit
         * @param options {object}
         */
        // @ts-ignore
        function openEdit(options) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'options' implicitly has an 'any' type.
            var config = _.pick(options, allowedOptions);
            var ms = $rootScope.$new(true);
            _.assign(ms, config);
            _.defaults(ms, defaults);
            if (ms.peopleIds && !ms.people) {
                PeopleService.getBasicByIds(ms.peopleIds).then(function getOwnerPeopleSuccess(response) {
                    ms.people = response.data;
                    openModal(ms);
                }, 
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                function getOwnerPeopleError(response) {
                    console.error('GET INFORMATION FOR OWNERS ERROR', response);
                });
            }
            else {
                openModal(ms).then(angular.noop, angular.noop);
            }
        }
        /**
         * @function openModal
         * @param scope {object}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
         */
        function openModal(scope) {
            var modal = $uibModal.open({
                animation: true,
                controller: 'AccessModalController',
                controllerAs: 'modalVm',
                scope: scope,
                size: 'lg',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'options' implicitly has an 'any' type.
                templateUrl: TEMPLATE_PATH + '/util/access-modal/access-modal.html',
            });
            return modal.result;
        }
        /**
         * @function getAccessFromPeople
         * @param people {Array}
         * @param accessGroups {object}
         * @param isPlanView {Boolean}
         * @returns {{owners: Array, participants: Array, assignees: Array}}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
        function getAccessFromPeople(people, accessGroups, isPlanView) {
            var access = {
                owners: [],
                participants: [],
                assignees: [],
            }, 
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            hasAssignees = accessGroups.assignees.length > 0, hasOwners = accessGroups.owners.length > 0, hasParticipants = accessGroups.participants.length > 0;
            _.forEach(people, function (person) {
                var owner, participant;
                if (hasOwners) {
                    owner = _.find(accessGroups.owners, { userId: person.id });
                    if (owner) {
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
                        person._isSubscribed = !!owner.viewNotes;
                        access.owners.push(person);
                    }
                }
                if (hasParticipants) {
                    if (isPlanView) {
                        participant = _.find(accessGroups.participants, {
                            userId: person.id,
                        });
                        if (participant) {
                            person._isSubscribed = !!participant.viewNotes;
                            access.participants.push(person);
                        }
                    }
                    else if (accessGroups.participants.indexOf(person.id) !== -1) {
                        access.participants.push(person);
                    }
                }
                if (hasAssignees) {
                    if (accessGroups.assignees.indexOf(person.id) !== -1) {
                        access.assignees.push(person);
                    }
                }
            });
            return access;
        }
        /**
         * @function setParameters
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'people' implicitly has an 'any' type.
         * @param filters {object}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'isPlanView' implicitly has an 'any' typ... Remove this comment to see the full error message
         * @param isExact {bool}
         */
        function setParameters(filters, isExact) {
            var queryParams = {};
            if (angular.isArray(filters.more) && filters.more.length) {
                // @ts-ignore
                queryParams.more = filters.more;
            }
            if (angular.isArray(filters.attributeValues) && filters.attributeValues.length) {
                // @ts-ignore
                queryParams[isExact ? 'onlyAttributes' : 'allAttributes'] = filters.attributeValues.join(',');
            }
            if (angular.isArray(filters.peopleValues) && filters.peopleValues.length) {
                // @ts-ignore
                queryParams.onlyPeople = filters.peopleValues.join(',');
            }
            if (angular.isArray(filters.permissions) && filters.permissions.length) {
                // @ts-ignore ts-migrate(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
                queryParams[isExact ? 'onlyPermissions' : 'allPermissions'] = filters.permissions.join(',');
            }
            if (angular.isArray(filters.roles) && filters.roles.length) {
                // @ts-ignore
                queryParams[isExact ? 'onlyRoles' : 'allRoles'] = filters.roles.join(',');
            }
            if (filters.isAttributeless) {
                // @ts-ignore
                queryParams.showAttributeless = 'true';
            }
            if (filters.isActiveOnly) {
                // @ts-ignore
                queryParams.showActive = 'true';
            }
            if (filters.isInactiveOnly) {
                // @ts-ignore ts-migrate(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
                queryParams.showInactive = 'true';
            }
            if (filters.isOrphaned) {
                // @ts-ignore
                queryParams.showOrphaned = 'true';
            }
            if (filters.isPermissionless) {
                // @ts-ignore
                queryParams.showPermissionless = 'true';
            }
            // @ts-ignore ts-migrate(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
            if (filters.isRoleless) {
                // @ts-ignore
                queryParams.showRoleless = 'true';
            }
            if (filters.isTerminated) {
                // @ts-ignore
                queryParams.showTerminated = 'true';
            }
            if (filters.query) {
                // @ts-ignore
                queryParams.query = filters.query;
            }
            // @ts-ignore ts-migrate(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
            return queryParams;
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'filters' implicitly has an 'any' type.

(function () {
    angular
        .module('App.Util')
        .controller('ActionItemsListModalController', [
        '$scope',
        '$uibModalInstance',
        ActionItemsListModalController,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$scope' implicitly has an 'any' type.
    function ActionItemsListModalController($scope, $uibModalInstance) {
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        /**
         * @listener $onInit
         */
        vm.$onInit = init;
        vm.fn = {
            close: close,
            onChangeTab: onChangeTab,
        };
        /**
         * @property subnav
         * @type {object}
         */
        vm.subnav = {
            onetime: {
                title: 'One-Time',
            },
            recurring: {
                title: 'Recurring',
            },
        };
        /**
         * @property selectedView
         * @type {string}
         * Which tab is currently visible
         */
        vm.selectedView = 'onetime';
        /**
         * @method close
         * Closes modal
         */
        function close() {
            $uibModalInstance.dismiss();
        }
        /**
         * @property recurringAdminAI
         * @type {Array}
         */
        vm.recurringAdminAI = [];
        /**
         * @property oneTimeAdminAI
         * @type {Array}
         */
        vm.oneTimeAdminAI = [];
        /**
         * @function init
         * @private
         */
        function init() {
            var partitions;
            partitions = _.partition($scope.actionItemsList, 'isRecurring');
            vm.oneTimeAdminAI = partitions[1];
            vm.recurringAdminAI = partitions[0];
            vm.actionItems = vm.oneTimeAdminAI;
        }
        /**
         * @method onChangeTab
         * @param tab {string}
         * Callback for the tabbed navigation directive.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'tab' implicitly has an 'any' type.
        function onChangeTab(tab) {
            vm.selectedView = tab;
            if (vm.selectedView === 'onetime') {
                vm.actionItems = vm.oneTimeAdminAI;
            }
            else {
                vm.actionItems = vm.recurringAdminAI;
            }
        }
    }
})();

(function () {
    angular
        .module('App.Util')
        .directive('adaptiveInsightsMapGoals', [
        '$state',
        '$window',
        'd3Service',
        'GoalsService',
        'TEMPLATE_PATH',
        AdaptiveInsightsMapGoals,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$state' implicitly has an 'any' type.
    function AdaptiveInsightsMapGoals($state, $window, d3Service, GoalsService, TEMPLATE_PATH) {
        var DirectiveDefinitionObject = {
            link: link,
            restrict: 'E',
            scope: {
                parentGoal: '=',
                supportingGoals: '=',
                highlightedItems: '=',
                hoverLeft: '<?',
            },
            templateUrl: TEMPLATE_PATH + '/util/adaptive-insights-map-goals/util.adaptive-insights-map-goals.html',
        };
        return DirectiveDefinitionObject;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope, element) {
            /**
             * @listener $destroy
             */
            scope.$on('$destroy', onDestroy);
            /**
             * @property chartWidth
             * @type {Number}
             */
            var chartWidth;
            /**
             * @property chartHeight
             * @type {Number}
             */
            var chartHeight;
            /**
             * @property isFiltered
             * @type {Boolean}
             * have the supporting goals been filtered down
             */
            var isFiltered = false;
            /**
             * @property lazyDrawChart
             * @type {object}
             * when an update to the plans or window resize
             */
            var lazyDrawChart = _.debounce(drawChart, 50);
            /**
             * @property lazyMouseleave
             * @type {object}
             * when you mouse leave a node
             */
            var lazyMouseleave = _.debounce(mouseleave, 50);
            /**
             * @property sunburstRadius
             * @type {number}
             */
            var sunburstRadius;
            /**
             * @property canvas
             * @type {object}
             * the HTML element that hold the svg element
             */
            var canvas = d3Service.d3.select(element[0]).append('svg:svg');
            /**
             * @property svg
             * @type {object}
             */
            var svg = canvas.append('svg:g').on('mouseleave', lazyMouseleave);
            /**
             * @property partition
             * @type {object}
             * This sections off each partition of the ring
             * and makes them equal in size. (return 1)
             * If we want to make the partitions vary in size by number of
             * goals we can return the number of goals, or number of child plans
             */
            var partition = d3Service.d3.partition();
            /**
             * @property arc
             * @type {object}
             * tells D3 how to draw the sunburst arcs
             */
            var arc = d3Service.d3
                .arc()
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                .startAngle(function (d) {
                return d.x0;
            })
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                .endAngle(function (d) {
                return d.x1;
            })
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                .innerRadius(function (d) {
                return Math.sqrt(d.y0);
            })
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                .outerRadius(function (d) {
                return Math.sqrt(d.y1);
            });
            /**
             * @property activeGoal
             * @type {object}
             */
            scope.activeGoal = null;
            /**
             * @property goalCardTop
             * @type {String}
             * for moving the goal card to follow the mouse,
             * this is the top number (pixels)
             */
            scope.goalCardTop = '';
            /**
             * @property goalCardLeft
             * @type {String}
             * for moving the goal card to follow the mouse,
             * this is the left number (pixels)
             */
            scope.goalCardLeft = '';
            init();
            /**
             * @method  buildGoalHierarchyData
             * @returns {object} tree data that d3 can use to build the tree
             * This takes the hierarchy data and converts it into tree
             * structure that d3 can use to display
             */
            function buildGoalHierarchyData() {
                var rootNode = scope.parentGoal;
                rootNode.children = getNestedChildren(scope.supportingGoals, scope.parentGoal);
                return rootNode;
            }
            /**
             * @method click
             * @param d {object} - the plan node
             * @returns {none}
             * sends the person to the plan
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
            function click(d) {
                var url = GoalsService.getUrlForGoal('show', d, undefined, d.parent);
                return $state.go(url.state, url.params);
            }
            /**
             * @method drawChart
             * @returns {void}
             * Draws the sunburst chart
             */
            function drawChart() {
                chartWidth = element.parent()[0].offsetWidth - 30;
                chartHeight = 0.75 * chartWidth;
                sunburstRadius = Math.min(chartWidth, chartHeight) / 2;
                // resize the canvas
                canvas.attr('width', chartWidth).attr('height', chartHeight);
                // move the svg
                svg.attr('transform', 'translate(' + chartWidth / 2 + ',' + chartHeight / 2 + ')');
                // resize the partitions
                partition.size([2 * Math.PI, sunburstRadius * sunburstRadius]);
                drawChartNodes();
            }
            /**
             * @method drawChartNodes
             * @returns {void}
             * Called on plan data update, this builds out the
             * sunburst chart
             */
            function drawChartNodes() {
                // remove all nodes
                svg.selectAll('path').remove();
                // build out the tree data
                var json = buildGoalHierarchyData();
                var root = d3Service.d3.hierarchy(json).count();
                var nodes = partition(root).descendants();
                // draw each node
                svg
                    .data([json]).selectAll('path')
                    .data(nodes)
                    .enter()
                    .append('svg:path')
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                    .attr('display', function (d) {
                    return d.depth ? null : 'none';
                })
                    .attr('d', arc)
                    .attr('fill-rule', 'evenodd')
                    .style('stroke', '#fff')
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                    .style('fill', function (d) {
                    return getNodeColor(d);
                })
                    .style('opacity', 1)
                    .on('mouseover', mouseover)
                    .on('click', click);
                highlightFilteredListGoals();
            }
            /**
             * @method getAncestors
             * @param node {object} - the plan node
             * @returns {Array} - array of ancestors
             * Given a node in a partition layout, return an array of all of its ancestor
             * nodes, highest first, but excluding the root.
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
            function getAncestors(node) {
                var path = [];
                var current = node;
                while (current.parent) {
                    path.unshift(current);
                    current = current.parent;
                }
                return path;
            }
            /**
             * @method getNestedChildren
             * @param supportingGoals {Array} - all supporting goals
             * @param parentGoal {object} - a targeted parent goal
             * @returns {Array} the tree data for the chart
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'supportingGoals' implicitly has an 'any... Remove this comment to see the full error message
            function getNestedChildren(supportingGoals, parentGoal) {
                // @ts-ignore ts-migrate(7034) FIXME: Variable 'treeData' implicitly has type 'any[]' in... Remove this comment to see the full error message
                var treeData = [];
                supportingGoals = _.orderBy(supportingGoals, ['id'], ['asc']);
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'supportingGoal' implicitly has an 'any'... Remove this comment to see the full error message
                supportingGoals.forEach(function (supportingGoal) {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'supportedGoal' implicitly has an 'any' ... Remove this comment to see the full error message
                    supportingGoal._allSupportedGoals.forEach(function (supportedGoal) {
                        if (supportedGoal.id === parentGoal.id) {
                            var children = getNestedChildren(supportingGoals, supportingGoal);
                            if (children.length) {
                                supportingGoal.children = _.uniqBy(children, 'id');
                            }
                            treeData.push(angular.copy(supportingGoal));
                        }
                    });
                });
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'treeData' implicitly has an 'any[]' type... Remove this comment to see the full error message
                return treeData;
            }
            /**
             * @method getNodeColor
             * @param d {object} - the plan node
             * @returns {string}
             * returns the color value for the node
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
            function getNodeColor(d) {
                // Draft color
                var color = '#818a91';
                // active
                if (d.data.state === 2) {
                    switch (d.data.status) {
                        case 3:
                            color = '#4CAF50';
                            break;
                        case 2:
                            color = '#FF9800';
                            break;
                        case 1:
                            color = '#F44336';
                            break;
                    }
                }
                // suspended
                if (d.data.state === 3) {
                    color = '#000000';
                }
                // completed
                if (d.data.state === 4) {
                    color = '#51bfe2';
                }
                return color;
            }
            /**
             * @method highlightFilteredListGoals
             * @returns {void}
             * When a user clicks on the attribute table to
             * filter down the goals by attribute, this will highlight
             * the filtered goals
             */
            function highlightFilteredListGoals() {
                // if the user has filtered down the supporting goals
                if (scope.highlightedItems.length !== scope.supportingGoals.length) {
                    // build a map of goal id of the filtered list
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'map' implicitly has an 'any' type.
                    var dataMap = scope.highlightedItems.reduce(function (map, goal) {
                        map[goal.id] = goal;
                        return map;
                    }, {});
                    // Fade all the nodes out
                    d3Service.d3
                        .select('adaptive-insights-map-goals')
                        .selectAll('path')
                        .style('opacity', 0.1);
                    // cycle through each graph node and if there is a match
                    // highlight that node
                    d3Service.d3
                        .select('adaptive-insights-map-goals')
                        .selectAll('path')
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                        .style('opacity', function (d) {
                        return dataMap[d.id] ? 1 : 0.1;
                    });
                    isFiltered = true;
                }
                else {
                    isFiltered = false;
                    d3Service.d3
                        .select('adaptive-insights-map-goals')
                        .selectAll('path')
                        .style('opacity', 1);
                }
            }
            /**
             * @method  init
             * @return {none}
             * Initialize directive
             */
            function init() {
                // Note: be sure to unregister in onDestroy
                angular.element($window).on('resize', drawChart);
                element.on('mousemove', mousemove);
                scope.$watch('supportingGoals', lazyDrawChart);
                scope.$watch('highlightedItems', highlightFilteredListGoals);
            }
            /**
             * @method mouseleave
             * @returns {void}
             */
            function mouseleave() {
                if (!isFiltered) {
                    // Deactivate all segments during transition.
                    canvas.selectAll('path').on('mouseover', null);
                    // fade all nodes back in
                    canvas
                        .selectAll('path')
                        .style('opacity', 1)
                        .on('mouseover', mouseover);
                }
                scope.activeGoal = null;
                scope.$apply();
            }
            /**
             * @method mouseover
             * @param  {object} d the node the mouse is over
             * @returns {void}
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
            function mouseover(d) {
                if (!isFiltered) {
                    var sequenceArray = getAncestors(d);
                    // Fade all the nodes out
                    canvas.selectAll('path').style('opacity', 0.15);
                    // Then highlight only those nodes that are an ancestor of the current node.
                    canvas
                        .selectAll('path')
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
                        .filter(function (node) {
                        return sequenceArray.indexOf(node) >= 0;
                    })
                        .style('opacity', 1);
                    scope.activeGoal = d.data;
                    scope.$apply();
                }
                else {
                    // for filtered goals, only show the goal for
                    // highlighted goals
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'map' implicitly has an 'any' type.
                    var dataMap = scope.highlightedItems.reduce(function (map, goal) {
                        map[goal.id] = goal;
                        return map;
                    }, {});
                    scope.activeGoal = dataMap[d.data.id] ? d.data : null;
                    scope.$apply();
                }
            }
            /**
             * @method mousemove
             * @param event {Event}
             * @returns {void}
             * When a user mouse moves over a node on the chart
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
            function mousemove(event) {
                if (scope.activeGoal) {
                    scope.goalCardTop = event.clientY - 200;
                    scope.goalCardLeft = event.clientX + 50;
                    if (scope.hoverLeft) {
                        scope.goalCardLeft = event.clientX - 425;
                    }
                    scope.$apply();
                }
            }
            /**
             * @function onDestroy
             * Called when this directive is destroyed.
             */
            function onDestroy() {
                // Remove window resize listener
                angular.element($window).off('resize', drawChart);
            }
        }
    }
})();

(function () {
    angular
        .module('App.Util')
        .directive('adaptiveInsightsMapPlans', [
        '$state',
        '$window',
        'd3Service',
        'PlansService',
        AdaptiveInsightsMapPlans,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$state' implicitly has an 'any' type.
    function AdaptiveInsightsMapPlans($state, $window, d3Service, PlansService) {
        return {
            link: link,
            restrict: 'E',
            scope: {
                activePlan: '=',
                includeAllPlans: '<?',
                supportingPlans: '<',
                topLevelPlans: '<',
                highlightedItems: '=',
            },
            template: '',
        };
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope, element) {
            /**
             * @listener $destroy
             * When this directive is removed from the DOM, remove listeners from window.
             */
            scope.$on('$destroy', onDestroy);
            /**
             * @property chartWidth
             * @type {Number}
             */
            var chartWidth;
            /**
             * @property chartHeight
             * @type {Number}
             */
            var chartHeight;
            /**
             * @property isFiltered
             * @type {Boolean}
             * have the supporting goals been filtered down
             */
            var isFiltered = false;
            /**
             * @property lazyDrawChart
             * @type {object}
             * when an update to the plans or window resize
             */
            var lazyDrawChart = _.debounce(drawChart, 50);
            /**
             * @property lazyMouseleave
             * @type {object}
             * when you mouse leave a node
             */
            var lazyMouseleave = _.debounce(mouseleave, 50);
            /**
             * @property sunburstRadius
             * @type {number}
             */
            var sunburstRadius;
            /**
             * @property canvas
             * @type {object}
             * the HTML element that hold the svg element
             */
            var canvas = d3Service.d3.select(element[0]).append('svg:svg');
            /**
             * @property svg
             * @type {object}
             */
            var svg = canvas.append('svg:g').on('mouseleave', lazyMouseleave);
            /**
             * @property partition
             * @type {object}
             * This sections off each partition of the ring
             * and makes them equal in size. (return 1)
             * If we want to make the partitions vary in size by number of
             * goals we can return the number of goals, or number of child plans
             */
            var partition = d3Service.d3.partition();
            /**
             * @property arc
             * @type {object}
             * tells D3 how to draw the sunburst arcs
             */
            var arc = d3Service.d3
                .arc()
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                .startAngle(function (d) {
                return d.x0;
            })
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                .endAngle(function (d) {
                return d.x1;
            })
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                .innerRadius(function (d) {
                return Math.sqrt(d.y0);
            })
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                .outerRadius(function (d) {
                return Math.sqrt(d.y1);
            });
            /**
             * @property goalCardTop
             * @type {String}
             * for moving the goal card to follow the mouse,
             * this is the top number (pixels)
             */
            scope.planCardTop = '';
            /**
             * @property goalCardLeft
             * @type {String}
             * for moving the goal card to follow the mouse,
             * this is the left number (pixels)
             */
            scope.planCardLeft = '';
            init();
            /**
             * @method  buildPlanHierarchyData
             * @property {object} data the hierarchy data from back-end
             * @return {object} tree data that d3 can use to build the tree
             * This takes the hierarchy data and converts it into tree
             * structure that d3 can use to display
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'data' implicitly has an 'any' type.
            function buildPlanHierarchyData(data) {
                var rawData = angular.copy(data), planMap = _.keyBy(rawData, 'id'), rootNode = {
                    title: 'root',
                    children: [],
                };
                _.forEach(rawData, function (plan) {
                    if (plan.state === 2 || scope.includeAllPlans) {
                        var parentPlan = getParentPlan(plan, planMap, rootNode);
                        (parentPlan.children || (parentPlan.children = [])).push(plan);
                    }
                });
                return rootNode;
            }
            /**
             * @function getParentPlan
             * @param {object} plan
             * @param {object} allPlansMap
             * @param {object} rootNode
             * @returns {object}
             */
            // @ts-ignore ts-migrate(7023) FIXME: 'getParentPlan' implicitly has return type 'any' b... Remove this comment to see the full error message
            function getParentPlan(plan, planMap, rootNode) {
                var parentPlan = planMap[plan.parentPlanId];
                if (!parentPlan) {
                    return rootNode;
                }
                else {
                    if (parentPlan.state === 2 || scope.includeAllPlans) {
                        return parentPlan;
                    }
                    else {
                        return getParentPlan(parentPlan, planMap, rootNode);
                    }
                }
            }
            /**
             * @method click
             * @param  {object} d the plan node
             * @return {none}
             * sends the person to the plan
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
            function click(d) {
                localStorage.removeItem("plan-tab");
                $state.go('app.plans.show', {
                    planId: d.data.id,
                });
            }
            /**
             * @method drawChart
             * @return {none}
             * Draws the sunburst chart
             */
            function drawChart() {
                chartWidth = element.parent()[0].offsetWidth - 30;
                chartHeight = 0.75 * chartWidth;
                sunburstRadius = Math.min(chartWidth, chartHeight) / 2;
                // resize the canvas
                canvas.attr('width', chartWidth).attr('height', chartHeight);
                // move the svg
                svg.attr('transform', 'translate(' + chartWidth / 2 + ',' + chartHeight / 2 + ')');
                // resize the partitions
                partition.size([2 * Math.PI, sunburstRadius * sunburstRadius]);
                drawChartNodes();
            }
            /**
             * @method drawChartNodes
             * @return {none}
             * Called on plan data update, this builds out the
             * sunburst chart
             */
            function drawChartNodes() {
                // merge the two plan types into one array
                var plans = angular.copy(scope.topLevelPlans);
                plans = plans.concat(scope.supportingPlans);
                // build out the tree data
                var json = buildPlanHierarchyData(plans);
                var root = d3Service.d3.hierarchy(json).count();
                var nodes = partition(root).descendants();
                // draw each node
                svg
                    .data([json]).selectAll('path')
                    .data(nodes)
                    .enter().append('svg:path')
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                    .attr('display', function (d) {
                    return d.depth ? null : 'none';
                })
                    .attr('d', arc)
                    .attr('fill-rule', 'evenodd')
                    .style('stroke', '#fff')
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                    .style('fill', function (d) {
                    return getNodeColor(d);
                })
                    .style('opacity', 1)
                    .on('mouseover', mouseover)
                    .on('click', click);
                highlightFilteredListPlans();
            }
            /**
             * @method getAncestors
             * @param  {object} node the plan node
             * @return {array}      array of ancestors
             * Given a node in a partition layout, return an array of all of its ancestor
             * nodes, highest first, but excluding the root.
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
            function getAncestors(node) {
                var path = [];
                var current = node;
                while (current.parent) {
                    path.unshift(current);
                    current = current.parent;
                }
                return path;
            }
            /**
             * @method getNodeColor
             * @param  {object} plan - the plan node
             * @return {string}
             * returns the color value for the node
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'plan' implicitly has an 'any' type.
            function getNodeColor(plan) {
                PlansService.setPlanAimStatus(plan.data);
                if (plan.data.aim) {
                    return plan.data.aim.status.color;
                }
                else {
                    return '#818A91';
                }
            }
            /**
             * @method highlightFilteredListPlans
             * @returns {void}
             * When a user clicks on the attribute table to
             * filter down the goals by attribute, this will highlight
             * the filtered goals
             */
            function highlightFilteredListPlans() {
                // filters out all plans that are completed or suspended because they 
                // are set to be hidded on default
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'plan' implicitly has an 'any' type.
                var defaultHighlighted = scope.highlightedItems.filter(function (plan) { return plan.state !== 3 && plan.state !== 4; });
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'plan' implicitly has an 'any' type.
                var defaultTopLevel = scope.topLevelPlans.filter(function (plan) { return plan.state !== 3 && plan.state !== 4; });
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'plan' implicitly has an 'any' type.
                var defaultSupporting = scope.supportingPlans.filter(function (plan) { return plan.state !== 3 && plan.state !== 4; });
                // if the user has filtered down the supporting goals
                // only should run if filters are selected
                if (defaultHighlighted.length !==
                    defaultTopLevel.length + defaultSupporting.length) {
                    // build a map of goal id of the filtered list
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'map' implicitly has an 'any' type.
                    var dataMap = scope.highlightedItems.reduce(function (map, plan) {
                        map[plan.id] = plan;
                        return map;
                    }, {});
                    // Fade all the nodes out
                    d3Service.d3
                        .select('adaptive-insights-map-plans')
                        .selectAll('path')
                        .style('opacity', 0.1);
                    // cycle through each graph node and if there is a match
                    // highlight that node
                    d3Service.d3
                        .select('adaptive-insights-map-plans')
                        .selectAll('path')
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                        .style('opacity', function (d) {
                        return dataMap[d.data.id] ? 1 : 0.1;
                    });
                    isFiltered = true;
                }
                else {
                    isFiltered = false;
                    d3Service.d3
                        .select('adaptive-insights-map-plans')
                        .selectAll('path')
                        .style('opacity', 1);
                }
            }
            /**
             * @method  init
             * @return {none}
             * Initialize directive
             */
            function init() {
                // Note: event must be removed from window in onDestroy
                angular.element($window).on('resize', drawChart);
                scope.$watch('topLevelPlans', lazyDrawChart);
                scope.$watch('supportingPlans', lazyDrawChart);
                scope.$watch('highlightedItems', highlightFilteredListPlans);
            }
            /**
             * @method mouseleave
             * @return {none}
             */
            function mouseleave() {
                if (!isFiltered) {
                    // Deactivate all segments during transition.
                    canvas.selectAll('path').on('mouseover', null);
                    // fade all nodes back in
                    canvas
                        .selectAll('path')
                        .style('opacity', 1)
                        .on('mouseover', mouseover);
                }
                else {
                    highlightFilteredListPlans();
                }
                // hide the plan details
                scope.activePlan = null;
                scope.$apply();
            }
            /**
             * @method mouseover
             * @param  {object} d the node the mouse is over
             * @return {none}
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
            function mouseover(d) {
                var sequenceArray = getAncestors(d);
                // Fade all the nodes out
                canvas.selectAll('path').style('opacity', 0.15);
                // Then highlight only those nodes that are an ancestor of the current node.
                canvas
                    .selectAll('path')
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
                    .filter(function (node) {
                    return sequenceArray.indexOf(node) >= 0;
                })
                    .style('opacity', 1);
                scope.activePlan = d.data;
                scope.$apply();
            }
            /**
             * @method mousemove
             * @param event {Event}
             * @returns {void}
             * When a user mouse moves over a node on the chart
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
            function mousemove(event) {
                if (scope.activePlan) {
                    scope.planCardTop = event.clientY;
                    scope.planCardLeft = event.clientX + 50;
                    scope.$apply();
                }
            }
            /**
             * @function onDestroy
             * @private
             */
            function onDestroy() {
                // Remove resize listener from window
                angular.element($window).off('resize', drawChart);
            }
        }
    }
})();

(function () {
    var ua = window.navigator.userAgent.toLowerCase();
    /**
     * @property isMSBrowser
     * @type {boolean}
     * This value is independent of the app, so define it once in this IIFE.
     */
    var isMSBrowser = ua.indexOf('edge/') !== -1 || ua.indexOf('trident/') !== -1;
    /**
     * @property isFireFox
     * @type {boolean}
     */
    var isFirefox = ua.indexOf('firefox') !== -1 && !isMSBrowser;
    angular
        .module('App.Util')
        .directive('aggregateHierarchy', [
        '$filter',
        '$state',
        'AuthenticationService',
        'd3Service',
        'KPIsService',
        'TEMPLATE_PATH',
        aggregateHierarchy,
    ]);
    /**
     * @directive chart-hierarchy
     *
     * Visual display of managers and direct reports based on D3.
     */
    function aggregateHierarchy($filter, $state, AuthenticationService, d3Service, KPIsService, TEMPLATE_PATH) {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter '$filter' implicitly has an 'any' type.
        var DirectiveDefinition = {
            link: link,
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd3Service' implicitly has an 'any' type... Remove this comment to see the full error message
            restrict: 'E',
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TEMPLATE_PATH' implicitly has an 'any' ... Remove this comment to see the full error message
            scope: {
                hierarchyData: '<',
                primaryKpiId: '@',
                kpi: '<',
                onChangeTab: '&',
            },
            templateUrl: TEMPLATE_PATH + '/util/chart-hierarchy/util.chart-hierarchy.html',
        };
        return DirectiveDefinition;
        function link(scope) {
            /**
             * @property fn
             * @type {object}
             * functions
             * */
            scope.fn = {
                expand: expand,
                collapse: collapse,
            };
            /**
             * @property currentKpiId
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
             * @type {number}
             */
            var currentKpiId = scope.primaryKpiId;
            /**
             * @property hierarchyTreeData
             * @type {Array}
             */
            var hierarchyTreeData;
            /**
             * @property rootNode
             * @type {Object}
             * The primary tree node, first in line
             */
            var rootNode;
            /**
             * @property animationDuration
             * @type {number}
             */
            var animationDuration = 200;
            /**
             * @property maxCharacters
             * @type {number}
             * Due to the fact we are drawing text, this will limit
             * the amount of characters displayed for names and titles
             */
            var maxCharacters = 18;
            /**
             * @property cardWidth
             * @type {number}
             */
            var cardWidth = 300;
            /**
             * @property cardHeight
             * @type {number}
             */
            var cardHeight = 80;
            /**
             * @property isPlanAdmin
             * @type {boolean}
             * Plan Admins can see everything, so link this card to the KPI if true
             */
            var isPlanAdmin = AuthenticationService.hasPermission('ADMIN_PLANS');
            var treeData = {};
            var root = {};
            /**
             * @property tree
             * @type {object}
             */
            var tree = d3Service.d3.tree().nodeSize([cardHeight + 50, cardWidth + 80]);
            /**
             * @property diagonal
             * @type {function}
             * this positions the node on the link lines
             */
            var diagonal = function link(d) {
                return "M" + d.source.y + "," + d.source.x
                    + "C" + (d.source.y + d.target.y) / 2 + "," + d.source.x
                    + " " + (d.source.y + d.target.y) / 2 + "," + d.target.x
                    + " " + d.target.y + "," + d.target.x;
            };
            /**
             * @property canvas
             * @type {object}
             * the HTML element that hold the svg element
             */
            var canvas = d3Service.d3.select('#hierarchy-canvas');
            /**
             * @property svg
             * @type {object}
             */
            var svg = canvas.append('svg').attr('shape-rendering', 'optimizeSpeed');
            /**
             * @property nodesContainer
             * @type {object}
             * HTML element that contains all of the tree nodes
             */
            var nodesContainer = svg.append('g').attr('id', 'container-nodes');
            /**
             * @property definitions
             * @type {object}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
             * sometime svg needs to reference another HTML element
             * to manipulate images, gradients, etc. This HTML element
             * will hold all of the needed definitions.
             */
            var defs = nodesContainer.append('defs');
            /**
             * @property lazyResizeCanvas
             * @type {function}
             */
            var lazyResizeCanvas = _.debounce(resizeCanvas, 50);
            /**
             * @property userId
             * @type {number}
             * Used to see if the current user is a plan owner/participant or kpi assignee.
             */
            var userId = AuthenticationService.getAccount().userId;
            /**
             * @property isLoaded
             * @type {boolean}
             * Don't show the hierarchy graph until we are ready.
             */
            scope.isLoaded = false;
            /**
             * @property isShowGraph
             * @type {boolean}
             * Don't show the hierarchy graph to Microsoft browsers.
             */
            scope.isShowGraph = !isMSBrowser;
            var resizeObserver = new ResizeObserver(function () {
                resizeCanvas();
            });
            scope.$onDestroy = function () {
                var gNodes = svg.selectAll('g#container-nodes');
                resizeObserver.unobserve(gNodes._groups[0][0]);
            };
            init();
            /**
             * @method alphabetizeChildren
             */
            function alphabetizeChildren(children) {
                return _.orderBy(children, ['title'], ['asc']);
            }
            /**
             * @method init
             */
            function init() {
                treeData = hierarchyTreeData = buildHierarchyTreeData(scope.hierarchyData);
                rootNode = hierarchyTreeData[0];
                root = d3Service.d3.hierarchy(rootNode, function (d) { return d.children; });
                // @ts-ignore
                root.x0 = 0;
                // @ts-ignore
                root.y0 = 0;
                var gNodes = svg.selectAll('g#container-nodes');
                resizeObserver.observe(gNodes._groups[0][0]);
                scope.isLoaded = true;
                collapseAll(root);
                draw(root);
            }
            function collapseAll(d) {
                if (d.children) {
                    d._children = d.children;
                    d._children.forEach(collapseAll);
                    d.children = null;
                }
            }
            /**
             * @method collapse
             * @returns {none}
             * Collapse expanded nodes to the *DEFAULT* expanse. Does not collapse to the root node.
             */
            function collapse() {
                collapseAll(root);
                draw(root);
            }
            /**
             * @method expand
             * @returns {none}
             */
            function expand() {
                expandNode(root);
                draw(root);
            }
            /**
             * @method  expandNode
             * @property {object} node a single tree node
             * Expands a single node in the tree
             */
            function expandNode(node) {
                if (node._children) {
                    node.children = node._children;
                    delete node._children;
                }
                _.forEach(node.children, expandNode);
            }
            /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'children' implicitly has an 'any' type.
             * @method  buildHierarchyTreeData
             * @param data {object} - the hierarchy data from back-end
             * @returns {Array} - tree data that d3 can use to build the tree
             * This takes the hierarchy data and converts it into tree
             * structure that d3 can use to display
             */
            function buildHierarchyTreeData(data) {
                var rawData = angular.copy(data), treeData = [], 
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                dataMap = _.keyBy(rawData, 'id');
                _.forEach(rawData, function (node, key) {
                    node.hierarchyId = key;
                    var manager = dataMap[node.aggregateParentKpis[0]];
                    if (manager) {
                        (manager.children || (manager.children = [])).push(node);
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                        manager.children = alphabetizeChildren(manager.children);
                    }
                    else {
                        treeData.push(node);
                    }
                });
                return treeData;
            }
            /**
             * @method clickNodeEvent
             * @property {object} node a single tree node
             * Handles when the each node in the tree
             * is clicked expanding and contracting the org chart.
             */
            function clickNodeEvent(node) {
                toggleNodeChildren(node);
                draw(node);
            }
            /**
             * @method toggleNodeChildren
             * @param  {object} node a single tree node
             * If the node has children, this will toggle
             * them to either show or hide on the tree
             */
            function toggleNodeChildren(node) {
                if (node.children) {
                    node._children = node.children;
                    delete node.children;
                }
                else {
                    node.children = node._children;
                    delete node._children;
                }
            }
            /**
             * @method goToKpi
             * @param  {object} node a single tree node
             */
            function goToKpi(node) {
                if (node.data.linkable) {
                    $state
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
                        .go('app.plans.kpi.show', {
                        planId: node.data.plan.id,
                        kpiId: node.data.id,
                    })
                        .finally(scope.onChangeTab());
                }
            }
            /**
             * @method getTranslateStyle
             * @param  {number} x the x position
             * @param  {number} y the y position
             * @returns {string} the CSS style to apply
             */
            function getTranslateStyle(x, y) {
                var style = 'transform: ' + 'translate(' + x + 'px, ' + y + 'px); ';
                style += '-ms-transform: ' + 'translate(' + x + 'px, ' + y + 'px); ';
                style += '-webkit-transform: ' + 'translate(' + x + 'px, ' + y + 'px); ';
                return style;
            }
            /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'data' implicitly has an 'any' type.
             * @method getInvertedTranslateStyle
             * @param  {number} y the y position
// @ts-ignore ts-migrate(7034) FIXME: Variable 'treeData' implicitly has type 'any[]' in... Remove this comment to see the full error message
             * @param  {number} x the x position
             * @returns {string} the CSS style to apply
             */
            function getInvertedTranslateStyle(y, x) {
                var a = y, b = x;
                return getTranslateStyle(a, b);
            }
            /**
             * @function getIsLinkable
             * @returns {boolean}
             * @private
             * Decide if the user can click on this card.
             * Note: Plan may be undefined.
             */
            function getIsLinkable(kpi) {
                // Plan Admin users can see everything
                var isPass = isPlanAdmin;
                if (!isPass && angular.isArray(kpi.assignees) && kpi.assignees.indexOf(userId) !== -1) {
                    // @ts-ignore ts-migrate(7005) FIXME: Variable 'treeData' implicitly has an 'any[]' type... Remove this comment to see the full error message
                    // User is assigned the KPI
                    isPass = true;
                }
                if (!isPass && kpi.plan) {
                    // Current plan == KPI plan
                    // If the KPI plan != the current plan, the KPI is view only.
                    if (angular.isArray(kpi.plan.ownerSet) && kpi.plan.ownerSet.indexOf(userId) !== -1) {
                        // User owns the plan
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
                        isPass = true;
                    }
                }
                return isPass;
            }
            /**
             * @method formatDate
             * @param date {string} - date to format
             * @returns {string} - formatted string
             */
            function formatDate(date) {
                var d = new Date(date);
                // normalize date to timezone from UTC
                d.setDate(d.getUTCDate());
                var month = d.getMonth() + 1, day = d.getDate();
                return month + '/' + day;
            }
            /**
             * @method trimText
             * @param text {string} - the text to trim
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
             * @returns {string} - the trimmed text
             * Since all of this is drawn and there is no wrapping of
             * text, this will truncate long names and titles
             */
            function trimText(text) {
                text = text.trim();
                if (text.length <= maxCharacters) {
                    return text;
                }
                return text.substring(0, maxCharacters) + '...';
            }
            /**
             * @method draw
             * @param source {object} - a single tree node
             */
            function draw(source) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
                var treeData = tree(root);
                var nodes = treeData.descendants();
                var links = treeData.descendants().slice(1);
                // this build an array of the nodes
                // as their id as the identifier
                var node = nodesContainer.selectAll('g.node').data(nodes, function (node) {
                    return node.data.hierarchyId;
                });
                // Enter any new nodes at the parent's previous position.
                // "Enter" reduces the nodes to just the ones that are new
                var nodeEnter = node
                    .enter()
                    .append('g')
                    .attr('style', function (node) {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'x' implicitly has an 'any' type.
                    var x = (node.parent && node.parent.x0) || (source && source.x0) || 0, y = (node.parent && node.parent.y0) || (source && source.y0) || 0;
                    return getTranslateStyle(y, x);
                });
                // the rectangular container
                nodeEnter
                    .append('rect')
                    .attr('class', 'rectangle')
                    .attr('height', cardHeight)
                    .attr('width', cardWidth)
                    .attr('style', function () {
                    return getTranslateStyle(cardHeight / -2, cardHeight / -2);
                })
                    .on('click', clickNodeEvent);
                // adds the kpi title
                nodeEnter
                    .append('text')
                    .attr('class', function (d) {
                    d.data.linkable = true;
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'y' implicitly has an 'any' type.
                    var titleClass = 'kpi-title';
                    if (!getIsLinkable(d)) {
                        titleClass += ' no-link-title';
                        d.data.linkable = false;
                    }
                    return titleClass;
                })
                    .text(function (d) {
                    var title = d.data.title;
                    return trimText(title);
                })
                    .on('click', goToKpi);
                // adds the kpi's most recent actual date
                nodeEnter
                    .append('text')
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'kpi' implicitly has an 'any' type.
                    .attr('class', 'kpi-date')
                    .text(function (d) {
                    return ((d.data.actualSeries.newestPoint && formatDate(d.data.actualSeries.newestPoint.date)) || '');
                });
                //add the kpi's most recent actual data point
                nodeEnter
                    .append('text')
                    .text(function (d) {
                    var newestPoint;
                    if (d.data.actualSeries.newestPoint) {
                        newestPoint = $filter('kpiPointFormat')(d.data.actualSeries.newestPoint.number, KPIsService.getDataPointFilter(d.data.type), d.data.displayPrecision);
                    }
                    else {
                        newestPoint = 'N/A';
                    }
                    d.data.pointLength = _.size(newestPoint);
                    return newestPoint;
                })
                    .attr('class', function (d) {
                    return 'kpi-data-point status' + d.data.status;
                })
                    .attr('text-anchor', 'end')
                    .attr('x', cardWidth - 65)
                    .attr('y', -4);
                //add the kpi's plan actual delta
                nodeEnter
                    .append('text')
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'date' implicitly has an 'any' type.
                    .attr('class', 'kpi-plan-delta')
                    .text(function (d) {
                    return $filter('kpiPointFormat')(KPIsService.calculatePlanActualDelta(d.data.actualSeries.newestPoint, {
                        actual: d.data.actualSeries,
                        plan: d.data.planSeries,
                    }), KPIsService.getDataPointFilter(d.data.type), d.data.displayPrecision);
                })
                    .attr('text-anchor', 'end')
                    .attr('x', cardWidth - 65)
                    .attr('y', 12);
                // add the kpi's number of children text
                nodeEnter
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'text' implicitly has an 'any' type.
                    .append('text')
                    .attr('class', 'kpi-children-count')
                    .attr('text-anchor', 'end')
                    .text(function (node) {
                    return ((node.children && node.children.length) ||
                        (node._children && node._children.length) ||
                        0);
                })
                    .on('click', clickNodeEvent);
                var nodeUpdate = nodeEnter.merge(node);
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'source' implicitly has an 'any' type.
                // Transition nodes to their new position.
                nodeUpdate.transition()
                    .duration(animationDuration)
                    //.each('end', lazyResizeCanvas)
                    .attr('style', function (node) {
                    return getInvertedTranslateStyle(node.y, node.x);
                });
                // updates all nodes on refresh
                nodeUpdate
                    .attr('class', function (node) {
                    var classNames = 'node active';
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
                    if (node.children || node._children) {
                        classNames += ' has-children';
                        if (node._children) {
                            classNames += ' hidden-children';
                        }
                    }
                    return classNames;
                });
                // Transition exiting nodes to the parent's new position.
                node
                    .exit()
                    .transition()
                    .duration(animationDuration)
                    .attr('style', function (node) {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
                    return getInvertedTranslateStyle(node.parent.y, node.parent.x);
                })
                    .remove();
                // Update the links…
                var link = nodesContainer.selectAll('path.link').data(links, function (link) {
                    return link.hierarchyId;
                });
                // Enter any new links at the parent's previous position.
                var linkEnter = link.enter()
                    .insert('path', 'g')
                    .attr('class', function (s) {
                    return 'link linkStatus' + s.status;
                })
                    .attr('d', function (d) {
                    var ret = "M" + d.y + "," + d.x
                        + "C" + (d.y + d.parent.y) / 2 + "," + d.x
                        + " " + (d.y + d.parent.y) / 2 + "," + d.parent.x
                        + " " + d.parent.y + "," + d.parent.x;
                    return ret;
                });
                var linkUpdate = linkEnter.merge(link);
                // Transition links to their new position.
                linkUpdate
                    .transition()
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                    .duration(animationDuration)
                    .attr('d', function (d) {
                    var ret = "M" + d.y + "," + d.x
                        + "C" + (d.y + d.parent.y) / 2 + "," + d.x
                        + " " + (d.y + d.parent.y) / 2 + "," + d.parent.x
                        + " " + d.parent.y + "," + d.parent.x;
                    return ret;
                });
                // Transition exiting nodes to the parent's new position.
                link
                    .exit()
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                    .transition()
                    .duration(animationDuration)
                    .attr('d', function (d) {
                    var ret = "M" + d.y + "," + d.x
                        + "C" + (d.y + d.parent.y) / 2 + "," + d.x
                        + " " + (d.y + d.parent.y) / 2 + "," + d.parent.x
                        + " " + d.parent.y + "," + d.parent.x;
                    return ret;
                })
                    .remove();
                // Stash the old positions for transition.
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                _.forEach(links, function (node) {
                    node.x0 = node.x;
                    node.y0 = node.y;
                });
            }
            /**
             * Because there is no method to get the current height of
             * the d3 tree, I had to wrap the tree in a bounding box
             * that will allow the container and canvas to be responsive
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
             * in vertical height. Width is handled with css overflow.
             */
            function resizeCanvas() {
                var minHeight;
                var yMargin = 50;
                var nodesArray = nodesContainer._groups;
                var rectangle = nodesArray[0][0].getBoundingClientRect(); //nodesContainer[0][0].getBoundingClientRect();
                minHeight = rectangle.height + yMargin * 2;
                // set the height of the svg element
                svg.attr('height', minHeight);
                //set the width of the svg element if needed
                var containerWidth = svg._groups[0][0].parentNode.clientWidth;
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                // TODO: Find permanent fix for FireFox bounding box width
                // FireFox's value for the bounding box width is different.
                var fudge = isFirefox ? cardWidth / 2 : 0;
                if (rectangle.width + fudge > containerWidth) {
                    // without the extra 0% the width will explode the view, hack!
                    svg.attr('style', 'width: calc(0% + ' + (200 + rectangle.width) + 'px);');
                }
                else {
                    // Remove style tag
                    svg.attr('style', null);
                }
                /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                 * The following is to center the nodeContainer vertically.
                 * The problem is that the tree is not always centered, meaning
                 * sometimes it adds tree nodes more on the top then bottom. So you
                 * have to go through the nodes, find the extremes, subtract the extremes
                 * and then divide by 2 and then subtract that from the height of
                 * the bounding box. Thus the tree will also be vertically centered.
                 */
                var extremeHigh = 0;
                var extremeLow = 0;
                var nodes = tree(root);
                var allNodes = nodes.descendants().slice(1);
                _.forEach(allNodes, function (node) {
                    if (node.x < extremeLow) {
                        extremeLow = node.x;
                    }
                    if (node.x > extremeHigh) {
                        extremeHigh = node.x;
                    }
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
                });
                var newPosition = (minHeight / 2 - (extremeLow + extremeHigh) / 2) - 25;
                nodesContainer.attr('style', function () {
                    return getTranslateStyle(80, newPosition);
                });
            }
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.

(function () {
    /*
    |--------------------------------------------------------------------------
    | Analysis modal.
    |--------------------------------------------------------------------------
    |
    | This will open the analysis modal window and use Watson to return
    | the tone analysis results. Simply pull "AnalysisModal" into your
    | controller and call the method AnalysisModal.open(message to analyze);
    | Watson can handle both plain text and html.
    |
    */
    angular
        .module('App.Util')
        .controller('AnalysisModalController', [
        '$rootScope',
        '$scope',
        '$uibModalInstance',
        'AnalysisModalConfig',
        'AnalysisService',
        AnalysisModalController,
    ])
        .factory('AnalysisModal', ['$uibModal', 'TEMPLATE_PATH', AnalysisModal]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$uibModal' implicitly has an 'any' type... Remove this comment to see the full error message
    function AnalysisModal($uibModal, TEMPLATE_PATH) {
        /**
         * @property service
         * @type {Object}
         * Exposed methods for the factory
         */
        var service = {
            open: open,
        };
        // expose the factory methods
        return service;
        /**
         * @method open
         * @param  {string} message the message to analyze
         * @return {modal}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'message' implicitly has an 'any' type.
        function open(message) {
            var modalInstance = $uibModal.open({
                animation: true,
                controller: 'AnalysisModalController',
                controllerAs: 'modalVm',
                resolve: {
                    AnalysisModalConfig: function () {
                        return {
                            message: message,
                        };
                    },
                },
                size: 'lg',
                templateUrl: TEMPLATE_PATH + '/util/analysis-modal/util.analysis-modal.html',
            });
            return modalInstance.result;
        }
    }
    function AnalysisModalController(
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$rootScope' implicitly has an 'any' typ... Remove this comment to see the full error message
    $rootScope, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$scope' implicitly has an 'any' type.
    $scope, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$uibModalInstance' implicitly has an 'a... Remove this comment to see the full error message
    $uibModalInstance, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AnalysisModalConfig' implicitly has an ... Remove this comment to see the full error message
    AnalysisModalConfig, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AnalysisService' implicitly has an 'any... Remove this comment to see the full error message
    AnalysisService) {
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        /**
         * @property $onInit
         * @type {listener}
         */
        vm.$onInit = init;
        /**
         * @property analysis
         * @type {Array}
         * Holds the analysis results
         */
        vm.analysis = [];
        /**
         * @property config
         * @type {[type]}
         */
        vm.config = AnalysisModalConfig;
        /**
         * @property isLoaded
         * @type {Boolean}
         * Has the analysis returned from the server
         */
        vm.isLoaded = false;
        /**
         * @property fn
         * @type {Object}
         * exposed methods
         */
        vm.fn = {
            cancel: cancel,
        };
        /**
         * @function init
         * @return {none}
         */
        function init() {
            if (vm.config.message) {
                // hit the service for the analysis
                AnalysisService.analyze(vm.config.message)
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                    .then(function getAnalysisSuccess(response) {
                    vm.analysis = response;
                })
                    .finally(function () {
                    vm.isLoaded = true;
                });
            }
            else {
                cancel();
            }
        }
        /**
         * @method cancel
         * @return {none}
         * Close the modal window
         */
        function cancel() {
            $uibModalInstance.close();
        }
    }
})();

(function () {
    angular
        .module('App.Util')
        .controller('AttachLinkModalController', [
        '$scope',
        '$rootScope',
        '$uibModalInstance',
        'modalTitle',
        'link',
        'linkText',
        AttachLinkModalController,
    ]);
    function AttachLinkModalController(
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$scope' implicitly has an 'any' type.
    $scope, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$rootScope' implicitly has an 'any' typ... Remove this comment to see the full error message
    $rootScope, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$uibModalInstance' implicitly has an 'a... Remove this comment to see the full error message
    $uibModalInstance, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'modalTitle' implicitly has an 'any' typ... Remove this comment to see the full error message
    modalTitle, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'link' implicitly has an 'any' type.
    link, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'linkText' implicitly has an 'any' type.
    linkText) {
        //config
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        vm.linkText = linkText;
        vm.link = link;
        vm.modalTitle = modalTitle;
        vm.fn = {
            ok: ok,
            cancel: cancel,
        };
        //when the user clicks done
        function ok() {
            // Check for errors
            if (vm.urlForm.$invalid) {
                if (vm.urlForm.link.$invalid) {
                    // URL: required and valid url
                    $rootScope.$emit('notify', 'Please enter a valid URL', 'error');
                }
                else if (vm.urlForm.linkText.$invalid) {
                    // Title: required
                    $rootScope.$emit('notify', 'Please enter text to display', 'error');
                }
                else {
                    // ¯\_(ツ)_/¯
                    $rootScope.$emit('notify', 'There is an unexpected error with the text you entered', 'error');
                }
            }
            else {
                $uibModalInstance.close({
                    text: vm.linkText,
                    link: vm.link,
                });
            }
        }
        //if the user cancels
        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    angular
        .module('App.Util')
        .factory('AttachmentsModal', [
        '$rootScope',
        '$uibModal',
        'TEMPLATE_PATH',
        AttachmentsModalFactory,
    ])
        .controller('AttachmentsModalController', [
        '$scope',
        '$uibModalInstance',
        AttachmentsModalController,
    ]);
    /**
     * @factory AttachmentsModalFactory
     * @constructor
     * Simplifies opening the modal to view/change attachments.
     * Usage:
     *   AttachmentsModal.open({
     *     ...
     *   });
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$rootScope' implicitly has an 'any' typ... Remove this comment to see the full error message
    function AttachmentsModalFactory($rootScope, $uibModal, TEMPLATE_PATH) {
        var service = {
            open: open,
        };
        return service;
        /**
         * @method open
         * @param options {object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'options' implicitly has an 'any' type.
        function open(options) {
            var allowedOptions = [
                'files',
                'isAdminContext',
                'isReadOnly',
                'links',
                'onDestroy',
                'onChange',
                'onUpload',
                'isTemplateTopic',
            ], ms = _.merge($rootScope.$new(true), _.pick(options, allowedOptions));
            return $uibModal
                .open({
                animation: true,
                controller: 'AttachmentsModalController',
                controllerAs: 'modalVm',
                scope: ms,
                size: 'md',
                templateUrl: TEMPLATE_PATH + '/util/attachments-modal/attachments-modal.html',
            })
                .result.then(angular.noop, angular.noop);
        }
    }
    /**
     * @controller AttachmentsModalController
     * @constructor
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$scope' implicitly has an 'any' type.
    function AttachmentsModalController($scope, $uibModalInstance) {
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        vm.attachments = _.cloneDeep($scope.files);
        vm.fn = {
            close: $uibModalInstance.dismiss,
        };
        vm.isTemplateTopic = !!$scope.isTemplateTopic;
        vm.isAdminContext = !!$scope.isAdminContext;
        vm.isReadOnly = !!$scope.isReadOnly;
        vm.links = _.cloneDeep($scope.links);
        vm.onChange = $scope.onChange;
        vm.onDestroy = $scope.onDestroy;
        vm.onUpload = $scope.onUpload;
    }
})();

(function () {
    angular
        .module('App.Util')
        .controller('AttendeeModalController', ['$scope', '$uibModalInstance', AttendeeModalController])
        .factory('AttendeeModal', ['$rootScope', '$uibModal', 'TEMPLATE_PATH', AttendeeModalFactory]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$rootScope' implicitly has an 'any' typ... Remove this comment to see the full error message
    function AttendeeModalFactory($rootScope, $uibModal, TEMPLATE_PATH) {
        var service = {
            open: open,
        };
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'options' implicitly has an 'any' type.
        function open(options) {
            var ms = $rootScope.$new(true);
            ms.options = options;
            var promise = $uibModal.open({
                animation: true,
                controller: 'AttendeeModalController',
                controllerAs: 'modalVm',
                scope: ms,
                size: 'lg',
                templateUrl: TEMPLATE_PATH + '/util/attendee-modal/util.attendee-modal.html',
                windowClass: 'attendee-modal',
                resolve: {
                    options: options,
                },
            });
            return promise.result;
        }
        return service;
    }
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
    function AttendeeModalController(scope, $uibModalInstance) {
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        /**
         * @property isAllSelected
         * @type {bool}
         */
        vm.isAllSelected = true;
        /**
         * @property isReadOnly
         * @type {bool}
         */
        vm.isReadOnly = scope.options.isReadOnly;
        /**
         * @property people
         * @type {array}
         */
        vm.people = scope.options.participants;
        /**
         * @property immutablePeopleIds
         * @type {Array}
         */
        vm.immutablePeopleIds =
            scope.options.immutablePeopleIds instanceof Array ? scope.options.immutablePeopleIds : [];
        /**
         * @listener $onInit
         */
        vm.$onInit = init;
        vm.fn = {
            ok: ok,
            cancel: cancel,
            isAttendanceOptional: isAttendanceOptional,
            toggleAll: toggleAll,
            toggleAttendee: toggleAttendee,
        };
        /**
         * @property attendeeQuery
         * @type {string}
         * Bound to the search box; used to filter results
         */
        vm.attendeeQuery = '';
        /**
         * @property isSuppressToggleAll
         * @type {bool}
         */
        vm.isSuppressToggleAll = scope.options.isSuppressToggleAll;
        /**
         * @method cancel
         * When the user clicks the cancel button or close button.
         */
        function cancel() {
            $uibModalInstance.close(vm.people);
        }
        /**
         * @function init
         */
        function init() {
            toggleAttendee();
        }
        /**
         * @method isAttendanceOptional
         * @param person {object}
         * @returns {boolean}
         * Returns true if the given person can be marked not attending.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'person' implicitly has an 'any' type.
        function isAttendanceOptional(person) {
            return vm.immutablePeopleIds.indexOf(person.id) !== -1;
        }
        /**
         * @method ok
         * When the user clicks ok.
         */
        function ok() {
            $uibModalInstance.close(vm.people);
        }
        /**
         * @method toggleAll
         * toggle all attendees
         */
        function toggleAll() {
            var toggleStatus = vm.isAllSelected;
            _.forEach(vm.people, function (person) {
                person.isAttendee = toggleStatus;
            });
        }
        /**
         * @method toggleAttendee
         * toggle individual attendee
         */
        function toggleAttendee() {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'person' implicitly has an 'any' type.
            vm.isAllSelected = vm.people.every(function (person) {
                return person.isAttendee;
            });
        }
    }
})();

(function () {
    angular
        .module('App.Util')
        .directive('avatar', [
        'AvatarsService',
        'MessagingService',
        '$state',
        'TEMPLATE_PATH',
        avatarDirective,
    ]);
    /**
     *
     * TODO: The avatar directive cannot be reused in the dom as it is currently implemented.
     *       If the avatar directive is in an ng-repeat, the images will go out of sync if the list is changed
     *       and ng-repeat doesn't use a model-specific track by (e.g. track by item.id).
     *       This forces util.item-picker to use an override of its native template to support a custom (and brittle)
     *       track by. When the avatar directive is rewritten to handle watches, the custom template can be removed.
     *
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AvatarsService' implicitly has an 'any'... Remove this comment to see the full error message
    function avatarDirective(AvatarsService, MessagingService, $state, TEMPLATE_PATH) {
        var DirectiveDefinitionObject = {
            restrict: 'E',
            scope: {
                personId: '=',
                person: '=?',
                size: '@',
                isOnline: '=?',
                badge: '=?',
                showPopover: '@?',
                showDropMenu: '@?',
                dropMenuRight: '@?',
            },
            templateUrl: TEMPLATE_PATH + '/util/avatar/avatar.html',
            link: link,
        };
        return DirectiveDefinitionObject;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope, element, attrs) {
            // for the sunburst directive that updates the avatar on
            // hover, this needs to watch and update on the fly
            scope.$watch('personId', setAvatar);
            // popup template path
            scope.popupTemplateUrl = TEMPLATE_PATH + '/util/avatar/popover-template.html';
            //config
            scope.loading = false;
            scope.hasBadge = !!attrs.badge;
            /**
             * For the drop menu
             * @property
             * @type {String}
             */
            scope.largeAvatarURL = '';
            /**
             * @property dropdownIsOpen
             * @type {Boolean}
             */
            scope.dropdownIsOpen = false;
            //public functions
            scope.fn = {
                showMenu: showMenu,
                goToDM: goToDM,
            };
            init();
            function init() {
                angular.element(element).addClass('loading');
                setAvatar();
                //watch for avatar updates
                AvatarsService.subscribe(setAvatar);
                //update the view when the avatar is loading
                scope.$watch(function () {
                    //get the current avatar timestamp
                    return AvatarsService.getLoading();
                }, 
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'isLoading' implicitly has an 'any' type... Remove this comment to see the full error message
                function (isLoading) {
                    if (isLoading) {
                        scope.loading = true;
                    }
                });
            }
            /**
             * @method goToDM
             * @param personId {number}
             * When "Direct Message" is selected, go to the DM screen
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'personId' implicitly has an 'any' type.
            function goToDM(personId) {
                MessagingService.getDMByPerson(personId).then(
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'room' implicitly has an 'any' type.
                function getDMSuccess(room) {
                    $state.go('app.stream.direct-messages.show', { roomId: room.id });
                }, 
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                function getDMError(response) {
                    console.error('GET AVATAR DM ERROR', response);
                });
            }
            /**
             * Sets both the avatar image and
             * the large image for the drop menu
             * @method setAvatar
             */
            function setAvatar() {
                //get the avatar image
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'image' implicitly has an 'any' type.
                AvatarsService.getUrlByUserId(scope.personId || 0, scope.size).then(function (image) {
                    scope.avatarUrl = image;
                    scope.loading = false;
                    //style for avatars set as a background image
                    scope.style = {
                        'background-image': 'url(' + scope.avatarUrl + ')',
                    };
                    angular.element(element).removeClass('loading');
                    setLargeAvatar();
                });
            }
            /**
             * For the fly-out menu, this will load the larger avatar,
             * only if the menu is active on the directive
             * @method setLargeAvatar
             */
            function setLargeAvatar() {
                if (scope.largeAvatarURL || !scope.showDropMenu) {
                    return;
                }
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'image' implicitly has an 'any' type.
                AvatarsService.getUrlByUserId(scope.personId || 0, 'lg').then(function (image) {
                    scope.largeAvatarURL = image;
                });
            }
            /**
             * Toggles the fly-out menu, if the menu is active on the
             * directive
             * @method showMenu
             * @param  {object} $event the click event
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter '$event' implicitly has an 'any' type.
            function showMenu($event) {
                if (scope.showDropMenu) {
                    $event.preventDefault();
                    $event.stopPropagation();
                    scope.dropdownIsOpen = !scope.dropdownIsOpen;
                }
            }
        }
    }
})();

(function () {
    angular
        .module('App.Util')
        .directive('backButton', ['$rootScope', '$state', 'TEMPLATE_PATH', BackButtonDirective]);
    /**
     * @directive back-button
     * @constructor
     * Displays a left arrow button for navigating back or up.
     * Iterates through navigation history to determine where the user should go.
     * History is kept in memory and erased when the browser reloads.
     * Route and optional params are checked against history. See app.js
     *
     * When `strict=true`, history is NOT checked.
     * This used when only one possible result should ever happen when the user clicks the left arrow.
     *
     * When `allow-recursive-routes=true`, the button can navigate to routes with the *same* name.
     * This was initially implemented to go back through nested supporting plans.
     *
     * The navigation can be prevented by supplying a onChange callback that returns false.
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$rootScope' implicitly has an 'any' typ... Remove this comment to see the full error message
    function BackButtonDirective($rootScope, $state, TEMPLATE_PATH) {
        var DirectiveDefinitionObject = {
            link: link,
            restrict: 'E',
            scope: {
                allowRecursiveRoutes: '@?',
                onChange: '&?',
                params: '=',
                route: '@',
                options: '=',
                strict: '@',
            },
            templateUrl: TEMPLATE_PATH + '/util/back-button/util.back-button.html',
        };
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope) {
            /**
             * @method goBack
             * Determine which state "back" is.
             * Note: Can be prevented if onChange() returns false.
             */
            scope.goBack = function goBack() {
                var resolvedRouteName = $state.get(scope.route).name;
                var options = angular.isObject(scope.options) ? scope.options : {};
                if (!scope.onChange || scope.onChange() !== false) {
                    // There is no callback, or callback doesn't explicitly return false
                    if (scope.strict) {
                        // do not check history, just go to the specified route
                        $state.go(resolvedRouteName, scope.params || {});
                    }
                    else {
                        // step through navigation history to find the best route
                        $rootScope.goBack(resolvedRouteName, scope.params || {}, !!scope.allowRecursiveRoutes, options);
                    }
                }
            };
        }
        return DirectiveDefinitionObject;
    }
})();

(function () {
    angular
        .module('App.Util')
        .directive('bar', ['TEMPLATE_PATH', 'EvaluationsService', BarDirective]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TEMPLATE_PATH' implicitly has an 'any' ... Remove this comment to see the full error message
    function BarDirective(TEMPLATE_PATH, EvaluationsService) {
        var DirectiveDefinitionObject = {
            restrict: 'E',
            link: link,
            scope: {
                cutPointMax: '<',
                cutPointMin: '<',
                direction: '<',
                evaluations: '<',
                currentEvaluationId: '<',
                max: '<',
                values: '=',
            },
            templateUrl: TEMPLATE_PATH + '/util/bar/util.bar.html',
        };
        return DirectiveDefinitionObject;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope) {
            /**
             * default structure of a bar object to be rendered.
             */
            var defaultBar = {
                value: 0,
                barClass: 'bar-default',
                completedOn: '--',
                direction: 0,
                barStyle: {
                    height: '0.1em',
                },
            };
            /**
             * Watch for updates to the past evaluation scores
             */
            scope.$watchCollection('evaluations', draw);
            /**
             * @function draw
             * Displays up to 5 of the last evaluations.
             * When used on a draft evaluation, the first evaluation is the draft.
             */
            function draw() {
                var bars = _.range(5), currentEvaluation = _.find(scope.evaluations, {
                    id: scope.currentEvaluationId,
                }), index = _.indexOf(scope.evaluations, currentEvaluation), currentEvaluationIndex = index === -1 ? 0 : index;
                scope.bars = _.map(bars, function (index) {
                    var evaluation = scope.evaluations[currentEvaluationIndex + index], bar = _.cloneDeep(defaultBar);
                    if (evaluation) {
                        var averageScore = EvaluationsService.getAverageScore(evaluation), cutpointMin = evaluation.evaluationCutpointMin, cutpointMax = evaluation.evaluationCutpointMax, evaluationMax = evaluation.evaluationMax, lowerIsBetter = evaluation.evaluationDirection;
                        bar.value = averageScore;
                        bar.barClass = getBarClassName(averageScore, cutpointMin, cutpointMax, lowerIsBetter);
                        bar.barStyle.height =
                            String(getBarHeight(averageScore, evaluationMax, lowerIsBetter)) + 'em';
                        bar.completedOn = evaluation.completedOnDate || 'Draft';
                    }
                    return bar;
                });
            }
            /**
             * @function getBarClassName
             * @param averageScore {number}
             * @param cutpointMin {number}
             * @param cutpointMax {number}
             * @param lowerIsBetter {boolean}
             * @returns {string}
             * Evaluations with no score get default bars.
             * Below the cut point, green if lower is better, red if higher is better.
             * Above the cut point, red if lower is better, green if higher is better.
             * In between cut points, warning.
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'averageScore' implicitly has an 'any' t... Remove this comment to see the full error message
            function getBarClassName(averageScore, cutpointMin, cutpointMax, lowerIsBetter) {
                if (averageScore === 0) {
                    return 'bar-default';
                }
                else if (averageScore < cutpointMin) {
                    return lowerIsBetter ? 'bar-success' : 'bar-danger';
                }
                else if (averageScore >= cutpointMax) {
                    return lowerIsBetter ? 'bar-danger' : 'bar-success';
                }
                else {
                    return 'bar-warning';
                }
            }
            /**
             * @function getBarHeight
             * @param averageScore {number}
             * @param evalMax {number}
             * @param lowerIsBetter {boolean}
             * @returns {number}
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'averageScore' implicitly has an 'any' t... Remove this comment to see the full error message
            function getBarHeight(averageScore, evalMax, lowerIsBetter) {
                if (averageScore === 0) {
                    return 0.1;
                }
                else if (lowerIsBetter) {
                    return (3 * (evalMax - averageScore)) / evalMax;
                }
                else {
                    return (3 * averageScore) / evalMax;
                }
            }
        }
    }
})();

(function () {
    /**
     *
     * Turns a button into disabled to stop
     * multiple form submissions.
     *
     * simply add the attribute click-once
     * for custom button text use click-once="One moment..."
     * bind the directive to the parent scope through enabled="parentScopeVar"
     *
     **/
    angular.module('App').directive('clickOnce', clickOnce);
    function clickOnce() {
        return {
            restrict: 'A',
            scope: {
                clickOnce: '=',
            },
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
            link: function (scope, iElement, iAttrs) {
                var originalHtml = iElement.html();
                /**
                 * Watching the enabled scope variable for changes
                 *
                 * @param  {boolean} newValue  is the field enabled?
                 * @param  {boolean} oldValue  not looking for differences so not needed
                 * @return {none}
                 */
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'newValue' implicitly has an 'any' type.
                scope.$watch('clickOnce', function (newValue, oldValue) {
                    //set button to disabled state
                    if (newValue) {
                        //disable the button
                        iElement.attr('disabled', true);
                        //replace the button text
                        if (newValue) {
                            iElement.html(newValue);
                        }
                        //exit the $watch
                        return;
                    }
                    //set back to original state
                    iElement.html(originalHtml);
                    iElement.attr('disabled', false);
                });
            },
        };
    }
})();

(function () {
    angular
        .module('App.Util')
        .controller('ChangePasswordModalController', [
        '$scope',
        '$uibModalInstance',
        'AuthenticationService',
        ChangePasswordModalController,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$scope' implicitly has an 'any' type.
    function ChangePasswordModalController($scope, $uibModalInstance, AuthenticationService) {
        //config
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        //public functions
        vm.fn = {
            ok: ok,
            cancel: cancel,
        };
        /////////////////////////// FUNCTIONS ///////////////////////////
        //when the user clicks ok
        function ok() {
            //get the data for the current user
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'currentUser' implicitly has an 'any' ty... Remove this comment to see the full error message
            AuthenticationService.getUserPerson().then(function (currentUser) {
                //close the modal
                $uibModalInstance.dismiss('cancel');
                //send the password reset email
                AuthenticationService.passwordReset(currentUser.emailAddress);
                //logout the user
                AuthenticationService.logout();
            });
        }
        //when the user cancels
        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    angular
        .module('App.Util')
        .directive('chart', ['$window', '$filter', '$timeout', 'KPIsService', chartDirective]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$window' implicitly has an 'any' type.
    function chartDirective($window, $filter, $timeout, KPIsService) {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'KPIsService' implicitly has an 'any' ty... Remove this comment to see the full error message
        var DirectiveDefinitionObject = {
            restrict: 'E',
            scope: {
                api: '=?',
                colors: '=?',
                data: '=?',
                height: '@?',
                isCardView: '@?',
                legendHeaderFormat: '@?',
                legendValueFormat: '=?',
                precision: '=?',
                showAxis: '=?',
                showLegend: '=?',
                subchart: '@',
                type: '=?',
                kpi: '<'
            },
            link: link,
        };
        return DirectiveDefinitionObject;
        function link(scope, element) {
            var chart = {};
            var chartColors = [];
            var chartConfig = {};
            var chartData = [];
            var chartSubChart = false;
            var chartType;
            var chartXS = {};
            var defaultActualColor = '#1194f6';
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
            var defaultColors = [
                '#F7412d',
                '#ff9900',
                // @ts-ignore ts-migrate(7034) FIXME: Variable 'chartColors' implicitly has type 'any[]'... Remove this comment to see the full error message
                '#3e4eb8',
                '#ec1561',
                '#009788',
                '#ffc200',
                '#cdde20',
                // @ts-ignore ts-migrate(7034) FIXME: Variable 'chartData' implicitly has type 'any[]' i... Remove this comment to see the full error message
                '#00a7f7',
            ];
            var range;
            /**
             * @property autoSummationObject
             * @type {object}
             */
            var autoSummationObject = {
                formattedPoints: [],
                points: {},
            };
            /**
             * @method formatPoints formats kpi points for auto summation for D3 chart
             * @returns {any} - an array of formatted D3 point objects
             * */
            function formatPoints() {
                autoSummationObject.formattedPoints = [];
                for (var formattedDate in autoSummationObject.points) {
                    autoSummationObject.formattedPoints.push({
                        // @ts-ignore
                        date: new Date(formattedDate),
                        // @ts-ignore
                        number: autoSummationObject.points[formattedDate],
                        //@ts-ignore
                        id: btoa(autoSummationObject.points[formattedDate] + Date.parse(formattedDate))
                    });
                }
                return autoSummationObject.formattedPoints;
            }
            /**
             * @method addKpiSeriesData this adds up all the point values in all the series that have the same date for auto summation
             * @param kpiSeriesData {any}
             * @param recalc {boolean}
             * @returns {any} - promise
             */
            function addKpiSeriesData(kpiSeriesData) {
                // @ts-ignore ts-migrate(7005) FIXME:
                kpiSeriesData.forEach(function (kpiDataSet) {
                    var dataDateEpoch = Date.parse(kpiDataSet.date);
                    var dataDate = new Date(dataDateEpoch);
                    // YYYY/MM/DD
                    var formattedDate = dataDate.getFullYear() + '/' + (dataDate.getMonth() + 1) + '/' + dataDate.getDate();
                    // @ts-ignore ts-migrate(7005) FIXME:
                    if (angular.isUndefined(autoSummationObject.points[formattedDate])) {
                        // @ts-ignore ts-migrate(7005) FIXME:
                        autoSummationObject.points[formattedDate] = kpiDataSet.number;
                    }
                    else {
                        // @ts-ignore ts-migrate(7005) FIXME:
                        autoSummationObject.points[formattedDate] += kpiDataSet.number;
                    }
                });
                return formatPoints();
            }
            var defaultPlanColor = '#cbcbcb';
            // @ts-ignore ts-migrate(7034) FIXME: Variable 'chartType' implicitly has type 'any' in ... Remove this comment to see the full error message
            /**
             * @property precision
             * @type {number}
             */
            var precision = scope.precision || 0;
            /**
             * @property projectedData
             * @type {object}
             * Copy of data that has projected data points.
             */
            var projectedData;
            /**
             * @property series
             * @type {Array}
             * Data from scope, sorted by id
             */
            var series;
            /**
// @ts-ignore ts-migrate(7034) FIXME: Variable 'range' implicitly has type 'any' in some... Remove this comment to see the full error message
             * @property update
             * @type {Function}
             * Throttled version of the update function to keep parents from
             * triggering chart redraws multiple times in a row.
             */
            var update = _.throttle(_update, 1000, { trailing: false });
            /**
             * @property api
             * @type {object}
             * Object bound with parent so that the parent component can tell this directive to update.
// @ts-ignore ts-migrate(7034) FIXME: Variable 'projectedData' implicitly has type 'any'... Remove this comment to see the full error message
             */
            scope.api = {
                update: update,
            };
            update();
            /**
             * @function convertChartData
             * @private
             * converts KPI data into a C3 friendly format
// @ts-ignore ts-migrate(7034) FIXME: Variable 'series' implicitly has type 'any' in som... Remove this comment to see the full error message
             */
            function convertChartData(data) {
                if (scope.kpi && scope.kpi.autoSummation === 1) {
                    var autoSummationSeries_1 = null;
                    var actualSeries_1 = null;
                    _.forEach(data, function (series) {
                        if (series.isActual) {
                            actualSeries_1 = series;
                        }
                        if (series.name !== null && series.points && series.points.length > 0) {
                            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'result' implicitly has an 'any' type.
                            if (!series.isPlan && !series.isActual) {
                                autoSummationSeries_1 = addKpiSeriesData(series.points);
                            }
                        }
                    });
                    if (actualSeries_1 !== null && autoSummationSeries_1 !== null) {
                        // @ts-ignore
                        actualSeries_1.points = autoSummationSeries_1;
                    }
                }
                var axes = [], axisData, customSeriesColors = _.clone(defaultColors), i, latestDate, lineData, lines = [], p, s, seriesColor, tempDate, tempDates;
                // Clear the chart colors
                chartColors = [];
                //sort the series by id to keep consistent color selection
                series = _.orderBy(data || [], ['isPlan', 'isActual', 'id'], ['desc', 'desc', 'asc']);
                //loop through the series
                for (i = 1; i <= series.length; i += 1) {
                    //config for this series
                    lineData = [];
                    axisData = [];
                    s = series[i - 1];
                    //make sure the name for the series is set
                    if (s.isActual) {
                        s.name = 'Actual';
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'data' implicitly has an 'any' type.
                        // Set the color for the Actual series to the second item in the custom colors or the default actual color
                        seriesColor = (scope.colors && scope.colors[1]) || defaultActualColor;
                    }
                    else if (s.isPlan) {
                        s.name = 'Plan';
                        // for circular charts, we will not track "Plan" values
                        if (!chartType.hasPlan || s.points.length === 0) {
                            continue;
                        }
                        // Set the color for the Plan series to the first item in the custom colors or the default plan color
                        seriesColor = (scope.colors && scope.colors[0]) || defaultPlanColor;
                    }
                    else {
                        seriesColor =
                            (scope.colors && scope.colors[i - 1]) ||
                                (customSeriesColors.length && customSeriesColors.shift()) ||
                                getRandomColor();
                    }
                    s.name = s.name || 'Series ' + i;
                    //add the name of the series as the first index
                    lineData.push(s.name);
                    axisData.push('chart-x' + i);
                    //map the series to the axes
                    chartXS[s.name] = 'chart-x' + i;
                    if (chartType.isSinglePoint) {
                        tempDates = [];
                        for (p = 0; p < s.points.length; p += 1) {
                            tempDates.push(new Date(s.points[p].date));
                        }
                        latestDate = _.max(tempDates);
                        for (p = 0; p < s.points.length; p += 1) {
                            tempDate = new Date(s.points[p].date);
                            if (latestDate.getTime() === tempDate.getTime()) {
                                // @ts-ignore ts-migrate(7005) FIXME: Variable 'chartType' implicitly has an 'any' type.
                                //add the data for this series
                                lineData.push(s.points[p].number);
                                //save the date for this data point to the x-axis series
                                axisData.push($filter('date')(s.points[p].date, 'yyyy-MM-dd'));
                            }
                        }
                    }
                    else {
                        //loop through the data points for the series
                        for (p = 0; p < s.points.length; p += 1) {
                            //add the data for this series
                            lineData.push(s.points[p].number);
                            //save the date for this data point to the x-axis series
                            axisData.push($filter('date')(s.points[p].date, 'yyyy-MM-dd'));
                        }
                    }
                    // Save the colors of all series in order
                    chartColors.push(seriesColor);
                    //save the line and axis data
                    axes.push(axisData);
                    lines.push(lineData);
                }
                //return an array of axes and line data
                return _.concat(axes, lines);
            }
            /**
             * @function createProjectedData
             * @private
// @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
             * Determines points that need to be calculated.
// @ts-ignore ts-migrate(7005) FIXME: Variable 'chartType' implicitly has an 'any' type.
             * Note: Users can't set the time-of-day, so it is meaningless. Purge it with setHours()
             */
            function createProjectedData() {
                var allSeries = _.cloneDeep(scope.data), dates = {}, datesPerSeries = {}, uniqueDates;
                // Loop through each series
                _.forEach(allSeries, function (currentSeries) {
                    // Create an object with the series, an array of days in the series, and the original days
                    datesPerSeries[currentSeries.id] = {
                        // @ts-ignore ts-migrate(2532) FIXME: Object is possibly 'undefined'.
                        series: currentSeries,
                        days: {},
                        originalDays: [],
                    };
                    _.forEach(currentSeries.points, function (point) {
                        // Add _day which is the number of milliseconds for midnight on the point's date
                        point._day = new Date(point.date).setHours(0, 0, 0, 0);
                        // Add this day to the cumulative list of days that have points on any series.
                        dates[point._day] = 1;
                        // Associate the value for this day on this series to calculate the projected value later.
                        // Note: only one value accepted per day
                        datesPerSeries[currentSeries.id].days[point._day] = point.number;
                        point._isProjected = 0;
                    });
                    // Get all the unique days for non-projected points now for faster searching later
                    datesPerSeries[currentSeries.id].originalDays = _(datesPerSeries[currentSeries.id].days)
                        .keys()
                        .map(Number)
                        .sortBy()
                        .value();
                });
                // Create an array of unique days (days are milliseconds to midnight, as a string).
                // Note: Keys are always strings, so this is an array of strings.
                uniqueDates = Object.keys(dates);
                // Loop through each day that has a point in at least one series.
                _.forEach(uniqueDates, function (day) {
                    // Loop through all the series
                    _.forEach(datesPerSeries, function (seriesAndDays, seriesIdKey) {
                        var projectedPoint, seriesId = Number(seriesIdKey);
                        // @ts-ignore
                        if (!angular.isDefined(seriesAndDays.days[day])) {
                            // This series doesn't have a point on this day
                            // Calculate what value it would be, add new point to the series.
                            // @ts-ignore
                            projectedPoint = createProjectedPoint(seriesAndDays, day, seriesAndDays.originalDays);
                            if (projectedPoint) {
                                // @ts-ignore
                                datesPerSeries[seriesId].series.points.push(projectedPoint);
                            }
                        }
                    });
                });
                return allSeries;
            }
            /**
             * @function createProjectedPoint
             * @param series {object}
             * @param day {string} - milliseconds for midnight, as a string
             * @param days {Array}
// @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
             * @returns {object}
             * @private
             *
             */
            function createProjectedPoint(series, day, days) {
                var dayMilliseconds = Number(day), intercept, nextPointDay, nextPointValue, previousPointDay, previousPointValue, projectedPoint, slope, wherePointWouldGo = _.sortedIndex(days, day);
                if (wherePointWouldGo && wherePointWouldGo !== days.length) {
                    // not first, not last
                    // id should be date, since we are projecting by day
                    previousPointDay = days[wherePointWouldGo - 1];
                    // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                    nextPointDay = days[wherePointWouldGo];
                    // series.days is a map of point values to point 'day'
                    previousPointValue = series.days[previousPointDay];
                    nextPointValue = series.days[nextPointDay];
                    // Find the slope of "Plan"
                    // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                    slope = (previousPointValue - nextPointValue) / (previousPointDay - nextPointDay);
                    // Find the intercept of "Plan"
                    intercept = previousPointValue - slope * previousPointDay;
                    projectedPoint = {
                        number: slope * dayMilliseconds + intercept,
                        // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                        date: new Date(dayMilliseconds),
                        _isProjected: 1,
                        // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                        id: 'projected',
                        i: _.uniqueId(),
                        name: series.series.name,
                    };
                }
                return projectedPoint;
            }
            /**
             * @function generateChart
             * @param config {object}
             * @private
             * Generate the chart with the settings and return its object.
             */
            function generateChart(config) {
                return $window.c3.generate({
                    padding: {
                        bottom: chartType.padding,
                    },
                    bindto: element[0],
                    data: {
                        xs: chartXS,
                        type: chartType.name,
                        columns: chartData,
                        empty: {
                            label: {
                                text: 'No Data Available',
                            },
                        },
                    },
                    color: {
                        pattern: chartColors,
                    },
                    legend: {
                        show: scope.showLegend,
                    },
                    axis: {
                        x: {
                            show: scope.showAxis,
                            padding: chartType.isAxisPadded
                                ? { left: 0, right: 0 }
                                : { left: undefined, right: undefined },
                            type: 'timeseries',
                            tick: {
                                format: '%-m/%d/%Y',
                                count: function () {
                                    //get the array with the most values
                                    var longestArray = _.maxBy(chartData, 'length');
                                    //return the number of indexes minus the first (the set title)
                                    return (longestArray || []).length - 1;
                                },
                                // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                                rotate: -30,
                            },
                            height: 45,
                        },
                        y: {
                            min: range.min,
                            max: range.max,
                            show: scope.showAxis,
                            tick: {
                                format: function (label) {
                                    return scope.legendValueFormat
                                        ? $filter('kpiChartFormat')(label, scope.legendValueFormat, precision)
                                        : label;
                                },
                            },
                        },
                    },
                    tooltip: {
                        format: {
                            title: function (date) {
                                return $filter('date')(date, scope.legendHeaderFormat);
                            },
                            value: function (value) {
                                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'series' implicitly has an 'any' type.
                                return scope.legendValueFormat
                                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'days' implicitly has an 'any' type.
                                    ? $filter('kpiPointFormat')(value, scope.legendValueFormat, 2)
                                    : value;
                            },
                        },
                        contents: function (d) {
                            var day, month, year, customTooltipHTML, pointRows = [];
                            //build markup for the tooltip
                            if (chartType.hasDates) {
                                // These types have dates
                                day = d[0].x.getDate();
                                month = d[0].x.getMonth(d[0].x) + 1;
                                year = d[0].x.getFullYear();
                                customTooltipHTML =
                                    "<table class='table tooltip-table table-bordered table-sm'><thead class='thead-inverse'><tr><th colspan='2'>" +
                                        month +
                                        '/' +
                                        day +
                                        '/' +
                                        year +
                                        "</th></tr></thead><tbody class='table-striped'>";
                            }
                            else {
                                customTooltipHTML =
                                    "<table class='table tooltip-table table-bordered table-sm'><tbody class='table-striped'>";
                            }
                            _.forEach(d, function (dataPoint) {
                                pointRows.push({
                                    point: dataPoint,
                                    html: '<tr><td>' +
                                        dataPoint.name +
                                        '</td><td>' +
                                        $filter('kpiPointFormat')(dataPoint.value, scope.legendValueFormat, precision) +
                                        '</td></tr>',
                                });
                            });
                            if (chartType.hasProjections) {
                                // These types have projections
                                var projectedDataPoints = getProjectedPoints(d[0].id, d[0].x);
                                _.forEach(projectedDataPoints, function (point) {
                                    if (point._isProjected) {
                                        pointRows.push({
                                            point: point,
                                            html: '<tr><td>' +
                                                point.name +
                                                '</td><td>~' +
                                                $filter('kpiPointFormat')(point.number, 
                                                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'config' implicitly has an 'any' type.
                                                scope.legendValueFormat, precision) +
                                                '</td></tr>',
                                        });
                                    }
                                });
                                // @ts-ignore ts-migrate(7005) FIXME: Variable 'chartType' implicitly has an 'any' type.
                            }
                            // Sort the rows by series
                            pointRows = _.sortBy(pointRows, function (row) {
                                var s = _.find(series, { name: row.point.name });
                                // @ts-ignore ts-migrate(7005) FIXME: Variable 'chartType' implicitly has an 'any' type.
                                return s && s.id;
                            });
                            // Concatenate rows
                            // @ts-ignore ts-migrate(7005) FIXME: Variable 'chartData' implicitly has an 'any[]' typ... Remove this comment to see the full error message
                            customTooltipHTML += _.map(pointRows, 'html').join('\n');
                            return customTooltipHTML + '</tbody></table>';
                        },
                    },
                    zoom: {
                        rescale: true,
                    },
                    subchart: {
                        show: chartSubChart,
                    },
                    point: {
                        r: config.pointRadius,
                    },
                    // @ts-ignore ts-migrate(7005) FIXME: Variable 'chartColors' implicitly has an 'any[]' t... Remove this comment to see the full error message
                    donut: {
                        label: {
                            show: false,
                        },
                        width: scope.isCardView ? 15 : 40,
                    },
                    pie: {
                        label: {
                            show: !scope.isCardView,
                        },
                    },
                    gauge: {
                        label: {
                            // Values for each series overlaps if anything else
                            // @ts-ignore ts-migrate(7005) FIXME: Variable 'chartType' implicitly has an 'any' type.
                            format: _.wrap(''),
                        },
                    },
                    size: {
                        height: scope.height,
                    },
                });
            }
            /**
             * @function getChartType
             * @param type {string}
             * @returns {object}
             * @private
             * Gets chart settings for a given type.
             */
            function getChartType(type) {
                return _.find(KPIsService.CHART_TYPES, { name: type });
            }
            /**
             * @function getProjectedPoints
             * @param series
             * @param date
             * @private
             * gets all projected data points
             */
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'chartData' implicitly has an 'any[]' typ... Remove this comment to see the full error message
            function getProjectedPoints(series, date) {
                var projectedDataPoints = [];
                _.forEach(projectedData, function (projectedSeries) {
                    if (projectedSeries.name !== series) {
                        _.forEach(projectedSeries.points, function (point) {
                            var zeroTime = new Date(point.date);
                            zeroTime.setHours(0, 0, 0, 0);
                            if (zeroTime.toDateString() === date.toDateString()) {
                                projectedDataPoints.push(point);
                            }
                            // @ts-ignore ts-migrate(7005) FIXME: Variable 'range' implicitly has an 'any' type.
                        });
                    }
                });
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'range' implicitly has an 'any' type.
                return projectedDataPoints;
            }
            /**
             * @function getRandomColor
             * @returns {string}
             * @private
             * Returns a random hex
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'label' implicitly has an 'any' type.
            function getRandomColor() {
                var color = '#', i;
                for (i = 0; i < 6; i += 1) {
                    color += Math.floor(Math.random() * 16).toString(16);
                }
                return color;
            }
            /**
             * @function _update
             * @private
             * Update after the current digest finishes.
             */
            function _update() {
                $timeout(function () {
                    // Get the settings object for this chart type.
                    chartType = getChartType(scope.type);
                    if (chartType) {
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'date' implicitly has an 'any' type.
                        if (angular.isArray(scope.colors) && scope.colors.length) {
                            // Plan is the first item
                            defaultPlanColor = scope.colors[0];
                            if (scope.colors.length > 1) {
                                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'value' implicitly has an 'any' type.
                                // Actual is the second item
                                defaultActualColor = scope.colors[1];
                            }
                            if (scope.colors.length > 2) {
                                defaultColors = _.concat(scope.colors.slice(2), defaultColors.slice(scope.colors.length - 2));
                            }
                        }
                        // Put the data into the correct format for the chart.
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                        autoSummationObject.formattedPoints = [];
                        autoSummationObject.points = [];
                        chartData = convertChartData(scope.data);
                        // @ts-ignore ts-migrate(7034) FIXME: Variable 'pointRows' implicitly has type 'any[]' i... Remove this comment to see the full error message
                        range = calculateRange(scope.data);
                        // Create projected points.
                        projectedData = createProjectedData();
                        // @ts-ignore ts-migrate(7005) FIXME: Variable 'chartType' implicitly has an 'any' type.
                        // Check if selected chart type works with a subchart.
                        chartSubChart = validateSubChart();
                        // Set the default legend header if needed
                        scope.legendHeaderFormat = scope.legendHeaderFormat || 'EEEE, MMMM d, y';
                        // get the config for the selected chart type
                        // chartConfig = getChartConfig(chartType);
                        chartConfig = { pointRadius: chartType.radius };
                        // Load the chart
                        chart = generateChart(chartConfig);
                        // Display chart in the correct type
                        // @ts-ignore
                        chart.transform(chartType.name);
                        // If the subchart is used
                        if (chartSubChart) {
                            //add a class to the subcharts element for easy css targeting
                            angular
                                .element(document
                                .querySelector('.c3')
                                .querySelectorAll('[clip-path*="-subchart"] ~ .c3-axis-x'))
                                .addClass('subchart-axis-x');
                        }
                    }
                }, 0);
            }
            /**
             * @function validateSubChart
             * @returns {boolean}
             * @private
             * Overrides subchart visibility if it's not supported with the selected chart type.
             * TODO: This doesn't update when points are added.
             */
            function validateSubChart() {
                // Check if there's data to display on a subchart.
                // chartData can be an array of arrays with length of 1.
                var isAllowed = !!_.find(chartData, function (d) {
                    return d.length > 1;
                });
                //send back the passed value or false if it's not allowed
                return isAllowed && scope.subchart == 'true';
            }
            function calculateRange(series) {
                var maxPoint;
                var minPoint;
                series.forEach(function (s) {
                    var numbers = s.points.map(function (p) {
                        return p.number;
                    });
                    // @ts-ignore ts-migrate(7005) FIXME: Variable 'chartType' implicitly has an 'any' type.
                    if (numbers.length) {
                        var max = Math.max.apply(Math, numbers);
                        var min = Math.min.apply(Math, numbers);
                        if (angular.isDefined(maxPoint)) {
                            maxPoint = (max > maxPoint) ? max : maxPoint;
                        }
                        else {
                            maxPoint = max;
                        }
                        if (angular.isDefined(minPoint)) {
                            minPoint = (min < minPoint) ? min : minPoint;
                        }
                        else {
                            minPoint = min;
                        }
                    }
                });
                return {
                    min: minPoint,
                    max: maxPoint
                };
            }
        }
    }
})();
// @ts-ignore ts-migrate(7005) FIXME: Variable 'pointRows' implicitly has an 'any[]' typ... Remove this comment to see the full error message

(function () {
    angular
        .module('App.Util')
        .directive('chartBubble', [
        'd3Service',
        '$filter',
        'TEMPLATE_PATH',
        chartBubble
    ]);
    function chartBubble(d3Service, $filter, TEMPLATE_PATH) {
        var DirectiveDefinition = {
            link: link,
            restrict: 'E',
            scope: {
                chartData: '=',
                xAxisLabel: '@?',
                yAxisLabel: '@?',
            },
            templateUrl: TEMPLATE_PATH + '/util/chart-bubble/util.chart-bubble.html'
        };
        return DirectiveDefinition;
        function link(scope, element, attrs) {
            var d3 = d3Service.d3;
            /**
             * @property fn
             * @type {object}
             * functions
             */
            scope.fn = {};
            /**
             * @property isLoaded
             * @type {boolean}
             */
            scope.isLoaded = false;
            /**
             * @property minValueXAxis
             * @type {Number}
             */
            var minValueXAxis = 0;
            /**
             * @property minValueYAxis
             * @type {Number}
             */
            var minValueYAxis = 0;
            /**
             * @property maxValueXAxis
             * @type {Number}
             */
            var maxValueXAxis = 6;
            /**
             * @property maxValueYAxis
             * @type {Number}
             */
            var maxValueYAxis = 6;
            var chartDataPoints = [];
            var chartColTexts = ['Very Low', 'Low', 'Average', 'High', 'Very High'];
            var chartColNums = [0, 1, 2, 3, 4, 5, 6];
            angular.forEach(scope.chartData, function (impactData, i) {
                var impact = impactData.impact, impactRisk = impactData.impactRisk, impactInvestment = impactData.impactInvestment, impactDifficulty = impactData.impactDifficulty, score = impactData.score, isFocused = impactData.isFocused, impactTargetDate = impactData.impactTargetDate, title = impactData.title;
                if (impactRisk === null ||
                    impact === null ||
                    impactInvestment === null)
                    return;
                var dataResult = {
                    impact: impact,
                    impactRisk: impactRisk,
                    impactInvestment: impactInvestment,
                    impactDifficulty: impactDifficulty,
                    score: score,
                    isFocused: isFocused,
                    impactTargetDate: impactTargetDate,
                    title: title
                };
                chartDataPoints.push(dataResult);
            });
            chartDataPoints
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'a' implicitly has an 'any' type.
                .sort(function (a, b) { return (a.impactInvestment > b.impactInvestment) ? 1 : -1; })
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'a' implicitly has an 'any' type.
                .sort(function (a, b) { return (a.impactRisk > b.impactRisk) ? 1 : -1; })
                .map(function (point, index) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'point' implicitly has an 'any' type.
                point.index = index;
                if (point.score <= 3 && point.score > 0) {
                    point.scoreColor = 'rgba(244, 67, 54, .75)';
                }
                else if (point.score >= 4 && point.score <= 6) {
                    point.scoreColor = 'rgba(255, 152, 0, .75)';
                }
                else if (point.score >= 7) {
                    point.scoreColor = 'rgba(76, 175, 80, .75)';
                }
                else {
                    point.scoreColor = 'rgba(150, 150, 150, .75)';
                }
            });
            var investments = chartDataPoints.map(function (point) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'point' implicitly has an 'any' type.
                return point.impactInvestment;
            }).sort();
            var reducer = function (accumulator, currentValue) { return accumulator + currentValue; };
            var totalInvestments = investments.reduce(reducer);
            var margin = ({ top: 20, right: 40, bottom: 45, left: 80 });
            var height = 300;
            var currentWidth = parseInt(d3.select('.chart-canvas').style('width'), 10);
            var svg = d3.select('.chart-canvas')
                .append("svg")
                .attr("height", height + margin.top + margin.bottom)
                .attr("width", currentWidth)
                .append("g");
            // Add X axis
            var x = d3.scaleLinear()
                .domain([minValueXAxis, maxValueXAxis]);
            var xAxis = svg.append("g")
                .attr("class", "x-axis")
                .call(d3.axisBottom(x));
            // add the X gridlines
            var xGridlines = svg.append("g")
                .attr("class", "grid")
                .attr("transform", "translate(0," + height + ")")
                .call(d3.axisBottom(x)
                .ticks(5)
                .tickSize(-height)
                .tickFormat(function (x) {
            }));
            // text label for the x axis
            svg.append("text")
                .attr("transform", "translate(" + ((currentWidth - margin.left - margin.right) / 2) + " ," +
                (height + margin.top + 20) + ")")
                .style("text-anchor", "middle")
                .text("Risk to MIN from not improving this driver");
            // Add Y axis
            var y = d3.scaleLinear()
                .domain([minValueYAxis, maxValueYAxis])
                .range([height, 0]);
            svg.append("g")
                .attr("class", "y-axis")
                .call(d3.axisLeft(y).tickSizeOuter(0).tickValues(chartColNums).tickFormat(function (x) {
                if (!(x % 2)) {
                    return;
                }
                return chartColTexts[x - 1];
            }));
            // add the Y gridlines
            svg.append("g")
                .attr("class", "grid")
                .call(d3.axisLeft(y)
                .ticks(5)
                .tickSize(-(currentWidth - margin.left - margin.right))
                .tickFormat(""));
            // text label for the y axis
            svg.append("text")
                .attr("transform", "rotate(-90)")
                .attr("y", 0 - margin.left)
                .attr("x", 0 - (height / 2))
                .attr("dy", "1em")
                .style("text-anchor", "middle")
                .text("Positive impact on MIN from improving this driver");
            // Add a scale for bubble size
            var z = d3.scaleLinear();
            // Add a scale for bubble color
            var myColor = d3.scaleOrdinal()
                .domain(['rgba(244, 67, 54, .75)', 'rgba(255, 152, 0, .75)', 'rgba(76, 175, 80, .75)', 'rgba(150, 150, 150, .75)'])
                .range(['rgba(244, 67, 54, .75)', 'rgba(255, 152, 0, .75)', 'rgba(76, 175, 80, .75)', 'rgba(150, 150, 150, .75)']);
            // -1- Create a tooltip div that is hidden by default:
            var tooltip = d3.select(".chart-canvas")
                .append("div")
                .style("visibility", 'hidden')
                .style("opacity", 0)
                .attr("class", "tooltip");
            // -2- Create 3 functions to show / update (when mouse move but stay on same circle) / hide the tooltip
            var showTooltip = function (d) {
                var html = buildTooltip(d);
                // @ts-ignore ts-migrate(2300) FIXME: Duplicate identifier 'this'.
                var radius = getRadius(d);
                var circleElement = d3.select(".circle-" + d.index);
                if (radius % 1 != 0) {
                    radius = Math.round(radius * 1.25) + .1;
                }
                else {
                    radius = Math.round(radius * 1.25);
                }
                circleElement.attr("r", radius);
                tooltip
                    .style("opacity", 1)
                    .style("visibility", 'visible')
                    .html(html)
                    .style("left", (d3.mouse(this)[0] + 30) + "px")
                    .style("top", (d3.mouse(this)[1] + 30) + "px");
            };
            var moveTooltip = function (d) {
                tooltip
                    .style("opacity", 1)
                    // @ts-ignore ts-migrate(2300) FIXME: Duplicate identifier 'this'.
                    .style("left", (d3.mouse(this)[0] + 30) + "px")
                    .style("top", (d3.mouse(this)[1] + 30) + "px");
            };
            var hideTooltip = function (d) {
                var circleElement = d3.select(".circle-" + d.index);
                circleElement.attr("r", getRadius(d));
                tooltip
                    .style("opacity", 0)
                    .style("visibility", 'hidden');
            };
            var buildTooltip = function (d) {
                return "\n                            <div class=\"impact-hover-window\">\n                                <p class=\"window-title\">" + d.title + "</p>\n                                <div class=\"radio-btn-group\">\n                                    <div class=\"btn-group\">\n                                        <label class=\"btn btn-default text-small\">\n                                            <div class=\"btn-title\">Risk to MIN</div>\n                                            <div class=\"btn-data\">" + chartColTexts[d.impactRisk] + "</div>\n                                        </label>\n                                        <label class=\"btn btn-default text-small\">\n                                            <div class=\"btn-title\">Impact</div>\n                                            <div class=\"btn-data\">" + chartColTexts[d.impact] + "</div>\n                                        </label>\n                                        <label class=\"btn btn-default text-small\">\n                                            <div class=\"btn-title\">Difficulty</div>\n                                            <div class=\"btn-data\">" + chartColTexts[d.impactDifficulty] + "</div>\n                                        </label>\n                                    </div>\n                                </div>\n                                <div class=\"impact-data\">\n                                    <div class=\"row\">\n                                        <div class=\"col-xs-4\">\n                                            <p class=\"title\">Investment</p>\n                                            <p class=\"data\">" + (d.impactInvestment ? '$' + d.impactInvestment.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '-') + "</p>\n                                        </div>\n                                        <div class=\"col-xs-4\">\n                                            <p class=\"title\">Target Date</p>\n                                            <p class=\"data\">" + ($filter('date')(d.impactTargetDate, 'M/d/yyyy') || '-') + "</p>\n                                        </div>\n                                        <div class=\"col-xs-4\">\n                                            <p class=\"title\">Status</p>\n                                            " + (d.isFocused ?
                    "<div class=\"col-xs-auto\">\n                                                    <span class=\"tag tag-driver-in-focus\">In Focus</span>\n                                                </div>" :
                    "<div class=\"col-xs-auto\">\n                                                    <span class=\"tag tag-driver-not-in-focus\">Not In Focus</span>\n                                                </div>") + "\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        ";
            };
            // Add dots
            var myCircles = svg.append('g')
                .selectAll("dot")
                .data(chartDataPoints)
                .enter()
                .append("circle")
                .attr("class", function (d) { return "bubbles circle-" + d.index; })
                .attr("cy", function (d) { return y(d.impact + 1); })
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                .attr("r", function (d) { return z(getRadius(d)); })
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                .style("fill", function (d) { return myColor(d.scoreColor); })
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                // -3- Trigger the functions
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                .on("mouseover", showTooltip)
                .on("mousemove", moveTooltip)
                .on("mouseleave", hideTooltip);
            scope.isLoaded = true;
            // A function that finishes to draw the chart for a specific device size.
            function drawChart() {
                // get the current width of the div where the chart appear, and attribute it to Svg
                currentWidth = parseInt(d3.select('.chart-canvas').style('width'), 10);
                svg.attr("width", currentWidth);
                svg.attr("transform", "translate(" + margin.left + "," + margin.top + ")");
                // Update the X scale and Axis
                x.range([0, currentWidth - margin.right - margin.left]);
                xAxis.attr("transform", "translate(0," + (height) + ")")
                    .call(d3.axisBottom(x).tickSizeOuter(0).tickValues(chartColNums).tickFormat(function (x) {
                    if (!(x % 2)) {
                        return;
                    }
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'x' implicitly has an 'any' type.
                    return chartColTexts[x - 1];
                }));
                // add the X gridlines
                xGridlines
                    .call(d3.axisBottom(x)
                    .ticks(5)
                    .tickSize(-height)
                    .tickFormat(""));
                // Add the last information needed for the circles: their X position
                myCircles
                    .attr("cx", function (d) { return x(d.impactRisk + 1); });
            }
            // Initialize the chart
            drawChart();
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
            // Add an event listener that run the function when dimension change
            window.addEventListener('resize', drawChart);
            function getRadius(d) {
                var investment = d.impactInvestment;
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                var isFocusedValue = d.isFocused ? .1 : 0;
                if (investment / totalInvestments > .5)
                    return 50 + isFocusedValue;
                if (investment / totalInvestments < .1)
                    return 10 + isFocusedValue;
                return Math.round(investment / totalInvestments * 100) + isFocusedValue;
            }
        }
    }
})();

(function () {
    var ua = window.navigator.userAgent.toLowerCase();
    /**
     * @property isMSBrowser
     * @type {boolean}
     * This value is independent of the app, so define it once in this IIFE.
     */
    var isMSBrowser = ua.indexOf('edge/') !== -1 || ua.indexOf('trident/') !== -1;
    /**
     * @property isFireFox
     * @type {boolean}
     */
    var isFirefox = ua.indexOf('firefox') !== -1 && !isMSBrowser;
    angular
        .module('App.Util')
        .directive('chartHierarchy', [
        '$state',
        '$q',
        'AuthenticationService',
        'AvatarsService',
        'd3Service',
        'PeopleService',
        'TEMPLATE_PATH',
        chartHierarchy,
    ]);
    /**
     * @directive chart-hierarchy
     *
     * Visual display of managers and direct reports based on D3.
     */
    function chartHierarchy($state, $q, AuthenticationService, AvatarsService, d3Service, PeopleService, TEMPLATE_PATH
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$state' implicitly has an 'any' type.
    ) {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter '$q' implicitly has an 'any' type.
        var DirectiveDefinition = {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AvatarsService' implicitly has an 'any'... Remove this comment to see the full error message
            link: link,
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd3Service' implicitly has an 'any' type... Remove this comment to see the full error message
            restrict: 'E',
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TEMPLATE_PATH' implicitly has an 'any' ... Remove this comment to see the full error message
            scope: {
                hierarchyData: '<',
                primaryPersonId: '@',
            },
            templateUrl: TEMPLATE_PATH + '/util/chart-hierarchy/util.chart-hierarchy.html',
        };
        return DirectiveDefinition;
        function link(scope) {
            /**
             * @property fn
             * @type {object}
             * functions
             */
            scope.fn = {
                expand: expand,
                collapse: collapse,
            };
            /**
             * @property avatars
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
             * @type {Array}
             */
            var avatars = [];
            /**
             * @property currentUserId
             * @type {number}
             */
            var currentUserId = AuthenticationService.getAccount().userId;
            /**
             * @property hierarchyTreeData
             * @type {Array}
             */
            var hierarchyTreeData = buildHierarchyTreeData(scope.hierarchyData);
            /**
// @ts-ignore ts-migrate(7034) FIXME: Variable 'avatars' implicitly has type 'any[]' in ... Remove this comment to see the full error message
             * @property rootNode
             * @type {Object}
             * The primary tree node, first in line
             */
            var rootNode = hierarchyTreeData[0];
            /**
             * @property animationDuration
             * @type {number}
             */
            var animationDuration = 50;
            /**
             * @property maxCharacters
             * @type {number}
             * Due to the fact we are drawing text, this will limit
             * the amount of characters displayed for names and titles
             */
            var maxCharacters = 16;
            /**
             * @property cardWidth
             * @type {number}
             */
            var cardWidth = 225;
            /**
             * @property cardHeight
             * @type {number}
             */
            var cardHeight = 80;
            var treeData = {};
            var root = {};
            /**
             * @property tree
             * @type {object}
             */
            var tree = d3Service.d3.tree().nodeSize([cardHeight + 20, cardWidth + 80]);
            /**
             * @property diagonal
             * @type {function}
             * this positions the node on the link lines
             */
            var diagonal = function link(d) {
                return "M" + d.source.y + "," + d.source.x
                    + "C" + (d.source.y + d.target.y) / 2 + "," + d.source.x
                    + " " + (d.source.y + d.target.y) / 2 + "," + d.target.x
                    + " " + d.target.y + "," + d.target.x;
            };
            /**
             * @property canvas
             * @type {object}
             * the HTML element that hold the svg element
             */
            var canvas = d3Service.d3.select('#hierarchy-canvas');
            /**
             * @property svg
             * @type {object}
             */
            var svg = canvas.append('svg').attr('shape-rendering', 'optimizeSpeed');
            /**
             * @property nodesContainer
             * @type {object}
             * HTML element that contains all of the tree nodes
             */
            var nodesContainer = svg.append('g').attr('id', 'container-nodes');
            /**
             * @property definitions
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
             * @type {object}
             * sometime svg needs to reference another HTML element
             * to manipulate images, gradients, etc. This HTML element
             * will hold all of the needed definitions.
             */
            var defs = nodesContainer.append('defs');
            /**
             * @property clipPathForAvatar
             * @type {object}
             * HTML element so that we can make the avatars circular
             */
            var clipPath = defs
                .append('clipPath')
                .attr('id', 'clip-circle-for-avatar')
                .append('circle')
                .attr('r', 20);
            /**
             * @property lazyResizeCanvas
             * @type {function}
             */
            var lazyResizeCanvas = _.debounce(resizeCanvas, 50);
            /**
             * @property isLoaded
             * @type {boolean}
             * Don't show the hierarchy graph until we are ready.
             */
            scope.isLoaded = false;
            /**
             * @property isShowGraph
             * @type {boolean}
             * Don't show the hierarchy graph to Microsoft browsers.
             */
            scope.isShowGraph = !isMSBrowser;
            var resizeObserver = new ResizeObserver(function () {
                resizeCanvas();
            });
            scope.$onDestroy = function () {
                var gNodes = svg.selectAll('g#container-nodes');
                resizeObserver.unobserve(gNodes._groups[0][0]);
            };
            init();
            resizeCanvas();
            /**
             * @method init
             */
            function init() {
                treeData = hierarchyTreeData;
                rootNode = hierarchyTreeData[0];
                root = d3Service.d3.hierarchy(rootNode, function (d) { return d.children; });
                // @ts-ignore
                root.x0 = 0;
                // @ts-ignore
                root.y0 = 0;
                //collapse and draw the graph
                // @ts-ignore
                root.children.forEach(collapseAll);
                scope.isLoaded = true;
                draw(root);
                var gNodes = svg.selectAll('g#container-nodes');
                resizeObserver.observe(gNodes._groups[0][0]);
            }
            /**
             * @method collapse
             * @returns {none}
             * Collapse expanded nodes to the *DEFAULT* expanse. Does not collapse to the root node.
             */
            function collapse() {
                if (scope.primaryPersonId === rootNode.id) {
                    collapseAll(root);
                }
                else {
                    collapseAll(root);
                    //find the primary person's node to collapse below
                    // let nodes = d3Service.d3.hierarchy(rootNode, d => d.children);
                    // nodes = tree(nodes);
                    // const allNodes = nodes.descendants().slice(1);
                    // _.forEach(allNodes, function(node) {
                    // 	if (node.data.id === scope.primaryPersonId && node.data.children) {
                    // 		return _.forEach(node.data.children, collapseNodes);
                    // 	}
                    // });
                }
                draw(root);
            }
            // Collapse the node and all it's children
            function collapseAll(d) {
                if (d.children) {
                    d._children = d.children;
                    d._children.forEach(collapseAll);
                    d.children = null;
                }
            }
            /**
             * @method collapseNodes
             * @param node
             * @returns {void}
             */
            function collapseNodes(node) {
                if (node.children) {
                    _.forEach(node.children, function (childNode) {
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                        collapseNodes(childNode);
                    });
                    if (node.id !== scope.primaryPersonId) {
                        node._children = node.children;
                        delete node.children;
                    }
                }
            }
            /**
             * @method expand
             * @returns {none}
             */
            function expand() {
                expandNode(root);
                draw(root);
            }
            /**
             * @method  expandNode
             * @property {object} node a single tree node
             * Expands a single node in the tree
             */
            function expandNode(node) {
                if (node._children) {
                    node.children = node._children;
                    delete node._children;
                }
                _.forEach(node.children, expandNode);
            }
            /**
             * @method  buildHierarchyTreeData
             * @param data {object} - the hierarchy data from back-end
             * @returns {Array} - tree data that d3 can use to build the tree
             * This takes the hierarchy data and converts it into tree
             * structure that d3 can use to display
             */
            function buildHierarchyTreeData(data) {
                var currentUserNode, rawData = angular.copy(data), treeData = [], dataMap = _.keyBy(rawData, 'id');
                _.forEach(rawData, function (node) {
                    var manager = dataMap[node.reportsToId];
                    node._showTeam = false;
                    if (node.id === currentUserId) {
                        currentUserNode = node;
                    }
                    if (manager) {
                        (manager.children || (manager.children = [])).push(node);
                    }
                    else {
                        treeData.push(node);
                    }
                });
                if (currentUserNode) {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                    // Only current user and subordinates can have a team link
                    updateHierarchyChildren(currentUserNode);
                }
                return treeData;
            }
            /**
             * @function updateHierarchyChildren
             * @param node {object}
             * Recursive function that iterates through all the children of node
             * Called by buildHierarchyTreeData with the Current User as the first node
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
             * Allows current user to view the team link for subordinates
             */
            function updateHierarchyChildren(node) {
                node._showTeam = true;
                _.forEach(node.children, updateHierarchyChildren);
            }
            /**
             * @method clickNodeEvent
             * @property {object} node a single tree node
             * Handles when the each node in the tree
             * is clicked expanding and contracting the org chart.
             */
            function clickNodeEvent(node) {
                if (node.children) {
                    node._children = node.children;
                    node.children = null;
                }
                else {
                    node.children = node._children;
                    node._children = null;
                    //expandNode(node);
                }
                draw(node);
            }
            /**
             * @method goToPeoplePage
             * @param  {object} node a single tree node
             */
            function goToPeoplePage(node) {
                canCurrentUserViewSelectedUser(node.data.id).then(function (canViewUser) {
                    if (canViewUser) {
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
                        $state.go('app.people.show', {
                            personId: node.data.id,
                        });
                    }
                });
            }
            /**
             * @function canCurrentUserViewSelectedUser
             * @private
             * Determine if the current user is allowed to view the selected user.
             */
            function canCurrentUserViewSelectedUser(personId) {
                return PeopleService.canViewUser(currentUserId, personId);
            }
            /**
             * @method goToTeamPage
             * @param  {object} node a single tree node
             */
            function goToTeamPage(node) {
                if (node.data._showTeam && node.data.userTeams[0]) {
                    $state.go('app.teams.show', { teamId: node.data.userTeams[0] });
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'data' implicitly has an 'any' type.
                }
            }
            /**
             * @method getTranslateStyle
// @ts-ignore ts-migrate(7034) FIXME: Variable 'treeData' implicitly has type 'any[]' in... Remove this comment to see the full error message
             * @param  {number} x the x position
             * @param  {number} y the y position
             * @returns {string} the CSS style to apply
             */
            function getTranslateStyle(x, y) {
                var style = 'transform: ' + 'translate(' + x + 'px, ' + y + 'px); ';
                style += '-ms-transform: ' + 'translate(' + x + 'px, ' + y + 'px); ';
                style += '-webkit-transform: ' + 'translate(' + x + 'px, ' + y + 'px); ';
                return style;
            }
            /**
             * @method getInvertedTranslateStyle
             * @param  {number} y the y position
             * @param  {number} x the x position
             * @returns {string} the CSS style to apply
             */
            function getInvertedTranslateStyle(y, x) {
                var a = y, b = x;
                return getTranslateStyle(a, b);
            }
            /**
             * @method trimText
             * @param text {string} - the text to trim
// @ts-ignore ts-migrate(7005) FIXME: Variable 'treeData' implicitly has an 'any[]' type... Remove this comment to see the full error message
             * @returns {string} - the trimmed text
             * Since all of this is drawn and there is no wrapping of
             * text, this will truncate long names and titles
             */
            function trimText(text) {
                text = text.trim();
                if (text.length <= maxCharacters) {
                    return text;
                }
                return text.substring(0, maxCharacters) + '...';
            }
            /**
             * @method draw
             * @param source {object} - a single tree node
             */
            function draw(source) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
                var treeData = tree(root);
                var nodes = treeData.descendants();
                var links = treeData.descendants().slice(1);
                // this build an array of the nodes
                // as their id as the identifier
                var node = nodesContainer.selectAll('g.node').data(nodes, function (node) {
                    return node.id;
                });
                var avatarPromises = [];
                var allNodes = links;
                // adds the avatar image to the circle
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
                _.forEach(nodes, function (node) {
                    // Normalize for fixed-depth.
                    node.y = node.depth * 280;
                    //fetch only unknown avatars
                    if (!avatars[node.data.id]) {
                        //request the avatar
                        var promise = AvatarsService.getUrlByUserId(node.data.id, 'md');
                        //save the image when the request is complete
                        promise.then(function (image) {
                            avatars[node.data.id] = image;
                        });
                        //save the request
                        avatarPromises.push(promise);
                    }
                });
                //when all the avatar requests are complete
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
                //update the nodes to include the avatars
                $q.all(avatarPromises).then(function () {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'canViewUser' implicitly has an 'any' ty... Remove this comment to see the full error message
                    // Enter any new nodes at the parent's previous position.
                    var nodeEnter = node.enter().append('g')
                        .attr('class', 'node')
                        .attr("transform", function (d) {
                        return "translate(" + source.y0 + "," + source.x0 + ")";
                    });
                    nodeEnter
                        .append('g')
                        .attr('style', function (node) {
                        var x = (node.parent && node.parent.x0) || (source && source.x0) || 0, y = (node.parent && node.parent.y0) || (source && source.y0) || 0;
                        return getTranslateStyle(y, x);
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'personId' implicitly has an 'any' type.
                    });
                    // the rectangular container
                    nodeEnter
                        .append('rect')
                        .attr('class', 'rectangle')
                        .attr('height', cardHeight)
                        .attr('width', cardWidth)
                        .attr('style', function () {
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
                        return getTranslateStyle(cardHeight / -2, cardHeight / -2);
                    })
                        .on('click', clickNodeEvent);
                    nodeEnter
                        .enter()
                        .append('circle')
                        .attr('class', 'circle')
                        .attr('r', 20);
                    // update the nodes with their images
                    nodeEnter
                        .append('image')
                        .attr('xlink:href', function (node) {
                        return avatars[node.data.id];
                    })
                        .attr('height', '40px')
                        .attr('width', '40px')
                        .attr('x', '-20px')
                        .attr('y', '-20px')
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'x' implicitly has an 'any' type.
                        .attr('clip-path', 'url(#clip-circle-for-avatar)')
                        .on('click', clickNodeEvent);
                    // adds the Person's name text
                    nodeEnter
                        .append('text')
                        .attr('class', 'name')
                        .text(function (d) {
                        return trimText(d.data.firstName + ' ' + d.data.lastName);
                    })
                        .on('click', goToPeoplePage);
                    // adds the Person's title text
                    nodeEnter
                        .append('text')
                        .attr('class', 'title')
                        .text(function (d) {
                        return (d.data.title && trimText(d.data.title)) || 'no title';
                    });
                    // adds the Person's team text
                    nodeEnter
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'y' implicitly has an 'any' type.
                        .append('text')
                        .attr('class', function (node) {
                        // If the current user doesn't have permission to link to the team, hide this node
                        // If there is no team, make the text red
                        return node.data._showTeam
                            ? node.data.userTeams[0]
                                ? 'team primary'
                                : 'team danger'
                            : 'hidden-xs-up';
                    })
                        .text(function (node) {
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'text' implicitly has an 'any' type.
                        return node.data.userTeams[0] ? 'view team' : '';
                    })
                        .on('click', goToTeamPage);
                    // add the Person's number of children text
                    nodeEnter
                        .append('text')
                        .attr('class', 'children-count')
                        .attr('text-anchor', 'end')
                        .text(function (node) {
                        return ((node.children && node.children.length) ||
                            (node._children && node._children.length) ||
                            0
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'source' implicitly has an 'any' type.
                        );
                    })
                        .on('click', clickNodeEvent);
                    // Transition nodes to their new position.
                    var nodeUpdate = nodesContainer.selectAll(".node")
                        .transition()
                        .duration(animationDuration)
                        .attr('style', function (node) {
                        return getInvertedTranslateStyle(node.y, node.x);
                    });
                    // updates all nodes on refresh
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
                    nodeUpdate.attr('class', function (node) {
                        var classNames = 'node active';
                        // @ts-ignore ts-migrate(7034) FIXME: Variable 'avatarPromises' implicitly has type 'any... Remove this comment to see the full error message
                        if (node.children || node._children) {
                            classNames += ' has-children';
                            if (node._children) {
                                classNames += ' hidden-children';
                            }
                        }
                        return classNames;
                    });
                    // Transition exiting nodes to the parent's new position.
                    var nodeExit = node.exit().transition()
                        // @ts-ignore ts-migrate(7005) FIXME: Variable 'avatars' implicitly has an 'any[]' type.
                        .duration(animationDuration)
                        .attr("transform", function (d) {
                        return "translate(" + source.y + "," + source.x + ")";
                    })
                        .remove();
                });
                // Update the links…
                var link = nodesContainer.selectAll('path.link').data(links, function (link) {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'image' implicitly has an 'any' type.
                    return link.id;
                });
                // Enter any new links at the parent's previous position.
                var linkEnter = link.enter()
                    .insert('path', 'g')
                    .attr('class', 'link')
                    .attr('d', function (d) {
                    var ret = "M" + d.y + "," + d.x
                        + "C" + (d.y + d.parent.y) / 2 + "," + d.x
                        + " " + (d.y + d.parent.y) / 2 + "," + d.parent.x
                        // @ts-ignore ts-migrate(7005) FIXME: Variable 'avatarPromises' implicitly has an 'any[]... Remove this comment to see the full error message
                        + " " + d.parent.y + "," + d.parent.x;
                    return ret;
                });
                var linkUpdate = linkEnter.merge(link);
                // Transition links to their new position.
                linkUpdate
                    .transition()
                    .duration(animationDuration)
                    .attr('d', function (d) {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                    var ret = "M" + d.y + "," + d.x
                        + "C" + (d.y + d.parent.y) / 2 + "," + d.x
                        + " " + (d.y + d.parent.y) / 2 + "," + d.parent.x
                        + " " + d.parent.y + "," + d.parent.x;
                    return ret;
                });
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
                // Transition exiting nodes to the parent's new position.
                var linkExit = link.exit()
                    .transition()
                    .duration(animationDuration)
                    .attr('d', function (d) {
                    var p = { source: d, target: d.parent };
                    diagonal(p);
                })
                    .remove();
                // Stash the old positions for transition.
                _.forEach(allNodes, function (node) {
                    node.x0 = node.x;
                    node.y0 = node.y;
                });
            }
            /**
             * Because there is no method to get the current height of
             * the d3 tree, I had to wrap the tree in a bounding box
             * that will allow the container and canvas to be responsive
             * in vertical height. Width is handled with css overflow.
             */
            function resizeCanvas() {
                var minHeight;
                var yMargin = 50;
                var nodesArray = nodesContainer._groups;
                var rectangle = nodesArray[0][0].getBoundingClientRect(); //nodesContainer[0][0].getBoundingClientRect();
                minHeight = rectangle.height + yMargin * 2 + 50;
                // set the height of the svg element
                svg.attr('height', minHeight);
                //set the width of the svg element if needed
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
                var containerWidth = svg._groups[0][0].parentNode.clientWidth;
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'avatars' implicitly has an 'any[]' type.
                // TODO: Find permanent fix for FireFox bounding box width
                // FireFox's value for the bounding box width is different.
                var fudge = isFirefox ? cardWidth / 2 : 0;
                if (rectangle.width + fudge > containerWidth) {
                    // without the extra 0% the width will explode the view, hack!
                    svg.attr('style', 'width: calc(0% + ' + (200 + rectangle.width) + 'px);');
                }
                else {
                    // Remove style tag
                    svg.attr('style', null);
                }
                /**
                 * The following is to center the nodeContainer vertically.
                 * The problem is that the tree is not always centered, meaning
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                 * sometimes it adds tree nodes more on the top then bottom. So you
                 * have to go through the nodes, find the extremes, subtract the extremes
                 * and then divide by 2 and then subtract that from the height of
                 * the bounding box. Thus the tree will also be vertically centered.
                 */
                var extremeHigh = 0;
                var extremeLow = 0;
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                //let nodes = d3Service.d3.hierarchy(root, d => d.children);
                var nodes = tree(root);
                var allNodes = nodes.descendants().slice(1);
                _.forEach(allNodes, function (node) {
                    if (node.x < extremeLow) {
                        extremeLow = node.x;
                    }
                    if (node.x > extremeHigh) {
                        extremeHigh = node.x;
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
                    }
                });
                var newPosition = (minHeight / 2 - (extremeLow + extremeHigh) / 2) - 25;
                nodesContainer.attr('style', function () {
                    return getTranslateStyle(80, newPosition);
                });
            }
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.

(function () {
    var ua = window.navigator.userAgent.toLowerCase();
    /**
     * @property isMSBrowser
     * @type {boolean}
     * This value is independent of the app, so define it once in this IIFE.
     */
    var isMSBrowser = ua.indexOf('edge/') !== -1 || ua.indexOf('trident/') !== -1;
    /**
     * @property isFireFox
     * @type {boolean}
     */
    var isFirefox = ua.indexOf('firefox') !== -1 && !isMSBrowser;
    angular
        .module('App.Util')
        .directive('chartOrg', [
        '$q',
        '$state',
        'AuthenticationService',
        'AvatarsService',
        'd3Service',
        'LogoService',
        'PeopleService',
        'TEMPLATE_PATH',
        chartOrg,
    ]);
    /**
     * @directive chart-org
     *
     * Visual display of managers and direct reports based on D3.
     */
    function chartOrg($q, $state, AuthenticationService, AvatarsService, d3Service, LogoService, PeopleService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$q' implicitly has an 'any' type.
    TEMPLATE_PATH
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AuthenticationService' implicitly has a... Remove this comment to see the full error message
    ) {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AvatarsService' implicitly has an 'any'... Remove this comment to see the full error message
        var DirectiveDefinition = {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd3Service' implicitly has an 'any' type... Remove this comment to see the full error message
            link: link,
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'LogoService' implicitly has an 'any' ty... Remove this comment to see the full error message
            restrict: 'E',
            scope: {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TEMPLATE_PATH' implicitly has an 'any' ... Remove this comment to see the full error message
                hierarchyData: '<',
                primaryPersonId: '@',
            },
            templateUrl: TEMPLATE_PATH + '/util/chart-hierarchy/util.chart-hierarchy.html',
        };
        return DirectiveDefinition;
        function link(scope) {
            /**
             * @property fn
             * @type {object}
             * functions
             */
            scope.fn = {
                expand: expand,
                collapse: collapse,
            };
            /**
             * @property avatars
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
             * @type {Array}
             */
            var avatars = [];
            /**
             * @property currentUserId
             * @type {number}
             */
            var currentUserId = AuthenticationService.getAccount().userId;
            /**
             * @property hierarchyTreeData
             * @type {Array}
             */
            var hierarchyTreeData = buildHierarchyTreeData(scope.hierarchyData);
            /**
// @ts-ignore ts-migrate(7034) FIXME: Variable 'avatars' implicitly has type 'any[]' in ... Remove this comment to see the full error message
             * @property rootNode
             * @type {Object}
             * The primary tree node, first in line
             */
            var rootNode = hierarchyTreeData[0];
            /**
             * @property animationDuration
             * @type {number}
             */
            var animationDuration = 200;
            /**
             * @property maxCharacters
             * @type {number}
             * Due to the fact we are drawing text, this will limit
             * the amount of characters displayed for names and titles
             */
            var maxCharacters = 16;
            /**
             * @property cardWidth
             * @type {number}
             */
            var cardWidth = 225;
            /**
             * @property cardHeight
             * @type {number}
             */
            var cardHeight = 80;
            var treeData = {};
            var root = {};
            /**
             * @property tree
             * @type {object}
             */
            var tree = d3Service.d3.tree().nodeSize([cardHeight + 20, cardWidth + 80]);
            /**
             * @property diagonal
             * @type {function}
             * this positions the node on the link lines
             */
            var diagonal = function link(d) {
                return "M" + d.source.y + "," + d.source.x
                    + "C" + (d.source.y + d.target.y) / 2 + "," + d.source.x
                    + " " + (d.source.y + d.target.y) / 2 + "," + d.target.x
                    + " " + d.target.y + "," + d.target.x;
            };
            /**
             * @property canvas
             * @type {object}
             * the HTML element that hold the svg element
             */
            var canvas = d3Service.d3.select('#hierarchy-canvas');
            /**
             * @property svg
             * @type {object}
             */
            var svg = canvas.append('svg').attr('shape-rendering', 'optimizeSpeed');
            /**
             * @property nodesContainer
             * @type {object}
             * HTML element that contains all of the tree nodes
             */
            var nodesContainer = svg.append('g').attr('id', 'container-nodes');
            /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
             * @property definitions
             * @type {object}
             * sometime svg needs to reference another HTML element
             * to manipulate images, gradients, etc. This HTML element
             * will hold all of the needed definitions.
             */
            var defs = nodesContainer.append('defs');
            /**
             * @property clipPathForAvatar
             * @type {object}
             * HTML element so that we can make the avatars circular
             */
            var clipPath = defs
                .append('clipPath')
                .attr('id', 'clip-circle-for-avatar')
                .append('circle')
                .attr('r', 20);
            /**
             * @property lazyResizeCanvas
             * @type {function}
             */
            var lazyResizeCanvas = _.debounce(resizeCanvas, 50);
            /**
             * @property isLoaded
             * @type {boolean}
             * Don't show the hierarchy graph until we are ready.
             */
            scope.isLoaded = false;
            /**
             * @property isShowGraph
             * @type {boolean}
             * Don't show the hierarchy graph to Microsoft browsers.
             */
            scope.isShowGraph = !isMSBrowser;
            init();
            /**
             * @method init
             */
            function init() {
                treeData = hierarchyTreeData;
                rootNode = hierarchyTreeData[0];
                root = d3Service.d3.hierarchy(rootNode, function (d) { return d.children; });
                // @ts-ignore
                root.x0 = 0;
                // @ts-ignore
                root.y0 = 0;
                //collapse and draw the graph
                //root.children.forEach( collapseAll);
                collapseAll(root);
                scope.isLoaded = true;
                draw(root);
                lazyResizeCanvas();
            }
            /**
             * @method collapse
             * @returns {none}
             * Collapse expanded nodes to the *DEFAULT* expanse. Does not collapse to the root node.
             */
            function collapse() {
                if (scope.primaryPersonId === rootNode.id) {
                    collapseAll(root);
                }
                else {
                    collapseAll(root);
                    //find the primary person's node to collapse below
                    // let nodes = d3Service.d3.hierarchy(rootNode, d => d.children);
                    // nodes = tree(nodes);
                    // const allNodes = nodes.descendants().slice(1);
                    // _.forEach(allNodes, function(node) {
                    // 	if (node.data.id === scope.primaryPersonId && node.data.children) {
                    // 		return _.forEach(node.data.children, collapseNodes);
                    // 	}
                    // });
                }
                draw(root);
                lazyResizeCanvas();
            }
            // Collapse the node and all it's children
            function collapseAll(d) {
                if (d.children) {
                    d._children = d.children;
                    d._children.forEach(collapseAll);
                    d.children = null;
                }
            }
            /**
             * @method collapseNodes
             * @param node
             * @returns {void}
             */
            function collapseNodes(node) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                if (node.children) {
                    _.forEach(node.children, function (childNode) {
                        collapseNodes(childNode);
                    });
                    if (node.id !== scope.primaryPersonId) {
                        node._children = node.children;
                        delete node.children;
                    }
                }
            }
            /**
             * @method expand
             * @returns {none}
             */
            function expand() {
                expandNode(root);
                draw(root);
                lazyResizeCanvas();
            }
            /**
             * @method  expandNode
             * @property {object} node a single tree node
             * Expands a single node in the tree
             */
            function expandNode(node) {
                if (node._children) {
                    node.children = node._children;
                    delete node._children;
                }
                _.forEach(node.children, expandNode);
            }
            /**
             * @method  buildHierarchyTreeData
             * @param data {object} - the hierarchy data from back-end
             * @returns {Array} - tree data that d3 can use to build the tree
             * This takes the hierarchy data and converts it into tree
             * structure that d3 can use to display
             */
            function buildHierarchyTreeData(data) {
                var currentUserNode, rawData = angular.copy(data), treeData = [], dataMap = _.keyBy(rawData, 'id');
                _.forEach(rawData, function (node) {
                    var manager = dataMap[node.reportsToId];
                    if (node.id === currentUserId) {
                        currentUserNode = node;
                    }
                    if (manager) {
                        (manager.children || (manager.children = [])).push(node);
                    }
                    else {
                        treeData.push(node);
                    }
                });
                return treeData;
            }
            /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
             * @function updateHierarchyChildren
             * @param node {object}
             * Recursive function that iterates through all the children of node
             * Called by buildHierarchyTreeData with the Current User as the first node
             * Allows current user to view the team link for subordinates
             */
            function updateHierarchyChildren(node) {
                node._showTeam = true;
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
                _.forEach(node.children, updateHierarchyChildren);
            }
            /**
             * @method clickNodeEvent
             * @property {object} node a single tree node
             * Handles when the each node in the tree
             * is clicked expanding and contracting the org chart.
             */
            function clickNodeEvent(node) {
                if (node.children) {
                    node._children = node.children;
                    node.children = null;
                }
                else {
                    node.children = node._children;
                    node._children = null;
                    //expandNode(node);
                }
                draw(node);
                lazyResizeCanvas();
            }
            /**
             * @method goToPeoplePage
             * @param  {object} node a single tree node
             */
            function goToPeoplePage(node) {
                canCurrentUserViewSelectedUser(node.data.id).then(function (canViewUser) {
                    if (canViewUser) {
                        $state.go('app.people.show', {
                            personId: node.data.id,
                            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
                        });
                    }
                });
            }
            /**
             * @function canCurrentUserViewSelectedUser
             * @private
             * Determine if the current user is allowed to view the selected user.
             */
            function canCurrentUserViewSelectedUser(personId) {
                return PeopleService.canViewUser(currentUserId, personId);
            }
            /**
             * @method getTranslateStyle
             * @param  {number} x the x position
             * @param  {number} y the y position
             * @returns {string} the CSS style to apply
             */
            function getTranslateStyle(x, y) {
                var style = 'transform: ' + 'translate(' + x + 'px, ' + y + 'px); ';
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'data' implicitly has an 'any' type.
                style += '-ms-transform: ' + 'translate(' + x + 'px, ' + y + 'px); ';
                // @ts-ignore ts-migrate(7034) FIXME: Variable 'treeData' implicitly has type 'any[]' in... Remove this comment to see the full error message
                style += '-webkit-transform: ' + 'translate(' + x + 'px, ' + y + 'px); ';
                return style;
            }
            /**
             * @method getInvertedTranslateStyle
             * @param  {number} y the y position
             * @param  {number} x the x position
             * @returns {string} the CSS style to apply
             */
            function getInvertedTranslateStyle(y, x) {
                var a = y, b = x;
                return getTranslateStyle(a, b);
            }
            /**
             * @method trimText
             * @param text {string} - the text to trim
             * @returns {string} - the trimmed text
             * Since all of this is drawn and there is no wrapping of
// @ts-ignore ts-migrate(7005) FIXME: Variable 'treeData' implicitly has an 'any[]' type... Remove this comment to see the full error message
             * text, this will truncate long names and titles
             */
            function trimText(text) {
                text = text.trim();
                if (text.length <= maxCharacters) {
                    return text;
                }
                return text.substring(0, maxCharacters) + '...';
            }
            /**
             * @method draw
             * @param source {object} - a single tree node
             */
            function draw(source) {
                var treeData = tree(root);
                var nodes = treeData.descendants();
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
                var links = treeData.descendants().slice(1);
                // this build an array of the nodes
                // as their id as the identifier
                var node = nodesContainer.selectAll('g.node').data(nodes, function (node) {
                    return node.id;
                });
                var avatarPromises = [];
                var allNodes = links;
                // Logo for Root Node
                var logoPromise = LogoService.getImageUrl('lg');
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
                logoPromise.then(function (image) {
                    avatars[0] = image;
                });
                avatarPromises.push(logoPromise);
                // adds the avatar image to the circle
                _.forEach(nodes, function (node) {
                    //fetch only unknown avatars
                    if (!avatars[node.data.id] && node.data.id) {
                        var promise = AvatarsService.getUrlByUserId(node.data.id, 'md');
                        //save the image when the request is complete
                        promise.then(function (image) {
                            avatars[node.data.id] = image;
                        });
                        //save the request
                        avatarPromises.push(promise);
                    }
                });
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
                //when all the avatar requests are complete
                //update the nodes to include the avatars
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'canViewUser' implicitly has an 'any' ty... Remove this comment to see the full error message
                $q.all(avatarPromises).then(function () {
                    // Enter any new nodes at the parent's previous position.
                    var nodeEnter = node.enter().append('g')
                        .attr('class', 'node')
                        .attr("transform", function (d) {
                        return "translate(" + source.y0 + "," + source.x0 + ")";
                    });
                    nodeEnter
                        .append('g')
                        .attr('style', function (node) {
                        var x = (node.parent && node.parent.x0) || (source && source.x0) || 0, 
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'personId' implicitly has an 'any' type.
                        y = (node.parent && node.parent.y0) || (source && source.y0) || 0;
                        return getTranslateStyle(y, x);
                    });
                    // the rectangular container
                    nodeEnter
                        .append('rect')
                        .attr('class', 'rectangle')
                        .attr('height', cardHeight)
                        .attr('width', cardWidth)
                        .attr('style', function () {
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'x' implicitly has an 'any' type.
                        return getTranslateStyle(cardHeight / -2, cardHeight / -2);
                    })
                        .on('click', clickNodeEvent);
                    nodeEnter
                        .enter()
                        .append('circle')
                        .attr('class', 'circle')
                        .attr('r', 20);
                    // update the nodes with their images
                    nodeEnter
                        .append('image')
                        .attr('xlink:href', function (node) {
                        return avatars[node.data.id];
                    })
                        .attr('height', function (node) {
                        // logos large, avatars small
                        return node.data.id === 0 ? '70px' : '40px';
                    })
                        .attr('width', function (node) {
                        // logos large, avatars small
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'y' implicitly has an 'any' type.
                        return node.data.id === 0 ? '200px' : '40px';
                    })
                        .attr('x', function (node) {
                        // logos centered, avatars left
                        return node.data.id === 0 ? '10px' : '-20px';
                    })
                        .attr('y', function (node) {
                        // logos centered, avatars middle
                        return node.data.id === 0 ? '-35px' : '-20px';
                    })
                        .attr('clip-path', function (node) {
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'text' implicitly has an 'any' type.
                        return node.data.id === 0 ? '' : 'url(#clip-circle-for-avatar)';
                    })
                        .on('click', clickNodeEvent);
                    // adds the Person's name text
                    nodeEnter
                        .append('text')
                        .attr('class', 'name')
                        .text(function (d) {
                        return trimText(d.data.firstName + ' ' + d.data.lastName);
                    })
                        .on('click', goToPeoplePage);
                    // adds the Person's title text
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'source' implicitly has an 'any' type.
                    nodeEnter
                        .append('text')
                        .attr('class', 'title')
                        .text(function (d) {
                        if (d.data.id) {
                            return (d.data.title && trimText(d.data.title)) || 'no title';
                        }
                    });
                    // adds the Person's email text
                    nodeEnter
                        .append('text')
                        .attr('class', 'email')
                        .text(function (d) {
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
                        if (d.data.id !== 0) {
                            return (d.data.emailAddress && trimText(d.data.emailAddress)) || 'no email';
                        }
                    });
                    // add the Person's number of children text
                    nodeEnter
                        .append('text')
                        .attr('class', 'children-count')
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'image' implicitly has an 'any' type.
                        .attr('text-anchor', 'end')
                        .text(function (node) {
                        return ((node.children && node.children.length) ||
                            (node._children && node._children.length) ||
                            0);
                    })
                        .on('click', clickNodeEvent);
                    // Transition nodes to their new position.
                    // @ts-ignore ts-migrate(7005) FIXME: Variable 'avatars' implicitly has an 'any[]' type.
                    var nodeUpdate = nodesContainer.selectAll(".node")
                        .transition()
                        .duration(animationDuration)
                        .attr('style', function (node) {
                        return getInvertedTranslateStyle(node.y, node.x);
                    });
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'image' implicitly has an 'any' type.
                    // updates all nodes on refresh
                    nodeUpdate.attr('class', function (node) {
                        var classNames = 'node active';
                        if (node.children || node._children) {
                            classNames += ' has-children';
                            if (node._children) {
                                classNames += ' hidden-children';
                            }
                        }
                        return classNames;
                    });
                    // Transition exiting nodes to the parent's new position.
                    var nodeExit = node.exit().transition()
                        .duration(animationDuration)
                        .attr("transform", function (d) {
                        return "translate(" + source.y + "," + source.x + ")";
                    })
                        .remove();
                });
                // Update the links…
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                var link = nodesContainer.selectAll('path.link').data(links, function (link) {
                    return link.id;
                });
                // Enter any new links at the parent's previous position.
                var linkEnter = link.enter()
                    .insert('path', 'g')
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
                    .attr('class', 'link')
                    .attr('d', function (d) {
                    var ret = "M" + d.y + "," + d.x
                        + "C" + (d.y + d.parent.y) / 2 + "," + d.x
                        + " " + (d.y + d.parent.y) / 2 + "," + d.parent.x
                        + " " + d.parent.y + "," + d.parent.x;
                    return ret;
                });
                var linkUpdate = linkEnter.merge(link);
                // Transition links to their new position.
                linkUpdate
                    .transition()
                    .duration(animationDuration)
                    .attr('d', function (d) {
                    var ret = "M" + d.y + "," + d.x
                        + "C" + (d.y + d.parent.y) / 2 + "," + d.x
                        + " " + (d.y + d.parent.y) / 2 + "," + d.parent.x
                        + " " + d.parent.y + "," + d.parent.x;
                    return ret;
                });
                // Transition exiting nodes to the parent's new position.
                var linkExit = link.exit()
                    .transition()
                    .duration(animationDuration)
                    .attr('d', function (d) {
                    var p = { source: d, target: d.parent };
                    diagonal(p);
                })
                    .remove();
                // Stash the old positions for transition.
                _.forEach(allNodes, function (node) {
                    node.x0 = node.x;
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
                    node.y0 = node.y;
                });
            }
            /**
// @ts-ignore ts-migrate(7005) FIXME: Variable 'avatars' implicitly has an 'any[]' type.
             * Because there is no method to get the current height of
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
             * the d3 tree, I had to wrap the tree in a bounding box
             * that will allow the container and canvas to be responsive
             * in vertical height. Width is handled with css overflow.
             */
            function resizeCanvas() {
                var minHeight;
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
                var yMargin = 50;
                var nodesArray = nodesContainer._groups;
                var rectangle = nodesArray[0][0].getBoundingClientRect(); //nodesContainer[0][0].getBoundingClientRect();
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
                minHeight = rectangle.height + yMargin * 2 + 50;
                // set the height of the svg element
                svg.attr('height', minHeight);
                //set the width of the svg element if needed
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
                var containerWidth = svg._groups[0][0].parentNode.clientWidth;
                // TODO: Find permanent fix for FireFox bounding box width
                // FireFox's value for the bounding box width is different.
                var fudge = isFirefox ? cardWidth / 2 : 0;
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.
                if (rectangle.width + fudge > containerWidth) {
                    // without the extra 0% the width will explode the view, hack!
                    svg.attr('style', 'width: calc(0% + ' + (200 + rectangle.width) + 'px);');
                }
                else {
                    // Remove style tag
                    svg.attr('style', null);
                }
                /**
                 * The following is to center the nodeContainer vertically.
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                 * The problem is that the tree is not always centered, meaning
                 * sometimes it adds tree nodes more on the top then bottom. So you
                 * have to go through the nodes, find the extremes, subtract the extremes
                 * and then divide by 2 and then subtract that from the height of
                 * the bounding box. Thus the tree will also be vertically centered.
                 */
                var extremeHigh = 0;
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                var extremeLow = 0;
                //let nodes = d3Service.d3.hierarchy( rootNode, d => d.children );
                var nodes = tree(root);
                var allNodes = nodes.descendants().slice(1);
                _.forEach(allNodes, function (node) {
                    if (node.x < extremeLow) {
                        extremeLow = node.x;
                    }
                    if (node.x > extremeHigh) {
                        extremeHigh = node.x;
                    }
                });
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                var newPosition = (minHeight / 2 - (extremeLow + extremeHigh) / 2) - 25;
                nodesContainer.attr('style', function () {
                    return getTranslateStyle(80, newPosition);
                });
            }
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'node' implicitly has an 'any' type.

(function () {
    angular
        .module('App.Util')
        .directive('chartScatter', [
        'd3Service',
        'AvatarsService',
        '$window',
        '$state',
        '$filter',
        'CLIENT_SETTINGS',
        'TEMPLATE_PATH',
        chartScatter,
    ]);
    function chartScatter(
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd3Service' implicitly has an 'any' type... Remove this comment to see the full error message
    d3Service, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AvatarsService' implicitly has an 'any'... Remove this comment to see the full error message
    AvatarsService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$window' implicitly has an 'any' type.
    $window, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$state' implicitly has an 'any' type.
    $state, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$filter' implicitly has an 'any' type.
    $filter, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'CLIENT_SETTINGS' implicitly has an 'any... Remove this comment to see the full error message
    CLIENT_SETTINGS, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TEMPLATE_PATH' implicitly has an 'any' ... Remove this comment to see the full error message
    TEMPLATE_PATH) {
        var DirectiveDefinition = {
            link: link,
            restrict: 'E',
            scope: {
                chartData: '=',
                xAxisLabel: '@?',
                yAxisLabel: '@?',
            },
            templateUrl: TEMPLATE_PATH + '/util/chart-scatter/util.chart-scatter.html',
        };
        return DirectiveDefinition;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope, element, attrs) {
            /**
             * @property fn
             * @type {object}
             * functions
             */
            scope.fn = {};
            /**
             * @property isLoaded
             * @type {boolean}
             */
            scope.isLoaded = false;
            /**
             * @property xAxisLabel
             * @type {string}
             */
            scope.xAxisLabel = angular.isDefined(scope.xAxisLabel) ? scope.xAxisLabel : 'Performance';
            /**
             * @property yAxisLabel
             * @type {string}
             */
            scope.yAxisLabel = angular.isDefined(scope.yAxisLabel)
                ? scope.yAxisLabel
                : 'Culture / Leadership';
            /**
             * @property minValueXAxis
             * @type {Number}
             */
            var minValueXAxis = 0;
            /**
             * @property minValueYAxis
             * @type {Number}
             */
            var minValueYAxis = 0;
            /**
             * @property maxValueXAxis
             * @type {Number}
             */
            var maxValueXAxis = 0;
            /**
             * @property maxValueYAxis
             * @type {Number}
             */
            var maxValueYAxis = 0;
            /**
             * @property successThreshold
             * @type {Number}
             */
            var successThreshold = 0;
            /**
             * @property fallingBehindThreshold
             * @type {Number}
             */
            var fallingBehindThreshold = 0;
            /**
             * @property evaluationDirection
             * @type {Number}
             * This tells us which direction is positive,
             * 0 is regular, 1 is lower is better
             */
            var evaluationDirection = 0;
            /**
             * @property toolTipsHTML
             * @type {Array}
             * Holds all of the tooltips html
             */
            // @ts-ignore ts-migrate(7034) FIXME: Variable 'toolTipsHTML' implicitly has type 'any[]... Remove this comment to see the full error message
            var toolTipsHTML = [];
            /**
             * @property chartPeopleNames
             * @type {Object}
             * This holds all of the people names
             * so the chart tooltip displays the name
             * correctly for each dot
             */
            var chartPeopleNames = {};
            /**
             * @property chartXSColumns
             * @type {Object}
             * This is so the chart knows how to match up
             * the two points for each person, the performance and
             * culture/leadership
             */
            var chartXSColumns = {};
            /**
             * @property chartColumns
             * @type {Array}
             * This holds all of the dot data for each person
             */
            // @ts-ignore ts-migrate(7034) FIXME: Variable 'chartColumns' implicitly has type 'any[]... Remove this comment to see the full error message
            var chartColumns = [];
            init();
            /**
             * @method init
             * @return {none}
             */
            function init() {
                minValueXAxis = minValueYAxis = CLIENT_SETTINGS.evaluationMin;
                maxValueXAxis = maxValueYAxis = CLIENT_SETTINGS.evaluationMax;
                successThreshold = CLIENT_SETTINGS.evaluationCutpointMax;
                fallingBehindThreshold = CLIENT_SETTINGS.evaluationCutpointMin;
                evaluationDirection = CLIENT_SETTINGS.evaluationDirection;
                scope.$watch('chartData', buildDataAndChart);
            }
            /**
             * @method buildDataAndChart
             * @return {none}
             * This is called to prepare the people data
             * and the information needed to display the chart
             */
            function buildDataAndChart() {
                if (angular.isDefined(scope.chartData)) {
                    scope.isLoaded = true;
                }
                preparePeopleData();
                drawChart();
            }
            /**
             * @method clearChartColumns
             * @return {non}
             * Cleans the array
             */
            function clearChartColumns() {
                chartColumns = [];
            }
            /**
             * @method preparePeopleData
             * @return {none}
             * This will prepare the chart data based
             * on the people data provided for the chart
             */
            function preparePeopleData() {
                clearChartColumns();
                angular.forEach(scope.chartData, function (person) {
                    var performance = person.goalPerformance, cultureLeadership;
                    // C3 does WEIRD stuff with these objects when the key can be cast as an integer (e.g. key="111")
                    // Safari breaks C3 (0.4.15) when the key is a number greater than 999.
                    var key = 'person_' + String(person.id);
                    if (performance && (performance.cultureScore || performance.performanceScore)) {
                        // Leadership & Culture
                        if (performance.leadershipScore && performance.cultureScore) {
                            // Leadership AND Culture, take the average
                            cultureLeadership =
                                (Number(performance.leadershipScore) + (performance.cultureScore || 0)) / 2;
                        }
                        else {
                            // Leadership OR Culture
                            cultureLeadership = performance.leadershipScore || performance.cultureScore || 0;
                        }
                        // Names
                        // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                        chartPeopleNames[person.id] = $filter('personName')(person);
                        // xs columns
                        // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                        chartXSColumns[key] = key + '_x';
                        // columns
                        // Y AXIS: culture/leadership
                        chartColumns.push([key, _.clamp(cultureLeadership || 0, 0, maxValueYAxis)]);
                        // X AXIS: performance
                        chartColumns.push([
                            key + '_x',
                            _.clamp(performance.performanceScore || 0, 0, maxValueXAxis),
                        ]);
                        buildTooltipsHTML(key, person.title, cultureLeadership, performance.performanceScore);
                    }
                });
            }
            /**
             * @method buildTooltipsHTML
             * @param key {string}
             * @param title {string}
             * @param cultureLeadership {number}
             * @param performance {number}
             * @return {none}
             * This will build out string values for each
             * person's tooltip, including their avatar, name and
             * scores
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'key' implicitly has an 'any' type.
            function buildTooltipsHTML(key, title, cultureLeadership, performance) {
                // Extract ID from key (strip "person_")
                var id = String(key).replace(/\D*/g, '');
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                AvatarsService.getUrlByUserId(id, 'sm').then(function (response) {
                    toolTipsHTML[key] =
                        '<div class="tool-tip">' +
                            '<img class="user-avatar pull-xs-left" src="' +
                            response +
                            '" alt="User Avatar">' +
                            '<h5 class="m-a-0">' +
                            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                            chartPeopleNames[id] +
                            '</h5>' +
                            '<span class="text text-small text-muted m-a-0">' +
                            (title || 'no title') +
                            '</span>' +
                            '<div class="divider clearfix"></div>' +
                            '<div class="stats">Performance <span>' +
                            $filter('number')(performance, 1) +
                            '</span></div>' +
                            '<div class="stats">Culture/Leadership <span>' +
                            $filter('number')(cultureLeadership, 1) +
                            '</span></div>' +
                            '</div>';
                });
            }
            /**
             * @method drawChart
             * @return {none}
             * This will draw the chart
             */
            function drawChart() {
                var canvas = d3Service.d3.select(element[0]);
                var container = canvas.select('div.chart-scatter');
                var svg = container.select('div.svg');
                var chart = $window.c3.generate({
                    bindto: svg,
                    data: {
                        type: 'scatter',
                        names: chartPeopleNames,
                        xs: chartXSColumns,
                        // @ts-ignore ts-migrate(7005) FIXME: Variable 'chartColumns' implicitly has an 'any[]' ... Remove this comment to see the full error message
                        columns: chartColumns,
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'color' implicitly has an 'any' type.
                        color: function (color, d) {
                            var avgScore = (d.value + d.x) / 2;
                            // When scoring is higher number is better
                            if (evaluationDirection === 0) {
                                if (avgScore >= successThreshold) {
                                    return '#4CAF50';
                                }
                                if (avgScore < successThreshold && avgScore >= fallingBehindThreshold) {
                                    return '#FF9800';
                                }
                                if (avgScore < fallingBehindThreshold) {
                                    return '#F44336';
                                }
                            }
                            // When scoring is lower number is better
                            if (avgScore > successThreshold) {
                                return '#F44336';
                            }
                            if (avgScore <= successThreshold && avgScore > fallingBehindThreshold) {
                                return '#FF9800';
                            }
                            if (avgScore <= fallingBehindThreshold) {
                                return '#4CAF50';
                            }
                        },
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                        onclick: function (d) {
                            // d.id is "person_9999". Use regex to strip out non-digits
                            var id = String(d.id).replace(/\D*/g, '');
                            $state.go('app.people.show', { personId: id });
                        },
                    },
                    axis: {
                        x: {
                            min: minValueXAxis - 1,
                            max: maxValueXAxis + 1,
                            show: true,
                            tick: {
                                values: [minValueXAxis, fallingBehindThreshold, successThreshold, maxValueXAxis],
                            },
                            padding: {
                                left: 0,
                                right: 0,
                            },
                        },
                        y: {
                            min: minValueYAxis - 1,
                            max: maxValueYAxis + 1,
                            show: true,
                            tick: {
                                values: [minValueYAxis, fallingBehindThreshold, successThreshold, maxValueYAxis],
                            },
                            padding: {
                                top: 0,
                                bottom: 0,
                            },
                        },
                    },
                    grid: {
                        lines: {
                            front: false,
                        },
                        x: {
                            show: true,
                            lines: [
                                {
                                    value: fallingBehindThreshold,
                                },
                                {
                                    value: successThreshold,
                                },
                            ],
                        },
                        y: {
                            show: true,
                            lines: [
                                {
                                    value: fallingBehindThreshold,
                                },
                                {
                                    value: successThreshold,
                                },
                            ],
                        },
                    },
                    legend: {
                        show: false,
                    },
                    point: {
                        r: 8,
                    },
                    tooltip: {
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
                        contents: function (d) {
                            // @ts-ignore ts-migrate(7005) FIXME: Variable 'toolTipsHTML' implicitly has an 'any[]' ... Remove this comment to see the full error message
                            return toolTipsHTML[d[0].id];
                        },
                    },
                });
                if (scope.chartData && !scope.chartData.length) {
                    chart.destroy();
                }
            }
        }
    }
})();

(function () {
    angular.module('App.Util').directive('checkbox', ['TEMPLATE_PATH', CheckboxDirective]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TEMPLATE_PATH' implicitly has an 'any' ... Remove this comment to see the full error message
    function CheckboxDirective(TEMPLATE_PATH) {
        var DirectiveDefinitionObject = {
            restrict: 'E',
            link: link,
            scope: {
                model: '=?',
                label: '@',
                onChange: '&',
            },
            templateUrl: TEMPLATE_PATH + '/util/checkbox/util.checkbox.html',
        };
        return DirectiveDefinitionObject;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope) {
            /**
             * @property uniqueId
             * Create an ID for the input+label pair.
             */
            scope.uniqueId = _.uniqueId('util-checkbox-');
            /**
             * @method onToggle
             * @param event {Event}
             * When the user changes the input's status.
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
            scope.onToggle = function (event) {
                scope.onChange({ isChecked: event.target.checked });
            };
        }
    }
})();

(function () {
    /**
     * This limits the number of lines of text and adds
     * and ellipsis to the end if the text overflows.
     *
     * example:
     * <* line-clamp="2" ng-bind="the text to bind"></*>
     * This will limit the text in this element to 2 lines
     */
    angular.module('App.Util').directive('lineClamp', ['$timeout', LineClampDirective]);
    function LineClampDirective($timeout) {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter '$timeout' implicitly has an 'any' type.
        var DirectiveDefinition = {
            restrict: 'A',
            link: link,
        };
        return DirectiveDefinition;
        function link(scope, element, attrs) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
            var nbLines = parseInt(attrs.lineClamp, 10);
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'element' implicitly has an 'any' type.
            //  Watching binded variable on the same element which is clamped
            if (attrs.ngBind) {
                scope.$watch(attrs.ngBind, clampElement);
            }
            //  Clamping text
            clampElement();
            function clampElement() {
                //  Async apply
                $timeout(function () {
                    //  Calling Clamp.js method
                    clamp(element[0], {
                        clamp: nbLines,
                    });
                });
            }
        }
        /**
         * Clamps a text node.
         * @param {HTMLElement} element. Element containing the text node to clamp.
         * @param {Object} options. Options to pass to the clamper.
         */
        function clamp(element, options) {
            options = options || {};
            var win = window, opt = {
                clamp: options.clamp || 2,
                useNativeClamp: typeof options.useNativeClamp != 'undefined' ? options.useNativeClamp : true,
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'element' implicitly has an 'any' type.
                splitOnChars: options.splitOnChars || ['.', '-', '–', '—', ' '],
                animate: options.animate || false,
                truncationChar: options.truncationChar || '…',
                truncationHTML: options.truncationHTML,
            }, sty = element.style, originalText = element.innerHTML, supportsNativeClamp = typeof element.style.webkitLineClamp != 'undefined', clampValue = opt.clamp, isCSSValue = clampValue.indexOf && (clampValue.indexOf('px') > -1 || clampValue.indexOf('em') > -1), truncationHTMLContainer;
            if (opt.truncationHTML) {
                truncationHTMLContainer = document.createElement('span');
                truncationHTMLContainer.innerHTML = opt.truncationHTML;
            }
            // @ts-ignore ts-migrate(7034) FIXME: Variable 'truncationHTMLContainer' implicitly has ... Remove this comment to see the full error message
            // UTILITY FUNCTIONS __________________________________________________________
            /**
             * Return the current style for an element.
             * @param {HTMLElement} elem The element to compute.
             * @param {string} prop The style property.
             * @returns {number}
             */
            function computeStyle(elem, prop) {
                if (!win.getComputedStyle) {
                    win.getComputedStyle = function (el, pseudo) {
                        this.el = el;
                        this.getPropertyValue = function (prop) {
                            var re = /(\-([a-z]){1})/g;
                            if (prop == 'float')
                                prop = 'styleFloat';
                            if (re.test(prop)) {
                                prop = prop.replace(re, function () {
                                    return arguments[2].toUpperCase();
                                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'elem' implicitly has an 'any' type.
                                });
                                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'prop' implicitly has an 'any' type.
                            }
                            // @ts-ignore ts-migrate(2322) FIXME: Type '(el: Element, pseudo: string | null | undefi... Remove this comment to see the full error message
                            return el.currentStyle && el.currentStyle[prop] ? el.currentStyle[prop] : null;
                        };
                        return this;
                    };
                }
                return win.getComputedStyle(elem, null).getPropertyValue(prop);
            }
            /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'prop' implicitly has an 'any' type.
             * Returns the maximum number of lines of text that should be rendered based
             * on the current height of the element and the line-height of the text.
             */
            function getMaxLines(height) {
                var availHeight = height || element.clientHeight, lineHeight = getLineHeight(element);
                return Math.max(Math.floor(availHeight / lineHeight), 0);
            }
            /**
             * Returns the maximum height a given element should have based on the line-
             * height of the text and the given clamp value.
             */
            function getMaxHeight(clmp) {
                var lineHeight = getLineHeight(element);
                return lineHeight * clmp;
            }
            /**
             * Returns the line-height of an element as an integer.
             */
            function getLineHeight(elem) {
                var lh = computeStyle(elem, 'line-height');
                if (lh == 'normal') {
                    // Normal line heights vary from browser to browser. The spec recommends
                    // a value between 1.0 and 1.2 of the font size. Using 1.1 to split the diff.
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'height' implicitly has an 'any' type.
                    lh = parseInt(computeStyle(elem, 'font-size')) * 1.2;
                }
                return parseInt(lh);
            }
            // MEAT AND POTATOES (MMMM, POTATOES...) ______________________________________
            var splitOnChars = opt.splitOnChars.slice(0), splitChar = splitOnChars[0], chunks, lastChunk;
            /**
             * Gets an element's last child. That may be another node or a node's contents.
             */
            function getLastChild(elem) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'clmp' implicitly has an 'any' type.
                //Current element has children, need to go deeper and get last child as a text node
                if (elem.lastChild.children && elem.lastChild.children.length > 0) {
                    return getLastChild(Array.prototype.slice.call(elem.children).pop());
                }
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'elem' implicitly has an 'any' type.
                //This is the absolute last child, a text node, but something's wrong with it. Remove it and keep trying
                else if (!elem.lastChild ||
                    !elem.lastChild.nodeValue ||
                    elem.lastChild.nodeValue === '' ||
                    elem.lastChild.nodeValue == opt.truncationChar) {
                    elem.lastChild.parentNode.removeChild(elem.lastChild);
                    // @ts-ignore ts-migrate(2322) FIXME: Type 'number' is not assignable to type 'string'.
                    return getLastChild(element);
                }
                //This is the last child we want, return it
                else {
                    return elem.lastChild;
                }
            }
            /**
             * Removes one character at a time from the text until its width or
             * height is beneath the passed-in max param.
             */
            function truncate(target, maxHeight) {
                // @ts-ignore ts-migrate(7034) FIXME: Variable 'chunks' implicitly has type 'any' in som... Remove this comment to see the full error message
                if (!maxHeight) {
                    // @ts-ignore ts-migrate(7034) FIXME: Variable 'lastChunk' implicitly has type 'any' in ... Remove this comment to see the full error message
                    return;
                }
                /**
                 * Resets global variables.
                 */
                function reset() {
                    splitOnChars = opt.splitOnChars.slice(0);
                    // @ts-ignore ts-migrate(7023) FIXME: 'getLastChild' implicitly has return type 'any' be... Remove this comment to see the full error message
                    splitChar = splitOnChars[0];
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'elem' implicitly has an 'any' type.
                    chunks = null;
                    lastChunk = null;
                }
                var nodeValue = target.nodeValue.replace(opt.truncationChar, '');
                //Grab the next chunks
                if (!chunks) {
                    //If there are more characters to try, grab the next one
                    if (splitOnChars.length > 0) {
                        splitChar = splitOnChars.shift();
                    }
                    //No characters to chunk by. Go character-by-character
                    else {
                        splitChar = '';
                    }
                    chunks = nodeValue.split(splitChar);
                }
                //If there are chunks left to remove, remove the last one and see if
                // the nodeValue fits.
                if (chunks.length > 1) {
                    lastChunk = chunks.pop();
                    applyEllipsis(target, chunks.join(splitChar));
                }
                //No more chunks can be removed using this character
                else {
                    chunks = null;
                }
                //Insert the custom HTML before the truncation character
                if (truncationHTMLContainer) {
                    target.nodeValue = target.nodeValue.replace(opt.truncationChar, '');
                    element.innerHTML =
                        target.nodeValue + ' ' + truncationHTMLContainer.innerHTML + opt.truncationChar;
                }
                //Search produced valid chunks
                if (chunks) {
                    //It fits
                    // @ts-ignore ts-migrate(7023) FIXME: 'truncate' implicitly has return type 'any' becaus... Remove this comment to see the full error message
                    if (element.clientHeight <= maxHeight) {
                        //There's still more characters to try splitting on, not quite done yet
                        if (splitOnChars.length >= 0 && splitChar !== '') {
                            applyEllipsis(target, chunks.join(splitChar) + splitChar + lastChunk);
                            chunks = null;
                        }
                        //Finished!
                        else {
                            return element.innerHTML;
                        }
                    }
                }
                //No valid chunks produced
                else {
                    //No valid chunks even when splitting by letter, time to move
                    //on to the next node
                    if (splitChar === '') {
                        applyEllipsis(target, '');
                        // @ts-ignore ts-migrate(7005) FIXME: Variable 'chunks' implicitly has an 'any' type.
                        target = getLastChild(element);
                        reset();
                    }
                }
                //If you get here it means still too big, let's keep truncating
                if (opt.animate) {
                    $timeout(function () {
                        truncate(target, maxHeight);
                    }, opt.animate === true ? 10 : opt.animate);
                }
                else {
                    return truncate(target, maxHeight);
                }
            }
            function applyEllipsis(elem, str) {
                elem.nodeValue = str + opt.truncationChar;
            }
            // CONSTRUCTOR ________________________________________________________________
            if (clampValue == 'auto') {
                // @ts-ignore
                clampValue = getMaxLines();
            }
            else if (isCSSValue) {
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'chunks' implicitly has an 'any' type.
                clampValue = getMaxLines(parseInt(clampValue));
            }
            var clampedText;
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'chunks' implicitly has an 'any' type.
            if (supportsNativeClamp && opt.useNativeClamp) {
                sty.overflow = 'hidden';
                sty.textOverflow = 'ellipsis';
                sty.webkitBoxOrient = 'vertical';
                sty.display = '-webkit-box';
                sty.webkitLineClamp = clampValue;
                if (isCSSValue) {
                    sty.height = opt.clamp + 'px';
                }
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'truncationHTMLContainer' implicitly has ... Remove this comment to see the full error message
            }
            else {
                var height = getMaxHeight(clampValue);
                if (height <= element.clientHeight) {
                    clampedText = truncate(getLastChild(element), height);
                }
            }
            return {
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'truncationHTMLContainer' implicitly has ... Remove this comment to see the full error message
                original: originalText,
                clamped: clampedText,
            };
        }
    }
})();
// @ts-ignore ts-migrate(7005) FIXME: Variable 'chunks' implicitly has an 'any' type.

(function () {
    angular
        .module('App.Util')
        .directive('collapseText', ['$timeout', 'TEMPLATE_PATH', CollapseTextDirective]);
    /**
     * @directive collapse-text
     * Used to collapse an optionally long amount of content to a max height and show a "Show All..." button.
     * Once the button is clicked, the button disappears and the content expands using uib-collapse.
     *
     * Set collapse-max-height for how high (number of pixels) the content can be before it is collapsed. Default is 100.
     * (20 pixels are added for the height of the button)
     *
     * If you want part of the content exposed, style the .collapse-text-collapsed to set the maximum height.
     * (You should also set display:block and overflow:hidden.)
     * (This style is independent of collapse-max-height)
     *
     * Usage:
     *   <div collapse-text collapse-max-height="100">
     *     <span ng-bind-html="myContent"></span>
     *   </div>
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$timeout' implicitly has an 'any' type.
    function CollapseTextDirective($timeout, TEMPLATE_PATH) {
        var DirectiveDefinitionObject = {
            link: link,
            restrict: 'A',
            templateUrl: TEMPLATE_PATH + '/util/collapse-text/util.collapse-text.html',
            transclude: true,
        };
        return DirectiveDefinitionObject;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope, element, attributes) {
            // Wrapper that is collapsed
            var wrapperDiv = element.children()[0];
            // Div to determine transcluded content height
            var contentDiv = angular.element(wrapperDiv).children()[0];
            // The height threshold is the max height plus 20px for the button
            var maxHeight = ((attributes.collapseMaxHeight && Number(attributes.collapseMaxHeight)) || 100) + 20;
            // Assume collapsed
            scope.isCollapsed = true;
            // Turn animation off, so the user doesn't watch all the text collapse
            scope.isInanimate = true;
            scope.isInitiallyCollapsed = true;
            /**
             * @method toggle
             */
            scope.toggle = function () {
                scope.isInanimate = false;
                $timeout(function () {
                    // If you do this immediately, there won't be an animation.
                    scope.isCollapsed = !scope.isCollapsed;
                }, 1);
            };
            // Wait a turn for the content to render
            $timeout(function () {
                scope.isCollapsed = contentDiv.clientHeight > maxHeight;
                scope.isInitiallyCollapsed = scope.isCollapsed;
                wrapperDiv.style.height = scope.isCollapsed ? maxHeight : 'auto';
                scope.showToggleBtn = contentDiv.clientHeight > maxHeight;
            }, 100);
        }
    }
})();

(function () {
    angular
        .module('App.Util')
        .directive('comment', [
        '$anchorScroll',
        '$sce',
        '$timeout',
        'AuthenticationService',
        'DraftsService',
        'GoalNoteModal',
        'GoalNoteProgressUpdateModal',
        'GoalNotesService',
        'GoalNoteStatusUpdateModal',
        'TEMPLATE_PATH',
        CommentDirective,
    ]);
    function CommentDirective(
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$anchorScroll' implicitly has an 'any' ... Remove this comment to see the full error message
    $anchorScroll, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$sce' implicitly has an 'any' type.
    $sce, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$timeout' implicitly has an 'any' type.
    $timeout, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AuthenticationService' implicitly has a... Remove this comment to see the full error message
    AuthenticationService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'DraftsService' implicitly has an 'any' ... Remove this comment to see the full error message
    DraftsService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'GoalNoteModal' implicitly has an 'any' ... Remove this comment to see the full error message
    GoalNoteModal, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'GoalNoteProgressUpdateModal' implicitly... Remove this comment to see the full error message
    GoalNoteProgressUpdateModal, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'GoalNotesService' implicitly has an 'an... Remove this comment to see the full error message
    GoalNotesService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'GoalNoteStatusUpdateModal' implicitly h... Remove this comment to see the full error message
    GoalNoteStatusUpdateModal, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TEMPLATE_PATH' implicitly has an 'any' ... Remove this comment to see the full error message
    TEMPLATE_PATH) {
        var DirectiveDefinitionObject = {
            link: link,
            restrict: 'E',
            scope: {
                comment: '=?',
                goal: '=',
                noteId: '@?',
                planId: '=',
                readOnly: '@',
                replyLimit: '@',
                thread: '=',
            },
            templateUrl: TEMPLATE_PATH + '/util/comment/util.comment.html',
        };
        return DirectiveDefinitionObject;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope) {
            /**
             * @property author
             * @type {object} author
             */
            var author = AuthenticationService.getAccount();
            /**
             * @property draftKey
             * @type {string}
             * Unique identifier used for saving a draft.
             */
            // @ts-ignore ts-migrate(7034) FIXME: Variable 'draftKey' implicitly has type 'any' in s... Remove this comment to see the full error message
            var draftKey;
            /**
             * @property goalType
             * @type {string}
             */
            var goalType = GoalNotesService.getTypeFromGoal(scope.goal);
            scope.fn = {
                add: add,
                clear: clear,
                onChangeMessageBody: onChangeMessageBody,
                onChangeStatus: onChangeStatus,
                replyToThread: replyToThread,
                openGoalNoteModal: openGoalNoteModal,
                openGoalNoteStatusUpdateModal: openGoalNoteStatusUpdateModal,
                openGoalNoteProgressUpdateModal: openGoalNoteProgressUpdateModal,
                shouldShowProgressOption: shouldShowProgressOption,
            };
            /**
             * @property isCommentChanged
             * @type {boolean}
             */
            scope.isCommentChanged = false;
            /**
             * @property isEditMode
             * @type {boolean}
             */
            scope.isEditMode = false;
            /**
             * @property isReplying
             * @type {boolean}
             * Whether or not a new comment is a reply to another comment or at the root level.
             */
            scope.isReplying = false;
            /**
             * @property isShowReply
             * @type {boolean}
             * Allows
             */
            scope.isShowReply = scope.readOnly != 'true';
            /**
             * @property isShowStatusDropdown
             * @type {boolean}
             */
            scope.isShowStatusDropdown = false;
            /**
             * @property isShowTopLevelReply
             * @type {boolean}
             * Should this instance show the "add to conversation" box.
             * Depends on scope.isShowReply
             */
            scope.isShowTopLevelReply = scope.isShowReply && !scope.comment;
            /**
             * @property newComment
             * @type {Object}
             */
            scope.newComment = {
                author: {
                    id: author.userId,
                    firstName: author.firstName,
                    lastName: author.lastName,
                    createdDate: new Date(),
                },
                goalId: scope.goal.id,
                goalType: goalType,
                messageBody: '',
                status: scope.goal.status,
            };
            /**
             * @property tooltipIsOpen
             * @type {boolean}
             */
            scope.tooltipIsOpen = false;
            init();
            /**
             * @method add
             * @param messageBody {string}
             * @returns {void}
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'messageBody' implicitly has an 'any' ty... Remove this comment to see the full error message
            function add(messageBody) {
                // @ts-ignore ts-migrate(2345) FIXME: Argument of type '5551555' is not assignable to pa... Remove this comment to see the full error message
                var temporaryId = _.uniqueId(5551555), comment = _.defaults({
                    id: temporaryId,
                    isTemporary: true,
                    messageBody: messageBody,
                    createdDate: new Date(),
                }, scope.newComment), parentId = (scope.comment && scope.comment.id) || '0', omitKeys = ['id', 'isTemporary'];
                comment.parentMessageId = parentId;
                if (scope.isCommentChanged) {
                    if (!angular.isArray(scope.thread[parentId])) {
                        scope.thread[parentId] = [];
                    }
                    //add new comment to the top of the thread
                    scope.thread[parentId].unshift(comment);
                    if (scope.goal.syncKpiStatus) {
                        omitKeys.push('status');
                    }
                    GoalNotesService.save(_.omit(comment, omitKeys), goalType, scope.goal.id).then(
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                    function saveNewCommentSuccess(response) {
                        // Find the temporary record
                        var record = _.find(scope.thread[parentId], {
                            id: temporaryId,
                        });
                        // Remove the temporary flag
                        delete record.isTemporary;
                        // Replace the contents of the temporary record with response from API
                        _.assign(record, response.data);
                        if (!record.parentMessageId) {
                            record.parentMessageId = '0';
                        }
                        scope.isCommentChanged = false;
                        // Update status for the goal if this is a top level comment
                        if (record.parentMessageId == '0' && scope.goal.status !== record.status) {
                            scope.goal.status = record.status;
                        }
                        //remove associated draft
                        // @ts-ignore ts-migrate(7005) FIXME: Variable 'draftKey' implicitly has an 'any' type.
                        DraftsService.remove(draftKey, scope.goal.id);
                    }, 
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                    function saveNewCommentError(response) {
                        console.error('SAVE NEW COMMENT ERROR', response);
                    });
                    scope.isEditMode = false;
                }
            }
            /**
             * @method clear
             * Closes the comment box and clears the message body.
             */
            function clear() {
                scope.isEditMode = false;
                scope.isReplying = false;
                scope.isShowStatusDropdown = false;
                // Remove any existing drafts
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'draftKey' implicitly has an 'any' type.
                DraftsService.remove(draftKey, scope.goal.id);
            }
            /**
             * @method init
             * Method called on initialization of directive
             */
            function init() {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'newValue' implicitly has an 'any' type.
                scope.$watch('goal', function (newValue) {
                    //update newComment.status when the status is updated outside the directive
                    scope.newComment.status = newValue.status;
                });
                // Determine the goal type to display visibility list
                if (scope.goal.alignmentGoalType) {
                    //is alignment goal type
                    scope.visibilityPopover = $sce.trustAsHtml('<div class="p-r-3">This note will be seen by:<ul class="p-l-2 m-t-1"><li>Reporting Hierarchy</li></ul></div>');
                }
                else if (scope.goal.performanceGoalType) {
                    // is performance goal type
                    if (scope.goal.performanceGoalType === 'PLAN') {
                        scope.visibilityPopover = $sce.trustAsHtml('<div class="p-r-3">This note will be seen by:<ul class="p-l-2 m-t-1"><li>Plan Admins</li><li>All Plan Access Levels</li><li>All Goal Access Levels</li><li>Reporting Hierarchy</li></ul></div>');
                    }
                    else {
                        scope.visibilityPopover = $sce.trustAsHtml('<div class="p-r-3">This note will be seen by:<ul class="p-l-2 m-t-1"><li>All Goal Access Levels</li><li>Reporting Hierarchy</li></ul></div>');
                    }
                }
                // Create the key used for draft notes
                draftKey = 'goal-' + goalType + '-' + ((scope.comment && scope.comment.id) || '0');
                // Plan goals
                if (scope.planId) {
                    scope.newComment.planId = Number(scope.planId);
                }
                // Scroll if note id present
                if (scope.noteId) {
                    $anchorScroll.yOffset = 150;
                    scrollToNote();
                }
                isLocalDraft();
            }
            /**
             * @method isLocalDraft
             * Check if the comments has a local draft saved
             */
            function isLocalDraft() {
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'draftKey' implicitly has an 'any' type.
                if (DraftsService.get(draftKey, scope.goal.id)) {
                    if (!scope.comment || scope.comment.parentId == '0') {
                        startEditMode();
                    }
                    else {
                        replyToThread();
                    }
                }
            }
            /**
             * @method onChangeMessageBody
             */
            function onChangeMessageBody() {
                scope.isCommentChanged = true;
                //store the message as a draft
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'draftKey' implicitly has an 'any' type.
                DraftsService.store(draftKey, scope.goal.id, scope.newComment.messageBody);
            }
            /**
             * @method onChangeStatus
             * @param status {number}
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'status' implicitly has an 'any' type.
            function onChangeStatus(status) {
                scope.newComment.status = status;
                scope.isCommentChanged = true;
            }
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'options' implicitly has an 'any' type.
            function openGoalNoteModal(options) {
                // get result back from this, call add() to persist message body
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'results' implicitly has an 'any' type.
                return GoalNoteModal.open(options).then(function (results) {
                    if (results.message) {
                        scope.isCommentChanged = true;
                    }
                    add(results.message);
                });
            }
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'options' implicitly has an 'any' type.
            function openGoalNoteProgressUpdateModal(options) {
                return GoalNoteProgressUpdateModal.open(options);
            }
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'options' implicitly has an 'any' type.
            function openGoalNoteStatusUpdateModal(options) {
                return GoalNoteStatusUpdateModal.open(options);
            }
            /**
             * @method replyToThread
             */
            function replyToThread() {
                scope.isEditMode = true;
                scope.isReplying = true;
                scope.isShowStatusDropdown = !scope.goal.syncKpiStatus;
                //look for any saved drafts
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'draftKey' implicitly has an 'any' type.
                scope.newComment.messageBody = DraftsService.get(draftKey, scope.goal.id);
                if (scope.newComment.messageBody) {
                    scope.isCommentChanged = true;
                }
            }
            /**
             * @method init
             * Method called to scroll focus to the selected note from stream.
             */
            function scrollToNote() {
                $timeout(function () {
                    // Scroll to the highlighted note
                    $anchorScroll('noteId_' + scope.noteId);
                }, 100);
            }
            function shouldShowProgressOption() {
                return (!scope.goal.hasAutomaticProgress &&
                    scope.newComment.goalType != 'culture' &&
                    scope.newComment.goalType != 'role' &&
                    scope.newComment.goalType != 'leadership');
            }
            /**
             * @function startEditMode
             * @private
             * Open the comment box.
             */
            function startEditMode() {
                scope.isEditMode = true;
                scope.isReplying = false;
                scope.isShowStatusDropdown = !scope.goal.syncKpiStatus;
                //look for any saved drafts
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'draftKey' implicitly has an 'any' type.
                scope.newComment.messageBody = DraftsService.get(draftKey, scope.goal.id);
                if (scope.newComment.messageBody) {
                    scope.isCommentChanged = true;
                }
            }
        }
    }
})();

(function () {
    angular
        .module('App.Util')
        .directive('competencyBadge', [
        'CompetencyBadgeService',
        '$state',
        'TEMPLATE_PATH',
        competencyBadgeDirective,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'CompetencyBadgeService' implicitly has ... Remove this comment to see the full error message
    function competencyBadgeDirective(CompetencyBadgeService, $state, TEMPLATE_PATH) {
        var DirectiveDefinitionObject = {
            restrict: 'E',
            scope: {
                id: '=',
                size: '@',
            },
            templateUrl: TEMPLATE_PATH + '/util/competency-badge/competency-badge.html',
            link: link,
        };
        return DirectiveDefinitionObject;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope, element, attrs) {
            //config
            scope.loading = false;
            init();
            function init() {
                angular.element(element).addClass('loading');
                setBadge();
                //watch for avatar updates
                CompetencyBadgeService.subscribe(setBadge);
                //update the view when the avatar is loading
                scope.$watch(function () {
                    //get the current badge timestamp
                    return CompetencyBadgeService.getLoading();
                }, 
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'isLoading' implicitly has an 'any' type... Remove this comment to see the full error message
                function (isLoading) {
                    if (isLoading) {
                        scope.loading = true;
                    }
                });
            }
            /**
             * Sets the badge image
             * @method setBadge
             */
            function setBadge() {
                //get the badge image
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'image' implicitly has an 'any' type.
                CompetencyBadgeService.getUrlById(scope.id, scope.size).then(function (image) {
                    scope.badgeUrl = image;
                    scope.loading = false;
                    //style for badge set as a background image
                    scope.style = {
                        'background-image': 'url(' + scope.badgeUrl + ')',
                    };
                    angular.element(element).removeClass('loading');
                });
            }
        }
    }
})();

(function () {
    angular
        .module('App.Util')
        .service('Confirmation', ['$rootScope', '$uibModal', 'TEMPLATE_PATH', ConfirmationService])
        .controller('ConfirmationController', ['$scope', '$uibModalInstance', ConfirmationController]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$rootScope' implicitly has an 'any' typ... Remove this comment to see the full error message
    function ConfirmationService($rootScope, $uibModal, TEMPLATE_PATH) {
        var service = {
            open: open,
        };
        return service;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'title' implicitly has an 'any' type.
        function open(title, message, button) {
            var modalInstance, ms = $rootScope.$new(true);
            ms.button = button || 'Confirm';
            ms.message = message;
            ms.title = title;
            modalInstance = $uibModal.open({
                animation: true,
                controller: 'ConfirmationController',
                controllerAs: 'modalVm',
                scope: ms,
                size: 'md',
                templateUrl: TEMPLATE_PATH + '/util/confirmation/util.confirmation.html',
            });
            return modalInstance.result;
        }
    }
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$scope' implicitly has an 'any' type.
    function ConfirmationController($scope, $uibModalInstance) {
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        /**
         * @property button
         * @type {string}
         * Label text for the action button.
         */
        vm.button = $scope.button;
        vm.fn = {
            cancel: cancel,
            ok: ok,
        };
        /**
         * @property message
         * @type {string}
         * Body text.
         */
        vm.message = $scope.message;
        /**
         * @property title
         * @type {string}
         * Title of the message.
         */
        vm.title = $scope.title;
        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
        function ok() {
            $uibModalInstance.close();
        }
    }
})();

(function () {
    angular
        .module('App.Util')
        .directive('datepicker', ['$filter', 'TEMPLATE_PATH', DatepickerDirective]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$filter' implicitly has an 'any' type.
    function DatepickerDirective($filter, TEMPLATE_PATH) {
        var DirectiveDefinitionObject = {
            link: link,
            // replace: true,
            restrict: 'E',
            scope: {
                listenerKey: '@',
                minDate: '=',
                originalDate: '=date',
                onChange: '&',
                onFocus: '&',
                showOnClick: '@',
                requireValue: '<?',
            },
            templateUrl: TEMPLATE_PATH + '/util/datepicker/util.datepicker.html',
        };
        return DirectiveDefinitionObject;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope) {
            /**
             * @listener datepicker:edit
             * Requires 'listenerKey' attribute
             * Parent $broadcast()'s this event with value for listenerKey to edit the line.
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
            scope.$on('datepicker:edit', function (event, arg) {
                if (arg == scope.listenerKey && !event.defaultPrevented) {
                    event.preventDefault();
                    // do the same as show() but don't $emit or you have a loop
                    scope.isShow = true;
                    scope.isFocus = true;
                }
            });
            /**
             * @listener datepicker:close
             * Requires 'listenerKey' attribute
             * Parent $broadcast()'s this event with value for listenerKey to edit the line.
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
            scope.$on('datepicker:close', function (event, arg) {
                if (arg == scope.listenerKey && !event.defaultPrevented) {
                    event.preventDefault();
                    // edit();
                    hide();
                }
            });
            /**
             * @property isShow
             * @type {boolean}
             */
            scope.isShow = scope.showOnClick != 'true';
            /**
             * @property datepicker
             * @type {object}
             * Models and configuration options for the UIB datepicker
             */
            if (scope.originalDate === null || scope.originalDate === undefined) {
                scope.datepicker = {
                    date: '',
                    isOpen: false,
                    options: {
                        showWeeks: false,
                    },
                };
            }
            else {
                scope.datepicker = {
                    date: new Date(scope.originalDate),
                    isOpen: false,
                    options: {
                        showWeeks: false,
                    },
                };
                if (scope.minDate) {
                    scope.datepicker.options.minDate = scope.minDate;
                }
                if (scope.originalDate) {
                    scope.datepicker.date = new Date(scope.originalDate);
                }
                // Set the date and the user date
                updateDate();
            }
            /**
             * @listener minDate
             * Re-evaluate the date if the minDate changes.
             */
            scope.$watch('minDate', function () {
                if (scope.minDate) {
                    if (scope.minDate > scope.datepicker.date) {
                        scope.originalDate = scope.minDate;
                    }
                    scope.datepicker.options.minDate = scope.minDate;
                }
            });
            /**
             * @listener originalDate
             * Listen for changes to the original date supplied by parent template (date attribute)
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'newValue' implicitly has an 'any' type.
            scope.$watch('originalDate', function (newValue, oldValue) {
                var update = false;
                if (!_.isDate(oldValue) && newValue) {
                    update = true;
                }
                else if (_.isDate(newValue)) {
                    if (newValue.getTime() != oldValue.getTime()) {
                        update = true;
                    }
                }
                else if (newValue != oldValue) {
                    update = true;
                }
                if (update) {
                    updateDate();
                    if (scope.listenerKey) {
                        scope.$emit('datepicker:isEditing', scope.listenerKey);
                    }
                }
            });
            /**
             * @method click
             */
            scope.click = function () {
                scope.onFocus();
            };
            /**
             * @method onChangeDate
             * Called when the user interacts with the datepicker popup calendar.
             * Updates the user-editable text field
             */
            scope.onChangeDate = function () {
                if (angular.isUndefined(scope.datepicker.date)) {
                    // date was cleared by control
                    scope.datepicker.date = '';
                }
                scope.datepicker.userdate = $filter('date')(scope.datepicker.date, 'MM/dd/yyyy');
                scope.onChange({ date: scope.datepicker.date });
                hide();
            };
            /**
             * @method onChangeUserDate
             * Called when the user changes text in the text field.
             * Parses the date and updates the popup calendar if the date is parseable.
             */
            scope.onChangeUserDate = function () {
                var dateNumber = new Date(scope.datepicker.userdate);
                // TODO: Handle invalid dates. Currently, nothing happens.
                // @ts-ignore ts-migrate(2345) FIXME: Argument of type 'Date' is not assignable to param... Remove this comment to see the full error message
                if (!isNaN(dateNumber)) {
                    scope.datepicker.date = dateNumber;
                    scope.onChange({ date: scope.datepicker.date });
                    hide();
                }
                else {
                    scope.datepicker.date = '';
                    scope.onChangeDate({ date: null });
                }
            };
            /**
             * @method openDatepicker
             * Used to open the datepicker popup
             */
            scope.openDatepicker = function () {
                if (!scope.datepicker.isOpen) {
                    scope.datepicker.isOpen = true;
                }
            };
            /**
             * @method show
             * Used to show the datepicker if it is hidden by default.
             * TODO: change to edit() to match inlineEdit
             */
            scope.show = function () {
                scope.isShow = true;
                scope.isFocus = true;
                if (scope.listenerKey) {
                    scope.$emit('datepicker:isEditing', scope.listenerKey);
                }
            };
            /**
             * @function hide
             * @private
             * We can hide if a value is not required, or the user has provided one, and showOnClick.
             */
            function hide() {
                if (!scope.requireValue || scope.datepicker.userdate) {
                    if (scope.showOnClick == 'true') {
                        scope.isShow = false;
                    }
                    scope.isFocus = false;
                }
            }
            /**
             * @function updateDate
             * Pass a true date object to the date picker. Format the date into a string to be displayed to the user.
             * Called when initialized if the date exists, then when the date changes.
             */
            function updateDate() {
                scope.datepicker.date = scope.originalDate && new Date(scope.originalDate);
                scope.datepicker.userdate = $filter('date')(scope.datepicker.date, 'MM/dd/yyyy');
            }
        }
    }
})();

(function () {
    angular
        .module('App.Util')
        .controller('UtilDeleteWithChallengeModalController', [
        '$rootScope',
        '$scope',
        '$state',
        '$uibModalInstance',
        'DeleteModalConfig',
        UtilDeleteWithChallengeModalController,
    ])
        .factory('DeleteWithChallengeModal', [
        '$uibModal',
        'TEMPLATE_PATH',
        DeleteWithChallengeModalFactory,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$uibModal' implicitly has an 'any' type... Remove this comment to see the full error message
    function DeleteWithChallengeModalFactory($uibModal, TEMPLATE_PATH) {
        var defaultOptions = {
            challenge: 'Type "DELETE"',
            answer: 'DELETE',
        };
        var service = {
            open: open,
        };
        return service;
        /**
         * @method open
         * @param options {object}
         * @returns {object} - promise
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'options' implicitly has an 'any' type.
        function open(options) {
            //create the modal with the desired config
            var modalInstance = $uibModal.open({
                animation: true,
                controller: 'UtilDeleteWithChallengeModalController',
                controllerAs: 'modalVm',
                resolve: {
                    DeleteModalConfig: function () {
                        return _.defaults(options, defaultOptions);
                    },
                },
                size: 'md',
                templateUrl: TEMPLATE_PATH + '/util/delete-with-challenge-modal/util.delete-with-challenge-modal.html',
            });
            return modalInstance.result;
        }
    }
    function UtilDeleteWithChallengeModalController(
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$rootScope' implicitly has an 'any' typ... Remove this comment to see the full error message
    $rootScope, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$scope' implicitly has an 'any' type.
    $scope, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$state' implicitly has an 'any' type.
    $state, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$uibModalInstance' implicitly has an 'a... Remove this comment to see the full error message
    $uibModalInstance, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'DeleteModalConfig' implicitly has an 'a... Remove this comment to see the full error message
    DeleteModalConfig) {
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        /**
         * @listener $onInit
         */
        vm.$onInit = init;
        /**
         * @listener $stateChangeStart
         * If the user navigates away, close the modal.
         * Initially implemented for when the user interacts with the avatar flyout menu.
         */
        var stateChangeListener = $rootScope.$on('$stateChangeStart', function () {
            $uibModalInstance.dismiss();
        });
        /**
         * @listener $destroy
         * When the controller is destroyed, unregister the $stateChangeStart listener.
         * $onDestroy doesn't work here.
         */
        $scope.$on('$destroy', stateChangeListener);
        /**
         * @property config
         * @type {Object}
         * instructions, challenge, answer, etc.
         */
        vm.config = DeleteModalConfig;
        vm.fn = {
            cancel: cancel,
            goToLink: goToLink,
            ok: ok,
        };
        /**
         * @property validation
         * @type {object}
         * Used to pass form validation messages to the template.
         */
        vm.validation = {};
        /**
         * @function init
         * @private
         */
        function init() {
            if (vm.config.linkRouteName) {
                // Determine the link for the template. This allows users to open the link
                // in a new tab.
                vm.link = $state.href(vm.config.linkRouteName, vm.config.linkRouteParameters);
            }
        }
        /**
         * @method cancel
         * Close the modal.
         */
        function cancel() {
            $uibModalInstance.dismiss();
        }
        /**
         * @method goToLink
         * Close the modal, go to the link specified in the config.
         */
        function goToLink() {
            cancel();
            $state.go(vm.config.linkRouteName, vm.config.linkRouteParameters);
        }
        /**
         * @method ok
         * Verify the answer matches the challenge answer. Case insensitive.
         * If they match, close the modal which fires the success handler in the controller.
         */
        function ok() {
            if (vm.challengeAnswer &&
                vm.config.answer.toLowerCase() === vm.challengeAnswer.toLowerCase()) {
                delete vm.validation.challengeAnswer;
                $uibModalInstance.close();
            }
            else {
                vm.validation.challengeAnswer =
                    'Please type DELETE into the field to confirm that you want to delete this ' +
                        vm.config.itemType +
                        '.';
            }
        }
    }
})();

(function () {
    /**
     * @property now
     * @type {Date}
     * Get the date once per app load.
     */
    var now = new Date();
    angular
        .module('App.Util')
        .directive('dueDate', ['$filter', 'ETWServicesUtils', DueDateDirective]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$filter' implicitly has an 'any' type.
    function DueDateDirective($filter, ETWServicesUtils) {
        var addDays = ETWServicesUtils.addDays;
        var DirectiveDefinitionObject = {
            link: link,
            scope: {
                date: '=',
                beginDate: '=',
                endDate: '=',
            },
            // Tag is invisible, not display:none, so it still has a footprint.
            template: '{{ formattedDate }} <span ng-class="[pillColorClass]" class="tag tag-due"></span>',
        };
        return DirectiveDefinitionObject;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope) {
            /**
             * @property date
             * @type {Date}
             * Convert string date into date object
             */
            var date = scope.date && new Date(scope.date);
            var beginDate = scope.beginDate && new Date(scope.beginDate);
            var endDate = scope.endDate && new Date(scope.endDate);
            scope.pillColorClass = 'invisible';
            if (scope.beginDate && scope.endDate) {
                if (beginDate <= now && now < date) {
                    // Check after begin date and before due date
                    scope.pillColorClass = 'tag-due-default'; // grey
                }
                else if (date < now && now < addDays(date, 1)) {
                    // Check during the due date
                    scope.pillColorClass = 'tag-due-warning'; // yellow
                }
                else if (addDays(date, 1) < now && now < addDays(endDate, 1)) {
                    // Check after due date, before end date
                    scope.pillColorClass = 'tag-due-danger'; // red
                }
            }
            else if (now > date) {
                // if there are no begin/end dates available, default to the original "show due pill" logic (visible and red if we're after the due date)
                scope.pillColorClass = 'tag-due-danger';
            }
            /**
             * @property formattedDate
             * @type {string}
             */
            scope.formattedDate = $filter('date')(scope.date, 'shortDate');
        }
    }
})();

(function () {
    angular
        .module('App.Util')
        .directive('engagement', ['$filter', 'TEMPLATE_PATH', EngagementDirective]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$filter' implicitly has an 'any' type.
    function EngagementDirective($filter, TEMPLATE_PATH) {
        var DirectiveDefinition = {
            link: link,
            restrict: 'E',
            scope: {
                collapsible: '@',
                engagement: '<',
                managerEngagements: '<',
                person: '<',
                showDirectReports: '<',
            },
            templateUrl: TEMPLATE_PATH + '/util/engagement/util.engagement.html',
        };
        return DirectiveDefinition;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope) {
            /**
             * @property engagementManager
             * @type {Object}
             */
            scope.engagementManager = {};
            /**
             * @property engagementPersonal
             * @type {Object}
             */
            scope.engagementPersonal = {};
            /**
             * @property chartColors
             * @type {array}
             */
            scope.chartColors = ['#852EF6', '#55C5FD', '#cbcbcb'];
            /**
             * @property chartData
             * @type {array}
             */
            scope.chartData = [];
            /**
             * @property chartType
             * @type {string}
             */
            scope.chartType = 'area-spline';
            scope.fn = {
                formatEngagementValue: formatEngagementValue,
                getEngagementColor: getEngagementColor,
            };
            /**
             * @property isCollapsible
             * @type {boolean}
             */
            scope.isCollapsible = scope.collapsible == 'true';
            /**
             * @property isLoaded
             * @type {integer}
             */
            scope.isLoaded = 0;
            init();
            function init() {
                getManagersEngagement();
                getPersonalEngagement();
            }
            /**
             * @method formatEngagementValue
             * @param value {number}
             * @returns {string}
             * Used by the template to say "1 day", "2 days", or "--"
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'value' implicitly has an 'any' type.
            function formatEngagementValue(value) {
                return value ? $filter('pluralize')(value, ['day', 'days']) : '--';
            }
            /**
             * @method getPersonalEngagement
             * @return {promise} so that we can always load the graph in the same order
             */
            function getPersonalEngagement() {
                scope.engagementPersonal = scope.engagement;
                scope.chartData.push({
                    id: 1,
                    name: 'Personal Engagement',
                    points: scope.engagementPersonal.chartData.engagement,
                });
                scope.chartData.push({
                    id: 2,
                    name: 'Engagement with Direct Reports',
                    points: scope.engagementPersonal.chartData.withDirectReports,
                });
                scope.isLoaded = true;
            }
            /**
             * @method getManagersEngagement
             */
            function getManagersEngagement() {
                // Only if the person reports to someone
                // The managerEngagements object is expected to be defined, but might not be
                if (scope.person.reportsToId && scope.managerEngagements) {
                    scope.engagementManager = scope.managerEngagements;
                    scope.chartData.push({
                        id: 3,
                        name: "Manager's Engagement",
                        points: scope.engagementManager.chartData.withDirectReports,
                    });
                }
            }
            /**
             * @method getEngagementColor
             * @param {integer} engagementAverage
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'engagementAverage' implicitly has an 'a... Remove this comment to see the full error message
            function getEngagementColor(engagementAverage) {
                var color = 'text-warning';
                if (engagementAverage < 14) {
                    color = 'text-success';
                }
                if (engagementAverage >= 30) {
                    color = 'text-danger';
                }
                return color;
            }
        }
    }
})();

(function () {
    angular
        .module('App.Util')
        .directive('errorScreen', ['$document', '$rootScope', ErrorScreenDirective]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$document' implicitly has an 'any' type... Remove this comment to see the full error message
    function ErrorScreenDirective($document, $rootScope) {
        var DirectiveDefinitionObject = {
            restrict: 'E',
            template: '<div ng-if="isError" class="center-block text-xs-center"><h1>404</h1></div>',
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
            link: function (scope) {
                /**
                 * @listener errorScreen:404
                 */
                $rootScope.$on('errorScreen:404', function () {
                    var div = $document[0].querySelector('ui-view.admin');
                    angular.element(div).addClass('ng-hide');
                    scope.isError = true;
                    /**
                     * @listener $stateChangeStart
                     * When the state is changed, revert back to normal.
                     * Use unregisterListener callback to destroy this listener. It will be recreated on the next 404.
                     */
                    var unregisterListener = $rootScope.$on('$stateChangeStart', function () {
                        angular.element(div).removeClass('ng-hide');
                        scope.isError = false;
                        unregisterListener();
                    });
                });
            },
        };
        return DirectiveDefinitionObject;
    }
})();

(function () {
    angular.module('App.Util').directive('etwScope', ['AuthenticationService', ETWScopeDirective]);
    /**
     * @directive ETWScopeDirective
     * @constructor
     * Removes the *inner* HTML from nodes that don't pass the scope expression.
     * Note that attributes/directives on root node will still exist, unlike ng-if
     * To show elements when a scope is *not* present, add a ! (bang) before the scope name.
     * Negated conditions can be used to show an error message to the user.
     *
     * NOTE: ``etw-scope`` rather than just ``scope`` because of the prevalence in angular.
     * NOTE: Scopes are stored lowercase, but can be passed upper case to look like existing guard directives.
     *
     * Usage:
     * 	 <ANY etw-scope="ETW_SCOPE">
     * 	   or
     * 	 <ANY etw-scope="! ETW_SCOPE">
     *
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AuthenticationService' implicitly has a... Remove this comment to see the full error message
    function ETWScopeDirective(AuthenticationService) {
        var DirectiveDefinitionObject = {
            link: link,
            restrict: 'A',
            priority: 1000,
        };
        return DirectiveDefinitionObject;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope, element, attributes) {
            var etwScopeExpression = attributes.etwScope.match(/^(!?)\s*([_A-Z]+)/), isNegated = !!etwScopeExpression && etwScopeExpression[1] == '!', etwScope = !!etwScopeExpression && etwScopeExpression[2], hasScope = AuthenticationService.hasScope(etwScope.toLowerCase());
            if (isNegated == hasScope) {
                element.remove();
            }
        }
    }
})();

(function () {
    /**
     * @function isPassFeatureTest
     * @param test {string} - "FEATURE" or "!FEATURE"
     * @param authService - AuthenticationService
     * @param settings - CLIENT_SETTINGS
     * @returns {boolean}
     * @private
     * Common logic between the feature directive and the feature filter.
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'test' implicitly has an 'any' type.
    function isPassFeatureTest(test, settings) {
        var featureExpression = test.match(/^(!?)\s*([_A-Z]+)/), isNegated = !!featureExpression && featureExpression[1] == '!', feature = !!featureExpression && featureExpression[2], isFeature = !!settings[feature];
        return isNegated != isFeature;
    }
    angular
        .module('App.Util')
        .directive('environmentFeature', ['ENVIRONMENT', EnvironmentFeatureDirective])
        .directive('localFeature', ['$window', LocalFeatureDirective])
        .directive('unlessLocalFeature', ['$window', UnlessLocalFeatureDirective])
        .directive('unlessLocalFeatureAndModule', [
        '$window',
        'CLIENT_SETTINGS',
        UnlessLocalFeatureAndModuleDirective,
    ])
        .directive('localFeatureOrModule', [
        '$window',
        'CLIENT_SETTINGS',
        LocalFeatureOrModuleDirective,
    ])
        .directive('feature', ['CLIENT_SETTINGS', FeatureDirective])
        .filter('feature', ['CLIENT_SETTINGS', FeatureFilterFactory]);
    /**
     * @directive environment-feature
     * @constructor
     * Removes elements that aren't marked for the current environment or lower.
     *
     * '<element environment-feature="stage">Hello</element>'
     *
     * Will show "hello" for stage, test, dev, and local. But not Prod.
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ENVIRONMENT' implicitly has an 'any' ty... Remove this comment to see the full error message
    function EnvironmentFeatureDirective(ENVIRONMENT) {
        var environments = ['prod', 'stage', 'test', 'dev', 'local'];
        return {
            priority: 1000,
            link: link,
            restrict: 'A',
        };
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope, element, attributes) {
            var env = environments.indexOf(attributes.environmentFeature.toLowerCase());
            var currentEnv = environments.indexOf(ENVIRONMENT);
            if (currentEnv < env) {
                element.remove();
            }
        }
    }
    /**
     * @directive local-feature
     * @constructor
     * Same as the feature directive but checks in local storage.
     * Use `unless-local-feature` for negation.
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$window' implicitly has an 'any' type.
    function LocalFeatureDirective($window) {
        return {
            priority: 1000,
            link: link,
            restrict: 'A',
        };
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope, element, attributes) {
            var feature = JSON.parse($window.localStorage.getItem('local-feature-' + attributes.localFeature));
            if (!feature) {
                element.remove();
            }
        }
    }
    /**
     * @directive unless-local-feature
     * @constructor
     * Negated version of `local-feature` to keep confusing boolean logic to a minumum.
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$window' implicitly has an 'any' type.
    function UnlessLocalFeatureDirective($window) {
        return {
            priority: 1000,
            link: link,
            restrict: 'A',
        };
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope, element, attributes) {
            var feature = JSON.parse($window.localStorage.getItem('local-feature-' + attributes.unlessLocalFeature));
            if (feature) {
                element.remove();
            }
        }
    }
    /**
     * @directive unless-local-feature-and-module
     * @constructor
     * Negated version of `local-feature-or-module` and feature to keep confusing boolean logic to a minumum.
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$window' implicitly has an 'any' type.
    function UnlessLocalFeatureAndModuleDirective($window, CLIENT_SETTINGS) {
        return {
            priority: 1000,
            link: link,
            restrict: 'A',
        };
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope, element, attributes) {
            var _a = attributes.unlessLocalFeatureAndModule.split(','), moduleName = _a[0], localFeature = _a[1];
            var feature = JSON.parse($window.localStorage.getItem('local-feature-' + localFeature.trim()));
            if (feature || !isPassFeatureTest(moduleName.trim(), CLIENT_SETTINGS)) {
                element.remove();
            }
        }
    }
    /**
     * @directive local-feature-or-module
     * @constructor
     * Negated version of `local-feature` and feature to keep confusing boolean logic to a minumum.
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$window' implicitly has an 'any' type.
    function LocalFeatureOrModuleDirective($window, CLIENT_SETTINGS) {
        return {
            priority: 1000,
            link: link,
            restrict: 'A',
        };
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope, element, attributes) {
            var _a = attributes.localFeatureOrModule.split(','), moduleName = _a[0], localFeature = _a[1];
            var feature = JSON.parse($window.localStorage.getItem('local-feature-' + localFeature.trim()));
            if (!feature && !isPassFeatureTest(moduleName.trim(), CLIENT_SETTINGS)) {
                element.remove();
            }
        }
    }
    /**
     * @directive feature
     * @constructor
     * Removes the *inner* HTML from nodes that don't pass the feature expression.
     * Note that attributes/directives on root node will still exist, unlike ng-if
     * To show elements when a feature is *not* present, add a ! (bang) before the feature name.
     * Negated conditions can be used to show an error message to the user.
     *
     * Usage:
     * 	 <ANY feature="MODULE">
     * 	   or
     * 	 <ANY feature="! MODULE">
     *
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'CLIENT_SETTINGS' implicitly has an 'any... Remove this comment to see the full error message
    function FeatureDirective(CLIENT_SETTINGS) {
        var DirectiveDefinitionObject = {
            priority: 1000,
            link: link,
            restrict: 'A',
        };
        return DirectiveDefinitionObject;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope, element, attributes) {
            if (!isPassFeatureTest(attributes.feature, CLIENT_SETTINGS)) {
                element.remove();
            }
        }
    }
    /**
     * @filter feature
     * @constructor
     * Show a string if a feature is on/off.
     *
     * Usage:
     *   {{ 'Plans are on' | feature:'PLANS' }}
     *   {{ 'Evaluations are off' | feature:'!EVALUATIONS' }}
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'CLIENT_SETTINGS' implicitly has an 'any... Remove this comment to see the full error message
    function FeatureFilterFactory(CLIENT_SETTINGS) {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'string' implicitly has an 'any' type.
        return function featureFilter(string, feature) {
            return isPassFeatureTest(feature, CLIENT_SETTINGS) ? string : '';
        };
    }
})();

(function () {
    angular
        .module('App.Util')
        .directive('fileAttachments', ['$http', '$window', 'TEMPLATE_PATH', FileAttachmentsDirective]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TEMPLATE_PATH' implicitly has an 'any' ... Remove this comment to see the full error message
    function FileAttachmentsDirective($http, $window, TEMPLATE_PATH) {
        var DirectiveDefinitionObject = {
            restrict: 'E',
            scope: {
                isAdminContext: '@',
                list: '=',
                onDestroy: '&',
                onUpload: '&',
                readOnly: '@',
                isTemplateTopic: '@',
            },
            link: link,
            templateUrl: TEMPLATE_PATH + '/util/file-attachments/util.file-attachments.html',
        };
        return DirectiveDefinitionObject;
        //@ts-ignore
        function link(scope) {
            scope.fn = {
                add: add,
                remove: remove,
                downloadAttachment: downloadAttachment
            };
            //@ts-ignore
            function downloadAttachment(link) {
                // @ts-ignore
                var rawResponse = function (value) {
                    return value;
                };
                console.log('from attach dlg');
                console.log(link);
                return $http({
                    method: 'GET',
                    url: link,
                    transformResponse: rawResponse,
                    headers: {
                        "Content-Type": "text/plain"
                    }
                }).then(
                // @ts-ignore
                function (resp) {
                    console.log(resp);
                    //location.assign(resp.data);
                    $window.open(resp.data, "_blank");
                });
            }
            /**
             * @method add
             * @param $file
             * @returns {*}
             * Upload an attachment.
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter '$file' implicitly has an 'any' type.
            function add($file) {
                if (!$file) {
                    return {};
                }
                //upload the file
                return scope.onUpload({ attachment: $file }).then(
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                function (response) {
                    // Sometimes the API returns an array, sometimes not. ¯\_(ツ)_/¯
                    var file = angular.isArray(response.data) ? _.head(response.data) : response.data;
                    if (file) {
                        //save the file in the list
                        if (angular.isArray(scope.list)) {
                            scope.list.push(file);
                        }
                        else {
                            scope.list = [file];
                        }
                    }
                }, 
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                function onUploadError(response) {
                    console.error('ATTACHMENT UPLOAD ERROR', response);
                });
            }
            /**
             * @method remove
             * @param file {object}
             * Remove a file from the requirement.
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'file' implicitly has an 'any' type.
            function remove(file) {
                //remove the file
                var request = scope.onDestroy({
                    attachment: file,
                });
                //when the file has been deleted
                request.then(function () {
                    // remove file from list
                    _.remove(scope.list, { id: file.id });
                });
            }
        }
    }
})();

(function () {
    angular
        .module('App.Util')
        .directive('filteredList', filteredListDirective)
        .directive('filteredListQuery', filteredListQueryDirective)
        .directive('filteredListMenu', ['TEMPLATE_PATH', FilteredListMenuDirective])
        .directive('filteredListButtonGroup', ['TEMPLATE_PATH', filteredListButtonGroupDirective]);
    /**
     * @directive filtered-list
     * Parent directive of filtered list archipelago. All other directives must be a child of a node with this directive.
     * Usage:
     *   <ELEMENT filtered-list="vm.filteredList">
     *     <input filtered-list-query ng-model="…">
     *     <div ng-repeat="item in vm.filteredList.filteredItems">
     *       …
     *     </div>
     *   </ELEMENT>
     */
    function filteredListDirective() {
        return {
            controller: ['$scope', FilteredListController],
            controllerAs: 'filteredListCtrl',
            restrict: 'A',
            scope: {
                filteredList: '<',
                filteredListControls: '@?',
                filteredListOnLoad: '&?',
            },
            link: function (scope) {
                if (scope.filteredListCtrl) {
                    if (angular.isDefined(scope.filteredListControls)) {
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
                        scope.filteredListCtrl.fn.setListControls(scope.filteredListControls.split(','));
                    }
                    if (angular.isDefined(scope.filteredListOnLoad)) {
                        scope.filteredListCtrl.fn.setControlLoadCallback(scope.filteredListOnLoad);
                    }
                    scope.filteredListCtrl.fn.setConfig(scope.filteredList);
                }
            },
        };
    }
    function FilteredListController($scope) {
        /**
         * property controlLoadCallback
         * @type {Function}
         */
        var controlLoadCallback;
        /**
         * @property filters
         * @type {object}
         * Map of filter arrays.
         * Keys are filter 'names'; see the 'name' scope variables.
         * Names are used to separate multiple controls in the same archipelago.
// @ts-ignore ts-migrate(7006) FIXME: Parameter '$scope' implicitly has an 'any' type.
         *   E.g. name allows assignee buttons, category menu, and show menu to not interfere with each other.
         */
        // @ts-ignore ts-migrate(7034) FIXME: Variable 'controlLoadCallback' implicitly has type... Remove this comment to see the full error message
        var filters = {};
        /**
         * @property query
         * @type {string}
         * Text entered into a search box to filter items
         */
        var query = '';
        /**
         * @property pendingFilterControls
         * @type {Array}
         * List of expected filtered-list directives that should load before the callback is called.
         * Used to prevent a list from rendering until all the controls filter the results.
         */
        var pendingFilterControls = [];
        var self = this;
        self.fn = {
            onChangeFilters: onChangeFilters,
            onChangeQuery: onChangeQuery,
            setConfig: setConfig,
            setControlAsLoaded: setControlAsLoaded,
            setControlLoadCallback: setControlLoadCallback,
            setListControls: setListControls,
        };
        /**
         * @method setControlAsLoaded
         * @param controlName {string}
         * Allows child directives to say that they are loaded.
         * Once they are loaded, execute the callback.
// @ts-ignore ts-migrate(7034) FIXME: Variable 'pendingFilterControls' implicitly has ty... Remove this comment to see the full error message
         */
        function setControlAsLoaded(controlName) {
            // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
            pendingFilterControls = _.without(pendingFilterControls, controlName);
            // @ts-ignore
            if (pendingFilterControls.length === 0 && controlLoadCallback) {
                // @ts-ignore
                controlLoadCallback();
            }
        }
        /**
         * @listener filteredList.items
         * When the items change, filter again.
         */
        $scope.$watchCollection('filteredList.items', filter);
        /**
         * @function filter
         * Take items and filter by query, etc, and return as filteredItems
         */
        function filter() {
            var result;
            if ($scope.filteredList && $scope.filteredList.items) {
                result = $scope.filteredList.items;
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'controlName' implicitly has an 'any' ty... Remove this comment to see the full error message
                result = _.filter(result, function (item) {
                    // @ts-ignore ts-migrate(7005) FIXME: Variable 'pendingFilterControls' implicitly has an... Remove this comment to see the full error message
                    var isPass = true, property, c = 0, col, 
                    // @ts-ignore ts-migrate(7005) FIXME: Variable 'controlLoadCallback' implicitly has an '... Remove this comment to see the full error message
                    colLength = $scope.filteredList.columns.length;
                    // Query
                    // @ts-ignore ts-migrate(7005) FIXME: Variable 'controlLoadCallback' implicitly has an '... Remove this comment to see the full error message
                    if (query.length) {
                        isPass = false;
                        // Iterate through all the defined columns to find a match.
                        while (!isPass && c < colLength) {
                            col = $scope.filteredList.columns[c];
                            isPass =
                                String(item[col])
                                    .toLowerCase()
                                    .indexOf(query) !== -1;
                            c += 1;
                        }
                    }
                    if (isPass) {
                        _.forIn(filters, function (sourceFilters) {
                            // Filter Source
                            var f, 
                            // @ts-ignore
                            filterLength = sourceFilters.length, groupPasses = _(sourceFilters)
                                .map(function (f) {
                                return [f.group, false];
                            })
                                .uniq()
                                .fromPairs()
                                .value();
                            // Filters
                            for (f = 0; f < filterLength; f += 1) {
                                // @ts-ignore
                                if (groupPasses[sourceFilters[f].group]) {
                                    continue;
                                }
                                // @ts-ignore
                                if (sourceFilters[f].predicate) {
                                    // @ts-ignore
                                    if (sourceFilters[f].predicate(item, sourceFilters[f])) {
                                        // @ts-ignore
                                        groupPasses[sourceFilters[f].group] = true;
                                    }
                                }
                                else {
                                    // @ts-ignore
                                    property = sourceFilters[f].property || sourceFilters[f].group;
                                    if (angular.isDefined(item[property]) &&
                                        // @ts-ignore
                                        item[property] == sourceFilters[f].value) {
                                        // @ts-ignore
                                        groupPasses[sourceFilters[f].group] = true;
                                    }
                                }
                            }
                            // Passes if there are no filters
                            // or if there are no groupPasses values that are false
                            isPass =
                                isPass && (filterLength === 0 || _.values(groupPasses).indexOf(false) === -1);
                        });
                    }
                    return isPass;
                });
                $scope.filteredList.filteredItems = result;
                // Set isFilteredOut, when no results because of filters
                $scope.filteredList.isFilteredOut =
                    result.length === 0 && $scope.filteredList.items.length > 0;
            }
        }
        /**
         * @method onChangeFilters
         * @param newFilters {array}
         * @param [source] {string=default} - optional name given to the control, used to determine the source of the new filters
         * Called when filter menu is changed.
         */
        // @ts-ignore
        function onChangeFilters(newFilters, source) {
            // @ts-ignore
            filters[source || 'default'] = angular.isArray(newFilters) ? newFilters : [];
            filter();
        }
        /**
         * function onChangeQuery
         * @param newQuery {string}
         * Callback called when text is changed in the search box.
         * newQuery comes from ngModel
         */
        // @ts-ignore
        function onChangeQuery(newQuery) {
            query = String(newQuery).toLowerCase();
            filter();
        }
        /**
         * @method setConfig
         * @param options {object}
         * Options:
         *   filteredItems {array} - created by directives, used by component in ngRepeat
         *   isFilteredOut {boolean} - created by directives, used by component to know if empty result is from filters
         *   items {array} - required, items from component
         */
        function setConfig(options) {
            // Note: This will trigger watch(), which will call filter().
            $scope.filteredList = options;
        }
        /**
         * @method setListControls
         * @param controlNames {Array}
         * Sets list of expected directives.
         */
        function setListControls(controlNames) {
            pendingFilterControls = controlNames;
        }
        /**
         * @method setControlLoadCallback
         * @param cb {Function}
         * Set the callback to be executed when all the directives are loaded.
         */
        function setControlLoadCallback(cb) {
            controlLoadCallback = cb;
        }
    }
    /**
     * @directive filtered-list-query
     * Attribute directive added to a search box that also has ngModel
     * Changes to the value update the filtered items.
     */
    function filteredListQueryDirective() {
        return {
            require: '^^filteredList',
            restrict: 'A',
            scope: {
                filteredListControlName: '@?',
                model: '=ngModel',
            },
            link: function (scope, element, attributes, controller) {
                var isLoaded = false;
                scope.$watch('model', function () {
                    if (angular.isDefined(scope.model)) {
                        controller.fn.onChangeQuery(scope.model);
                    }
                    if (!isLoaded) {
                        isLoaded = true;
                        if (scope.filteredListControlName) {
                            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'newFilters' implicitly has an 'any' typ... Remove this comment to see the full error message
                            controller.fn.setControlAsLoaded(scope.filteredListControlName);
                        }
                    }
                });
            },
        };
    }
    /**
     * @directive filtered-list-menu
     * @constructor
     * Options must be a collection of objects, each with a "property" and "title".
     * The whole option object is passed back, so you can add whatever other properties you need.
     * E.g.:
     * [
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'newQuery' implicitly has an 'any' type.
     *   { property: 'Status', title: 'On Track', isWidget: true }
     * ]
     * Full options:
     * [
     *   {
     *     group: 'Status',
     *     predicate: function () {},
     *     preselected: true,
     *     property: 'Status',
     *     title: 'On Track',
     *     value: 1
     *   }
     * ]
     */
    function FilteredListMenuDirective(TEMPLATE_PATH) {
        var DirectiveDefinitionObject = {
            link: link,
            require: '?^^filteredList',
            restrict: 'E',
            scope: {
                filteredListControlName: '@?',
                filters: '=?',
                options: '=',
                onChange: '&',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'options' implicitly has an 'any' type.
                placeholder: '@',
                name: '@',
            },
            templateUrl: TEMPLATE_PATH + '/util/filtered-list/util.filtered-list-menu.html',
        };
        return DirectiveDefinitionObject;
        function link(scope, element, attributes, controller) {
            // Filter options can be "preselected"
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'controlNames' implicitly has an 'any' t... Remove this comment to see the full error message
            scope.filters = _.filter(scope.options, { preselected: true });
            if (scope.filters.length && controller) {
                // If any options are preselected, inform the controller
                controller.fn.onChangeFilters(scope.filters, scope.name || 'default');
            }
            if (scope.filteredListControlName) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'cb' implicitly has an 'any' type.
                controller.fn.setControlAsLoaded(scope.filteredListControlName);
            }
            /**
             * @method changeFilters
             * Inform parent and controller that the selected options have changed.
             */
            scope.changeFilters = function () {
                scope.onChange({ filters: scope.filters });
                if (controller) {
                    controller.fn.onChangeFilters(scope.filters, scope.name || 'default');
                }
            };
        }
    }
    function filteredListButtonGroupDirective(TEMPLATE_PATH) {
        var DirectiveDefinitionObject = {
            link: link,
            require: '?^^filteredList',
            restrict: 'E',
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
            scope: {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'element' implicitly has an 'any' type.
                filteredListControlName: '@?',
                filters: '=?',
                options: '=',
                onChange: '&',
                name: '@',
            },
            templateUrl: TEMPLATE_PATH + '/util/filtered-list/util.filtered-list-button-group.html',
        };
        return DirectiveDefinitionObject;
        function link(scope, element, attributes, controller) {
            var initialOption;
            if (controller) {
                // Add preselected options to the modal, or just the first one.
                initialOption = _.find(scope.options, { preselected: true });
                scope.filters = {
                    model: initialOption || scope.options[0],
                };
                controller.fn.onChangeFilters([scope.filters.model], scope.name || 'buttonGroup');
                if (scope.filteredListControlName) {
                    controller.fn.setControlAsLoaded(scope.filteredListControlName);
                }
            }
            /**
             * @method changeFilters
             * Inform parent and controller that the radio button option has changed.
             */
            scope.changeButtons = function () {
                var filtersToPass;
                //if the all radio button is selected then we just add all the options
                if (scope.filters.model.title == 'All') {
                    var modifiedList = _.clone(scope.options);
                    modifiedList.pop();
                    filtersToPass = modifiedList;
                }
                else {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TEMPLATE_PATH' implicitly has an 'any' ... Remove this comment to see the full error message
                    filtersToPass = [scope.filters.model];
                }
                scope.onChange({ filters: filtersToPass });
                if (controller) {
                    controller.fn.onChangeFilters(filtersToPass, scope.name || 'buttonGroup');
                }
            };
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.

(function () {
    /**
     * @property etwStates
     * @type {object}
     * @private
     * System wide map of state codes to text labels.
     * Initially for Plans.
     */
    var etwStates = {
        0: 'None',
        1: 'Draft',
        2: 'Active',
        3: 'Suspended',
        4: 'Completed',
    };
    /**
     * @property etwStatuses
     * @type {object}
     * @private
     * System wide map of status codes. Statuses are used throughout the app. Yes, it's "statuses".
     */
    var etwStatuses = {
        0: 'No Status',
        1: 'Falling Behind',
        2: 'At Risk',
        3: 'On Track',
    };
    angular
        .module('App.Util')
        .filter('imgUrl', ['IMAGE_PATH', imgUrlFilterFactory])
        .filter('etwGoalTypeTitle', ['GoalsService', etwGoalTypeTitleFilterFactory])
        .filter('etwState', [etwStateFilterFactory])
        .filter('etwStatus', [etwStatusFilterFactory])
        .filter('pluralize', [pluralizeFilterFactory])
        .filter('inArray', [arrayFilterFactory])
        .filter('kpiChartFormat', ['$filter', kpiChartFormat])
        .filter('kpiPointFormat', ['$filter', kpiPointFormat])
        .filter('trustAsHtml', ['$sce', trustAsHtml])
        .filter('useFilter', ['$interpolate', useFilter])
        .filter('percentage', ['$filter', percentage])
        .filter('ordinal', ['$filter', ordinalFilter])
        .filter('limitFraction', ['$filter', limitFractionFilter])
        .filter('forTheNextDays', ['ETWServicesUtils', forTheNextDaysFilter]);
    /**
     * @filter forTheNextDaysFilter
     * Filters a collection where the date property occurs within the
     * next provided amount of days from today.
     * @optional showing items from the past. False by default
     * Usage:
     *   item in collection | forTheNextDays:7
     *   item in collection | forTehNextDays:14:true
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ETWServicesUtils' implicitly has an 'an... Remove this comment to see the full error message
    function forTheNextDaysFilter(ETWServicesUtils) {
        /**
         * @param {array} items
         * @param {number} daysToGo
         * @param {boolean} showPastDue
         * @returns {array}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'items' implicitly has an 'any' type.
        return function (items, daysToGo, showPastDue) {
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            var limit = Number(daysToGo);
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'date' implicitly has an 'any' type.
            var daysFromToday = function (date) {
                return ETWServicesUtils.daysBetweenDates(today, new Date(date));
            };
            // @ts-ignore ts-migrate(7034) FIXME: Variable 'results' implicitly has type 'any[]' in ... Remove this comment to see the full error message
            var results = [];
            angular.forEach(items, function (item) {
                var daysUntil = daysFromToday(item.date);
                if (showPastDue) {
                    if (daysUntil <= limit)
                        results.push(item);
                }
                else {
                    if (0 <= daysUntil && daysUntil <= limit)
                        results.push(item);
                }
            });
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'results' implicitly has an 'any[]' type.
            return results;
        };
    }
    //limits a number to a number of decimal places
    function limitFractionFilter() {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'input' implicitly has an 'any' type.
        return function (input, decimalCount) {
            return (input && !isNaN(input) && +input.toFixed(decimalCount)) || input;
        };
    }
    //returns a number with an ordinal attached (th, st, nd, rd)
    function ordinalFilter() {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'input' implicitly has an 'any' type.
        return function (input) {
            //config
            var s = ['th', 'st', 'nd', 'rd'], v = input % 100;
            //send back the updated value
            return input + (s[(v - 20) % 10] || s[v] || s[0]);
        };
    }
    /**
     * @filter kpiChartFormat
     * Formats KPI Chart Data Point value according to KPI settings.
     * Note: Currently the currency type is passed as a second argument using a comma.
     * Usage:
     *   myVar | kpiChartFormat:percentage:2
     *   myVar | kpiChartFormat:currency,$:2
     *   myVar | kpiChartFormat:number:5
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$filter' implicitly has an 'any' type.
    function kpiChartFormat($filter) {
        /**
         * @param value {number}
         * @param format {string}
         * @param [precision] {number}
         * @returns {string}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'value' implicitly has an 'any' type.
        return function (value, format, precision) {
            var formatParts = format.split(','), result;
            if (angular.isUndefined(precision)) {
                precision = 2;
            }
            if (value > 99999 || value < -99999) {
                precision = 2;
            }
            switch (formatParts[0]) {
                case 'percentage':
                    result = $filter('numeraljs')(
                    // @ts-ignore ts-migrate(2362) FIXME: The left-hand side of an arithmetic operation must... Remove this comment to see the full error message
                    getRawValue(value) / 100, createFormatString('0', precision) + '%');
                    break;
                case 'currency':
                    if (value > 99999 || value < -99999) {
                        result = $filter('numeraljs')(getRawValue(value), (formatParts[1] || '$') + createFormatString('0', precision));
                    }
                    else {
                        var currency = formatParts[1] || '$';
                        result = $filter('number')(getRawValue(value), precision);
                        result = currency.concat(result);
                    }
                    break;
                default:
                    if (value > 99999 || value < -99999) {
                        result = $filter('numeraljs')(getRawValue(value), createFormatString('0', precision));
                    }
                    else {
                        result = $filter('number')(getRawValue(value), precision);
                    }
            }
            return result;
        };
    }
    /**
     * Remove any commas from the input string.
     * @param input
     * @returns {string}
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'input' implicitly has an 'any' type.
    function getRawValue(input) {
        var value = String(input).replace(/%/g, '');
        value = String(value).replace(/\$/g, '');
        return String(value).replace(/,/g, '');
    }
    /**
     * @filter kpiPointFormat
     * Formats KPI Data Point value according to KPI settings.
     * Note: Currently the currency type is passed as a second argument using a comma.
     * Note: precision is optional and ignored for currency.
     * Usage:
     *   myVar | kpiPointFormat:percentage:2
     *   myVar | kpiPointFormat:currency,$:2
     *   myVar | kpiPointFormat:number:5
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$filter' implicitly has an 'any' type.
    function kpiPointFormat($filter) {
        /**
         * @param value {number}
         * @param format {string}
         * @param [precision] {number}
         * @returns {string}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'value' implicitly has an 'any' type.
        return function (value, format, precision) {
            var formatParts = format.split(','), result;
            if (angular.isUndefined(precision)) {
                precision = 2;
            }
            switch (formatParts[0]) {
                case 'percentage':
                    result = $filter('number')(getRawValue(value), precision) + '%';
                    break;
                case 'currency':
                    var currency = formatParts[1] || '$';
                    result = $filter('number')(getRawValue(value), precision);
                    result = currency.concat(result);
                    break;
                default:
                    result = $filter('number')(getRawValue(value), precision);
            }
            return result;
        };
    }
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'initialFormat' implicitly has an 'any' ... Remove this comment to see the full error message
    function createFormatString(initialFormat, precision) {
        if (!initialFormat || !precision || precision <= 0) {
            return initialFormat + 'a';
        }
        var paddedFormat = initialFormat;
        // Check for decimal point
        if (paddedFormat.indexOf('.') == -1) {
            // Add the decimal point
            paddedFormat += '.';
        }
        // Pad Right zero's to the format string
        for (var i = 0; i < precision; i++) {
            paddedFormat += '0';
        }
        return paddedFormat + 'a';
    }
    //allow dynamic usage of filters
    //http://stackoverflow.com/a/26851568
    // @deprecated
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$interpolate' implicitly has an 'any' t... Remove this comment to see the full error message
    function useFilter($interpolate) {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'text' implicitly has an 'any' type.
        return function (text, filterName) {
            //if a filter wasn't passed
            if (!filterName) {
                return text;
            }
            //run the filter on the text
            var result = $interpolate('{{value | ' + filterName + '}}');
            //send back the updated text
            return result({ value: text });
        };
    }
    //formats a number as a percentage
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$filter' implicitly has an 'any' type.
    function percentage($filter) {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'input' implicitly has an 'any' type.
        return function (input, decimals) {
            return $filter('number')(input, decimals) + '%';
        };
    }
    //prevents a string of HTML from being stripped
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$sce' implicitly has an 'any' type.
    function trustAsHtml($sce) {
        return $sce.trustAsHtml;
    }
    //filters an array against an array
    //@arrayToFilter: the incoming array
    //@arrayOfFilters: array to filter against
    //@arrayTargetKey: the sub key of the incoming array (probably needs a better name)
    function arrayFilterFactory() {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'arrayToFilter' implicitly has an 'any' ... Remove this comment to see the full error message
        return function (arrayToFilter, arrayOfFilters, arrayTargetKey) {
            //config
            // @ts-ignore ts-migrate(7034) FIXME: Variable 'arrayToReturn' implicitly has type 'any[... Remove this comment to see the full error message
            var arrayToReturn = [];
            //if nothing was passed, send back the original data
            if (!arrayOfFilters || !arrayOfFilters.length) {
                return arrayToFilter;
            }
            //loop through each element of the array to filter against
            _.forEach(arrayToFilter, function (element) {
                //select the object to source from
                var items = arrayTargetKey ? element[arrayTargetKey] : element;
                //loop through the items
                _.forEach(items, function (item) {
                    //loop through array of filters
                    _.forEach(arrayOfFilters, function (filter) {
                        //save the item that matches the filter
                        if (item === filter) {
                            arrayToReturn.push(element);
                        }
                    });
                });
            });
            //send back the filtered data
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'arrayToReturn' implicitly has an 'any[]'... Remove this comment to see the full error message
            return _.uniqBy(arrayToReturn, 'id');
        };
    }
    /**
     * @filter etwGoalTypeTitle
     * Returns the human readable type for a goal.
     * Usage:
     *   {{ goal | etwGoalTypeTitle }}
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'GoalsService' implicitly has an 'any' t... Remove this comment to see the full error message
    function etwGoalTypeTitleFilterFactory(GoalsService) {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goal' implicitly has an 'any' type.
        return function etwGoalTypeTitleFilter(goal) {
            return GoalsService.getTypeTitleFromGoal(goal);
        };
    }
    function etwStateFilterFactory() {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'value' implicitly has an 'any' type.
        return function etwStateFilter(value) {
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            return etwStates[Number(value || 0)] || '';
        };
    }
    function etwStatusFilterFactory() {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'value' implicitly has an 'any' type.
        return function etwStatusFilter(value) {
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            return etwStatuses[Number(value || 0)] || '';
        };
    }
    //
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'IMAGE_PATH' implicitly has an 'any' typ... Remove this comment to see the full error message
    function imgUrlFilterFactory(IMAGE_PATH) {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'url' implicitly has an 'any' type.
        return function imgUrlFilter(url) {
            return IMAGE_PATH + '/' + url;
        };
    }
    /**
     * @filter pluralize
     * param value {number}
     * param arguments {array}
     *   singular {string} - singular form, e.g. 'person'
     *   plural {string} - zero and plural form, e.g. 'people'
     *   [isShowValue] {boolean} - default true, whether to show the value at the end of the string.
     * returns {string}
     * Usage:
     * <span ng-bind="numberOfPeople | pluralize:['person', 'people']"></span>
     * <span ng-bind="numberOfPeople | pluralize:['has', 'have', false]"></span>
     *
     * Note: For more complex control, see ngPluralize that ships with AngularJS.
     */
    function pluralizeFilterFactory() {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'value' implicitly has an 'any' type.
        return function pluralizeFilter(value, parameters) {
            var isShowValue = parameters.length < 3 || parameters[2], plural = parameters[1], singular = parameters[0];
            var str = Number(value) === 1 ? singular : plural;
            return (angular.isUndefined(isShowValue) || isShowValue ? value + ' ' : '') + str;
        };
    }
})();

(function () {
    angular.module('App.Util').component('iconsReference', {
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return TEMPLATE_PATH + '/util/icons-reference/icons-reference.html';
            },
        ],
    });
})();

(function () {
    angular
        .module('App.Util')
        .controller('IdleModalController', ['$rootScope', '$uibModalInstance', IdleModalController]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$rootScope' implicitly has an 'any' typ... Remove this comment to see the full error message
    function IdleModalController($rootScope, $uibModalInstance) {
        var unregisterListener = $rootScope.$on('IdleEnd', function () {
            $uibModalInstance.close();
        });
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        this.$onDestroy = function () {
            unregisterListener();
        };
    }
})();

(function () {
    angular
        .module('App.Util')
        .directive('inlineEditInput', ['TEMPLATE_PATH', '$timeout', InlineEditInputDirective])
        .component('inlineEditInputTransition', {
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return TEMPLATE_PATH + '/util/inline-edit/util.inline-edit-input-transition.html';
            },
        ],
        transclude: true,
        bindings: {
            transparentDisabled: '<',
            disabled: '<',
            v1Class: '@?',
            inputModel: '=',
            focusOnEmpty: '=?',
            placeholder: '@?',
            maxLength: '@?',
            listenerKey: '@',
            customTabAdvance: '<',
            formatter: '&?',
            // callbacks
            onChange: '&',
            onEdit: '&',
            // styling
            textAlign: '@',
            large: '<',
            transparentBackground: '<',
        },
        controller: [
            '$window',
            function ($window) {
                var _this = this;
                var feature = JSON.parse($window.localStorage.getItem('local-feature-inline-edit-v2'));
                // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
                this.useNewInlineEdit = feature;
                // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
                this.localOnChange = function (inputModel) {
                    // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
                    if (_this.onChange) {
                        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
                        _this.onChange({ inputModel: inputModel });
                    }
                };
                // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
                this.localOnEdit = function (listenerKey) {
                    // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
                    if (_this.onEdit) {
                        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
                        _this.onEdit({ listenerKey: listenerKey });
                    }
                };
                // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
                this.localFormatter = function (value) {
                    // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
                    if (_this.formatter && value) {
                        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
                        return _this.formatter({ value: value });
                    }
                    return value;
                };
            },
        ],
    });
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TEMPLATE_PATH' implicitly has an 'any' ... Remove this comment to see the full error message
    function InlineEditInputDirective(TEMPLATE_PATH, $timeout) {
        return {
            restrict: 'E',
            link: link,
            scope: {
                focusOnEmpty: '<?',
                inputModel: '=',
                placeholder: '@?',
                maxLength: '@?',
                listenerKey: '@',
                transparentDisabled: '<',
                disabled: '<',
                disableTabIndex: '<',
                formatter: '&?',
                // callbacks
                onChange: '&',
                onEdit: '&',
                // styling
                alignRight: '<',
                large: '<',
                transparentBackground: '<',
            },
            templateUrl: TEMPLATE_PATH + '/util/inline-edit/util.inline-edit-input.html',
        };
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope, element) {
            // @ts-ignore ts-migrate(7034) FIXME: Variable 'origValue' implicitly has type 'any' in ... Remove this comment to see the full error message
            var origValue;
            scope.focused = false;
            scope.maxLengthReached = false;
            scope.focus = focus;
            scope.blur = blur;
            scope.keyup = keyup;
            var input = element.find('input');
            var ngModel = input.controller('ngModel');
            if (scope.formatter) {
                input.on('blur', formatValue);
                input.on('focus', unFormatValue);
                scope.$on('$destroy', function () {
                    input.off('blur', formatValue);
                    input.off('focus', unFormatValue);
                });
                $timeout(formatValue, 0); // wait for render, trigger first format pass
            }
            if (scope.focusOnEmpty && !scope.inputModel) {
                focusInput();
            }
            if (scope.disableTabIndex) {
                element.find('input').attr('tabindex', '-1');
            }
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
            scope.$on('inlineEdit:edit', function (event, listenerKey) {
                if (listenerKey == scope.listenerKey && !event.defaultPrevented) {
                    event.preventDefault();
                    focusInput();
                }
            });
            scope.classes = {
                'text-xs-right': scope.alignRight,
                'form-control-lg': scope.large,
                'bg-transparent': scope.transparentBackground,
            };
            function focus() {
                origValue = scope.inputModel;
                scope.focused = true;
                scope.$emit('inlineEdit:isEditing', scope.listenerKey);
                scope.onEdit({ listenerKey: scope.listenerKey });
            }
            function blur() {
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'origValue' implicitly has an 'any' type.
                if (origValue !== scope.inputModel) {
                    scope.onChange({ inputModel: scope.inputModel });
                }
                scope.focused = false;
                origValue = null;
                scope.maxLengthReached = false;
            }
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
            function keyup(event) {
                if (scope.maxLength)
                    setMaxLengthReached(); // showing tooltip?
                if (event.which === 13)
                    blurInput(); // ENTER
            }
            function setMaxLengthReached() {
                scope.maxLengthReached = scope.inputModel.length >= scope.maxLength;
            }
            function focusInput() {
                element.find('input')[0].focus();
            }
            function blurInput() {
                element.find('input')[0].blur();
            }
            function formatValue() {
                input.val(scope.formatter({ value: ngModel.$modelValue }));
            }
            function unFormatValue() {
                input.val(ngModel.$modelValue);
            }
        }
    }
})();

(function () {
    angular
        .module('App.Util')
        .directive('autogrow', ['$window', '$timeout', AutoGrowTextAreaDirective])
        .directive('inlineEdit', ['TEMPLATE_PATH', InlineEditDirective])
        .directive('inlineEditV2', ['TEMPLATE_PATH', '$timeout', InlineEditDirectiveV2])
        .component('inlineEditTransition', {
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return TEMPLATE_PATH + '/util/inline-edit/util.inline-edit-transition.html';
            },
        ],
        transclude: true,
        bindings: {
            transparentDisabled: '<',
            disabled: '<',
            v1Class: '@?',
            inputModel: '=',
            focusOnEmpty: '=?',
            placeholder: '@?',
            maxLength: '@?',
            listenerKey: '@',
            customTabAdvance: '<',
            formatter: '&?',
            // callbacks
            onChange: '&',
            onEdit: '&',
            // styling
            textAlign: '@',
            large: '<',
            transparentBackground: '<',
        },
        controller: [
            '$window',
            function ($window) {
                var _this = this;
                var feature = JSON.parse($window.localStorage.getItem('local-feature-inline-edit-v2'));
                // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
                this.useNewInlineEdit = feature;
                // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
                this.localOnChange = function (inputModel) {
                    // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
                    if (_this.onChange) {
                        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
                        _this.onChange({ inputModel: inputModel });
                    }
                };
                // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
                this.localOnEdit = function (listenerKey) {
                    // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
                    if (_this.onEdit) {
                        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
                        _this.onEdit({ listenerKey: listenerKey });
                    }
                };
                // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
                this.localFormatter = function (value) {
                    // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
                    if (_this.formatter && value) {
                        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
                        return _this.formatter({ value: value });
                    }
                    return value;
                };
            },
        ],
    });
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TEMPLATE_PATH' implicitly has an 'any' ... Remove this comment to see the full error message
    function InlineEditDirective(TEMPLATE_PATH) {
        var DirectiveDefinitionObject = {
            restrict: 'E',
            link: link,
            scope: {
                focusOnEmpty: '=?',
                formatter: '&?',
                inputModel: '=',
                listenerKey: '@',
                maxLength: '@?',
                onCancel: '&',
                onChange: '&',
                onEdit: '&',
                placeholder: '@?',
                reusable: '@',
                textAlign: '@',
                truncate: '=?',
            },
            templateUrl: TEMPLATE_PATH + '/util/inline-edit/util.inline-edit.html',
            transclude: true,
        };
        return DirectiveDefinitionObject;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope, element) {
            // @ts-ignore ts-migrate(7034) FIXME: Variable 'originalInputModel' implicitly has type ... Remove this comment to see the full error message
            var originalInputModel;
            /**
             * @property state
             * @type {string}
             * [editing | saved | saving | error]
             */
            scope.state = '';
            scope.fn = {
                click: click,
                edit: edit,
                format: format,
                keyUp: keyUp,
                save: save,
            };
            /**
             * @property isMaxLength
             * @type {boolean}
             */
            scope.isMaxLength = false;
            /**
             * For inline editable page titles that have no value, if focus-on-empty="true"
             * then this inline edit will be focused on load
             */
            if (scope.focusOnEmpty && !scope.inputModel) {
                edit();
            }
            /**
             * @listener inlineEdit:edit
             * Requires 'listenerKey' attribute
             * Parent $broadcast()'s this event with value for listenerKey to edit the line.
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
            scope.$on('inlineEdit:edit', function (event, arg) {
                if (arg == scope.listenerKey && !event.defaultPrevented) {
                    event.preventDefault();
                    edit();
                }
            });
            /**
             * @method cancel
             * @private
             * For when the user hits the ESC or when contents haven't changed in save()
             */
            function cancel() {
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'originalInputModel' implicitly has an 'a... Remove this comment to see the full error message
                scope.inputModel = originalInputModel;
                scope.onCancel({
                    listenerKey: scope.listenerKey,
                });
                scope.isMaxLength = false;
                scope.state = '';
                updateElementClass();
            }
            /**
             * @method clearProgressIndicatorsLater
             * @private
             * Set a timeout to reset the classes that inform the user the input is being saved.
             * Do not show this when "reusable" is set.
             */
            function clearProgressIndicatorsLater() {
                // turn off "saving" indicator when resolved
                scope.state = '';
                scope.altText = '';
                updateElementClass();
            }
            /**
             * @method click
             * Enter edit mode by user action.
             */
            function click() {
                scope.$emit('inlineEdit:isEditing', scope.listenerKey);
                edit();
            }
            /**
             * @method edit
             * Enter edit mode
             */
            function edit() {
                originalInputModel = scope.inputModel;
                scope.onEdit({
                    listenerKey: scope.listenerKey,
                });
                scope.altText = 'Editing Field';
                scope.state = 'editing';
                updateElementClass();
                element.find('textarea')[0].focus();
            }
            /**
             * @method format
             * @param value {string}
             * @returns {string}
             * Allows for parent to format the display text. This is usually done through a $filter.
             * Originally implemented for KPI Data Point filters.
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'value' implicitly has an 'any' type.
            function format(value) {
                return scope.formatter ? scope.formatter({ value: value }) : value;
            }
            /**
             * @method keyUp
             * @param event {event}
             * Saves/cancels if user hits tab/esc
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
            function keyUp(event) {
                if (scope.maxLength && scope.inputModel) {
                    scope.isMaxLength = scope.inputModel.length >= scope.maxLength;
                }
                //if user hits enter
                if (event.which === 13) {
                    //trigger the save function
                    element.find('textarea')[0].blur();
                }
                //if user hits escape
                if (event.which === 27) {
                    //exit edit mode and do not save
                    cancel();
                }
            }
            /**
             * @method save
             * @returns {boolean}
             * Attempt to save the updated value
             * History: This used to prevent saving based on FocusEvent.relatedTarget, but FireFox does not support it, so the functionality was removed.
             */
            function save() {
                var promise;
                //remove from edit mode
                scope.state = '';
                scope.altText = 'Saving changes…';
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'originalInputModel' implicitly has an 'a... Remove this comment to see the full error message
                if (scope.inputModel === originalInputModel && scope.state != 'error') {
                    cancel();
                }
                else {
                    // update the inputModel with the new value so it is passed to the onChange function
                    originalInputModel = scope.inputModel;
                    scope.state = 'saving';
                    if (scope.reusable) {
                        // For when the directive doesn't 'stay' with the record, but the value was sent somewhere else.
                        // Usually when creating multiple records quickly.
                        // Do this before calling onChange()
                        scope.state = '';
                        scope.altText = '';
                    }
                    updateElementClass();
                    // Save the value
                    promise = scope.onChange({
                        inputModel: scope.inputModel,
                    });
                    if (!scope.reusable) {
                        // For when this instance 'stays' with the record, usually when updating a value.
                        if (promise && promise.then) {
                            promise
                                .then(function onChangeSuccess() {
                                scope.altText = 'Changes have been saved.';
                            }, 
                            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                            function onChangeError(response) {
                                if (response) {
                                    scope.state = 'error';
                                    updateElementClass();
                                    scope.altText = 'Error saving changes.';
                                }
                            })
                                .finally(function () {
                                try {
                                    clearProgressIndicatorsLater();
                                }
                                catch (e) {
                                    console.error(e);
                                }
                            });
                        }
                        else {
                            // when onChange doesn't return a promise, so turn off "saving" indicator
                            clearProgressIndicatorsLater();
                            scope.altText = 'Changes have been saved.';
                        }
                    }
                }
            }
            /**
             * @function updateElementClass
             * @private
             * When scope.state is 'editing', add a class to the <inline-edit> element.
             * Originally implemented so that a tag that is inline with a title would disappear when the title is edited in Meeting Topics.
             */
            function updateElementClass() {
                element.toggleClass('inline-edit-editing', scope.state == 'editing');
            }
        }
    }
    // Adapted from https://embed.plnkr.co/plunk/gCkYts
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$window' implicitly has an 'any' type.
    function AutoGrowTextAreaDirective($window, $timeout) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: link,
        };
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope, element, attributes) {
            var computedStyles = $window.getComputedStyle(element[0]);
            var minHeight = parseInt(computedStyles.getPropertyValue('min-height'), 10) || 0;
            // prevent newlines in textbox
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'evt' implicitly has an 'any' type.
            element.on('keydown', function (evt) {
                if (evt.which === 13) {
                    evt.preventDefault();
                }
            });
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'evt' implicitly has an 'any' type.
            element.on('input', function (evt) {
                element.css({ height: 0, minheight: 0 });
                // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
                var contentHeight = this.scrollHeight;
                // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
                var borderHeight = this.offsetHeight;
                element.css({
                    minHeight: null,
                    height: contentHeight + 'px',
                });
            });
            scope.$watch(attributes.ngModel, trigger);
            trigger();
            function trigger() {
                $timeout(element.triggerHandler.bind(element, 'input'), 1);
            }
        }
    }
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TEMPLATE_PATH' implicitly has an 'any' ... Remove this comment to see the full error message
    function InlineEditDirectiveV2(TEMPLATE_PATH, $timeout) {
        return {
            restrict: 'E',
            link: link,
            scope: {
                focusOnEmpty: '<?',
                inputModel: '=',
                placeholder: '@?',
                maxLength: '@?',
                listenerKey: '@',
                transparentDisabled: '<',
                disabled: '<',
                disableTabIndex: '<',
                formatter: '&?',
                // callbacks
                onChange: '&',
                onEdit: '&',
                // styling
                alignRight: '<',
                large: '<',
                transparentBackground: '<',
            },
            templateUrl: TEMPLATE_PATH + '/util/inline-edit/util.inline-edit-v2.html',
        };
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope, element) {
            // @ts-ignore ts-migrate(7034) FIXME: Variable 'origValue' implicitly has type 'any' in ... Remove this comment to see the full error message
            var origValue;
            scope.focused = false;
            scope.maxLengthReached = false;
            scope.focus = focus;
            scope.blur = blur;
            scope.keyup = keyup;
            var input = element.find('textarea');
            var ngModel = input.controller('ngModel');
            if (scope.formatter) {
                input.on('blur', formatValue);
                input.on('focus', unFormatValue);
                scope.$on('$destroy', function () {
                    input.off('blur', formatValue);
                    input.off('focus', unFormatValue);
                });
                $timeout(formatValue, 0); // wait for render, trigger first format pass
            }
            if (scope.focusOnEmpty && !scope.inputModel) {
                focusInput();
            }
            if (scope.disableTabIndex) {
                element.find('textarea').attr('tabindex', '-1');
            }
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
            scope.$on('inlineEdit:edit', function (event, listenerKey) {
                if (listenerKey == scope.listenerKey && !event.defaultPrevented) {
                    event.preventDefault();
                    focusInput();
                }
            });
            scope.classes = {
                'text-xs-right': scope.alignRight,
                'form-control-lg': scope.large,
                'bg-transparent': scope.transparentBackground,
            };
            function focus() {
                origValue = scope.inputModel;
                scope.focused = true;
                scope.$emit('inlineEdit:isEditing', scope.listenerKey);
                scope.onEdit({ listenerKey: scope.listenerKey });
            }
            function blur() {
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'origValue' implicitly has an 'any' type.
                if (origValue !== scope.inputModel) {
                    scope.onChange({ inputModel: scope.inputModel });
                }
                scope.focused = false;
                origValue = null;
                scope.maxLengthReached = false;
            }
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
            function keyup(event) {
                if (scope.maxLength)
                    setMaxLengthReached(); // showing tooltip?
                if (event.which === 13)
                    blurInput(); // ENTER
            }
            function setMaxLengthReached() {
                scope.maxLengthReached = scope.inputModel.length >= scope.maxLength;
            }
            function focusInput() {
                element.find('textarea')[0].focus();
            }
            function blurInput() {
                element.find('textarea')[0].blur();
            }
            function formatValue() {
                input.val(scope.formatter({ value: ngModel.$modelValue }));
            }
            function unFormatValue() {
                input.val(ngModel.$modelValue);
            }
        }
    }
})();

(function () {
    angular
        .module('App.Util')
        .directive('itemPicker', ['TEMPLATE_PATH', '$rootScope', ItemPickerDirective]);
    function ItemPickerDirective(TEMPLATE_PATH) {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TEMPLATE_PATH' implicitly has an 'any' ... Remove this comment to see the full error message
        /**
         * @directive item-picker
         * @param autoFocus
         * @param columns {string} - Comma delimited list of columns. Primary key must be first
         * @param items
         * @param label
         * @param onChange
         * @param [openOnClick] - optional. Default false. Sets minimum query length to 0 (otherwise 1) effectively opening the suggestion box immediately.
         * @param querier
         * @param [require-click] - optional. Default true
         * @param [type] - optional. [ people | ]
         */
        var DirectiveDefinitionObject = {
            restrict: 'E',
            link: link,
            scope: {
                autoFocus: '@',
                columns: '@',
                groupColumns: '@?',
                items: '=',
                label: '@',
                onChange: '&',
                openOnClick: '@?',
                querier: '=',
                requireClick: '@?',
                type: '@?',
            },
            templateUrl: TEMPLATE_PATH + '/util/item-picker/util.item-picker.html',
        };
        return DirectiveDefinitionObject;
        function link(scope) {
            /**
             * @property isAutoFocus
             * @type {boolean}
             * True by default, false if autoFocus is explicitly 'false'
             */
            scope.isAutoFocus = scope.autoFocus != 'false';
            /**
             * property searchBox
             * @type {boolean}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
             * Boolean toggles backdrop and search box.
             */
            scope.searchBox = false;
            /**
             * @property itemPickerTemplate
             * @type {string}
             * Template url for searched item list.
             */
            if (scope.type == 'people') {
                scope.itemPickerTemplate =
                    TEMPLATE_PATH + '/util/item-picker/util.item-picker-people-list.html';
            }
            else if (scope.type == 'grouped') {
                scope.itemPickerTemplate =
                    TEMPLATE_PATH + '/util/item-picker/util.item-picker-grouped-list.html';
            }
            else if (scope.type == 'competency') {
                scope.itemPickerTemplate =
                    TEMPLATE_PATH + '/util/item-picker/util.item-picker-competency-list.html';
            }
            else {
                scope.itemPickerTemplate = TEMPLATE_PATH + '/util/item-picker/util.item-picker-list.html';
            }
            /**
             * @property isRequireClick
             * @type {boolean}
             * When true, shows the + icon and the label. Used to add items to a list.
             * Defaults to true.
             */
            scope.isRequireClick =
                angular.isUndefined(scope.requireClick) || scope.requireClick === 'true';
            /**
             * @property typeahead
             * @type {object}
             * Create an object for typeahead to use.
             */
            scope.typeahead = {
                query: null,
            };
            /**
             * @property columnList
             * @type {Array}
             * Get the list of columns from directive attributes.
             */
            scope.columnList = _.map(scope.columns.split(','), _.trim);
            /**
             * @property groupColumns
             * @type {Array}
             * Get the list of columns from directive attributes.
             */
            if (scope.groupColumns) {
                scope.groupColumnsList = _.map(scope.groupColumns.split(','), _.trim);
            }
            /**
             * @property primaryKey
             * @type {string}
             * Derived from the first item in the columns list.
             */
            scope.primaryKey = scope.columnList[0];
            /**
             * @method toggleSearchBox
             */
            scope.toggleSearchBox = function () {
                scope.searchBox = !scope.searchBox;
            };
            /**
             * @method onSelect
             * @param item {object}
             */
            scope.onSelect = function (item) {
                // Delete duplicate primary key (it is just for the popup template)
                delete item._itemPickerPK;
                //pass selected item object to role component
                scope.selected = item;
                scope.searchBox = false;
                scope.onChange({
                    selection: item,
                });
                // Clear typeahead search box
                scope.typeahead.query = null;
            };
            /**
             * @method search
             * @param query {string}
             * @returns {Array}
             * Fetch the search results from the 'querier'.
             */
            scope.search = function search(query) {
                return scope.querier((query && query.trim()) || '').then(function querierSuccess(response) {
                    // Paginated search results contain an array called "records"
                    var results = response.data.records || response.data;
                    if (scope.items && scope.items.length < 100 && scope.columnList.length) {
                        // Get all the results that are not in items
                        results = _.differenceBy(results, scope.items, scope.primaryKey);
                    }
                    if (scope.type == 'grouped') {
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'item' implicitly has an 'any' type.
                        _.forEach(results, function (result) {
                            result.grouped = true;
                        });
                        var groupedResults = _.groupBy(results, scope.groupColumnsList[0]);
                        _.map(groupedResults, function (groupResult) {
                            // @ts-ignore
                            groupResult[0].firstInGroup = true;
                        });
                    }
                    // Duplicate primary key in a way item picker can always expect in the popup template
                    _.forEach(results, function (result) {
                        result._itemPickerPK = result[scope.primaryKey];
                    });
                    return results;
                });
            };
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'query' implicitly has an 'any' type.

(function () {
    angular
        .module('App.Util')
        .directive('linkAttachments', [
        '$uibModal',
        '$window',
        'TEMPLATE_PATH',
        LinkAttachmentsDirective,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$uibModal' implicitly has an 'any' type... Remove this comment to see the full error message
    function LinkAttachmentsDirective($uibModal, $window, TEMPLATE_PATH) {
        var DirectiveDefinitionObject = {
            restrict: 'E',
            scope: {
                isAdminContext: '@',
                list: '=',
                onChange: '&',
                onDestroy: '&',
                onUpload: '&',
                readOnly: '@',
                isTemplateTopic: '@',
            },
            link: link,
            templateUrl: TEMPLATE_PATH + '/util/link-attachments/util.link-attachments.html',
        };
        return DirectiveDefinitionObject;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope) {
            /**
             * @property originUrl
             * @type {string}
             * Base of the app URL. Used to check if a link is local or not.
             * Local links open in the same browser window.
             */
            var originUrl = $window.location.origin;
            scope.fn = {
                add: add,
                edit: edit,
                getTarget: getTarget,
                remove: remove,
            };
            /**
             * @method add
             */
            function add() {
                // @ts-ignore ts-migrate(2554) FIXME: Expected 3 arguments, but got 1.
                modal('Add Link').then(function (data) {
                    scope
                        .onChange({
                        attachment: {
                            link: data.link,
                            name: data.text,
                        },
                    })
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                        .then(function (response) {
                        //add the new link to the page
                        if (angular.isArray(scope.list)) {
                            scope.list.push(response.data);
                        }
                        else {
                            scope.list = [response.data];
                        }
                    });
                }, angular.noop);
            }
            /**
             * @method edit
             * @param link {object}
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'link' implicitly has an 'any' type.
            function edit(link) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'data' implicitly has an 'any' type.
                modal('Edit Link', link.link, link.name).then(function (data) {
                    // Update UI immediately
                    // @ts-ignore ts-migrate(2693) FIXME: 'any' only refers to a type, but is being used as ... Remove this comment to see the full error message
                    _.assign(link, { link: data.link, name: data.text });
                    //update the link
                    scope
                        .onChange({
                        attachment: {
                            id: link.id,
                            link: data.link,
                            name: data.text,
                        },
                    })
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                        .then(function (response) {
                        // Update the UI again, in case something changed.
                        _.assign(link, response.data);
                    });
                }, angular.noop);
            }
            /**
             * @method getTarget
             * @param item {object}
             * @returns {string}
             * Returns _blank or _self depending if the link is on this domain or not
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'item' implicitly has an 'any' type.
            function getTarget(item) {
                return item.link && item.link.indexOf(originUrl) === -1 ? '_blank' : '_self';
            }
            /**
             * @function modal
             * @param modalTitle {string}
             * @param [link] {string}
             * @param [linkText] {string}
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'modalTitle' implicitly has an 'any' typ... Remove this comment to see the full error message
            function modal(modalTitle, link, linkText) {
                var modal;
                modal = $uibModal.open({
                    animation: true,
                    controller: 'AttachLinkModalController',
                    controllerAs: 'modalVm',
                    resolve: {
                        modalTitle: function () {
                            return modalTitle;
                        },
                        link: function () {
                            return link;
                        },
                        linkText: function () {
                            return linkText;
                        },
                    },
                    size: 'md',
                    templateUrl: TEMPLATE_PATH + '/util/attach-link-modal/util.attach-link-modal.html',
                });
                //send back the modal promise
                return modal.result;
            }
            /**
             * @method remove
             * @param link {object}
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'link' implicitly has an 'any' type.
            function remove(link) {
                // Remove from UI immediately
                _.remove(scope.list, { id: link.id });
                //request deleting the link
                scope.onDestroy({
                    attachment: link,
                });
            }
        }
    }
})();

(function () {
    angular.module('App.Util').directive('listAddItem', ['TEMPLATE_PATH', ListAddItemDirective]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TEMPLATE_PATH' implicitly has an 'any' ... Remove this comment to see the full error message
    function ListAddItemDirective(TEMPLATE_PATH) {
        var DirectiveDefinitionObject = {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: TEMPLATE_PATH + '/util/list-add-item/util.list-add-item.html',
        };
        return DirectiveDefinitionObject;
    }
})();

(function () {
    angular
        .module('App.Util')
        .directive('listFilters', [
        'TEMPLATE_PATH',
        'AttributesService',
        'AuthenticationService',
        'PermissionGroupsService',
        'RolesService',
        ListFiltersDirective,
    ]);
    function ListFiltersDirective(TEMPLATE_PATH, AttributesService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TEMPLATE_PATH' implicitly has an 'any' ... Remove this comment to see the full error message
    AuthenticationService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AttributesService' implicitly has an 'a... Remove this comment to see the full error message
    PermissionGroupsService, 
    // @ts-ignore
    RolesService
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'PermissionGroupsService' implicitly has... Remove this comment to see the full error message
    ) {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'RolesService' implicitly has an 'any' t... Remove this comment to see the full error message
        var DirectiveDefinitionObject = {
            restrict: 'E',
            link: link,
            scope: {
                attributes: '=?',
                attributesLoaded: '&?',
                filters: '=',
                onChange: '&',
                searchPlaceholder: '@',
                focus: '@',
                permissionGroups: '=?',
                roles: '=?',
                showAttributes: '@',
                showPermissionGroups: '@',
                showMore: '@?',
                showPlanAccess: '@?',
                showHiddenRoles: '@?',
            },
            templateUrl: TEMPLATE_PATH + '/util/list-filters/util.list-filters.html',
        };
        return DirectiveDefinitionObject;
        function link(scope) {
            /**
             * @property initialPromises
             * @type {Array}
             * Array of promises if the directive needs to fetch attributes, values, permission groups, roles.
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
             * If the menu directive is initialized before the options are loaded, it will fire a change event
             * which would tell the parent the filters changed.
             */
            var initialPromises = [AttributesService.resolve()];
            //Watching change on people stat click
            scope.$watch('filters.clickedAttributeStats', updateAttributeValuesForStatSummaryClick);
            /**
             * @property disabledClearBtn
             * @type {boolean}
             * Be sure to set false if any of the filters are set before the screen is loaded.
             */
            scope.disabledClearBtn =
                _.isEmpty(scope.filters.permissions) &&
                    _.isEmpty(scope.filters.attributeValues) &&
                    _.isEmpty(scope.filters.roles) &&
                    _.isEmpty(scope.filters.query);
            scope.fn = {
                onClearFilters: onClearFilters,
                onAttributeChange: onAttributeChange,
                onSearch: onSearch,
                onSelect: onSelect,
                setSelectedAttribute: setSelectedAttribute,
            };
            /**
             * @property isAttributeValuesLoaded
             * @type {boolean}
             */
            scope.isAttributeValuesLoaded = false;
            /**
             * @property isLoaded
             * @type {boolean}
             */
            scope.isLoaded = false;
            /**
             * @property more
             * @type {object}
             * more drop down object
             */
            scope.more = {
                directReports: {
                    title: 'My Direct Reports',
                    name: 'directReports',
                    moreGroup: 'Other',
                },
            };
            if (scope.showPlanAccess == 'true') {
                scope.more.owners = {
                    title: 'Owners',
                    name: 'owners',
                    moreGroup: 'Plan Access',
                };
                scope.more.participants = {
                    title: 'Participants',
                    name: 'participants',
                    moreGroup: 'Plan Access',
                };
                scope.more.viewOnly = {
                    title: 'View Only',
                    name: 'viewOnly',
                    moreGroup: 'Plan Access',
                };
            }
            /**
             * @property orderedAttributes
             * @type {Array}
             * used specifically for displaying the attributes in the drop downs so they display in order
             */
            scope.orderedAttributes = [];
            /**
             * @property selections
             * @type {object}
             * Map of the state of all the drop down menus.
             * Selections are collections of objects, filters are arrays of IDs.
             * Seed the selections by finding objects with IDs found in the arrays.
             * Attributes and Attribute Values are extra complex.
             */
            scope.selections = {
                attributes: [],
                attributeValues: {},
                more: [],
                permissions: [],
                roles: [],
                allAttributeValues: [],
                selectedAttributeValues: [],
            };
            if (scope.showAttributes == 'true' &&
                angular.isUndefined(scope.attributes)) {
                getAttributes();
            }
            if (scope.showPermissionGroups == 'true' &&
                angular.isUndefined(scope.permissionGroups) &&
                AuthenticationService.hasPermission('VIEW_ADMIN_PERMISSIONS')) {
                initialPromises.push(getPermissionGroups());
            }
            if (angular.isUndefined(scope.roles)) {
                getRoles();
            }
            // Initialize menu directives once all the promises are resolved.
            AttributesService.all(initialPromises).finally(function () {
                try {
                    scope.isLoaded = true;
                }
                catch (e) {
                    console.error(e);
                }
            });
            /**
             * @function getAttributes
             * @returns {object} - promise
             */
            function getAttributes() {
                // ATTRIBUTES
                return AttributesService.getAll(true).then(function (response) {
                    //first store ordered attributes before keying
                    scope.orderedAttributes = response.data;
                    scope.selections.allAttributeValues = [];
                    _.forEach(scope.orderedAttributes, function (attribute) {
                        scope.selections.allAttributeValues = _.concat(scope.selections.allAttributeValues, attribute.attributeValues);
                    });
                    scope.isAttributeValuesLoaded = true;
                    sortAttributeValues();
                    scope.attributes = _.keyBy(scope.orderedAttributes, 'id');
                    scope.selections.selectedAttributeValues = [];
                    if (angular.isArray(scope.filters.attributeValues) &&
                        scope.filters.attributeValues.length) {
                        _.forEach(scope.attributes, function (attribute) {
                            _.forEach(attribute.attributeValues, function (av) {
                                if (scope.filters.attributeValues.indexOf(av.id) !== -1) {
                                    scope.selections.selectedAttributeValues.push(av);
                                }
                            });
                        });
                    }
                    if (scope.attributesLoaded !== undefined) {
                        scope.attributesLoaded({ loadedAttributes: scope.attributes });
                    }
                });
            }
            /**
             * @function getPermissionGroups
             * @returns {object} - promise
             * @private
             */
            function getPermissionGroups() {
                // Custom permission groups are not passed in, so fetch them from the API
                // PERMISSION GROUPS
                return PermissionGroupsService.getAll().then(function (response) {
                    scope.permissionGroups = response.data;
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                    // @ts-ignore
                    scope.selections.permissions = _.filter(scope.permissionGroups, function (role) {
                        return scope.filters.permissions && scope.filters.permissions.indexOf(role.id) !== -1;
                    });
                });
            }
            /**
             * @function getRoles
             * @returns {object} - promise
             * @private
             */
            function getRoles() {
                // Custom roles are not passed in from parent component, so fetch the full list from the API
                // ROLES
                return RolesService.getAll(scope.showHiddenRoles == 'true').then(function (response) {
                    scope.roles = response.data;
                    scope.selections.roles = _.filter(scope.roles, function (role) {
                        return scope.filters.roles && scope.filters.roles.indexOf(role.id) !== -1;
                    });
                });
            }
            /**
             * @method onAttributeChange
             */
            function onAttributeChange() {
                scope.selections.selectedAttributeValues = _.remove(scope.selections.selectedAttributeValues, function (attributeValue) {
                    if (attributeValue !== scope.selectedAttributeValue) {
                        // @ts-ignore
                        if (attributeValue.attributeId !== scope.selectedAttributeValue.attributeId) {
                            return attributeValue;
                        }
                    }
                    else {
                        return attributeValue;
                    }
                });
                onSelect();
            }
            function onClearFilters() {
                // clears each filter
                scope.selections.permissions = [];
                scope.selections.roles = [];
                scope.selections.selectedAttributeValues = [];
                scope.selections.more = [];
                scope.filters.query = '';
                var filters = {
                    permissions: [],
                    query: '',
                    roles: [],
                    isExact: false,
                    attributeValues: [],
                    more: false,
                };
                // call parent
                scope.onChange({
                    filters: filters,
                });
                // disable clear button
                scope.disabledClearBtn = true;
            }
            /**
             * @method onSearch
             * @param query {string}
             * Model passed to the search directive updates one digest cycle behind.
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
             * This call back allows it to update this component immediately (besides debounce)
             */
            function onSearch(query) {
                scope.filters.query = query;
                onSelect();
            }
            /**
             * @method onSelect
             * Called by each menu that changes the filters.
             * Informs the parent that the filters have changed.
             * Note: All filters are non-exact, meaning e.g. a match can have more than the selected roles, etc.
             */
            function onSelect() {
                //enable clear button
                scope.disabledClearBtn = false;
                var filters = {
                    permissions: _.map(scope.selections.permissions, 'id'),
                    query: scope.filters.query,
                    roles: _.map(scope.selections.roles, 'id'),
                    isExact: false,
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                    attributeValues: _.map(scope.selections.selectedAttributeValues, 'id'),
                    more: scope.selections.more,
                };
                // Call parent
                scope.onChange({
                    filters: filters,
                });
            }
            /**
             * @method setSelectedAttribute
             * @param attributeValue {object}
             */
            function setSelectedAttribute(attributeValue) {
                scope.selectedAttributeValue = attributeValue;
            }
            /**
             * @function sortAttributeValues
             * @private
             */
            function sortAttributeValues() {
                scope.orderedAttributes.forEach(function (attribute) {
                    var sortedAttributeValues = [];
                    var attributeValueHash = _.keyBy(attribute.attributeValues, 'id');
                    var curr = {};
                    //need to find the first attribute value in order
                    //The attribute value id that isn't a sortId will be the first attributevalue in the sort order
                    var hashBySortId = _.keyBy(attribute.attributeValues, 'sortId');
                    attribute.attributeValues.forEach(function (attributeValue) {
                        if (!hashBySortId.hasOwnProperty(attributeValue.id)) {
                            curr = attributeValue;
                        }
                    });
                    sortedAttributeValues.push(curr);
                    if (attribute.attributeValues.length > 0) {
                        // @ts-ignore
                        while (curr.sortId !== 0) {
                            // @ts-ignore
                            curr = attributeValueHash[curr.sortId];
                            sortedAttributeValues.push(curr);
                        }
                    }
                    attribute.attributeValues = sortedAttributeValues;
                });
            }
            /**
             * @function updateAttributeValuesForStatSummaryClick
             * @param newValue
             * @param oldValue
             */
            function updateAttributeValuesForStatSummaryClick(newValue, oldValue) {
                if (newValue !== oldValue) {
                    scope.selections.selectedAttributeValues = [];
                    newValue.forEach(function (clickedAttribute) {
                        var attribute = scope.attributes[clickedAttribute.attributeId], attributeValue = attribute &&
                            _.find(attribute.attributeValues, {
                                id: clickedAttribute.attributeValueId,
                            });
                        if (attribute && attributeValue) {
                            scope.selections.selectedAttributeValues.push(attributeValue);
                        }
                    });
                    onSelect();
                }
            }
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'query' implicitly has an 'any' type.

(function () {
    angular.module('App.Util').component('manageImage', {
        bindings: {
            competency: '=',
            onBeforeRemoveImage: '&?',
            onBeforeUploadImage: '&?',
            person: '=',
            readOnly: '=',
            type: '@?',
        },
        controller: ['AvatarsService', 'LogoService', 'CompetencyBadgeService', ManageImageComponent],
        controllerAs: 'manageImageVm',
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return TEMPLATE_PATH + '/util/manage-image/manage-image.html';
            },
        ],
    });
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AvatarsService' implicitly has an 'any'... Remove this comment to see the full error message
    function ManageImageComponent(AvatarsService, LogoService, CompetencyBadgeService) {
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        /**
         * @listener $onInit
         */
        vm.$onInit = init;
        /**
         * @property image
         * @type {object}
         * File object for uploading an image.
         * If from an input, loaded would be input.files[0]
         */
        vm.image = {
            cropDimensions: {},
            croppedOutput: '',
        };
        //public functions
        vm.fn = {
            cropImageToggle: cropImageToggle,
            removeImage: removeImage,
            uploadImage: uploadImage,
        };
        /**
         * @function init
         * @private
         */
        function init() {
            vm.onBeforeUploadImage = vm.onBeforeUploadImage || AvatarsService.resolve;
            vm.onBeforeRemoveImage = vm.onBeforeRemoveImage || AvatarsService.resolve;
            //if the type isn't set, default to 'user'.
            vm.type = vm.type || 'user';
            //if the requested type is for company logo
            if (vm.type === 'company') {
                //set the crop shape to a rectangle instead of a circle (default)
                vm.cropType = 'rectangle';
                //watch for logo updates
                LogoService.subscribe(function () {
                    //exit if the user is currently cropping
                    if (vm.cropEnabled) {
                        return;
                    }
                    //get the current logo
                    loadImage();
                });
                //get the current logo
                loadImage();
            }
            if (vm.type === 'badge') {
                vm.cropType = 'circle';
                //load the current badge or the default
                loadBadge();
            }
        }
        //loads the current logo
        function loadImage() {
            //request the current logo
            LogoService.getImageUrl('lg')
                //when the logo is retrieved
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'image' implicitly has an 'any' type.
                .then(function (image) {
                vm.image.url = image;
            });
        }
        function loadBadge() {
            //request the current badge
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'image' implicitly has an 'any' type.
            CompetencyBadgeService.getUrlById(vm.competency.id || 0, 'lg').then(function (image) {
                vm.image.url = image;
            });
        }
        /**
         * @method upload
         * Take the selected file and pass it to the AvatarService.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'file' implicitly has an 'any' type.
        function uploadImage(file) {
            vm.onBeforeUploadImage().then(function () {
                //config
                var promise;
                //show uploading text to the user
                vm.uploadingPlaceholder = 'Uploading...';
                //take the user to the crop view immediately while the file uploads
                cropImageToggle(file);
                //upload the file
                if (vm.type === 'user') {
                    promise = AvatarsService.save(file, vm.person.id);
                }
                else if (vm.type === 'company') {
                    promise = LogoService.save(file);
                }
                else {
                    promise = CompetencyBadgeService.save(file, vm.competency.id);
                }
                //if there's an error
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                promise.catch(function (response) {
                    console.error('UPLOAD FAIL', response);
                });
                //when the upload is complete || failed
                promise.then(function () {
                    //clear the upload placeholder text
                    vm.uploadingPlaceholder = '';
                });
            });
        }
        /**
         * @method removeImage
         * Deletes the associated image
         */
        function removeImage() {
            vm.onBeforeRemoveImage().then(function () {
                //request file deletion
                if (vm.type === 'user') {
                    AvatarsService.destroy(vm.person.id);
                }
                else if (vm.type === 'company') {
                    LogoService.destroy();
                }
                else {
                    CompetencyBadgeService.destroy(vm.competency.id);
                }
            });
        }
        //toggles the cropping functionality for the image
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'uploadedImage' implicitly has an 'any' ... Remove this comment to see the full error message
        function cropImageToggle(uploadedImage) {
            //if entering crop mode
            if (!vm.cropEnabled) {
                //after upload
                if (Boolean(uploadedImage)) {
                    //use the newly uploaded file
                    vm.image.url = uploadedImage;
                    //set the new state
                    vm.cropEnabled = true;
                }
                else {
                    //config
                    var promise;
                    //without upload
                    //get the original image as a dataUri for the cropper
                    //this is because the ngImgCrop uses crossOrigin 'anonymous'
                    //and therefore won't send the auth cookie to get the image.
                    if (vm.type === 'user') {
                        promise = AvatarsService.getUrlByUserId(vm.person.id, 'orig');
                    }
                    else if (vm.type === 'company') {
                        promise = LogoService.getImageUrl('orig');
                    }
                    else {
                        promise = CompetencyBadgeService.getUrlById(vm.competency.id, 'orig');
                    }
                    //once the image is retrieved
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'imageUrl' implicitly has an 'any' type.
                    promise.then(function (imageUrl) {
                        //request encoded version regardless of input in case caching is disabled
                        AvatarsService.getDataUriForImageUrl(imageUrl)
                            //once the encoded version is retrieved
                            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'dataUri' implicitly has an 'any' type.
                            .then(function (dataUri) {
                            //apply the image
                            vm.image.url = dataUri;
                            //set the new state
                            vm.cropEnabled = true;
                        });
                    });
                }
            }
            else {
                //leaving crop mode
                //if there's no image, exit the onCommit crop actions
                if (!vm.image.croppedOutput) {
                    return;
                }
                //update the users local image with the cropped one
                vm.image.url = vm.image.croppedOutput;
                //ask the server to crop the image
                if (vm.type === 'user') {
                    AvatarsService.crop(vm.person.id, vm.image.cropDimensions);
                }
                else if (vm.type === 'company') {
                    LogoService.crop(vm.image.cropDimensions);
                }
                else {
                    CompetencyBadgeService.crop(vm.competency.id, vm.image.cropDimensions);
                }
                //toggle the image crop view
                vm.cropEnabled = !vm.cropEnabled;
                //set the image to loading mode
                if (vm.type === 'user') {
                    AvatarsService.setLoading(true);
                }
                if (vm.type === 'badge') {
                    CompetencyBadgeService.setLoading(true);
                }
            }
        }
    }
})();

(function () {
    angular
        .module('App.Util')
        .controller('MiosModalController', ['$scope', '$uibModalInstance', MiosModalController])
        .factory('MiosModal', ['$rootScope', '$uibModal', 'TEMPLATE_PATH', MioModalFactory]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$rootScope' implicitly has an 'any' typ... Remove this comment to see the full error message
    function MioModalFactory($rootScope, $uibModal, TEMPLATE_PATH) {
        var service = {
            open: open,
        };
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'options' implicitly has an 'any' type.
        function open(options) {
            var ms = $rootScope.$new(true);
            ms.options = options;
            var promise = $uibModal.open({
                animation: true,
                controller: 'MiosModalController',
                controllerAs: 'modalVm',
                scope: ms,
                size: 'md',
                templateUrl: TEMPLATE_PATH + '/util/mios-modal/util.mios-modal.html',
                windowClass: 'mios-modal',
                resolve: {
                    options: options,
                },
            });
            return promise.result;
        }
        return service;
    }
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
    function MiosModalController(scope, $uibModalInstance) {
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        /**
         * @listener $onInit
         */
        vm.$onInit = init;
        vm.fn = {
            ok: ok,
        };
        /**
         * @function init
         */
        function init() {
            vm.supportedMios = scope.options.supportedMios;
        }
        /**
         * @method ok
         * When the user clicks ok.
         */
        function ok() {
            $uibModalInstance.close();
        }
    }
})();

(function () {
    angular
        .module('App.Util')
        .controller('MoveDirectReportsModal', [
        '$uibModalInstance',
        'PeopleService',
        'fromUser',
        MoveDirectReportsModal,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$uibModalInstance' implicitly has an 'a... Remove this comment to see the full error message
    function MoveDirectReportsModal($uibModalInstance, PeopleService, fromUser) {
        //config
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        vm.checked = 'reassign'; //set default
        //public functions
        vm.fn = {
            close: close,
            save: save,
            searchPeople: searchPeople,
            onSelectPerson: onSelectPerson,
            removeSelectedPerson: removeSelectedPerson,
        };
        /////////////////// FUNCTIONS ///////////////////
        //close the modal
        function close() {
            $uibModalInstance.dismiss();
        }
        //perform the selected actions
        function save() {
            //if reassigning direct reports
            if (vm.checked === 'reassign') {
                //exit if no person selected
                if (!vm.selectedPerson) {
                    return;
                }
            }
            //send back the selectedPerson
            $uibModalInstance.close(vm.selectedPerson);
        }
        /**
         * @method searchPeople
         * @param query {string}
         * @returns {object} - promise, Array
         * Curry to blacklist the current person with the People search.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'query' implicitly has an 'any' type.
        function searchPeople(query) {
            return PeopleService.search(query, [fromUser]);
        }
        //when a user is selected in the dropdown list
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'person' implicitly has an 'any' type.
        function onSelectPerson(person) {
            vm.selectedPerson = person;
        }
        //clears out the selected person for transferring direct reports to
        function removeSelectedPerson() {
            vm.selectedPerson = undefined;
        }
    }
})();

(function () {
    angular.module('App.Util').directive('multiPerson', ['TEMPLATE_PATH', MultiPersonDirective]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TEMPLATE_PATH' implicitly has an 'any' ... Remove this comment to see the full error message
    function MultiPersonDirective(TEMPLATE_PATH) {
        var DirectiveDefinitionObject = {
            restrict: 'E',
            link: link,
            scope: {
                people: '=',
                limit: '=',
                avatarSize: '@',
            },
            templateUrl: TEMPLATE_PATH + '/util/multi-person/util.multi-person.html',
        };
        return DirectiveDefinitionObject;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope) {
            scope.ids = [];
            scope.persons = [];
            scope.hiddenAvatars = 0;
            scope.$watchCollection('people', function () {
                // @ts-ignore ts-migrate(7034) FIXME: Variable 'ids' implicitly has type 'any[]' in some... Remove this comment to see the full error message
                var ids = [];
                if (scope.people) {
                    _.forEach(scope.people, function (person) {
                        if (angular.isObject(person) && angular.isDefined(person.id)) {
                            ids.push(person.id);
                        }
                        else if (angular.isNumber(person)) {
                            ids.push(person);
                        }
                    });
                    // @ts-ignore ts-migrate(7005) FIXME: Variable 'ids' implicitly has an 'any[]' type.
                    scope.ids = _.uniq(ids);
                    scope.hiddenAvatars = Math.max(0, scope.people.length - scope.limit);
                    buildPersonList();
                }
            });
            /**
             * @method  buildPersonList
             * @return {none}
             * Because the scope.ids list is a unique list of people,
             * after the ids list is built this method will run to match
             * the people to the list so that their popover cards can
             * display the person's information
             */
            function buildPersonList() {
                angular.forEach(scope.ids, function (personId) {
                    angular.forEach(scope.people, function (person) {
                        if (person.id == personId) {
                            scope.persons.push(person);
                        }
                    });
                });
            }
        }
    }
})();

(function () {
    angular
        .module('App.Util')
        .controller('MultiProductNavController', [
        '$scope',
        '$state',
        'AuthenticationService',
        'ENVIRONMENT',
        'PRODUCT_URLS',
        MultiProductNavController,
    ])
        .directive('multiProductNav', ['TEMPLATE_PATH', MultiProductNav]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TEMPLATE_PATH' implicitly has an 'any' ... Remove this comment to see the full error message
    function MultiProductNav(TEMPLATE_PATH) {
        return {
            scope: {},
            controller: 'MultiProductNavController',
            controllerAs: '$ctrl',
            templateUrl: TEMPLATE_PATH + '/util/multi-product-nav/util.multi-product-nav.html',
        };
    }
    function MultiProductNavController(
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$scope' implicitly has an 'any' type.
    $scope, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$state' implicitly has an 'any' type.
    $state, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AuthenticationService' implicitly has a... Remove this comment to see the full error message
    AuthenticationService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ENVIRONMENT' implicitly has an 'any' ty... Remove this comment to see the full error message
    ENVIRONMENT, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'PRODUCT_URLS' implicitly has an 'any' t... Remove this comment to see the full error message
    PRODUCT_URLS) {
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        vm.HERMES_URL = PRODUCT_URLS.hermes;
        vm.JANUS_URL = PRODUCT_URLS.janus;
        vm.currentLocation = _.includes($state.current.name, 'admin') ? 'admin' : 'hermes';
        // TODO: TEMPORARY - Replace environment-specific variable in the template with final name.
        vm.TEMPORARY_APP_NAME_FOR_HERMES_PLEASE_CHANGE_SOMEDAY =
            ENVIRONMENT === 'stage' || ENVIRONMENT === 'prod' ? 'ETW' : 'Align';
        vm.access = {
            admin: AuthenticationService.hasPermission('VIEW_ADMIN'),
            janus: AuthenticationService.hasScope('janus'),
        };
        vm.access.any = _.some(_.values(vm.access));
    }
})();

(function () {
    angular.module('App.Util').directive('noBodyScroll', [noBodyScrollDirective]);
    /**
     * This directive prevents scroll events from spilling over to the <body>.
     * Apply this directive to elements with their own scrollbars
     * and when the user scrolls to the top of the element, the rest of the viewport
     * will not move.
     *
     * example: <div class="this has an overflow-y=scroll class" no-body-scroll></div>
     *
     */
    function noBodyScrollDirective() {
        var directiveDefinition = {
            restrict: 'A',
            link: link,
        };
        return directiveDefinition;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope, element) {
            /**
             * @property el
             * @type {object}
             */
            var el = element[0];
            /**
             * @listener touchmove, wheel
             * Disable events from devices that scroll.
             * Previous solution involved setting the 'overflow' property of the view port,
             * but that would either add a scrollbar when there wasn't one, or remove a scroll bar if there was.
             * The effect was the page would jump horizontally on mouseover of the element.
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
            element.on('touchmove, wheel', function (event) {
                if (event.deltaY < 0) {
                    // Going up
                    if (el.scrollTop === 0) {
                        event.preventDefault();
                    }
                }
                else {
                    // Going down
                    if (el.scrollTop >= el.scrollHeight - el.clientHeight) {
                        event.preventDefault();
                    }
                }
            });
        }
    }
})();

(function () {
    angular
        .module('App.Util')
        .directive('permission', ['AuthenticationService', PermissionDirective]);
    /**
     * @directive permission
     * @constructor
     * Removes the *inner* HTML from nodes that don't pass the permission expression.
     * Note that attributes/directives on root node will still exist, unlike ng-if
     * To show elements when a permission is *not* present, add a ! (bang) before the permission name.
     * Negated conditions can be used to show an error message to the user.
     *
     * Usage:
     * 	 <ANY permission="PERMISSION">
     * 	   or
     * 	 <ANY permission="! PERMISSION">
     *
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AuthenticationService' implicitly has a... Remove this comment to see the full error message
    function PermissionDirective(AuthenticationService) {
        var DirectiveDefinitionObject = {
            link: link,
            restrict: 'A',
        };
        return DirectiveDefinitionObject;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope, element, attributes) {
            var permissionExpression = attributes.permission.match(/^(!?)\s*([_A-Z]+)/), isNegated = !!permissionExpression && permissionExpression[1] == '!', permission = !!permissionExpression && permissionExpression[2];
            if (isNegated == AuthenticationService.hasPermission(permission)) {
                if (attributes.permissionDeniedClass) {
                    angular.element(element).addClass('disabled');
                }
                else {
                    element.remove();
                }
            }
        }
    }
})();

(function () {
    angular
        .module('App.Util')
        .controller('PermissionsListModalController', [
        '$scope',
        '$uibModalInstance',
        'AuthenticationService',
        PermissionsListModalController,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$scope' implicitly has an 'any' type.
    function PermissionsListModalController($scope, $uibModalInstance, AuthenticationService) {
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        /**
         * @listener $onInit
         */
        vm.$onInit = init;
        vm.fn = {
            close: close,
            getPermissionsInView: getPermissionsInView,
            onChangeTab: onChangeTab,
            collapsePermissions: collapsePermissions,
        };
        /**
         * @property hasViewPermissions
         * @type {boolean}
         */
        vm.hasViewPermissions = _.includes(AuthenticationService.getAccount().authorities, 'VIEW_ADMIN_PERMISSIONS');
        /**
         * @property hasViewRoles
         * @type {boolean}
         */
        vm.hasViewRoles = _.includes(AuthenticationService.getAccount().authorities, 'VIEW_ADMIN_ROLES');
        /**
         * @property subnav
         * @type {object}
         */
        vm.subnav = {
            application: {
                title: 'Application',
            },
            reports: {
                title: 'Reports',
            },
            admin: {
                title: 'Admin',
            },
        };
        /**
         * @property selectedView
         * @type {string}
         * Which tab is currently visible
         */
        vm.selectedView = 'application';
        /**
         * @method close
         * Closes modal
         */
        function close() {
            $uibModalInstance.dismiss();
        }
        /**
         * @method collapsePermissions
         * @param id {number}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
        function collapsePermissions(id) {
            _.forEach(vm.permissions, function (permission) {
                if (permission.id == id) {
                    permission.isCollapsed = !permission.isCollapsed;
                }
            });
        }
        /**
         * @method getPermissionsInView
         * @returns {Array}
         * Returns an array of permissions available to the selected view
         */
        function getPermissionsInView() {
            vm.permissions = _.filter(vm.permissions, 'visible');
            return _.filter(vm.permissions, function (p) {
                return p.applicationView.toLowerCase() === vm.selectedView;
            });
        }
        /**
         * @function getPermissions
         * @returns {object} - promise, array
         * @private
         */
        function getPermissions() {
            vm.permissions = [];
            _.forEach(vm.roles, function (role) {
                _.forEach(role.permissionGroups, function (permissionGroup) {
                    _.forEach(permissionGroup.permissionGroupPermissions, function (permissionGroupPermission) {
                        permissionGroupPermission.permission.roleTitle = role.title;
                        permissionGroupPermission.permission.roleId = role.id;
                        permissionGroupPermission.permission.permissionGroupTitle = permissionGroup.groupName;
                        permissionGroupPermission.permission.permissionGroupId = permissionGroup.id;
                        permissionGroupPermission.permission.isCollapsed = true;
                        vm.permissions.push(permissionGroupPermission.permission);
                    });
                });
            });
        }
        /**
         * @function init
         * @private
         */
        function init() {
            vm.permissionsLoaded = false;
            vm.roles = $scope.roleList;
            getPermissions();
        }
        /**
         * @method onChangeTab
         * @param tab {string}
         * Callback for the tabbed navigation directive.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'tab' implicitly has an 'any' type.
        function onChangeTab(tab) {
            vm.selectedView = tab;
        }
    }
})();

(function () {
    /**
     * @property personNameNow
     * @type {Date}
     * Date that the app was loaded, set to midnight.
     * Used by personName directive and personName filter.
     */
    var personNameNow = new Date();
    personNameNow.setUTCHours(0, 0, 1);
    /**
     * @property personNameNowString
     * @type {string}
     * ISO 8601 String of now to be compared with strings from the API.
     */
    var personNameNowString = personNameNow.toISOString();
    angular
        .module('App.Util')
        .directive('personName', ['PeopleService', PersonNameDirective])
        .directive('personTitle', ['PeopleService', PersonTitleDirective])
        .filter('personName', [PersonNameFilterFactory]);
    /**
     * @directive person-name
     * @constructor
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'PeopleService' implicitly has an 'any' ... Remove this comment to see the full error message
    function PersonNameDirective(PeopleService) {
        var DirectiveDefinitionObject = {
            link: link,
            restrict: 'E',
            scope: {
                personId: '<?',
                person: '<?',
            },
            template: '<span class="text-overflow-ellipsis">{{ (person.alias || person.firstName) + " " + person.lastName }} </span>' +
                '<span ng-if="checkIsTerminated() || checkIsInactive()" class="tag tag-terminated m-l-0_5">Inactive</span>',
        };
        return DirectiveDefinitionObject;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope) {
            scope.checkIsInactive = function () {
                return checkIsInactive(scope.person);
            };
            scope.checkIsTerminated = function () {
                return checkIsTerminated(scope.person);
            };
            if (!scope.person) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                PeopleService.getBasicById(scope.personId).then(function (response) {
                    scope.person = response.data;
                });
            }
        }
    }
    /**
     * @directive person-title
     * @constructor
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'PeopleService' implicitly has an 'any' ... Remove this comment to see the full error message
    function PersonTitleDirective(PeopleService) {
        var DirectiveDefinitionObject = {
            link: link,
            restrict: 'E',
            scope: {
                personId: '<?',
                person: '<?',
            },
            template: '<div class="text-overflow-ellipsis">{{ person.title || "No Title"}}</div>',
        };
        return DirectiveDefinitionObject;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope) {
            if (!scope.person) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                PeopleService.getBasicById(scope.personId).then(function (response) {
                    scope.person = response.data;
                });
            }
        }
    }
    /**
     * @filter personName
     * @constructor
     */
    function PersonNameFilterFactory() {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'person' implicitly has an 'any' type.
        return function personNameFilter(person) {
            var name = (person.alias || person.firstName) + ' ' + person.lastName, isInactive = checkIsInactive(person);
            return name + (isInactive ? ' (Inactive)' : '');
        };
    }
    /**
     * @function checkIsInactive
     * @param person {object}
     * @returns {boolean}
     * @private
     * Function called by personName filter and person-name directive.
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'person' implicitly has an 'any' type.
    function checkIsInactive(person) {
        var isInactive;
        if (person) {
            // Check userEnabled
            if (person.hasOwnProperty('userEnabled')) {
                isInactive = Number(person.userEnabled) !== 1;
            }
        }
        return isInactive;
    }
    /**
     * @function checkIsTerminated
     * @param person {object}
     * @returns {boolean}
     * @private
     * Function called by personName filter and person-name directive.
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'person' implicitly has an 'any' type.
    function checkIsTerminated(person) {
        var isTerminated = false;
        var now = new Date();
        if (person) {
            // If active, then check termination date
            if (angular.isString(person.terminationDate)) {
                // date might be a string
                isTerminated = person.terminationDate && person.terminationDate < personNameNowString;
            }
            else if (angular.isDate(person.terminationDate)) {
                // date might be a date object
                isTerminated = person.terminationDate && person.terminationDate < now;
            }
        }
        return isTerminated;
    }
})();

(function () {
    /**
     * Small Pie Charts
     * This directive is for the small pie charts used
     * to display Performance, Culture, Leadership and also
     * on evaluations.
     *
     * Calculations:
     * Currently, we assume the min (or max) score is 1.
     * Higher is better: score/scale = percentage
     * Lower is better: (scale + 1 + score)/scale = percentage
     *
     * ex. <pie value="7.2" scale="10" diameter="16" status-class="pie-success"></pie>
     */
    angular.module('App.Util').directive('pie', ['TEMPLATE_PATH', PieDirective]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TEMPLATE_PATH' implicitly has an 'any' ... Remove this comment to see the full error message
    function PieDirective(TEMPLATE_PATH) {
        var DirectiveDefinitionObject = {
            restrict: 'E',
            link: link,
            scope: {
                cutPointMax: '=',
                cutPointMin: '=',
                diameter: '=?',
                direction: '=',
                percentage: '=?',
                scale: '=?',
                value: '=?',
            },
            templateUrl: TEMPLATE_PATH + '/util/pie/util.pie.html',
        };
        return DirectiveDefinitionObject;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope) {
            /**
             * @property direction
             * @type {number}
             * 0 = higher is better
             * 1 = lower is better
             */
            var direction = angular.isDefined(scope.direction) ? Number(scope.direction) : 0;
            /**
             * @property isFixedPercentage
             * @type {boolean}
             * True if the parent already provided the percentage.
             * Used when the parent is displaying an aggregation of multiple scores of different scales.
             * See Team Dashboard.
             */
            var isFixedPercentage = angular.isDefined(scope.percentage);
            /**
             * @property value
             * @type {integer}
             */
            scope.value = angular.isUndefined(scope.value) ? undefined : scope.value;
            /**
             * @property scale
             * @type {integer}
             */
            scope.scale = angular.isUndefined(scope.scale) ? 10 : scope.scale;
            /**
             * @property diameter
             * @type {integer}
             */
            scope.diameter = angular.isUndefined(scope.diameter) ? 16 : scope.diameter;
            /**
             * @property radius
             * @type {integer}
             */
            scope.radius = scope.diameter / 2;
            /**
             * @property class
             * @type {Object}
             */
            scope.class = {
                pieClass: 'pie',
                textClass: 'text-muted',
            };
            /**
             * @property pathDescription
             * @type {String}
             * defines the SVG path to create the pie chart
             */
            scope.pathDescription = getSVGPieDescription();
            /**
             * Watch the value for the pie and update the
             * chart, style and number when updated
             */
            scope.$watch('value', function () {
                var adjustedValue = direction ? scope.scale + 1 - scope.value : scope.value;
                if (!isFixedPercentage) {
                    // Explicit percentage provided by the parent component. Don't update
                    scope.percentage = scope.value === 0 ? 0 : (adjustedValue / scope.scale) * 100;
                }
                scope.pathDescription = getSVGPieDescription();
                setStatusClasses();
            });
            /**
             * @method setStatusClasses
             * determines what color the pie and text
             * should be
             */
            function setStatusClasses() {
                var status = 'warning';
                if (scope.value > 0) {
                    if (scope.value < scope.cutPointMin) {
                        status = scope.direction ? 'success' : 'danger';
                    }
                    else if (scope.value >= scope.cutPointMax) {
                        status = scope.direction ? 'danger' : 'success';
                    }
                    scope.class = {
                        pieClass: 'pie pie-' + status,
                        textClass: 'text-' + status,
                    };
                }
                else {
                    scope.class = {
                        pieClass: 'pie',
                        textClass: 'text-muted',
                    };
                }
            }
            /**
             * @method getSVGPieDescription
             * @return {string} the pie definition
             * SVG is expecting a string with all of the data to
             * draw the pie chart, this method defines the data
             */
            function getSVGPieDescription() {
                if (!scope.value) {
                    return '';
                }
                var x = Math.cos((2 * Math.PI) / (100 / scope.percentage));
                var y = Math.sin((2 * Math.PI) / (100 / scope.percentage));
                var longArc = scope.percentage <= 50 ? 0 : 1;
                return ('M' +
                    scope.radius +
                    ',' +
                    scope.radius +
                    ' L' +
                    scope.radius +
                    ',' +
                    0 +
                    ' A' +
                    scope.radius +
                    ',' +
                    scope.radius +
                    ' 0 ' +
                    longArc +
                    ',1 ' +
                    (scope.radius + y * scope.radius) +
                    ',' +
                    (scope.radius - x * scope.radius) +
                    ' z');
            }
        }
    }
})();

(function () {
    angular
        .module('App.Util')
        .directive('richTextEdit', ['$window', richTextEditDirective])
        .directive('toneAnalysis', [
        '$window',
        'AuthenticationService',
        'AnalysisModal',
        toneAnalysisDirective,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$window' implicitly has an 'any' type.
    function richTextEditDirective($window) {
        var DirectiveDefinitionObject = {
            require: ['ngModel', 'richTextEdit'],
            restrict: 'A',
            controller: RTFController,
            scope: {
                onCancel: '&',
                onChange: '&',
                onEdit: '&',
                rtfFocus: '=?',
            },
            link: link,
        };
        return DirectiveDefinitionObject;
        function RTFController() {
            // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
            var ctrl = this;
            /**
             * @param toolbar
             * @ {array[string]}
             */
            ctrl.toolbar = $window.ClassicEditor.etwToolbars.defaultToolbar;
            /**
             * @param createCallbacks
             * @type {array[function]}
             * Callbacks are given `editor` instance.
             */
            ctrl.createCallbacks = [];
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope, element, attributes, controllers) {
            var ngModel = controllers[0];
            var selfController = controllers[1];
            // init the editor
            $window.ClassicEditor.create(element[0], {
                toolbar: selfController.toolbar,
                toneAnalysis: {
                    minContent: 100,
                },
            }).then(editorCreated, editorError);
            /**
             * @function editorCreated
             * @private
             * @param {Object} editor
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'editor' implicitly has an 'any' type.
            function editorCreated(editor) {
                // interaction changes happen to viewDoc
                // data changes happen to modelDoc
                var viewDoc = editor.editing.view.document, modelDoc = editor.model.document;
                if (angular.isUndefined(scope.rtfFocus) || scope.rtfFocus) {
                    editor.editing.view.focus();
                }
                scope.$on('$destroy', editor.destroy.bind(editor));
                viewDoc.on('blur', updateNgModel(editor));
                viewDoc.on('blur', scope.onCancel);
                viewDoc.on('focus', scope.onEdit);
                modelDoc.on('change', scope.onChange);
                ngModel.$render = updateEditorModel(editor);
                // unless specified only on blur, always update ngModel
                if (attributes.richTextEdit != 'blur') {
                    modelDoc.on('change', updateNgModel(editor));
                }
                _.forEach(selfController.createCallbacks, function (callback) {
                    callback(editor);
                });
            }
            /**
             * @function editorError
             * @private
             * @param {Error} error
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'error' implicitly has an 'any' type.
            function editorError(error) {
                console.warn(error);
            }
            /**
             * @function updateNgModel
             * @private
             * @param {Object} editor
             * @returns {Function}
             *
             * If the editor is empty it will still contain a <p>&nbsp;</p>.
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'editor' implicitly has an 'any' type.
            function updateNgModel(editor) {
                return function () {
                    var value = editor.isEmpty ? '' : editor.getData();
                    ngModel.$setViewValue(value);
                };
            }
            /**
             * @function updateEditorModel
             * @private
             * @param {Object} editor
             * @returns {Function}
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'editor' implicitly has an 'any' type.
            function updateEditorModel(editor) {
                return function () {
                    var value = ngModel.$viewValue || '';
                    editor.setData(value);
                };
            }
        }
    }
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$window' implicitly has an 'any' type.
    function toneAnalysisDirective($window, AuthenticationService, AnalysisModal) {
        var DirectiveDefinitionObject = {
            require: ['ngModel', 'richTextEdit'],
            restrict: 'A',
            link: {
                pre: link,
            },
        };
        return DirectiveDefinitionObject;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope, element, attributes, controllers) {
            var ngModel = controllers[0];
            var richTextEdit = controllers[1];
            /**
             * @param hasToneAnalysis
             * @type {boolean}
             */
            var hasToneAnalysis = AuthenticationService.hasModule('TONE_ANALYSIS');
            if (hasToneAnalysis) {
                richTextEdit.toolbar = $window.ClassicEditor.etwToolbars.toneAnalysisToolbar;
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'editor' implicitly has an 'any' type.
                richTextEdit.createCallbacks.push(function (editor) {
                    editor.on('tone-analysis', analyzeTone);
                });
            }
            /**
             * @function analyzeTone
             * @private
             */
            function analyzeTone() {
                AnalysisModal.open({
                    messageBody: ngModel.$viewValue,
                });
            }
        }
    }
})();

(function () {
    /*
    |--------------------------------------------------------------------------
    | Saving Notification Component
    |--------------------------------------------------------------------------
    |
    | This is the universal "saving..." component that informs the
    | user that the application is saving. It provides feedback for when
    | the saving process has started and when it is successful. All errors
    | are handled by the 'notify' component.
    |
    | This component is listening for
    | three events: 'save', 'saveSuccess', 'saveError'
    |
    | This component is added once programatically to the body.
    |
    */
    angular
        .module('App.Util')
        .directive('savingNotification', ['$rootScope', 'TEMPLATE_PATH', savingNotificationDirective]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$rootScope' implicitly has an 'any' typ... Remove this comment to see the full error message
    function savingNotificationDirective($rootScope, TEMPLATE_PATH) {
        var directiveDefinition = {
            restrict: 'E',
            scope: {},
            templateUrl: TEMPLATE_PATH + '/util/saving-notification/saving-notification.html',
            link: link,
        };
        return directiveDefinition;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope, element, attrs) {
            /**
             * @property isActive
             * @type {Boolean}
             */
            scope.isActive = false;
            /**
             * @property isSucccess
             * @type {Boolean}
             */
            scope.isSuccess = false;
            /**
             * @property message
             * @type {String}
             */
            scope.message = '';
            $rootScope.$on('save', function () {
                scope.isActive = true;
                scope.isSuccess = false;
                scope.message = 'saving...';
            });
            $rootScope.$on('saveSuccess', function () {
                scope.isActive = false;
                scope.isSuccess = true;
                scope.message = 'saved.';
            });
            $rootScope.$on('saveError', function () {
                scope.isActive = false;
                scope.message = '';
            });
        }
    }
    // Add the directive to the DOM
    angular
        .element(document.body)
        .append(angular.element('<saving-notification></saving-notification>'));
})();

(function () {
    angular.module('App.Util').directive('search', ['TEMPLATE_PATH', searchDirective]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TEMPLATE_PATH' implicitly has an 'any' ... Remove this comment to see the full error message
    function searchDirective(TEMPLATE_PATH) {
        var directiveDefinition = {
            restrict: 'E',
            scope: {
                inputModel: '=',
                inputId: '@?',
                inputChange: '&',
                placeholder: '@?',
                focusOnEmpty: '=?',
            },
            templateUrl: TEMPLATE_PATH + '/util/search/search.html',
            link: link,
        };
        return directiveDefinition;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope, element, attrs) {
            scope.modelOptions = false;
            scope.fn = {
                clearSearch: clearSearch,
            };
            function clearSearch() {
                scope.inputModel = '';
                scope.inputChange({ query: scope.inputModel });
            }
        }
    }
})();

(function () {
    angular
        .module('App.Util')
        .directive('selectAttribute', [
        'AttributesService',
        'AttributeValuesService',
        'TEMPLATE_PATH',
        SelectAttributeDirective,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AttributesService' implicitly has an 'a... Remove this comment to see the full error message
    function SelectAttributeDirective(AttributesService, AttributeValuesService, TEMPLATE_PATH) {
        var DirectiveDefinitionObject = {
            restrict: 'E',
            replace: true,
            link: link,
            scope: {
                attributeSets: '=',
                multiple: '@?',
                overrideSetId: '@',
                resourceId: '@',
                serviceType: '@',
                showHelpText: '=?',
            },
            templateUrl: TEMPLATE_PATH + '/util/select-attribute/util.select-attribute.html',
        };
        return DirectiveDefinitionObject;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope) {
            scope.fn = {
                attributeHasValues: attributeHasValues,
                newAttributeSet: newAttributeSet,
                onAttributeChange: onAttributeChange,
                onRemoveSet: onRemoveSet,
                onSelectAttributeValue: onSelectAttributeValue,
                removeAttributeSet: removeAttributeSet,
            };
            /**
             * @property isAttributesLoaded
             * @type {boolean}
             */
            scope.isAttributesLoaded = false; //if all service requests are complete
            /**
             * @property selectedAttributes
             * @type {object}
             * Map of attribute sets with selected attributes.
             */
            scope.selectedAttributes = {};
            /**
             * @property selectedValuesForAttributeSets
             * @type {object}
             * Map of values in a set.
             */
            scope.selectedValuesForAttributeSets = {};
            /**
             * @property allowMultiple
             * @type {boolean}
             * True if <select-attribute multiple/>
             * Allows adding a new set if true.
             */
            scope.allowMultiple = angular.isDefined(scope.multiple);
            // Attribute Sets must be an array
            if (!angular.isArray(scope.attributeSets)) {
                //put it in an array
                scope.attributeSets = (scope.attributeSets && [scope.attributeSets]) || [{}];
            }
            //get a list of attributes to work with
            getAttributes();
            //if only one attribute set is allowed AND there currently isn't one
            if (!scope.allowMultiple && !scope.attributeSets) {
                //add one as default
                newAttributeSet();
            }
            /**
             * @method attributeHasValues
             * @param attr {object}
             * @returns {boolean}
             * Used as a filter on list of attributes.
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'attr' implicitly has an 'any' type.
            function attributeHasValues(attr) {
                return !!attr.attributeValueCount;
            }
            /**
             * @function destroySet
             * @param setId {number}
             * @returns {object} - promise
             * @private
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'setId' implicitly has an 'any' type.
            function destroySet(setId) {
                return AttributeValuesService.removeSet(scope.resourceId, setId);
            }
            /**
             * @method getAttributes
             * @returns {object} - promise
             * Get all the attributes to list in the first combo box.
             */
            function getAttributes() {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                return AttributesService.getAll(true).then(function (response) {
                    // Only keep the ones with values
                    scope.attributes = _.filter(response.data, function (attribute) {
                        return attribute.attributeValues.length;
                    });
                    //get previously selected attributes
                    getSelectedAttributes();
                    scope.isAttributesLoaded = true;
                });
            }
            /**
             * @method getSelectedAttributes
             * @returns {object} - promise
             * Gets all the AttributeValues from the AttributeSet
             * Gets details for each AttributeValue
             * Gets all the sibling AttributeValues.
             */
            function getSelectedAttributes() {
                _.forEach(scope.attributeSets, function (set) {
                    scope.selectedAttributes[set.id] = _.map(set.attributeValues, function (value) {
                        return _.find(scope.attributes, { id: value.attributeId });
                    });
                    scope.selectedValuesForAttributeSets[set.id] = _.keyBy(set.attributeValues, 'attributeId');
                });
            }
            /**
             * @function newAttributeSet
             * @private
             * Start a new attribute set.
             */
            function newAttributeSet() {
                //if this was called from a permission group
                if (scope.serviceType === 'PermissionGroupPermission') {
                    scope.attributeSets = [{}];
                }
                //if this was called from Admin > Person
                if (scope.serviceType === 'Person') {
                    //create a new set on this resource
                    AttributeValuesService.newSet(scope.resourceId).then(function createEmptySetSuccess(
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                    response) {
                        scope.attributeSets.push(response.data);
                    });
                }
            }
            /**
             * @method onAttributeChange
             * @param setId {integer}
             */
            //TODO make sure attribute values are always output in the same order
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'setId' implicitly has an 'any' type.
            function onAttributeChange(setId, attrId) {
                var isInSet = !!_.find(scope.selectedAttributes[setId], { id: attrId });
                if (isInSet) {
                    //if removing an attribute (thus it's value)
                    //if there is a value selected
                    if (scope.selectedValuesForAttributeSets[setId][attrId]) {
                        //for permissions
                        if (scope.serviceType === 'PermissionGroupPermission') {
                            AttributeValuesService.unassignFrom(scope.serviceType, scope.resourceId, scope.overrideSetId, scope.selectedValuesForAttributeSets[setId][attrId].id);
                        }
                        else {
                            //for everything else
                            AttributeValuesService.unassignFrom(scope.serviceType, scope.resourceId, scope.selectedValuesForAttributeSets[setId][attrId].id, setId);
                        }
                    }
                }
            }
            /**
             * @method onRemoveSet
             * @param setId {number}
             * @returns {object} - promise
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'setId' implicitly has an 'any' type.
            function onRemoveSet(setId) {
                // Remove from UI
                _.remove(scope.attributeSets, {
                    id: setId,
                });
                // Remove from API
                return destroySet(setId);
            }
            /**
             * @method onSelectAttributeValue
             * @param setId {number} - AttributeSet ID
             * @param attributeValueId {number}
             * @returns {object} - promise
             * Callback for the select-attribute directive.
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'setId' implicitly has an 'any' type.
            function onSelectAttributeValue(setId, attributeValueId) {
                var promise;
                if (scope.serviceType === 'PermissionGroupPermission') {
                    //for permissions
                    promise = AttributeValuesService.assignTo(scope.serviceType, scope.resourceId, scope.overrideSetId, attributeValueId);
                }
                else {
                    //for everything else
                    promise = AttributeValuesService.assignTo(scope.serviceType, scope.resourceId, attributeValueId, setId);
                }
                return promise || AttributeValuesService.reject();
            }
            /**
             * @method removeAttributeSet
             * @param setId {number}
             * @returns {object} - promise
             * Removes an attribute set from API if there are no selected attributes.
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'setId' implicitly has an 'any' type.
            function removeAttributeSet(setId) {
                var promise;
                //if only one set is allowed AND this is the last set
                if (scope.allowMultiple || scope.attributeSets.length > 1) {
                    //if there are no selected attributes for this set
                    if (!scope.selectedAttributes[setId] || !scope.selectedAttributes[setId].length) {
                        //remove the set from the service
                        // TODO: Removing the set from attributeSets removes the menu from the user which might not be expected.
                        // TODO: Should just remove from api, but sets would then need to be created when a value is selected
                        // TODO: promise = destroySet(setId);
                        promise = onRemoveSet(setId);
                    }
                }
                return promise || AttributeValuesService.reject();
            }
        }
    }
})();

(function () {
    angular.module('App.Util').directive('sortMenu', ['TEMPLATE_PATH', SortMenuDirective]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TEMPLATE_PATH' implicitly has an 'any' ... Remove this comment to see the full error message
    function SortMenuDirective(TEMPLATE_PATH) {
        var DirectiveDefinitionObject = {
            restrict: 'E',
            link: link,
            scope: {
                config: '=',
                onChange: '&',
            },
            templateUrl: TEMPLATE_PATH + '/util/sort-menu/util.sort-menu.html',
        };
        return DirectiveDefinitionObject;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope) {
            scope.fn = {
                select: select,
            };
            // Set the current column as the default
            scope.config.column =
                scope.config.defaultColumn || (scope.config.options && scope.config.options[0].column);
            /**
             * @property isShowDefault
             * @type {boolean}
             * Determine if default is different from other columns
             */
            scope.isShowDefault =
                scope.config.defaultColumn &&
                    !_.find(scope.config.options, { column: scope.config.defaultColumn });
            /**
             * @property sortStates
             * @type {object}
             * Keeps track of sort directions
             */
            scope.sortStates = {};
            // Set the default sort
            scope.sortStates[scope.config.column] = false;
            /**
             * @method select
             * @param column {string}
             * Takes an object key to sort a list by.
             * "default" sortBy doesn't not take ascending/descending. It is designed for drag-and-drop
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'column' implicitly has an 'any' type.
            function select(column) {
                if (!column) {
                    // reset the default sort if nothing received
                    scope.config.column = scope.config.defaultColumn;
                    // Default does NOT use ascending/descending
                    scope.config.isDescending = false;
                }
                else {
                    //set the sort order for this key
                    scope.sortStates[column] =
                        angular.isDefined(scope.sortStates[column]) && !scope.sortStates[column];
                    //set the requested sort
                    scope.config.column = column;
                    scope.config.isDescending = scope.sortStates[column];
                }
                scope.onChange();
            }
        }
    }
})();

(function () {
    angular.module('App.Util').directive('spinner', ['TEMPLATE_PATH', SpinnerDirective]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TEMPLATE_PATH' implicitly has an 'any' ... Remove this comment to see the full error message
    function SpinnerDirective(TEMPLATE_PATH) {
        var DirectiveDefinitionObject = {
            restrict: 'E',
            template: '<div class="overlay"></div><div class="loader"></div>',
        };
        return DirectiveDefinitionObject;
    }
})();

(function () {
    angular
        .module('App.Util')
        .directive('statusDropdown', ['TEMPLATE_PATH', StatusDropdownDirective]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TEMPLATE_PATH' implicitly has an 'any' ... Remove this comment to see the full error message
    function StatusDropdownDirective(TEMPLATE_PATH) {
        var DirectiveDefinitionObject = {
            link: link,
            restrict: 'E',
            scope: {
                above: '<?',
                below: '<?',
                status: '=',
                onChange: '&?',
                menuRight: '@?',
            },
            templateUrl: TEMPLATE_PATH + '/util/status-dropdown/util.status-dropdown.html',
        };
        return DirectiveDefinitionObject;
    }
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
    function link(scope) {
        if (!angular.isDefined(scope.above)) {
            // set default to 0
            scope.above = 0;
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'statusNumber' implicitly has an 'any' t... Remove this comment to see the full error message
        scope.isAvailable = function (statusNumber) {
            var isAvailable = true;
            if (angular.isDefined(scope.above) && scope.above != -1) {
                isAvailable = statusNumber > scope.above;
            }
            if (angular.isDefined(scope.below) && scope.below != -1) {
                isAvailable = statusNumber < scope.below;
            }
            return isAvailable;
        };
    }
})();

(function () {
    angular.module('App.Util').directive('statusMeter', ['TEMPLATE_PATH', StatusMeterDirective]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TEMPLATE_PATH' implicitly has an 'any' ... Remove this comment to see the full error message
    function StatusMeterDirective(TEMPLATE_PATH) {
        var DirectiveDefinitionObject = {
            restrict: 'E',
            link: link,
            scope: {
                onTrack: '=',
                atRisk: '=',
                failing: '=',
                noStatus: '=',
                planStatus: '=',
                hasGoals: '=',
            },
            templateUrl: TEMPLATE_PATH + '/util/status-meter/util.status-meter.html',
        };
        return DirectiveDefinitionObject;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope) {
            if (angular.isDefined(scope.planStatus) && !scope.hasGoals) {
                scope.onTrack = null;
                scope.atRisk = null;
                scope.failing = null;
                scope.noStatus = null;
                if (scope.planStatus === 3) {
                    scope.onTrack = 1;
                }
                else if (scope.planStatus === 2) {
                    scope.atRisk = 1;
                }
                else if (scope.planStatus === 1) {
                    scope.failing = 1;
                }
                else {
                    scope.noStatus = 1;
                }
            }
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'newValues' implicitly has an 'any' type... Remove this comment to see the full error message
            scope.$watchGroup(['onTrack', 'atRisk', 'failing', 'noStatus'], function (newValues) {
                if (angular.isDefined(newValues)) {
                    scope.max = _.sum(newValues);
                }
            });
        }
    }
})();

(function () {
    /**
     * @directive subNav
     *
     * Usage:
     *   <sub-nav nav-list="expression" selected-view="string" on-change="function expression"></sub-nav>
     *
     *  navList is an object where the keys are tab names and the values are a config object for the tab.
     *  navList = {
     *    navName : {
     *      cssClass: "space delimited list of class names",
     *      title: "Label text"
     *    }
     *  }
     *
     *  subNav allows transclusion, initially to show evaluation dates on the same line:
     *  <sub-nav …>
     *    Hello World
     *  </sub-nav>
     *
     */
    angular.module('App.Util').directive('subNav', ['TEMPLATE_PATH', SubNavDirective]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TEMPLATE_PATH' implicitly has an 'any' ... Remove this comment to see the full error message
    function SubNavDirective(TEMPLATE_PATH) {
        var DirectiveDefinitionObject = {
            restrict: 'E',
            link: link,
            scope: {
                navList: '=',
                onChange: '&',
                selectedView: '@',
            },
            templateUrl: TEMPLATE_PATH + '/util/sub-nav/util.sub-nav.html',
            transclude: true,
        };
        return DirectiveDefinitionObject;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'selected' implicitly has an 'any' type.
            scope.onSelectView = function (selected) {
                scope.selectedView = selected;
                scope.onChange({ tab: selected });
            };
        }
    }
})();

(function () {
    angular.module('App.Util').directive('toggleModel', ['TEMPLATE_PATH', ToggleModelDirective]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TEMPLATE_PATH' implicitly has an 'any' ... Remove this comment to see the full error message
    function ToggleModelDirective(TEMPLATE_PATH) {
        var DirectiveDefinitionObject = {
            restrict: 'E',
            link: link,
            scope: {
                falseValue: '@?',
                model: '=',
                onBeforeChange: '&?',
                onChange: '&',
                trueValue: '@?',
                isDisabled: '=',
            },
            templateUrl: TEMPLATE_PATH + '/util/toggle/util.toggle-model.html',
        };
        return DirectiveDefinitionObject;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
        function link(scope) {
            /**
             * @property uniqueId
             * Create an ID for the input+label pair.
             */
            scope.uniqueId = _.uniqueId('toggle-model-');
            /**
             * @method onClick
             * @param event {Event}
             * Intercept the click in case there is an onBeforeChange.
             * Originally used for warning the user before they turn KPI Aggregation off since there is a cost.
             * Note: You MUST rely on the returned 'value' parameter because the model binding is updated *after* this turn.
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
            scope.onClick = function (event) {
                // @ts-ignore ts-migrate(7034) FIXME: Variable 'checkbox' implicitly has type 'any' in s... Remove this comment to see the full error message
                var checkbox;
                if (scope.isDisabled || scope.onBeforeChange) {
                    event.preventDefault();
                    event.stopPropagation();
                    if (!scope.isDisabled && scope.onBeforeChange) {
                        checkbox = event.target.control;
                        scope.onBeforeChange().then(function onBeforeChangeSuccess() {
                            // @ts-ignore ts-migrate(7005) FIXME: Variable 'checkbox' implicitly has an 'any' type.
                            checkbox.checked = !checkbox.checked;
                            // @ts-ignore ts-migrate(7005) FIXME: Variable 'checkbox' implicitly has an 'any' type.
                            if (checkbox.checked) {
                                scope.model = angular.isDefined(scope.trueValue) ? scope.trueValue : true;
                            }
                            else {
                                scope.model = angular.isDefined(scope.falseValue) ? scope.falseValue : true;
                            }
                            scope.onChange({
                                // @ts-ignore ts-migrate(7005) FIXME: Variable 'checkbox' implicitly has an 'any' type.
                                isChecked: checkbox.checked,
                                value: scope.model,
                            });
                        }, angular.noop);
                    }
                }
            };
            /**
             * @method onToggle
             * @param event {Event}
             * When the user changes the input's status.
             */
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
            scope.onToggle = function (event) {
                scope.onChange({ isChecked: event.target.checked, value: scope.model });
            };
        }
    }
})();

(function () {
    /*
    |--------------------------------------------------------------------------
    | Analysis Tone progress bar..
    |--------------------------------------------------------------------------
    |
    | On the tone analysis report each tone has a bar that represents the
    | probability of the message being interpreted as having the tone. This
    | directive is for a tone probability bar.
    |
    */
    angular.module('App.Util').directive('tone', ['AnalysisService', 'TEMPLATE_PATH', ToneDirective]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AnalysisService' implicitly has an 'any... Remove this comment to see the full error message
    function ToneDirective(AnalysisService, TEMPLATE_PATH) {
        /**
         * @property DirectiveDefinitionObject
         * @type {Object}
         */
        var DirectiveDefinitionObject = {
            restrict: 'E',
            scope: {
                tone: '=',
            },
            templateUrl: TEMPLATE_PATH + '/util/tone/util.tone.html',
        };
        return DirectiveDefinitionObject;
    }
})();

// use strict set in app.js
(function () {
    angular
        .module('ETWServices', ['App', 'MockETWServices'])
        .constant('API_SERVICES_URLS', {
        ACTION_ITEMS: '/actionitem/v1%CLIENT%',
        ACCOUNT_SETTINGS: '/accountsettings/v1%CLIENT%/settings',
        ALERTS: '/communication/v1%CLIENT%/alerts',
        ANALYZE_GOAL_NOTE: '/communication/v1%CLIENT%/goals/analyze/tone',
        ATTRIBUTES: '/attribute/v1%CLIENT%/attributes',
        ATTRIBUTE_VALUES: '/attribute/v1%CLIENT%/attributevalues',
        ATTRIBUTE_SETS: '/attribute/v1%CLIENT%/attributesets',
        AVATARS: '/avatar/v1%CLIENT%/avatars',
        AUTHORIZE: '/useraccount',
        CATEGORIES: '/goal/v1%CLIENT%/categories',
        CLIENT: '/goal/v1%CLIENT%/client',
        CLIENTS: '/useraccount/v1%CLIENT%',
        COMPETENCIES: '/competency/v1%CLIENT%/competencies',
        COMPETENCY_BADGE: '/avatar/v1%CLIENT%/badge/competency',
        DRIVER_FILES: '/file/v1%CLIENT%/plans',
        ENGAGEMENT: '/engagement/v1%CLIENT%/engagement',
        EVALUATION_COMPLETED_SCORES: '/score/v1%CLIENT%/completed/evaluations',
        EVALUATION_SCORES: '/score/v1%CLIENT%/evaluations',
        EVALUATIONS: '/evaluation/v1%CLIENT%/evaluations',
        FILE: '/file/v1/file',
        FILES: '/file/v1/files',
        GOAL_KPIS: '/goal/v1%CLIENT%/kpis',
        GOALS: '/goal/v1%CLIENT%/goals',
        GOALS_MOBILE: '/goal/v1%CLIENT%/mobile',
        GOAL_GROUPS: '/goal/v1%CLIENT%/groups',
        GOAL_FILES: '/file/v1%CLIENT%/goals',
        KPI: '/kpi/v1%CLIENT%',
        KPI_PLANS: '/kpi/v1%CLIENT%/plans',
        KPI_USERS: '/kpi/v1%CLIENT%/users',
        LEADERSHIP_LEVELS: '/level/v1%CLIENT%/leadership',
        LOGOS: '/avatar/v1%CLIENT%/logos',
        MEETING_INSTANCES: '/meeting/v1%CLIENT%/instances',
        MEETING_PLANS: '/meeting/v1%CLIENT%/plans',
        MEETING_SERIES: '/meeting/v1%CLIENT%/series',
        MEETING_USERS: '/meeting/v1%CLIENT%/users',
        MEETING_TEMPLATES: '/meetingtemplate/v1%CLIENT%/meetingtemplates',
        MEETING_TEMPLATE_TOPIC_FILES: '/file/v1%CLIENT%/templatetopics',
        MEETING_TEMPLATE_TOPICS: '/meetingtemplate/v1%CLIENT%/topics',
        MESSAGES: '/communication/v1%CLIENT%/messages',
        MESSAGES_USERS: '/communication/v1%CLIENT%/users',
        OUTCOMES: '/outcomes/v1%CLIENT%/outcome',
        OUTCOME_TYPES: '/outcomes/v1%CLIENT%/outcometypes',
        PAST_EVALUATIONS: '/evaluation/v1%CLIENT%/pastevaluations',
        PERMISSIONS: '/permission/v1%CLIENT%/permissions',
        PERMISSION_GROUPS: '/permission/v1%CLIENT%/groups',
        PINNED_PLANS: '/plan/v1%CLIENT%/pinnedPlans',
        PLAN_GOALS: '/goal/v1%CLIENT%/plans',
        PLANS: '/plan/v1%CLIENT%/plans',
        PLANS_FILES: '/file/v1%CLIENT%/plans',
        PLANS_LIST: '/plan/v1%CLIENT%/planList',
        PLANS_SUPPORTING: '/plan/v1%CLIENT%/nonToplevelplans',
        PLANS_TOP: '/plan/v1%CLIENT%/toplevelplans',
        REALTIME_MESSAGING_CHANNELS: '/messaging/v1%CLIENT%/channels',
        REALTIME_MESSAGING_GROUPS: '/messaging/v1%CLIENT%/groups',
        REALTIME_MESSAGING_USERS: '/messaging/v1%CLIENT%/users',
        REPORTS_EVALUATIONS: '/reporting/v1%CLIENT%/evaluations',
        REPORTS_PEOPLE: '/reporting/v1%CLIENT%/people',
        RESET_PASSWORD: '/useraccount/reset',
        RESPONSIBILITIES: '/role/v1%CLIENT%/responsibilities',
        RESOURCES: '/resource/v1/resources',
        ROLES: '/role/v1%CLIENT%/roles',
        SCORED_GOALS_MESSAGES: '/communication/v1%CLIENT%/goalscores',
        SET_PASSWORD: '/useraccount/setPassword',
        STRATEGIES: '/businessstrategy/v1%CLIENT%/plans',
        STRATEGY_ELEMENTS: '/businessstrategy/v1%CLIENT%/strategies',
        STRATEGY_PLANS: '/businessstrategy/v1%CLIENT%/plans',
        TEAMS: '/team/v1%CLIENT%/teams',
        TOPICS: '/meeting/v1%CLIENT%/topics',
        TOPIC_FILES: '/file/v1%CLIENT%/topics',
        USER_GOALS: '/goal/v1%CLIENT%/users',
        USER_PLANS: '/plan/v1%CLIENT%/users',
        USERS: '/useraccount/v1%CLIENT%/users',
        USERSLIST: '/useraccount/v1%CLIENT%/userList',
        USERS_TEAM: '/team/v1%CLIENT%/users',
        USERS_LEVEL: '/level/v1%CLIENT%/users',
    })
        .constant('PUBNUB_KEYS', {
        dev: {
            publish: 'pub-c-6c33c02c-4f42-4df9-bd35-f81d82cdec2a',
            subscribe: 'sub-c-8f77a54e-81e1-11e6-974e-0619f8945a4f',
        },
        local: {
            publish: 'pub-c-6c33c02c-4f42-4df9-bd35-f81d82cdec2a',
            subscribe: 'sub-c-8f77a54e-81e1-11e6-974e-0619f8945a4f',
        },
        test: {
            publish: 'pub-c-fef60540-da5e-4b5b-a290-fcdbb6df5c76',
            subscribe: 'sub-c-ab76f632-81e1-11e6-a68c-0619f8945a4f',
        },
        stage: {
            publish: 'pub-c-426964dd-07c9-4336-bdb9-478461b4e83b',
            subscribe: 'sub-c-cab3631e-81e1-11e6-974e-0619f8945a4f',
        },
        prod: {
            publish: 'pub-c-128f19f5-8c49-4f32-b894-c91a7967a169',
            subscribe: 'sub-c-4b41d00e-81f8-11e6-bb6b-0619f8945a4f',
        },
    })
        .constant('GOOGLE_ANALYTICS', {
        dev: {
            property: 'UA-76992300-5',
        },
        test: {
            property: 'UA-76992300-4',
        },
        stage: {
            property: 'UA-76992300-2',
        },
        prod: {
            property: 'UA-76992300-3',
        },
    })
        .constant('WALK_ME', {
        dev: {
            source: 'https://cdn.walkme.com/users/6cbf8bc6b4074175a66db42243c4325a/test/walkme_6cbf8bc6b4074175a66db42243c4325a_https.js',
        },
        test: {
            source: 'https://cdn.walkme.com/users/6cbf8bc6b4074175a66db42243c4325a/test/walkme_6cbf8bc6b4074175a66db42243c4325a_https.js',
        },
        stage: {
            source: 'https://cdn.walkme.com/users/6cbf8bc6b4074175a66db42243c4325a/test/walkme_6cbf8bc6b4074175a66db42243c4325a_https.js',
        },
        prod: {
            source: 'https://cdn.walkme.com/users/6cbf8bc6b4074175a66db42243c4325a/walkme_6cbf8bc6b4074175a66db42243c4325a_https.js',
        },
    })
        .config(['$httpProvider', configureHttpInterceptor]);
    //set $http defaults
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$httpProvider' implicitly has an 'any' ... Remove this comment to see the full error message
    function configureHttpInterceptor($httpProvider) {
        //optimization to trigger a $digest only once per set of calls
        $httpProvider.useApplyAsync(true);
        //allow credentials on each request
        $httpProvider.defaults.withCredentials = true;
        //
        $httpProvider.interceptors.push('etwServicesInterceptor');
    }
})();

(function () {
    angular
        .module('ETWServices')
        .factory('AccountSettingsService', [
        '$cacheFactory',
        '$http',
        'ETWServicesUtils',
        AccountSettingsServiceFactory,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$cacheFactory' implicitly has an 'any' ... Remove this comment to see the full error message
    function AccountSettingsServiceFactory($cacheFactory, $http, ETWServicesUtils) {
        var service = {
            get: get,
            save: save,
            subscribe: ETWServicesUtils.subscribe('AccountSettingsService'),
        };
        /**
         * @property serviceUrl
         * @type {string}
         * Get the URL for account settings -> client controller -> user account service.
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('ACCOUNT_SETTINGS');
        /**
         * @function get.clear
         * @private
         * Clear the cache
         */
        get.clear = function () {
            $cacheFactory.get('$http').remove(serviceUrl);
        };
        return service;
        /**
         * @method get
         * @returns {object} - promise,
         * Fetches the account settings based upon the current users token
         * Settings accessible in the app via the CLIENT_SETTINGS value.
         * Note: This should only be called in a Run block in app.js
         */
        function get() {
            return $http({
                cache: true,
                method: 'GET',
                url: serviceUrl,
            });
        }
        /**
         * @method save
         * @param accountSettings {object}
         * @param changedProperties {Array} - optional. For partial updates
         * @returns {object} - promise
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'accountSettings' implicitly has an 'any... Remove this comment to see the full error message
        function save(accountSettings, changedProperties) {
            var options = {
                data: accountSettings,
                errorMessage: 'Account Settings could not be saved.',
                idName: 'id',
                properties: changedProperties,
                url: serviceUrl + '/' + ETWServicesUtils.asId(accountSettings.id),
            };
            // Clear the cache
            get.clear();
            return ETWServicesUtils.save(options, undefined, 'AccountSettingsService');
        }
    }
})();

(function () {
    angular
        .module('ETWServices')
        .factory('ActionItemsService', [
        '$http',
        '$filter',
        'AuthenticationService',
        'ETWServicesUtils',
        'GoalsService',
        'PubnubService',
        ActionItemsServiceFactory,
    ]);
    function ActionItemsServiceFactory($http, $filter, AuthenticationService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
    ETWServicesUtils, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AuthenticationService' implicitly has a... Remove this comment to see the full error message
    GoalsService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ETWServicesUtils' implicitly has an 'an... Remove this comment to see the full error message
    PubnubService) {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'GoalsService' implicitly has an 'any' t... Remove this comment to see the full error message
        PubnubService.registerListener('realtime-messaging:onMessage', onPubnubMessage);
        /**
         * @property PUBNUB_ACTION_TYPE_MAP
         * @type {object}
         * Keep verbage on client side consistent
         */
        var PUBNUB_ACTION_TYPE_MAP = {
            new: 'create',
            delete: 'destroy',
            update: 'pubnubUpdate',
        };
        /**
         * @property serviceUrl
         * @type {string}
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('ACTION_ITEMS');
        /**
         * @property modelDefinition
         * @type {object}
         */
        var modelDefinition = {
            columns: {
                _highlighted: 'excluded',
                _relativeDueDate: 'excluded',
                _isCollapsed: 'excluded',
                dueDate: 'date',
            },
            decoders: [fixAPIActionItemGoals],
        };
        /**
         * @property generatorModelDefinition
         * @type {object}
         */
        var generatorModelDefinition = {
            columns: {
                _highlighted: 'excluded',
                startDate: 'simpleDate',
                firstDueDate: 'simpleDate',
            },
        };
        /**
         * @property decodePaginatedResponse
         * @type {Function}
         * Clean returned action items in paginated responses.
         */
        var decodePaginatedResponse = ETWServicesUtils.decodePaginatedResponse(modelDefinition);
        /**
         * @property decodeGeneratorResponse
         * @type {Function}
         * Clean returned single action items.
         */
        var decodeGeneratorResponse = ETWServicesUtils.decodeResponse(generatorModelDefinition);
        /**
         * @property decodeResponse
         * @type {Function}
         * Clean returned single action items.
         */
        var decodeResponse = ETWServicesUtils.decodeResponse(modelDefinition);
        /**
         * @property propertyCallbacks
         * @type {object}
         * Callbacks specific to action item updates.
         */
        var propertyCallbacks = {};
        /**
         * @property operationCallbacks
         * @type {object}
         * Callbacks specific to creating/destroying/updating action items.
         */
        var operationCallbacks = {
            create: {},
            destroy: {},
            localUpdate: {},
            pubnubUpdate: {},
        };
        var service = {
            assignableUsersForDriver: assignableUsersForDriver,
            assignableUsersForGoal: assignableUsersForGoal,
            create: create,
            createAIGenerator: createAIGenerator,
            destroy: destroy,
            duplicate: duplicate,
            destroyAIGenerator: destroyAIGenerator,
            getById: getById,
            getBlank: getBlank,
            getBlankAIGenerator: getBlankAIGenerator,
            daysInMonth: daysInMonth,
            getDriversComplete: getDriversComplete,
            getDriversIncomplete: getDriversIncomplete,
            getDriversRecurring: getDriversRecurring,
            getGoalsComplete: getGoalsComplete,
            getGoalsIncomplete: getGoalsIncomplete,
            getIconClass: getIconClass,
            getIconTooltip: getIconTooltip,
            getMeetingComplete: getMeetingComplete,
            getMeetingIncomplete: getMeetingIncomplete,
            getNth: getNth,
            getNumberExtension: getNumberExtension,
            getUsersComplete: getUsersComplete,
            getUsersCompleteDelegate: getUsersCompleteDelegate,
            getUsersIncomplete: getUsersIncomplete,
            getUsersInCompleteDelegate: getUsersInCompleteDelegate,
            getUsersRecurring: getUsersRecurring,
            getRelativeDueDate: getRelativeDueDate,
            getUsersStatus: getUsersStatus,
            resolve: ETWServicesUtils.resolve,
            setRecurrenceDay: setRecurrenceDay,
            subscribeToProperty: subscribeToProperty,
            subscribeToOperation: subscribeToOperation,
            userCanCreateForGoal: userCanCreateForGoal,
            update: update,
            updateAIGenerator: updateAIGenerator,
        };
        return service;
        /**
         * @function cleanResponse
         * @private
         * @param [decoder] {Function}
         * @returns {Function}
         * Will Decode a response if a function is provided,
         * then pulls the data from the response.
         */
        function cleanResponse(decoder) {
            return function (resp) {
                if (decoder) {
                    decoder(resp);
                }
                return resp.data;
            };
        }
        /**
         * @method assignableUsersForDriver
         * @param driverId {number}
         * @returns {promise}
         */
        function assignableUsersForDriver(driverId) {
            var url = [
                getServiceUrl('drivers'),
                ETWServicesUtils.asId(driverId),
                'actionitems/assignable_users',
            ].join('/');
            return $http({
                errorMessage: 'Count not retrieve Assignable Users for Driver.',
                method: 'GET',
                url: url,
                // @ts-ignore
            }).then(cleanResponse());
        }
        /**
         * @method assignableUsersForGoal
         * @param goalId {number}
         * @param goalType {string}
         * @returns {promise}
         */
        function assignableUsersForGoal(goalId, goalType) {
            return $http({
                errorMessage: 'Count not retrieve Assignable Users for Goal.',
                method: 'GET',
                url: getGoalsUrl(goalId, goalType, 'assignable_users'),
                // @ts-ignore
            }).then(cleanResponse());
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'decoder' implicitly has an 'any' type.
        /**
         * @function create
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'resp' implicitly has an 'any' type.
         * @param actionItem {Object}
         * @param contextName {string}
         * @returns {Object}
         */
        function create(actionItem, contextName) {
            var options = {
                errorMessage: 'Can not save Action Item',
                data: actionItem,
                url: getServiceUrl('actionitems'),
            };
            return save(options).then(function (actionItem) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'driverId' implicitly has an 'any' type.
                notifyOnOperation('create', actionItem, contextName);
                return actionItem;
            });
        }
        /**
         * @function createAIGenerator
         * @param actionItem {object}
         * @param contextName {string}
         * @returns {promise}
         */
        function createAIGenerator(actionItem, contextName) {
            var options = {
                errorMessage: 'This recurring action item cannot be saved.',
            };
            // @ts-ignore ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
            if (actionItem.contextName === 'roles') {
                // @ts-ignore
                options.data = actionItem.actionItem;
                // @ts-ignore
                options.url = getAIServiceUrl(contextName, actionItem.ownerEntityId);
            }
            else {
                // @ts-ignore
                options.data = actionItem;
                // @ts-ignore
                options.url = getAIServiceUrl('users', actionItem.user);
            }
            return save(options).then(function (actionItem) {
                // @ts-ignore
                notifyOnOperation('create', actionItem, contextName);
                return actionItem;
            });
        }
        /**
         * @function destroy
         * @param actionItem {Object}
         * @param contextName {String}
// @ts-ignore ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
         * @returns {Object}
         */
        function destroy(actionItem, contextName) {
            var options = {
                errorMessage: 'There was an error deleting - ' + actionItem.title,
                method: 'DELETE',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
                url: getActionItemUrl(actionItem.id),
            };
            return $http(options).then(function (resp) {
                // @ts-ignore
                notifyOnOperation('destroy', actionItem, contextName);
                return resp;
            });
        }
        /**
         * @function destroyAIGenerator
         * @param actionItem {object}
         * @param contextName {string}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
         * @returns {promise}
         */
        // @ts-ignore ts-migrate(2554) FIXME: Expected 4 arguments, but got 3.
        function destroyAIGenerator(actionItem, contextName) {
            var options = {
                errorMessage: 'There was an error deleting - ' + actionItem.title,
                method: 'DELETE',
                url: getAIActionItemUrl(actionItem, contextName),
            };
            return $http(options).then(function (resp) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
                notifyOnOperation('destroy', actionItem, contextName);
                return resp;
            });
        }
        /**
         * @function fixAPIActionItemGoals
         * @param record {object}
         * @private
         * Iteratee used to 'fix' goals embedded in the API response for an Action Item.
         * ActionItem has a 'goal', but that goal doesn't have the goal type.
         * ActionItem has its own alignment/performance goal types.
         * This function is passed to ETWServicesUtils via the model definition.
         */
        function fixAPIActionItemGoals(record) {
            if (record.goal) {
                record.goal.alignmentGoalType = record.alignmentGoalType;
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
                record.goal.performanceGoalType = record.performanceGoalType;
                // @ts-ignore ts-migrate(2554) FIXME: Expected 4 arguments, but got 3.
            }
        }
        /**
         * @function getBlank
         * @returns {object}
         */
        function getBlank() {
            var midnight = new Date();
            midnight.setHours(0, 0, 0, 0);
            return {
                user: null,
                title: '',
                description: '',
                completed: false,
                type: null,
                progress: null,
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
                dueDate: midnight,
            };
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'contextName' implicitly has an 'any' ty... Remove this comment to see the full error message
        }
        /**
         * @function getBlankAIGenerator
         * @returns {object}
         */
        function getBlankAIGenerator() {
            return {
                title: '',
                isRecurring: false,
                cadenceType: null,
            };
        }
        /**
         * @method getById
         * @param actionItemId {Number}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'resp' implicitly has an 'any' type.
        function getById(actionItemId) {
            // @ts-ignore ts-migrate(2554) FIXME: Expected 4 arguments, but got 3.
            return $http({
                errorMessage: 'Could not retrieve Action Item',
                method: 'GET',
                url: getActionItemUrl(actionItemId),
            }).then(cleanResponse(decodeResponse));
        }
        /**
         * @function getComplete
         * @private
         * @param {string} url
         * @param {object} paginationParams
         * @returns {promise}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function getComplete(url, paginationParams) {
            var params = _.assign({
                completed: true,
                sortBy: 'modifiedDate',
                ascending: false,
            }, paginationParams);
            return $http({
                errorMessage: 'Could not retrieve Complete Action Items',
                method: 'GET',
                params: params,
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'resp' implicitly has an 'any' type.
                url: url,
                // @ts-ignore ts-migrate(2554) FIXME: Expected 4 arguments, but got 3.
            }).then(cleanResponse(decodePaginatedResponse));
        }
        /**
         * @function getDelegateUsersUrl
         * @private
         * @param userId {number}
         */
        function getDelegateUsersUrl(userId) {
            return [
                getDelegateServiceUrl('assignors'),
                ETWServicesUtils.asId(userId),
                'actionitems',
            ].join('/');
        }
        /**
         * @function getDelegateServiceUrl
         * @private
         * @param type {string}
         * Attach the type of endpoint to the service.
         * Instead of having multiple entries in API_SERVICE_URLS.
         */
        function getDelegateServiceUrl(type) {
            return [serviceUrl, type].join('/');
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'record' implicitly has an 'any' type.
        /**
         * @function getDriversComplete
         * @param driverId {number}
         * @param paginationParams {Object}
         * @returns {promise}
         */
        function getDriversComplete(driverId, paginationParams) {
            var url = getDriversUrl(driverId);
            return getComplete(url, paginationParams);
        }
        /**
         * @function getDriversIncomplete
         * @param driverId {number}
         * @returns {promise}
         */
        function getDriversIncomplete(driverId) {
            return $http({
                errorMessage: 'Could not retrieve Incomplete Action Items for Driver',
                method: 'GET',
                params: { completed: false },
                url: getDriversUrl(driverId),
            }).then(cleanResponse(decodePaginatedResponse));
        }
        /**
         * @function getDriversRecurring
         * @param driverId {number}
         * @returns {promise}
         */
        function getDriversRecurring(driverId) {
            return $http({
                errorMessage: 'Could not retrieve Recurring Action Items for the Driver',
                method: 'GET',
                url: getDriversRecurringUrl(driverId),
            }).then(cleanResponse(decodeGeneratorResponse));
        }
        /**
         * @function getGoalsComplete
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItemId' implicitly has an 'any' t... Remove this comment to see the full error message
         * @param goalId {number}
         * @param goalType {string}
         * @param paginationParams {Object}
         * @returns {promise}
         */
        function getGoalsComplete(goalId, goalType, paginationParams) {
            var url = getGoalsUrl(goalId, goalType, 'actionitems');
            return getComplete(url, paginationParams);
        }
        /**
         * @function getGoalsIncomplete
         * @param goalId {number}
         * @param goalType {string}
         * @returns {promise}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'url' implicitly has an 'any' type.
        function getGoalsIncomplete(goalId, goalType) {
            return $http({
                errorMessage: 'Could not retrieve Incomplete Action Items',
                method: 'GET',
                params: { completed: false },
                url: getGoalsUrl(goalId, goalType, 'actionitems'),
            }).then(cleanResponse(decodePaginatedResponse));
        }
        /**
         * @function getUsersIncomplete
         * @param userId {number}
         * @returns {promise}
         */
        function getUsersIncomplete(userId) {
            return $http({
                errorMessage: 'Could not retrieve Incomplete Action Items',
                method: 'GET',
                params: { completed: false },
                url: getUsersUrl(userId),
            }).then(cleanResponse(decodePaginatedResponse));
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'userId' implicitly has an 'any' type.
        }
        /**
         * @function getUsersInCompleteDelegate
         * @param userId {number}
         * @returns {promise}
         */
        function getUsersInCompleteDelegate(userId) {
            return $http({
                errorMessage: 'Could not retrieve Incomplete Action Items',
                method: 'GET',
                params: { completed: false },
                url: getDelegateUsersUrl(userId),
            }).then(cleanResponse(decodePaginatedResponse));
        }
        /**
         * @function getUsersRecurring
         * @param userId {number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
         * @returns {promise}
         */
        function getUsersRecurring(userId) {
            return $http({
                errorMessage: 'Could not retrieve Recurring Action Items',
                method: 'GET',
                url: getUsersRecurringUrl(userId),
            }).then(cleanResponse(decodeGeneratorResponse));
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'driverId' implicitly has an 'any' type.
         * @method getMeetingComplete
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'paginationParams' implicitly has an 'an... Remove this comment to see the full error message
         * @param meetingId {Number}
         * @param paginationParams {Object}
         * @returns {promise}
         */
        function getMeetingComplete(meetingId, paginationParams) {
            var url = getMeetingActionItemsUrl(meetingId);
            return getComplete(url, paginationParams);
        }
        /**
         * @method getMeetingIncomplete
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'driverId' implicitly has an 'any' type.
         * @param meetingId {number}
         * @returns {promise}
         */
        function getMeetingIncomplete(meetingId) {
            return $http({
                errorMessage: 'Could not retrieve Incomplete Action Items',
                method: 'GET',
                params: { completed: false },
                url: getMeetingActionItemsUrl(meetingId),
            }).then(cleanResponse(decodePaginatedResponse));
        }
        /**
         * @function getRelativeDueDate
         * @private
         * @param dueDate {Date}
         * @returns {Object}
         */
        function getRelativeDueDate(dueDate) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'driverId' implicitly has an 'any' type.
            var oneDay = 24 * 60 * 60 * 1000;
            var today = new Date().setHours(0, 0, 0, 0);
            var diffDays = Math.round((dueDate - today) / oneDay);
            var overDue = diffDays < 0;
            var nearDue = !overDue && diffDays < 7;
            return {
                days: diffDays,
                nearDue: nearDue,
                overDue: overDue,
            };
        }
        /**
         * @function getUsersStatus
         * @param userId {number}
         * @returns {promise}
         */
        function getUsersStatus(userId) {
            return $http({
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalId' implicitly has an 'any' type.
                errorMessage: 'Count not retrieve users Action Item Status',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalType' implicitly has an 'any' type.
                method: 'GET',
                url: getUsersUrl(userId) + '/status',
                // @ts-ignore
            }).then(cleanResponse());
        }
        /**
         * @method getIconClass
         * @param {String} actionItemType
         * @returns {String}
         */
        function getIconClass(actionItemType) {
            return {
                DRIVER: 'icon-driver',
                MEETING: 'icon-meeting-agenda',
                PERSONAL: 'icon-person',
                ROLE: 'icon-gears',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalId' implicitly has an 'any' type.
                MANAGER_ASSIGNED: 'icon-leader',
                PERFORMANCE_GOAL: 'icon-goals',
                ALIGNMENT_GOAL: 'icon-goals',
            }[actionItemType];
        }
        /**
         * @method getIconTooltip
         * @return {String} the tooltip text for the action item icon
         */
        function getIconTooltip(actionItem) {
            var toolTip = _.startCase(_.toLower(actionItem.type)); // default to type
            if (actionItem.driver) {
                toolTip = actionItem.driver.plan.title;
            }
            else if (actionItem.meeting) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'userId' implicitly has an 'any' type.
                toolTip = actionItem.meeting.seriesName;
            }
            else if (actionItem.goal) {
                toolTip = actionItem.goal.title;
            }
            return toolTip;
        }
        /**
         * @function getUsersComplete
         * @param userId {Number}
         * @param paginationParams {Object}
         * @returns {promise}
         */
        function getUsersComplete(userId, paginationParams) {
            var url = getUsersUrl(userId);
            return getComplete(url, paginationParams);
        }
        /**
         * @function getUsersCompleteDelegate
         * @param userId {Number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'userId' implicitly has an 'any' type.
         * @param paginationParams {Object}
         * @returns {promise}
         */
        function getUsersCompleteDelegate(userId, paginationParams) {
            var url = getDelegateUsersUrl(userId);
            return getComplete(url, paginationParams);
        }
        /**
         * @method getPlanAll
         * @param planId {Number}
         * @param paginationParams {Object}
         * @returns {String}
         */
        function getPlanAll(planId) {
            return $http({
                errorMessage: false,
                method: 'GET',
                params: { completed: false },
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'userId' implicitly has an 'any' type.
                url: getPlansUrl(planId),
            }).then(cleanResponse(decodePaginatedResponse));
        }
        /**
         * @function getActionItemUrl
         * @private
         * @param actionItemId {number}
         */
        function getActionItemUrl(actionItemId) {
            return [getServiceUrl('actionitems'), ETWServicesUtils.asId(actionItemId)].join('/');
        }
        /**
         * @function getActionItemUrl
         * @private
         * @param actionItem {object}
         * @param contextName {string}
         */
        function getAIActionItemUrl(actionItem, contextName) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'meetingId' implicitly has an 'any' type... Remove this comment to see the full error message
            if (contextName === 'roles') {
                return [
                    getAIServiceUrl(contextName, actionItem.ownerEntityId),
                    ETWServicesUtils.asId(actionItem.id),
                ].join('/');
            }
            else {
                return [
                    getAIServiceUrl('users', actionItem.ownerEntityId),
                    ETWServicesUtils.asId(actionItem.id),
                ].join('/');
            }
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'meetingId' implicitly has an 'any' type... Remove this comment to see the full error message
         * @function getAIServiceUrl
         * @private
         * @param type {string}
         * @param id {number}
         */
        function getAIServiceUrl(type, id) {
            return [serviceUrl, type, id, 'actionitemgenerators'].join('/');
        }
        /**
         * @function getServiceUrl
         * @private
         * @param type {string}
         * Attach the type of endpoint to the service.
         * Instead of having multiple entries in API_SERVICE_URLS.
         */
        function getServiceUrl(type) {
            return [serviceUrl, type].join('/');
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'dueDate' implicitly has an 'any' type.
         * @function getDriversUrl
         * @private
         * @param driverId {number}
         */
        function getDriversUrl(driverId) {
            return [getServiceUrl('drivers'), ETWServicesUtils.asId(driverId), 'actionitems'].join('/');
        }
        /**
         * @function getMeetingActionItemsUrl
         * @private
         * @param meetingId {number}
         */
        function getMeetingActionItemsUrl(meetingId) {
            return [getServiceUrl('meetings'), ETWServicesUtils.asId(meetingId), 'actionitems'].join('/');
        }
        /**
         * @function getTopicsUrl
         * @private
         * @param topicId {number}
         */
        function getTopicsUrl(topicId) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'userId' implicitly has an 'any' type.
            return [getServiceUrl('topics'), ETWServicesUtils.asId(topicId), 'actionitems'].join('/');
        }
        /**
         * @function getUsersUrl
         * @private
         * @param userId {number}
         */
        function getUsersUrl(userId) {
            // @ts-ignore ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
            return [getServiceUrl('users'), ETWServicesUtils.asId(userId), 'actionitems'].join('/');
        }
        /**
         * @function getDriversUrl
         * @private
         * @param driverId {number}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItemType' implicitly has an 'any'... Remove this comment to see the full error message
        function getDriversRecurringUrl(driverId) {
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            return [getServiceUrl('drivers'), ETWServicesUtils.asId(driverId), 'actionitemgenerators'].join('/');
        }
        /**
         * @function getUsersUrl
         * @private
         * @param userId {number}
         */
        function getUsersRecurringUrl(userId) {
            return [getServiceUrl('users'), ETWServicesUtils.asId(userId), 'actionitemgenerators'].join('/');
        }
        /**
         * @function getGoalsUrl
         * @private
         * @param goalId {number}
         * @param goalType {string}
         * @param suffix {string}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function getGoalsUrl(goalId, goalType, suffix) {
            return [
                getServiceUrl('goals'),
                ETWServicesUtils.asId(goalId),
                'goalType',
                goalType,
                suffix,
            ].join('/');
        }
        /**
         * @function getPlansUrl
         * @private
         * @param planId {number}
         */
        function getPlansUrl(planId) {
            return [getServiceUrl('plans'), ETWServicesUtils.asId(planId)].join('/');
        }
        /**
         * @function notifyOnOperation
         * @private
         * @param operation {string}
         * @param actionItem {Object}
         * @param [contextName] {string}
         * @param [changedProperties] {Array}
         */
        function notifyOnOperation(operation, actionItem, contextName, changedProperties) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'userId' implicitly has an 'any' type.
            _.forEach(_.values(operationCallbacks[operation]), function (callback) {
                callback(actionItem, contextName, changedProperties);
            });
        }
        /**
         * @function notifyOnProperties
         * @private
         * @param changedProperties {array}
         * @param actionItem {object}
         */
        function notifyOnProperties(changedProperties, actionItem) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'userId' implicitly has an 'any' type.
            _.forEach(changedProperties, function (property) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'paginationParams' implicitly has an 'an... Remove this comment to see the full error message
                _.forEach(_.values(propertyCallbacks[property]), function (callback) {
                    callback(actionItem);
                });
            });
        }
        /**
         * @function onPubnubMessage
         * @private
         * @param msg {object}
         */
        function onPubnubMessage(msg) {
            if (msg.message.type == 'actionItem') {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                var operation = PUBNUB_ACTION_TYPE_MAP[msg.message.action], actionItem = msg.body;
                // @ts-ignore
                notifyOnOperation(operation, actionItem);
            }
        }
        /**
         * @function save
         * @private
         * @param options {Object}
         * @returns {Object} - promise
         */
        function save(options) {
            return ETWServicesUtils.save(options, modelDefinition).then(cleanResponse(decodeResponse));
        }
        /**
         * @method subscribeToProperty
         * @param property {string}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItemId' implicitly has an 'any' t... Remove this comment to see the full error message
         * @param callback {Function}
         * @returns {Function}
         */
        function subscribeToProperty(property, callback) {
            var index = _.uniqueId();
            if (!propertyCallbacks[property]) {
                propertyCallbacks[property] = {};
            }
            propertyCallbacks[property][index] = callback;
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
            return unsubscribeCallbackFactory(propertyCallbacks, property, index);
        }
        /**
         * @method subscribeToOperation
         * @param operation {string}
         * @param callback {Function}
         * @returns {Function}
         */
        function subscribeToOperation(operation, callback) {
            var index = _.uniqueId();
            operationCallbacks[operation][index] = callback;
            return unsubscribeCallbackFactory(operationCallbacks, operation, index);
        }
        /**
         * @function unsubscribeCallbackFactory
         * @private
         * @param callbacks {object}
         * @param collection {string}
         * @param callbackIndex {string}
         * @returns {Function}
         */
        function unsubscribeCallbackFactory(callbacks, collection, callbackIndex) {
            return function () {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
                delete callbacks[collection][callbackIndex];
            };
        }
        /**
         * @method userCanCreateForGoal
         * @param goalType {string}
         * @param goalId {number}
         */
        function userCanCreateForGoal(goalId, goalType) {
            return $http({
                errorMessage: 'Could not retrieve create Permission for current user.',
                method: 'GET',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
                url: getGoalsUrl(goalId, goalType, 'createActionItem'),
                // @ts-ignore
            }).then(cleanResponse());
        }
        /**
         * @method update
         * @param actionItem {object}
         * @param changedProperties {array}
         * @param contextName {string}
         * @returns {Object} - promise
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'driverId' implicitly has an 'any' type.
         */
        function update(actionItem, changedProperties, contextName) {
            var options = {
                data: actionItem,
                errorMessage: 'Can not update Action Item',
                idName: 'id',
                properties: changedProperties,
                url: getActionItemUrl(actionItem.id),
            };
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'meetingId' implicitly has an 'any' type... Remove this comment to see the full error message
            return save(options).then(function (actionItem) {
                //clear cache for goals on plans to update cards
                if (changedProperties[0] === 'completed' &&
                    actionItem.type === 'PERFORMANCE_GOAL' &&
                    actionItem.goal.performanceGoalType === 'PLAN') {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'topicId' implicitly has an 'any' type.
                    GoalsService.getAllForPlan.clear(actionItem.goal.plan.id);
                    ETWServicesUtils.notify('GoalsService');
                }
                notifyOnOperation('localUpdate', actionItem, contextName, changedProperties);
                notifyOnProperties(changedProperties, actionItem);
                return actionItem;
            });
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'userId' implicitly has an 'any' type.
         * @method updateAIGenerator
         * @param generator {object}
         * @param contextName {string}
         * @param changedProperties {array}
         */
        function updateAIGenerator(generator, contextName, changedProperties) {
            var options = {
                data: generator,
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'driverId' implicitly has an 'any' type.
                errorMessage: 'This recurring action item could not be updated.',
                idName: 'id',
                properties: changedProperties,
                url: getAIActionItemUrl(generator, contextName),
            };
            return ETWServicesUtils.save(options, generatorModelDefinition).then(function (response) {
                var savedGenerator = response.data;
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'userId' implicitly has an 'any' type.
                notifyOnOperation('localUpdate', savedGenerator, contextName, changedProperties);
                notifyOnProperties(changedProperties, savedGenerator);
                return savedGenerator;
            });
        }
        function setRecurrenceDay(recurrence, day) {
            var today = new Date();
            var d = $filter('date')(today, 'EEE');
            if (day) {
                d = day;
            }
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalId' implicitly has an 'any' type.
            switch (d) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalType' implicitly has an 'any' type.
                case 'Sun':
                case 'Sunday':
                    recurrence.days.sun = true;
                    break;
                case 'Mon':
                case 'Monday':
                    recurrence.days.mon = true;
                    break;
                case 'Tue':
                case 'Tuesday':
                    recurrence.days.tue = true;
                    break;
                case 'Wed':
                case 'Wednesday':
                    recurrence.days.wed = true;
                    break;
                case 'Thu':
                case 'Thursday':
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                    recurrence.days.thu = true;
                    break;
                case 'Fri':
                case 'Friday':
                    recurrence.days.fri = true;
                    break;
                case 'Sat':
                case 'Saturday':
                    recurrence.days.sat = true;
                    break;
            }
        }
        function daysInMonth(selectedDate) {
            var date = selectedDate ? selectedDate : new Date();
            var month = date.getMonth() + 1;
            var year = date.getFullYear();
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'operation' implicitly has an 'any' type... Remove this comment to see the full error message
            return new Date(year, month, 0).getDate();
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'changedProperties' implicitly has an 'a... Remove this comment to see the full error message
        function getNth(dat) {
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            var d = dat ? dat instanceof Date ? dat : new Date(dat) : new Date(), date = d.getDate(), n = Math.ceil(date / 7);
            return n;
        }
        function getNumberExtension(number, selectedDate) {
            var extension = '' + number;
            switch (number) {
                case 1:
                    extension = number + 'st';
                    break;
                case 2:
                    extension = number + 'nd';
                    break;
                case 3:
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'changedProperties' implicitly has an 'a... Remove this comment to see the full error message
                    extension = number + 'rd';
                    break;
                case 4:
                    var date = selectedDate ? selectedDate : new Date();
                    // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                    if (daysInMonth(date) - date.getDate() >= 7)
                        extension = number + 'th';
                    else
                        extension = 'last';
                    break;
                case 5:
                    extension = 'last';
                    break;
            }
            return extension;
        }
        // @ts-ignore
        function duplicate(userId, actionId) {
            return $http({
                method: 'POST',
                url: serviceUrl + "/users/" + userId + "/actionitems/" + actionId
            });
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'msg' implicitly has an 'any' type.

(function () {
    angular
        .module('ETWServices')
        .factory('AlertsService', ['$http', 'ETWServicesUtils', AlertsServiceFactory]);
    /**
     * @constant TYPES
     * @type {object}
     */
    var TYPES = {
        0: {
            entity: 'KPI',
            label: 'KPI Update Due',
            name: 'KPI_UPDATE_DUE',
        },
        1: {
            entity: 'KPI',
            label: 'KPI State Change',
            name: 'KPI_STATE_CHANGE',
        },
        2: {
            entity: 'KPI',
            label: 'KPI Downgrade Status',
            name: 'KPI_STATUS_DOWNGRADE',
        },
        3: {
            entity: 'KPI',
            label: 'KPI upgrade status',
            name: 'KPI_STATUS_UPGRADE',
        },
        4: {
            entity: 'EVALUATION',
            label: 'Evaluation State Change',
            name: 'EVALUATION_STATE_CHANGE',
        },
        5: {
            entity: 'EVALUATION',
            label: 'Evaluation Due',
            name: 'EVALUATION_DUE',
        },
        17: {
            entity: 'EVALUATION',
            label: 'Evaluation Edited',
            name: 'COMPLETED_EVALUATION_EDITED',
        },
        6: {
            entity: 'GOAL',
            label: 'Goal State Change',
            name: 'GOAL_STATE_CHANGE',
        },
        7: {
            entity: 'GOAL',
            label: 'Goal Downgrade Status',
            name: 'GOAL_STATUS_DOWNGRADE',
        },
        8: {
            entity: 'GOAL',
            label: 'Goal Upgrade Status',
            name: 'GOAL_STATUS_UPGRADE',
        },
        9: {
            entity: 'GOAL',
            label: 'Goal Update Due',
            name: 'GOAL_UPDATE_DUE',
        },
        10: {
            entity: 'PLAN',
            label: 'Plan State Change',
            name: 'PLAN_STATE_CHANGE',
        },
        11: {
            entity: 'ACTION_ITEM_TRAY',
            label: 'Action Item Due In 7 Days',
            name: 'ACTION_ITEM_DUE_SOON',
        },
        12: {
            entity: 'ACTION_ITEM_TRAY',
            label: 'Action Item Overdue',
            name: 'ACTION_ITEM_OVERDUE',
        },
        13: {
            entity: 'ACTION_ITEM_TRAY',
            label: 'Action Item Assigned to you',
            name: 'ACTION_ITEM_ASSIGNED',
        },
        14: {
            entity: 'ACTION_ITEM_NOT_LINKED',
            label: 'Action Item Deleted',
            name: 'ACTION_ITEM_DELETED',
        },
        15: {
            entity: 'ACTION_ITEM_PERSON',
            label: 'Action Item Completed',
            name: 'ACTION_ITEM_COMPLETED',
        },
        16: {
            entity: 'ACTION_ITEM_PERSON',
            label: 'Action Item Assigned to Direct Report',
            name: 'ACTION_ITEM_ASSIGNED_DIRECT_REPORT',
        },
    };
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
    function AlertsServiceFactory($http, ETWServicesUtils) {
        /**
         * @property modelDefinition
         * @type {Object}
         * Configuration object used by ETWServicesUtils for formatting certain columns.
         * pageSize is the number to expect in each page from the server.
         * TODO: remove pageSize when API provides the value in metadata
         */
        var modelDefinition = {
            columns: {
                createdDate: 'date',
            },
        };
        var service = {
            TYPES: TYPES,
            getAll: getAll,
            archive: archive,
            unarchive: unarchive,
            archiveAll: archiveAll,
        };
        /**
         * @property serviceUrl
         * @type {string}
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('ALERTS');
        return service;
        /**
         * @method archive
         * @param alertId {number}
         * @returns {object} - promise
         * Marks an alert as "read"
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'alertId' implicitly has an 'any' type.
        function archive(alertId) {
            return $http({
                method: 'POST',
                url: serviceUrl + '/' + alertId + '/archive',
            });
        }
        /**
         * @method archiveAll
         * @returns {object} - promise
         * Marks all alerts as "read"
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ids' implicitly has an 'any' type.
        function archiveAll(ids) {
            if (!angular.isArray(ids) || !ids.length) {
                return ETWServicesUtils.reject('IDs are required.');
            }
            return $http({
                method: 'POST',
                url: serviceUrl + '/archiveMultiple?ids=' + ids.join(','),
            });
        }
        /**
         * @method getAll
         * @param isArchived {boolean}
         * @param [startKey] {string} - optional starting point
         * Get all read or unread alerts, starting with optional startKey.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'isArchived' implicitly has an 'any' typ... Remove this comment to see the full error message
        function getAll(isArchived, startKey) {
            var path = isArchived ? '/archived' : '/unread';
            return $http({
                errorMessage: 'The list of alerts could not be retrieved.',
                method: 'GET',
                params: startKey ? { startKey: startKey } : {},
                url: serviceUrl + path,
            }).then(ETWServicesUtils.paginate(modelDefinition, startKey), ETWServicesUtils.reject);
        }
        /**
         * @method unarchive
         * @param alertId {number}
         * @returns {object} - promise
         * Marks an alert as "unread"
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'alertId' implicitly has an 'any' type.
        function unarchive(alertId) {
            return $http({
                method: 'POST',
                url: serviceUrl + '/' + alertId + '/unarchive',
            });
        }
    }
})();

(function () {
    angular
        .module('ETWServices')
        .factory('AnalysisService', ['$http', 'ETWServicesUtils', AnalysisServiceFactory]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
    function AnalysisServiceFactory($http, ETWServicesUtils) {
        /**
         * @property categoryHelper
         * @type {object}
         * The organized results of the analysis
         */
        var categoryHelper = {
            emotionTone: {
                title: 'Emotional Tones',
                helper: 'The higher the number the more likely the message will be perceived as having the tone.',
            },
            languageTone: {
                title: 'Language Styles',
                helper: 'The higher the number the more likely the message will be perceived as having the language style.',
            },
            socialTone: {
                title: 'Social Tendencies',
                helper: 'The higher the number the more likely the message will be perceived as having the social tendency.',
            },
        };
        /**
         * @property tonesHelper
         * @type {object}
         */
        var tonesHelper = {
            // Emotional Tones
            anger: {
                description: 'Evoked due to injustice, conflict, humiliation, negligence or betrayal. If anger is active, the individual attacks the target, verbally or physically. If anger is passive, the person silently sulks and feels tension and hostility.',
            },
            disgust: {
                description: 'An emotional response of revulsion to something considered offensive or unpleasant. It is a sensation that refers to something revolting.',
            },
            fear: {
                description: 'A response to impending danger. It is a survival mechanism that is a reaction to some negative stimulus. It may be a mild caution or an extreme phobia.',
            },
            joy: {
                description: 'Joy or happiness has shades of enjoyment, satisfaction and pleasure. There is a sense of well-being, inner peace, love, safety and contentment.',
            },
            sadness: {
                description: 'Indicates a feeling of loss and disadvantage. When a person can be observed to be quiet, less energetic and withdrawn, it may be inferred that sadness exists.',
            },
            // Language Styles
            analytical: {
                description: "A person's reasoning and analytical attitude about things.",
            },
            confident: {
                description: "A person's degree of certainty.",
            },
            tentative: {
                description: "A person's degree of inhibition.",
            },
            // Social Tendencies
            agreeableness_big5: {
                description: 'The tendency to be compassionate and cooperative towards others.',
            },
            conscientiousness_big5: {
                description: 'The tendency to act in an organized or thoughtful way.',
            },
            emotional_range_big5: {
                description: "The extent a persona's emotion is sensitive to the environment.",
            },
            extraversion_big5: {
                description: 'The tendency to seek stimulation in the company of others.',
            },
            openness_big5: {
                description: 'The extent a person is open to experience a variety of activities.',
            },
        };
        /**
         * @property channelsServiceUrl
         * @type {string}
         */
        var analyzeServiceUrl = ETWServicesUtils.getEndpointUrl('ANALYZE_GOAL_NOTE');
        var service = {
            analyze: analyze,
        };
        return service;
        /**
         * @method analyze
         * @param  {string} message the text or html to analyze
         * @return {Object}         promise, object
         * Retrieve the tone analysis for a given message.
         *
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'message' implicitly has an 'any' type.
        function analyze(message) {
            return analyzeMessage(message).then(
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            function analyzeMessageSuccess(response) {
                var results = response.data.documentTone.toneCategories;
                // cycle through each analysis category and add the helper text
                // and css classes and ordering
                _.forEach(results, function (toneCategory) {
                    toneCategory.title = getCategoryTitle(toneCategory.categoryId);
                    toneCategory.help = getCategoryHelp(toneCategory.categoryId);
                    // order the tones by score
                    toneCategory.tones = _.orderBy(toneCategory.tones, ['score'], ['desc']);
                    // cycle through each tone and add helper text and class
                    _.forEach(toneCategory.tones, function (tone, index) {
                        tone.formattedScore = getFormattedScore(tone.score);
                        tone.cssClass = getToneCss(tone.toneId, index);
                    });
                    // set the tone explanation for the highest scoring tone
                    toneCategory.toneExplanations = [
                        {
                            name: toneCategory.tones[0].toneName,
                            description: getToneDescription(toneCategory.tones[0].toneId),
                        },
                    ];
                    // if the next highest tone score is less than 10 from the highest
                    // we will add it to the explanations
                    if (_.inRange(toneCategory.tones[1].formattedScore, toneCategory.tones[0].formattedScore - 10, toneCategory.tones[0].formattedScore)) {
                        toneCategory.toneExplanations.push({
                            name: toneCategory.tones[1].toneName,
                            description: getToneDescription(toneCategory.tones[1].toneId),
                        });
                    }
                });
                return results;
            }, 
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            function analyzeMessageError(response) {
                console.error('GET TONE ANALYSIS ERROR', response);
            });
        }
        /**
         * @function analyzeMessage
         * @param message {object} The text/html to analyze
         * @returns {object} - promise
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'message' implicitly has an 'any' type.
        function analyzeMessage(message) {
            if (!message || !message.messageBody || !message.messageBody.length) {
                return ETWServicesUtils.reject('There was no text to analyze.');
            }
            else {
                return $http({
                    errorMessage: 'The Tone Analysis could not be retrieved.',
                    method: 'POST',
                    url: analyzeServiceUrl,
                    data: message,
                });
            }
        }
        /**
         * @function getCategoryTitle
         * @param  {string} categoryId the tone category id
         * @return {string}            ETW version title of the tone category
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'categoryId' implicitly has an 'any' typ... Remove this comment to see the full error message
        function getCategoryTitle(categoryId) {
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            return categoryHelper[_.camelCase(categoryId)].title;
        }
        /**
         * @function getCategoryHelp
         * @param  {string} categoryId the tone category id
         * @return {string}            The small gray text under the tone category's tones
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'categoryId' implicitly has an 'any' typ... Remove this comment to see the full error message
        function getCategoryHelp(categoryId) {
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            return categoryHelper[_.camelCase(categoryId)].helper;
        }
        /**
         * @function getToneCss
         * @param  {string} toneId the id of the tone
         * @param  {number} index  tones are ordered by score, this is the index of the tone in the order
         * @return {string}        the css class for the tone
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'toneId' implicitly has an 'any' type.
        function getToneCss(toneId, index) {
            return _.includes(['anger', 'disgust', 'fear', 'joy', 'sadness'], toneId)
                ? 'tone-' + toneId
                : 'tone-level-' + index || 0;
        }
        /**
         * @function getFormattedScore
         * @param  {number} score the given score from Watson
         * @return {number}       formatted score. ex: 42
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'score' implicitly has an 'any' type.
        function getFormattedScore(score) {
            return Math.round(score * 100);
        }
        /**
         * @function getToneDescription
         * @param  {string} toneId the id of the tone
         * @return {string}        the helper text for the give tone, used for explanation of the top scoring tones
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'toneId' implicitly has an 'any' type.
        function getToneDescription(toneId) {
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            return tonesHelper[toneId].description;
        }
    }
})();

(function () {
    angular
        .module('ETWServices')
        .factory('AttributeValuesService', [
        '$http',
        'AttributesService',
        'ETWServicesUtils',
        'AuthenticationService',
        AttributeValuesServiceFactory,
    ]);
    function AttributeValuesServiceFactory($http, AttributesService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
    ETWServicesUtils, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AttributesService' implicitly has an 'a... Remove this comment to see the full error message
    AuthenticationService) {
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'AuthenticationService' implicitly has a... Remove this comment to see the full error message
         * @property attributesServiceUrlForClient
         * @type {string}
         * @private
         */
        var attributesServiceUrlForClient = ETWServicesUtils.getEndpointUrlForClient('ATTRIBUTES', AuthenticationService.getAccount().clientId);
        var service = {
            assignTo: assignTo,
            destroy: destroy,
            destroyMultiple: destroyMultiple,
            getByAttributeId: getByAttributeId,
            getById: getById,
            newSet: newSet,
            reject: ETWServicesUtils.reject,
            removeSet: removeSet,
            resolve: ETWServicesUtils.resolve,
            save: save,
            subscribe: ETWServicesUtils.subscribe('AttributeValuesService'),
            unassignFrom: unassignFrom,
            unsubscribe: ETWServicesUtils.unsubscribe('AttributeValuesService'),
        };
        /**
         * @property serviceUrl
         * @type {string}
         * @private
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('ATTRIBUTE_VALUES');
        /**
         * @property serviceUrl
         * @type {string}
         * @private
         */
        var setsServiceUrl = ETWServicesUtils.getEndpointUrl('ATTRIBUTE_SETS');
        return service;
        /**
         * @method assignTo
         * @param type {string} - Model type to assign to
         * @param {...*} n - other parameters specific to the type
         * @returns {object} - promise
         * Used to assign attribute values to various models
         * Usage:
         *   AttributeValuesService.assignTo('PermissionGroupPermission', 1, 2, 3)
         */
        function assignTo(type, n) {
            var args = _.tail(arguments), promise;
            switch (type) {
                case 'PermissionGroupPermission':
                    promise = assignToPermissionGroupPermission.apply(service, args);
                    break;
                case 'Person':
                    promise = assignToPerson.apply(service, args);
                    break;
            }
            return promise;
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
         * @function assignToPermissionGroupPermission
         * @param groupId {number}
         * @param permId {number}
         * @param valueId {number}
         * @returns {object} - promise
         * @private
// @ts-ignore ts-migrate(2345) FIXME: Argument of type 'any[]' is not assignable to para... Remove this comment to see the full error message
         * Used to assign an AttributeValue to a PermissionGroup Permission.
         */
        function assignToPermissionGroupPermission(groupId, permId, valueId) {
            return $http({
                // @ts-ignore ts-migrate(2345) FIXME: Argument of type 'any[]' is not assignable to para... Remove this comment to see the full error message
                errorMessage: 'Could not assign the attribute value to this permission.',
                method: 'POST',
                data: { empty: 'post' },
                url: serviceUrl +
                    '/' +
                    ETWServicesUtils.asId(valueId) +
                    '/groups/' +
                    ETWServicesUtils.asId(groupId) +
                    '/permissions/' +
                    ETWServicesUtils.asId(permId),
            }).finally(function () {
                try {
                    ETWServicesUtils.notify('AttributeValuesService');
                }
                catch (e) {
                    console.error(e);
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'groupId' implicitly has an 'any' type.
                }
            });
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'permId' implicitly has an 'any' type.
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'valueId' implicitly has an 'any' type.
        /**
         * @function assignToPerson
         * @param personId {number}
         * @param attributeValueId {number}
         * @param setId {number}
         * @returns {object} - promise
         * @private
         * Used to assign an AttributeValue to a person.
         */
        function assignToPerson(personId, attributeValueId, setId) {
            var url = '';
            if (setId) {
                //if applying to an existing set
                url =
                    serviceUrl +
                        '/' +
                        ETWServicesUtils.asId(attributeValueId) +
                        '/attributesets/' +
                        ETWServicesUtils.asId(setId) +
                        '/users/' +
                        ETWServicesUtils.asId(personId);
            }
            else {
                //if there's not a set to attach to
                url =
                    serviceUrl +
                        '/' +
                        ETWServicesUtils.asId(attributeValueId) +
                        '/users/' +
                        ETWServicesUtils.asId(personId);
            }
            return $http({
                errorMessage: 'Could not assign the attribute value to this person.',
                method: 'POST',
                data: { empty: 'post' },
                url: url,
            }).finally(function () {
                try {
                    ETWServicesUtils.notify('AttributeValuesService');
                }
                catch (e) {
                    console.error(e);
                }
            });
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'personId' implicitly has an 'any' type.
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'attributeValueId' implicitly has an 'an... Remove this comment to see the full error message
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'setId' implicitly has an 'any' type.
         * @method destory
         * @param id {number}
         * @param [reassignToId] {number}
         * @returns {Object}
         */
        function destroy(id, reassignToId) {
            return destroyMultiple([id], reassignToId);
        }
        /**
         * @method destroyMultiple
         * @param ids {Array}
         * @param [reassignToId] {number}
         * @returns {object} - promise
         * API response is just a header
         * attributeValueIds is a comma delimited list of ids.
         */
        function destroyMultiple(ids, reassignToId) {
            var params = {};
            // @ts-ignore
            params.attributeValueIds = _.map(ids, ETWServicesUtils.asId).join(',');
            if (reassignToId) {
                // @ts-ignore
                params.reassignAttributeValueId = reassignToId;
            }
            return $http({
                errorMessage: 'This attribute value could not be removed.',
                method: 'DELETE',
                params: params,
                url: serviceUrl,
            }).finally(function () {
                try {
                    // Clear Attribute cache (separate service)
                    AttributesService.getAll.clear();
                    ETWServicesUtils.notify('AttributeValuesService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method getByAttributeId
         * @param attributeId {string}
         * @param [isCountPeople] {boolean} - optional; set true to include counts of people with the AttributeValue
         * @returns {object} - promise, object
         * Get a values for an attribute
         */
        function getByAttributeId(attributeId, isCountPeople) {
            var params = {};
            if (isCountPeople) {
                // @ts-ignore
                params.showemployeecount = true;
            }
            return $http({
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
                errorMessage: 'There was a problem retrieving the values for this attribute.',
                method: 'GET',
                params: params,
                url: attributesServiceUrlForClient +
                    '/' +
                    ETWServicesUtils.asId(attributeId) +
                    '/attributevalues',
            });
        }
        /**
         * @method getById
         * @param attributeValueId {number}
         * @returns {*}
         */
        function getById(attributeValueId) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ids' implicitly has an 'any' type.
            var promise = $http({
                errorMessage: 'This attribute value could not be retrieved.',
                method: 'GET',
                url: serviceUrl + '/' + ETWServicesUtils.asId(attributeValueId),
            });
            return promise.then(function (response) {
                // TODO: Actually, directive will already have a list of all attributes. Can map it there.
                if (response.data && response.data.attributeId) {
                    return AttributesService.getById(response.data.attributeId).then(function (attributeResponse) {
                        response.data.attribute = attributeResponse.data;
                        return response;
                    });
                }
                else {
                    return response;
                }
            });
        }
        /**
         * @method newSet
         * @param resourceId {number}
         * @returns {object} - promise
         * Creates a new attribute set on the resource.
         */
        function newSet(resourceId) {
            return $http({
                errorMessage: 'Could not create the attribute set.',
                method: 'POST',
                data: { empty: 'post' },
                url: setsServiceUrl + '/users/' + ETWServicesUtils.asId(resourceId),
            }).finally(function () {
                try {
                    ETWServicesUtils.notify('AttributeValuesService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'attributeId' implicitly has an 'any' ty... Remove this comment to see the full error message
         * @method removeSet
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'isCountPeople' implicitly has an 'any' ... Remove this comment to see the full error message
         * @param resourceId {number}
         * @param setId {number}
         * @returns {object}
         * Removes an attribute set from the resource.
         */
        function removeSet(resourceId, setId) {
            return $http({
                errorMessage: 'Could not remove the attribute set.',
                method: 'DELETE',
                data: { empty: 'post' },
                url: setsServiceUrl +
                    '/' +
                    ETWServicesUtils.asId(setId) +
                    '/users/' +
                    ETWServicesUtils.asId(resourceId),
            }).finally(function () {
                try {
                    ETWServicesUtils.notify('AttributeValuesService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method save
         * @param attributeValue {object}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'attributeValueId' implicitly has an 'an... Remove this comment to see the full error message
         * @param [changedProperties] {Array} - list of property names that have changed
         * @returns {object} - promise, object
         */
        function save(attributeValue, changedProperties) {
            var options = {
                data: attributeValue,
                idName: 'id',
                properties: changedProperties,
                url: serviceUrl,
            };
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            if (angular.isDefined(attributeValue.id)) {
                options.url = serviceUrl + '/' + ETWServicesUtils.asId(attributeValue.id);
            }
            // Save value, clear Attribute cache (note: this is calling a separate service)
            return ETWServicesUtils.save(options, undefined, 'AttributeValuesService', 
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'attributeResponse' implicitly has an 'a... Remove this comment to see the full error message
            AttributesService.getAll.clear);
        }
        /**
         * @method unassignFrom
         * @param type {string}
         * @param {...*} n - other parameters specific to the type
         * Used to remove an AttributeValue from something.
         * See assignTo()
         */
        function unassignFrom(type, n) {
            var args = _.tail(arguments);
            switch (type) {
                case 'PermissionGroupPermission':
                    unassignFromPermissionGroupPermission.apply(service, args);
                    break;
                case 'Person':
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'resourceId' implicitly has an 'any' typ... Remove this comment to see the full error message
                    unassignFromPerson.apply(service, args);
                    break;
            }
        }
        /**
         * @function unassignFromPermissionGroupPermission
         * @param groupId {number}
         * @param permId {number}
         * @param valueId {number}
         * @returns {object} - promise
         * @private
         * Remove an AttributeValue from a PermissionGroup Permission.
         */
        function unassignFromPermissionGroupPermission(groupId, permId, valueId) {
            return $http({
                errorMessage: 'Could not remove the attribute value from this permission.',
                method: 'DELETE',
                url: serviceUrl +
                    '/' +
                    ETWServicesUtils.asId(valueId) +
                    '/groups/' +
                    ETWServicesUtils.asId(groupId) +
                    '/permissions/' +
                    ETWServicesUtils.asId(permId),
            }).finally(function () {
                try {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'resourceId' implicitly has an 'any' typ... Remove this comment to see the full error message
                    ETWServicesUtils.notify('AttributeValuesService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @function unassignFromPerson
         * @param personId {number}
         * @param attributeValueId {number}
         * @param setId {number}
         * @returns {object} - promise
         * @private
         * Remove an AttributeValue from a Person.
         */
        function unassignFromPerson(personId, attributeValueId, setId) {
            //config
            var url = '';
            //if applying to an existing set
            if (setId) {
                url =
                    serviceUrl +
                        '/' +
                        ETWServicesUtils.asId(attributeValueId) +
                        '/attributesets/' +
                        ETWServicesUtils.asId(setId) +
                        '/users/' +
                        ETWServicesUtils.asId(personId);
            }
            //if there's not a set to attach to
            else {
                url =
                    serviceUrl +
                        '/' +
                        ETWServicesUtils.asId(attributeValueId) +
                        '/users/' +
                        ETWServicesUtils.asId(personId);
            }
            return $http({
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'attributeValue' implicitly has an 'any'... Remove this comment to see the full error message
                errorMessage: 'Could not remove the attribute value from this person.',
                method: 'DELETE',
                url: url,
            }).finally(function () {
                try {
                    ETWServicesUtils.notify('AttributeValuesService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.

(function () {
    angular
        .module('ETWServices')
        .factory('AttributesService', [
        '$cacheFactory',
        '$http',
        'ETWServicesUtils',
        'AuthenticationService',
        AttributesServiceFactory,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$cacheFactory' implicitly has an 'any' ... Remove this comment to see the full error message
    function AttributesServiceFactory($cacheFactory, $http, ETWServicesUtils, AuthenticationService) {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ETWServicesUtils' implicitly has an 'an... Remove this comment to see the full error message
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'AuthenticationService' implicitly has a... Remove this comment to see the full error message
         * @property modelDefinition
         * @type {Object}
         * Configuration object used by ETWServicesUtils for formatting or excluding certain columns.
         * isChanged, isError, isTemporary are used to manage simultaneous asynchronous updates to the attribute list.
         */
        var modelDefinition = {
            columns: {
                _isChanged: 'excluded',
                _isError: 'excluded',
                _isTemporary: 'excluded',
            },
        };
        var service = {
            all: ETWServicesUtils.all,
            destroy: destroy,
            getAll: getAll,
            getById: getById,
            reject: ETWServicesUtils.reject,
            resolve: ETWServicesUtils.resolve,
            save: save,
            subscribe: ETWServicesUtils.subscribe('AttributesService'),
            unsubscribeAll: ETWServicesUtils.unsubscribeAll('AttributesService'),
        };
        /**
         * @property serviceUrlForClient
         * @type {string}
         * @private
         */
        var serviceUrlForClient = ETWServicesUtils.getEndpointUrlForClient('ATTRIBUTES', AuthenticationService.getAccount().clientId);
        /**
         * @method getAll.clear
         * @returns {object}
         * Clears the cache for the getAll() results.
         * Call this in any methods that change the results of getAll.
         *
         * Usage:
         *    save().then(getAll.clear);
         * or:
         *    getAll.clear();
         */
        getAll.clear = function () {
            $cacheFactory.get('$http').remove(serviceUrlForClient);
            $cacheFactory.get('$http').remove(serviceUrlForClient + '?withValues=true');
        };
        /**
         * @method getById.clear
         * @param id {number}
         */
        getById.clear = function (id) {
            $cacheFactory.get('$http').remove(serviceUrlForClient + '/' + ETWServicesUtils.asId(id));
            getAll.clear();
        };
        return service;
        /**
         * @method destroy
         * @param id {number}
         * @returns {object} - promise
         */
        function destroy(id) {
            return $http({
                errorMessage: false,
                method: 'DELETE',
                url: serviceUrlForClient + '/' + ETWServicesUtils.asId(id),
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
            })
                .catch(function (response) {
                //if the service returned an error
                //decide which message to display to the user
                return serviceExceptionHandler(response, 'This attribute could not be removed.');
            })
                .finally(function () {
                try {
                    getAll.clear();
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
                    ETWServicesUtils.notify('AttributesService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method getAll
         * @param [isIncludeValues] {boolean=false} - optional, if values array should be included
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
         * @returns {object} - promise, array
         * Get all attributes
         */
        function getAll(isIncludeValues) {
            var params = {};
            if (isIncludeValues) {
                // Note: If you change parameters, you have to change the clear() function.
                // @ts-ignore
                params.withValues = true;
            }
            return $http({
                cache: true,
                method: 'GET',
                params: params,
                url: serviceUrlForClient,
            });
        }
        /**
         * @method getById
         * @param id {number}
         * @returns {object} - promise, object
         */
        function getById(id) {
            return $http({
                cache: true,
                errorMessage: 'There was a problem retrieving this attribute.',
                method: 'GET',
                url: serviceUrlForClient + '/' + ETWServicesUtils.asId(id),
            });
        }
        /**
         * @method save
         * @param attribute {object}
         * @param [changedProperties] {array}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'isIncludeValues' implicitly has an 'any... Remove this comment to see the full error message
         * @returns {object}
         */
        function save(attribute, changedProperties) {
            var options = {
                data: attribute,
                errorMessage: false,
                idName: 'id',
                properties: changedProperties,
                url: serviceUrlForClient,
            }, promise;
            if (attribute.id) {
                // Attribute exists
                options.url = serviceUrlForClient + '/' + ETWServicesUtils.asId(attribute.id);
            }
            if (!attribute.id && !attribute.title) {
                // Attribute doesn't exist; title is empty
                // Since title must be unique, compare it with existing columnName from getAll()
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
                promise = ETWServicesUtils.generateUniqueValueForColumn(getAll, 'title', 'Untitled Attribute').then(function (uniqueValue) {
                    // Then save resulting uniqueValue as the new columnName
                    options.data.title = uniqueValue;
                    return ETWServicesUtils.save(options, modelDefinition, 'AttributesService', function () {
                        getById.clear(attribute.id);
                    });
                });
            }
            else {
                // Attribute exists OR title not empty
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'attribute' implicitly has an 'any' type... Remove this comment to see the full error message
                promise = ETWServicesUtils.save(options, modelDefinition, 'AttributesService', function () {
                    if (attribute.id) {
                        getById.clear(attribute.id);
                    }
                    else {
                        getAll.clear();
                    }
                });
            }
            // return promise with catch
            return promise.catch(function (response) {
                return serviceExceptionHandler(response, 'This attribute could not be saved.');
            });
        }
        /**
         * @function serviceExceptionHandler
         * @param response {object}
         * @param defaultResponse {string}
         * @returns {object} - promise. Passes along another rejection with the response so the controller can act on it.
         * @private
         * When the API returns an error message, display to the user and pray that it's understandable by humans.
         * Note: ATM the errors for this API are non-standard
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'uniqueValue' implicitly has an 'any' ty... Remove this comment to see the full error message
        function serviceExceptionHandler(response, defaultResponse) {
            var message = angular.isString(response.data.error) ? response.data.error : defaultResponse;
            ETWServicesUtils.notifyErrorMessage(message);
            return ETWServicesUtils.reject(response);
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.

(function () {
    /**
     * @service AuthenticationService
     */
    angular
        .module('ETWServices')
        .factory('AuthenticationService', [
        '$http',
        '$location',
        '$rootScope',
        '$state',
        '$timeout',
        '$window',
        'AUTH_LOCATION',
        'authService',
        'ETWServicesUtils',
        'PeopleService',
        'PRODUCT_URLS',
        AuthenticationService,
    ]);
    function AuthenticationService($http, $location, $rootScope, $state, $timeout, $window, AUTH_LOCATION, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
    authService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$rootScope' implicitly has an 'any' typ... Remove this comment to see the full error message
    ETWServicesUtils, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$timeout' implicitly has an 'any' type.
    PeopleService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AUTH_LOCATION' implicitly has an 'any' ... Remove this comment to see the full error message
    PRODUCT_URLS) {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'authService' implicitly has an 'any' ty... Remove this comment to see the full error message
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'ETWServicesUtils' implicitly has an 'an... Remove this comment to see the full error message
         * @property serviceUrl
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'PeopleService' implicitly has an 'any' ... Remove this comment to see the full error message
         * @type {string}
         * @private
         */
        var authServiceUrl = ETWServicesUtils.getEndpointUrl('AUTHORIZE');
        /**
         * @property personPromise
         * @type object
         * Promise to be returned when getUserPerson() is called.
         */
        var personPromise;
        /**
         * @property resetPasswordServiceUrl
         * @type {string}
         */
        var resetPasswordServiceUrl = ETWServicesUtils.getEndpointUrl('RESET_PASSWORD');
        // @ts-ignore ts-migrate(7034)
        /**
         * @property resetPasswordServiceUrl
         * @type {string}
         */
        var setPasswordServiceUrl = ETWServicesUtils.getEndpointUrl('SET_PASSWORD');
        var service = {
            authenticate: authenticate,
            authenticateImpersonation: authenticateImpersonation,
            authenticateSSO: authenticateSSO,
            canImpersonate: debounce(canImpersonate),
            canSwitchClient: debounce(canSwitchClient),
            encodeReferrer: encodeReferrer,
            decodeReferrer: decodeReferrer,
            defer: ETWServicesUtils.defer,
            checkToken: checkToken,
            getAccount: getAccount,
            getUserAuthKey: getUserAuthKey,
            getUserPerson: getUserPerson,
            hasModule: hasModule,
            hasPermission: hasPermission,
            hasScope: hasScope,
            init: init,
            isAuthenticated: debounce(isAuthenticated),
            isImpersonating: isImpersonating,
            loadAccessToken: loadAccessToken,
            logout: debounce(logout),
            passwordReset: passwordReset,
            refresh: debounce(refresh),
            reject: ETWServicesUtils.reject,
            resolve: ETWServicesUtils.resolve,
            setAuthCookie: setAuthCookie,
            setPassword: setPassword,
        };
        /**
         * @property trackingToken
         * @type {string}
         */
        var trackingToken = 'window loading';
        /**
         * @property token
         * @type {object}
         * Decoded token object
         */
        var token = loadAccessToken();
        // gobal method for debugging JWT
        $window.etwJwt = function () {
            console.log(JSON.parse($window.atob($window.localStorage.getItem('user.access_token').split('.')[1])));
        };
        //send back anything publicly accessible
        return service;
        /**
         * @method authenticate
         * @param username {string}
         * @param password {string}
         * @param company {string} - optional, companyShortName
         * @param subdomain {string} - optional, default is 'app'
         * @returns {object} - promise
         */
        function authenticate(username, password, company, subdomain) {
            var headers = {
                Authorization: 'Basic ' + window.btoa(username + ':' + password),
                'Content-Type': 'application/json; charset=utf-8',
                'no-auth-token': true
            }, promise;
            if (subdomain && subdomain !== 'app') {
                // Non-default subdomain first
                // @ts-ignore
                headers.ETWSubdomain = subdomain;
            }
            else if (company) {
                // Company second (company can come from localStorage)
                // @ts-ignore
                headers.ETWClientId = company;
            }
            else {
                // Default to app subdomain
                // @ts-ignore
                headers.ETWSubdomain = 'app';
            }
            //attempt to log the user in
            promise = $http({
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'username' implicitly has an 'any' type.
                data: {},
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'password' implicitly has an 'any' type.
                ignoreAuthModule: true,
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'subdomain' implicitly has an 'any' type... Remove this comment to see the full error message
                errorMessage: false,
                method: 'POST',
                url: authServiceUrl + '/login',
                headers: headers,
            }).then(function authenticateUserSuccess(response) {
                if (response.data && response.data.access_token) {
                    //save the tokens
                    setTokens(response.data.access_token, response.data.refresh_token);
                }
                //tell the auth handler that the user has logged in
                authService.loginConfirmed();
                return token;
            });
            // Log error. Do not chain this promise.
            promise.catch(function authenticateUserError(response) {
                console.error('USER AUTH ERROR', response);
            });
            //return the promise to whoever is calling
            return promise;
        }
        /**
         * @method authenticateSSO
         * @param ssoAuthToken {string}
         * @param ssoRefreshToken {string}
         * Performing an SSO based login from auth and refresh tokens.
         */
        function authenticateSSO(ssoAuthToken, ssoRefreshToken) {
            // We need to set the tokens we got from the saml redirect
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            setTokens(ssoAuthToken, ssoRefreshToken);
            // Tell the auth handler that the user has logged in
            authService.loginConfirmed();
            $state.go('app.stream.index');
        }
        /**
         *
         * @param authToken
         * @param refreshToken
         */
        // @ts-ignore ts-migrate(7006)
        function authenticateImpersonation(authToken, refreshToken) {
            setTokens(authToken, refreshToken);
            $window.location.reload();
        }
        // @ts-ignore ts-migrate(7006)
        function canImpersonate() {
            // @ts-ignore ts-migrate(7006)
            return angular.isDefined(token.adminUser);
        }
        // @ts-ignore ts-migrate(7006)
        function canSwitchClient() {
            return $http({
                errorMessage: false,
                method: 'GET',
                url: authServiceUrl + '/v1/can-switch-client',
            });
        }
        /**
         * @method decodeReferrer
         * @param from {string} base64-encoded ascii
         * @returns {object}
         * From has 3 parts: product, userId, path.
         */
        function decodeReferrer(from) {
            var parts = $window.atob(from).split('%%'), valid = parts.length === 3;
            return {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                product: (valid && parts[0]) || '',
                userId: (valid && parts[1] && Number(parts[1])) || 0,
                path: (valid && parts[2] && parts[2].replace(/^\/#!/, '')) || '',
            };
        }
        /**
         * @function encodeReferrer
         * @returns {string}
         */
        function encodeReferrer() {
            var product = 'hermes', 
            // @ts-ignore
            userId = token.userId || 0, url = $location.url();
            if (url == '/home' || url.indexOf('/signin') === 0) {
                url = '';
            }
            else {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ssoAuthToken' implicitly has an 'any' t... Remove this comment to see the full error message
                url = '/#!' + url;
            }
            return $window.btoa([product, userId, url].join('%%'));
        }
        /**
         * @method fetchTokens
         * @returns {object} - promise
         */
        function fetchTokens() {
            var subdomain = $window.location.hostname.split('.')[0];
            if (_.includes(['localhost', 'align', 'app'], subdomain)) {
                subdomain = 'default';
            }
            return $http({
                errorMessage: false,
                ignoreAuthModule: true,
                method: 'GET',
                url: authServiceUrl + '/tokens?subdomain=' + subdomain,
            }).then(function (response) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'from' implicitly has an 'any' type.
                setTokens(response.data.accessToken.substr(7), response.data.refreshToken);
                document.cookie = 'Authorization=;expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=.etw.com';
            }, angular.noop);
        }
        /**
         * @method getAccount
         * @returns {object}
         * Used to get contents of the JWT
         */
        function getAccount() {
            return token;
        }
        /**
         * @method getUserPerson
         * @returns {object} - promise
         * Get the corresponding Person record for the User.
         * The promise is kept in memory so the Person only has to be fetched once.
         */
        function getUserPerson() {
            if (!personPromise) {
                if (!token) {
                    loadAccessToken();
                }
                if (token) {
                    // @ts-ignore
                    personPromise = PeopleService.getById(token.userId).then(function getUserPersonSuccess(response) {
                        return response.data;
                    }, function getUserPersonError(response) {
                        console.error('GET USER PERSON ERROR', response);
                        if (response && response.status && response.status > 400 && response.status < 500) {
                            // If 401, 403, 404, the user should sign out, in
                            // If 500+, blame the server and allow to reload the browser.
                            service.logout();
                        }
                        return ETWServicesUtils.reject(response);
                    });
                }
                else {
                    // Not authenticated
                    personPromise = ETWServicesUtils.reject('AuthenticationService.getUserPerson(): Neither person nor token exist.');
                }
            }
            return personPromise;
        }
        /**
         * @function goToExternalSignIn
         * @param signInParam {object}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
         * Navigates the user to the separate auth app.
         */
        function goToExternalSignIn(signInParam) {
            $window.location.href = PRODUCT_URLS.auth + '?signout&from=' + signInParam.from;
        }
        /**
         * @function goToInternalSignIn
         * Navigates the user to the align (legacy) sign in screen
         */
        function goToInternalSignIn(signInParam) {
            $state.go('signin', signInParam, { notify: false }).then(function onStateChangeSuccess() {
                // Wait till after digest cycle for window.location to know where it is.
                $timeout(function () {
                    // Reload the app to clear all memory.
                    $window.location.reload();
                });
            });
        }
        /**
         *
         */
        function getUserAuthKey() {
            var promise;
            if (isAuthenticated()) {
                // UI *must* wait for this call to complete because the response clears the cookie version of the JWT
                promise = $http({
                    errorMessage: false,
                    url: authServiceUrl + '/transfer'
                })
                    .then(function (resp) {
                    console.log(resp);
                    return resp;
                });
            }
            else {
                promise = ETWServicesUtils.resolve();
            }
            return promise;
        }
        /**
// @ts-ignore ts-migrate(7005) FIXME: Variable 'personPromise' implicitly has an 'any' t... Remove this comment to see the full error message
         * @method hasPermission
         * @param permission {string}
         * @returns {boolean}
         * Check if a string label exists in the token authorities array.
         */
        function hasPermission(permission) {
            // @ts-ignore
            return angular.isArray(token.authorities) && token.authorities.indexOf(permission) !== -1;
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
         * @function hasHermesPermissions
         * @private
         * @returns {boolean}
         * 'VIEW_ADMIN_*' permissions always come along with base 'VIEW_ADMIN'.
         * To view Hermes the user must have 'VIEW_ADMIN' and _any_ other
         * 'VIEW_ADMIN_*' permission *besides* 'VIEW_ADMIN_PEOPLE'.
         */
        function hasHermesPermissions() {
            // @ts-ignore
            var adminPerms = _.filter(token.authorities, function (text) {
                return _.startsWith(text, 'VIEW_ADMIN_');
            });
            _.pull(adminPerms, 'VIEW_ADMIN_PEOPLE');
            return hasPermission('VIEW_ADMIN') && !!adminPerms.length;
        }
        /**
         * @method hasScope
         * @param {string} scope
         * @returns {boolean}
         */
        function hasScope(scope) {
            if (scope == 'hermes') {
                return hasHermesPermissions();
            }
            // @ts-ignore
            return _.includes(token.scope, scope);
        }
        /**
// @ts-ignore ts-migrate(7005) FIXME: Variable 'personPromise' implicitly has an 'any' t... Remove this comment to see the full error message
         * @method hasModule
         * @param module {string}
         * @returns {boolean}
         * Check for a feature in the JWT's modules collection.
         * Cf. AccountSettingsService.get()
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'signInParam' implicitly has an 'any' ty... Remove this comment to see the full error message
         * Note: Only used to override CLIENT_SETTINGS in routes module.
         * DO NOT call this method elsewhere in the app; use CLIENT_SETTINGS.
         * JWT is always loaded first; CLIENT_SETTINGS might not be loaded yet.
         */
        function hasModule(module) {
            // @ts-ignore
            return token.modules && !!_.find(token.modules, { feature: module });
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'signInParam' implicitly has an 'any' ty... Remove this comment to see the full error message
         * @method init
         */
        function init() {
            // @ts-ignore
            if (!init.initialized) {
                // @ts-ignore
                init.initialized = fetchTokens();
                $window.addEventListener('focus', windowFocusHandler, true);
                $window.addEventListener('blur', windowBlurHandler, true);
            }
            // @ts-ignore
            return init.initialized;
        }
        /**
         *
         */
        function isImpersonating() {
            // @ts-ignore
            if (angular.isArray(token.authorities)) {
                // @ts-ignore
                var idxUser = _.findIndex(token.authorities, function (a) {
                    // @ts-ignore
                    return a.startsWith('IMPERSONATION-');
                }, 0);
                // @ts-ignore
                var idxClient = _.findIndex(token.authorities, function (a) {
                    // @ts-ignore
                    return a.startsWith('CLIENT-IMPERSONATION-');
                }, 0);
                var response = {
                    user: -1,
                    client: -1,
                };
                if (idxUser >= 0) {
                    // @ts-ignore
                    var value = token.authorities[idxUser];
                    var parts = value.split('-');
                    response.user = parts.length == 2 ? parts[1] : -1;
                }
                if (idxClient >= 0) {
                    // @ts-ignore
                    var value = token.authorities[idxClient];
                    var parts = value.split('-');
                    response.client = parts.length == 3 ? parts[2] : -1;
                }
                return response;
            }
        }
        /**
         * @function isTokenValid
         * @private
         * @param {object} token
         * @returns {boolean}
         */
        function isTokenValid(token) {
            return token.exp * 1000 > +new Date();
        }
        /**
         * @method isAuthenticated
         * @returns {boolean}
         * Checks if the user has a token
         */
        function isAuthenticated() {
            var accessToken = loadAccessToken(), 
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'permission' implicitly has an 'any' typ... Remove this comment to see the full error message
            refreshToken = loadRefreshToken();
            if (accessToken && isTokenValid(accessToken)) {
                // @ts-ignore ts-migrate(2339) FIXME: Property 'authorities' does not exist on type 'str... Remove this comment to see the full error message
                return true;
            }
            return refreshToken && isTokenValid(refreshToken);
        }
        /**
         * @function checkToken
         * @params token {string}
         * @returns {string}
         * Checks if the token used to reset the user's password has expired.
         */
        function checkToken(token) {
            return $http({
                method: 'GET',
                url: authServiceUrl + '/reset-tokens/' + token,
            });
        }
        /**
         * @function debounce
         * @param func {Function}
         * @returns {Function}
         * @private
         */
        // @ts-ignore ts-migrate(2339) FIXME: Property 'authorities' does not exist on type 'str... Remove this comment to see the full error message
        function debounce(func) {
            return _.debounce(func, 1000, { leading: true, trailing: false });
        }
        /**
         * @function loadAccessToken
         * @private
         * loads and decodes an access token
         */
        function loadAccessToken() {
            //config
            var newToken = '', splitToken, tokenToParse;
            //check for authentication token in storage
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'scope' implicitly has an 'any' type.
            var access_token = $window.localStorage.getItem('user.access_token') || '';
            //if a token was set
            if (access_token) {
                //attempt parsing the token
                try {
                    // @ts-ignore ts-migrate(2339) FIXME: Property 'scope' does not exist on type 'string'.
                    //split apart the token
                    splitToken = access_token.split('.');
                    //get the only part of the access token we need
                    if (splitToken.length === 3) {
                        tokenToParse = splitToken[1];
                    }
                    //parse the token
                    newToken = JSON.parse($window.atob(tokenToParse));
                }
                catch (e) {
                    //throw an error
                    console.error('Invalid access token found. Resetting login.');
                    // Refresh and allow the user to login again
                    // If API somehow sets invalid token, this will be an endless loop.
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'module' implicitly has an 'any' type.
                    service.refresh();
                }
            }
            //send back the decoded token
            // @ts-ignore ts-migrate(2339) FIXME: Property 'modules' does not exist on type 'string'... Remove this comment to see the full error message
            return newToken;
        }
        /**
         * @function loadRefreshToken
         * @private
         */
        // @ts-ignore ts-migrate(7023) FIXME: 'init' implicitly has return type 'any' because it... Remove this comment to see the full error message
        function loadRefreshToken() {
            // @ts-ignore ts-migrate(2339) FIXME: Property 'initialized' does not exist on type '() ... Remove this comment to see the full error message
            var refreshToken = $window.localStorage.getItem('user.refresh_token');
            try {
                var splitToken = refreshToken.split('.');
                var decodedToken = $window.atob(splitToken[1]);
                return JSON.parse(decodedToken);
            }
            catch (e) {
                return '';
            }
        }
        /**
         * @method logout
// @ts-ignore ts-migrate(2339) FIXME: Property 'initialized' does not exist on type '() ... Remove this comment to see the full error message
         * @param [isRedirect] {boolean=true} - Should user be redirected to signin screen
         * @returns {object} - promise
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'token' implicitly has an 'any' type.
         * Call this method to force the session to end. If the session is just old, call service.refresh().
         * Note: DO NOT CALL DIRECTLY
         * This method redirects the user so should be debounced.
         *
         * Use service.logout()
         */
        function logout(isRedirect) {
            var promise, from = encodeReferrer(), signInParam = {};
            // If authenticated, tell the API to sign out
            if (isAuthenticated()) {
                // UI *must* wait for this call to complete because the response clears the cookie version of the JWT
                // Note: this promise might be rejected if the JWT has already expired
                promise = $http({
                    errorMessage: false,
                    url: authServiceUrl + '/logout',
                });
            }
            else {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'token' implicitly has an 'any' type.
                promise = ETWServicesUtils.resolve();
            }
            //clear out the token
            setTokens(null, null);
            //remove the kpi tab from local storage
            localStorage.removeItem("kpi-tab-open");
            //tell the auth handler that the user is no longer logged in
            authService.loginCancelled({}, { status: 401, statusText: 'User has signed out' });
            // isDirect is true if undefined
            if (angular.isUndefined(isRedirect) || isRedirect) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'func' implicitly has an 'any' type.
                // Redirect user to sign in (default behavior)
                // Set a 'from' parameter that has the current URL so the user can return after signin
                // Don't set it if just /, /home, or /signin*
                // Encode the UserID, so the redirect doesn't work on change user.
                if (from) {
                    // @ts-ignore
                    signInParam.from = from;
                }
                // Send the user back to the signin view. Don't notify because promise app will be reloaded
                // Don't redirect until the API call completes.
                // Redirect no matter what.
                promise = promise.finally(function () {
                    if (AUTH_LOCATION == 'internal') {
                        goToInternalSignIn(signInParam);
                    }
                    else if (AUTH_LOCATION !== 'karma') {
                        goToExternalSignIn(signInParam);
                    }
                });
            }
            //return the request's promise
            return promise;
        }
        /**
         * @method passwordReset
         * @param email {string}
         * @param clientId {number}
         * @returns {object} - promise
         */
        // @ts-ignore ts-migrate(7006)
        function passwordReset(email, clientId) {
            return $http({
                errorMessage: false,
                method: 'POST',
                url: resetPasswordServiceUrl,
                data: {
                    email: email,
                    clientId: clientId,
                },
            });
        }
        /**
         * @method refresh
         * @returns {object} - promise
         * When a token has expired, request a new one using the refresh token.
         * Note: DO NOT CALL DIRECTLY
         * This method reloads the browser.
         * Potentially multiple services could call this method at once, so should be debounced.
         *
         * Use service.refresh()
         */
        function refresh() {
            var request, refresh_token = $window.localStorage.getItem('user.refresh_token');
            if (!refresh_token) {
                request = service.logout(); //log the user out
            }
            else {
                //attempt to log the user in with the refresh token
                request = $http({
                    data: {
                        refresh_token: refresh_token,
                    },
                    errorMessage: false,
                    method: 'POST',
                    url: authServiceUrl + '/refresh',
                }).then(function refreshSuccess(response) {
                    //update the access token
                    setTokens(response.data.access_token, response.data.refresh_token);
                    trackingToken = JSON.stringify(token);
                    //tell the auth handler that the user has logged in again
                    authService.loginConfirmed();
                }, function refreshError() {
                    //notify the user they need to login again
                    $rootScope.$emit('notify', 'Your session has expired. Please login again.', 'info');
                    //log out the user
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'isRedirect' implicitly has an 'any' typ... Remove this comment to see the full error message
                    service.logout();
                });
            }
            return request || ETWServicesUtils.reject();
        }
        /**
         *
         */
        function setAuthCookie() {
            return $http({
                errorMessage: false,
                method: 'GET',
                url: authServiceUrl + '/set-auth-cookie',
            });
        }
        /**
         * @method setPassword
         * @param resetPasswordToken {string}
         * @param password {string}
         * @returns {object} - promise
         * Used for an un-authenticated user to submit a new password.
         */
        function setPassword(resetPasswordToken, password) {
            return $http({
                method: 'POST',
                url: setPasswordServiceUrl,
                data: {
                    password: password,
                    token: resetPasswordToken,
                },
            });
        }
        /**
         * @function setTokens
         * @param accessToken {string|null}
         * @param refreshToken {string|null}
         * @private
         * Set the private and persistent values for the access and refresh tokens.
         * Pass a null (or falsy) value to clear the tokens.
         */
        function setTokens(accessToken, refreshToken) {
            //if an access token was passed
            if (accessToken) {
                $window.localStorage.setItem('user.access_token', accessToken);
            }
            else {
                $window.localStorage.removeItem('user.access_token');
            }
            //if a refresh token was passed
            if (refreshToken) {
                $window.localStorage.setItem('user.refresh_token', refreshToken);
            }
            else {
                $window.localStorage.removeItem('user.refresh_token');
            }
            //if one of the tokens is being set
            if (accessToken || refreshToken) {
                // @ts-ignore ts-migrate(2339) FIXME: Property 'from' does not exist on type '{}'.
                //also track the login time (for initial login and token refreshes)
                $window.localStorage.setItem('user.last_login', new Date().getTime());
            }
            // Load the contents of the tokens into memory
            token = loadAccessToken();
            // Reset debounced function now that the value is different.
            service.isAuthenticated.cancel();
            // Tell listeners that the user has changed.
            $rootScope.$emit('user:change');
        }
        /**
         * @function windowBlurHandler
         * @private
         */
        function windowBlurHandler() {
            trackingToken = JSON.stringify(token);
        }
        /**
         * @function windowFocusHandler
         * @private
         * Pulls the latest token from localStorage and compares it to
         * latest in memory version.
         */
        function windowFocusHandler() {
            if (trackingToken === 'window loading') {
                return;
            }
            token = loadAccessToken();
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'email' implicitly has an 'any' type.
            var tokensMatch = JSON.stringify(token) === trackingToken;
            if (!tokensMatch) {
                //service.logout();
                console.log('... would have logged out...'); // zzmatt
            }
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.

(function () {
    var SIZES = [
        'sm',
        'sm2x',
        'sm3x',
        'sm4x',
        'md',
        'md2x',
        'md3x',
        'md4x',
        'lg',
        'lg2x',
        'lg3x',
        'lg4x',
        'orig',
    ];
    angular
        .module('ETWServices')
        .factory('AvatarsService', [
        '$http',
        'ETWServicesUtils',
        'IS_MOCKED',
        '$window',
        AvatarsServiceFactory,
    ]);
    function AvatarsServiceFactory($http, ETWServicesUtils, IS_MOCKED, $window) {
        //user config
        var cacheEnabled = true;
        //script config
        // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
        var avatarTimestamp = new Date().getTime(), 
        // @ts-ignore ts-migrate(7006) FIXME: Parameter '$window' implicitly has an 'any' type.
        isLoading = false, avatarCache = {};
        //public functions
        var service = {
            crop: crop,
            destroy: destroy,
            getDataUriForImageUrl: getDataUriForImageUrl,
            getLoading: getLoading,
            getUrlByUserId: getUrlByUserId,
            reject: ETWServicesUtils.reject,
            resolve: ETWServicesUtils.resolve,
            save: save,
            setLoading: setLoading,
            subscribe: ETWServicesUtils.subscribe('AvatarsService'),
            unsubscribeAll: ETWServicesUtils.unsubscribeAll('AvatarsService'),
        };
        /**
         * @property serviceUrl
         * @type {string}
         * Path to the root of the avatars API
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('AVATARS');
        //send back functions to play with
        return service;
        //////////////// FUNCTIONS ////////////////
        //refresh the avatars when it has been manipulated
        function refreshAvatar() {
            //get the current timestamp
            avatarTimestamp = new Date().getTime();
            //clear the avatar cache as references are invalid
            clearAvatarCache();
            //tell subscribers that there was an update
            ETWServicesUtils.notify('AvatarsService');
        }
        //set whether the avatar is loading or not
        function setLoading(newValue) {
            isLoading = newValue;
        }
        //get whether or not an avatar is loading
        function getLoading() {
            return isLoading;
        }
        /**
         * @method getDataUriForImageUrl
         * @param imageUrl
         * @returns {object} - promise, string
         * Takes a URL and loads it into an orphan image node.
         * Then extracts the DataURI and returns it as a string.
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'newValue' implicitly has an 'any' type.
         * from https://davidwalsh.name/convert-image-data-uri-javascript
         */
        function getDataUriForImageUrl(imageUrl) {
            var deferred = ETWServicesUtils.defer();
            var image = angular.element('<img>')[0];
            // @ts-ignore
            image.crossOrigin = 'use-credentials';
            //once the browser has loaded the image
            image.onload = function () {
                var canvas = angular.element('<canvas>')[0];
                // @ts-ignore
                canvas.width = this.naturalWidth;
                // @ts-ignore
                canvas.height = this.naturalHeight;
                // @ts-ignore
                canvas.getContext('2d').drawImage(this, 0, 0);
                //return the image
                // @ts-ignore
                deferred.resolve(canvas.toDataURL('image/png'));
            };
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'imageUrl' implicitly has an 'any' type.
            image.src = imageUrl;
            return deferred.promise;
        }
        //sends a request to the server to crop the users image
        function crop(personId, details) {
            return $http({
                errorMessage: 'Unable to crop avatar',
                method: 'POST',
                data: {
                    x: details.cropImageLeft,
                    y: details.cropImageTop,
                    width: details.cropImageWidth,
                    height: details.cropImageHeight,
                },
                url: serviceUrl + '/users/' + ETWServicesUtils.asId(personId) + '/crop',
            })
                .then(function () {
                //apply the new avatar
                refreshAvatar();
                //the new avatar has finished loading
                setLoading(false);
            })
                .finally(function () {
                try {
                    ETWServicesUtils.notify('AvatarsService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method getUrlByUserId
         * @param userId {number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'personId' implicitly has an 'any' type.
         * @param size {string}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'details' implicitly has an 'any' type.
         * @returns {string}
         */
        function getUrlByUserId(userId, size) {
            var url;
            var deferred = ETWServicesUtils.defer();
            if (!~SIZES.indexOf(size)) {
                throw new Error('Incorrect Avatar size:' + size);
            }
            if (IS_MOCKED) {
                if (!userId) {
                    url = '/images/_demo/avatars/placeholder-avatar.png';
                }
                else {
                    url =
                        '/images/_demo/avatars/' + ETWServicesUtils.asId((userId % 8) + 1) + '/original.png';
                }
            }
            else {
                url =
                    serviceUrl +
                        '/users/' +
                        ETWServicesUtils.asId(userId) +
                        '/' +
                        size +
                        '?v=' +
                        avatarTimestamp;
            }
            //if caching is enabled
            if (cacheEnabled) {
                //check cache for dataURI version of image
                if (!avatarCache[url]) {
                    //create a dataURI for this avatar
                    getDataUriForImageUrl(url).then(function (image) {
                        //send back the dataURI version
                        deferred.resolve(image);
                        //cache the dataURI version
                        cacheAvatar(url, image);
                    });
                }
                //if a cached imaged was found
                else {
                    //send back the dataURI version
                    deferred.resolve(avatarCache[url]);
                }
            }
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'userId' implicitly has an 'any' type.
            //if caching is disabled
            else {
                // @ts-ignore ts-migrate(7034) FIXME: Variable 'url' implicitly has type 'any' in some l... Remove this comment to see the full error message
                deferred.resolve(url);
            }
            //return the promise
            return deferred.promise;
        }
        //saves the dataURI version of a image URL
        function cacheAvatar(url, dataURI) {
            //inject the new avatar
            avatarCache[url] = dataURI;
        }
        //clear the avatar cache
        function clearAvatarCache() {
            //clear the local copy
            avatarCache = {};
        }
        /**
         * @method save
         * @param file {object}
         * @returns {object} - promise
         * Uploads a file
         */
        function save(file, userId) {
            //config
            var options = {
                data: {},
                errorMessage: 'The avatar could not be uploaded.',
                imagePropertyName: 'content',
                method: 'POST',
                url: serviceUrl + '/users/' + ETWServicesUtils.asId(userId),
            };
            //upload the file
            var request = ETWServicesUtils.upload(options, 'files', file);
            //trigger an update for the images on the page
            request.then(refreshAvatar);
            //send back the request's promise
            return request;
        }
        /**
         * @method destroy
// @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
         * @param id {number}
         * @returns {object} - promise
         */
        function destroy(id) {
            return $http({
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'image' implicitly has an 'any' type.
                errorMessage: 'Avatar could not be removed.',
                method: 'DELETE',
                url: serviceUrl + '/users/' + ETWServicesUtils.asId(id),
            })
                .then(refreshAvatar)
                .finally(function () {
                try {
                    // @ts-ignore ts-migrate(7005) FIXME: Variable 'url' implicitly has an 'any' type.
                    ETWServicesUtils.notify('AvatarsService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
    }
})();
// @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message

(function () {
    angular
        .module('ETWServices')
        .factory('Cache', ['$cacheFactory', '$http', 'ETWServicesUtils', CustomCacheFactory]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$cacheFactory' implicitly has an 'any' ... Remove this comment to see the full error message
    function CustomCacheFactory($cacheFactory, $http, ETWServicesUtils) {
        /**
         * @property attributesCache
         * @type {object}
         * Custom cache for attributes
         */
        var attributesCache = $cacheFactory('AttributesServiceCache');
        /**
         * @property originalCacheGetFunction
         * @type {Function}
         * Save the original $cacheFactory.Cache.put method so it can be extended
         */
        var originalCacheGetFunction = attributesCache.get;
        // Extend the put() function to disregard URL params
        // This allows all cached GET responses to be cleared without guessing all the
        // url parameter permutations.
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'key' implicitly has an 'any' type.
        attributesCache.get = function (key, value) {
            // disregard the querystring
            // arguments[0] = key.split('?')[0];
            originalCacheGetFunction.apply(attributesCache, arguments);
        };
        /**
         * @property originalCachePutFunction
         * @type {Function}
         * Save the original $cacheFactory.Cache.put method so it can be extended
         */
        var originalCachePutFunction = attributesCache.put;
        // Extend the put() function to disregard URL params
        // This allows all cached GET responses to be cleared without guessing all the
        // url parameter permutations.
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'key' implicitly has an 'any' type.
        attributesCache.put = function (key, value) {
            // disregard the querystring
            // arguments[0] = key.split('?')[0];
            originalCachePutFunction.apply(attributesCache, arguments);
        };
    }
})();

(function () {
    angular
        .module('ETWServices')
        .factory('ClientService', [
        '$cacheFactory',
        '$http',
        'ETWServicesUtils',
        ClientServiceFactory,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$cacheFactory' implicitly has an 'any' ... Remove this comment to see the full error message
    function ClientServiceFactory($cacheFactory, $http, ETWServicesUtils) {
        /**
         * @property modelDefinition
         * @type {object}
         */
        var modelDefinition = {};
        var service = {
            get: get,
            search: search,
        };
        /**
         * @property serviceUrl
         * @type {string}
         * Get the URL for account settings -> client controller -> user account service.
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('CLIENTS');
        /**
         * @function get.clear
         * @private
         * Clear the cache
         */
        get.clear = function () {
            $cacheFactory.get('$http').remove(serviceUrl);
        };
        return service;
        /**
         * @method get
         * @returns {object} - promise,
         * Fetches the account settings based upon the current users token
         * Settings accessible in the app via the CLIENT_SETTINGS value.
         * Note: This should only be called in a Run block in app.js
         */
        function get() {
            return $http({
                cache: true,
                method: 'GET',
                url: serviceUrl,
            });
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'attachment' implicitly has an 'any' typ... Remove this comment to see the full error message
        function search(client) {
            // Create object to combine filterParams, sortParams, paginationParams.
            // We wouldn't want to mutate filterParams since that could mess up the controller.
            var parameters = {}, promise;
            promise = $http({
                errorMessage: 'The clients could not be retrieved.',
                method: 'GET',
                params: parameters,
                url: serviceUrl + '/active-client-search?client=' + client,
            }).then(ETWServicesUtils.decodeResponse(modelDefinition), ETWServicesUtils.reject);
            return promise;
        }
    }
})();

(function () {
    var SIZES = [
        'sm',
        'sm2x',
        'sm3x',
        'sm4x',
        'md',
        'md2x',
        'md3x',
        'md4x',
        'lg',
        'lg2x',
        'lg3x',
        'lg4x',
        'orig',
    ];
    angular
        .module('ETWServices')
        .factory('LogoService', [
        '$http',
        'AuthenticationService',
        'ETWServicesUtils',
        'IS_MOCKED',
        '$window',
        LogoServiceFactory,
    ]);
    function LogoServiceFactory($http, AuthenticationService, ETWServicesUtils, IS_MOCKED, $window) {
        //user config
        var cacheEnabled = true;
        //script config
        // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
        var imageTimestamp = new Date().getTime(), 
        // @ts-ignore ts-migrate(7006) FIXME: Parameter '$window' implicitly has an 'any' type.
        isLoading = false, logoCache = {};
        //public functions
        var service = {
            crop: crop,
            destroy: destroy,
            getImageTimestamp: getImageTimestamp,
            getDataUriForImageUrl: getDataUriForImageUrl,
            getIsLoading: getIsLoading,
            getImageUrl: getImageUrl,
            save: save,
            setIsLoading: setIsLoading,
            subscribe: ETWServicesUtils.subscribe('LogoService'),
            unsubscribeAll: ETWServicesUtils.unsubscribeAll('LogoService'),
        };
        /**
         * @property serviceUrl
         * @type {string}
         * Path to the root of the avatars API
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('LOGOS');
        //send back functions to play with
        return service;
        //////////////// FUNCTIONS ////////////////
        //refresh the avatars when it has been manipulated
        function refreshImage() {
            //get the current timestamp
            imageTimestamp = new Date().getTime();
            //clear the avatar cache as references are invalid
            clearLogoCache();
            //let any subscibers know that the image has been refreshed
            ETWServicesUtils.notify('LogoService');
        }
        //hook for getting the current timestamp for an avatar
        function getImageTimestamp() {
            return imageTimestamp;
        }
        //set whether the avatar is loading or not
        function setIsLoading(newValue) {
            isLoading = newValue;
        }
        //get whether or not an avatar is loading
        function getIsLoading() {
            return isLoading;
        }
        /**
         * @method getDataUriForImageUrl
         * @param imageUrl
         * @returns {object} - promise, string
         * Takes a URL and loads it into an orphan image node.
         * Then extracts the DataURI and returns it as a string.
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'newValue' implicitly has an 'any' type.
         * from https://davidwalsh.name/convert-image-data-uri-javascript
         */
        function getDataUriForImageUrl(imageUrl) {
            var deferred = ETWServicesUtils.defer();
            var image = angular.element('<img>')[0];
            // @ts-ignore
            image.crossOrigin = 'use-credentials';
            //once the browser has loaded the image
            image.onload = function () {
                var canvas = angular.element('<canvas>')[0];
                // @ts-ignore
                canvas.width = this.naturalWidth;
                // @ts-ignore
                canvas.height = this.naturalHeight;
                // @ts-ignore
                canvas.getContext('2d').drawImage(this, 0, 0);
                //return the image
                // @ts-ignore
                deferred.resolve(canvas.toDataURL('image/png'));
            };
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'imageUrl' implicitly has an 'any' type.
            image.src = imageUrl;
            return deferred.promise;
        }
        //sends a request to the server to crop the users image
        function crop(details) {
            return $http({
                errorMessage: 'Unable to crop avatar',
                method: 'POST',
                data: {
                    x: details.cropImageLeft,
                    y: details.cropImageTop,
                    width: details.cropImageWidth,
                    height: details.cropImageHeight,
                },
                url: serviceUrl + '/crop',
            })
                .then(function () {
                //apply the new image
                refreshImage();
                //the new avatar has finished loading
                setIsLoading(false);
            })
                .finally(function () {
                try {
                    ETWServicesUtils.notify('LogoService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method getImageUrl
         * @param userId {number}
         * @param size {string}
         * @returns {string}
         */
        function getImageUrl(size) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'details' implicitly has an 'any' type.
            var url;
            var deferred = ETWServicesUtils.defer();
            if (!~SIZES.indexOf(size)) {
                throw new Error('Incorrect Logo size:' + size);
            }
            if (IS_MOCKED) {
                //TODO setup this condition for demo company logo if needed
                // if( ! userId ) {
                url = '/images/logo-app.svg';
                // } else {
                // url = '/images/_demo/avatars/' + ETWServicesUtils.asId((userId % 8) + 1) + '/original.png';
                // }
            }
            else {
                url = serviceUrl + '/client/' +
                    AuthenticationService.getAccount().clientIdNum +
                    '/size/' + size + '?v=' + imageTimestamp;
            }
            //if caching is enabled
            if (cacheEnabled) {
                //check cache for dataURI version of image
                if (!logoCache[url]) {
                    //create a dataURI for this avatar
                    getDataUriForImageUrl(url).then(function (image) {
                        //send back the dataURI version
                        deferred.resolve(image);
                        //cache the dataURI version
                        cacheAvatar(url, image);
                    });
                }
                //if a cached imaged was found
                else {
                    //send back the dataURI version
                    deferred.resolve(logoCache[url]);
                }
            }
            //if caching is disabled
            else {
                deferred.resolve(url);
            }
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'size' implicitly has an 'any' type.
            // @ts-ignore ts-migrate(7034) FIXME: Variable 'url' implicitly has type 'any' in some l... Remove this comment to see the full error message
            //return the promise
            return deferred.promise;
        }
        //saves the dataURI version of a image URL
        function cacheAvatar(url, dataURI) {
            //inject the new avatar
            logoCache[url] = dataURI;
        }
        //clear the avatar cache
        function clearLogoCache() {
            //clear the local copy
            logoCache = {};
        }
        /**
         * @method save
         * @param file {object}
         * @returns {object} - promise
         * Uploads a file
         */
        function save(file, userId) {
            //config
            var options = {
                data: {},
                errorMessage: 'The logo could not be uploaded.',
                imagePropertyName: 'content',
                method: 'POST',
                url: serviceUrl,
            };
            //upload the file
            var request = ETWServicesUtils.upload(options, 'files', file);
            //trigger an update for the images on the page
            request.then(refreshImage);
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            //send back the request's promise
            return request;
        }
        /**
         * @method destroy
         * @returns {object} - promise
         */
        function destroy() {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'image' implicitly has an 'any' type.
            return $http({
                errorMessage: 'Logo could not be removed.',
                method: 'DELETE',
                url: serviceUrl + '/client',
            })
                .then(refreshImage)
                .finally(function () {
                try {
                    // @ts-ignore ts-migrate(7005) FIXME: Variable 'url' implicitly has an 'any' type.
                    ETWServicesUtils.notify('LogoService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
    }
})();
// @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message

(function () {
    angular
        .module('ETWServices')
        .factory('CompetenciesService', [
        '$http',
        'ETWServicesUtils',
        'JanusServicesUtils',
        CompetenciesServiceFactory,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
    function CompetenciesServiceFactory($http, ETWServicesUtils, JanusServicesUtils) {
        /**
         * @property leadershipLevelsUrl
         * @type {string}
         */
        var leadershipLevelsUrl = ETWServicesUtils.getEndpointUrl('LEADERSHIP_LEVELS');
        /**
         * @property modelDefinition
         * @type {object}
         */
        var modelDefinition = {};
        var service = {
            all: ETWServicesUtils.all,
            assignToLeadershipLevel: assignToLeadershipLevel,
            destroy: destroy,
            getAll: getAll,
            getAssignedToLeadershipLevel: getAssignedToLeadershipLevel,
            getUnassignedForLeadershipLevel: getUnassignedForLeadershipLevel,
            getAvailableLevels: getAvailableLevels,
            getById: getById,
            getCompetencyLevelLabels: getCompetencyLevelLabels,
            getNew: getNew,
            reject: ETWServicesUtils.reject,
            resolve: ETWServicesUtils.resolve,
            save: save,
            subscribe: ETWServicesUtils.subscribe('CompetenciesService'),
            unassignFromLeadershipLevel: unassignFromLeadershipLevel,
            unsubscribe: ETWServicesUtils.unsubscribe('CompetenciesService'),
        };
        /**
         * @property serviceUrl
         * @type {string}
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('COMPETENCIES');
        return service;
        /**
         * @method assignToLeadershipLevel
         * @param competencyId {number}
         * @param leadershipLevelId {number}
         * @param competencyLevel {number}
         * @returns {object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'competencyId' implicitly has an 'any' t... Remove this comment to see the full error message
        function assignToLeadershipLevel(competencyId, leadershipLevelId, competencyLevel) {
            return $http({
                method: 'POST',
                data: competencyLevel,
                url: [
                    leadershipLevelsUrl,
                    ETWServicesUtils.asId(leadershipLevelId),
                    'competencies',
                    ETWServicesUtils.asId(competencyId),
                ].join('/'),
            });
        }
        /**
         * @method destroy
         * @param competencyId {number}
         * @returns {object} - promise
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'competencyId' implicitly has an 'any' t... Remove this comment to see the full error message
        function destroy(competencyId) {
            var options = {
                errorMessage: 'This competency could not be removed.',
                url: serviceUrl + '/' + ETWServicesUtils.asId(competencyId),
            };
            return ETWServicesUtils.destroy(options, modelDefinition, 'CompetenciesService');
        }
        /**
         * @method getAll
         * @returns {object} - promise, Array of Competencies
         */
        function getAll() {
            return $http({
                errorMessage: 'All Competencies could not be retrieved.',
                method: 'GET',
                url: serviceUrl,
            });
        }
        /**
         * @method getAssignedToLeadershipLevel
         * @param leadershipLevelId {number}
         * @returns {object} - promise, Array of Competencies
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'leadershipLevelId' implicitly has an 'a... Remove this comment to see the full error message
        function getAssignedToLeadershipLevel(leadershipLevelId) {
            return $http({
                method: 'GET',
                url: leadershipLevelsUrl + '/' + ETWServicesUtils.asId(leadershipLevelId) + '/competencies',
            });
        }
        /**
         * getAvailableLevels
         * @param competencyId
         * @returns {object} - promise, Array of Levels.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'competencyId' implicitly has an 'any' t... Remove this comment to see the full error message
        function getAvailableLevels(competencyId) {
            return JanusServicesUtils.get('LEVELS_FOR_COMPETENCY', {
                competencyId: competencyId,
            });
        }
        /**
         * @method getById
         * @params id {number}
         * @returns {object} - promise, Array
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
        function getById(id) {
            return $http({
                method: 'GET',
                url: serviceUrl + '/' + ETWServicesUtils.asId(id),
            });
        }
        /**
         * @method getCompetencyLevelLabels
         * @returns {object} - promise, Array of Labels for selecting levels for behaviors.
         */
        function getCompetencyLevelLabels() {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            return JanusServicesUtils.get('COMPETENCY_LEVEL_LABELS').then(function (response) {
                return response.data;
            });
        }
        /**
         * @method getNew
         * @param [options] {object}
         * @returns {object} - promise
         * Acts like getById() but instead returns a new unsaved competency with whatever options are passed.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'options' implicitly has an 'any' type.
        function getNew(options) {
            return ETWServicesUtils.resolve({
                title: '',
                description: '',
            });
        }
        /**
         * @method getUnassignedForLeadershipLevel
         * @param leadershipLevelId {number}
         * @returns {object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'leadershipLevelId' implicitly has an 'a... Remove this comment to see the full error message
        function getUnassignedForLeadershipLevel(leadershipLevelId) {
            return JanusServicesUtils.get('COMPETENCIES_FOR_LEADERSHIP', {
                leadershipLevelId: leadershipLevelId,
            }).then(sortResponse('title', 'id'));
        }
        /**
         * @method save
         * @param competency {object}
         * @param [changedProperties] {Array}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'competency' implicitly has an 'any' typ... Remove this comment to see the full error message
        function save(competency, changedProperties) {
            var options = {
                data: _.cloneDeep(competency),
                errorMessage: 'This competency could not be saved.',
                idName: 'id',
                properties: changedProperties,
                url: serviceUrl,
            };
            if (competency.id) {
                options.url = serviceUrl + '/' + ETWServicesUtils.asId(competency.id);
            }
            return ETWServicesUtils.save(options, modelDefinition, 'CompetenciesService');
        }
        /**
         * @function sort
         * @param items {Array}
         * @param columnName {String}
         * @param idColumnName {String}
         * @returns {Array}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'items' implicitly has an 'any' type.
        function sort(items, columnName, idColumnName) {
            return _(items)
                .orderBy([
                function (item) {
                    return item[columnName].toLowerCase();
                },
                idColumnName,
            ], ['asc', 'asc'])
                .value();
        }
        /**
         * @function sortResponse
         * @param columnName {String}
         * @param idColumnName {String}
         * @returns {function(*): *}
         * Designed to be used as a response handler.
         * Sorts according to a specific algorithm used in other products.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'columnName' implicitly has an 'any' typ... Remove this comment to see the full error message
        function sortResponse(columnName, idColumnName) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            return function (response) {
                response.data = sort(response.data, columnName, idColumnName);
                return response;
            };
        }
        /**
         * @method unassignFromLeadershipLevel
         * @param competencyId {number}
         * @param leadershipLevelId {number}
         * @returns {object} - promise
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'competencyId' implicitly has an 'any' t... Remove this comment to see the full error message
        function unassignFromLeadershipLevel(competencyId, leadershipLevelId) {
            var options = {
                errorMessage: 'This competency could not be removed from the leadership level.',
                url: leadershipLevelsUrl +
                    '/' +
                    ETWServicesUtils.asId(leadershipLevelId) +
                    '/competencies/' +
                    ETWServicesUtils.asId(competencyId),
            };
            return ETWServicesUtils.destroy(options, modelDefinition, 'CompetenciesService');
        }
    }
})();

(function () {
    var SIZES = [
        'sm',
        'sm2x',
        'sm3x',
        'sm4x',
        'md',
        'md2x',
        'md3x',
        'md4x',
        'lg',
        'lg2x',
        'lg3x',
        'lg4x',
        'orig',
    ];
    angular
        .module('ETWServices')
        .factory('CompetencyBadgeService', [
        '$http',
        'ETWServicesUtils',
        'IS_MOCKED',
        CompetencyBadgeServiceFactory,
    ]);
    function CompetencyBadgeServiceFactory($http, ETWServicesUtils, IS_MOCKED) {
        var cacheEnabled = true;
        //script config
        // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
        var badgeTimestamp = new Date().getTime(), 
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ETWServicesUtils' implicitly has an 'an... Remove this comment to see the full error message
        isLoading = false, badgeCache = {};
        //public functions
        var service = {
            crop: crop,
            destroy: destroy,
            getDataUriForImageUrl: getDataUriForImageUrl,
            getLoading: getLoading,
            getUrlById: getUrlById,
            reject: ETWServicesUtils.reject,
            resolve: ETWServicesUtils.resolve,
            save: save,
            setLoading: setLoading,
            subscribe: ETWServicesUtils.subscribe('CompetencyBadgeService'),
            unsubscribeAll: ETWServicesUtils.unsubscribeAll('CompetencyBadgeService'),
        };
        /**
         * @property serviceUrl
         * @type {string}
         * Path to the root of the badges API
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('COMPETENCY_BADGE');
        //send back functions to play with
        return service;
        //////////////// FUNCTIONS ////////////////
        //refresh the badge when it has been manipulated
        function refreshBadge() {
            //get the current timestamp
            badgeTimestamp = new Date().getTime();
            //clear the badge cache as references are invalid
            clearBadgeCache();
            //tell subscribers that there was an update
            ETWServicesUtils.notify('CompetencyBadgeService');
        }
        //set whether the badge is loading or not
        function setLoading(newValue) {
            isLoading = newValue;
        }
        //get whether or not an badge is loading
        function getLoading() {
            return isLoading;
        }
        /**
         * @method getDataUriForImageUrl
         * @param imageUrl
         * @returns {object} - promise, string
         * Takes a URL and loads it into an orphan image node.
         * Then extracts the DataURI and returns it as a string.
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'newValue' implicitly has an 'any' type.
         * from https://davidwalsh.name/convert-image-data-uri-javascript
         */
        function getDataUriForImageUrl(imageUrl) {
            var deferred = ETWServicesUtils.defer();
            var image = angular.element('<img>')[0];
            // @ts-ignore
            image.crossOrigin = 'use-credentials';
            //once the browser has loaded the image
            image.onload = function () {
                var canvas = angular.element('<canvas>')[0];
                // @ts-ignore
                canvas.width = this.naturalWidth;
                // @ts-ignore
                canvas.height = this.naturalHeight;
                // @ts-ignore
                canvas.getContext('2d').drawImage(this, 0, 0);
                //return the image
                // @ts-ignore
                deferred.resolve(canvas.toDataURL('image/png'));
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'imageUrl' implicitly has an 'any' type.
            };
            // @ts-ignore
            image.src = imageUrl;
            return deferred.promise;
        }
        //sends a request to the server to crop the badge image
        function crop(id, details) {
            return $http({
                errorMessage: 'Unable to crop badge',
                method: 'POST',
                data: {
                    x: details.cropImageLeft,
                    y: details.cropImageTop,
                    width: details.cropImageWidth,
                    height: details.cropImageHeight,
                },
                url: serviceUrl + '/' + ETWServicesUtils.asId(id) + '/crop',
            })
                .then(function () {
                //apply the new badge
                refreshBadge();
                //the new badge has finished loading
                setLoading(false);
            })
                .finally(function () {
                try {
                    ETWServicesUtils.notify('CompetencyBadgeService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method getUrlById
         * @param id {number}
         * @param size {string}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
         * @returns {string}
         */
        function getUrlById(id, size) {
            var url;
            var deferred = ETWServicesUtils.defer();
            if (!~SIZES.indexOf(size)) {
                throw new Error('Incorrect Badge size:' + size);
            }
            if (IS_MOCKED) {
                url = '/images/_demo/badges/placeholder-badge.png';
            }
            else {
                url =
                    serviceUrl + '/' + ETWServicesUtils.asId(id || 0) + '/' + size + '?v=' + badgeTimestamp;
            }
            //if caching is enabled
            if (cacheEnabled) {
                //check cache for dataURI version of image
                if (!badgeCache[url]) {
                    //create a dataURI for this badge
                    getDataUriForImageUrl(url).then(function (image) {
                        //send back the dataURI version
                        deferred.resolve(image);
                        //cache the dataURI version
                        cacheBadge(url, image);
                    });
                }
                //if a cached imaged was found
                else {
                    //send back the dataURI version
                    deferred.resolve(badgeCache[url]);
                }
            }
            //if caching is disabled
            else {
                deferred.resolve(url);
            }
            //return the promise
            return deferred.promise;
        }
        //saves the dataURI version of a image URL
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
        function cacheBadge(url, dataURI) {
            // @ts-ignore ts-migrate(7034) FIXME: Variable 'url' implicitly has type 'any' in some l... Remove this comment to see the full error message
            //inject the new badge
            badgeCache[url] = dataURI;
        }
        //clear the badge cache
        function clearBadgeCache() {
            //clear the local copy
            badgeCache = {};
        }
        /**
         * @method save
         * @param file {object}
         * @returns {object} - promise
         * Uploads a file
         */
        function save(file, id) {
            //config
            var options = {
                data: {},
                errorMessage: 'The badge could not be uploaded.',
                imagePropertyName: 'content',
                method: 'POST',
                url: serviceUrl + '/' + ETWServicesUtils.asId(id),
            };
            //upload the file
            var request = ETWServicesUtils.upload(options, 'files', file);
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            //trigger an update for the images on the page
            request.then(refreshBadge);
            //send back the request's promise
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'image' implicitly has an 'any' type.
            return request;
        }
        /**
         * @method destroy
         * @param id {number}
         * @returns {object} - promise
         */
        function destroy(id) {
            return $http({
                errorMessage: 'Badge could not be removed.',
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'url' implicitly has an 'any' type.
                method: 'DELETE',
                url: serviceUrl + '/' + ETWServicesUtils.asId(id),
            })
                .then(refreshBadge)
                .finally(function () {
                try {
                    ETWServicesUtils.notify('CompetencyBadgeService');
                }
                catch (e) {
                    // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                    console.error(e);
                }
            });
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'url' implicitly has an 'any' type.

(function () {
    angular.module('ETWServices').service('d3Service', ['$window', d3Service]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$window' implicitly has an 'any' type.
    function d3Service($window) {
        var d3 = $window.d3;
        return {
            d3: d3,
        };
    }
})();

(function () {
    angular
        .module('ETWServices')
        .factory('DraftsService', ['$window', 'AuthenticationService', DraftsServiceFactory]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$window' implicitly has an 'any' type.
    function DraftsServiceFactory($window, AuthenticationService) {
        var ls = $window.localStorage;
        /**
         * @property oldStorageKey
         * @type {string}
         * TODO: Deprecated. Legacy drafts support. Should be removed 8/2017
         */
        var oldStorageKey = 'drafts.' +
            AuthenticationService.getAccount().clientId +
            '.' +
            AuthenticationService.getAccount().userId;
        /**
         * @property storageKey
         * @type {string}
         */
        var storageKey = 'drafts.' +
            AuthenticationService.getAccount().clientIdNum +
            '.' +
            AuthenticationService.getAccount().userId;
        var service = {
            get: get,
            remove: remove,
            store: store,
        };
        return service;
        /**
         * @method get
         * @param key {string}
         * @param id {number}
         * @returns {string}
         * Returns the object of the requested draft.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'key' implicitly has an 'any' type.
        function get(key, id) {
            var currentDrafts, requested;
            if (ls && ls.getItem) {
                //load all the drafts
                currentDrafts = loadAllDrafts();
                //located the requested draft
                requested = _.find(currentDrafts, { id: id, key: key });
                // TODO: Deprecated. Legacy drafts support. Should be removed 8/2017
                // TODO: Top level comment drafts were '-undefined' instead of -0.
                if (!requested && key.substr(-2) == '-0') {
                    key = key.substr(0, key.length - 2) + '-undefined';
                    requested = _.find(currentDrafts, { id: id, key: key });
                }
                if (requested && requested.expiration) {
                    if (requested.expiration - new Date().getTime() < 0) {
                        // draft expired
                        remove(key, id);
                        requested = undefined;
                    }
                }
            }
            //return the requested draft string
            return (requested && requested.string) || undefined;
        }
        /**
         * @function loadAllDrafts
         * @private
         * Return the users current set of drafts.
         */
        function loadAllDrafts() {
            var buffer = '', encoded, decoded = '', strings, i;
            //get the encoded string from storage
            encoded = ls.getItem(storageKey) || '';
            if (encoded === '') {
                // Try old storage key
                // TODO: Deprecated. Legacy drafts support. Should be removed 8/2017
                encoded = ls.getItem(oldStorageKey) || '';
            }
            //decode the string
            try {
                decoded = $window.atob(encoded);
            }
            catch (e) {
                strings = encoded.split(',');
                buffer = '';
                for (i = 0; i < strings.length; i += 1) {
                    buffer = strings[i];
                    // Base64 encoded strings are grouped by 4 characters, simple alphanumeric with + and /.
                    // Padded by = at the end if necessary.
                    if (buffer.length % 4 === 0 && buffer.match(/^[a-zA-Z0-9+/]+=*$/) !== null) {
                        // base64
                        decoded += $window.atob(buffer);
                    }
                    else {
                        // multibyte
                        decoded += buffer;
                    }
                }
            }
            //send back the decoded array
            return JSON.parse(decoded || '[]');
        }
        /**
         * @function update
         * @param data
         * @private
         * Overwrites the draft cache per storageKey.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'data' implicitly has an 'any' type.
        function update(data) {
            var buffer = '', code, i, stringified, strings = [];
            //convert the cache to a string
            stringified = JSON.stringify(data);
            for (i = 0; i < stringified.length; i++) {
                code = stringified.charCodeAt(i);
                if (code <= 128) {
                    buffer += stringified[i];
                }
                else {
                    if (buffer.length) {
                        strings.push($window.btoa(buffer));
                        buffer = '';
                    }
                    strings.push(stringified[i]);
                }
            }
            if (buffer.length) {
                strings.push($window.btoa(buffer));
            }
            // Comma is not a base64 character, so it is safe as a delimiter
            var encoded = strings.join(',');
            //overwrite the current cached data
            ls.setItem(storageKey, encoded);
            // TODO: Deprecated. Legacy drafts support. Should be removed 8/2017
            if (ls.getItem(oldStorageKey) !== null) {
                ls.removeItem(oldStorageKey);
            }
        }
        /**
         * @method store
         * @param key {string}
         * @param id {number}
         * @param string {string}
         * Stores a new draft built from input.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'key' implicitly has an 'any' type.
        function store(key, id, string) {
            var currentDrafts, expiration, requested;
            if (ls && ls.getItem) {
                //load the users current drafts
                currentDrafts = loadAllDrafts();
                //check for a current draft
                requested = _.find(currentDrafts, { id: id, key: key });
                //if a current draft was found
                if (requested) {
                    //update the current draft
                    requested.string = string;
                    //if the incoming string is empty
                    if (!string) {
                        //remove the draft from the cache
                        _.remove(currentDrafts, requested);
                    }
                }
                else {
                    expiration = new Date();
                    // Draft expires in 7 days.
                    expiration.setDate(expiration.getDate() + 7);
                    //create a new draft
                    currentDrafts.push({
                        id: id,
                        expiration: expiration.getTime(),
                        key: key,
                        string: string,
                    });
                }
                //save the updated data
                update(currentDrafts);
            }
        }
        /**
         * @method remove
         * @param key {string}
         * @param id {number}
         * Removes a draft from storage.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'key' implicitly has an 'any' type.
        function remove(key, id) {
            var currentDrafts, requested;
            if (ls && ls.getItem) {
                //load the current drafts
                currentDrafts = loadAllDrafts();
                //find the requested draft
                requested = _.find(currentDrafts, { id: id, key: key }) || {};
                //remove the requested draft if it was found
                _.remove(currentDrafts, requested);
                //save the updated draft set
                update(currentDrafts);
            }
        }
    }
})();

(function () {
    angular
        .module('ETWServices')
        .factory('DriversService', [
        '$cacheFactory',
        '$http',
        'ETWServicesUtils',
        DriversServiceFactory,
    ]);
    /**
     * @factory DriversServiceFactory
     */
    function DriversServiceFactory($cacheFactory, $http, ETWServicesUtils) {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter '$cacheFactory' implicitly has an 'any' ... Remove this comment to see the full error message
        var service = {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
            attachmentDestroy: attachmentDestroy,
            attachmentSave: attachmentSave,
            attachmentUpload: attachmentUpload,
            destroy: destroy,
            getDriversForPlan: getDriversForPlan,
            getDriversForUser: getDriversForUser,
            getDriversForUserPlans: getDriversForUserPlans,
            getFiles: getFiles,
            getNew: getNew,
            move: move,
            resolve: ETWServicesUtils.resolve,
            saveForPlan: saveForPlan,
            subscribe: ETWServicesUtils.subscribe('DriversService'),
            unsubscribe: ETWServicesUtils.unsubscribe('DriversService'),
            subscribeLinks: ETWServicesUtils.subscribe('DriversServiceLinks'),
            unsubscribeLinks: ETWServicesUtils.unsubscribe('DriversServiceLinks'),
        };
        /**
         * @property plansServiceUrl
         * @type {string}
         */
        var plansServiceUrl = ETWServicesUtils.getEndpointUrl('PLANS');
        /**
         * @property fileServiceUrl
         * @type {string}
         */
        var fileServiceUrl = ETWServicesUtils.getEndpointUrl('DRIVER_FILES');
        /**
         * @method getDriversForPlan.clear
         * Clears the cache for the getDriversForPlan(planId) results.
         * All methods that modify Drivers must call this method.
         */
        getDriversForPlan.clear = function (planId) {
            $cacheFactory
                .get('$http')
                .remove(plansServiceUrl + '/' + ETWServicesUtils.asId(planId) + '/drivers');
        };
        return service;
        /**
         * @method attachmentDestroy
         * @param planId {number}
         * @param driverId {number}
         * @returns {Function}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
         * Curries the IDs for the plan and Driver into the standard destroy method. Controllers can then just pass type and attachment.
         * Clears the cache and notifies subscribers.
         */
        function attachmentDestroy(planId, driverId) {
            var baseUrl = plansServiceUrl +
                '/' +
                ETWServicesUtils.asId(planId) +
                '/drivers/' +
                ETWServicesUtils.asId(driverId);
            return function (type, attachment) {
                getDriversForPlan.clear(planId);
                return ETWServicesUtils.attachmentDestroy(type, baseUrl, attachment).finally(function attachmentDestroyFinal() {
                    try {
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                        ETWServicesUtils.notify('DriversServiceLinks');
                    }
                    catch (e) {
                        console.error(e);
                    }
                });
            };
        }
        /**
         * @method attachmentSave
         * @param planId {number}
         * @param driverId {number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
         * @returns {Function}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'attachment' implicitly has an 'any' typ... Remove this comment to see the full error message
         * Curries the plan ID and Driver ID in the standard upload method. Controllers can then just pass type and attachment.
         * Clears the cache and notifies subscribers.
         */
        function attachmentSave(planId, driverId) {
            var baseUrl = plansServiceUrl +
                '/' +
                ETWServicesUtils.asId(planId) +
                '/drivers/' +
                ETWServicesUtils.asId(driverId);
            return function (type, attachment, isAdminEntity) {
                getDriversForPlan.clear(planId);
                return ETWServicesUtils.attachmentSave(type, baseUrl, attachment, isAdminEntity).finally(function attachmentSaveFinal() {
                    try {
                        ETWServicesUtils.notify('DriversServiceLinks');
                    }
                    catch (e) {
                        console.error(e);
                    }
                });
            };
        }
        /**
         * @method attachmentUpload
         * @param planId {number}
         * @param driverId {number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
         * @returns {Function}
         * Curries the IDs for the plan and driver into the standard upload method. Controllers can then just pass type and attachment.
         * Clears the cache and notifies any subscribers.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
        function attachmentUpload(planId, driverId) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'isAdminEntity' implicitly has an 'any' ... Remove this comment to see the full error message
            var baseUrl = plansServiceUrl +
                '/' +
                ETWServicesUtils.asId(planId) +
                '/drivers/' +
                ETWServicesUtils.asId(driverId), baseDownloadUrl = plansServiceUrl +
                '/' +
                ETWServicesUtils.asId(planId) +
                '/drivers/' +
                ETWServicesUtils.asId(driverId);
            return function (type, attachment, isAdminEntity) {
                getDriversForPlan.clear(planId);
                return ETWServicesUtils.attachmentUpload(baseUrl, attachment, isAdminEntity, baseDownloadUrl).finally(function attachmentSaveFinal() {
                    try {
                        ETWServicesUtils.notify('DriversServiceLinks');
                    }
                    catch (e) {
                        console.error(e);
                    }
                });
            };
        }
        /**
         * @method destroy
         * @param planId {number}
         * @param driverId {number}
         */
        function destroy(planId, driverId) {
            return $http({
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                errorMessage: 'This Driver could not be removed.',
                method: 'DELETE',
                url: generateServiceUrl(planId, driverId),
            }).finally(function () {
                try {
                    getDriversForPlan.clear(planId);
                    ETWServicesUtils.notify('DriversService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @function generateServiceUrl
         * @param planId {number}
         * @param [driverId] {number} - optional Driver ID
         * @returns {string}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
         * @private
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'attachment' implicitly has an 'any' typ... Remove this comment to see the full error message
         * Used to generate the URI for the endpoints.
         */
        function generateServiceUrl(planId, driverId) {
            var url = plansServiceUrl + '/' + ETWServicesUtils.asId(planId) + '/drivers';
            if (angular.isDefined(driverId)) {
                url += '/' + ETWServicesUtils.asId(driverId);
            }
            return url;
        }
        /**
         * @function generateServiceUrl
         * @param userId {number}
         * @param [driverId] {number} - optional Driver ID
         * @returns {string}
         // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
         * @private
         // @ts-ignore ts-migrate(7006) FIXME: Parameter 'attachment' implicitly has an 'any' typ... Remove this comment to see the full error message
         * Used to generate the URI for the endpoints.
         */
        function generateServiceUserDriversUrl(userId, driverId) {
            var url = plansServiceUrl + '/users/' + ETWServicesUtils.asId(userId) + '/drivers';
            if (angular.isDefined(driverId)) {
                url += '/' + ETWServicesUtils.asId(driverId);
            }
            return url;
        }
        /**
         * @function generateServiceUserPlanDriversUrl
         * @returns {string}
         // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
         * @private
         // @ts-ignore ts-migrate(7006) FIXME: Parameter 'attachment' implicitly has an 'any' typ... Remove this comment to see the full error message
         * Used to generate the URI for the endpoints.
         */
        function generateServiceUserPlanDriversUrl() {
            var url = plansServiceUrl + '/drivers';
            return url;
        }
        /**
         * Returns the list of drivers associated with the given plan
         * @param planId
         * @returns {[Object]}
         */
        function getDriversForPlan(planId, driverId) {
            return $http({
                errorMessage: 'Drivers for this plan could not be retrieved.',
                method: 'GET',
                url: generateServiceUrl(planId, driverId),
            });
        }
        function getDriversForUser(userId, driverId) {
            return $http({
                errorMessage: 'Drivers for this plan could not be retrieved.',
                method: 'GET',
                url: generateServiceUserDriversUrl(userId, driverId),
            });
        }
        /**
         *
         * @param page
         * @param pageSize
         * @param direction forward > 0, back <= 0
         */
        function getDriversForUserPlans(page, pageSize, direction) {
            return $http({
                errorMessage: 'Drivers for this user could not be retrieved.',
                method: 'GET',
                url: generateServiceUserPlanDriversUrl() + '?page=' + page + '&page-size=' + pageSize + '&direction=' + direction,
            });
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
         * @method getFiles
         * @param planId {number}
         * @param driverId {number}
         * @returns {object} - promise, array
         * Returns data for attached files.
         */
        function getFiles(planId, driverId) {
            return $http({
                errorMessage: 'Files could not be retrieved for this Driver.',
                method: 'GET',
                url: fileServiceUrl +
                    '/' +
                    ETWServicesUtils.asId(planId) +
                    '/drivers/' +
                    ETWServicesUtils.asId(driverId),
            }).then(function (response) {
                _.forEach(response.data, function (file) {
                    file.downloadUrl =
                        plansServiceUrl +
                            '/' +
                            ETWServicesUtils.asId(planId) +
                            '/drivers/' +
                            ETWServicesUtils.asId(driverId) +
                            '/file/' +
                            file.id;
                });
                return response;
                // @ts-ignore
            }, service.reject);
        }
        /**
         * @method getNew
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
         * @param options {object}
         * @returns {object} - promise, object
         * Creates a new (unsaved) instance with default values.
         */
        function getNew(options) {
            _.defaults(options, {
                // @ts-ignore
                id: _.uniqueId(115464215),
                isFocused: 0,
                type: 'QUANTITATIVE',
                isTemporary: true,
                description: '',
            });
            return ETWServicesUtils.resolve({
                data: options,
            });
        }
        /**
         * @method move
         * @param driverId {number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
         * @param oldPlanId {number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'driverId' implicitly has an 'any' type.
         * @param newPlanId {number}
         * Move the Driver from one plan to another.
         * /plans/{planId}/drivers/{driverId}/newplan/{newPlanId}
         */
        function move(driverId, oldPlanId, newPlanId) {
            return $http({
                errorMessage: 'Could not move Driver',
                method: 'PATCH',
                url: plansServiceUrl +
                    '/' +
                    ETWServicesUtils.asId(oldPlanId) +
                    '/drivers/' +
                    ETWServicesUtils.asId(driverId) +
                    '/newplan/' +
                    ETWServicesUtils.asId(newPlanId),
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
            }).finally(function moveDriverToPlanFinal() {
                // clear cache?
                // Notify subscribers
                ETWServicesUtils.notify('DriversService');
            });
        }
        /**
         * @method save
         * @param driver {object}
         * @param planId {number}
         * @param [changedProperties] {array} - optional. For partial updates
         * @returns {object} - promise, Driver
         * Create/update/patch a Driver
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
        function saveForPlan(driver, planId, changedProperties) {
            var options = {
                data: driver,
                errorMessage: 'This driver could not be saved.',
                idName: 'id',
                properties: changedProperties,
                // @ts-ignore
                url: generateServiceUrl(planId),
            };
            if (angular.isDefined(driver.id)) {
                options.url = generateServiceUrl(planId, driver.id);
            }
            return ETWServicesUtils.save(options, undefined);
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'options' implicitly has an 'any' type.

(function () {
    angular
        .module('ETWServices')
        .factory('EngagementService', ['$http', 'ETWServicesUtils', EngagementServiceFactory]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
    function EngagementServiceFactory($http, ETWServicesUtils) {
        var service = {
            all: ETWServicesUtils.all,
            getAllForPeople: getAllForPeople,
            getAllForPerson: getAllForPerson,
            getPersonalEngagementRangeByUserId: getPersonalEngagementRangeByUserId,
            reject: ETWServicesUtils.reject,
            resolve: ETWServicesUtils.resolve,
        };
        /**
         * @property serviceUrlForClient
         * @type {string}
         * @private
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('ENGAGEMENT');
        /**
         * @property sixMonthsAgo
         * @type {Date}
         * First day of the month, six months ago.
         * Used to limit engagement data
         */
        var sixMonthsAgo = (function () {
            var d = new Date();
            d.setHours(0, 0, 0, 0);
            d.setDate(1);
            d.setMonth(d.getMonth() - 6);
            return d;
        })();
        return service;
        /**
         * Takes the data for engagement from the back-end
         * and cleans it up for the front-end
         * @method analyze
         * @param  {object} response data from back-end
         * @return {object}      chart data and engagement numbers
         */
        function analyze(response) {
            var data = response.data.engagements;
            var engagement = getEngagementBoilerplate();
            var engagementCount = 0;
            var managerEngagementCount = 0;
            engagement.endDate = new Date(response.data.endDate);
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            engagement.startDate = new Date(response.data.startDate);
            // @ts-ignore
            engagement.minGap = response.data.minGap;
            // @ts-ignore
            engagement.maxGap = response.data.maxGap;
            // @ts-ignore
            engagement.userId = response.data.userId;
            // if the person has no engagement
            if (data.length === 0) {
                return engagement;
            }
            engagement.startDate = ETWServicesUtils.toDate(data[0].startDate);
            // set both start and end dates to zero time
            engagement.startDate.setHours(0, 0, 0, 0);
            engagement.endDate.setHours(0, 0, 0, 0);
            var emptyDataPoints = getEmptyDataPoints(engagement.startDate, engagement.endDate);
            // Back-end provides engagement data broken down
            // by month. This will cycle through each month and
            // combine the information.
            angular.forEach(data, function (monthlyEngagement) {
                // Personal Engagement Chart Entries
                angular.forEach(monthlyEngagement.engagement.dates, function (engagementData) {
                    var engagementDate = ETWServicesUtils.toDate(engagementData.date);
                    engagementDate.setHours(0, 0, 0, 0);
                    // this will not count engagement on the bookends,
                    // we are looking for note gaps only, not notes on
                    // the startDate and endDate
                    if (ETWServicesUtils.daysBetweenDates(engagementDate, engagement.endDate) !== 0 &&
                        ETWServicesUtils.daysBetweenDates(engagementDate, engagement.startDate) !== 0) {
                        engagementCount += 1;
                    }
                    engagement.chartData.engagement.push({
                        number: engagementData.count,
                        date: engagementDate,
                    });
                });
                // Engagement with Direct Reports Chart Entries
                // Note: API (and DTO) calls the engagement a user has with their direct reports "managerEngagement"
                angular.forEach(monthlyEngagement.managerEngagement.dates, function (engagementData) {
                    var engagementDate = ETWServicesUtils.toDate(engagementData.date);
                    // this will not count engagement on the bookends,
                    // we are looking for note gaps only, not notes on
                    // the startDate and endDate
                    if (ETWServicesUtils.daysBetweenDates(engagementDate, engagement.endDate) !== 0 &&
                        // @ts-ignore ts-migrate(2322) FIXME: Type 'any' is not assignable to type 'never'.
                        ETWServicesUtils.daysBetweenDates(engagementDate, engagement.startDate) !== 0
                    // @ts-ignore ts-migrate(2322) FIXME: Type 'any' is not assignable to type 'never'.
                    ) {
                        managerEngagementCount += 1;
                    }
                    engagement.chartData.withDirectReports.push({
                        number: engagementData.count,
                        date: engagementDate,
                    });
                });
            });
            // Combine the actual data with the date placeholders
            engagement.chartData.engagement = engagement.chartData.engagement.concat(emptyDataPoints);
            engagement.chartData.withDirectReports = engagement.chartData.withDirectReports.concat(emptyDataPoints);
            // Clean out duplicates in the chart data
            engagement.chartData.engagement = getUniqueEngagementChartData(engagement.chartData.engagement);
            engagement.chartData.withDirectReports = getUniqueEngagementChartData(engagement.chartData.withDirectReports);
            // Get engagement averages
            engagement.engagement = calculateEngagementAverage(engagement.startDate, engagementCount);
            engagement.withDirectReports = calculateEngagementAverage(engagement.startDate, managerEngagementCount);
            // @ts-ignore ts-migrate(2322) FIXME: Type 'any' is not assignable to type 'never'.
            return engagement;
        }
        /**
         * @function analyzeGroup
// @ts-ignore ts-migrate(2322) FIXME: Type 'any' is not assignable to type 'never'.
         * @param response {object}
         * @returns {object} - map of engagement data by userId
         * Iterates through array of engagement data from getAllForPeople()
         * Returns an object where the userIds are the keys.
         */
        // @ts-ignore ts-migrate(2769) FIXME: No overload matches this call.
        function analyzeGroup(response) {
            var analyses = _.map(response.data, function (e) {
                return analyze({ data: e });
            });
            // @ts-ignore ts-migrate(2769) FIXME: No overload matches this call.
            return _.keyBy(analyses, 'userId');
        }
        /**
         * Finds the simple average of engagement
// @ts-ignore ts-migrate(2322) FIXME: Type 'unknown[]' is not assignable to type 'never[... Remove this comment to see the full error message
         * gaps, in days, for the given start date to today
         * @method calculateEngagementAverage
// @ts-ignore ts-migrate(2322) FIXME: Type 'unknown[]' is not assignable to type 'never[... Remove this comment to see the full error message
         * @param  {Date} startDate           from when engagement start
         * @param  {Integer} numberOfEngagements number of engagements
         * @return {Integer}                     an average of days between each engagement
         */
        function calculateEngagementAverage(startDate, numberOfEngagements) {
            // if no engagement yet
            if (numberOfEngagements === 0) {
                return 0;
            }
            var totalDays = ETWServicesUtils.daysBetweenDates(startDate, new Date());
            return Math.floor(totalDays / (numberOfEngagements + 1));
        }
        function getAllForPeople(userIds, startDate, endDate) {
            var parameters = {
                startDate: startDate || sixMonthsAgo,
                users: userIds.join(','),
            };
            if (endDate) {
                // @ts-ignore
                parameters.endDate = endDate;
            }
            return $http({
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                errorMessage: 'Engagement could not be retrieved for this person',
                method: 'GET',
                params: parameters,
                url: serviceUrl,
            }).then(analyzeGroup, ETWServicesUtils.reject);
        }
        /**
         * @method getAllForPerson
         * @param userId {number} - The person's id
         * @param [startDate] {Date}
         * @param [endDate] {Date}
         * @return {object} - promise, Array
         * Get all engagement for a person from the last evaluation or hire date.
         */
        function getAllForPerson(userId, startDate, endDate) {
            var parameters = {
                startDate: startDate || sixMonthsAgo,
            };
            if (endDate) {
                // @ts-ignore
                parameters.endDate = endDate;
            }
            return $http({
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'startDate' implicitly has an 'any' type... Remove this comment to see the full error message
                errorMessage: 'Engagement could not be retrieved for this person',
                method: 'GET',
                params: parameters,
                url: serviceUrl + '/user/' + userId,
            }).then(analyze, ETWServicesUtils.reject);
        }
        /**
         * @function getEmptyDataPoints
         * @param {Date} startDate the engagement starting date
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'userIds' implicitly has an 'any' type.
         * @param {Date} endDate the engagement end date
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'startDate' implicitly has an 'any' type... Remove this comment to see the full error message
         * @return {Array} an array of chart data points for each day between dates
         * @private
         * This builds out empty chart data points so that the engagement chart shows empty days as well engagement days.
         */
        function getEmptyDataPoints(startDate, endDate) {
            var totalDays = ETWServicesUtils.daysBetweenDates(startDate, endDate);
            var dataPoints = [];
            for (var i = 0; i <= totalDays; i++) {
                var day = ETWServicesUtils.addDays(startDate, i);
                dataPoints.push({
                    number: 0,
                    date: day,
                });
            }
            return dataPoints;
        }
        /**
         * Boilerplate for engagement data
         * @method getEngagementBoilerplate
         * @return {object}
         * Note: API calls engagement of a user with their direct reports "managerEngagement".
         *   For clarity, UI refers to it as "withDirectReports"
         */
        function getEngagementBoilerplate() {
            return {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'userId' implicitly has an 'any' type.
                startDate: new Date(),
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'startDate' implicitly has an 'any' type... Remove this comment to see the full error message
                endDate: new Date(),
                engagement: 0,
                withDirectReports: 0,
                chartData: {
                    engagement: [],
                    withDirectReports: [],
                },
            };
        }
        /**
         * @method getPersonalEngagementRangeByUserId
         * @param  {number} userId the person's id
         * @return {promise}
         * Gets the engagement range for a given person
         */
        function getPersonalEngagementRangeByUserId(userId) {
            return $http({
                errorMessage: 'Engagement could not be retrieved for this person',
                method: 'GET',
                url: serviceUrl + '/user/' + userId + '/minmax',
            });
        }
        /**
         * Since we concat the array we need to clean out
         * the duplicates between the actual engagement and
         * the empty date placeholders
         * @method getUniqueEngagementChartData
         * @param  {Array} chartData the chart data
         * @return {Array}
         */
        function getUniqueEngagementChartData(chartData) {
            return _.uniqWith(chartData, function (a, b) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'startDate' implicitly has an 'any' type... Remove this comment to see the full error message
                return a.date.getTime() == b.date.getTime();
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'endDate' implicitly has an 'any' type.
            });
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'userId' implicitly has an 'any' type.

(function () {
    angular
        .module('ETWServices')
        .factory('etwServicesInterceptor', [
        '$q',
        '$cookies',
        '$rootScope',
        '$window',
        'PRODUCT_URLS',
        'TEMPLATE_PATH',
        'API_SERVICES_URLS',
        etwServicesInterceptor,
    ]);
    /**
     * @factory etwServicesInterceptor
     * Handle _all_ requests and responses by $http.
     * Note: This interceptor applies to ALL XHR, including template files.
     * To only apply to ETW API, check the url for the PRODUCT_URLS.api
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$q' implicitly has an 'any' type.
    function etwServicesInterceptor($q, $cookies, $rootScope, $window, PRODUCT_URLS, TEMPLATE_PATH, API_SERVICES_URLS) {
        var service = {
            responseError: responseError,
            request: request,
        };
        return service;
        // @ts-ignore
        function request(config) {
            var noTokenHeader = config.headers['no-auth-token'];
            var refreshURL = ((PRODUCT_URLS.api + API_SERVICES_URLS['AUTHORIZE']).replace('%CLIENT%', '')) + '/refresh';
            if (config.url != refreshURL && !noTokenHeader && !config.url.startsWith('/templates') && !config.url.startsWith('uib/template')) {
                var promiseToHaveValidToken = void 0;
                var access_token = $window.localStorage.getItem('user.access_token') || '';
                var decryptedAccessToken = void 0;
                var isValidToken = false;
                if (access_token) {
                    var splitToken = access_token.split('.');
                    if (splitToken.length === 3) {
                        decryptedAccessToken = JSON.parse($window.atob(splitToken[1]));
                        isValidToken = decryptedAccessToken.exp * 1000 > +new Date();
                    }
                }
                if (isValidToken === false) { // change this to false after test
                    var $http = angular.injector(["ng"]).get("$http");
                    var refresh_token = $window.localStorage.getItem('user.refresh_token');
                    if (refresh_token) {
                        promiseToHaveValidToken = $http({
                            data: {
                                refresh_token: refresh_token,
                            },
                            method: 'POST',
                            url: refreshURL,
                        }).then(function (response) {
                            // update the access token
                            // @ts-ignore
                            var newAccessToken = response.data.access_token;
                            // @ts-ignore
                            var newRefreshToken = response.data.refresh_token;
                            if (newAccessToken) {
                                $window.localStorage.setItem('user.access_token', newAccessToken);
                            }
                            if (newRefreshToken) {
                                $window.localStorage.setItem('user.refresh_token', newRefreshToken);
                            }
                            return newAccessToken;
                        }, function (error) {
                            $window.localStorage.removeItem('user.access_token');
                            $window.localStorage.removeItem('user.refresh_token');
                        });
                    }
                }
                {
                    promiseToHaveValidToken = $q.resolve($window.localStorage.getItem('user.access_token'));
                }
                return promiseToHaveValidToken.then(function (token) {
                    if (token) {
                        config.headers['Authorization'] = 'Bearer ' + token;
                    }
                    return config;
                });
            }
            else {
                return config;
            }
        }
        // @ts-ignore ts-migrate(7006)
        function decodeToken(token) {
            var parts = token.split('.');
            if (parts.length !== 3) {
                throw new Error('JWT must have 3 parts');
            }
            // @ts-ignore ts-migrate(7006)
            var decoded = urlBase64Decode(parts[1]);
            if (!decoded) {
                throw new Error('Cannot decode the token');
            }
            return angular.fromJson(decoded);
        }
        // @ts-ignore ts-migrate(7006)
        function getTokenExpirationDate(token) {
            // @ts-ignore ts-migrate(7006)
            var decoded = this.decodeToken(token);
            if (typeof decoded.exp === "undefined") {
                return null;
            }
            var d = new Date(0); // The 0 here is the key, which sets the date to the epoch
            d.setUTCSeconds(decoded.exp);
            return d;
        }
        // @ts-ignore ts-migrate(7006)
        function isTokenExpired(token, offsetSeconds) {
            // @ts-ignore ts-migrate(7006)
            var d = this.getTokenExpirationDate(token);
            offsetSeconds = offsetSeconds || 0;
            if (d === null) {
                return false;
            }
            // Token expired?
            return !(d.valueOf() > (new Date().valueOf() + (offsetSeconds * 1000)));
        }
        // @ts-ignore ts-migrate(7006)
        function urlBase64Decode(str) {
            var output = str.replace(/-/g, '+').replace(/_/g, '/');
            switch (output.length % 4) {
                case 0: {
                    break;
                }
                case 2: {
                    output += '==';
                    break;
                }
                case 3: {
                    output += '=';
                    break;
                }
                default: {
                    throw 'Illegal base64url string!';
                }
            }
            return $window.decodeURIComponent(escape($window.atob(output))); //polyfill https://github.com/davidchambers/Base64.js
        }
        ;
        /**
         * @function getErrorMessage
         * @param config {object}
         * @param data {object|string}
         * @param status {number}
         * @returns {*}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'config' implicitly has an 'any' type.
        function getErrorMessage(config, data, status) {
            var message;
            if (angular.isString(config.errorMessage)) {
                // TODO: Remove the '409' hack when the api has a standard, structured error response body.
                // 409 check added for Meeting Instances because there was a human readable API error message for one specific scenario.
                if (status === 409 && data.error) {
                    message = data.error;
                }
                else {
                    message = config.errorMessage;
                }
            }
            else if (angular.isString(data)) {
                message = data;
            }
            else if (angular.isString(data.error)) {
                message = data.error;
            }
            else {
                message = 'There was a problem connecting to the server.';
            }
            return message;
        }
        /**
         * @method responseError
         * @param rejection {object}
         * @returns {object} - rejected promise
         * Display an error message if the API returns an error.
         * To customize the error message, set errorMessage in the $http options:
         *   $http({
         *     …
         *     errorMessage: 'A custom error message.'
         *     …
         *   });
         * To suppress error messages, set errrorMessage to false:
         *   $http({
         *     …
         *     errorMessage: false
         *     …
         *   });
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'rejection' implicitly has an 'any' type... Remove this comment to see the full error message
        function responseError(rejection) {
            var message;
            if (angular.isDefined(rejection.config) &&
                rejection.config.url.indexOf(PRODUCT_URLS.api) === 0) {
                // API ENDPOINT ERROR
                // if an error message was returned
                if (rejection.config.errorMessage !== false) {
                    // define the message
                    message = getErrorMessage(rejection.config, rejection.data, rejection.status);
                    //respond to HTTP status
                    switch (rejection.status) {
                        //Unknown resource
                        case 404:
                            $rootScope.$emit('errorScreen:404');
                            break;
                        //all others
                        default:
                            $rootScope.$emit('notify', message, 'error');
                    }
                }
            }
            else if (angular.isDefined(rejection.config) &&
                rejection.config.url.indexOf(TEMPLATE_PATH) !== -1) {
                // TEMPLATE ERROR
                // This is expected to be displayed when a new app is published and the old files are removed from the server.
                // This will also show if there is network traffic or a typo that prevents a template from loading.
                // TODO: Handle deployments in a more graceful fashion.
                $rootScope.$emit('notify', 'Some parts of this app could not be loaded. Please reload your browser.', 'error');
            }
            else if (rejection instanceof Error) {
                $rootScope.$emit('notify', 'There was a problem connecting to the server.', 'error');
                console.error(rejection);
            }
            //send back rejection object
            return $q.reject(rejection);
        }
    }
})();

(function () {
    angular
        .module('ETWServices')
        .factory('ETWServicesUtils', [
        '$http',
        '$q',
        '$rootScope',
        'PRODUCT_URLS',
        'API_SERVICES_URLS',
        ETWServicesUtilsFactory,
    ]);
    /**
     * @constant LOCAL_TIMEZONE_OFFSET_MINUTES
     * @type {number}
     * How many minutes behind UTC (GMT).
     * Arizona is MST, which has an offset of 420.
     * Zones east of UTC will have a negative value.
     */
    var LOCAL_TIMEZONE_OFFSET_MINUTES = new Date().getTimezoneOffset();
    /**
     * @factory ETWServicesUtilsFactory
     * @constructor
     * All reusable code for services that connect to the ETW API goes here.
     */
    function ETWServicesUtilsFactory($http, $q, $rootScope, PRODUCT_URLS, API_SERVICES_URLS) {
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
         * @property attachmentTypes
// @ts-ignore ts-migrate(7006) FIXME: Parameter '$q' implicitly has an 'any' type.
         * @type {object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'API_SERVICES_URLS' implicitly has an 'a... Remove this comment to see the full error message
        var attachmentTypes = {
            link: {
                name: 'link',
                path: '/links',
            },
            file: {
                name: 'file',
                path: '/files',
            },
        };
        /**
         * @property callbacks
         * @type {object}
         */
        var callbacks = {};
        var service = {
            addDays: addDays,
            all: $q.all,
            asGuid: asGuid,
            asId: asId,
            asUrlParam: encodeURIComponent,
            attachmentDestroy: attachmentDestroy,
            attachmentSave: attachmentSave,
            attachmentUpload: attachmentUpload,
            daysBetweenDates: daysBetweenDates,
            decodePaginatedResponse: decodePaginatedResponse,
            decodeResponse: decodeResponse,
            defer: $q.defer,
            destroy: destroy,
            encodeParamCollection: encodeParamCollection,
            error: error,
            generateUniqueValueForColumn: generateUniqueValueForColumn,
            getEndpointUrl: getEndpointUrl,
            getEndpointUrlForClient: getEndpointUrlForClient,
            notify: notify,
            notifyErrorMessage: notifyErrorMessage,
            paginate: paginate,
            reject: $q.reject,
            resolve: $q.resolve,
            save: save,
            showSaveStatus: showSaveStatus,
            subscribe: subscribe,
            toDate: toDate,
            unsubscribe: unsubscribe,
            unsubscribeAll: unsubscribeAll,
            upload: upload,
        };
        return service;
        /**
         * @method addDays
         * @param date {Date} - the date to add days to
         * @param days {number} - number of days to add
         * @returns {Date} copy of date with added number of days
         */
        function addDays(date, days) {
            var result = new Date(date.getTime());
            result.setDate(result.getDate() + days);
            return result;
        }
        /**
         * @function asDate
         * @param str {string|date}
         * @returns {date}
         * @private
         * Force the string to be an
         */
        function asDate(str) {
            var d = angular.isDate(str) ? str : new Date(str);
            if (isNaN(d.getFullYear())) {
                notifyErrorMessage('Could not connect to the server because a date field is the wrong format.');
                throw new FormatException(str, 'Date');
            }
            return d;
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'date' implicitly has an 'any' type.
         * @function asGuid
         * @param str {string}
         * @returns {string}
         * @private
         * Force the string to be a RFC4122 GUID
         */
        function asGuid(str) {
            var matches;
            if (str) {
                matches = String(str).match(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i);
            }
            if (!str || !matches) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'str' implicitly has an 'any' type.
                notifyErrorMessage('Could not connect to the server because an ID is the wrong format.');
                throw new FormatException(str, 'GUID');
            }
            return matches[0];
        }
        /**
         * @function asId
         * @param str {string|number}
         * @returns {number}
         * @private
// @ts-ignore ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
         * Force the string to be an integer
         */
        function asId(str) {
            var formattedNumber = parseInt(str, 10);
            if (formattedNumber != str) {
                //notifyErrorMessage('Could not connect to the server because an ID is the wrong format.');
                throw new FormatException(str, 'ID');
            }
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'str' implicitly has an 'any' type.
            return formattedNumber;
        }
        /**
         * @method attachmentDestroy
         * @param type {string} - [link | file]
         * @param baseUrl {string}
         * @param attachment {object}
         * @param [modelDefinition] {object}
         * @param [serviceName] {string}
         * @returns {object}
         * Deletes an attachment.
         */
        // @ts-ignore ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
        function attachmentDestroy(type, baseUrl, attachment, modelDefinition, serviceName) {
            var options = {
                errorMessage: 'The ' + attachmentTypes[type].name + ' could not be removed.',
                url: baseUrl + attachmentTypes[type].path + '/' + asId(attachment.id),
            };
            return destroy(options, modelDefinition, serviceName);
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'str' implicitly has an 'any' type.
         * @method attachmentSave
         * @param type {string}
         * @param baseUrl {string}
         * @param attachment {object}
         * @param isAdminEntity {boolean}
         * @param [modelDefinition] {object}
         * @param [serviceName] {boolean}
// @ts-ignore ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
         * attachment: id, link, name
         */
        function attachmentSave(type, baseUrl, attachment, isAdminEntity, modelDefinition, serviceName) {
            var options;
            // 'name' must be present in the request payload. If undefined, the API will reject the request.
            attachment.name = attachment.name || '';
            if (attachment.id) {
                // update
                options = {
                    errorMessage: 'The ' + attachmentTypes[type].name + ' could not be updated.',
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
                    idName: 'id',
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'serviceName' implicitly has an 'any' ty... Remove this comment to see the full error message
                    properties: ['link', 'name'],
                    data: attachment,
                    // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                    url: baseUrl + attachmentTypes[type].path + '/' + asId(attachment.id),
                };
                // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            }
            else {
                // add
                //attempt to save the link
                options = {
                    data: attachment,
                    errorMessage: 'Unable to save the ' + attachmentTypes[type].name + '.',
                    method: 'POST',
                    url: baseUrl + attachmentTypes[type].path + (isAdminEntity ? '/admin' : ''),
                };
            }
            // @ts-ignore
            return save(options, modelDefinition, serviceName);
        }
        /**
         * @method attachmentUpload
         * @param baseUrl {string}
         * @param attachment {Blob} - See FormData API
         * @param isAdminEntity {boolean}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
         * @param baseDownloadUrl {string}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'isAdminEntity' implicitly has an 'any' ... Remove this comment to see the full error message
         * @param [modelDefinition] {string} - service-specific column rules; TBD
         * @param [serviceName] {string}
         * @returns {object}
         * Uploads a file.
         */
        function attachmentUpload(baseUrl, attachment, isAdminEntity, baseDownloadUrl, modelDefinition, serviceName) {
            var options = {
                data: {},
                // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                errorMessage: 'The file could not be uploaded.',
                url: baseUrl + '/files' + (isAdminEntity ? '/admin' : ''),
            };
            return upload(options, 'files', attachment).then(function (response) {
                if (angular.isArray(response.data)) {
                    // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                    _.forEach(response.data, function (file) {
                        file.downloadUrl = baseDownloadUrl + '/file/' + file.id;
                    });
                }
                else {
                    response.data.downloadUrl = baseDownloadUrl + '/file/' + response.data.id;
                }
                if (serviceName) {
                    notify(serviceName);
                }
                return response;
            }, service.reject);
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        }
        /**
         * @method daysBetweenDates
         * @param  {Date} startDate the start date
// @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
         * @param  {Date} endDate the end date
         * @return {number}       number of days between the two dates
         */
        // @ts-ignore ts-migrate(2554) FIXME: Expected 4 arguments, but got 3.
        function daysBetweenDates(startDate, endDate) {
            // Get 1 day in milliseconds
            var one_day = 1000 * 60 * 60 * 24;
            // Convert both dates to milliseconds
            var startDate_ms = startDate.getTime();
            var endDate_ms = endDate.getTime();
            // Calculate the difference in milliseconds
            var difference_ms = endDate_ms - startDate_ms;
            // Convert back to days and return
            return Math.floor(difference_ms / one_day);
        }
        /**
         * @method decodePaginatedResponse
         * @param modelDefinition {object}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'baseUrl' implicitly has an 'any' type.
         * @returns {Function}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'isAdminEntity' implicitly has an 'any' ... Remove this comment to see the full error message
         * Used in Promise chains to decode columns from Paginated responses of the type:
         *  - {paginationDTO: {}, records: [], totalRecords: X}
         */
        function decodePaginatedResponse(modelDefinition) {
            return function (response) {
                _.forEach(response.data.records, function (record) {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                    decodeResponseRecord(modelDefinition.decoders, modelDefinition.columns, record);
                });
                return response;
            };
        }
        /**
         * @method decodeResponse
         * @param modelDefinition {object}
         * @returns {Function}
         * Curries the ModelDefinition.columns with a promise handler.
         * Pass in the column config and any columns defined will determine if matching keys from
         * the response data will be passed through a formatter.
         * Usage:
         *   $http(…).then(
         *     ETWServicesUtils.decodeResponse({ myDateField: 'date' }),
         *     ETWServicesUtils.reject
         *   );
         */
        function decodeResponse(modelDefinition) {
            return function (response) {
                if (modelDefinition && (modelDefinition.columns || modelDefinition.callbacks)) {
                    if (angular.isArray(response.data)) {
                        _.forEach(response.data, function (record) {
                            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'startDate' implicitly has an 'any' type... Remove this comment to see the full error message
                            decodeResponseRecord(modelDefinition.decoders, modelDefinition.columns, record);
                        });
                    }
                    else {
                        decodeResponseRecord(modelDefinition.decoders, modelDefinition.columns, response.data);
                    }
                }
                return response;
            };
        }
        /**
         * @function decodeResponseRecord
         * @param decoders {Array} - optional array of functions that mutate record
         * @param columns {object} - map of column names
         * @param record {object} - row from API response
         * @returns {void}
         * @private
         * Called exclusively from decodeResponse()
         * Function that can be applied to a single response object or each item in a response array.
         */
        function decodeResponseRecord(decoders, columns, record) {
            _.forOwn(decoders, function (callback) {
                callback(record);
            });
            _.forOwn(columns, function (value, key) {
                var theDate = record[key];
                switch (columns[key]) {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'modelDefinition' implicitly has an 'any... Remove this comment to see the full error message
                    case 'date':
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                        if (theDate) {
                            record[key] = toDate(record[key]);
                        }
                        break;
                    case 'simpleDate':
                        if (theDate) {
                            record[key] = asDateAtLocalMidnight(record[key]);
                        }
                        break;
                }
            });
        }
        /**
         * @method destroy
         * @param options {object}
         * @param [modelDefinition] {object} - service-specific column rules, TBD
         * @param [serviceName] {string} - Sends notification for service
         * @returns {object} - promise
         */
        function destroy(options, modelDefinition, serviceName) {
            var promise;
            _.defaults(options, { method: 'DELETE' });
            promise = $http(options);
            if (serviceName) {
                promise = promise.finally(function () {
                    notify(serviceName);
                });
            }
            return promise;
        }
        /**
         * @function encodeParam
         * @param parameters {object}
         * @param param {string}
         * @param type {string}
         * @private
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'modelDefinition' implicitly has an 'any... Remove this comment to see the full error message
         * If param exists in parameters, format it for use with $http.
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
         * Original need was to format simple arrays into a format expected by the API, that is arrays are stringified.
         * Note: for the reverse, see decodeParam() in mocks.
         */
        function encodeParam(parameters, param, type) {
            if (angular.isDefined(parameters[param])) {
                switch (type) {
                    case 'boolean':
                        parameters[param] = Boolean(parameters[param]);
                        break;
                    case 'array':
                        if (!angular.isString(parameters[param])) {
                            parameters[param] = JSON.stringify(parameters[param]);
                        }
                        break;
                    case 'date':
                        parameters[param] = toDate(parameters[param]);
                        break;
                    case 'simpledate':
                        parameters[param] = toSimpleDate(parameters[param]);
                        break;
                }
            }
        }
        /**
         * @method encodeParamCollection
         * @param parameters {object}
         * @param formats {object} - key: parameters key, value: format (array)
         * Pass an map of parameters to encode. Calls encodeParam() on each one.
         */
        function encodeParamCollection(parameters, formats) {
            var format;
            for (format in formats) {
                if (formats.hasOwnProperty(format)) {
                    encodeParam(parameters, format, formats[format]);
                }
            }
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'decoders' implicitly has an 'any' type.
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'columns' implicitly has an 'any' type.
         * @method error
         * @param response {object} - response from $http promise
         * Generic method for handling error responses from the server.
         * Note: Some error responses are handled by etwServicesInterceptor.
         */
        function error(response) {
            var message;
            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                message = response.data.message;
            }
            else {
                message = 'There was a problem with the response from the server.';
            }
            notifyErrorMessage(message);
        }
        /**
         * @exception FormatException
         * @param property {*}
         * @param type {string}
         * @constructor
         */
        function FormatException(property, type) {
            this.name = 'ETWServicesFormatException';
            this.message = 'The passed value is not a proper ' + type + ': "' + property + '".';
            console.trace();
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'options' implicitly has an 'any' type.
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'modelDefinition' implicitly has an 'any... Remove this comment to see the full error message
         * @method generateUniqueValueForColumn
         * @param getAllExistingMethod {function} - function that returns a promise with response.data
         * @param columnName {string} - name of the column to compare in response.data
         * @param prefix {string} - default value to use, might append a space and number
         * @returns {object} - promise
         * Determined a unique value for a column based on a prefix and all existing columns.
         * Initially used to create a unique groupName for PermissionGroupsService.
         * Note: getAll() should be cached.
         * Usage:
         *    // Assuming service has getAll() that returns $http()
         *    ETWServicesUtils.generateUniqueValueForColumn(getAll, 'title', 'Untitled').then(function (uniqueValue) {
         *			options.data.title = uniqueValue;
         *			return ETWServicesUtils.save(options);
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'parameters' implicitly has an 'any' typ... Remove this comment to see the full error message
         *		});
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'param' implicitly has an 'any' type.
         * Results in 'Untitled', then 'Untitled 1', 'Untitled 2', etc.
         */
        function generateUniqueValueForColumn(getAllExistingMethod, columnName, prefix) {
            // Call the getAll() method
            return getAllExistingMethod().then(function (response) {
                var autoGeneratedId = 0, value = prefix, 
                // iterate through the response from the getAll method
                previouslyGeneratedValues = _.filter(response.data, function (row) {
                    // Look for columns that already have the prefix
                    var matches;
                    if (angular.isString(row[columnName])) {
                        matches = row[columnName].match(new RegExp('^' + prefix + '(\\s(\\d+))?$'));
                        if (matches && matches.length > 2 && angular.isDefined(matches[2])) {
                            // If there are prefixes that already have been incremented, find the max
                            autoGeneratedId = Math.max(0, autoGeneratedId, Number(matches[2]));
                        }
                    }
                    // Return true if a column has just the prefix or the prefix with an increment
                    return matches !== null;
                });
                if (previouslyGeneratedValues.length) {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'parameters' implicitly has an 'any' typ... Remove this comment to see the full error message
                    // If the prefix has already been used, increment it one more
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'formats' implicitly has an 'any' type.
                    value = prefix + ' ' + (autoGeneratedId + 1);
                }
                // Return the new default value for the column
                return value;
            });
        }
        /**
         * @method getEndpointUrl
         * @param endpointName {string} - Name of property of API_SERVICES_URLS constant
         * @returns {string}
         * Return the URL to the appropriate service WITHOUT including the clientId
         */
        function getEndpointUrl(endpointName) {
            var u = PRODUCT_URLS.api + API_SERVICES_URLS[endpointName];
            return u.replace('%CLIENT%', '');
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
         * @method getEndpointUrlForClient
         * @param endpointName {string} - Name of API_SERVICES_URLS property
         * @param clientName {string}
         * @returns {string}
         * Return the URL for the API service including the clientId.
         * See getEndpointUrl()
         */
        function getEndpointUrlForClient(endpointName, clientName) {
            var u = PRODUCT_URLS.api + API_SERVICES_URLS[endpointName], n = encodeURIComponent(clientName);
            return u.replace('%CLIENT%', '/clients/' + n);
        }
        /**
         * @method notify
         * @param serviceName {string}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'property' implicitly has an 'any' type.
         * Notify observers.
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
         * Iterates through callbacks subscribed for a given service.
// @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
         * Note: not related to notify library.
         */
        function notify(serviceName) {
            _.forOwn(callbacks[serviceName], function (cb) {
                cb();
            });
        }
        /**
         * @method notifyErrorMessage
         * @param message {string}
         * Display a pop-up (bubble) notification to the user.
         */
        function notifyErrorMessage(message) {
            if (!angular.isString(message)) {
                // Developer fail if this is ever shown to the user. Shame!
                message = "Something's wrong with the API.";
            }
            $rootScope.$emit('notify', message, 'error');
        }
        /**
         * @function paginate
         * @param modelDefinition {object}
         * @param previousKey {string|undefined}
         * @returns {Function}
         * @private
         * Curries the startKey and adds pagination metadata to a $http response.
         */
        function paginate(modelDefinition, previousKey) {
            return function (response) {
                var nextKey, last;
                // Get key BEFORE it is decoded
                last = _.findLast(response.data, 'lastEvalKey');
                if (last) {
                    nextKey = last.lastEvalKey;
                }
                // Decode columns
                response = decodeResponse(modelDefinition)(response);
                // Add pagination metadata
                // TODO: Hopefully API will someday send metadata
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'getAllExistingMethod' implicitly has an... Remove this comment to see the full error message
                response.data = {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'columnName' implicitly has an 'any' typ... Remove this comment to see the full error message
                    nextKey: nextKey,
                    previousKey: previousKey,
                    result: response.data,
                };
                return response;
            };
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
         * @method save
         * @param options {object}
         * - url {string} - required
         * - data {object} - required
         * - [idName] {string} - optional. name of the id column
         * - [properties] {array} - optional. Null for all properties
         * @param [modelDefinition] {object} - information about the model for data validation
         * @param [serviceName] {string} - if present, notify subscribers
         * @param [callback] {Function} - if present, called *before* promise resolves
         * @returns {object} - promise
         * Save a complete or partial resource
         * idName is the name of the id, so for an existing record, data[idName] should work
         *
         * Note: callback is provided to ensure code can run *before* subscribers are notified.
         * To keep code DRY, save() will automatically notify subscribers. $http caches need to be
         * cleared before notify(), so callback runs before notify. If your callback has nothing to
         * do with subscribers, use the returned promise instead.
         */
        function save(options, modelDefinition, serviceName, callback) {
            var method = 'POST', httpConfig, data = _.cloneDeep(options.data);
            if (angular.isUndefined(options.url)) {
                throw new Error('API URL is required to save a resource.');
            }
            // if the idName defined AND the id was passed
            if (angular.isDefined(options.idName) && !_.isNil(data[options.idName])) {
                //if properties were passed
                if (angular.isArray(options.properties) && options.properties.length) {
                    // PATCH: partial update
                    method = 'PATCH';
                    // Only send the specified properties.
                    data = _.pick(data, options.properties);
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'endpointName' implicitly has an 'any' t... Remove this comment to see the full error message
                }
                else {
                    // PUT: full update
                    // Note: Most API endpoints do not support PUT.
                    method = 'PUT';
                }
            }
            if (modelDefinition && angular.isDefined(modelDefinition.columns)) {
                _.forEach(modelDefinition.columns, function (type, column) {
                    var value;
                    if (!_.isNil(data[column])) {
                        switch (type) {
                            case 'array':
                                if (!angular.isArray(data[column])) {
                                    throw new FormatException(column, 'Array');
                                }
                                break;
                            case 'date':
                                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'endpointName' implicitly has an 'any' t... Remove this comment to see the full error message
                                if (angular.isDate(data[column]) || data[column].length) {
                                    // Check if a proper date, save as date object
                                    data[column] = asDate(data[column]);
                                }
                                else {
                                    data[column] = null;
                                }
                                break;
                            case 'number':
                                value = Number(data[column]);
                                data[column] = isNaN(value) ? null : value;
                                break;
                            case 'excluded':
                                delete data[column];
                                break;
                            case 'simpleDate':
                                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'serviceName' implicitly has an 'any' ty... Remove this comment to see the full error message
                                data[column] = toSimpleDate(data[column]);
                                // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                                break;
                        }
                    }
                });
            }
            // Set the options for $http
            httpConfig = {
                data: data,
                method: options.method || method,
                url: options.url,
            };
            // Add custom error message (even if false)
            if (angular.isDefined(options.errorMessage)) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'message' implicitly has an 'any' type.
                httpConfig.errorMessage = options.errorMessage;
            }
            var promise;
            promise = $http(httpConfig).then(decodeResponse(modelDefinition), service.reject);
            // Show the "Saving…" box.
            showSaveStatus(promise);
            // Optional callback (probably to clear cache) and Notify Subscribers
            if (angular.isDefined(serviceName) || angular.isDefined(callback)) {
                // Callback and notify subscribers on success.
                promise = promise.then(function (response) {
                    try {
                        // Note: callback runs *before* notify.
                        // If your code can wait, use the promise instead.
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'modelDefinition' implicitly has an 'any... Remove this comment to see the full error message
                        if (callback) {
                            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'previousKey' implicitly has an 'any' ty... Remove this comment to see the full error message
                            callback();
                        }
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                        // Note: notify runs *after* callback
                        if (serviceName) {
                            notify(serviceName);
                        }
                    }
                    catch (e) {
                        console.error(e);
                    }
                    return response;
                });
            }
            return promise;
        }
        /**
         * @method showSaveStatus
         * @param promise {object}
         * @returns {void}
         * Emits an event for the saving-notification directive.
         * When called, the "Saving…" box shows on the bottom right of the screen.
         * When the promise is resolved, the box goes away.
         * Note: Do NOT return the promise; this should be its own promise chain so as to not interfere with existing error handling.
         * TODO: The directive should just subscribe directly with a callback instead of getting $rootScope involved.
         */
        function showSaveStatus(promise) {
            $rootScope.$emit('save');
            promise.then(function saveSuccess() {
                $rootScope.$emit('saveSuccess');
            }, function saveError() {
                $rootScope.$emit('saveError');
            });
        }
        /**
         * @method subscribe
         * @param serviceName {string}
         * @returns {Function}
         * Curries a method to subscribe a callback with the service name.
         * Callbacks are stored by serviceName and then a unique id.
         * The unique id is returned to unsubscribe later.
         */
        function subscribe(serviceName) {
            return function (callback) {
                var index = _.uniqueId();
                if (!callbacks[serviceName]) {
                    callbacks[serviceName] = {};
                }
                callbacks[serviceName][index] = callback;
                return index;
            };
        }
        /**
         * TODO: make dynamic, not just AZ time
         * @function toDate
         * @param str {string}
         * @returns {Date}
         * Checks to see if date has time and time zone.
         * Different than $filter('date') because this returns a Date object (with timezone), not a string.
         * matches:
         *   0: all
         *   1: date
         *   2: all time
         *   3: time
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'options' implicitly has an 'any' type.
         *   4: all timezone
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'serviceName' implicitly has an 'any' ty... Remove this comment to see the full error message
         *   5: timezone offset
         */
        function toDate(str) {
            var matches, result;
            if (angular.isDate(str)) {
                result = str;
            }
            if (str) {
                matches = String(str).match(/^([0-9-]+)(T([0-9:.]+)([-+Z](.+))?)?$/);
                if (matches && !matches[3]) {
                    str += 'T00:00';
                }
                if (matches && !matches[4]) {
                    str += '-07:00';
                }
                result = new Date(str);
            }
            else {
                result = str;
            }
            return result;
        }
        /**
         * @function toSimpleDate
         * @param datetime {Date}
         * @returns {string} - "YYYY-MM-DD"
         * Encodes a Date object to an ISO-8601 formatted string
         * Using the timezone offset, the time is set to midnight UTC, in local time
         * Setting midnight UTC ensures the date of the ISO string won't be tomorrow or yesterday.
         */
        function toSimpleDate(datetime) {
            datetime.setHours(0, 0 - LOCAL_TIMEZONE_OFFSET_MINUTES, 0, 0);
            return datetime.toISOString().slice(0, 10);
        }
        /**
         * @function asDateAtLocalMidnight
         * @param simpleDateString
         * @returns {Date}
         * Decodes a simple date (no time) into a date object at local midnight.
         * Since Date() assumes UTC, the date could be different when displayed in the local timezone.
         */
        function asDateAtLocalMidnight(simpleDateString) {
            var p = _.map(simpleDateString.split('-').slice(0, 3), _.toInteger);
            return new Date(p[0], p[1] - 1, p[2], 0, 0, 0, 0);
        }
        /**
// @ts-ignore ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
         * @method unsubscribe
         * @param serviceName {string}
         * @returns {Function}
         * Curries a method to unsubscribe a single callback for the given service.
         * Pass the unique ID returned from subscribe()
         */
        function unsubscribe(serviceName) {
            return function (index) {
                if (callbacks[serviceName]) {
                    if (callbacks[serviceName].length === 1) {
                        delete callbacks[serviceName];
                    }
                    else {
                        delete callbacks[serviceName][index];
                    }
                }
            };
        }
        /**
         * @method unsubscribeAll
         * @param serviceName {string}
         * @returns {Function}
         * Curries a method to unsubscribe all callbacks for the given service name.
         * Usually called by the $onDestroy event in a controller.
         */
        function unsubscribeAll(serviceName) {
            return function () {
                delete callbacks[serviceName];
            };
        }
        /**
         * @method upload
         * @param options {object}
         * @param columnName {string}
         * @param file {Blob} - (Yes, Blob. See FormData API)
         * @returns {object} - promise
         */
        function upload(options, columnName, file) {
            var formData, promise;
            // Test for FormData, which only exists in modern browsers.
            if (angular.isDefined(FormData)) {
                formData = new FormData();
                formData.append(columnName, file);
                promise = $http({
                    headers: {
                        'Content-Type': undefined,
                    },
                    data: formData,
                    method: options.method || 'POST',
                    transformRequest: angular.identity,
                    url: options.url,
                });
            }
            else {
                // Reject promise if FormData doesn't exist.
                promise = service.reject({
                    message: 'FormData is not supported by this browser.',
                });
            }
            return promise;
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.

(function () {
    /**
     * @constant GOAL_TYPES
     * @type {Array}
     * Static goal types and how they map to properties in an Evaluation.
     */
    var GOAL_TYPES = [
        {
            title: 'Culture',
            type: 'CULTURE',
            category: 'alignment',
            property: 'cultureGoalScore',
        },
        {
            title: 'Leadership',
            type: 'LEADERSHIP',
            category: 'alignment',
            property: 'leadershipGoalScore',
        },
        {
            title: 'Role',
            type: 'ROLE',
            category: 'performance',
            property: 'roleGoalScore',
        },
        {
            title: 'Personal',
            type: 'PERSONAL',
            category: 'performance',
            property: 'personalGoalScore',
        },
        {
            title: 'Plan',
            type: 'PLAN',
            category: 'performance',
            property: 'planGoalScore',
        },
        {
            title: 'Manager Assigned',
            type: 'MANAGER_ASSIGNED',
            category: 'performance',
            property: 'managerAssignedGoalScore',
        },
    ];
    var STATES = [
        {
            isCompleted: false,
            state: 'NOTSTARTED',
        },
        {
            isCompleted: false,
            state: 'INPROGRESS',
        },
        {
            isCompleted: true,
            state: 'SKIPPED',
        },
        {
            isCompleted: true,
            state: 'SUBMITTED',
        },
    ];
    angular
        .module('ETWServices')
        .factory('EvaluationsService', ['$http', 'ETWServicesUtils', EvaluationsServiceFactory]);
    function EvaluationsServiceFactory($http, ETWServicesUtils) {
        var service = {
            NOTSTARTED: 0,
            INPROGRESS: 1,
            SKIPPED: 2,
            SUBMITTED: 3,
            GOAL_TYPES: GOAL_TYPES,
            all: ETWServicesUtils.all,
            getAllForPerson: getAllForPerson,
            getAllPastForPerson: getAllPastForPerson,
            getAverageScore: getAverageScore,
            getById: getById,
            getIsEvaluationCompleted: getIsEvaluationCompleted,
            getPeopleCollections: getPeopleCollections,
            reject: ETWServicesUtils.reject,
            // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
            resolve: ETWServicesUtils.resolve,
            save: save,
            submit: submit,
            subscribe: ETWServicesUtils.subscribe('EvaluationsService'),
            unsubscribe: ETWServicesUtils.unsubscribe('EvaluationsService'),
        };
        /**
         * @property completedServiceUrl
         * @type {string}
         * API for completed evaluations
         */
        var completedServiceUrl = ETWServicesUtils.getEndpointUrl('PAST_EVALUATIONS');
        /**
         * @property serviceUrl
         * @type {string}
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('EVALUATIONS');
        return service;
        /**
         * @method getAllForPerson
         * @param personId {number}
         * @param [isCompleted] {boolean=false} - current or completed evaluations
         * @returns {object} - promise, Array
         */
        function getAllForPerson(personId, isCompleted) {
            var path = isCompleted ? '/pastevaluations' : '';
            return $http({
                errorMessage: 'The evaluations for this person could not be retrieved.',
                method: 'GET',
                url: serviceUrl + '/users/' + ETWServicesUtils.asId(personId) + path,
            });
        }
        /**
         * @method getAllPastForPerson
         * @param personId {number}
         * @returns {object} - promise, array
         */
        function getAllPastForPerson(personId) {
            return $http({
                errorMessage: 'The completed evaluations for this person could not be retrieved.',
                method: 'GET',
                url: serviceUrl + '/users/' + ETWServicesUtils.asId(personId),
            });
        }
        /**
         * @function getAverageScore
         * @param evaluation {object}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'personId' implicitly has an 'any' type.
         * @return {number} the average of all three
         */
        function getAverageScore(evaluation) {
            var averageScore;
            var scoreCount = 3;
            if (evaluation.averageScore) {
                averageScore = evaluation.averageScore;
            }
            else {
                if (evaluation.performanceScore === 0) {
                    scoreCount--;
                }
                if (evaluation.leadershipScore === 0) {
                    scoreCount--;
                }
                if (evaluation.cultureScore === 0) {
                    scoreCount--;
                }
                averageScore =
                    (evaluation.performanceScore + evaluation.leadershipScore + evaluation.cultureScore) /
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'personId' implicitly has an 'any' type.
                        scoreCount;
            }
            return averageScore;
        }
        /**
         * @method getById
         * @param id {number}
         * @param [isCompleted] {boolean=false} - whether this ID is for a completed evaluation.
         * @returns {object} - promise, object
         */
        function getById(id, isCompleted) {
            var baseUrl = isCompleted ? completedServiceUrl : serviceUrl;
            return $http({
                errorMessage: false,
                method: 'GET',
                url: baseUrl + '/' + ETWServicesUtils.asId(id),
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'evaluation' implicitly has an 'any' typ... Remove this comment to see the full error message
            }).then(function getByIdSuccess(response) {
                return response;
            }, function getBySuccessError(response) {
                var message = (response.data && response.data.error) || 'This evaluation could not be accessed.';
                if (response.status === 403) {
                    message = 'You do not have access to view this evaluation.';
                }
                else if (response.status === 404) {
                    message = 'This evaluation does not exist.';
                }
                ETWServicesUtils.notifyErrorMessage(message);
                return ETWServicesUtils.reject(response);
            });
        }
        /**
         * @method getIsEvaluationCompleted
         * @param evaluation {object}
         * @returns {boolean}
         * Pass in an evaluation to get a boolean if it is completed.
         * Completed evaluations are stored in a different database.
         */
        function getIsEvaluationCompleted(evaluation) {
            var state = evaluation && STATES[evaluation.state];
            return state && state.isCompleted;
        }
        /**
         * @method getPeopleCollections
         * @param primaryAttribute {number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
         * @param secondaryAttribute {number}
         * @returns {object} - promise, Array
         */
        function getPeopleCollections(primaryAttribute, secondaryAttribute) {
            var params = {};
            if (primaryAttribute) {
                // @ts-ignore
                params.primaryAttribute = ETWServicesUtils.asId(primaryAttribute);
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                if (secondaryAttribute) {
                    //secondary attribute is optional only if you have a primary selected
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                    params.secondaryAttribute = ETWServicesUtils.asId(secondaryAttribute);
                }
            }
            return $http({
                errorMessage: 'People collections could not be retrieved',
                method: 'GET',
                params: params,
                url: serviceUrl + '/collections',
            });
        }
        /**
         * @method save
         * @param evaluation {object}
         * @param [changedProperties] {Array}
         * Note: UI never creates evaluations.
         * POST is used to complete (submit) an evaluation, not create one.
         */
        function save(evaluation, changedProperties) {
            var options;
            if (_.isNil(evaluation.id)) {
                throw new Error('Evaluations cannot be created. An ID for the evaluation is required.');
            }
            options = {
                errorMessage: false,
                data: evaluation,
                idName: 'id',
                method: 'PATCH',
            };
            if (evaluation.pastEvaluationUpdateHistories) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'evaluation' implicitly has an 'any' typ... Remove this comment to see the full error message
                options.url = completedServiceUrl + '/' + ETWServicesUtils.asId(evaluation.id);
            }
            else {
                options.properties = changedProperties;
                options.url = serviceUrl + '/' + ETWServicesUtils.asId(evaluation.id);
            }
            return ETWServicesUtils.save(options, undefined, 'EvaluationsService').catch(serviceExceptionHandler);
        }
        /**
         * @function serviceExceptionHandler
         * @param response {object}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'primaryAttribute' implicitly has an 'an... Remove this comment to see the full error message
         * @returns {object} - promise. Passes along another rejection with the response so the controller can act on it.
         * @private
         * When the API returns an error message, display to the user and pray that it's understandable by humans.
         * Response.data properties: timestamp, status, error, exception, message, path.
         */
        function serviceExceptionHandler(response) {
            var message = angular.isString(response.data.message)
                ? response.data.message
                : 'This evaluation could not be saved.';
            ETWServicesUtils.notifyErrorMessage(message);
            return ETWServicesUtils.reject(response);
        }
        /**
         * @method submit
         * @param evaluation {object}
         * @returns {object} - promise, object
         * Method called to complete a current evaluation.
         */
        function submit(evaluation) {
            return $http({
                data: {
                    state: service.SUBMITTED,
                },
                errorMessage: 'This evaluation could not be submitted.',
                method: 'POST',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'evaluation' implicitly has an 'any' typ... Remove this comment to see the full error message
                url: serviceUrl + '/' + ETWServicesUtils.asId(evaluation.id),
            });
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.

(function () {
    /**
     * @service FaviconService
     *
     * In an effort to notify the person that an ETW event has occurred,
     * like a new unread message, this service can be called to alter the
     * favicon image in the browser tab.
     *
     */
    angular
        .module('ETWServices')
        .factory('FaviconService', ['$window', 'IMAGE_PATH', FaviconServiceFactory]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$window' implicitly has an 'any' type.
    function FaviconServiceFactory($window, IMAGE_PATH) {
        /**
         * @property canvas
         * @type {object}
         * for drawing the new favicon with numbers we
         * need a canvas element
         */
        var canvas = document.createElement('canvas');
        /**
         * @property faviconUrl
         * @type {String}
         * The url to the original favicon
         */
        var faviconUrl = IMAGE_PATH + '/' + 'favicon.png';
        /**
         * @property font
         * @type {String}
         * for stylizing the number of unread messages
         * on the favicon
         */
        var font = 'Helvetica, Arial, sans-serif';
        /**
         * @property opacity
         * @type {Number}
         * what the default favicon opacity will
         * fade to if there is a message count
         */
        var opacity = 0.3;
        /**
         * @property placeholderImage
         * @type {object}
         * We need an image container to draw the
         * new canvas with
         */
        // @ts-ignore ts-migrate(7034) FIXME: Variable 'placeholderImage' implicitly has type 'a... Remove this comment to see the full error message
        var placeholderImage;
        /**
         * @property service
         * @type {Object}
         */
        var service = {
            setTotalUnreadMessages: setTotalUnreadMessages,
        };
        /**
         * @property unreadMessages
         * @type {Integer}
         */
        var unreadMessages = 0;
        /**
         * @property unreadMessagesString
         * @type {String}
         * For displaying the notify count as text
         */
        var unreadMessagesString = '';
        /**
         * @property updateFaviconThrottled
         * @type {method}
         */
        var updateFaviconThrottled = _.debounce(updateFavicon, 100);
        return service;
        /**
         * @method getCavasFaviconHref
         * @return {string}
         * This will create a new image based on the
         * favicon image and overlay an unread message
         * counter and return the href as data
         */
        function getCanvasFaviconHref() {
            var multiplier;
            var fontSize;
            var context;
            var xOffset;
            var yOffset;
            var border;
            var shadow;
            // Scale canvas elements based on favicon size
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'placeholderImage' implicitly has an 'any... Remove this comment to see the full error message
            multiplier = placeholderImage.width / 16;
            fontSize = multiplier * 11;
            xOffset = multiplier;
            yOffset = multiplier * 11;
            border = multiplier * 2;
            shadow = multiplier * 3;
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'placeholderImage' implicitly has an 'any... Remove this comment to see the full error message
            canvas.height = canvas.width = placeholderImage.width;
            context = canvas.getContext('2d');
            // @ts-ignore ts-migrate(2531) FIXME: Object is possibly 'null'.
            context.font = 'bold ' + fontSize + 'px ' + font;
            // Draw faded favicon background
            if (unreadMessages) {
                // @ts-ignore ts-migrate(2531) FIXME: Object is possibly 'null'.
                context.globalAlpha = opacity;
            }
            // @ts-ignore ts-migrate(2531) FIXME: Object is possibly 'null'.
            context.drawImage(placeholderImage, 0, 0);
            // @ts-ignore ts-migrate(2531) FIXME: Object is possibly 'null'.
            context.globalAlpha = 1.0;
            // Draw white drop shadow
            // @ts-ignore ts-migrate(2531) FIXME: Object is possibly 'null'.
            context.shadowColor = '#FFF';
            // @ts-ignore ts-migrate(2531) FIXME: Object is possibly 'null'.
            context.shadowBlur = shadow;
            // @ts-ignore ts-migrate(2531) FIXME: Object is possibly 'null'.
            context.shadowOffsetX = 0;
            // @ts-ignore ts-migrate(2531) FIXME: Object is possibly 'null'.
            context.shadowOffsetY = 0;
            // Draw white border
            // @ts-ignore ts-migrate(2531) FIXME: Object is possibly 'null'.
            context.fillStyle = '#FFF';
            // @ts-ignore ts-migrate(2531) FIXME: Object is possibly 'null'.
            context.fillText(unreadMessagesString, xOffset, yOffset);
            // @ts-ignore ts-migrate(2531) FIXME: Object is possibly 'null'.
            context.fillText(unreadMessagesString, xOffset + border, yOffset);
            // @ts-ignore ts-migrate(2531) FIXME: Object is possibly 'null'.
            context.fillText(unreadMessagesString, xOffset, yOffset + border);
            // @ts-ignore ts-migrate(2531) FIXME: Object is possibly 'null'.
            context.fillText(unreadMessagesString, xOffset + border, yOffset + border);
            // Draw black count
            // @ts-ignore ts-migrate(2531) FIXME: Object is possibly 'null'.
            context.fillStyle = '#000';
            // @ts-ignore ts-migrate(2531) FIXME: Object is possibly 'null'.
            context.fillText(unreadMessagesString, xOffset + border / 2.0, yOffset + border / 2.0);
            return canvas.toDataURL('image/png');
        }
        /**
         * @method normalizeUnreadMessages
         * This cleans up the unreadMessages and
         * sets limits, it also sets the text representation
         * of unreadMessagesString
         */
        function normalizeUnreadMessages() {
            // no new messages
            if (unreadMessages < 1) {
                unreadMessages = 0;
                unreadMessagesString = '';
            }
            if (unreadMessages > 0 && unreadMessages < 10) {
                unreadMessagesString = ' ' + unreadMessages;
            }
            if (unreadMessages > 9 && unreadMessages < 100) {
                unreadMessagesString = '' + unreadMessages;
            }
            // nothing over 99
            if (unreadMessages > 99) {
                unreadMessagesString = '99+';
            }
        }
        /**
         * @method setFaviconImage
         * @param {string} href
         * This replaces the href value for the favicon
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'href' implicitly has an 'any' type.
        function setFaviconImage(href) {
            $window.document.querySelector("link[rel*='icon']").href = href;
        }
        /**
         * @method setTotalUnreadMessages
         * @return {integer}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'count' implicitly has an 'any' type.
        function setTotalUnreadMessages(count) {
            unreadMessages = count;
            updateFaviconThrottled();
        }
        /**
         * @method updateFavicon
         * @return {none}
         * This checks to see of there are any unread
         * messages or not and calls to update the favicon
         */
        function updateFavicon() {
            normalizeUnreadMessages();
            if (unreadMessages === 0) {
                setFaviconImage(faviconUrl);
            }
            if (unreadMessages > 0) {
                placeholderImage = document.createElement('img');
                // @ts-ignore ts-migrate(2774) FIXME: This condition will always return true since the f... Remove this comment to see the full error message
                if (canvas.getContext) {
                    placeholderImage.crossOrigin = 'anonymous';
                    placeholderImage.onload = function () {
                        var canvasFaviconHref = getCanvasFaviconHref();
                        setFaviconImage(canvasFaviconHref);
                    };
                    placeholderImage.src = faviconUrl;
                }
            }
        }
    }
})();

(function () {
    angular
        .module('ETWServices')
        .factory('GoalCategoriesService', [
        '$http',
        'AuthenticationService',
        'ETWServicesUtils',
        GoalCategoriesServiceFactory,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
    function GoalCategoriesServiceFactory($http, AuthenticationService, ETWServicesUtils) {
        /**
         * @property usersServiceUrl
         * @type {string}
         */
        var clientServiceUrl = ETWServicesUtils.getEndpointUrlForClient('CATEGORIES', AuthenticationService.getAccount().clientIdNum);
        /**
         * @property goalServiceUrl
         * @type {string}
         */
        var goalServiceUrl = ETWServicesUtils.getEndpointUrl('GOALS');
        /**
         * @property modelDefinition
         * @type {Object}
         * Configuration object used by ETWServicesUtils for formatting or excluding certain columns.
         */
        var modelDefinition = {
            columns: {
                _highlighted: 'excluded',
                _isError: 'excluded',
                _isTemporary: 'excluded',
            },
        };
        /**
         * @property serviceUrl
         * @type {string}
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('CATEGORIES');
        var service = {
            assign: assign,
            destroy: destroy,
            getAll: getAll,
            getNew: getNew,
            reject: ETWServicesUtils.reject,
            resolve: ETWServicesUtils.resolve,
            save: save,
            sort: sort,
        };
        return service;
        /**
         * @method assign
         * @param categoryId {number}
         * @param goalId {number}
         * @returns {object}
         * Called by GoalsService.assignToCategory()
         * Note: Use GoalsService method instead to clear cached Goals
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'categoryId' implicitly has an 'any' typ... Remove this comment to see the full error message
        function assign(categoryId, goalId) {
            return $http({
                errorMessage: 'Unable to assign category',
                method: 'POST',
                url: goalServiceUrl +
                    '/' +
                    ETWServicesUtils.asId(goalId) +
                    '/categories/' +
                    ETWServicesUtils.asId(categoryId),
            });
        }
        /**
         * @method destroy
         * @param categoryId {number}
         * @param newCategoryId {number}
         * @returns {object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'categoryId' implicitly has an 'any' typ... Remove this comment to see the full error message
        function destroy(categoryId, newCategoryId) {
            return $http({
                errorMessage: 'This Category could not be removed',
                method: 'DELETE',
                params: {
                    categoryToReassignToId: ETWServicesUtils.asId(newCategoryId),
                },
                url: serviceUrl + '/' + ETWServicesUtils.asId(categoryId),
            });
        }
        /**
         * @method getAll
         * @returns {object} - promise, Array
         */
        function getAll() {
            var promise = $http({
                errorMessage: 'Unable to retrieve all goal categories',
                method: 'GET',
                url: clientServiceUrl,
            });
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            return promise.then(function (response) {
                response.data = sort(response.data);
                return response;
            }, ETWServicesUtils.reject);
        }
        /**
         * @method getNew
         * @returns {object} - promise, object
         */
        function getNew() {
            return ETWServicesUtils.resolve({
                data: {
                    title: undefined,
                    enableAutolink: false,
                    editable: true,
                    defaultCategory: false,
                },
            });
        }
        /**
         * @method save
         * @param category {object}
         * @param [properties] {Array}
         * @returns {object} - promise, object
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'category' implicitly has an 'any' type.
        function save(category, properties) {
            var options = {
                errorMessage: 'Can not save goal category',
                data: category,
                properties: properties,
                url: serviceUrl,
                idName: 'id',
            };
            if (angular.isDefined(category.id)) {
                options.url = serviceUrl + '/' + ETWServicesUtils.asId(category.id);
            }
            return ETWServicesUtils.save(options, modelDefinition, 'GoalCategoriesService');
        }
        /**
         * @function sort
         * @public
         * Arrange categories in a particular order.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'categories' implicitly has an 'any' typ... Remove this comment to see the full error message
        function sort(categories) {
            return _.orderBy(categories, ['defaultCategory', sortCategoriesTitleIterator], ['desc', 'asc']);
        }
        /**
         * @function sortCategoriesTitleIterator
         * @param category {object}
         * @returns {string}
         * @private
         * Allow case-insensitive sorting by title.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'category' implicitly has an 'any' type.
        function sortCategoriesTitleIterator(category) {
            return category.title.toLowerCase();
        }
    }
})();

(function () {
    angular
        .module('ETWServices')
        .factory('GoalGroupsService', [
        '$cacheFactory',
        '$http',
        'ETWServicesUtils',
        GoalGroupsServiceFactory,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$cacheFactory' implicitly has an 'any' ... Remove this comment to see the full error message
    function GoalGroupsServiceFactory($cacheFactory, $http, ETWServicesUtils) {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
        var service = {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ETWServicesUtils' implicitly has an 'an... Remove this comment to see the full error message
            assignTo: assignTo,
            clone: clone,
            destroy: destroy,
            getAll: getAll,
            getById: getById,
            reject: ETWServicesUtils.reject,
            resolve: ETWServicesUtils.resolve,
            save: save,
            search: search,
            subscribe: ETWServicesUtils.subscribe('GoalGroupsService'),
            unassignFrom: unassignFrom,
            unsubscribeAll: ETWServicesUtils.unsubscribeAll('GoalGroupsService'),
        };
        /**
         * @property serviceUrl
         * @type {string}
         * @private
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('GOAL_GROUPS');
        /**
         * @method getAll.clear
         * Clears the cache for the getAll() request
         */
        getAll.clear = function getAllClear() {
            $cacheFactory.get('$http').remove(serviceUrl);
        };
        /**
         * @method getById.clear
         * @param id {number}
         * Clears the cache entry for the call to get this group, then clears the cache for getAll.
         * Note: Since some goals are only fetched from a group, GoalTemplatesService calls this method.
         */
        getById.clear = function getByIdClear(id) {
            $cacheFactory.get('$http').remove(serviceUrl + '/' + ETWServicesUtils.asId(id));
            getAll.clear();
        };
        return service;
        /**
         * @method assignTo
         * @param type {string} - Model type to assign to
         * @param {...*} n - other parameters specific to the type
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
         * @returns {object} - promise
         * Used to assign roles to various models
         * Usage:
         *   GoalGroupsService.assignTo('Role', 1, 2)
         */
        function assignTo(type, n) {
            var args = _.tail(arguments), promise;
            switch (type) {
                case 'Role':
                    promise = assignToRole.apply(service, args);
                    break;
            }
            return promise;
        }
        /**
         * @method assignToRole
         * @param roleId {number}
         * @param goalGroupId {number}
         * @returns {object} - promise
         * @private
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
         * Assigns a GoalGroup to a Role. See assignTo()
         * /roles/{role_id}/goal-groups/{goal_group_id}"
         */
        function assignToRole(roleId, goalGroupId) {
            return $http({
                // @ts-ignore ts-migrate(2345) FIXME: Argument of type 'any[]' is not assignable to para... Remove this comment to see the full error message
                errorMessage: 'Could not assign the goal group to this role.',
                method: 'POST',
                data: { empty: 'post' },
                url: serviceUrl +
                    '/' +
                    ETWServicesUtils.asId(goalGroupId) +
                    '/roles/' +
                    ETWServicesUtils.asId(roleId),
            }).finally(function () {
                try {
                    ETWServicesUtils.notify('GoalGroupsService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method clone
         * @param sourceId {number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'roleId' implicitly has an 'any' type.
         * @returns {object} - promise, object
         */
        function clone(sourceId) {
            var options = {
                data: {},
                errorMessage: 'There was a problem cloning this group.',
                idName: 'id',
                url: serviceUrl + '?sourceGoalGroupId=' + ETWServicesUtils.asId(sourceId),
            };
            return ETWServicesUtils.save(options, undefined, 'GoalGroupsService', getAll.clear);
        }
        /**
         * @method destroy
         * @param id {number}
         * (delete is a reserved word.)
         */
        function destroy(id) {
            return $http({
                errorMessage: 'This group could not be deleted.',
                method: 'DELETE',
                url: serviceUrl + '/' + ETWServicesUtils.asId(id),
            }).finally(function () {
                try {
                    getAll.clear();
                    ETWServicesUtils.notify('GoalGroupsService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method getAll
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'sourceId' implicitly has an 'any' type.
         * @returns {object} - promise, array
         * Get all goal groups
         */
        function getAll() {
            return $http({
                errorMessage: 'There was a problem retrieving goal groups.',
                method: 'GET',
                url: serviceUrl,
                cache: true,
            });
        }
        /**
         * @method getById
         * @param id {string}
         * @returns {object} - promise, object
         * Get a specific goal group
         */
        function getById(id) {
            return $http({
                errorMessage: 'There was a problem retrieving this goal group.',
                method: 'GET',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
                url: serviceUrl + '/' + ETWServicesUtils.asId(id),
            }).then(function removeAssignmentInfoFromGroupGoals(response) {
                // Remove assignees, messageCount, kpis
                // Goals in a group are more like templates and don't functionally have these properties
                // Goal Card directive shows/hides these properties if they exist
                _.forEach(response.data.alignmentGoals, function (goal) {
                    delete goal.assignees;
                    delete goal.kpis;
                    delete goal.messageCount;
                });
                _.forEach(response.data.performanceGoals, function (goal) {
                    delete goal.assignees;
                    delete goal.kpis;
                    delete goal.messageCount;
                });
                return response;
            });
        }
        /**
         * @method save
         * @param goalGroup {object}
         * @param changedProperties {array} - optional. For partial updates
         * @returns {object} - promise, GoalGroup
         * Create/update/patch a goalGroup
         */
        function save(goalGroup, changedProperties) {
            var options = {
                data: goalGroup,
                errorMessage: false,
                idName: 'id',
                properties: changedProperties,
                url: serviceUrl,
            };
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
            if (angular.isDefined(goalGroup.id)) {
                options.url = serviceUrl + '/' + ETWServicesUtils.asId(goalGroup.id);
            }
            return ETWServicesUtils.save(options, undefined, 'GoalGroupsService', getAll.clear).catch(serviceExceptionHandler);
        }
        /**
         * @method search
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
         * @param query {string}
         * @returns {object} - promise, array
         * Standard search method. All searchable services should have this method, accept a string, return an array.
         */
        function search(query) {
            return $http({
                method: 'GET',
                url: serviceUrl,
                params: {
                    query: query,
                },
            }).then(function filterSearchResponse(response) {
                query = String(query).toLowerCase();
                // TODO: Until search API filters,
                _.remove(response.data, function (row) {
                    return (
                    // @ts-ignore
                    String(row.title)
                        .toLowerCase()
                        .indexOf(query) == -1 &&
                        // @ts-ignore
                        String(row.description)
                            .toLowerCase()
                            .indexOf(query) == -1);
                });
                return response;
            }, ETWServicesUtils.reject);
        }
        /**
         * @function serviceExceptionHandler
         * @param response {object}
         * @returns {object} - promise. Passes along another rejection with the response so the controller can act on it.
         * @private
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalGroup' implicitly has an 'any' type... Remove this comment to see the full error message
         * When the API returns an error message, display to the user and pray that it's understandable by humans.
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'changedProperties' implicitly has an 'a... Remove this comment to see the full error message
         * Response.data properties: timestamp, status, error, exception, message, path.
         */
        function serviceExceptionHandler(response) {
            var message = angular.isString(response.data.message)
                ? response.data.message
                : 'This goal group could not be saved.';
            ETWServicesUtils.notifyErrorMessage(message);
            return ETWServicesUtils.reject(response);
        }
        /**
         * @method unassignFrom
         * @param type {string}
         * @param {...*} n - other parameters specific to the type
         * Used to remove a GoalGroup from something.
         * See assignTo()
         */
        function unassignFrom(type, n) {
            var args = _.tail(arguments);
            switch (type) {
                case 'Role':
                    unassignFromRole.apply(service, args);
                    break;
            }
        }
        /**
         * @function unassignFromRole
         * @param roleId {number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'query' implicitly has an 'any' type.
         * @param goalGroupId {number}
         * @returns {object} - promise
         * @private
         * Remove an GoalGroup from a Role.
         */
        function unassignFromRole(roleId, goalGroupId) {
            return $http({
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                errorMessage: 'Could not remove the goal group from this role.',
                method: 'DELETE',
                url: serviceUrl +
                    '/' +
                    ETWServicesUtils.asId(goalGroupId) +
                    '/roles/' +
                    ETWServicesUtils.asId(roleId),
            }).finally(function () {
                try {
                    // TODO: Clear cache?
                    ETWServicesUtils.notify('GoalGroupsService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.

(function () {
    angular
        .module('ETWServices')
        .factory('GoalNotesService', [
        'ETWServicesUtils',
        'GoalsService',
        'NotesService',
        'PlansService',
        GoalNotesServiceFactory,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ETWServicesUtils' implicitly has an 'an... Remove this comment to see the full error message
    function GoalNotesServiceFactory(ETWServicesUtils, GoalsService, NotesService, PlansService) {
        var service = {
            getAllForGoal: getAllForGoal,
            getAllForPlanGoal: getAllForPlanGoal,
            getTypeFromGoal: GoalsService.getTypeFromGoal,
            resolve: ETWServicesUtils.resolve,
            reject: ETWServicesUtils.reject,
            save: save,
            subscribe: ETWServicesUtils.subscribe('GoalNotesService'),
            unsubscribe: ETWServicesUtils.unsubscribe('GoalNotesService'),
            unsubscribeAll: ETWServicesUtils.unsubscribeAll('GoalNotesService'),
        };
        /**
         * @property planGoalsServiceUrl
         * @type {string}
         */
        var planGoalsServiceUrl = ETWServicesUtils.getEndpointUrl('PLAN_GOALS');
        /**
         * @property serviceUrl
         * @type {string}
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('GOALS');
        return service;
        /**
         * @method generatePlanGoalServiceUrl
         * @param planId {number}
         * @param goalId {number}
         * @param [messageId] {number}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
        function generatePlanGoalServiceUrl(planId, goalId, messageId) {
            var url = planGoalsServiceUrl +
                '/' +
                ETWServicesUtils.asId(planId) +
                '/goals/' +
                ETWServicesUtils.asId(goalId) +
                '/messages';
            if (messageId) {
                url += '/' + ETWServicesUtils.asGuid(messageId);
            }
            return url;
        }
        /**
         * @method generateServiceUrl
         * @param goalType {string}
         * @param goalId {number}
         * @param [messageId] {string} - GUID
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalType' implicitly has an 'any' type.
        function generateServiceUrl(goalType, goalId, messageId) {
            var url = serviceUrl +
                '/' +
                ETWServicesUtils.asId(goalId) +
                '/goalType/' +
                GoalsService.asType(goalType) +
                '/messages';
            if (messageId) {
                url += '/' + ETWServicesUtils.asGuid(messageId);
            }
            return url;
        }
        /**
         * @method getAllForGoal
         * @param goalType {string}
         * @param goalId {number}
         * @returns {object} - promise
         * Note: response.data is threaded by parentMessageId
         * i.e. if messages 123 and 442 had replies:
         *   response.data = { 0: […], 123: […], 442: […] }
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalType' implicitly has an 'any' type.
        function getAllForGoal(goalType, goalId) {
            // @ts-ignore ts-migrate(2554) FIXME: Expected 3 arguments, but got 2.
            var url = generateServiceUrl(goalType, goalId);
            return NotesService.getAll(url);
        }
        /**
         * @deprecated
         * @method getAllForPlanGoal
         * @param planId {Number}
         * @param goalId {Number}
         * @returns {object} - promise
         * Note: response.data is threaded by parentMessageId
         * i.e. if messages 123 and 442 had replies:
         *   response.data = { 0: […], 123: […], 442: […] }
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
        function getAllForPlanGoal(planId, goalId) {
            // @ts-ignore ts-migrate(2554) FIXME: Expected 3 arguments, but got 2.
            var url = generatePlanGoalServiceUrl(planId, goalId);
            return NotesService.getAll(url);
        }
        /**
         * @method save
         * @param message {object}
         * @param goalType {string}
         * @param goalId {number}
         * @param [changedProperties] {string}
         * @returns {object} - promise
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'message' implicitly has an 'any' type.
        function save(message, goalType, goalId, changedProperties) {
            // @ts-ignore ts-migrate(2554) FIXME: Expected 3 arguments, but got 2.
            var url = generateServiceUrl(goalType, goalId);
            return NotesService.save(message, changedProperties, url, 'GoalNotesService').finally(function saveForGoalFinal() {
                try {
                    if (message.planId) {
                        // Clear Plan Goal cache
                        GoalsService.getAllForPlan.clear(message.planId);
                        // Clear Plan Cache
                        PlansService.getById.clear(message.planId);
                    }
                    // Clear Goal cache
                    GoalsService.getByIdForType.clear(goalType, goalId);
                    // Notify subscribers to Goals because the goal status might have changed
                    ETWServicesUtils.notify('GoalsService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
    }
})();

(function () {
    angular
        .module('ETWServices')
        .factory('GoalTemplatesService', [
        '$http',
        'ETWServicesUtils',
        'GoalGroupsService',
        'GoalsService',
        GoalTemplatesFactory,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
    function GoalTemplatesFactory($http, ETWServicesUtils, GoalGroupsService, GoalsService) {
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'GoalGroupsService' implicitly has an 'a... Remove this comment to see the full error message
         * @property fileServiceUrl
         * @type {string}
         */
        var fileServiceUrl = ETWServicesUtils.getEndpointUrl('GOAL_FILES');
        /**
         * @property groupsServiceUrl
         * @type {string}
         * @private
         * For goals that are based on the groupId
         */
        var groupsServiceUrl = ETWServicesUtils.getEndpointUrl('GOAL_GROUPS');
        /**
         * @property modelDefinition
         * @type {Object}
         * Configuration object used by ETWServicesUtils for formatting certain columns
         */
        var modelDefinition = {
            columns: {
                dueDate: 'date',
                goalGroup: 'excluded',
                updateInterval: 'number',
            },
        };
        var service = {
            attachmentDestroy: attachmentDestroy,
            attachmentSave: attachmentSave,
            attachmentUpload: attachmentUpload,
            clone: clone,
            defer: ETWServicesUtils.defer,
            destroy: destroy,
            getAdminGoalTypes: getAdminGoalTypes,
            getByIdAndType: getByIdAndType,
            getFiles: getFiles,
            getNew: getNew,
            getTypeFromGoal: GoalsService.getTypeFromGoal,
            reject: ETWServicesUtils.reject,
            resolve: ETWServicesUtils.resolve,
            save: save,
            saveAsType: saveAsType,
            subscribe: ETWServicesUtils.subscribe('GoalTemplatesService'),
            unsubscribe: ETWServicesUtils.unsubscribe('GoalTemplatesService'),
            unsubscribeAll: ETWServicesUtils.unsubscribeAll('GoalTemplatesService'),
        };
        /**
         * @property serviceUrl
         * @type {string}
         * @private
         * For goals that are accessed by goalId
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('GOALS');
        return service;
        /**
         * @method attachmentDestroy
         * @param goalId {number}
         * @param goalType {string}
         * @returns {Function}
         * Curries the goal ID and type in the standard destroy method. Controllers can then just pass type and attachment.
         */
        function attachmentDestroy(goalId, goalType) {
            return function (type, attachment) {
                var baseUrl = makeServiceUrl(goalType, undefined, goalId);
                return ETWServicesUtils.attachmentDestroy(type, baseUrl, attachment).finally(function attachmentSaveFinal() {
                    try {
                        ETWServicesUtils.notify('GoalTemplatesService');
                    }
                    catch (e) {
                        console.error(e);
                    }
                });
            };
        }
        /**
         * @method attachmentSave
         * @param goalId {number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalId' implicitly has an 'any' type.
         * @param goalType {string}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalType' implicitly has an 'any' type.
         * @returns {Function}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
         * Curries the goal ID and type in the standard upload method. Controllers can then just pass type and attachment.
         */
        function attachmentSave(goalId, goalType) {
            return function (type, attachment) {
                var baseUrl = makeServiceUrl(goalType, undefined, goalId);
                return ETWServicesUtils.attachmentSave(type, baseUrl, attachment, true).finally(function attachmentSaveFinal() {
                    try {
                        ETWServicesUtils.notify('GoalTemplatesService');
                    }
                    catch (e) {
                        console.error(e);
                    }
                });
            };
        }
        /**
         * @method attachmentUpload
         * @param goalId {number}
         * @param goalType {string}
         * @returns {Function}
         * Curries the roleId in the standard upload method. Controllers can then just pass type and attachment.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalId' implicitly has an 'any' type.
        function attachmentUpload(goalId, goalType) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalType' implicitly has an 'any' type.
            return function (type, attachment) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
                var baseUrl = makeServiceUrl(goalType, undefined, goalId), baseDownloadUrl = serviceUrl +
                    '/' +
                    ETWServicesUtils.asId(goalId) +
                    '/goalType/' +
                    GoalsService.asType(goalType);
                return ETWServicesUtils.attachmentUpload(baseUrl, attachment, true, baseDownloadUrl).finally(function attachmentSaveFinal() {
                    try {
                        ETWServicesUtils.notify('GoalTemplatesService');
                    }
                    catch (e) {
                        console.error(e);
                    }
                });
            };
        }
        /**
         * @method clone
         * @param sourceId {number}
         * @param type {string}
         * @returns {object} - promise, object
         */
        function clone(sourceId, type) {
            var options = {
                data: {},
                errorMessage: 'There was a problem cloning this goal.',
                idName: 'id',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalId' implicitly has an 'any' type.
                url: serviceUrl + '/' + ETWServicesUtils.asId(sourceId) + '/goalType/' + type + '/clone',
            };
            return ETWServicesUtils.save(options, modelDefinition, 'GoalTemplatesService', GoalGroupsService.getAll.clear);
        }
        /**
         * @method destroy
         * @param id {number}
         * @param type {string}
         * @param [groupId] {number} - required to clear group cache
         * (delete is a reserved word.)
         * Note: API currently only returns some goals via a group.
         *       The cache needs to be cleared for that group, so pass the groupId
         * Note: groupId is NOT part of the destroy URL
         */
        function destroy(id, type, groupId) {
            return $http({
                errorMessage: 'This goal could not be deleted.',
                method: 'DELETE',
                url: makeServiceUrl(type, undefined, id),
            }).finally(function () {
                try {
                    if (groupId) {
                        GoalGroupsService.getById.clear(groupId);
                    }
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'sourceId' implicitly has an 'any' type.
                    ETWServicesUtils.notify('GoalTemplatesService');
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method getAdminGoalTypes
         * @returns {object}
         * Returns a map of types that can be used in Goal Groups.
         */
        function getAdminGoalTypes() {
            return _(GoalsService.TYPES)
                .filter({
                isAdmin: true,
            })
                .keyBy('type')
                .value();
        }
        /**
         * @method getByIdAndType
         * @param id {number}
         * @param type {string}
         * @returns {object} - promise, object
         */
        function getByIdAndType(id, type) {
            return $http({
                errorMessage: 'There was a problem retrieving this goal.',
                method: 'GET',
                url: makeServiceUrl(type, undefined, id),
            }).then(ETWServicesUtils.decodeResponse(modelDefinition), ETWServicesUtils.reject);
        }
        /**
         * @method getFiles
         * @param goalId {number}
         * @param goalType {string}
         * @returns {object} - promise
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
         * Retrieves a list of file attachments for the goal
         */
        function getFiles(goalId, goalType) {
            return $http({
                errorMessage: 'Files for this goal could not be retrieved.',
                method: 'GET',
                url: fileServiceUrl + '/' + ETWServicesUtils.asId(goalId) + '/goalType/' + goalType,
            }).then(function (response) {
                _.forEach(response.data, function (file) {
                    file.downloadUrl =
                        serviceUrl +
                            '/' +
                            ETWServicesUtils.asId(goalId) +
                            '/goalType/' +
                            GoalsService.asType(goalType) +
                            '/file/' +
                            file.id;
                });
                return response;
            }, service.reject);
        }
        /**
         * @method getNew()
         * @param options {object}
         * Creates a new (unsaved) instance with default values.
         */
        function getNew(options) {
            return ETWServicesUtils.resolve({
                data: {
                    goalGroup: options.goalGroup,
                },
            });
        }
        /**
         * @function makeServiceUrl
         * @private
         * [@param type] {string} - optional. Temporary?
         * [@param groupId] {string} - optional
         * [@param goalId] {string} - optional if groupId
         * @returns {string}
         */
        function makeServiceUrl(type, groupId, goalId) {
            var url;
            if (groupId || goalId) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
                if (groupId) {
                    // groupId
                    // groups/:groupId/goals
                    url = groupsServiceUrl + '/' + ETWServicesUtils.asId(groupId);
                    if (goalId) {
                        // groupId + goalId
                        // groups/:groupId/goals/:goalId
                        url += '/goals/' + ETWServicesUtils.asId(goalId);
                    }
                }
                else {
                    // goalId only
                    // goals/:goalId
                    url = serviceUrl + '/' + ETWServicesUtils.asId(goalId);
                    if (type) {
                        url += '/goalType/' + GoalsService.asType(type);
                    }
                }
            }
            else {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalId' implicitly has an 'any' type.
                throw new Error('A groupId or goalId are required to generate the API URL.');
            }
            return url;
        }
        /**
         * @method save
         * @param goal {object}
         * @param goalType {string}
         * @param changedProperties {array} - optional. For partial updates
         * @param [isNotify] {boolean=true} - If true, notify subscribed controllers
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
         * @returns {object} - promise, GoalGroup
         * Create/update/patch a goalGroup
         */
        function save(goal, goalType, changedProperties, isNotify) {
            var options = {
                data: _.omitBy(goal, _.isArray),
                errorMessage: 'This goal could not be saved.',
                idName: 'id',
                properties: changedProperties,
            };
            isNotify = angular.isUndefined(isNotify) || isNotify;
            if (goal.goalGroup) {
                if (goal.id) {
                    // update
                    // @ts-ignore
                    options.url = serviceUrl + '/' + ETWServicesUtils.asId(goal.id) + '/goalType/' + goalType;
                }
                else {
                    // create
                    // @ts-ignore
                    options.url =
                        serviceUrl + '/' + goalType + '/goalGroupId/' + ETWServicesUtils.asId(goal.goalGroup);
                }
            }
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'options' implicitly has an 'any' type.
            return ETWServicesUtils.save(options, modelDefinition, isNotify ? 'GoalTemplatesService' : null);
        }
        /**
         * @method saveAsType
         * @param goal {object}
         * @param newType {string}
         * @param oldType {string}
         * @returns {object} - promise
         * Note: This does NOT save an entire goal, just changes types and returns the (maybe new) ID
         * POST /goal/v1/goals/123/goalType/leadership/convert/culture
         * TODO: ensure types are part of the whitelist
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
        function saveAsType(goal, newType, oldType) {
            return $http({
                data: {
                    id: goal.id,
                },
                errorMessage: 'The type for this goal could not be changed.',
                method: 'POST',
                url: serviceUrl +
                    '/' +
                    ETWServicesUtils.asId(goal.id) +
                    '/goalType/' +
                    oldType +
                    '/convert/' +
                    newType,
            }).finally(function () {
                if (goal.goalGroup) {
                    GoalGroupsService.getById.clear(goal.goalGroup);
                    ETWServicesUtils.notify('GoalTemplatesService');
                }
            });
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'goal' implicitly has an 'any' type.

(function () {
    angular
        .module('ETWServices')
        .factory('GoalsService', [
        '$cacheFactory',
        '$http',
        'GoalCategoriesService',
        'ETWServicesUtils',
        'PlansService',
        GoalsServiceFactory,
    ]);
    /**
     * @constant TYPES
     * @type {Array}
     * Static goal types used by GoalsService
     */
    var TYPES = [
        {
            title: 'Culture',
            type: 'culture',
            category: 'alignment',
            isAdmin: true,
            sortIndex: 4,
        },
        {
            title: 'Leadership',
            type: 'leadership',
            category: 'alignment',
            isAdmin: true,
            sortIndex: 5,
        },
        {
            title: 'Role',
            type: 'role',
            category: 'performance',
            isAdmin: true,
            sortIndex: 3,
        },
        {
            title: 'Plan',
            type: 'plan',
            category: 'performance',
            isAdmin: false,
            sortIndex: 0,
        },
        {
            title: 'Manager Assigned',
            type: 'manager_assigned',
            category: 'performance',
            isAdmin: false,
            sortIndex: 1,
        },
        {
            title: 'Personal',
            type: 'personal',
            category: 'performance',
            isAdmin: false,
            sortIndex: 2,
        },
    ];
    /**
     * @constant CATEGORIES
     * @type {object}
     */
    var CATEGORIES = {
        alignment: ['culture', 'leadership'],
        performance: ['role', 'plan', 'manager_assigned', 'personal'],
    };
    /**
     * @constant ALLOWED_TYPES
     * @type {Array}
     * Array used to restrict goal types.
     */
    var ALLOWED_TYPES = _.map(TYPES, 'type');
    /**
     * @property accessTypeActions
     * @type {object}
     * Map of access types to what is used by the API.
     * Viz., the "viewOnly" action is used for "viewers"
     */
    var accessTypeActions = {
        assignees: 'assignees',
        participants: 'participants',
        viewers: 'viewOnly',
    };
    function GoalsServiceFactory($cacheFactory, $http, GoalCategoriesService, ETWServicesUtils, PlansService) {
        // NOTE: Plan Goals do not have their own service, but are always a part of a plan.
        /**
         * @property modelDefinition
         * @type {Object}
         * Configuration object used by ETWServicesUtils for formatting certain columns
         * primaryKpiId is set when associating KPIs, not updating the goal. Exclude it from updates.
         */
        var modelDefinition = {
            columns: {
                dueDate: 'date',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter '$cacheFactory' implicitly has an 'any' ... Remove this comment to see the full error message
                plan: 'excluded',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
                primaryKpiId: 'excluded',
            },
        };
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ETWServicesUtils' implicitly has an 'an... Remove this comment to see the full error message
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'PlansService' implicitly has an 'any' t... Remove this comment to see the full error message
         * @property fileServiceUrl
         * @type {string}
         */
        var fileServiceUrl = ETWServicesUtils.getEndpointUrl('GOAL_FILES');
        /**
         * @property planGoalsServiceUrl
         * @type {string}
         */
        var planGoalsServiceUrl = ETWServicesUtils.getEndpointUrl('PLAN_GOALS');
        //public functions
        var service = {
            CATEGORIES: CATEGORIES,
            TYPES: TYPES,
            addAllPeople: addAllPeople,
            addPerson: addPerson,
            addSupportedGoal: addSupportedGoal,
            all: ETWServicesUtils.all,
            assignToCategory: assignToCategory,
            asType: asType,
            attachmentDestroy: attachmentDestroy,
            attachmentSave: attachmentSave,
            attachmentUpload: attachmentUpload,
            clone: clone,
            createGoalByWizard: createGoalByWizard,
            defer: ETWServicesUtils.defer,
            destroy: destroy,
            getActiveAndDraftGoalsForUser: getActiveAndDraftGoalsForUser,
            getAllForGoal: getAllForGoal,
            getAllForGoalByAttributes: getAllForGoalByAttributes,
            getAllForPerson: getAllForPerson,
            getAllForPlan: getAllForPlan,
            getAllCompletedSuspendedForPlan: getAllCompletedSuspendedForPlan,
            getAttachmentsFromGoal: getAttachmentsFromGoal,
            getByIdForType: getByIdForType,
            getCompletedAndSuspendedGoalsForUser: getCompletedAndSuspendedGoalsForUser,
            getFiles: getFiles,
            getForGoalUpToLevels: getForGoalUpToLevels,
            getNew: getNew,
            getTypeFromGoal: getTypeFromGoal,
            getTypeTitleFromGoal: getTypeTitleFromGoal,
            getUrlForGoal: getUrlForGoal,
            move: move,
            reject: ETWServicesUtils.reject,
            removeAllPeople: removeAllPeople,
            removePerson: removePerson,
            removeSupportedGoal: removeSupportedGoal,
            resolve: ETWServicesUtils.resolve,
            save: save,
            searchByPlan: searchByPlan,
            searchSupportableGoalsById: searchSupportableGoalsById,
            subscribe: ETWServicesUtils.subscribe('GoalsService'),
            updateGoalDueDate: updateGoalDueDate,
            updateGoalSortOrder: updateGoalSortOrder,
            unsubscribe: ETWServicesUtils.unsubscribe('GoalsService'),
            unsubscribeAll: ETWServicesUtils.unsubscribeAll('GoalsService'),
        };
        /**
         * @property plansGoalsCache
         * @type {object}
         * Stores list of Goals to cache bust when a Plan is busted.
         */
        var plansGoalsCache = {};
        /**
         * @property serviceUrl
         * @type {string}
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('GOALS');
        /**
         * @property usersServiceUrl
         * @type {string}
         */
        var usersServiceUrl = ETWServicesUtils.getEndpointUrl('USER_GOALS');
        var usersMobileUrl = ETWServicesUtils.getEndpointUrl('GOALS_MOBILE');
        /**
         * @function getAllForPlan.clear
         * @param planId {number}
         * @private
         * Clears the cache for all the goals on a plan
         */
        getAllForPlan.clear = function (planId) {
            var cache = $cacheFactory.get('$http'), goals = plansGoalsCache[ETWServicesUtils.asId(planId)] || [];
            cache.remove(generateGetAllForEntityServiceUrl('plan', planId));
            _.forEach(goals, cache.remove);
        };
        /**
         * @function getByIdForType.add
         * @private
         * @param {object} goal
         * Adds goal url to list of cached items to be busted along with Plan.
         */
        getByIdForType.add = function (goal) {
            var planId = ETWServicesUtils.asId(goal.plan.id), currentPlanGoals = plansGoalsCache[planId] || [], goalUrl = generateServiceUrl(getTypeFromGoal(goal), goal.id);
            if (!_.includes(currentPlanGoals, goalUrl)) {
                plansGoalsCache[planId] = _.union(currentPlanGoals, [goalUrl]);
            }
        };
        /**
         * @function getByIdForType.clear
         * @param goalType {string}
         * @param goalId {number}
         */
        getByIdForType.clear = function (goalType, goalId) {
            $cacheFactory.get('$http').remove(generateServiceUrl(goalType, goalId));
        };
        return service;
        /**
         * @method addAllPeople
         * @param goalId {number}
         * @param goalType {string}
         * @param accessType {string}
         * @param people {Array}
         * @returns {object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
        function addAllPeople(goalId, goalType, accessType, people) {
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            var peopleList = _.map(people, function (person) {
                return {
                    id: person.id,
                    flag: person._isSubscribed,
                };
            });
            var params = { ids: peopleList };
            return $http({
                errorMessage: 'This list of people could not be added in goal',
                method: 'POST',
                data: params,
                url: generateServiceUrl(goalType, goalId) + '/' + accessTypeActions[accessType],
            }).finally(function () {
                try {
                    // Clear cached responses
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goal' implicitly has an 'any' type.
                    getByIdForType.clear(goalType, goalId);
                    ETWServicesUtils.notify('GoalsService');
                    // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method addPerson
         * @param goalId {number}
         * @param goalType {string}
         * @param personId {number}
// @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
         * @param accessType {string}
         * @param [planId] {number}
         * Adds a person via the goal service
         */
        function addPerson(goalId, goalType, personId, accessType, planId) {
            return $http({
                errorMessage: 'This person could not be added to the goal.',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalType' implicitly has an 'any' type.
                method: 'POST',
                url: generateServiceUrl(goalType, goalId) +
                    '/' +
                    accessTypeActions[accessType] +
                    '/' +
                    ETWServicesUtils.asId(personId),
            }).finally(function () {
                try {
                    // Clear cached responses
                    getByIdForType.clear(goalType, goalId);
                    if (planId) {
                        getAllForPlan.clear(planId);
                    }
                    ETWServicesUtils.notify('GoalsService');
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalId' implicitly has an 'any' type.
                }
                catch (e) {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalType' implicitly has an 'any' type.
                    console.error(e);
                }
            });
        }
        /**
         * @method addSupportedGoal
         * @param goalId {number}
         * @param goalType {string}
         * @param parentGoalId {number}
         * @returns {object} - promise
         */
        function addSupportedGoal(goalId, goalType, parentGoalId) {
            return $http({
                errorMessage: 'Could not assign a supported goal to this goal.',
                method: 'POST',
                data: { payload: null },
                url: serviceUrl +
                    '/' +
                    ETWServicesUtils.asId(goalId) +
                    '/supported/' +
                    // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                    ETWServicesUtils.asId(parentGoalId),
            }).finally(function () {
                try {
                    getByIdForType.clear(goalType, goalId);
                    ETWServicesUtils.notify('GoalsService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method assignToCategory
         * @param categoryId {number}
         * @param goalType {string}
         * @param goalId {number}
         * @param [planId] {number}
         * @returns {object} - promise
         * Set the category for a goal.
         * Clear cached goal and cached list of goals on a plan.
         * Notify subscribers to GoalsService.
         */
        function assignToCategory(categoryId, goalType, goalId, planId) {
            return GoalCategoriesService.assign(categoryId, goalId).finally(
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalId' implicitly has an 'any' type.
            function assignToCategoryFinal() {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'accessType' implicitly has an 'any' typ... Remove this comment to see the full error message
                getByIdForType.clear(goalType, goalId);
                if (planId) {
                    getAllForPlan.clear(planId);
                }
                ETWServicesUtils.notify('GoalsService');
            });
        }
        /**
         * @function asType
         * @param str {string}
         * @returns {string}
         * @private
// @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
         * Ensures a string matches the lists of known types.
         * TODO
         */
        function asType(str) {
            var formattedStr = String(str).toLowerCase();
            if (ALLOWED_TYPES.indexOf(formattedStr) === -1) {
                throw new GoalTypeException(str);
            }
            return formattedStr;
        }
        /**
         * @function attachmentDestroy
         * @param goalType {string}
         * @param goalId {number}
         * @param [planId] {number}
         * @returns {Function}
         * Returns a function that has a common signature will all services that support attachments.
         */
        function attachmentDestroy(goalType, goalId, planId) {
            var baseUrl = serviceUrl + '/' + ETWServicesUtils.asId(goalId) + '/goalType/' + asType(goalType);
            return function (type, attachment) {
                // Clear cache
                getByIdForType.clear(goalType, goalId);
                if (planId) {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalId' implicitly has an 'any' type.
                    // Clear cache for Plan Goals
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'parentGoalId' implicitly has an 'any' t... Remove this comment to see the full error message
                    getAllForPlan.clear(planId);
                }
                return ETWServicesUtils.attachmentDestroy(type, baseUrl, attachment).finally(function attachmentSaveFinal() {
                    try {
                        ETWServicesUtils.notify('GoalsService');
                    }
                    catch (e) {
                        console.error(e);
                    }
                });
            };
        }
        /**
         * @function attachmentSave
         * @param goalType {string}
         * @param goalId {number}
         * @param [planId] {number}
         * @returns {Function}
         * Returns a function with a common signature to be used by attachment directives that are service agnostic.
         */
        function attachmentSave(goalType, goalId, planId) {
            var baseUrl = serviceUrl + '/' + ETWServicesUtils.asId(goalId) + '/goalType/' + asType(goalType);
            return function (type, attachment, isAdminEntity) {
                // Clear cache
                getByIdForType.clear(goalType, goalId);
                if (goalType == 'plan' && planId) {
                    // Clear cache for Plan Goals
                    getAllForPlan.clear(planId);
                }
                return ETWServicesUtils.attachmentSave(type, baseUrl, attachment, isAdminEntity).finally(function attachmentSaveFinal() {
                    try {
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'categoryId' implicitly has an 'any' typ... Remove this comment to see the full error message
                        ETWServicesUtils.notify('GoalsService');
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalType' implicitly has an 'any' type.
                    }
                    catch (e) {
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                        console.error(e);
                    }
                });
            };
        }
        /**
         * @function attachmentUpload
         * @param goalType {string}
         * @param goalId {number}
         * @param [planId] {number}
         * @returns {Function}
         * Returns a function for use with attachment directives.
         */
        function attachmentUpload(goalType, goalId, planId) {
            var baseUrl = serviceUrl + '/' + ETWServicesUtils.asId(goalId) + '/goalType/' + asType(goalType), baseDownloadUrl = serviceUrl + '/' + ETWServicesUtils.asId(goalId) + '/goalType/' + asType(goalType);
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'str' implicitly has an 'any' type.
            return function (type, attachment, isAdminEntity) {
                // Clear cache
                getByIdForType.clear(goalType, goalId);
                if (goalType == 'plan' && planId) {
                    // Clear cache for Plan Goals
                    // @ts-ignore ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
                    getAllForPlan.clear(planId);
                }
                return ETWServicesUtils.attachmentUpload(baseUrl, attachment, isAdminEntity, baseDownloadUrl).finally(function attachmentSaveFinal() {
                    try {
                        ETWServicesUtils.notify('GoalsService');
                    }
                    catch (e) {
                        console.error(e);
                    }
                });
            };
        }
        /**
         * @method clone
         * @param goalType {string}
         * @param goalId {number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalType' implicitly has an 'any' type.
         * @param planId {number}
         * @returns {object} - promise, object
         * Clones a goal. Only managers can clone goals assigned to a person.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
        function clone(goalType, goalId, planId) {
            var params = {
                goalId: goalId,
                goalType: goalType,
            };
            return $http({
                errorMessage: 'The goal could not be cloned.',
                method: 'POST',
                data: { null: null },
                params: params,
                url: generateServiceUrl(goalType, goalId) + '/clone',
            }).finally(function () {
                try {
                    if (planId) {
                        getAllForPlan.clear(planId);
                    }
                    ETWServicesUtils.notify('GoalsService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method createGoalByWizard
         * @param goal {object}
         * @returns {object} - promise
         */
        function createGoalByWizard(goal) {
            return $http({
                errorMessage: 'Could not create goal.',
                method: 'POST',
                data: goal,
                url: serviceUrl,
            }).then(function (response) {
                ETWServicesUtils.notify('GoalsService');
                return response;
            });
        }
        /**
         * @method destroy
         * @param goalType {string}
         * @param goalId {number}
         * @param [planId] {number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalType' implicitly has an 'any' type.
         * @returns {object} - promise
         */
        function destroy(goalType, goalId, planId) {
            return $http({
                errorMessage: 'This Plan Goal could not be removed.',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
                method: 'DELETE',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'attachment' implicitly has an 'any' typ... Remove this comment to see the full error message
                url: generateServiceUrl(goalType, goalId),
            }).finally(function () {
                try {
                    if (goalType == 'plan' && planId) {
                        getAllForPlan.clear(planId);
                        // Clear Plan Cache
                        PlansService.getById.clear(planId);
                    }
                    ETWServicesUtils.notify('GoalsService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @function generateGetAllForEntityServiceUrl
         * @param type {string}
         * @param entityId {number}
         * @returns {string}
         * @private
         * Returns the API endpoint URL for returning all goals that belong to an entity.
         * Expected entities: plan, user
         */
        function generateGetAllForEntityServiceUrl(type, entityId) {
            return serviceUrl + '/' + asType(type) + '/entityId/' + ETWServicesUtils.asId(entityId);
        }
        /**
         * @function generateServiceUrl
         * @param goalType {string}
         * @param goalId {number}
         * @returns {string}
         * @private
         * Note: API doesn't support fetching all by type.
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalType' implicitly has an 'any' type.
         * Note: To fetch all by an "entity" see generateGetAllForEntityServiceUrl
         */
        function generateServiceUrl(goalType, goalId) {
            return serviceUrl + '/' + ETWServicesUtils.asId(goalId) + '/goalType/' + asType(goalType);
        }
        /**
         * @method getAllForGoal
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
         * @param goalId {number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'isAdminEntity' implicitly has an 'any' ... Remove this comment to see the full error message
         * @param goalType {string}
         * Gets supporting goals for a given goal.
         * Note: '/supportinggoals' goes one level deep.
         *       '/allsupportinggoals' fetches all levels
         */
        function getAllForGoal(goalId, goalType) {
            if (goalType) {
                return $http({
                    errorMessage: 'Supporting goals for this goal could not be retrieved.',
                    method: 'GET',
                    url: serviceUrl + '/' + ETWServicesUtils.asId(goalId) + '/allsupportinggoals',
                });
            }
            else {
                throw new Error('Only performance goals can have supporting goals.');
            }
        }
        /**
         * @method getForGoalUpToLevels
         * @param goalId {number}
         * @param goalType {string}
         * @param levels {number}
         */
        function getForGoalUpToLevels(goalId, goalType, levels) {
            if (goalType) {
                return $http({
                    errorMessage: 'Supporting goals for this goal could not be retrieved.',
                    method: 'GET',
                    url: serviceUrl +
                        '/' +
                        ETWServicesUtils.asId(goalId) +
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalType' implicitly has an 'any' type.
                        '/supportinggoals/levels/' +
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalId' implicitly has an 'any' type.
                        ETWServicesUtils.asId(levels),
                });
            }
            else {
                throw new Error('Only performance goals can have supporting goals.');
            }
        }
        /**
         *
         * @param userId
         */
        function getActiveAndDraftGoalsForUser(userId) {
            return $http({
                errorMessage: 'The goals could not be retrieved for this person.',
                method: 'GET',
                url: usersMobileUrl + '/users/' + ETWServicesUtils.asId(userId) + '/draftAndActiveGoals',
            });
        }
        /**
         *
         * @param userId
         */
        function getCompletedAndSuspendedGoalsForUser(userId) {
            return $http({
                errorMessage: 'The goals could not be retrieved for this person.',
                method: 'GET',
                url: usersMobileUrl + '/users/' + ETWServicesUtils.asId(userId) + '/completedAndSuspendedGoals',
            });
        }
        /**
         * @method getAllForGoalByAttributes
         * @param goalId {number}
         * @param [primaryAttributeId] {number} - optional
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'goal' implicitly has an 'any' type.
         * @param [secondaryAttributeId] {number} - optional
         * @returns {object} - promise, Array
         */
        function getAllForGoalByAttributes(goalId, primaryAttributeId, secondaryAttributeId) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            var url = serviceUrl + '/' + ETWServicesUtils.asId(goalId) + '/allsupportinggoals';
            if (primaryAttributeId) {
                url += '/byattribute/' + ETWServicesUtils.asId(primaryAttributeId);
            }
            if (secondaryAttributeId) {
                url += '/byattribute/' + ETWServicesUtils.asId(secondaryAttributeId);
            }
            return $http({
                errorMessage: 'Supporting goals for this goal could not be retrieved.',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalType' implicitly has an 'any' type.
                method: 'GET',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalId' implicitly has an 'any' type.
                url: url,
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
            });
        }
        /**
         * @method getAllForPerson
         * @param userId {number}
         * @returns {object} - promise, array
         * Note: DO NOT CACHE
         * In order to clear the cache, you have to clear it for every person on (or removed) from all access levels of a plan.
         */
        function getAllForPerson(userId) {
            return $http({
                errorMessage: 'The goals could not be retrieved for this person.',
                method: 'GET',
                url: usersServiceUrl + '/' + ETWServicesUtils.asId(userId) + '/goals',
            });
        }
        /**
         * @method getAllForPlan
         * @param planId {number}
         * @returns {object} - promise, Array
         */
        function getAllForPlan(planId) {
            return $http({
                cache: true,
                errorMessage: 'The goals for this plan could not be retrieved.',
                method: 'GET',
                url: generateGetAllForEntityServiceUrl('plan', planId),
            })
                .then(ETWServicesUtils.decodeResponse(modelDefinition), ETWServicesUtils.reject)
                .then(function (response) {
                _.forEach(response.data, getByIdForType.add);
                return response;
            });
        }
        /**
         *
         * @param planId
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'entityId' implicitly has an 'any' type.
        function getAllCompletedSuspendedForPlan(planId) {
            return $http({
                cache: true,
                errorMessage: 'The goals for this plan could not be retrieved.',
                method: 'GET',
                url: generateGetAllForEntityServiceUrl('plan', planId) + '?state=4',
            })
                .then(ETWServicesUtils.decodeResponse(modelDefinition), ETWServicesUtils.reject)
                .then(function (response) {
                _.forEach(response.data, getByIdForType.add);
                return response;
            });
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalType' implicitly has an 'any' type.
         * @method getAttachmentsFromGoal
         * @param goal {object}
         * @returns {object} - links {Array}, files {Array}, count {number}
         * Pass in a goal, get attachments back. Includes attachments to parent Goal Template, if there is one.
         */
        function getAttachmentsFromGoal(goal) {
            var allGoalLinks = [];
            var allS3Resources = [];
            // Attachments to goal
            if (angular.isArray(goal.goalLinks)) {
                allGoalLinks = goal.goalLinks;
            }
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalId' implicitly has an 'any' type.
            if (angular.isArray(goal.s3Resources)) {
                allS3Resources = goal.s3Resources;
            }
            if (goal.masterGoal) {
                // Attachments to goal template
                if (angular.isArray(goal.masterGoal.goalLinks)) {
                    allGoalLinks = _.union(allGoalLinks, goal.masterGoal.goalLinks);
                }
                if (angular.isArray(goal.masterGoal.s3Resources)) {
                    allS3Resources = _.union(allS3Resources, goal.masterGoal.s3Resources);
                }
            }
            return {
                links: allGoalLinks,
                files: allS3Resources,
                count: allGoalLinks.length + allS3Resources.length,
            };
        }
        /**
         * @method getByIdForType
         * @param type {string}
         * @param id {number}
         * @returns {object} - promise, Object
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalId' implicitly has an 'any' type.
        function getByIdForType(type, id) {
            return $http({
                cache: true,
                errorMessage: 'This goal could not be retrieved.',
                method: 'GET',
                url: generateServiceUrl(type, id),
            })
                .then(ETWServicesUtils.decodeResponse(modelDefinition), ETWServicesUtils.reject)
                .then(function (response) {
                if (response.data.plan) {
                    getByIdForType.add(response.data);
                }
                return response;
            });
        }
        /**
         * @method getFiles
         * @param goalType {string}
         * @param goalId {number}
         * Retrieves a list of file attachments for the goal.
         */
        function getFiles(goalType, goalId) {
            return $http({
                errorMessage: 'Files for this goal could not be retrieved.',
                method: 'GET',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'userId' implicitly has an 'any' type.
                url: fileServiceUrl + '/' + ETWServicesUtils.asId(goalId) + '/goalType/' + asType(goalType),
            }).then(function (response) {
                _.forEach(response.data, function (file) {
                    file.downloadUrl =
                        serviceUrl +
                            '/' +
                            ETWServicesUtils.asId(goalId) +
                            '/goalType/' +
                            asType(goalType) +
                            '/file/' +
                            file.id;
                });
                return response;
            }, service.reject);
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'userId' implicitly has an 'any' type.
         * @method getNew
         * @param options {object}
         * @returns {object} - promise, object
         * Creates a new (unsaved) instance with default values.
         */
        function getNew(options) {
            _.defaults(options, {
                assignees: [],
                autolinkedPerformanceGoals: [],
                categories: [],
                participants: [],
                state: 1,
                supportedPerformanceGoals: [],
                userEditable: true,
                viewers: [],
            });
            if (options.type) {
                if (service.CATEGORIES.alignment.indexOf(options.type) !== -1) {
                    options.alignmentGoalType = options.type;
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalId' implicitly has an 'any' type.
                }
                else if (service.CATEGORIES.performance.indexOf(options.type) !== -1) {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'primaryAttributeId' implicitly has an '... Remove this comment to see the full error message
                    options.performanceGoalType = options.type;
                }
                delete options.type;
            }
            return ETWServicesUtils.resolve({
                data: options,
            });
        }
        /**
         * @function getSupportableGoals
         * @param type {string}
         * @param goalId {number}
         * @returns {object} - promise
         * @private
         * Called by searchSupportableGoalsById
         * Note: Currently only plan goals are shared/public
         */
        function getSupportableGoals(type, goalId) {
            return $http({
                errorMessage: 'Could not get available supportable goals for this goal.',
                method: 'GET',
                data: { payload: null },
                url: generateServiceUrl(type, goalId) + '/sharedgoals',
            });
        }
        /**
         * @method getTypeFromGoal
         * @param goal {object}
         * @returns {string}
         * Utility to make it easy to determine which goal type a goal has.
         * Return value is lower case string or undefeined.
         * Note: this method doesn't call the API
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'userId' implicitly has an 'any' type.
        function getTypeFromGoal(goal) {
            var type = goal.alignmentGoalType || goal.performanceGoalType;
            if (angular.isString(type) && type.length) {
                type = type.toLowerCase();
            }
            else {
                type = undefined;
            }
            return asType(type);
        }
        /**
         * @method getTypeTitleFromGoal
         * @param goal {object}
         * @returns {string}
         * Returns human readable title for the goal type. E.g. "Manager Assigned".
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
        function getTypeTitleFromGoal(goal) {
            var type = getTypeFromGoal(goal);
            return type && _.find(service.TYPES, { type: type }).title;
        }
        /**
         * @method getUrlForGoal
         * @param screen {string}
         * @param goal {object}
         * @param [tab] {string}
         * @param [parentGoal] {object}
         * @param [personId] {number}
         * @returns {object} - two properties, params and state, to be used with $state.go
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
         * Creates the route information for a goal
         */
        function getUrlForGoal(screen, goal, tab, parentGoal, personId) {
            var params = {
                goalId: goal.id,
                goalType: getTypeFromGoal(goal),
            }, state;
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
            if (['settings', 'show'].indexOf(screen) === -1) {
                screen = 'show';
            }
            if (tab) {
                // @ts-ignore
                params.tab = tab;
                screen = 'show-tab';
            }
            if (personId) {
                // Goals for a person
                if (tab) {
                    state = 'app.people.person-goals.show-tab';
                }
                else {
                    state = 'app.people.person-goals.' + screen;
                }
            }
            else if (parentGoal && parentGoal.id) {
                // Supporting goals
                // @ts-ignore
                params.parentGoalId = parentGoal.id;
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                params.parentGoalType = parentGoal.type || getTypeFromGoal(parentGoal);
                if (screen == 'settings') {
                    state = 'app.goals.supporting-goal-settings';
                }
                else if (tab) {
                    state = 'app.goals.supporting-goal-tab';
                }
                else {
                    state = 'app.goals.supporting-goal';
                }
            }
            else {
                // All other goals
                state = 'app.goals.' + screen;
            }
            return {
                params: params,
                state: state,
            };
        }
        /**
         * @exception GoalTypeException
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'goal' implicitly has an 'any' type.
         * @param goalType {string}
         * @constructor
         */
        function GoalTypeException(goalType) {
            this.name = 'GoalServicesGoalTypeException';
            this.message = 'The passed goal type, "' + goalType + '", is not allowed.".';
            console.trace();
        }
        /**
         * @method move
         * @param goalId {number}
         * @param oldPlanId {number} - ID for goal's previous plan, necessary to clear cache
         * @param newPlanId {number} - ID of target plan to move goal to
         * @returns {object} - promise
         */
        function move(goalId, oldPlanId, newPlanId) {
            return $http({
                errorMessage: 'Could not move Plan',
                method: 'PATCH',
                url: planGoalsServiceUrl +
                    '/' +
                    ETWServicesUtils.asId(newPlanId) +
                    '/goals/' +
                    ETWServicesUtils.asId(goalId) +
                    '/move',
            }).finally(function () {
                try {
                    // It is a bad idea to have hard-coded goal types in the code.
                    // So at least by wrapping in asType() this line will break if types change in the future.
                    var planGoalType = asType('plan');
                    // Clear original plan and target plan from cache
                    getAllForPlan.clear(oldPlanId);
                    getAllForPlan.clear(newPlanId);
                    // Clear goal from cache
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
                    getByIdForType.clear(planGoalType, goalId);
                    // Notify subscribers
                    ETWServicesUtils.notify('PlansService');
                    ETWServicesUtils.notify('GoalsService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method removePerson
         * @param goalId {number}
         * @param goalType {string}
         * @param accessType {string}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
         * @param [planId] {number} - Plan ID to clear the cache
         * Removes all people access via the goal service.
         */
        function removeAllPeople(goalId, goalType, accessType, planId) {
            return $http({
                errorMessage: 'This person could not be removed from the goal.',
                method: 'DELETE',
                url: generateServiceUrl(goalType, goalId) + '/' + accessTypeActions[accessType],
            }).finally(function () {
                try {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalType' implicitly has an 'any' type.
                    // Clear goal cache
                    getByIdForType.clear(goalType, goalId);
                    if (planId) {
                        // clear for plan
                        getAllForPlan.clear(planId);
                    }
                    ETWServicesUtils.notify('GoalsService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method removePerson
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
         * @param goalId {number}
         * @param goalType {string}
         * @param personId {number}
         * @param accessType {string}
         * @param [planId] {number} - Plan ID to clear the cache
         * Removes a person via the goal service.
         */
        function removePerson(goalId, goalType, personId, accessType, planId) {
            return $http({
                errorMessage: 'This person could not be removed from the goal.',
                method: 'DELETE',
                url: generateServiceUrl(goalType, goalId) +
                    '/' +
                    accessTypeActions[accessType] +
                    '/' +
                    ETWServicesUtils.asId(personId),
            }).finally(function () {
                try {
                    // Clear goal cache
                    getByIdForType.clear(goalType, goalId);
                    if (planId) {
                        // clear for plan
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'options' implicitly has an 'any' type.
                        getAllForPlan.clear(planId);
                    }
                    ETWServicesUtils.notify('GoalsService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method removeSupportedGoal
         * @param goalId {number}
         * @param goalType {string}
         * @param parentGoalId {number}
         * @returns {object} - promise
         */
        function removeSupportedGoal(goalId, goalType, parentGoalId) {
            return $http({
                errorMessage: 'Could not assign a supported goal to this goal.',
                method: 'DELETE',
                data: { payload: null },
                url: serviceUrl +
                    '/' +
                    ETWServicesUtils.asId(goalId) +
                    '/supported/' +
                    ETWServicesUtils.asId(parentGoalId),
            }).finally(function () {
                try {
                    getByIdForType.clear(goalType, goalId);
                    ETWServicesUtils.notify('GoalsService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method save
         * @param goal {object}
         * @param [changedProperties] {string}
         * For Manager Assigned, Personal, Plan goals
         * When creating goals:
         *   Manager Assigned require ID of one assignee (expecting only one, takes first)
         *   Personal don't require assignee; API uses JWT
         *   Plan require plan ID
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
         * Updates to existing goals use same endpoint regardless of goalType.
         */
        function save(goal, changedProperties) {
            var goalType = getTypeFromGoal(goal), isPlanGoal = goalType == 'plan' && goal.plan && goal.plan.id, options = {
                data: _.omitBy(goal, _.isArray),
                errorMessage: 'The goal could not be saved.',
                idName: 'id',
                properties: changedProperties,
                url: serviceUrl + '/' + goalType,
            }, assigneeId = _.first(goal.assignees);
            if (goal.id) {
                // All existing goals use goalType/goalId
                options.url = generateServiceUrl(goalType, goal.id);
            }
            else if (isPlanGoal) {
                // New plan goals pass the plan ID in the url.
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goal' implicitly has an 'any' type.
                options.url = generateGetAllForEntityServiceUrl('plan', goal.plan.id);
            }
            else if (goalType == 'manager_assigned') {
                // New manager assigned goals (or other client-specific goal types) must be created with one assignee ID
                options.url = generateGetAllForEntityServiceUrl('manager_assigned', assigneeId);
            }
            return ETWServicesUtils.save(options, modelDefinition, 'GoalsService', function () {
                // Clear the cache (before subscribers are notified)
                if (angular.isDefined(goal.id)) {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goal' implicitly has an 'any' type.
                    getByIdForType.clear(getTypeFromGoal(goal), goal.id);
                }
                if (isPlanGoal) {
                    getAllForPlan.clear(goal.plan.id);
                    // @ts-ignore ts-migrate(2532) FIXME: Object is possibly 'undefined'.
                    // Clear Plan Cache
                    PlansService.getById.clear(goal.plan.id);
                }
            });
        }
        /**
         * @method searchByPlan
         * @param planId {number}
         * @param query {string}
         * @returns {object} - promise, Array
         */
        function searchByPlan(planId, query) {
            query = query.toLowerCase();
            return getAllForPlan(planId).then(function getAllSuccess(response) {
                // Remove the ones that don't match
                _.remove(response.data, function (record) {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'screen' implicitly has an 'any' type.
                    return record.title.toLowerCase().indexOf(query) === -1;
                });
                return response;
            });
        }
        /**
         * @method searchSupportableGoals
         * @param type {string}
         * @param goalId {number}
         * @param query {string}
         * @returns {object} - promise, Array
         * Note: Currently, only plan goals are public/shared
         */
        function searchSupportableGoalsById(type, goalId, query) {
            query = query.toLowerCase();
            return getSupportableGoals(type, goalId).then(function getAllSuccess(response) {
                // Remove the ones that don't match
                _.remove(response.data, function (record) {
                    // @ts-ignore
                    return !record.title || record.title.toLowerCase().indexOf(query) === -1;
                });
                return response;
            });
        }
        function updateGoalDueDate(dueDateMessage) {
            var options = {
                data: dueDateMessage,
                errorMessage: 'This message could not be saved.',
                url: serviceUrl +
                    '/' +
                    ETWServicesUtils.asId(dueDateMessage.goalId) +
                    '/goalType/' +
                    dueDateMessage.goalType +
                    '/duedate',
            };
            return ETWServicesUtils.save(options, modelDefinition, 'GoalsService');
        }
        /**
         * @method updateGoalSortOrder
         * @param planId {number}
         * @param goalId {number}
         * @param sortId {number}
         * @returns {object} - promise
         * Updates the Goal sort order for a plan.
         */
        function updateGoalSortOrder(planId, goalId, sortId) {
            return $http({
                errorMessage: 'Sort order not updated',
                method: 'PATCH',
                url: planGoalsServiceUrl +
                    '/' +
                    ETWServicesUtils.asId(planId) +
                    '/goals/' +
                    ETWServicesUtils.asId(goalId) +
                    '/sortId/' +
                    ETWServicesUtils.asId(sortId),
            });
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalType' implicitly has an 'any' type.

(function () {
    angular
        .module('ETWServices')
        .factory('KPIDataPointsService', [
        '$cacheFactory',
        '$http',
        'ETWServicesUtils',
        'GoalsService',
        'KPIsService',
        'PlansService',
        KpiDataPointsServiceFactory,
    ]);
    function KpiDataPointsServiceFactory(
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$cacheFactory' implicitly has an 'any' ... Remove this comment to see the full error message
    $cacheFactory, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
    $http, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ETWServicesUtils' implicitly has an 'an... Remove this comment to see the full error message
    ETWServicesUtils, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'GoalsService' implicitly has an 'any' t... Remove this comment to see the full error message
    GoalsService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'KPIsService' implicitly has an 'any' ty... Remove this comment to see the full error message
    KPIsService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'PlansService' implicitly has an 'any' t... Remove this comment to see the full error message
    PlansService) {
        // NOTE: KPIs and Data Points do not have their own service, but are always a part of a plan.
        /**
         * @property modelDefinition
         * @type {Object}
         * Configuration object used by ETWServicesUtils for formatting certain columns
         */
        var modelDefinition = {
            columns: {
                date: 'date',
            },
        };
        /**
         * @property plansServiceUrl
         * @type {string}
         */
        var plansServiceUrl = ETWServicesUtils.getEndpointUrl('KPI_PLANS');
        var service = {
            ACTUAL: -1,
            PLAN: -2,
            destroyForKpi: destroyForKpi,
            getAllForKpi: getAllForKpi,
            getByIdForKpi: getByIdForKpi,
            reject: ETWServicesUtils.reject,
            saveForKpi: saveForKpi,
            subscribe: ETWServicesUtils.subscribe('KPIDataPointsService'),
            unsubscribeAll: ETWServicesUtils.unsubscribeAll('KPIDataPointsService'),
        };
        /**
         * @function getAllForPlan.clear
         * @param planId {number}
         * @param kpiId {number}
         * @param seriesId {number}
         * @private
         * Clears the cache for the getAllForPlan() results.
         * All methods that modify KPIs must call this method.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
        getAllForKpi.clear = function (planId, kpiId, seriesId) {
            // @ts-ignore ts-migrate(2554) FIXME: Expected 4 arguments, but got 3.
            $cacheFactory.get('$http').remove(generateServiceUrl(planId, kpiId, seriesId));
            if (planId) {
                // Clear the KPI Service. Data points are nested within the KPI.
                KPIsService.getByIdForPlan.clear(planId, kpiId);
            }
        };
        /**
         * @function getByIdForPlan.clear
         * @param planId {number}
         * @param kpiId {number}
         * @param seriesId {number}
         * @param id {number}
         * Clears the cache for getByIdForPlan(id) then calls getAllForPlan.clear()
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
        getByIdForKpi.clear = function (planId, kpiId, seriesId, id) {
            $cacheFactory.get('$http').remove(generateServiceUrl(planId, kpiId, seriesId, id));
            getAllForKpi.clear(planId, kpiId, seriesId);
        };
        return service;
        /**
         * @method destroyForKpi
         * @param planId {number}
         * @param kpiId {number}
         * @param seriesId {number}
         * @param id {number}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
        function destroyForKpi(planId, kpiId, seriesId, id) {
            return $http({
                method: 'DELETE',
                url: generateServiceUrl(planId, kpiId, seriesId, id),
            }).finally(function () {
                try {
                    getByIdForKpi.clear(planId, kpiId, seriesId, id);
                    ETWServicesUtils.notify('KPIDataPointsService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @function generateServiceUrl
         * @param planId {number}
         * @param kpiId {number}
         * @param seriesId {number} - series ID
         *   -1 = Actual
         *   -2 = Plan
         * @param [id] {number} - optional KPI ID
         * @returns {string}
         * @private
         * Used to generate the URI for the endpoints.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
        function generateServiceUrl(planId, kpiId, seriesId, id) {
            var url = plansServiceUrl +
                '/' +
                ETWServicesUtils.asId(planId) +
                '/kpis/' +
                ETWServicesUtils.asId(kpiId);
            if (seriesId === service.ACTUAL || seriesId === service.PLAN) {
                url += seriesId === service.ACTUAL ? '/actualpoints' : '/planpoints';
            }
            else {
                url += '/series/' + Number(seriesId) + '/points';
            }
            if (angular.isDefined(id)) {
                url += '/' + ETWServicesUtils.asId(id);
            }
            return url;
        }
        /**
         * @deprecated - data points are included in the kpi object
         * @method getAllForKpi
         * @param planId {number}
         * @param kpiId {number}
         * @param seriesId {number}
         * @returns {object} - promise, Array of Plans
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
        function getAllForKpi(planId, kpiId, seriesId) {
            return $http({
                errorMessage: 'Plans could not be retrieved.',
                method: 'GET',
                // @ts-ignore ts-migrate(2693) FIXME: 'any' only refers to a type, but is being used as ... Remove this comment to see the full error message
                url: generateServiceUrl(planId, kpiId, seriesId),
                // @ts-ignore ts-migrate(2693) FIXME: 'any' only refers to a type, but is being used as ... Remove this comment to see the full error message
            }).then(ETWServicesUtils.decodeResponse(modelDefinition), ETWServicesUtils.reject);
        }
        /**
         * @deprecated - data points are included in the kpi object
         * @method getByIdForPlan
         * @param planId {number}
         * @param kpiId {number}
         * @param seriesId {number}
         * @param id {number}
         * @returns {object} - promise, Plan object
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
        function getByIdForKpi(planId, kpiId, seriesId, id) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
            return $http({
                cache: true,
                errorMessage: 'This plan could not be retrieved.',
                method: 'GET',
                url: generateServiceUrl(planId, kpiId, seriesId, id),
            }).then(ETWServicesUtils.decodeResponse(modelDefinition), ETWServicesUtils.reject);
        }
        /**
         * @method saveForKpi
         * @param point {object}
         * @param planId {number}
         * @param kpiId {number}
         * @param seriesId {number}
         * @param [changedProperties] {array} - optional. For partial updates
         * @returns {object} - promise, Plan
         * Create/update/patch a KPI
         * TODO: KPI API only accepts POST and PATCH
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'point' implicitly has an 'any' type.
        function saveForKpi(point, planId, kpiId, seriesId, changedProperties) {
            var options = {
                data: point,
                errorMessage: 'This data point could not be saved.',
                idName: 'id',
                properties: changedProperties,
                // @ts-ignore ts-migrate(2554) FIXME: Expected 4 arguments, but got 3.
                url: generateServiceUrl(planId, kpiId, seriesId),
            };
            if (angular.isDefined(point.id)) {
                options.url = generateServiceUrl(planId, kpiId, seriesId, point.id);
            }
            // Save the point, notify subscribers, clear cache on callback.
            return ETWServicesUtils.save(options, modelDefinition, 'KPIDataPointsService', function () {
                // Clear Plan Cache
                PlansService.getById.clear(planId);
                // Clear the cache (before subscribers are notified)
                if (angular.isDefined(point.id)) {
                    getByIdForKpi.clear(planId, kpiId, seriesId, point.id);
                }
                else {
                    getAllForKpi.clear(planId, kpiId, seriesId);
                }
            }).finally(function () {
                //with auto-status potentially connected goals status can change need to clear
                GoalsService.getAllForPlan.clear(planId);
                ETWServicesUtils.notify('GoalsService');
            });
        }
    }
})();

(function () {
    /**
     * @property accessTypes
     * @type {object}
     * @private
     * Map of accessTypes to URI path
     * Used by addPerson and removePerson.
     */
    var accessTypes = {
        assignee: 'assignees',
    };
    /**
     * @property accessTypeActions
     * @type {object}
     * Used to map abstracted terms used in access modal with terms used in the API.
     */
    var accessTypeActions = {
        assignee: 'assignees',
    };
    /**
     * @property autoStatusComparisonSources
     * @type {object}
     * Currently, Auto Status is derived from the Plan series or a flat value.
     * The intention is that eventually other series in addition to Plan can be used for comparison.
     * In the interim, we only decide between value and plan series.
     */
    var autoStatusComparisonSources = {
        0: 'Value',
        1: 'Plan',
    };
    /**
     * @property autoStatusDataTypes
     * @type {object}
     * Map to data formats used for Auto Status comparison.
     * Format IDs are the same used by dataTypesAnd
     */
    var autoStatusDataTypes = {
        1: 'Number',
        3: 'Percent',
    };
    /**
     * @property chartDirections
     * @type {object}
     */
    var chartDirections = {
        0: 'Higher is better',
        1: 'Lower is better',
    };
    /**
     * @property chartTypes
     * @type {Array}
     */
    var chartTypes = [
        {
            hasDates: true,
            hasPlan: true,
            hasProjections: true,
            isAggregatable: true,
            isAxisPadded: true,
            isSinglePoint: false,
            name: 'line',
            padding: 0,
            radius: 3,
            title: 'Line',
        },
        {
            hasDates: true,
            hasPlan: true,
            hasProjections: true,
            isAggregatable: true,
            isAxisPadded: true,
            isSinglePoint: false,
            name: 'spline',
            padding: 0,
            radius: 3,
            title: 'Spline',
        },
        {
            hasDates: true,
            hasPlan: true,
            hasProjections: false,
            isAggregatable: true,
            isAxisPadded: true,
            isSinglePoint: false,
            name: 'step',
            padding: 0,
            radius: 3,
            title: 'Step',
        },
        {
            hasDates: true,
            hasPlan: true,
            hasProjections: true,
            isAggregatable: true,
            isAxisPadded: true,
            isSinglePoint: false,
            name: 'area',
            padding: 0,
            radius: 3,
            title: 'Area',
        },
        {
            hasDates: true,
            hasPlan: true,
            hasProjections: true,
            isAggregatable: true,
            isAxisPadded: true,
            isSinglePoint: false,
            name: 'area-spline',
            padding: 0,
            radius: 3,
            title: 'Area Spline',
        },
        {
            hasDates: true,
            hasPlan: true,
            hasProjections: false,
            isAggregatable: true,
            isAxisPadded: true,
            isSinglePoint: false,
            name: 'area-step',
            padding: 0,
            radius: 3,
            title: 'Area Step',
        },
        {
            hasDates: true,
            hasPlan: true,
            hasProjections: false,
            isAggregatable: true,
            isAxisPadded: false,
            isSinglePoint: false,
            name: 'bar',
            padding: 0,
            radius: 3,
            title: 'Bar',
        },
        {
            hasDates: false,
            hasPlan: true,
            hasProjections: false,
            isAggregatable: true,
            isAxisPadded: true,
            isSinglePoint: false,
            name: 'scatter',
            padding: 0,
            radius: 10,
            title: 'Scatter',
        },
        {
            hasDates: false,
            hasPlan: false,
            hasProjections: false,
            isAggregatable: false,
            isAxisPadded: true,
            isSinglePoint: false,
            name: 'pie',
            padding: 0,
            radius: 3,
            title: 'Pie',
        },
        {
            hasDates: false,
            hasPlan: false,
            hasProjections: false,
            isAggregatable: false,
            isAxisPadded: true,
            isSinglePoint: false,
            name: 'donut',
            padding: 0,
            radius: 3,
            title: 'Donut',
        },
        {
            hasDates: false,
            hasPlan: false,
            hasProjections: false,
            isAggregatable: false,
            isAxisPadded: true,
            isSinglePoint: true,
            name: 'gauge',
            padding: 20,
            radius: 3,
            title: 'Gauge',
        },
    ];
    /**
     * @property dataTypesAndFormats
     * @type {object}
     * Config for different data types.
     */
    var dataTypesAndPrecision = {
        1: {
            title: 'Number',
            group: 'General',
            precision: {
                0: 'None',
                1: '.0',
                2: '.00',
                3: '.000',
                4: '.0000',
            },
        },
        2: {
            title: '$',
            group: 'Currency',
            precision: {
                0: 'None',
                1: '.0',
                2: '.00',
            },
        },
        3: {
            title: '%',
            group: 'General',
            precision: {
                0: 'None',
                1: '.0',
                2: '.00',
                3: '.000',
                4: '.0000',
            },
        },
    };
    angular
        .module('ETWServices')
        .factory('KPIsService', [
        '$cacheFactory',
        '$http',
        'ETWServicesUtils',
        'GoalsService',
        KpisServiceFactory,
    ]);
    // KPI: KEY PERFORMANCE INDICATOR
    function KpisServiceFactory($cacheFactory, $http, ETWServicesUtils, GoalsService) {
        // NOTE: KPIs do not have their own API, but are always a part of a plan.
        var service = {
            CHART_TYPES: chartTypes,
            COMPARISON_SOURCES: autoStatusComparisonSources,
            COMPARISON_TYPES: autoStatusDataTypes,
            DIRECTIONS: chartDirections,
            LIST_OF_NONAGGREGATABLE_CHART_TYPES: 'Pie, Donut, and Gauge',
            TYPES_AND_PRECISION: dataTypesAndPrecision,
            addAggregate: addAggregate,
            addAllPeople: addAllPeople,
            addPerson: addPerson,
            all: ETWServicesUtils.all,
            assignTo: assignTo,
            attachmentDestroy: attachmentDestroy,
            attachmentSave: attachmentSave,
            attachmentUpload: attachmentUpload,
            calculatePlanActualDelta: calculatePlanActualDelta,
            clone: clone,
            cloneNoPoints: cloneNoPoints,
            destroy: destroy,
            destroySeries: destroySeries,
            getAggregateLeafNodes: getAggregateLeafNodes,
            getAllAggregateKpis: getAllAggregateKpis,
            getAllForPlan: getAllForPlan,
            getAllForUser: getAllForUser,
            getByIdForPlan: getByIdForPlan,
            getDataPointFilter: getDataPointFilter,
            getFiles: getFiles,
            getMutability: getMutability,
            getNew: getNew,
            move: move,
            reject: ETWServicesUtils.reject,
            removeAggregate: removeAggregate,
            removeAllPeople: removeAllPeople,
            removePerson: removePerson,
            resolve: ETWServicesUtils.resolve,
            saveForPlan: saveForPlan,
            saveSeries: saveSeries,
            searchByPlan: searchByPlan,
            subscribe: ETWServicesUtils.subscribe('KPIsService'),
            unassignFrom: unassignFrom,
            unsubscribe: ETWServicesUtils.unsubscribe('KPIsService'),
            unsubscribeAll: ETWServicesUtils.unsubscribeAll('KPIsService'),
            // @ts-ignore ts-migrate(7006) FIXME: Parameter '$cacheFactory' implicitly has an 'any' ... Remove this comment to see the full error message
            updateKpiSortOrder: updateKpiSortOrder,
        };
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ETWServicesUtils' implicitly has an 'an... Remove this comment to see the full error message
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'GoalsService' implicitly has an 'any' t... Remove this comment to see the full error message
         * @property planGoalsServiceUrl
         * @type {string}
         */
        var goalKPIsServiceUrl = ETWServicesUtils.getEndpointUrl('GOALS');
        /**
         * @property plansServiceUrl
         * @type {string}
         */
        var plansServiceUrl = ETWServicesUtils.getEndpointUrl('KPI_PLANS');
        /**
         * @property userKpiServiceUrl
         * @type {string}
         */
        var userKpiServiceUrl = ETWServicesUtils.getEndpointUrl('KPI_USERS');
        /**
         * @property fileServiceUrl
         * @type {string}
         */
        var fileServiceUrl = ETWServicesUtils.getEndpointUrl('PLANS_FILES');
        /**
         * @property kpiServiceUrl
         * @type {string}
         */
        var kpiServiceUrl = ETWServicesUtils.getEndpointUrl('KPI');
        /**
         * @function getAllForPlan.clear
         * @param planId {number}
         * @private
         * Clears the cache for the getAllForPlan() results.
         * All methods that modify KPIs must call this method.
         */
        getAllForPlan.clear = function (planId) {
            // @ts-ignore
            $cacheFactory.get('$http').remove(generateServiceUrl(planId));
        };
        /**
         * @function getByIdForPlan.clear
         * @param planId {number}
         * @param id {number}
         * Clears the cache for getByIdForPlan(id) then calls getAllForPlan.clear()
         */
        getByIdForPlan.clear = function (planId, id) {
            $cacheFactory.get('$http').remove(generateServiceUrl(planId, id));
            getAllForPlan.clear(planId);
        };
        return service;
        /**
         * @method addAggregate
         * @param parentKpiPlanId {number}
         * @param parentKpiId {number}
         * @param planId {number}
         * @param kpiId {number}
         */
        function addAggregate(parentKpiPlanId, parentKpiId, planId, kpiId) {
            var baseUrl = plansServiceUrl +
                '/' +
                ETWServicesUtils.asId(parentKpiPlanId) +
                '/kpis/' +
                ETWServicesUtils.asId(parentKpiId) +
                '/aggregateKpi/' +
                ETWServicesUtils.asId(kpiId);
            return $http({
                errorMessage: 'Could not add aggregate KPI',
                method: 'POST',
                url: baseUrl,
            }).finally(function addAggregateKpiFinal() {
                clearCachesForAggregation(planId, parentKpiPlanId, kpiId, parentKpiId);
            });
        }
        /**
         * @method addAllPeople
         * @param planId {number}
         * @param kpiId {number}
         * @param accessType {string}
         * @param people {Array}
         * @returns {object}
         */
        function addAllPeople(planId, kpiId, accessType, people) {
            var peopleList = _.map(people, function (person) {
                return {
                    id: person.id,
                    flag: person._isSubscribed,
                };
            });
            var params = { ids: peopleList };
            return $http({
                errorMessage: '',
                method: 'POST',
                data: params,
                url: plansServiceUrl +
                    '/' +
                    ETWServicesUtils.asId(planId) +
                    '/kpis/' +
                    ETWServicesUtils.asId(kpiId) +
                    '/' +
                    accessTypeActions[accessType],
            }).finally(function () {
                try {
                    // clear kpi cache
                    if (angular.isDefined(kpiId)) {
                        getByIdForPlan.clear(planId, kpiId);
                    }
                    else {
                        getAllForPlan.clear(planId);
                    }
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method addPerson
         * @param planId {number}
         * @param kpiId {number}
         * @param personId {number}
         * @param accessType {string} - [assignee], maps to accessTypes
         * @returns {object} - promise
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
         */
        // @ts-ignore ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
        function addPerson(planId, kpiId, personId, accessType) {
            return changePerson(planId, kpiId, personId, accessType, 'POST');
        }
        /**
         * @method assignTo
         * @param type {string} - Model type to assign to
         * @param {...*} n - other parameters specific to the type
         * @returns {object} - promise
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
         * Used to assign roles to various models
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
         * Usage:
         *   RolesService.assignTo('Person', 1, 2)
         */
        function assignTo(type, n) {
            var args = _.tail(arguments), promise;
            switch (type) {
                case 'PlanGoal':
                    promise = assignToPlanGoal.apply(service, args);
                    break;
            }
            return promise;
        }
        /**
         * @method assignToPlanGoal
         * @param goalId {number}
         * @param kpiId {number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'parentKpiPlanId' implicitly has an 'any... Remove this comment to see the full error message
         * @param isPrimary {boolean} - Temporary
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'parentKpiId' implicitly has an 'any' ty... Remove this comment to see the full error message
         * @param [planId] {number} - Temporary
         * @returns {object} - promise
         * @private
         * Assigns a role to a person. See assignTo()
         */
        function assignToPlanGoal(kpiId, goalId, isPrimary, planId) {
            var url = goalKPIsServiceUrl +
                '/' +
                ETWServicesUtils.asId(goalId) +
                '/kpis/' +
                ETWServicesUtils.asId(kpiId);
            if (isPrimary) {
                url += '/primary';
            }
            return $http({
                errorMessage: 'Could not assign the KPI to this goal.',
                method: 'POST',
                data: { payload: null },
                url: url,
            }).finally(function () {
                try {
                    // clear goal cache
                    GoalsService.getByIdForType.clear('plan', goalId);
                    if (planId) {
                        GoalsService.getAllForPlan.clear(planId);
                    }
                    ETWServicesUtils.notify('KPIsService');
                    ETWServicesUtils.notify('GoalsService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
         * @method attachmentDestroy
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'accessType' implicitly has an 'any' typ... Remove this comment to see the full error message
         * @param planId {number}
         * @param kpiId {number}
         * @returns {Function}
         * Curries the IDs for the plan and KPI into the standard destroy method. Controllers can then just pass type and attachment.
         * Clears the cache and notifies subscribers.
         */
        function attachmentDestroy(planId, kpiId) {
            var baseUrl = plansServiceUrl +
                '/' +
                ETWServicesUtils.asId(planId) +
                '/kpis/' +
                ETWServicesUtils.asId(kpiId);
            return function (type, attachment) {
                getByIdForPlan.clear(planId, kpiId);
                return ETWServicesUtils.attachmentDestroy(type, baseUrl, attachment).finally(function attachmentSaveFinal() {
                    // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                    try {
                        ETWServicesUtils.notify('KPIsService');
                    }
                    catch (e) {
                        console.error(e);
                    }
                });
            };
        }
        /**
         * @method attachmentSave
         * @param planId {number}
         * @param kpiId {number}
         * @returns {Function}
         * Curries the plan ID and KPI ID in the standard upload method. Controllers can then just pass type and attachment.
         * Clears the cache and notifies subscribers.
         */
        function attachmentSave(planId, kpiId) {
            var baseUrl = plansServiceUrl +
                '/' +
                ETWServicesUtils.asId(planId) +
                '/kpis/' +
                ETWServicesUtils.asId(kpiId);
            return function (type, attachment, isAdminEntity) {
                getByIdForPlan.clear(planId, kpiId);
                return ETWServicesUtils.attachmentSave(type, baseUrl, attachment, isAdminEntity).finally(
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                function attachmentSaveFinal() {
                    try {
                        ETWServicesUtils.notify('KPIsService');
                    }
                    catch (e) {
                        console.error(e);
                    }
                });
            };
        }
        /**
         * @method attachmentUpload
         * @param planId {number}
         * @param kpiId {number}
         * @returns {Function}
         * Curries the IDs for the plan and kpi into the standard upload method. Controllers can then just pass type and attachment.
         * Clears the cache and notifies any subscribers.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
        function attachmentUpload(planId, kpiId) {
            var baseUrl = plansServiceUrl +
                '/' +
                ETWServicesUtils.asId(planId) +
                '/kpis/' +
                ETWServicesUtils.asId(kpiId), 
            // @ts-ignore ts-migrate(2345) FIXME: Argument of type 'any[]' is not assignable to para... Remove this comment to see the full error message
            baseDownloadUrl = plansServiceUrl +
                '/' +
                ETWServicesUtils.asId(planId) +
                '/kpis/' +
                ETWServicesUtils.asId(kpiId);
            return function (type, attachment, isAdminEntity) {
                getByIdForPlan.clear(planId, kpiId);
                return ETWServicesUtils.attachmentUpload(baseUrl, attachment, isAdminEntity, baseDownloadUrl).finally(function attachmentSaveFinal() {
                    try {
                        ETWServicesUtils.notify('KPIsService');
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'kpiId' implicitly has an 'any' type.
                    }
                    catch (e) {
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'isPrimary' implicitly has an 'any' type... Remove this comment to see the full error message
                        console.error(e);
                    }
                });
            };
        }
        /**
         * @function calculatePlanActualDelta
         * @returns {number}
         * @private
         * Calculates the difference between the last Actual and the most recent Plan.
         */
        function calculatePlanActualDelta(lastActual, series) {
            //if there's no lastActual, exit
            if (_.isEmpty(lastActual)) {
                return 0;
            }
            // get timestamp for lastActual
            var lastActualTime = new Date(lastActual.date).getTime();
            //sort the plan points by date
            var sortedPlanPoints = _.sortBy(series.plan.points, 'date');
            //get all the plan points before actual
            var plansBeforeActual = _.filter(sortedPlanPoints, function (p) {
                return p.date <= lastActual.date;
            });
            // get plan point immediately prior to lastActual chronologically (prevPlan)
            var prevPlan = _.last(plansBeforeActual);
            //get the plan points after the actual
            var plansAfterActual = _.filter(sortedPlanPoints, function (p) {
                return p.date > lastActual.date;
            });
            // get plan point immediately following lastActual chronologically (nextPlan)
            var nextPlan = _.first(plansAfterActual);
            //exit if there's no previous plan point
            if (!prevPlan) {
                return 0;
            }
            //if there's no nextPlan
            if (!nextPlan) {
                //clone the other point
                nextPlan = _.clone(prevPlan);
                //set a new date 1 second in the future from the last actual.
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                //date in the future doesn't really matter since value doesn't
                //change from prevPlan
                nextPlan.date = new Date(lastActual.date).getTime() + 1000;
            }
            //get the prevPlan timestamp
            var x1 = new Date(prevPlan.date).getTime();
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
            //get the nextPlan timestamp
            var x2 = new Date(nextPlan.date).getTime();
            //find the slope of "Plan"
            var slope = (prevPlan.number - nextPlan.number) / (x1 - x2);
            //find the intercept of "Plan"
            var intercept = prevPlan.number - slope * x1;
            //get the expected value for "Plan" where "Actual" is
            var expectedPlanValue = slope * lastActualTime + intercept;
            //calculate the difference between the nextPlan and lastActual
            var diff = lastActual.number - expectedPlanValue;
            //send back the difference
            return diff || 0;
        }
        /**
         * @method changePerson
         * @private
         * @param planId {number}
         * @param kpiId {number}
         * @param personId {number}
         * @param accessType {string} - [assignee], maps to accessTypes
         * @param method {string} - [POST|DELETE]
         * @returns {object} - promise
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
         * Called by addPerson and removePerson
         */
        function changePerson(planId, kpiId, personId, accessType, method) {
            var accessTypePath = accessTypes[accessType];
            if (!accessTypePath) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
                throw new Error('Access Type is invalid.');
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'attachment' implicitly has an 'any' typ... Remove this comment to see the full error message
            }
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'isAdminEntity' implicitly has an 'any' ... Remove this comment to see the full error message
            return $http({
                errorMessage: 'This person could not be added.',
                method: method,
                url: plansServiceUrl +
                    '/' +
                    ETWServicesUtils.asId(planId) +
                    '/kpis/' +
                    ETWServicesUtils.asId(kpiId) +
                    '/' +
                    accessTypePath +
                    '/' +
                    ETWServicesUtils.asId(personId),
            }).finally(function () {
                try {
                    getByIdForPlan.clear(planId, kpiId);
                    ETWServicesUtils.notify('KPIsService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @function clearCachesForAggregation
         * @param planId {number}
         * @param parentPlanId {number}
         * @param kpiId {number}
         * @param parentKpiId {number}
         * @private
         * Clear the cached data that might have been changed when a kpi is added or removed from an aggregation list.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
        function clearCachesForAggregation(planId, parentPlanId, kpiId, parentKpiId) {
            GoalsService.getAllForPlan.clear(parentPlanId);
            // Clear cache for parent KPI.
            getByIdForPlan.clear(parentPlanId, parentKpiId);
            // Clear cache for KPI that has been removed.
            getByIdForPlan.clear(planId, kpiId);
            // Notify subscribers
            ETWServicesUtils.notify('KPIsService');
        }
        /**
         * @method clone
         * @param planId {number}
         * @param sourceId {number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
         * @returns {object} - promise, object
         */
        function clone(planId, sourceId) {
            // API supports cloning to another plan, UI does not
            var newPlanId = planId;
            var options = {
                data: {},
                errorMessage: 'There was a problem cloning this KPI.',
                idName: 'id',
                url: plansServiceUrl +
                    '/' +
                    ETWServicesUtils.asId(planId) +
                    '/kpis' +
                    '?sourceKpiId=' +
                    ETWServicesUtils.asId(sourceId) +
                    '&planId=' +
                    ETWServicesUtils.asId(newPlanId),
            };
            return ETWServicesUtils.save(options, undefined, 'KPIsService');
        }
        /**
         * Clone KPI without cloning the data series
         * @method cloneNoPoints
         * @param planId {number}
         * @param sourceId {number}
         * @param newPlanId {number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'lastActual' implicitly has an 'any' typ... Remove this comment to see the full error message
         * @returns {object} - promise, object
         */
        function cloneNoPoints(planId, sourceId, newPlanId) {
            // API supports cloning to another plan, UI does not... oh yes it does
            var options = {
                data: {},
                errorMessage: 'There was a problem cloning this KPI.',
                idName: 'id',
                url: plansServiceUrl +
                    '/' +
                    ETWServicesUtils.asId(planId) +
                    '/kpis' +
                    '?sourceKpiId=' +
                    ETWServicesUtils.asId(sourceId) +
                    '&planId=' +
                    ETWServicesUtils.asId(newPlanId) +
                    '&noData=true',
            };
            return ETWServicesUtils.save(options, undefined, 'KPIsService');
        }
        /**
         * @method destroy
         * @param planId {number}
         * @param id {number}
         */
        function destroy(planId, id) {
            return $http({
                errorMessage: 'This KPI could not be removed.',
                method: 'DELETE',
                url: generateServiceUrl(planId, id),
            }).finally(function () {
                try {
                    getByIdForPlan.clear(planId, id);
                    GoalsService.getAllForPlan.clear(planId);
                    ETWServicesUtils.notify('KPIsService');
                    ETWServicesUtils.notify('GoalsService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method destroySeries
         * @param planId {number}
         * @param kpiId {number}
         * @param seriesId {number}
         * @returns {object} - promise
         */
        function destroySeries(planId, kpiId, seriesId) {
            return $http({
                method: 'DELETE',
                url: generateSeriesServiceUrl(planId, kpiId, seriesId),
            }).finally(function () {
                try {
                    getByIdForPlan.clear(planId, kpiId);
                    ETWServicesUtils.notify('KPIsService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @function generateSeriesServiceUrl
         * @param planId {number}
         * @param kpiId {number}
         * @param [seriesId] {number} - optional KPI ID
         * @returns {string}
         * @private
         * Used to generate the URI for the endpoints.
         */
        function generateSeriesServiceUrl(planId, kpiId, seriesId) {
            var url = plansServiceUrl +
                '/' +
                ETWServicesUtils.asId(planId) +
                '/kpis/' +
                ETWServicesUtils.asId(kpiId) +
                '/series';
            if (angular.isDefined(seriesId)) {
                url += '/' + ETWServicesUtils.asId(seriesId);
            }
            return url;
        }
        /**
         * @function generateServiceUrl
         * @param planId {number}
         * @param [kpiId] {number} - optional KPI ID
         * @returns {string}
         * @private
         * Used to generate the URI for the endpoints.
         */
        function generateServiceUrl(planId, kpiId) {
            var url = plansServiceUrl + '/' + ETWServicesUtils.asId(planId) + '/kpis';
            if (angular.isDefined(kpiId)) {
                url += '/' + ETWServicesUtils.asId(kpiId);
            }
            return url;
        }
        function generateServiceUrlWithState(planId, state) {
            var url = plansServiceUrl + '/' + ETWServicesUtils.asId(planId) + '/kpis';
            if (angular.isDefined(state)) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                url += '?state=' + state;
            }
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'accessType' implicitly has an 'any' typ... Remove this comment to see the full error message
            return url;
        }
        /**
// @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
         * @method getAggregateLeafNodes
         * @param kpiId
         * @returns {object} - promise
         */
        function getAggregateLeafNodes(kpiId) {
            return $http({
                errorMessage: 'Kpi Aggregate leaf nodes could not be retrieved.',
                method: 'GET',
                url: kpiServiceUrl + '/aggregate_leaf_nodes/' + ETWServicesUtils.asId(kpiId),
            });
        }
        /**
         * @method getAllAggregateKpis
         * @param kpiId
         * @returns {object} - promise
         */
        function getAllAggregateKpis(kpiId) {
            return $http({
                errorMessage: 'Kpi Aggregates could not be retrieved.',
                method: 'GET',
                url: kpiServiceUrl + '/aggregate_all_nodes/' + ETWServicesUtils.asId(kpiId),
            });
        }
        /**
         * @method getAllForPlan
         * @param planId {number}
         * @param state {number} - state and lower to return
         * @returns {object} - promise, Array of Plans
         */
        function getAllForPlan(planId, state) {
            return $http({
                errorMessage: 'Plans could not be retrieved.',
                method: 'GET',
                url: generateServiceUrlWithState(planId, state),
            });
        }
        /**
         * @function getAllForPlanTree
         * @param planId {number}
         * @returns {object} - promise, Array of Plans
         * @private
         */
        function getAllForPlanTree(planId) {
            var url = plansServiceUrl + '/' + ETWServicesUtils.asId(planId) + '/all';
            return $http({
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                errorMessage: 'Plans could not be retrieved.',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'kpiId' implicitly has an 'any' type.
                method: 'GET',
                url: url,
            });
        }
        /**
         * @method getAllForUser
         * @param userId {number}
         * @returns {object} - promise, array
         * Returns KPIs the user is assigned to.
         */
        function getAllForUser(userId) {
            return $http({
                errorMessage: 'Could not retrieve KPIs',
                url: userKpiServiceUrl + '/' + ETWServicesUtils.asId(userId) + '/kpis',
            });
        }
        /**
         * @method getByIdForPlan
         * @param planId {number}
         * @param id {number}
         * @returns {object} - promise, Plan object
         */
        function getByIdForPlan(planId, id) {
            return $http({
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                cache: true,
                errorMessage: 'This KPI could not be retrieved.',
                method: 'GET',
                url: generateServiceUrl(planId, id),
            }).then(setDefaults);
        }
        /**
         * @method getDataPointFilter
         * @param typeId {number}
         * @param formatId {number}
         * @returns {string} - angular filter
         * @desc returns a filter based on kpi.type AND kpi.format
         */
        function getDataPointFilter(typeId) {
            var filter = 'number', params = '';
            if (typeId) {
                // Set the filter based on selected type
                switch (dataTypesAndPrecision[typeId].title) {
                    case '$':
                        filter = 'currency';
                        params = ',$';
                        break;
                    case '%':
                        filter = 'percentage';
                        break;
                }
            }
            return filter + params;
        }
        /**
         * @method getFiles
         * @param planId {number}
         * @param kpiId {number}
         * @returns {object} - promise, array
         * Returns data for attached files.
         */
        function getFiles(planId, kpiId) {
            return $http({
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                errorMessage: 'Files could not be retrieved for this KPI.',
                method: 'GET',
                url: fileServiceUrl +
                    '/' +
                    ETWServicesUtils.asId(planId) +
                    '/kpis/' +
                    ETWServicesUtils.asId(kpiId),
            }).then(function (response) {
                _.forEach(response.data, function (file) {
                    file.downloadUrl =
                        plansServiceUrl +
                            '/' +
                            ETWServicesUtils.asId(planId) +
                            '/kpis/' +
                            ETWServicesUtils.asId(kpiId) +
                            '/file/' +
                            file.id;
                });
                return response;
            }, service.reject);
        }
        /**
         * @method getMutability
         * @param kpi {object}
         * @returns {string}
         * Looks at aggregate parents and aggregate settings to determine if given KPI can be moved/cloned/deleted.
         */
        function getMutability(kpi) {
            var immutableReason;
            if (angular.isArray(kpi.aggregateParents) && kpi.aggregateParents.length > 0) {
                immutableReason =
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                    'This KPI cannot be moved, cloned or deleted because it contributes to an aggregated KPI.';
            }
            else if (kpi.aggregate !== 0 && kpi.aggregate != '0') {
                immutableReason =
                    'This KPI cannot be moved, cloned or deleted because it imports data from other KPI.';
            }
            return immutableReason;
        }
        /**
         * @method getNew
         * @param [options] {object} - defaults
         * @returns {object} - promise
         * Create a new record with defaults.
         */
        function getNew(options) {
            return ETWServicesUtils.resolve({ data: options || {} }).then(setDefaults);
        }
        /**
         * @method move
         * @param kpiId {number}
         * @param oldPlanId {number}
         * @param newPlanId {number}
         * Move the KPI from one plan to another.
         */
        function move(kpiId, oldPlanId, newPlanId) {
            return $http({
                errorMessage: 'Could not move KPI',
                method: 'PATCH',
                url: 
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                plansServiceUrl +
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'seriesId' implicitly has an 'any' type.
                    '/' +
                    ETWServicesUtils.asId(oldPlanId) +
                    '/kpis/' +
                    ETWServicesUtils.asId(kpiId) +
                    '/newplan/' +
                    ETWServicesUtils.asId(newPlanId),
            }).finally(function moveKpiToPlanFinal() {
                // Clear cache for KPI using OLD plan
                getByIdForPlan.clear(oldPlanId, kpiId);
                // Notify subscribers
                ETWServicesUtils.notify('KPIsService');
                GoalsService.getAllForPlan.clear(oldPlanId);
                ETWServicesUtils.notify('GoalsService');
            });
        }
        /**
         * @method removeAggregate
         * @param parentKpiPlanId {number}
         * @param parentKpiId {number}
         * @param planId {number}
         * @param kpiId {number}
         */
        function removeAggregate(parentKpiPlanId, parentKpiId, planId, kpiId) {
            var baseUrl = plansServiceUrl +
                '/' +
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                ETWServicesUtils.asId(parentKpiPlanId) +
                '/kpis/' +
                ETWServicesUtils.asId(parentKpiId) +
                '/aggregateKpi/' +
                ETWServicesUtils.asId(kpiId);
            return $http({
                errorMessage: 'Could not remove aggregate KPI',
                method: 'DELETE',
                url: baseUrl,
            }).finally(function removeAggregateKpiFinal() {
                clearCachesForAggregation(planId, parentKpiPlanId, kpiId, parentKpiId);
            });
        }
        /**
         * @method removeAllPeople
         * @param accessType {string}
         * @param [planId] {number} - Plan ID to clear the cache
         * @param [kpiId] {number} - KPI ID to clear the cache
         * Removes all people access via the goal service.
         */
        function removeAllPeople(planId, kpiId, accessType) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
            return $http({
                errorMessage: 'This person could not be removed from the goal.',
                method: 'DELETE',
                url: ETWServicesUtils.getEndpointUrl('KPI_PLANS') +
                    '/' +
                    planId +
                    '/' +
                    'kpis/' +
                    kpiId +
                    '/' +
                    accessTypeActions[accessType],
            }).finally(function () {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                try {
                    // clear kpi cache
                    if (angular.isDefined(kpiId)) {
                        getByIdForPlan.clear(planId, kpiId);
                    }
                    else {
                        getAllForPlan.clear(planId);
                    }
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method removePerson
         * @param planId {number}
         * @param kpiId {number}
         * @param personId {number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'kpiId' implicitly has an 'any' type.
         * @param accessType {string} - [assignee], maps to accessTypes
         * @returns {object} - promise
         */
        function removePerson(planId, kpiId, personId, accessType) {
            return changePerson(planId, kpiId, personId, accessType, 'DELETE');
        }
        /**
         * @method save
         * @param kpi {object}
         * @param planId {number}
         * @param [changedProperties] {array} - optional. For partial updates
         * @returns {object} - promise, Plan
         * Create/update/patch a KPI
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'kpiId' implicitly has an 'any' type.
        function saveForPlan(kpi, planId, changedProperties) {
            var options = {
                errorMessage: 'This kpi could not be saved.',
                idName: 'id',
                properties: changedProperties,
                // @ts-ignore
                url: generateServiceUrl(planId),
            };
            if (angular.isDefined(kpi.id)) {
                options.url = generateServiceUrl(planId, kpi.id);
            }
            if (changedProperties && changedProperties.indexOf('autoStatusEnabled') !== -1) {
                setDefaultsForAutoStatus(kpi, changedProperties);
            }
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
            // Copy KPI to options. Arrays are not sent to the API.
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'state' implicitly has an 'any' type.
            options.data = _.omitBy(kpi, _.isArray);
            return ETWServicesUtils.save(options, undefined, 'KPIsService', function () {
                // Clear the cache (before subscribers are notified)
                // TODO: Clear cache for goals using shared/public kpis
                if (planId) {
                    // Primary KPIs can be cached on a goal, so clear the goals on same plan
                    GoalsService.getAllForPlan.clear(planId);
                }
                if (angular.isDefined(kpi.id)) {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                    getByIdForPlan.clear(planId, kpi.id);
                }
                else {
                    getAllForPlan.clear(planId);
                }
            });
        }
        /**
         * @method saveSeries
         * @param series {object}
         * @param planId {number}
         * @param kpiId {number}
         * @param [changedProperties] {array} - optional. For partial updates
         * @returns {object}
         */
        function saveSeries(series, planId, kpiId, changedProperties) {
            var options = {
                // Clone Series object. Arrays are not sent to the API.
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'userId' implicitly has an 'any' type.
                data: _.omitBy(series, _.isArray),
                errorMessage: 'The data series could not be saved.',
                idName: 'id',
                properties: changedProperties,
                // @ts-ignore
                url: generateSeriesServiceUrl(planId, kpiId),
            };
            if (angular.isDefined(series.id)) {
                options.url = generateSeriesServiceUrl(planId, kpiId, series.id);
            }
            return ETWServicesUtils.save(options, undefined, 'KPIsService', function () {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                // Clear the cache (before subscribers are notified)
                if (angular.isDefined(series.id)) {
                    getByIdForPlan.clear(planId, kpiId);
                }
                else {
                    getAllForPlan.clear(planId);
                }
            });
        }
        /**
         * @method searchByPlan
         * @param planId {number}
         * @param isIncludeSupportingPlans {boolean} - Should KPIs from supporting plans be included
         * @param query {string}
         * @returns {object} - promise, Array
         */
        function searchByPlan(planId, isIncludeSupportingPlans, query) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'typeId' implicitly has an 'any' type.
            var promise = isIncludeSupportingPlans ? getAllForPlanTree(planId) : getAllForPlan(planId);
            query = query.toLowerCase();
            return promise.then(function getAllSuccess(response) {
                try {
                    // Use only unique KPIs
                    // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                    var matches = _.uniqBy(response.data, 'id');
                    if (query) {
                        // Remove the ones that don't match (title might be null or an empty string)
                        _.remove(matches, function (record) {
                            // @ts-ignore
                            return !record.title || record.title.toLowerCase().indexOf(query) === -1;
                        });
                    }
                    response.data = matches;
                }
                catch (e) {
                    console.error('KPI SEARCH BY PLAN ERROR', e);
                }
                return response;
            });
        }
        /**
         * @function setDefaults
         * @param response {object}
         * @returns {object} - $http response
         * @private
         * Used to populate missing columns and create blank KPIs.
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
         * Auto Status is on by default.
         * Usually this would just be getNew(), but empty columns from existing KPIs require these values, too.
         * Usage:
         *   $http(…).then(setDefaults);
         */
        function setDefaults(response) {
            _.defaults(response.data, {
                aggregate: 0,
                aggregateParents: [],
                aggregateSet: [],
                autoStatusEnabled: 1,
                chartType: 'area-spline',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                series: [],
                state: 2,
                type: 1,
                displayPrecision: 0,
            });
            setDefaultsForAutoStatus(response.data, []);
            return response;
        }
        /**
         * @function setDefaultsForAutoStatus
         * @param kpi {object}
         * @param properties {Array}
         * Used when Auto Status is turned on.
         * Piggy backs default values into PATCH save.
         */
        function setDefaultsForAutoStatus(kpi, properties) {
            if (kpi.autoStatusEnabled) {
                if (_.isNil(kpi.autoStatusComparisonType)) {
                    kpi.autoStatusComparisonType = 1;
                    properties.push('autoStatusComparisonType');
                }
                if (_.isNil(kpi.autoStatusDataType)) {
                    kpi.autoStatusDataType = 3;
                    properties.push('autoStatusDataType');
                }
                if (_.isNil(kpi.autoStatusCutpointMax)) {
                    kpi.autoStatusCutpointMax = 10;
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'kpi' implicitly has an 'any' type.
                    properties.push('autoStatusCutpointMax');
                }
                if (_.isNil(kpi.autoStatusCutpointMin)) {
                    kpi.autoStatusCutpointMin = 0;
                    properties.push('autoStatusCutpointMin');
                }
                if (_.isNil(kpi.autoStatusDirection)) {
                    kpi.autoStatusDirection = 0;
                    properties.push('autoStatusDirection');
                }
            }
        }
        /**
         * @method unassignFrom
         * @param type {string}
         * @param {...*} n - other parameters specific to the type
         * Used to remove a KPI from something.
         * See assignTo()
         */
        function unassignFrom(type, n) {
            var args = _.tail(arguments);
            switch (type) {
                case 'PlanGoal':
                    unassignFromPlanGoal.apply(service, args);
                    break;
            }
        }
        /**
         * @function unassignFromPlanGoal
         * @param goalId {number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'options' implicitly has an 'any' type.
         * @param kpiId {number}
         * @param [planId] {number}
         * @returns {object} - promise
         * @private
         * Remove an Role from a Person.
         */
        function unassignFromPlanGoal(goalId, kpiId, planId) {
            return $http({
                errorMessage: 'Could not remove the role from this person.',
                method: 'DELETE',
                url: 
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'kpiId' implicitly has an 'any' type.
                goalKPIsServiceUrl +
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'oldPlanId' implicitly has an 'any' type... Remove this comment to see the full error message
                    '/' +
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'newPlanId' implicitly has an 'any' type... Remove this comment to see the full error message
                    ETWServicesUtils.asId(goalId) +
                    '/kpis/' +
                    ETWServicesUtils.asId(kpiId),
            }).finally(function () {
                try {
                    // clear goal cache
                    GoalsService.getByIdForType.clear('plan', goalId);
                    if (planId) {
                        GoalsService.getAllForPlan.clear(planId);
                    }
                    ETWServicesUtils.notify('KPIsService');
                    ETWServicesUtils.notify('GoalsService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method updateKpiSortOrder
         * @param planId {number}
         * @param kpiId {number}
         * @param sortId {number}
         * @returns {object} - promise
         * Updates the Kpi sort order for a plan.
         */
        function updateKpiSortOrder(planId, kpiId, sortId) {
            return $http({
                errorMessage: 'Sort order not updated',
                method: 'PATCH',
                url: plansServiceUrl +
                    '/' +
                    ETWServicesUtils.asId(planId) +
                    '/kpis/' +
                    ETWServicesUtils.asId(kpiId) +
                    '/sortId/' +
                    ETWServicesUtils.asId(sortId),
            }).finally(function () {
                try {
                    // clear the goal cache
                    if (planId) {
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'parentKpiPlanId' implicitly has an 'any... Remove this comment to see the full error message
                        GoalsService.getAllForPlan.clear(planId);
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                    }
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'kpiId' implicitly has an 'any' type.
                    ETWServicesUtils.notify('GoalsService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.

(function () {
    angular
        .module('ETWServices')
        .factory('LeadershipLevelsService', [
        '$http',
        'ETWServicesUtils',
        LeadershipLevelsServiceFactory,
    ]);
    function LeadershipLevelsServiceFactory($http, ETWServicesUtils) {
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
         * @property leadershipLevelModelDefinition
         * @type {object}
         */
        var leadershipLevelModelDefinition = {
            columns: {
                startDate: 'date',
                endDate: 'date',
            },
        };
        /**
         * @property modelDefinition
         * @type {object}
         */
        var modelDefinition = {};
        var service = {
            all: ETWServicesUtils.all,
            assignToUser: assignToUser,
            destroy: destroy,
            getAll: getAll,
            getById: getById,
            getForUser: getForUser,
            getNew: getNew,
            reject: ETWServicesUtils.reject,
            resolve: ETWServicesUtils.resolve,
            save: save,
            saveUsersLeadershipLevel: saveUsersLeadershipLevel,
            subscribe: ETWServicesUtils.subscribe('LeadershipLevelsService'),
            unsubscribe: ETWServicesUtils.unsubscribe('LeadershipLevelsService'),
            unsubscribeAll: ETWServicesUtils.unsubscribeAll('LeadershipLevelsService'),
        };
        /**
         * @property serviceUrl
         * @type {string}
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('LEADERSHIP_LEVELS');
        /**
         * @property usersLevelServiceUrl
         * @type {string}
         */
        var usersLevelServiceUrl = ETWServicesUtils.getEndpointUrl('USERS_LEVEL');
        return service;
        /**
         * @method assignToUser
         * @param {number} leadershipLevelId
         * @param {number} userId
         * @returns {object} - promise
         */
        function assignToUser(leadershipLevelId, userId) {
            var options = {
                data: {},
                errorMessage: 'Cannot assign User to Leadership Level',
                url: [
                    usersLevelServiceUrl,
                    ETWServicesUtils.asId(userId),
                    'leadership',
                    ETWServicesUtils.asId(leadershipLevelId),
                ].join('/'),
            };
            return ETWServicesUtils.save(options, modelDefinition, 'LeadershipLevelsService');
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'leadershipLevelId' implicitly has an 'a... Remove this comment to see the full error message
         * @method destroy
         * @param levelId {number}
         * @param [reassignLevelId] {number}
         * @returns {object} - promise
         */
        function destroy(levelId, reassignLevelId) {
            var options = {
                errorMessage: 'This leadership level could not be removed.',
                url: serviceUrl + '/' + ETWServicesUtils.asId(levelId),
            };
            if (reassignLevelId) {
                // @ts-ignore
                options.params = {
                    reassignLevelId: ETWServicesUtils.asId(reassignLevelId),
                };
            }
            return ETWServicesUtils.destroy(options, modelDefinition, 'LeadershipLevelsService');
        }
        /**
         * @method getAll
         * @returns {object} - promise, Array of Leadership Levels
         */
        function getAll() {
            return $http({
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'levelId' implicitly has an 'any' type.
                errorMessage: 'Leadership Levels could not be retrieved.',
                method: 'GET',
                url: serviceUrl,
            });
        }
        /**
         * @method getById
         * @params id {number}
         * @returns {object} - promise, Array
         */
        function getById(id) {
            return $http({
                method: 'GET',
                url: serviceUrl + '/' + ETWServicesUtils.asId(id),
            });
        }
        /**
         * @method getForUser
         * @param {number} userId
         * @returns {object} - promise
         */
        function getForUser(userId) {
            return $http({
                method: 'GET',
                url: [usersLevelServiceUrl, ETWServicesUtils.asId(userId), 'leadership'].join('/'),
            });
        }
        /**
         * @method getNew
         * @param [options] {object}
         * @returns {object} - promise
         * Acts like getById() but instead returns a new unsaved level with whatever options are passed.
         */
        function getNew(options) {
            var data = _.defaults(options, { title: '', description: null });
            return ETWServicesUtils.resolve({
                data: data,
            });
        }
        /**
         * @method save
         * @param level {object}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
         * @param [changedProperties] {Array}
         */
        function save(level, changedProperties) {
            var options = {
                data: _.cloneDeep(level),
                idName: 'id',
                properties: changedProperties,
                url: serviceUrl,
            };
            if (level.id) {
                options.url = serviceUrl + '/' + ETWServicesUtils.asId(level.id);
            }
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'userId' implicitly has an 'any' type.
            return ETWServicesUtils.save(options, modelDefinition, 'LeadershipLevelsService');
        }
        /**
         * @method saveUsersLeadershipLevel
         * @param {object} level
         * @param {string} property
         */
        function saveUsersLeadershipLevel(level, property) {
            var options = {
                data: level,
                errorMessage: 'Could not update Users Leadership Level.',
                idName: 'id',
                properties: [property],
                url: [
                    usersLevelServiceUrl,
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'options' implicitly has an 'any' type.
                    ETWServicesUtils.asId(level.userId),
                    'leadership',
                    ETWServicesUtils.asId(level.leadershipLevelId),
                    'levels',
                    ETWServicesUtils.asId(level.id),
                ].join('/'),
            };
            return ETWServicesUtils.save(options, leadershipLevelModelDefinition, 'LeadershipLevelsService');
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'level' implicitly has an 'any' type.

(function () {
    angular
        .module('ETWServices')
        .factory('MeetingInstancesService', [
        '$http',
        'ETWServicesUtils',
        'MeetingSeriesService',
        'PeopleService',
        MeetingInstancesServiceFactory,
    ]);
    function MeetingInstancesServiceFactory(
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
    $http, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ETWServicesUtils' implicitly has an 'an... Remove this comment to see the full error message
    ETWServicesUtils, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'MeetingSeriesService' implicitly has an... Remove this comment to see the full error message
    MeetingSeriesService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'PeopleService' implicitly has an 'any' ... Remove this comment to see the full error message
    PeopleService) {
        /**
         * @property modelDefinition
         * @type {object}
         */
        var modelDefinition = {
            columns: {
                date: 'date',
            },
        };
        var service = {
            getById: getById,
            getCompletedForSeries: getCompletedForSeries,
            getLastCompletedForSeries: getLastCompletedForSeries,
            getNew: getNew,
            getPendingForSeries: getPendingForSeries,
            reject: ETWServicesUtils.reject,
            resolve: ETWServicesUtils.resolve,
            save: save,
            subscribe: ETWServicesUtils.subscribe('MeetingInstancesService'),
            unsubscribe: ETWServicesUtils.unsubscribe('MeetingInstancesService'),
        };
        /**
         * @deprecated
         * @property serviceUrlForSeries
         * @type {string}
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('MEETING_INSTANCES');
        /**
         * @property serviceUrlForPeople
         * @type {string}
         */
        var serviceUrlForPeople = ETWServicesUtils.getEndpointUrl('MEETING_USERS');
        /**
         * @property serviceUrlForSeries
         * @type {string}
         */
        var serviceUrlForSeries = ETWServicesUtils.getEndpointUrl('MEETING_SERIES');
        return service;
        /**
         * @function getAllForSeries
         * @param personId {number}
         * @param seriesId {number}
         * @param isCompleted {boolean}
         * @param pageNumber {number}
         * @param params {object}
         * @returns {object} - promise, Array
         * @private
         * Note: `completed` is required by the API. Use getCompletedForSeries or getPendingForSeries.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'personId' implicitly has an 'any' type.
        function getAllForSeries(personId, seriesId, isCompleted, pageNumber, params) {
            _.defaults(params, {
                completed: isCompleted,
                pageNumber: pageNumber || 0,
                pageSize: 25,
                sortBy: 'date',
                ascending: false,
            });
            return $http({
                errorMessage: false,
                method: 'GET',
                params: params,
                url: serviceUrlForPeople +
                    '/' +
                    ETWServicesUtils.asId(personId) +
                    '/series/' +
                    ETWServicesUtils.asId(seriesId) +
                    '/instances',
            });
        }
        /**
         * @method getById
         * @param personId {number}
         * @param id {number}
         * @returns {*}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'personId' implicitly has an 'any' type.
        function getById(personId, id) {
            return $http({
                method: 'GET',
                url: serviceUrlForPeople +
                    '/' +
                    ETWServicesUtils.asId(personId) +
                    '/instances/' +
                    ETWServicesUtils.asId(id),
            });
        }
        /**
         * @method getCompletedForSeries
         * @param personId {number}
         * @param seriesId {number}
         * @param pageNumber {number}
         * @param [params] {object} - parameters for filtering
         * @returns {Object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'personId' implicitly has an 'any' type.
        function getCompletedForSeries(personId, seriesId, pageNumber, params) {
            return getAllForSeries(personId, seriesId, true, pageNumber, params || {});
        }
        /**
         * @method getLastCompletedForSeries
         * @param personId {number}
         * @param seriesId {number}
         * @returns {Object}
         * Note: 403 and 404 are a valid responses, do not show an error message.
         *   403: person wasn't a participant on the last instance
         *   404: there are no completed instances
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'personId' implicitly has an 'any' type.
        function getLastCompletedForSeries(personId, seriesId) {
            return $http({
                errorMessage: false,
                method: 'GET',
                url: serviceUrlForPeople +
                    '/' +
                    ETWServicesUtils.asId(personId) +
                    '/series/' +
                    ETWServicesUtils.asId(seriesId) +
                    '/lastCompletedMeeting',
            });
        }
        /**
         * @method getNew
         * @param options {Object}
         * @param [series] {Object} - required if you need to predict a date
         * @param [previousInstanceTimestamp] {string} - ISO 8601 string, required for predicting a date
         * @param [previousInstanceParticipantSet] {Array} - Array of user IDs
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'options' implicitly has an 'any' type.
        function getNew(options, series, previousInstanceTimestamp, previousInstanceParticipantSetIds) {
            var participants;
            // date
            if (!options.date && series) {
                options.date = MeetingSeriesService.suggestDate(series, previousInstanceTimestamp);
            }
            // participants
            if (!options.participantSet && series) {
                return PeopleService.getBasicByIds(previousInstanceParticipantSetIds).then(function (
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                response) {
                    var terminatedPeople = _.reject(response.data, {
                        terminationDate: null,
                    }); // null means not fired
                    var terminatedPeopleIds = _.map(terminatedPeople, 'id');
                    var seriesSuggestedParticipantIds = _.union(series.ownerSet, series.participantSet, previousInstanceParticipantSetIds);
                    options.participantSet = _.map(_.difference(seriesSuggestedParticipantIds, terminatedPeopleIds), function makeParticipant(id) {
                        return { userId: id, isAttendee: true };
                    });
                    return {
                        data: options,
                    };
                });
            }
            return ETWServicesUtils.resolve({
                data: options,
            });
        }
        /**
         * @method getPendingForSeries
         * @param personId {number}
         * @param seriesId {number}
         * @param pageNumber {number}
         * @param [params] {object} - parameters for filtering
         * @returns {Object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'personId' implicitly has an 'any' type.
        function getPendingForSeries(personId, seriesId, pageNumber, params) {
            return getAllForSeries(personId, seriesId, false, pageNumber, params || {});
        }
        /**
         * @method save
         * @param personId {number}
         * @param instance {object}
         * @param [changedProperties] {Array}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'personId' implicitly has an 'any' type.
        function save(personId, instance, changedProperties) {
            var options = {
                data: _.cloneDeep(instance),
                errorMessage: 'This meeting could not be saved.',
                idName: 'id',
                properties: changedProperties,
                url: serviceUrlForSeries + '/' + ETWServicesUtils.asId(instance.seriesId) + '/instances',
            };
            if (instance.id) {
                options.url = serviceUrl + '/' + ETWServicesUtils.asId(instance.id);
            }
            return ETWServicesUtils.save(options, modelDefinition, 'MeetingInstancesService');
        }
    }
})();

var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
(function () {
    angular
        .module('ETWServices')
        .factory('MeetingSeriesService', [
        '$http',
        'AuthenticationService',
        'MeetingTemplatesService',
        'ETWServicesUtils',
        MeetingSeriesServiceFactory,
    ]);
    /**
     * @property SERIES_FREQUENCIES
     * @type {object}
     * Map of frequencies (cadence) allowed by the API
     */
    var SERIES_FREQUENCIES = {
        DAILY: {
            delta: 1,
            sortValue: 1,
            title: 'Daily',
            unit: 'days',
        },
        WEEKLY: {
            delta: 7,
            sortValue: 7,
            title: 'Weekly',
            unit: 'days',
        },
        BIWEEKLY: {
            delta: 14,
            sortValue: 14,
            title: 'Biweekly',
            unit: 'days',
        },
        MONTHLY: {
            delta: 1,
            sortValue: 30,
            title: 'Monthly',
            unit: 'months',
        },
        BIMONTHLY: {
            delta: 2,
            sortValue: 60,
            title: 'Bimonthly',
            unit: 'months',
        },
        QUARTERLY: {
            delta: 3,
            sortValue: 90,
            title: 'Quarterly',
            unit: 'months',
        },
        SEMI_ANNUALLY: {
            delta: 6,
            sortValue: 180,
            title: 'Semiannually',
            unit: 'months',
        },
        ANNUALLY: {
            delta: 1,
            sortValue: 365,
            title: 'Annually',
            unit: 'years',
        },
        AD_HOC: {
            delta: 7,
            sortValue: 0,
            title: 'Ad Hoc',
            unit: 'days',
        },
    };
    /**
     * @property SERIES_TYPES
     * @type {object}
     * Map of meeting types allowed by the API
     */
    var SERIES_TYPES = {
        GENERAL: {
            title: 'General',
        },
        PLAN: {
            title: 'Plan',
        },
        ONE_TO_ONE: {
            title: '1:1',
        },
    };
    function MeetingSeriesServiceFactory($http, AuthenticationService, MeetingTemplatesService, ETWServicesUtils) {
        /**
         * @property modelDefinition
         * @type {object}
         */
        var modelDefinition = {
            columns: {
                _frequencyTitle: 'excluded',
                _frequencyValue: 'excluded',
            },
        };
        var service = {
            all: ETWServicesUtils.all,
            assign: assign,
            canView: canView,
            destroy: destroy,
            FREQUENCIES: SERIES_FREQUENCIES,
            getAll: getAll,
            getAllForPerson: getAllForPerson,
            getAllForPlan: getAllForPlan,
            getById: getById,
            getFrequencies: getFrequencies,
            // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
            getMeetingTemplates: getMeetingTemplates,
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'MeetingTemplatesService' implicitly has... Remove this comment to see the full error message
            getNew: getNew,
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ETWServicesUtils' implicitly has an 'an... Remove this comment to see the full error message
            hideUsersSeries: hideUsersSeries,
            hideUsersSeriesAll: hideUsersSeriesAll,
            reject: ETWServicesUtils.reject,
            resolve: ETWServicesUtils.resolve,
            save: save,
            subscribe: ETWServicesUtils.subscribe('MeetingSeriesService'),
            suggestDate: suggestDate,
            TYPES: SERIES_TYPES,
            unassign: unassign,
            unsubscribe: ETWServicesUtils.unsubscribe('MeetingSeriesService'),
            findTemplates: findTemplates,
            replaceName: replaceName,
        };
        /**
         * @property serviceUrl
         * @type {string}
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('MEETING_SERIES');
        /**
         * @property serviceUrlForPeople
         * @type {string}
         */
        var serviceUrlForPeople = ETWServicesUtils.getEndpointUrl('MEETING_USERS');
        /**
         * @property serviceUrlForPlans
         * @type {string}
         */
        var serviceUrlForPlans = ETWServicesUtils.getEndpointUrl('MEETING_PLANS');
        /**
         * @property serviceUrlForMeetingTemplates
         * @type {string}
         */
        var serviceUrlForMeetingTemplates = ETWServicesUtils.getEndpointUrl('MEETING_TEMPLATES');
        return service;
        /**
         * @method assign
         * @param id {number} - series ID
         * @param people {Array} - collection of people
         * @returns {object} - promise
         * Add owners to a meeting series.
         * Currently only general and 1:1 meetings.
         */
        function assign(id, people) {
            var params = {};
            // @ts-ignore
            params.ids = _.map(people, function (person) {
                return { id: person.id };
            });
            return $http({
                method: 'POST',
                data: params,
                url: serviceUrl + '/' + ETWServicesUtils.asId(id) + '/owners',
            });
        }
        /**
         * @method destroy
         * @param seriesId {number}
         * @returns {object} - promise
         */
        function destroy(seriesId) {
            var options = {
                errorMessage: 'This meeting series could not be removed.',
                url: serviceUrl + '/' + ETWServicesUtils.asId(seriesId),
            };
            return ETWServicesUtils.destroy(options, modelDefinition, 'MeetingSeriesService');
        }
        /**
         * @method canView
         * @param seriesId {number} - series ID
         * @returns {object} - promise
         */
        function canView(seriesId) {
            return $http({
                method: 'GET',
                url: serviceUrl + '/' + ETWServicesUtils.asId(seriesId) + '/can-view',
            });
        }
        /**
         * @method getAll
         * @returns {object} - promise, Array
         * Get all Meeting Series for the current user.
         */
        function getAll() {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
            return getAllForPerson(AuthenticationService.getAccount().userId);
        }
        /**
         * @method getAllForPerson
         * @param personId {number}
         * @returns {object} - promise, Array
         */
        function getAllForPerson(personId) {
            return $http({
                method: 'GET',
                url: serviceUrlForPeople + '/' + ETWServicesUtils.asId(personId) + '/series',
            });
        }
        /**
         * @method getAllForPlan
         * @params planId {number}
         * @returns {object} - promise, Array
         */
        function getAllForPlan(planId) {
            return $http({
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'seriesId' implicitly has an 'any' type.
                method: 'GET',
                url: serviceUrlForPlans + '/' + ETWServicesUtils.asId(planId) + '/series',
            });
        }
        /**
         * @method getById
         * @params id {number}
         * @returns {object} - promise, Array
         */
        function getById(id) {
            return $http({
                method: 'GET',
                url: serviceUrl + '/' + ETWServicesUtils.asId(id),
            });
        }
        /**
         * @method getFrequencies
         * @returns {Array}
         * Returns the list of frequencies in an array that can be used in nya-select.
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'seriesId' implicitly has an 'any' type.
         */
        function getFrequencies() {
            return _.map(SERIES_FREQUENCIES, function (v, k) {
                return { id: k, title: v.title };
            });
        }
        /**
         * @method getMeetingTemplates
         * @returns {object} - promise, array
         * Get all active meeting templates
         */
        function getMeetingTemplates() {
            return MeetingTemplatesService.getActive();
        }
        /**
         * @method getNew
         * @param [options] {object}
         * @returns {object} - promise
         * Acts like getById() but instead returns a new unsaved series with whatever options are passed.
         */
        function getNew(options) {
            var newSeries = _.defaultsDeep(options, {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'personId' implicitly has an 'any' type.
                frequency: 'WEEKLY',
                ownerSet: [AuthenticationService.getAccount().userId],
                rulesOfEngagement: '',
                type: 'GENERAL',
            });
            return ETWServicesUtils.resolve({ data: newSeries });
        }
        /**
         * @function getNextDate
         * @param timestamp {string} - ISO 8601 string from the API
         * @param frequencyKey {string}
         * @returns {Date}
         * @private
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
         * Determine what the next date for a Meeting Instance should be.
         * Note: nextDate might be in the past.
         */
        function getNextDate(timestamp, frequencyKey) {
            var frequency = SERIES_FREQUENCIES[frequencyKey], nextDate = new Date(timestamp);
            switch (frequency.unit) {
                case 'months':
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
                    nextDate.setMonth(nextDate.getMonth() + frequency.delta);
                    break;
                case 'years':
                    nextDate.setFullYear(nextDate.getFullYear() + frequency.delta);
                    break;
                case 'days':
                    nextDate.setDate(nextDate.getDate() + frequency.delta);
                    break;
            }
            return nextDate;
        }
        /**
         * @method hideUsersSeries
         * @param series
         * @returns {*}
         * Used to hide a meeting series from a users tray.
         * This requires it's own endpoint because it's user+series specific and there are different restrictions on who can do it.
         */
        function hideUsersSeries(series) {
            return save(series, ['hidden'], serviceUrl + '/' + ETWServicesUtils.asId(series.id) + '/hidden');
        }
        function hideUsersSeriesAll(series) {
            return save(series, ['hidden'], serviceUrl + '/' + ETWServicesUtils.asId(series.id) + '/hidden?allUsers=true');
        }
        /**
         * @method save
         * @param series {object}
         * @param [changedProperties] {Array}
         * @param [saveUrl] {String}
         */
        function save(series, changedProperties, saveUrl) {
            var options = {
                data: _.cloneDeep(series),
                errorMessage: 'This meeting series could not be saved.',
                idName: 'id',
                properties: changedProperties,
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'options' implicitly has an 'any' type.
                url: saveUrl || serviceUrl,
            };
            if (!saveUrl && series.id) {
                options.url = serviceUrl + '/' + ETWServicesUtils.asId(series.id);
            }
            return ETWServicesUtils.save(options, modelDefinition, 'MeetingSeriesService');
        }
        /**
         * @method suggestDate
         * @param series {object}
         * @param [previousInstanceTimestamp] {string} - ISO 8601 format date string
         * @returns {Date}
         */
        function suggestDate(series, previousInstanceTimestamp) {
            var midnight = new Date(), nextDate;
            midnight.setHours(0, 0, 0, 0);
            if (previousInstanceTimestamp) {
                nextDate = getNextDate(previousInstanceTimestamp, series.frequency);
                // next date or today, whichever one is later
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'timestamp' implicitly has an 'any' type... Remove this comment to see the full error message
                nextDate = midnight < nextDate ? nextDate : midnight;
                // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            }
            else {
                nextDate = midnight;
            }
            return nextDate;
        }
        /**
         * @method unassign
         * @param id {number} - series ID
         * @param [personId] {number} - ID of person to unassign
         * @returns {object} - promise
         * Remove owners to a meeting series.
         * Currently only general and 1:1 meetings.
         * If person is omitted (or doesn't have an ID), all people are unassigned.
         */
        function unassign(id, personId) {
            var url = serviceUrl + '/' + ETWServicesUtils.asId(id) + '/owners';
            if (personId) {
                url += '/' + ETWServicesUtils.asId(personId);
            }
            return $http({
                method: 'DELETE',
                url: url,
            });
        }
    }
    var TEMPLATE_START = ':template:';
    var TEMPLATE_END = ':end_template:';
    var NAME_START = ':name:';
    var NAME_END = ':end_name:';
    /**
     * @param {string} input
     * @param {number} offset
     * @returns {array}
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'series' implicitly has an 'any' type.
    function findTemplates(input, offset) {
        if (offset === void 0) { offset = 0; }
        if (!input)
            return [];
        if (input === '</p>')
            return [];
        var start = input.toLowerCase().indexOf(TEMPLATE_START);
        var end = input.toLowerCase().indexOf(TEMPLATE_END);
        if (start === -1)
            return [];
        if (end === -1)
            return [];
        var relativeStart = start + offset;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'series' implicitly has an 'any' type.
        var relativeEnd = end + offset;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'saveUrl' implicitly has an 'any' type.
        var nextStringStart = end + TEMPLATE_END.length;
        var nextOffset = nextStringStart + offset;
        var nameMeta = findName(input);
        var name = nameMeta.name, nameStart = nameMeta.start, nameEnd = nameMeta.end;
        var content = extractContent(input.slice(nameEnd, end));
        return __spreadArray([
            {
                start: relativeStart,
                end: relativeEnd,
                name: name,
                content: content,
                full: input.slice(start, end),
            }
        ], findTemplates(input.slice(nextStringStart), nextOffset));
    }
    function extractName(input) {
        if (input.startsWith('</p>'))
            return extractName(chopStart(input, 4));
        if (input.startsWith('<p>'))
            return extractName(chopStart(input, 3));
        if (input.endsWith('</p>'))
            return extractName(chopEnd(input, 4));
        if (input.endsWith('<p>'))
            return extractName(chopEnd(input, 3));
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'series' implicitly has an 'any' type.
        if (input.startsWith('<br>'))
            return extractName(chopStart(input, 4));
        if (input.endsWith('<br>'))
            return extractName(chopEnd(input, 4));
        return input.trim();
    }
    function extractContent(input) {
        if (input.startsWith('</p>') && input.endsWith('<p>')) {
            return chopStart(chopEnd(input, 3), 4);
        }
        return input;
    }
    function chopEnd(input, amount) {
        return input.slice(0, input.length - amount);
    }
    function chopStart(input, amount) {
        return input.slice(amount);
    }
    function findName(input) {
        var start = input.toLowerCase().indexOf(NAME_START);
        var end = input.toLowerCase().indexOf(NAME_END);
        return {
            start: start,
            end: end + NAME_END.length,
            name: extractName(input.slice(start + NAME_START.length, end)),
        };
    }
    function replaceName(input, template, newName) {
        var one = _replaceName(template.full, template, newName);
        var left = input.slice(0, template.start);
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
        var right = input.slice(template.end);
        return left + one + right;
    }
    function _replaceName(input, template, newName) {
        var _a = findName(input), start = _a.start, end = _a.end;
        var left = input.slice(0, start + NAME_START.length);
        var right = input.slice(end - NAME_END.length);
        return left + newName + right;
    }
})();
// @ts-ignore ts-migrate(7023) FIXME: 'findTemplates' implicitly has return type 'any' b... Remove this comment to see the full error message

(function () {
    angular
        .module('ETWServices')
        .factory('MeetingTemplatesService', [
        '$cacheFactory',
        '$http',
        'ETWServicesUtils',
        MeetingTemplatesServiceFactory,
    ]);
    /**
     * @property modelDefinition
     * @type {object}
     */
    var modelDefinition = {};
    function MeetingTemplatesServiceFactory($cacheFactory, $http, ETWServicesUtils) {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter '$cacheFactory' implicitly has an 'any' ... Remove this comment to see the full error message
        var service = {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
            attachmentDestroy: attachmentDestroy,
            attachmentSave: attachmentSave,
            attachmentUpload: attachmentUpload,
            destroy: destroy,
            destroyTopic: destroyTopic,
            destroyTopicDiscussionPoint: destroyTopicDiscussionPoint,
            getActive: getActive,
            getAll: getAll,
            getById: getById,
            getFiles: getFiles,
            reject: ETWServicesUtils.reject,
            resolve: ETWServicesUtils.resolve,
            save: save,
            saveTemplateTopic: saveTemplateTopic,
            saveTemplateDiscussionPoint: saveTemplateDiscussionPoint,
            search: search,
            subscribe: ETWServicesUtils.subscribe('MeetingTemplatesService'),
            unsubscribe: ETWServicesUtils.unsubscribe('MeetingTemplatesService'),
            unsubscribeAll: ETWServicesUtils.unsubscribeAll('MeetingTemplatesService'),
        };
        /**
         * @property fileServiceUrl
         * @type {string}
         */
        var fileServiceUrl = ETWServicesUtils.getEndpointUrl('MEETING_TEMPLATE_TOPIC_FILES');
        /**
         * @property serviceUrl
         * @type {string}
         * @private
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('MEETING_TEMPLATES');
        /**
         * @property templateTopicsServiceUrl
         * @type {string}
         */
        var templateTopicsServiceUrl = ETWServicesUtils.getEndpointUrl('MEETING_TEMPLATE_TOPICS');
        /**
         * @property TEMPLATE_STATE
         * type {object}
         * Backend overloaded concept of `etwState` without using the same Enum
         */
        var TEMPLATE_STATE = {
            draft: 0,
            active: 1,
        };
        /**
         * @method getAll.clear
         * Clears the cache for the getAll() request
         */
        getAll.clear = function getAllClear() {
            $cacheFactory.get('$http').remove(serviceUrl);
        };
        /**
         * @method getById.clear
         * @param id {number}
         * Clears the cache entry for the call to get this meeting template, then clears the cache for getAll.
         * Note: Since some meeting-templates are only fetched from a group, MeetingTemplatesService calls this method.
         */
        getById.clear = function getByIdClear(id) {
            $cacheFactory.get('$http').remove(serviceUrl + '/' + ETWServicesUtils.asId(id));
            getAll.clear();
        };
        return service;
        /**
         * @function attachmentDestroy
         * @param topicId {number}
         * @returns {Function}
         * Returns a function that has a common signature will all services that support attachments.
         */
        function attachmentDestroy(topicId) {
            var baseUrl = templateTopicsServiceUrl + '/' + ETWServicesUtils.asId(topicId);
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
            return function (type, attachment) {
                return ETWServicesUtils.attachmentDestroy(type, baseUrl, attachment, modelDefinition, 'MeetingTemplatesService');
            };
        }
        /**
         * @function attachmentSave
         * @param topicId {number}
         * @returns {Function}
         * Returns a function with a common signature to be used by attachment directives that are service agnostic.
         */
        function attachmentSave(topicId) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'topicId' implicitly has an 'any' type.
            var baseUrl = templateTopicsServiceUrl + '/' + ETWServicesUtils.asId(topicId);
            return function (type, attachment, isAdminEntity) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
                return ETWServicesUtils.attachmentSave(type, baseUrl, attachment, isAdminEntity, modelDefinition, 'MeetingTemplatesService');
            };
        }
        /**
         * @function attachmentUpload
         * @param topicId {number}
         * @returns {Function}
         * Returns a function for use with attachment directives.
         */
        function attachmentUpload(topicId) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'topicId' implicitly has an 'any' type.
            var baseUrl = templateTopicsServiceUrl + '/' + ETWServicesUtils.asId(topicId), baseDownloadUrl = templateTopicsServiceUrl + '/' + ETWServicesUtils.asId(topicId);
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
            return function (type, attachment, isAdminEntity) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'isAdminEntity' implicitly has an 'any' ... Remove this comment to see the full error message
                return ETWServicesUtils.attachmentUpload(baseUrl, attachment, isAdminEntity, baseDownloadUrl, modelDefinition, 'MeetingTemplatesService');
            };
        }
        /**
         * @method destroy
         * @param id {number}
         * (delete is a reserved word.)
         */
        function destroy(id) {
            return $http({
                errorMessage: 'This meeting template could not be deleted.',
                method: 'DELETE',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'topicId' implicitly has an 'any' type.
                url: serviceUrl + '/' + ETWServicesUtils.asId(id),
            }).finally(function () {
                try {
                    getAll.clear();
                    ETWServicesUtils.notify('MeetingTemplatesService');
                }
                catch (e) {
                    console.error(e);
                }
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
            });
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'attachment' implicitly has an 'any' typ... Remove this comment to see the full error message
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'isAdminEntity' implicitly has an 'any' ... Remove this comment to see the full error message
         * @method destroyTopic
         * @param meetingTemplateId {number}
         * @param topicId {number}
         * (delete is a reserved word.)
         */
        function destroyTopic(meetingTemplateId, topicId) {
            return $http({
                errorMessage: 'This template topic could not be deleted.',
                method: 'DELETE',
                url: serviceUrl +
                    '/' +
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
                    ETWServicesUtils.asId(meetingTemplateId) +
                    '/topics/' +
                    ETWServicesUtils.asId(topicId),
            }).finally(function () {
                try {
                    getAll.clear();
                    ETWServicesUtils.notify('MeetingTemplatesService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        function destroyTopicDiscussionPoint(meetingTemplateId, topicId, discussionId) {
            return $http({
                errorMessage: 'This template topic discussion point could not be deleted.',
                method: 'DELETE',
                url: serviceUrl +
                    '/' +
                    ETWServicesUtils.asId(meetingTemplateId) +
                    '/topics/' +
                    ETWServicesUtils.asId(topicId) +
                    '/discussionpoints/' +
                    ETWServicesUtils.asId(discussionId),
            }).finally(function () {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'meetingTemplateId' implicitly has an 'a... Remove this comment to see the full error message
                try {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'topicId' implicitly has an 'any' type.
                    getAll.clear();
                    ETWServicesUtils.notify('MeetingTemplatesService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method getAll
         * @returns {object} - promise, array
         * Get all meeting templates
         */
        function getAll() {
            return $http({
                errorMessage: 'There was a problem retrieving meeting templates.',
                method: 'GET',
                url: serviceUrl,
                cache: true,
            });
        }
        /**
         * @method getActive
         * @returns {object} - promise, array
         * Get active meeting templates
         */
        function getActive() {
            return getAll().then(function (resp) {
                resp.data = _.filter(resp.data, { state: TEMPLATE_STATE.active });
                return resp;
            });
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'meetingTemplateId' implicitly has an 'a... Remove this comment to see the full error message
         * @method getById
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'topicId' implicitly has an 'any' type.
         * @param id {string}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'discussionId' implicitly has an 'any' t... Remove this comment to see the full error message
         * @returns {object} - promise, object
         * Get a specific meeting template
         */
        function getById(id) {
            return $http({
                errorMessage: 'There was a problem retrieving this meeting template.',
                method: 'GET',
                url: serviceUrl + '/' + ETWServicesUtils.asId(id),
            }).then(function removeAssignmentInfoFromGroupGoals(response) {
                return response;
            });
        }
        /**
         * @method getFiles
         * @param topicId {number}
         * @returns {object} - promise
         * Request the attached files for particular meeting template
         */
        function getFiles(topicId) {
            return $http({
                errorMessage: 'Could not retrieve attached files.',
                method: 'GET',
                url: fileServiceUrl + '/' + ETWServicesUtils.asId(topicId),
            }).then(function (response) {
                _.forEach(response.data, function (file) {
                    file.downloadUrl =
                        templateTopicsServiceUrl + '/' + ETWServicesUtils.asId(topicId) + '/file/' + file.id;
                });
                return response;
            }, service.reject);
        }
        /**
         * @method save
         * @param meetingTemplate {object}
         * @param changedProperties {array} - optional. For partial updates
         * @returns {object} - promise, MeetingTemplates
         * Create/update/patch a meetingTemplate
         */
        function save(meetingTemplate, changedProperties) {
            var options = {
                data: meetingTemplate,
                errorMessage: false,
                idName: 'id',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'resp' implicitly has an 'any' type.
                properties: changedProperties,
                url: serviceUrl,
            };
            if (angular.isDefined(meetingTemplate.id)) {
                options.url = serviceUrl + '/' + ETWServicesUtils.asId(meetingTemplate.id);
            }
            return ETWServicesUtils.save(options, undefined, 'MeetingTemplatesService', getAll.clear).catch(serviceExceptionHandler);
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
         * @method saveTemplateTopic
         * @param meetingTemplateId {number}
         * @param templateTopic {object}
         * @param changedProperties {array} - optional. For partial updates
         * @returns {object} - promise, Template agenda Topic
         * Create/update/patch a Meeting template agenda Topic
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
         */
        function saveTemplateTopic(meetingTemplateId, templateTopic, changedProperties) {
            var options = {
                data: templateTopic,
                errorMessage: false,
                idName: 'id',
                properties: changedProperties,
                //url: serviceUrl
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'topicId' implicitly has an 'any' type.
                url: serviceUrl + '/' + ETWServicesUtils.asId(meetingTemplateId) + '/topics',
            };
            if (angular.isDefined(templateTopic.id)) {
                options.url =
                    serviceUrl +
                        '/' +
                        ETWServicesUtils.asId(meetingTemplateId) +
                        '/topics/' +
                        ETWServicesUtils.asId(templateTopic.id);
            }
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            return ETWServicesUtils.save(options, undefined, 'MeetingTemplatesService', getAll.clear).catch(serviceExceptionHandler);
        }
        /**
         * @method saveTemplateDiscussionPoint
         * @param meetingTemplateId {number}
         * @param topicId {number}
         * @param discussionPoint {string}
         * @param [discussionId] {number}
         * @returns {object} - promise
         */
        function saveTemplateDiscussionPoint(meetingTemplateId, topicId, discussionPoint, changedProperties) {
            var options = {
                data: discussionPoint,
                errorMessage: false,
                idName: 'id',
                properties: changedProperties,
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'meetingTemplate' implicitly has an 'any... Remove this comment to see the full error message
                url: serviceUrl + '/' + ETWServicesUtils.asId(meetingTemplateId) + '/topics/' +
                    ETWServicesUtils.asId(topicId) + '/discussionpoints',
            };
            if (angular.isDefined(discussionPoint.id)) {
                options.url =
                    serviceUrl + '/' + ETWServicesUtils.asId(meetingTemplateId) + '/topics/' +
                        ETWServicesUtils.asId(topicId) + '/discussionpoints/' + discussionPoint.id;
            }
            return ETWServicesUtils.save(options, undefined, 'MeetingTemplatesService', getAll.clear).catch(serviceExceptionHandler);
        }
        /**
         * @method search
         * @param query {string}
         * @returns {object} - promise, array
         * Standard search method. All searchable services should have this method, accept a string, return an array.
         */
        function search(query) {
            return $http({
                method: 'GET',
                url: serviceUrl,
                params: {
                    query: query,
                },
            }).then(function filterSearchResponse(response) {
                query = String(query).toLowerCase();
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'meetingTemplateId' implicitly has an 'a... Remove this comment to see the full error message
                // TODO: Until search API filters,
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'changedProperties' implicitly has an 'a... Remove this comment to see the full error message
                _.remove(response.data, function (row) {
                    return (
                    // @ts-ignore
                    String(row.title)
                        .toLowerCase()
                        .indexOf(query) == -1 &&
                        // @ts-ignore
                        String(row.description)
                            .toLowerCase()
                            .indexOf(query) == -1);
                });
                return response;
            }, ETWServicesUtils.reject);
        }
        /**
         * @function serviceExceptionHandler
         * @param response {object}
         * @returns {object} - promise. Passes along another rejection with the response so the controller can act on it.
         * @private
         * When the API returns an error message, display to the user and pray that it's understandable by humans.
         * Response.data properties: timestamp, status, error, exception, message, path.
         */
        function serviceExceptionHandler(response) {
            var message = angular.isString(response.data.error)
                ? response.data.error
                : 'This meeting template could not be saved.';
            ETWServicesUtils.notifyErrorMessage(message);
            return ETWServicesUtils.reject(response);
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'meetingTemplateId' implicitly has an 'a... Remove this comment to see the full error message

(function () {
    /**
     * @service MessagingService
     *
     * Events:
     *   realtime-messaging:updated-room-channels - Room list created or updated
     *   realtime-messaging:updated-dm-channels - Direct Message list created or updated
     */
    angular
        .module('ETWServices')
        .factory('MessagingService', [
        '$rootScope',
        '$http',
        '$q',
        'AuthenticationService',
        'PubnubService',
        'ETWServicesUtils',
        MessagingServiceFactory,
    ]);
    function MessagingServiceFactory($rootScope, $http, $q, AuthenticationService, PubnubService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$rootScope' implicitly has an 'any' typ... Remove this comment to see the full error message
    ETWServicesUtils
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$q' implicitly has an 'any' type.
    ) {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AuthenticationService' implicitly has a... Remove this comment to see the full error message
        var connectionPromise;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'PubnubService' implicitly has an 'any' ... Remove this comment to see the full error message
        var service = {
            // @ts-ignore ts-migrate(7034) FIXME: Variable 'connectionPromise' implicitly has type '... Remove this comment to see the full error message
            addAllRoomMembers: addAllRoomMembers,
            addRoomMember: addRoomMember,
            connect: connect,
            connectAndGetRoom: connectAndGetRoom,
            deleteRoom: deleteRoom,
            getAllAvailableRooms: getAllAvailableRooms,
            getDirectMessageChannels: getDirectMessageChannels,
            getDirectMessageRoomById: getDirectMessageRoomById,
            getDMByPerson: getDMByPerson,
            getNewRoom: getNewRoom,
            getNotificationChannels: getNotificationChannels,
            getRoomById: getRoomById,
            getRoomChannels: getRoomChannels,
            getRoomChannelsByPerson: getRoomChannelsByPerson,
            getChannelById: getChannelById,
            joinRoom: joinRoom,
            leaveDirectMessageRoom: leaveDirectMessageRoom,
            markChannelRead: markChannelRead,
            refreshDirectMessagesChannelStores: refreshDirectMessagesChannelStores,
            refreshRoomChannelStores: refreshRoomChannelStores,
            removeAllRoomMembers: removeAllRoomMembers,
            removeRoomMember: removeRoomMember,
            saveRoom: saveRoom,
            setRoomVisibility: setRoomVisibilty,
            subscribe: ETWServicesUtils.subscribe('MessagingService'),
            unsubscribe: ETWServicesUtils.unsubscribe('MessagingService'),
        };
        /**
         * @property channelsServiceUrl
         * @type {string}
         */
        var channelsServiceUrl = ETWServicesUtils.getEndpointUrl('REALTIME_MESSAGING_CHANNELS');
        /**
         * @property channelGroups
         * @type {Array}
         */
        var channelGroups = [];
        /**
         * @property directMesssageGroup
         * @type {object}
         */
        var directMesssageGroup = {};
        /**
         * @property directMessageChannels
         * @type {Array}
         */
        var directMessageChannels = [];
        /**
         * @property groupsServiceUrl
         * @type {string}
         */
        // @ts-ignore ts-migrate(7034) FIXME: Variable 'channelGroups' implicitly has type 'any[... Remove this comment to see the full error message
        var groupsServiceUrl = ETWServicesUtils.getEndpointUrl('REALTIME_MESSAGING_GROUPS');
        /**
         * @property usersServiceUrl
         * @type {string}
         */
        var usersServiceUrl = ETWServicesUtils.getEndpointUrl('REALTIME_MESSAGING_USERS');
        /**
         * @property hasGrantUserAccess
         * @type {boolean}
         */
        // @ts-ignore ts-migrate(7034) FIXME: Variable 'directMessageChannels' implicitly has ty... Remove this comment to see the full error message
        var hasGrantUserAccess = false;
        /**
         * @property directMessageChannels
         * @type {Array}
         */
        var notificationChannels = [];
        /**
         * @property directMessageGroup
         * @type {Object}
         */
        var notificationGroup = {};
        /**
         * @property roomChannels
         * @type {Array}
         */
        var roomChannels = [];
        /**
         * @property roomGroup
         * @type {object}
         */
        var roomGroup = {};
        /**
         * @property userId
         * Cached value of the userId.
         * Should only be accessed through getUserId()
         */
        var userId;
        /**
         * @property userServiceUrl
         * @type {string}
         */
        // @ts-ignore ts-migrate(7034) FIXME: Variable 'notificationChannels' implicitly has typ... Remove this comment to see the full error message
        var userServiceUrl = ETWServicesUtils.getEndpointUrl('REALTIME_MESSAGING_USERS');
        return service;
        /**
         * @method connect
         * @returns {object} - promise
         * Use this method to get a promise that is resolved when all the setup is complete.
// @ts-ignore ts-migrate(7034) FIXME: Variable 'roomChannels' implicitly has type 'any[]... Remove this comment to see the full error message
         * Calling then() on a promise *after* the promise has resolved will run the callback immediately.
         *
         * NOTE:
         * This will never reject.
         *
         * Usage:
         *   MessagingService.connect().then(function () {
         *     vm.roomChannels = MessagingService.getRoomChannels();
         *   });
         */
        function connect() {
            // @ts-ignore ts-migrate(7034) FIXME: Variable 'userId' implicitly has type 'any' in som... Remove this comment to see the full error message
            return $q(function (resolve) {
                if (connectionPromise) {
                    return resolve(connectionPromise);
                }
                if (AuthenticationService.hasModule('COMMUNICATION')) {
                    connectionPromise = init();
                    return resolve(connectionPromise);
                }
                var destroyListener = $rootScope.$on('user:changed', function () {
                    destroyListener();
                    return resolve(connect());
                });
            });
        }
        /**
         * @function init
         * @private
         * Note: Should ONLY be called by connect();
         */
        function init() {
            return AuthenticationService.getUserPerson()
                .then(getChannelGroupsForUser)
                .then(setupRooms)
                .then(setupDirectMessages)
                .then(setupNotifications)
                .then(function () {
                //subscribe to all pubnub channels with presence - group, direct
                var ch = _.map(directMessageChannels, 'uuid'), 
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'resolve' implicitly has an 'any' type.
                channels = _.union(roomChannels, directMessageChannels);
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'connectionPromise' implicitly has an 'an... Remove this comment to see the full error message
                if (channels.length) {
                    //subscribe to pubnub for room and dm channels
                    PubnubService.subscribeChannels(channels, true);
                }
                if (notificationChannels.length) {
                    //subscribe to pubnub for notificationChannels
                    PubnubService.subscribeChannels(notificationChannels, false);
                }
                //register to receive pubnub messages so we can look for changes in channel states
                PubnubService.registerListener('realtime-messaging:onMessage', onMessageEvent);
                //need to show who is online for initial direct message channels
                retrieveCurrentPresenceForAllDMChannels(ch);
            });
        }
        /**
         * @function retrieveCurrentPresenceForAllDMChannels
         * @private
         * Show who is online for initial direct message channels.
         */
        function retrieveCurrentPresenceForAllDMChannels(ch) {
            //need to show who is online for initial direct message channels
            PubnubService.getHereNowForChannels(ch).then(function (response) {
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'directMessageChannels' implicitly has an... Remove this comment to see the full error message
                _.forEach(directMessageChannels, function (d) {
                    // @ts-ignore ts-migrate(7005) FIXME: Variable 'roomChannels' implicitly has an 'any[]' ... Remove this comment to see the full error message
                    if (d.type == 'DIRECT_YOU' && d.members.length === 1) {
                        //this is just you
                        d.online = true;
                    }
                    else {
                        if (response.channels[d.uuid] &&
                            angular.isArray(response.channels[d.uuid].occupants) &&
                            response.channels[d.uuid].occupants.length > 1) {
                            d.online = true;
                        }
                    }
                });
            });
        }
        /**
         * @function onMessageEvent
         * @param msg {object} - Message object
// @ts-ignore ts-migrate(7005) FIXME: Variable 'notificationChannels' implicitly has an ... Remove this comment to see the full error message
         */
        function onMessageEvent(msg) {
            //here we are listening to see if we are getting a message
            var channel = _.find(directMessageChannels, { uuid: msg.channel });
            //on a hidden channel need to rejoin it
            if (channel && channel.isHidden == 1) {
                rejoinDirectMessageRoom(channel);
                //notify listeners of the change
                $rootScope.$emit('realtime-messaging:updated-dm-channels', directMessageChannels);
            }
        }
        /**
         * @function getUserId
         * @returns {Number}
         * @private
         * Returns userId or undefined. Only accesses it from AuthenticationService once.
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'ch' implicitly has an 'any' type.
         * This getter protects the service from bombing when initialized before the user is fully authenticated.
         */
        function getUserId() {
            // return userId;
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            if (!userId && AuthenticationService.isAuthenticated()) {
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'directMessageChannels' implicitly has an... Remove this comment to see the full error message
                userId = AuthenticationService.getAccount().userId;
            }
            return userId;
        }
        /**
         * @function setupRooms
         * @returns {object} - promise, Array (roomChannels)
         * @private
         */
        function setupRooms() {
            var filtered = channelGroups.filter(filterRoomGroups);
            if (filtered.length && filtered[0]) {
                // there is only one room channel group
                roomGroup = filtered[0];
                // @ts-ignore
                roomChannels = roomGroup.channelMemberships;
                $rootScope.$emit('realtime-messaging:updated-room-channels', roomChannels);
            }
        }
        /**
         * @function setupDirectMessages
         * @returns {object} - promise, Array (directMessageChannels)
         * @private
         */
        function setupDirectMessages() {
            var ch, filtered = channelGroups.filter(filterDirectChannelGroups), 
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'msg' implicitly has an 'any' type.
            promise;
            if (filtered && filtered[0]) {
                // there is only one dm channel group
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'directMessageChannels' implicitly has an... Remove this comment to see the full error message
                directMesssageGroup = filtered[0];
                // @ts-ignore
                directMessageChannels = directMesssageGroup.channelMemberships;
                ch = _.map(directMessageChannels, 'uuid');
                retrieveCurrentPresenceForAllDMChannels(ch);
                //let the controllers know of the change
                $rootScope.$emit('realtime-messaging:updated-dm-channels', directMessageChannels);
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'directMessageChannels' implicitly has an... Remove this comment to see the full error message
                promise = ETWServicesUtils.resolve();
            }
            else {
                promise = ETWServicesUtils.reject();
            }
            return promise;
        }
        /**
         * @function setupNotifications
         * @returns {object} - promise, Array (notificationChannels)
         * @private
         */
        function setupNotifications() {
            var filtered = channelGroups.filter(filterNotificationGroups);
            if (filtered && filtered[0]) {
                // there is only one notification channel group
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'userId' implicitly has an 'any' type.
                notificationGroup = filtered[0];
                // @ts-ignore
                notificationChannels = notificationGroup.channelMemberships;
            }
        }
        /**
         * @method getDirectMessageChannels
// @ts-ignore ts-migrate(7005) FIXME: Variable 'userId' implicitly has an 'any' type.
         * @returns {Array}
         */
        function getDirectMessageChannels() {
            return directMessageChannels;
        }
        /**
         * @method getRoomChannels
         * @returns {Array}
         */
        function getRoomChannels() {
            return roomChannels;
        }
        // @ts-ignore ts-migrate(7005) FIXME: Variable 'channelGroups' implicitly has an 'any[]'... Remove this comment to see the full error message
        /**
         * @method getRoomChannels
         * @param personId {number}
         * @returns {object}
         */
        function getRoomChannelsByPerson(personId) {
            return $http({
                errorMessage: 'Channel groups for this user could not be retrieved.',
                method: 'GET',
                url: usersServiceUrl + '/' + ETWServicesUtils.asId(personId) + '/channelGroups',
            });
        }
        /**
         * @method getNotificationChannels
         * @returns {object}
         */
        function getNotificationChannels() {
            return notificationChannels;
        }
        /**
         * @method setRoomVisibilty
         * @returns {object} promise
         */
        // @ts-ignore ts-migrate(7005) FIXME: Variable 'channelGroups' implicitly has an 'any[]'... Remove this comment to see the full error message
        function setRoomVisibilty(roomId, isVisible) {
            var room = {};
            // @ts-ignore
            room.id = roomId;
            // @ts-ignore
            room.isVisible = isVisible;
            //save the room return the promise on save
            return saveRoom(room, ['isVisible']);
        }
        /**
         * @method saveRoom
         * @param room {object}
         * @param [changedProperties] {Array} - optional. For partial updates
         * @returns {object} - promise, Plan
         * Create/update/patch a room
         */
        function saveRoom(room, changedProperties) {
            var isNewRoom = true;
            var options = {
                data: room,
                errorMessage: 'This room could not be saved.',
                idName: 'id',
                properties: changedProperties,
                url: channelsServiceUrl,
            };
            if (angular.isDefined(room.id)) {
                options.url = channelsServiceUrl + '/' + ETWServicesUtils.asId(room.id);
                isNewRoom = false;
            }
            return ETWServicesUtils.save(options, undefined, 'MessagingService').then(function saveRoomSuccess(response) {
                return refreshRoomChannelStores().then(function () {
                    if (isNewRoom) {
                        // @ts-ignore ts-migrate(7005) FIXME: Variable 'channelGroups' implicitly has an 'any[]'... Remove this comment to see the full error message
                        PubnubService.subscribeChannels([response.data]);
                    }
                    return response;
                });
            }, function saveRoomError(response) {
                console.error('SAVE ROOM ERROR', response);
            });
        }
        /**
         * @function createDM
         * @param withUserId {number}
         * @private
         */
        function createDM(withUserId) {
            // TODO remove name (gets 400 now)
            var room = {
                name: getUserId() + '@' + withUserId,
                type: 'DIRECT',
                groupType: 'DIRECT',
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'directMessageChannels' implicitly has an... Remove this comment to see the full error message
                isVisible: true,
                userIds: [getUserId(), withUserId],
            };
            var options = {
                data: room,
                errorMessage: 'Failure in creating direct message channel.',
                idName: 'id',
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'roomChannels' implicitly has an 'any[]' ... Remove this comment to see the full error message
                url: channelsServiceUrl,
            };
            return ETWServicesUtils.save(options, undefined, 'MessagingService')
                .then(function (response) {
                room = response.data;
            })
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'personId' implicitly has an 'any' type.
                .then(refreshDirectMessagesChannelStores)
                .then(function () {
                //subscribe to pubnub
                PubnubService.subscribeChannels([room]);
                // @ts-ignore
                return _.find(directMessageChannels, { id: room.id });
            });
        }
        /**
         * @method getDMByPerson
         * @param {number} personId the person in whom the user wants to DM
         * @returns {redirect} to the DM room
         * This first checks to see if there is an existing Direct Message room
// @ts-ignore ts-migrate(7005) FIXME: Variable 'notificationChannels' implicitly has an ... Remove this comment to see the full error message
         * with the logged in user and the person. If there is, then this will
         * send the user right away to the room. If not, the createDM method
         * is called to create a new DM room.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'roomId' implicitly has an 'any' type.
        function getDMByPerson(personId) {
            var isExistingChannel = false, promise = ETWServicesUtils.reject(), room;
            //see if there is already a channel to send the user to
            angular.forEach(directMessageChannels, function (channel) {
                if (channel.members.indexOf(personId) !== -1) {
                    isExistingChannel = true;
                    if (channel.isHidden === 1) {
                        //if this is a hidden room because I left we need to show it again
                        //and inform the service we would like to see it again
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'room' implicitly has an 'any' type.
                        rejoinDirectMessageRoom(channel);
                    }
                    // return room (channel)
                    promise = ETWServicesUtils.resolve(channel);
                }
            });
            if (!isExistingChannel) {
                // no room found get a new one
                promise = createDM(personId);
            }
            return promise;
        }
        /**
         * @method getNewRoom()
         * Creates a new (unsaved) instance with default values.
         */
        function getNewRoom() {
            return {
                isVisible: true,
                type: 'PUBLIC_GROUP',
                groupType: 'GROUP',
                userIds: [getUserId()],
            };
        }
        /**
         * @function connectAndGetRoom
         * @param roomId {number}
         * @returns {object} - promise, room object
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
         * @private
         * Simplify the common sequence of connecting just to get a room.
         */
        function connectAndGetRoom(roomId) {
            return connect().then(function connectionSuccess() {
                return getRoomById(roomId);
            }, ETWServicesUtils.reject);
        }
        /**
         * @method getRoomById
         * @param roomId {object}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
         * @returns {object} - Room if it exists in roomChannels,
         *   empty object {} if roomChannels doesn't contain a room with matching roomId.
         */
        function getRoomById(roomId) {
            var room = _.find(roomChannels, { id: Number(roomId) });
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'withUserId' implicitly has an 'any' typ... Remove this comment to see the full error message
            return room || {};
        }
        /**
         * @method getDirectMessageRoomById
         * @param directMessageId {number}
         * @returns {object} - Direct Message Room
         */
        function getDirectMessageRoomById(directMessageId) {
            return _.find(directMessageChannels, { id: Number(directMessageId) });
        }
        /**
         * @method refreshRoomChannelStores
         * @returns {object} - promise
         */
        function refreshRoomChannelStores() {
            return getChannelGroupsForUser()
                .then(setupRooms)
                .finally(function () {
                ETWServicesUtils.notify('MessagingService');
            });
        }
        /**
         * @method refreshDirectMessagesChannelStores
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
         * @param channel {object}
         * @param subFlag {Boolean}
         */
        function refreshDirectMessagesChannelStores(channel, subFlag) {
            return getChannelGroupsForUser()
                .then(setupDirectMessages)
                .then(function () {
                if (channel && subFlag) {
                    if (channel.action == 'add') {
                        // @ts-ignore ts-migrate(7005) FIXME: Variable 'directMessageChannels' implicitly has an... Remove this comment to see the full error message
                        // Only happens when a channel is added for the very first time. It lasts forever.
                        PubnubService.subscribeChannels([channel], true);
                    }
                    else if (channel.action == 'remove') {
                        // Not expected to ever happen, unless we are deleting an entire client
                        PubnubService.unsubscribeChannels([channel]);
                    }
                }
            });
        }
        /**
         * @method joinRoom
         * @param room {object}
         */
        function joinRoom(room) {
            //we are adding ourselves to a public available room
            return addRoomMember(room, getUserId())
                .then(refreshRoomChannelStores)
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'personId' implicitly has an 'any' type.
                .then(function () {
                //subscribe to pubnub
                PubnubService.subscribeChannels([room]);
                return room;
            });
        }
        /**
         * @method addRoomMember
         * @param room {object}
// @ts-ignore ts-migrate(7005) FIXME: Variable 'directMessageChannels' implicitly has an... Remove this comment to see the full error message
         * @param addUserId {number}
         * @returns {object} - promise
         */
        function addRoomMember(room, addUserId) {
            return $http({
                errorMessage: 'Failure in adding user to room.',
                method: 'POST',
                url: channelsServiceUrl + '/' + ETWServicesUtils.asId(room.id) + '/members/' + addUserId,
            });
        }
        /**
         * @method addAllRoomMembers
         * @param roomId {Number}
         * @param peopleIds {Array}
         * @returns {object} - promise
         */
        function addAllRoomMembers(roomId, peopleIds) {
            return $http({
                errorMessage: 'Failure to add people to room.',
                method: 'POST',
                data: { ids: peopleIds },
                url: channelsServiceUrl + '/' + ETWServicesUtils.asId(roomId) + '/members',
            });
        }
        /**
         * @method removeRoomMember
         * @param room {object}
         * @param removeUserId {number}
         * @returns {object} - promise
         * Unsubscribes the current user from room.
         */
        function removeRoomMember(room, removeUserId) {
            if (removeUserId == getUserId()) {
                removeRoomFromChannelStore(room);
                //unsubscribe from this room in pubnub
                PubnubService.unsubscribeChannels([room.uuid]);
            }
            //remove the channel membership
            return $http({
                errorMessage: 'Failure in remove user from room.',
                method: 'DELETE',
                url: channelsServiceUrl + '/' + ETWServicesUtils.asId(room.id) + '/members/' + removeUserId,
            });
        }
        /**
         * @method removeAllRoomMembers
         * @param roomId {Number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'roomId' implicitly has an 'any' type.
         * @param peopleIds {Array}
         * @returns {object} - promise
         */
        function removeAllRoomMembers(roomId, peopleIds) {
            return $http({
                errorMessage: 'Failure to remove people from room.',
                method: 'PATCH',
                data: { ids: peopleIds },
                url: channelsServiceUrl + '/' + ETWServicesUtils.asId(roomId) + '/removed-members',
            });
        }
        /**
         * @method leaveDirectMessageRoom
         * @param room {object}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'roomId' implicitly has an 'any' type.
         * @returns {Object} - promise
         */
        // @ts-ignore ts-migrate(7005) FIXME: Variable 'roomChannels' implicitly has an 'any[]' ... Remove this comment to see the full error message
        function leaveDirectMessageRoom(room) {
            //mark the room as hidden
            room.isHidden = 1;
            //have the api set it on the db
            return setChannelHidden(room);
        }
        /**
         * @method rejoinDirectMessageRoom
         * @param room {object}
         * @returns {Object} - promise
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'directMessageId' implicitly has an 'any... Remove this comment to see the full error message
        function rejoinDirectMessageRoom(room) {
            //go ahead and mark the room visible
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'directMessageChannels' implicitly has an... Remove this comment to see the full error message
            room.isHidden = 0;
            //have the api set it on the db
            return setChannelHidden(room);
        }
        /**
         * @function setChannelHidden
         * @param room {object}
         * @returns {object} - promise
         * @private
         */
        function setChannelHidden(room) {
            return $http({
                errorMessage: 'Failure in setting room hidden.',
                method: 'PATCH',
                data: { isHidden: room.isHidden },
                url: groupsServiceUrl +
                    '/' +
                    // @ts-ignore
                    ETWServicesUtils.asId(directMesssageGroup.id) +
                    '/channels/' +
                    ETWServicesUtils.asId(room.id),
            });
        }
        /**
         * @function getChannelGroupsForUser
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'channel' implicitly has an 'any' type.
         * @returns {object} - promise, Array
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'subFlag' implicitly has an 'any' type.
         * @private
         */
        function getChannelGroupsForUser() {
            var grantAccess = false;
            if (!hasGrantUserAccess) {
                grantAccess = true;
                hasGrantUserAccess = true;
            }
            return $http({
                errorMessage: 'Channel groups for this user could not be retrieved.',
                method: 'GET',
                url: userServiceUrl +
                    '/' +
                    ETWServicesUtils.asId(getUserId()) +
                    '/channelGroups?grantAccess=' +
                    grantAccess,
            }).then(function (response) {
                channelGroups = response.data;
            });
        }
        /**
         * @method markChannelRead
         * @returns {object}
         */
        function markChannelRead(room) {
            return $http({
                errorMessage: 'Failure marking messages read.',
                method: 'PUT',
                url: channelsServiceUrl + '/' + ETWServicesUtils.asId(room.id) + '/read',
            });
        }
        /**
         * @method getAllAvailableRooms
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'room' implicitly has an 'any' type.
         * @returns {object}
         */
        function getAllAvailableRooms() {
            return $http({
                errorMessage: 'Failure in fetching all available rooms.',
                method: 'GET',
                url: channelsServiceUrl,
            });
        }
        /**
         * @method getChannelById
         * @returns {object}
         */
        function getChannelById(roomId) {
            return $http({
                errorMessage: 'Failure in fetching channel by id.',
                method: 'GET',
                url: channelsServiceUrl + '/' + ETWServicesUtils.asId(roomId),
            });
        }
        /**
         * @method deleteRoom
         * @param room {object}
         * @returns {object} - promise
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'room' implicitly has an 'any' type.
        function deleteRoom(room) {
            removeRoomFromChannelStore(room);
            //now that our channel list is up to date we need to unsubscribe to the channel
            PubnubService.unsubscribeChannels([room.uuid]);
            //finally we need to remove it from the etw database
            return ETWServicesUtils.destroy({
                errorMessage: 'This room could not be removed.',
                url: channelsServiceUrl + '/' + ETWServicesUtils.asId(room.id),
            }).finally(function () {
                try {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'roomId' implicitly has an 'any' type.
                    ETWServicesUtils.notify('MessagingService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @function removeRoomFromChannelStore
         * @param room {object}
         * @private
         */
        function removeRoomFromChannelStore(room) {
            //you can only really ever leave public and private rooms
            if (room.type == 'PUBLIC_GROUP' || room.type == 'PRIVATE_GROUP') {
                _.remove(roomChannels, { id: room.id });
                //let the components know this room has been deleted
                $rootScope.$emit('realtime-messaging:updated-room-channels', roomChannels);
            }
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'room' implicitly has an 'any' type.
         * @function filterDirectChannelGroups
         * @returns {boolean}
         * @private
         */
        function filterDirectChannelGroups(group) {
            return group.type === 'DIRECT';
        }
        /**
         * @function filterRoomGroups
         * @returns {boolean}
         * @private
         */
        function filterRoomGroups(group) {
            return group.type === 'GROUP';
        }
        /**
         * @function filterRoomGroups
         * @returns {boolean}
         * @private
         */
        function filterNotificationGroups(group) {
            return group.type === 'NOTIFICATION';
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'roomId' implicitly has an 'any' type.

(function () {
    angular
        .module('ETWServices')
        .factory('NotesCache', ['ETWServicesUtils', 'PubnubService', NotesCacheServiceFactory]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ETWServicesUtils' implicitly has an 'an... Remove this comment to see the full error message
    function NotesCacheServiceFactory(ETWServicesUtils, PubnubService) {
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'PubnubService' implicitly has an 'any' ... Remove this comment to see the full error message
        /**
         * @property notes
         * @type {object}
         * Variable that keeps the cache of all notes viewed in stream.
         * notes[ recipient ][ type ][ filter person | all ] = { nextKey, notes }
         */
        var notes = {};
        var service = {
            use: use,
        };
        /**
         * @listener realtime-messaging:onMessage
         * Listen for when a note is added anywhere in the app
         */
        PubnubService.registerListener('realtime-messaging:onMessage', onMessageEvent);
        return service;
        /**
         * @function add
         * @param recipientPersonId {number}
         * @param type {string}
         * @param newNotes {Array}
         * @param [nextKey] {string} - timestamp used for pagination. Can be 'PREPEND'. Internally set to 'END' if undefined
         * @param [filterPersonId] {number}
         * @private
         */
        function add(recipientPersonId, type, newNotes, nextKey, filterPersonId) {
            var filterKey = filterPersonId || 'all', blacklistedIds;
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'recipientPersonId' implicitly has an 'a... Remove this comment to see the full error message
            // Make sure required properties are defined in the notes object
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'newNotes' implicitly has an 'any' type.
            initForRecipient(recipientPersonId);
            // @ts-ignore ts-migrate(7034) FIXME: Variable 'blacklistedIds' implicitly has type 'any... Remove this comment to see the full error message
            if (angular.isDefined(notes[recipientPersonId][type].blacklist)) {
                // Reject messages that were just toggled
                // When notes are archived (etc) in bulk, the next API response will still contain those notes.
                // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                blacklistedIds = notes[recipientPersonId][type].blacklist;
                newNotes = _.reject(newNotes, function (note) {
                    return blacklistedIds.indexOf(note.id) !== -1;
                });
            }
            if (angular.isUndefined(notes[recipientPersonId][type][filterKey])) {
                // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                notes[recipientPersonId][type][filterKey] = { notes: [] };
            }
            notes[recipientPersonId][type][filterKey].notes = _(
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'blacklistedIds' implicitly has an 'any' ... Remove this comment to see the full error message
            notes[recipientPersonId][type][filterKey].notes)
                .concat(newNotes)
                .uniqBy('id')
                .sortBy('createdDate')
                // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                .reverse()
                .value();
            if (nextKey != 'PREPEND') {
                // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                // Notes that are added via push are prepended to the list, so they don't affect nextKey
                // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                notes[recipientPersonId][type][filterKey].nextKey = nextKey || 'END';
            }
            getPeople(recipientPersonId, type, filterPersonId);
        }
        /**
         * @function get
         * @param recipientPersonId {number}
         * @param type {string}
         * @param [filterPersonId] {number}
         * @returns {Array}
         */
        function get(recipientPersonId, type, filterPersonId) {
            var filterKey = filterPersonId || 'all', result;
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            result = _.get(notes, [recipientPersonId, type, filterKey, 'notes'], []);
            return result;
        }
        /**
         * @function getKey
         * @param recipientPersonId {number}
         * @param type {string}
         * @param [filterPersonId] {number}
         * @returns {string}
         */
        function getKey(recipientPersonId, type, filterPersonId) {
            var filterKey = filterPersonId || 'all';
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'recipientPersonId' implicitly has an 'a... Remove this comment to see the full error message
            return _.get(notes, [recipientPersonId, type, filterKey, 'nextKey']);
        }
        /**
         * function getLastState
         * @param recipientPersonId {number}
         * @param type {string}
         * @returns {object}
         * @private
         * Gets the last person the list was filtered by IF the recipient and type are the same.
         * Switch recipient or type (archived/unarchived) and the last filter resets.
         * This way a user can view a goal, come back, and filters will be the same.
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'recipientPersonId' implicitly has an 'a... Remove this comment to see the full error message
         * But the filter is not the same when e.g. switching to archived notes.
         */
        function getLastState(recipientPersonId, type) {
            var lastFilterPersonId;
            initForRecipient(recipientPersonId);
            if (
            // @ts-ignore
            notes.last &&
                // @ts-ignore
                notes.last.recipientPersonId === recipientPersonId &&
                // @ts-ignore
                notes.last.type == type) {
                // @ts-ignore
                lastFilterPersonId = notes.last.filterPersonId;
            }
            return {
                filterPersonId: lastFilterPersonId,
            };
        }
        /**
         * @function getMark
         * @param recipientPersonId {number}
         * @param type {string}
         * @returns {string}
         * @private
         * Gets the ID for marked note, if there is one.
         */
        // @ts-ignore
        function getMark(recipientPersonId, type) {
            var markedNoteId;
            if (
            // @ts-ignore
            notes.mark &&
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'recipientPersonId' implicitly has an 'a... Remove this comment to see the full error message
                notes.mark.recipientPersonId === recipientPersonId &&
                // @ts-ignore
                notes.mark.type == type) {
                // @ts-ignore
                markedNoteId = notes.mark.noteId;
            }
            return markedNoteId;
        }
        /**
         * @function getPeople
         * @param recipientPersonId {number}
         * @param type {string}
         * @param [protectedPersonId] {number}
         * @returns {Array}
         * @private
         */
        // @ts-ignore
        function getPeople(recipientPersonId, type, protectedPersonId) {
            // @ts-ignore
            var recipientTypeNotes = notes[recipientPersonId][type];
            var currentAuthors, protectedPerson;
            if (angular.isDefined(recipientTypeNotes.all)) {
                currentAuthors = _(recipientTypeNotes.all.notes)
                    .map('author')
                    .uniqBy('id')
                    .value();
                if (protectedPersonId && !_.find(currentAuthors, { id: protectedPersonId })) {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'recipientPersonId' implicitly has an 'a... Remove this comment to see the full error message
                    // recipientTypeNotes.people.push(protectedPersonId);
                    protectedPerson = _.find(recipientTypeNotes.people, {
                        id: protectedPersonId,
                    });
                    if (protectedPerson) {
                        currentAuthors.push(protectedPerson);
                    }
                }
                recipientTypeNotes.people = currentAuthors;
            }
            if (!angular.isArray(recipientTypeNotes.people)) {
                recipientTypeNotes.people = [];
            }
            return recipientTypeNotes.people;
        }
        /**
         * @function getWithPromise
         * @param recipientPersonId {number}
         * @param type {string}
         * @param [filterPersonId] {number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'recipientPersonId' implicitly has an 'a... Remove this comment to see the full error message
         * @returns {object} - promise, Array
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
        function getWithPromise(recipientPersonId, type, filterPersonId) {
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            var response = {
                result: get(recipientPersonId, type, filterPersonId),
                nextKey: getKey(recipientPersonId, type, filterPersonId),
            };
            return ETWServicesUtils.resolve(response);
        }
        /**
         * @function initForRecipient
         * @param recipientPersonId {number}
         * @private
         * Defines the default structure for the cache for a recipient.
         */
        // @ts-ignore
        function initForRecipient(recipientPersonId) {
            // @ts-ignore
            if (angular.isUndefined(notes[recipientPersonId])) {
                // @ts-ignore
                notes[recipientPersonId] = {};
            }
            // @ts-ignore
            _.defaults(notes[recipientPersonId], {
                archived: {},
                readonly: {},
                unarchived: {},
            });
        }
        /**
         * @function setMark
         * @param recipientPersonId {number}
         * @param type {string}
         * @param noteId {string}
         * @private
         * Marks a note so it can be highlighted later.
         */
        // @ts-ignore
        function setMark(recipientPersonId, type, noteId) {
            initForRecipient(recipientPersonId);
            // @ts-ignore
            notes.mark = {
                noteId: noteId,
                recipientPersonId: recipientPersonId,
                type: type,
            };
        }
        /**
         * @function move
         * @param recipientPersonId {number}
         * @param noteIds {Array}
         * @param fromType {string}
         * @param toType {string}
         * @param filterPersonId {number}
         * @private
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'recipientPersonId' implicitly has an 'a... Remove this comment to see the full error message
        function move(recipientPersonId, noteIds, fromType, toType, filterPersonId) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
            var toEvict = {};
            _.forEach(noteIds, function (id) {
                // for each ID
                _.forEach(notes, function (recipientNotes, recipient) {
                    // @ts-ignore
                    var limboNotes = [];
                    // for each recipient
                    _.forEach(recipientNotes[fromType], function (notesByAuthor) {
                        // for each author in recipients note of specified type
                        // Put in limbo, to be reinserted
                        // @ts-ignore
                        limboNotes = _.concat(limboNotes, _.remove(notesByAuthor.notes, { id: id }));
                    });
                    if (limboNotes.length) {
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'recipientPersonId' implicitly has an 'a... Remove this comment to see the full error message
                        // Make a list of recipients
                        toEvict[recipient] = true;
                    }
                });
                // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            });
            // evict caches notes were moved to
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            _.forEach(toEvict, function (value, recipient) {
                // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                if (_.get(notes, [recipient, toType])) {
                    // @ts-ignore
                    notes[recipient][toType] = {};
                }
            });
            // @ts-ignore
            notes[recipientPersonId][fromType].blacklist = noteIds;
            if (!filterPersonId) {
                // Recount the list of authors unless one is selected
                getPeople(recipientPersonId, fromType, filterPersonId);
            }
        }
        /**
         * @method moveVisible
         * @param recipientPersonId {number}
         * @param fromType {string}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'recipientPersonId' implicitly has an 'a... Remove this comment to see the full error message
         * @param [filterPersonId] {number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
         * @returns {Array}
         * Returns the visible notes.
         * Adds IDs of visible notes to blacklist since immediately fetching more messages
         *   will still contain those notes. The blacklist is only needed for a short time.
         * Clears the entire cache for the recipient.
         */
        // @ts-ignore
        function moveVisible(recipientPersonId, fromType, filterPersonId) {
            var visibleNotes = get(recipientPersonId, fromType, filterPersonId), ids = _.map(visibleNotes, 'id'), toType = fromType == 'archived' ? 'unarchived' : 'archived';
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'recipientPersonId' implicitly has an 'a... Remove this comment to see the full error message
            move(recipientPersonId, ids, fromType, toType, filterPersonId);
            return ids;
        }
        /**
         * @function onMessageEvent
         * @param msg {object}
         * @private
         * Listener to PubNub
// @ts-ignore ts-migrate(7034) FIXME: Variable 'limboNotes' implicitly has type 'any[]' ... Remove this comment to see the full error message
         * When a new message event goes out, this function determines which cache to put it in.
         */
        function onMessageEvent(msg) {
            var message = msg.message, note;
            if (message.type == 'stream' && msg.body && _.startsWith(msg.channel, 'Notification')) {
                note = msg.body;
                if (angular.isArray(note.archivedRecipientIds)) {
                    // Archived notes
                    // @ts-ignore ts-migrate(7005) FIXME: Variable 'limboNotes' implicitly has an 'any[]' ty... Remove this comment to see the full error message
                    _.forEach(note.archivedRecipientIds, function (recipientId) {
                        // @ts-ignore
                        if (recipientId !== note.authorId) {
                            // Notes that are auto-archived are expected to always be
                            // when the author doesn't want their own notes in their stream
                            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                            if (notes[recipientId]) {
                                // Add to cache twice
                                // Filtered notes are a separate API call, so that list is always separate
                                // Therefore the note needs to be added to both lists separately.
                                // @ts-ignore
                                add(recipientId, 'archived', [note], 'PREPEND');
                                // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                                if (notes[recipientId].archived[note.authorId]) {
                                    // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                                    add(recipientId, 'archived', [note], 'PREPEND', note.authorId);
                                }
                            }
                        }
                    });
                }
                if (angular.isArray(note.unreadRecipientIds)) {
                    // Unarchived notes (unread)
                    _.forEach(note.unreadRecipientIds, function (recipientId) {
                        // @ts-ignore
                        if (notes[recipientId]) {
                            // Cache for this recipient exists in memory
                            // Prepend the note to the cached lists. 'PREPEND' doesn't mess up pagination.
                            // Note has to be added to 'all' and authorId separately.
                            // @ts-ignore
                            add(recipientId, 'unarchived', [note], 'PREPEND');
                            // @ts-ignore
                            if (notes[recipientId].unarchived[note.authorId]) {
                                add(recipientId, 'unarchived', [note], 'PREPEND', note.authorId);
                            }
                        }
                    });
                }
            }
        }
        /**
         * @function setPersonFilter
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'recipientPersonId' implicitly has an 'a... Remove this comment to see the full error message
         * @param recipientPersonId {number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'fromType' implicitly has an 'any' type.
         * @param type {string}
         * @param filterPersonId {number}
         * @private
         */
        // @ts-ignore
        function setPersonFilter(recipientPersonId, type, filterPersonId) {
            initForRecipient(recipientPersonId);
            // @ts-ignore
            notes.last = {
                filterPersonId: filterPersonId,
                type: type,
                recipientPersonId: recipientPersonId,
            };
        }
        /**
         * @method use
         * @param recipientPersonId {number}
         * @param type {string} - [archived|readonly|unarchived]
         * @returns {NotesCacheView}
         */
        function use(recipientPersonId, type) {
            return new NotesCacheView(recipientPersonId, type);
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'msg' implicitly has an 'any' type.
         * @class NotesCacheView
// @ts-ignore ts-migrate(7034) FIXME: Variable 'note' implicitly has type 'any' in some ... Remove this comment to see the full error message
         * @param recipientPersonId {number}
         * @param type {string}
         * @constructor
         */
        function NotesCacheView(recipientPersonId, type) {
            var that = this;
            that.add = function (newNotes, nextKey, filterPersonId) {
                return add(recipientPersonId, type, newNotes, nextKey, filterPersonId);
            };
            that.get = function (filterPersonId) {
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'note' implicitly has an 'any' type.
                return get(recipientPersonId, type, filterPersonId);
            };
            that.getKey = function (filterPersonId) {
                return getKey(recipientPersonId, type, filterPersonId);
            };
            that.getLastState = function () {
                return getLastState(recipientPersonId, type);
            };
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            that.getMark = function () {
                return getMark(recipientPersonId, type);
            };
            that.getPeople = function () {
                return notes[recipientPersonId][type].people;
            };
            that.getWithPromise = function (filterPersonId) {
                return getWithPromise(recipientPersonId, type, filterPersonId);
            };
            // @ts-ignore ts-migrate(2554) FIXME: Expected 5 arguments, but got 4.
            that.mark = function (noteId) {
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'note' implicitly has an 'any' type.
                return setMark(recipientPersonId, type, noteId);
            };
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            that.remove = function (noteIds, filterPersonId) {
                var toType = type == 'archived' ? 'unarchived' : 'archived';
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'note' implicitly has an 'any' type.
                return move(recipientPersonId, noteIds, type, toType, filterPersonId);
            };
            that.removeAll = function (filterPersonId) {
                return moveVisible(recipientPersonId, type, filterPersonId);
            };
            that.setPersonFilter = function (filterPersonId) {
                return setPersonFilter(recipientPersonId, type, filterPersonId);
            };
        }
    }
})();
// @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message

(function () {
    angular
        .module('ETWServices')
        .factory('NotesService', ['$http', 'ETWServicesUtils', NotesServiceFactory]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
    function NotesServiceFactory($http, ETWServicesUtils) {
        /**
         * @property modelDefinition
         * @type {Object}
         * Configuration object used by ETWServicesUtils for formatting certain columns
         */
        var modelDefinition = {
            columns: {
                createdDate: 'date',
                dueDate: 'date',
            },
        };
        var service = {
            archive: archive,
            archiveAll: archiveAll,
            getAll: getAll,
            getAllForScoredGoal: getAllForScoredGoal,
            getArchived: getArchived,
            getById: getById,
            getUnarchived: getUnarchived,
            reject: ETWServicesUtils.reject,
            save: save,
            subscribe: ETWServicesUtils.subscribe('NotesService'),
            unarchive: unarchive,
            unsubscribeAll: ETWServicesUtils.unsubscribeAll('NotesService'),
        };
        /**
         * @property serviceUrl
         * @type {string}
         * Get the URL for messages.
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('MESSAGES');
        /**
         * @property scoredGoalNotesServiceUrl
         * @type {string}
         * API URL for getting messages that are copied to a goal in a completed evaluation.
         */
        var scoredGoalNotesServiceUrl = ETWServicesUtils.getEndpointUrl('SCORED_GOALS_MESSAGES');
        /**
         * @property usersServiceUrl
         * @type {string}
         * Get the URL for messages
         */
        var usersServiceUrl = ETWServicesUtils.getEndpointUrl('MESSAGES_USERS');
        return service;
        /**
         * @method archive
         * @param id {string} - uuid
         * @returns {object} - promise
         * Archives a message.
         */
        function archive(id) {
            return $http({
                method: 'POST',
                url: serviceUrl + '/' + ETWServicesUtils.asGuid(id) + '/archive',
            });
        }
        /**
         * @method archiveAll
         * @param ids {Array}
         * @returns {object} - promise
         * Archives all the users messages.
         */
        function archiveAll(ids) {
            var promise;
            if (angular.isArray(ids) && ids.length) {
                promise = $http({
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
                    method: 'POST',
                    url: serviceUrl + '/archive?messageids=' + ids.join(','),
                });
            }
            return promise || ETWServicesUtils.reject('IDs are required');
        }
        /**
         * @method getAll
         * @param url {string}
         * @returns {object} - promise
         * Note: returns a THREADED response, based on parentMessageId
         */
        function getAll(url) {
            return $http({
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ids' implicitly has an 'any' type.
                errorMessage: 'The messages for this goal could not be retrieved.',
                method: 'GET',
                url: url,
            })
                .then(ETWServicesUtils.decodeResponse(modelDefinition), ETWServicesUtils.reject)
                .then(threaded, ETWServicesUtils.reject);
        }
        /**
         * @method getAllForScoredGoal
         * @param scoredGoalId {number}
         * @returns {object} - promise, Array
         * Gets the messages for a goal that is scored in a completed evaluation.
         */
        function getAllForScoredGoal(scoredGoalId) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'url' implicitly has an 'any' type.
            var url = scoredGoalNotesServiceUrl + '/' + ETWServicesUtils.asId(scoredGoalId) + '/messages';
            return $http({
                errorMessage: 'The messages for this goal could not be retrieved.',
                method: 'GET',
                url: url,
            })
                .then(ETWServicesUtils.decodeResponse(modelDefinition), ETWServicesUtils.reject)
                .then(threadEval, ETWServicesUtils.reject);
        }
        /**
         * @method getArchived
         * @param [userId] {number|undefined} - optional, get notes for specific user
         * @param [authorId] {number|undefined} - optional, filter notes by author
         * @param [startKey] {string|undefined} - token used for pagination
         * @returns {object} - promise
         * @paginated
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'scoredGoalId' implicitly has an 'any' t... Remove this comment to see the full error message
         * Retrieves archived messages for a user.
         */
        function getArchived(userId, authorId, startKey) {
            var params = {}, url = serviceUrl + '/archived';
            if (authorId) {
                // @ts-ignore
                params.authorId = authorId;
            }
            if (startKey) {
                // @ts-ignore
                params.startKey = startKey;
            }
            if (userId) {
                url = usersServiceUrl + '/' + ETWServicesUtils.asId(userId) + '/messages/archived';
            }
            return $http({
                errorMessage: 'Past notes could not be retrieved.',
                method: 'GET',
                params: params,
                url: url,
            }).then(ETWServicesUtils.paginate(modelDefinition, startKey), ETWServicesUtils.reject);
        }
        /**
         * @method getById
         * @param id {string} - GUID
         * @returns {object} - promise
         */
        function getById(id) {
            return $http({
                errorMessage: 'This message could not be retrieved.',
                method: 'GET',
                url: serviceUrl + '/' + ETWServicesUtils.asGuid(id),
            });
        }
        /**
         * @method getUnarchived
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'userId' implicitly has an 'any' type.
         * @param [userId] {number|undefined} - optional, get notes for specific user
         * @param [authorId] {number|undefined} - optional, filter notes by author
         * @param [startKey] {string|undefined} - optional, token used for pagination
         * @returns {object} - promise
         * @paginated
         * Retrieves unarchived messages for a user.
         */
        function getUnarchived(userId, authorId, startKey) {
            var params = {}, url = serviceUrl + '/unread';
            if (authorId) {
                // @ts-ignore
                params.authorId = authorId;
            }
            if (startKey) {
                // @ts-ignore
                params.startKey = startKey;
            }
            if (userId) {
                //get unread messages for the passed in user
                url = usersServiceUrl + '/' + ETWServicesUtils.asId(userId) + '/messages/unread';
            }
            return $http({
                errorMessage: 'Notes could not be retrieved.',
                method: 'GET',
                params: params,
                url: url,
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
            }).then(ETWServicesUtils.paginate(modelDefinition, startKey), ETWServicesUtils.reject);
        }
        /**
         * @method save
         * @param message {object}
         * @param [changedProperties] {Array}
         * @param url {string}
         * @param serviceName {string} - name of the service, used for subscriptions
         * @returns {object} - promise
         */
        function save(message, changedProperties, url, serviceName) {
            var options = {
                data: message,
                errorMessage: 'This message could not be saved.',
                idName: 'id',
                properties: changedProperties,
                url: url,
            };
            return ETWServicesUtils.save(options, modelDefinition, serviceName);
        }
        /**
         * @function threadEval
         * @param response {object} - $http response
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'userId' implicitly has an 'any' type.
         * @returns {object} - response
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'startKey' implicitly has an 'any' type.
         * Takes a response and threads it by originalParentMessageId, each group sorted by id.
         */
        function threadEval(response) {
            var oldIds = _.keyBy(response.data, 'originalMessageId');
            response.data = _(response.data)
                .map(function (comment) {
                comment.parentMessageId =
                    (oldIds[comment.originalParentMessageId] &&
                        oldIds[comment.originalParentMessageId].id) ||
                        '0';
                if (comment.authorFirstName && !comment.author) {
                    comment.author = {
                        firstName: comment.authorFirstName,
                        lastName: comment.authorLastName,
                    };
                }
                return comment;
            })
                // sort by parent id, createdDate, then by id
                .sortBy(['parentMessageId', 'createdDate', 'id'])
                // group by parent
                .groupBy('parentMessageId')
                // export result
                .value();
            //reverse order desc for comments newest first
            _.forEach(response.data, function (thread) {
                _.reverse(thread);
            });
            return response;
        }
        /**
         * @function thread
         * @param response {object} - $http response
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'message' implicitly has an 'any' type.
         * @returns {object} - response
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'url' implicitly has an 'any' type.
         * Takes a response and threads it by parentMessageId, each group sorted by id.
         */
        function threaded(response) {
            response.data = _(response.data)
                .map(function (comment) {
                if (!comment.parentMessageId) {
                    // Set all null parentMessageIds to '0'
                    comment.parentMessageId = '0';
                }
                return comment;
            })
                // sort by parent id, createdDate, then by id
                .sortBy(['parentMessageId', 'createdDate', 'id'])
                // group by parent
                .groupBy('parentMessageId')
                // export result
                .value();
            //reverse order desc for comments newest first
            _.forEach(response.data, function (thread) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                _.reverse(thread);
            });
            return response;
        }
        /**
         * @method unarchive
         * @param messageId {string} - GUID
         * @returns {*}
         * Unarchives a message.
         */
        function unarchive(messageId) {
            return $http({
                method: 'POST',
                url: serviceUrl + '/' + messageId + '/unarchive',
            });
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.

(function () {
    /**
     * @service NotificationService
     *
     */
    angular
        .module('ETWServices')
        .factory('NotificationService', [
        'MessagingService',
        'PubnubService',
        NotificationServiceFactory,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'MessagingService' implicitly has an 'an... Remove this comment to see the full error message
    function NotificationServiceFactory(MessagingService, PubnubService) {
        /**
         * @property notificationChannels
         * @type {Array}
         */
        // @ts-ignore ts-migrate(7034) FIXME: Variable 'notificationChannels' implicitly has typ... Remove this comment to see the full error message
        var notificationChannels = [];
        var service = {
            init: init,
        };
        return service;
        /**
         * @method init
         * Note: This service doesn't run unless it is injected, but there is nothing to do with it if init() calls itself.
         *   Some IDEs will say it is dead code unless you call a method on the service.
         *   Therefore, this method should be called somewhere, like in a Run block.
         */
        function init() {
            //we must make sure the MessagingService is connected
            MessagingService.connect().then(function connectMessaging() {
                //we only care about notifications here
                var ncs = MessagingService.getNotificationChannels();
                if (ncs) {
                    _.forEach(ncs, function (nc) {
                        //create a hash
                        notificationChannels[nc.uuid] = nc;
                    });
                }
                //register this service as a listener to new messages
                PubnubService.registerListener('realtime-messaging:onMessage', onMessageEvent);
            }, 
            // If user is not signed in, connect() will be rejected
            angular.noop);
        }
        /**
         * @method onMessageEvent
         * The concern here is to only listen to notification channels
         * then based upon teh notification determine the appropriate action.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'msg' implicitly has an 'any' type.
        function onMessageEvent(msg) {
            // example "{'action': 'add', 'type': 'room', 'channel': '53', 'uuid': '9fe717b1-efde-45ff-ad31-db2cbb98241d'}”
            // example "{'action': 'add', 'type': 'direct', 'channel': '53', 'uuid': 'e9aae5e3-269a-4aad-b6c5-874ae64ae8cb'}”
            //should only pay attention to messages which are notificationChannels
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'notificationChannels' implicitly has an ... Remove this comment to see the full error message
            if (notificationChannels[msg.channel]) {
                if (msg.message.type === 'room') {
                    // have the MessagingService reload the room components
                    MessagingService.refreshRoomChannelStores().then(subscribeWithPubNub(msg.message));
                }
                else if (msg.message.type === 'direct' && msg.message.action !== 'update') {
                    // have the MessagingService reload the direct messaging components
                    MessagingService.refreshDirectMessagesChannelStores(msg.message, true);
                }
            }
        }
        /**
         * Subscribe or unsubscribe to the channel contained in the message based
         * on the action contained in the message
         * @param channel
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'channel' implicitly has an 'any' type.
        function subscribeWithPubNub(channel) {
            if (channel.action == 'add') {
                //subscribe to pubnub
                PubnubService.subscribeChannels([channel], true);
            }
            if (channel.action == 'remove') {
                PubnubService.unsubscribeChannels([channel]);
            }
        }
    }
})();

(function () {
    angular
        .module('ETWServices')
        .factory('OutcomesService', ['$http', 'ETWServicesUtils', OutcomesServiceFactory]);
    /**
     * @factory OutcomesServiceFactory
     * Statuses:
             NONE(0),
             DRAFT(1),
             ACTIVE(2),
             SUSPENDED(3),
             COMPLETED(4);
     */
    function OutcomesServiceFactory($http, ETWServicesUtils) {
        /**
         * @property modelDefinition
// @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
         * @type {Object}
         * Configuration object used by ETWServicesUtils for formatting or excluding certain columns.
         */
        var modelDefinition = {
            columns: {
                _highlighted: 'excluded',
                _isError: 'excluded',
                _isTemporary: 'excluded',
            },
        };
        /**
         * @property outcomeServiceUrl
         * @type {string}
         */
        var outcomeServiceUrl = ETWServicesUtils.getEndpointUrl('OUTCOMES');
        /**
         * @property outcomeTypeServiceUrl
         * @type {string}
         */
        var outcomeTypeServiceUrl = ETWServicesUtils.getEndpointUrl('OUTCOME_TYPES');
        var plansServiceUrl = ETWServicesUtils.getEndpointUrl('PLANS');
        var service = {
            destroyType: destroyType,
            getAllForPlan: getAllForPlan,
            getAllTypes: getAllTypes,
            getByIdForPlan: getByIdForPlan,
            getNewType: getNewType,
            linkGoal: linkGoal,
            reject: ETWServicesUtils.reject,
            resolve: ETWServicesUtils.resolve,
            removeFromPlan: removeFromPlan,
            removeGoal: removeGoal,
            saveForPlan: saveForPlan,
            saveType: saveType,
            search: search,
            sortTypes: sortTypes,
            subscribe: ETWServicesUtils.subscribe('OutcomesService'),
            unassignFrom: unassignFrom,
            unsubscribeAll: ETWServicesUtils.unsubscribeAll('OutcomesService'),
            updateOutcome: updateOutcome,
        };
        // caching
        getAllForPlan.clear = function (planId) {
            // TODO: clear cache
        };
        getByIdForPlan.clear = function (outcomeId, planId) {
            // TODO: clear cache
            // @ts-ignore
            getAllForPlan.clear();
        };
        return service;
        /**
         * @method destroyType
         * @param categoryId {number}
         * @param newType {object} - optional
         * @returns {object}
         */
        function destroyType(typeId, newType) {
            var params = {};
            if (newType) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                params.outcomeTypeToReassignToId = newType.id;
            }
            return $http({
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'outcomeId' implicitly has an 'any' type... Remove this comment to see the full error message
                errorMessage: 'This Outcome Type could not be removed',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                method: 'DELETE',
                params: params,
                // @ts-ignore ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
                url: outcomeTypeServiceUrl + '/' + ETWServicesUtils.asId(typeId),
            });
        }
        /**
         * @method getNewType
         * @returns {object} - promise, object
         */
        function getNewType() {
            return ETWServicesUtils.resolve({
                data: {
                    title: undefined,
                },
            });
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'typeId' implicitly has an 'any' type.
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'newType' implicitly has an 'any' type.
         * @method getAllTypes
         * @returns {object} - promise, Array
         */
        function getAllTypes() {
            var promise = $http({
                errorMessage: 'Unable to retrieve all outcome types',
                method: 'GET',
                url: outcomeTypeServiceUrl,
            });
            return promise.then(function (response) {
                response.data = sortTypes(response.data);
                return response;
            }, ETWServicesUtils.reject);
        }
        /**
         * @method linkGoal
         * @param {umber} outcomeId
         * @param {umber} goalId
         * @returns {object} - promise
         */
        function linkGoal(outcomeId, goalId) {
            var url = [outcomeServiceUrl, outcomeId, 'addgoal', goalId].join('/');
            return $http({
                errorMessage: 'Cannot associate Goal with Outcome',
                method: 'POST',
                url: url,
                data: {},
            });
        }
        /**
         * @function sortTypes
         * @public
         * Arrange types in a particular order.
         */
        function sortTypes(types) {
            return _.orderBy(types, ['defaultCategory', sortTypesTitleIterator], ['desc', 'asc']);
        }
        /**
         * @function sortTypesTitleIterator
         * @param type {object}
         * @returns {string}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
         * @private
         * Allow case-insensitive sorting by title.
         */
        function sortTypesTitleIterator(type) {
            return type.name.toLowerCase();
        }
        /**
         * @method saveType
         * @param outcomeType {object}
         * @param [properties] {Array}
         * @returns {object} - promise, object
         */
        function saveType(outcomeType, properties) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'outcomeId' implicitly has an 'any' type... Remove this comment to see the full error message
            var options = {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goalId' implicitly has an 'any' type.
                errorMessage: 'Can not save outcome type',
                data: outcomeType,
                properties: properties,
                url: outcomeTypeServiceUrl,
                idName: 'id',
            };
            if (angular.isDefined(outcomeType.id)) {
                options.url = outcomeTypeServiceUrl + '/' + ETWServicesUtils.asId(outcomeType.id);
            }
            return ETWServicesUtils.save(options, modelDefinition, 'OutcomesService');
        }
        /**
         * @function generatePlanServiceUrl
         * @param planId {number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'types' implicitly has an 'any' type.
         * @param [id] {number} - optional Outcome ID
         * @returns {string}
         * @private
         * Used to generate the URI for the Plan endpoints.
         */
        function generatePlanServiceUrl(planId, id) {
            var url = plansServiceUrl + '/' + ETWServicesUtils.asId(planId) + '/outcomes';
            if (angular.isDefined(id)) {
                url += '/' + ETWServicesUtils.asId(id);
            }
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
            return url;
        }
        /**
         * @method getAllForPlan
         * @param planId {number}
         * @returns {object} - promise, array
         */
        function getAllForPlan(planId) {
            return $http({
                errorMessage: 'Outcomes for this plan could not be retrieved.',
                method: 'GET',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'outcomeType' implicitly has an 'any' ty... Remove this comment to see the full error message
                url: generatePlanServiceUrl(planId),
            });
        }
        function getByIdForPlan(planId, outcomeId) { }
        /**
         * @method saveForPlan
         * @param outcome {object}
         * @param planId {number}
         * @param [changedProperties] {Array}
         * @returns {object} - promise, object
         */
        function saveForPlan(outcome, planId, changedProperties) {
            var options = {
                data: outcome,
                errorMessage: 'This outcome could not be saved.',
                idName: 'id',
                properties: changedProperties,
                // @ts-ignore
                url: generatePlanServiceUrl(planId),
            };
            if (angular.isDefined(outcome.id)) {
                options.url = generatePlanServiceUrl(planId, outcome.id);
            }
            return ETWServicesUtils.save(options, undefined, 'OutcomesService', function () {
                if (angular.isDefined(outcome.id)) {
                    // @ts-ignore
                    getByIdForPlan.clear(outcome.id);
                }
                else {
                    // @ts-ignore
                    getAllForPlan.clear();
                }
            });
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
        /**
         * @method search
         * @param planId {number}
         * @param query {string}
         * @returns {object} - promise, Array
         */
        function search(planId, query) {
            query = query.toLowerCase();
            return getAllForPlan(planId).then(function getAllSuccess(response) {
                // Remove the ones that don't match
                _.remove(response.data, function (outcome) {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                    return outcome.title.toLowerCase().indexOf(query) === -1;
                });
                return response;
            });
        }
        /**
         * @method unassignFrom
         * @param type {string}
         * @param {...*} n - other parameters specific to the type
// @ts-ignore ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
         * Used to remove an Outcome from something.
         * See assignTo()
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
        function unassignFrom(type, n) {
            var args = _.tail(arguments);
            switch (type) {
                case 'plan':
                    removeFromPlan.apply(service, args);
                    break;
            }
        }
        /**
         * @function removeGoal
         * @param outcomeId {number}
         * @param goalId {number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'outcome' implicitly has an 'any' type.
         * @returns {object} - promise
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
         * @private
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'changedProperties' implicitly has an 'a... Remove this comment to see the full error message
         * Remove a goal from an Outcome.
         */
        function removeGoal(outcomeId, goalId) {
            var options = {
                errorMessage: 'Could not remove the goal from outcome.',
                url: outcomeServiceUrl +
                    '/' +
                    // @ts-ignore ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
                    ETWServicesUtils.asId(outcomeId) +
                    '/goal/' +
                    ETWServicesUtils.asId(goalId),
            };
            return ETWServicesUtils.destroy(options, modelDefinition, 'OutcomesService');
        }
        /**
         * @function removeFromPlan
         * @param planId {number}
         * @param outcomeId {number}
         * @returns {object} - promise
         * @private
         * Remove an Outcome from a Plan.
         */
        // @ts-ignore ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
        function removeFromPlan(planId, outcomeId) {
            var options = {
                errorMessage: 'Could not remove the outcome.',
                // @ts-ignore ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
                url: generatePlanServiceUrl(planId) + '/' + ETWServicesUtils.asId(outcomeId),
            };
            return ETWServicesUtils.destroy(options, modelDefinition, 'OutcomesService');
        }
        //updates an outcome with a new title
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
        function updateOutcome(planId, outcome, property) {
            //config
            var data = {};
            //update the data to be sent
            data[property] = outcome[property];
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            //send request to service
            return $http({
                errorMessage: 'Could not update the outcome.',
                data: data,
                method: 'PATCH',
                url: generatePlanServiceUrl(planId, outcome.id),
            }).finally(function () {
                try {
                    ETWServicesUtils.notify('OutcomesService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.

(function () {
    angular
        .module('ETWServices')
        .factory('PeopleService', ['$http', 'ETWServicesUtils', 'TeamsService', PeopleServiceFactory]);
    /*
     =========== API FILTERS ===========
     String  anyAttributes
     String  allAttributes
     String  noneAttributes
     String  onlyAttributes
     String  anyRoles
     String  allRoles
     String  noneRoles
     String  onlyRoles
     String  anyPermissions
     String  allPermissions
     String  nonePermissions
     String  onlyPermissions
     Boolean showInactive
     Boolean showTerminated
     Boolean showOrphaned
     Boolean showAttributeless
     Boolean showPermissionless
     Boolean showRoleless
     String  onlyPeople
     String  query
     Boolean includeEvalDueDate
     Boolean withGoalPerformance
     ===================================
     */
    function PeopleServiceFactory($http, ETWServicesUtils, TeamsService) {
        var modelDefinition = {
            columns: {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
                _analysis: 'excluded',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TeamsService' implicitly has an 'any' t... Remove this comment to see the full error message
                _engagements: 'excluded',
                _isSubscribed: 'excluded',
                evaluationDueDate: 'date',
                hireDate: 'date',
                terminationDate: 'date',
            },
        };
        var serviceUrl = ETWServicesUtils.getEndpointUrl('USERS');
        var impersonateUrl = ETWServicesUtils.getEndpointUrl('AUTHORIZE') + '/switchuser';
        var userListServiceUrl = ETWServicesUtils.getEndpointUrl('USERSLIST');
        var service = {
            all: ETWServicesUtils.all,
            analyze: analyze,
            attachmentDestroy: attachmentDestroy,
            attachmentSave: attachmentSave,
            attachmentUpload: attachmentUpload,
            canViewUser: canViewUser,
            destroy: destroy,
            getAll: getAll,
            getAllForPerson: getAllForPerson,
            getAttributeStats: getAttributeStats,
            getBasicById: getBasicById,
            getBasicByIds: getBasicByIds,
            getBossChainLevelForIds: getBossChainLevelForIds,
            getById: getById,
            getDirectReportsForId: getDirectReportsForId,
            getNew: getNew,
            getSubordinatesForId: getSubordinatesForId,
            getSuperiorsForId: getSuperiorsForId,
            impersonateClient: impersonateClient,
            impersonateUser: impersonateUser,
            moveDirectReports: moveDirectReports,
            reject: ETWServicesUtils.reject,
            resolve: ETWServicesUtils.resolve,
            save: save,
            search: search,
            sort: sort,
            subscribe: ETWServicesUtils.subscribe('PeopleService'),
            unassignDirectReports: unassignDirectReports,
            unsubscribe: ETWServicesUtils.unsubscribe('PeopleService'),
            unsubscribeAll: ETWServicesUtils.unsubscribeAll('PeopleService'),
        };
        return service;
        /**
         * @method analyze
         * @param response {object}
         * @returns {object} - response
         * Used by handling the $http promise.
         * Run this method to normalize and optimize person data for filtering.
         * Attaches a _analysis object to each RECORD that must be removed before POST/PATCH/PUT to the API
         * (It should be removed using the modelDefinition object defined above.)
         * Attaches a _analysis object to the REQUEST that has a list of data unique to the entire collection.
         * Initially used to handle filtering in the UI, this method is now only used for reports.
         */
        function analyze(response) {
            var allAttributes = [], allAttributeValues = {}, allPermissionGroups = [], allRoles = [], records = angular.isArray(response.data) ? response.data : response.data.records, terminationCount = 0;
            _.forEach(records, function (person) {
                var analysis = {
                    attributes: [],
                    attributeValues: [],
                    isTerminated: false,
                    permissionGroups: [],
                    roles: [],
                    searchText: '',
                };
                // Search text: certain columns, joined by a new line (to keep searches discreet), set all lower case
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                var searchTerms = [
                    // @ts-ignore ts-migrate(7034) FIXME: Variable 'allAttributes' implicitly has type 'any[... Remove this comment to see the full error message
                    person.alias,
                    person.firstName,
                    // @ts-ignore ts-migrate(7034) FIXME: Variable 'allPermissionGroups' implicitly has type... Remove this comment to see the full error message
                    person.lastName,
                    // @ts-ignore ts-migrate(7034) FIXME: Variable 'allRoles' implicitly has type 'any[]' in... Remove this comment to see the full error message
                    person.username,
                    person.emailAddress,
                    person.uniqueId,
                ];
                analysis.searchText = searchTerms.join('\n').toLowerCase();
                // Attribute Sets, Attributes, Attribute Values
                _.forEach(person.attributeSets, function (attributeSet) {
                    _.forEach(attributeSet.attributeValues, function (attributeValue) {
                        var attribute = {
                            id: attributeValue.attributeId,
                            title: attributeValue.attributeTitle,
                        };
                        // Record
                        analysis.attributes.push(attribute.id);
                        analysis.attributeValues.push(attributeValue.id);
                        // Response
                        allAttributes.push(attribute);
                        if (!angular.isArray(allAttributeValues[attribute.id])) {
                            allAttributeValues[attribute.id] = [];
                        }
                        allAttributeValues[attribute.id].push(attributeValue);
                    });
                });
                // Roles and Permission Groups
                _.forEach(person.roleList, function (role) {
                    // Record
                    analysis.roles.push(role.id);
                    analysis.permissionGroups = _.concat(analysis.permissionGroups, _.map(role.permissionGroups, 'id'));
                    // Response
                    allRoles.push(role);
                    allPermissionGroups = _.concat(allPermissionGroups, role.permissionGroups);
                });
                // Termination
                if (person.terminationDate && +person.terminationDate < +new Date()) {
                    analysis.isTerminated = true;
                    terminationCount += 1;
                }
                // Attach to the person
                // @ts-ignore ts-migrate(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
                // Beware if this person record is ever pushed back to the API. This object must be removed.
                // @ts-ignore ts-migrate(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
                person._analysis = analysis;
            });
            allAttributes = _(allAttributes)
                .uniqBy('id')
                .map(function (attribute) {
                // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                attribute.values = _.uniqBy(allAttributeValues[attribute.id], 'id');
                return attribute;
            })
                // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                .value();
            response.analysis = {
                totalTerminationCount: terminationCount,
                // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                uniqueAttributes: _(allAttributes)
                    .uniqBy('id')
                    .keyBy('id')
                    .value(),
                uniquePermissionGroups: _.uniqBy(allPermissionGroups, 'id'),
                uniqueRoles: _(allRoles)
                    .uniqBy('id')
                    .filter('visible')
                    .value(),
            };
            return response;
        }
        /**
// @ts-ignore ts-migrate(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
         * @method attachmentDestroy
// @ts-ignore ts-migrate(2322) FIXME: Type 'any[]' is not assignable to type 'never[]'.
         * @param personId {number}
         * @returns {Function}
         * Curries the person ID in the standard destroy method. Controllers can then just pass type and attachment.
         */
        function attachmentDestroy(personId) {
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'allPermissionGroups' implicitly has an '... Remove this comment to see the full error message
            var baseUrl = serviceUrl + '/' + ETWServicesUtils.asId(personId);
            return function (type, attachment) {
                return ETWServicesUtils.attachmentDestroy(type, baseUrl, attachment).finally(function attachmentSaveFinal() {
                    try {
                        ETWServicesUtils.notify('PeopleService');
                    }
                    catch (e) {
                        console.error(e);
                    }
                });
            };
        }
        /**
         * @method attachmentSave
         * @param personId {number}
         * @returns {Function}
// @ts-ignore ts-migrate(7005) FIXME: Variable 'allAttributes' implicitly has an 'any[]'... Remove this comment to see the full error message
         * Curries the person ID in the standard upload method. Controllers can then just pass type and attachment.
         */
        function attachmentSave(personId) {
            var baseUrl = serviceUrl + '/' + ETWServicesUtils.asId(personId);
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            return function (type, attachment, isAdminEntity) {
                return ETWServicesUtils.attachmentSave(type, baseUrl, attachment, isAdminEntity).finally(function attachmentSaveFinal() {
                    try {
                        ETWServicesUtils.notify('PeopleService');
                    }
                    catch (e) {
                        console.error(e);
                    }
                });
            };
        }
        /**
         * @method attachmentUpload
         * @param personId {number}
// @ts-ignore ts-migrate(7005) FIXME: Variable 'allPermissionGroups' implicitly has an '... Remove this comment to see the full error message
         * @returns {Function}
// @ts-ignore ts-migrate(7005) FIXME: Variable 'allRoles' implicitly has an 'any[]' type... Remove this comment to see the full error message
         * Curries the person ID in the standard upload method. Controllers can then just pass type and attachment.
         */
        function attachmentUpload(personId) {
            var baseUrl = serviceUrl + '/' + ETWServicesUtils.asId(personId), baseDownloadUrl = serviceUrl + '/' + ETWServicesUtils.asId(personId);
            return function (type, attachment, isAdminEntity) {
                return ETWServicesUtils.attachmentUpload(baseUrl, attachment, isAdminEntity, baseDownloadUrl
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'personId' implicitly has an 'any' type.
                ).finally(function attachmentSaveFinal() {
                    try {
                        ETWServicesUtils.notify('PeopleService');
                    }
                    catch (e) {
                        console.error(e);
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
                    }
                });
            };
        }
        /**
         * @method canViewUser
         * @param id {number}
         * @param canViewUserId {number}
         * @returns {object} - promise, boolean
         * Determine if the user is allowed to view user with id (canViewUserId)
         * Note: The result of the promise is a boolean, not a 'data' object.
         */
        function canViewUser(id, canViewUserId) {
            var promise;
            if (id === canViewUserId) {
                promise = ETWServicesUtils.resolve(true);
            }
            else {
                promise = $http({
                    errorMessage: 'Unable to determine if current user is allowed to view given user.',
                    method: 'GET',
                    url: serviceUrl +
                        '/' +
                        ETWServicesUtils.asId(id) +
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'personId' implicitly has an 'any' type.
                        '/can-view/' +
                        ETWServicesUtils.asId(canViewUserId),
                }).then(function getUserSuccess(response) {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
                    return !!response.data && !!response.data.canViewUser;
                }, function getUserError(response) {
                    console.error('VIEWER ACCESS ERROR', response);
                    return false;
                });
            }
            return promise;
        }
        /**
         * @method destroy
         * @param id {number}
         * @returns {object} - promise
         */
        function destroy(id) {
            return $http({
                errorMessage: 'The person could not be removed.',
                method: 'DELETE',
                url: serviceUrl + '/' + ETWServicesUtils.asId(id),
            }).finally(function () {
                try {
                    ETWServicesUtils.notify('PeopleService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method getAll
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'personId' implicitly has an 'any' type.
         * @param [filterParams] {object} - optional map of filters
         * @param [sortParams] {object} - optional sortBy settings
         * @param [paginationParams] {object} - optional pagination settings
         * @param [blacklist] {array}
         * @returns {*}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'attachment' implicitly has an 'any' typ... Remove this comment to see the full error message
        function getAll(filterParams, sortParams, paginationParams, blacklist) {
            // Create object to combine filterParams, sortParams, paginationParams.
            // We wouldn't want to mutate filterParams since that could mess up the controller.
            var parameters = {}, promise;
            if (filterParams) {
                _.assign(parameters, filterParams);
                // Arrays need to be stringified.
                ETWServicesUtils.encodeParamCollection(parameters, {
                    anyAttributes: 'array',
                    allAttributes: 'array',
                    noneAttributes: 'array',
                    onlyAttributes: 'array',
                    anyRoles: 'array',
                    allRoles: 'array',
                    noneRoles: 'array',
                    onlyRoles: 'array',
                });
            }
            // Combine sort parameters with query params
            _.assign(parameters, sortParams);
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
            // Combine pagination parameters with query params
            _.assign(parameters, paginationParams);
            promise = $http({
                errorMessage: 'The people could not be retrieved.',
                method: 'GET',
                params: parameters,
                url: serviceUrl,
            }).then(ETWServicesUtils.decodeResponse(modelDefinition), ETWServicesUtils.reject);
            if (blacklist && blacklist.length) {
                promise = promise.then(removeBlacklistedRecords(blacklist));
            }
            return promise;
        }
        /**
         * @method getAllForPerson
         * @param [filterParams] {object} - filters
         * @param [sortParams] {object} - sortBy
         * @param [paginationParams] {object} - pagination settings
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
         * @param [isShowPerformance] {boolean}
         * @param [blacklist] {Array}
         * @returns {object} - promise, paginated object
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
        function getAllForPerson(filterParams, sortParams, paginationParams, isShowPerformance, blacklist) {
            var parameters = {}, promise;
            if (isShowPerformance) {
                // @ts-ignore
                parameters.withGoalPerformance = true;
                // @ts-ignore
                parameters.includeEvalDueDate = true;
            }
            _.assign(parameters, filterParams);
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
            _.assign(parameters, sortParams);
            _.assign(parameters, paginationParams);
            promise = $http({
                errorMessage: 'The list of people could not be retrieved.',
                method: 'GET',
                params: parameters,
                url: serviceUrl + '/peoplepage',
            });
            if (blacklist && blacklist.length) {
                promise = promise.then(removeBlacklistedRecords(blacklist));
            }
            return promise;
        }
        /**
         * @method getAttributeStats
         * @param  {number} primaryAttributeId   the primary attribute id, REQUIRED!
         * @param  {number} secondaryAttributeId the secondary attribute id
         * @return {object}                      promise
         * This will pull a list of all people that are the logged in person's peers
         * and subordinates and if they have the attributes passed and what values
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'filterParams' implicitly has an 'any' t... Remove this comment to see the full error message
         * they are. This is for the attribute filter section of the People>People page
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'blacklist' implicitly has an 'any' type... Remove this comment to see the full error message
        function getAttributeStats(primaryAttributeId, secondaryAttributeId) {
            // back-end asked for -1 value for nulls
            secondaryAttributeId = secondaryAttributeId ? secondaryAttributeId : -1;
            var promise = !primaryAttributeId
                ? ETWServicesUtils.resolve({ data: [] })
                : $http({
                    errorMessage: 'Unable to retrieve people filtered by attributes',
                    method: 'GET',
                    url: serviceUrl +
                        '/attribute/' +
                        primaryAttributeId +
                        '/attribute/' +
                        secondaryAttributeId,
                });
            return promise;
        }
        /**
         * @method getBasicById
         * @param id {number}
         * @returns {object} - promise, object
         */
        function getBasicById(id) {
            return $http({
                errorMessage: 'The person could not be retrieved.',
                method: 'GET',
                url: serviceUrl + '/' + ETWServicesUtils.asId(id),
            }).then(ETWServicesUtils.decodeResponse(modelDefinition), ETWServicesUtils.reject);
        }
        /**
         * @method getBasicByIds
         * @param ids {Array} - array of user ids.
         * @returns {object} - promise, object
         * Returns people in sorted order
         */
        function getBasicByIds(ids) {
            var promise;
            if (ids.length) {
                promise = $http({
                    errorMessage: 'The people could not be retrieved.',
                    method: 'GET',
                    url: userListServiceUrl + '?userAccountIds=' + ids.toString(),
                });
            }
            else {
                promise = ETWServicesUtils.resolve({ data: [] });
            }
            return promise.then(function (response) {
                // Sort response by lastName, alias if set, otherwise firstName
                response.data = sort(response.data);
                // Decode response according to model definition
                return ETWServicesUtils.decodeResponse(modelDefinition)(response);
            }, ETWServicesUtils.reject);
        }
        /**
         * @method getBossChainLevelForIds
         * @param ids {Array}
         * @param bossCandidateId {number}
         * @returns {object} - promise, number
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'filterParams' implicitly has an 'any' t... Remove this comment to see the full error message
         * Used to find the lowest boss chain level for a group of assignees.
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'isShowPerformance' implicitly has an 'a... Remove this comment to see the full error message
         * This method gets the level in relation to each assignee, and returns the lowest one.
         * If the boss candidate is not in the boss chain, promise returns -1.
         * The level when the candidate is the user is -1.
         * The level when the candidate is the user's direct boss is 0.
         */
        function getBossChainLevelForIds(ids, bossCandidateId) {
            var promises = _.map(ids, function (id) {
                // If the id is identical to the candidate, an automatic -1.
                return id === bossCandidateId
                    ? ETWServicesUtils.resolve({ data: [] })
                    // @ts-ignore
                    : getSuperiorsForId(id);
            });
            return ETWServicesUtils.all(promises).then(function getAllIdsSuperiorsSuccess(responses) {
                var minimumLevel = -1;
                _.forEach(responses, function (response) {
                    var superiorIds = _.map(response.data, 'id'), index = superiorIds.indexOf(bossCandidateId);
                    // index is the level of the boss in the boss chain
                    // Find the lowest level
                    if (index !== -1) {
                        if (minimumLevel === -1) {
                            minimumLevel = index;
                        }
                        else {
                            minimumLevel = Math.min(minimumLevel, index);
                        }
                    }
                });
                return minimumLevel;
            });
        }
        /**
         * @method getById
         * @param id {number}
         * @returns {object} - promise, object
         */
        function getById(id) {
            return $http({
                errorMessage: 'The person could not be retrieved.',
                method: 'GET',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'primaryAttributeId' implicitly has an '... Remove this comment to see the full error message
                url: serviceUrl + '/' + ETWServicesUtils.asId(id) + '?details=true',
            })
                .then(ETWServicesUtils.decodeResponse(modelDefinition), ETWServicesUtils.reject)
                .then(function (response) {
                _.forEach(response.data.s3Resources, function (file) {
                    file.downloadUrl = serviceUrl + '/' + ETWServicesUtils.asId(id) + '/file/' + file.id;
                });
                return response;
            }, service.reject);
        }
        /**
         * @method getDirectReportsForId
         * @param id {number}
         * @param [isWithPerformance] {boolean=false}
         * @returns {object} - promise, Array
         * Get all subordinates for ID, one level down
         */
        function getDirectReportsForId(id, isWithPerformance) {
            var params = {};
            if (isWithPerformance) {
                // TODO: withPerformance is deprectated
                // @ts-ignore
                params.withPerformance = true;
                // @ts-ignore
                params.withGoalPerformance = true;
                // @ts-ignore
                params.includeEvalDueDate = true;
            }
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
            return $http({
                errorMessage: 'Direct reports for this user could not be retrieved.',
                method: 'GET',
                params: params,
                url: serviceUrl + '/' + ETWServicesUtils.asId(id) + '/direct-reports',
            }).then(ETWServicesUtils.decodeResponse(modelDefinition), ETWServicesUtils.reject);
        }
        /**
         * @method getNew
         * @returns {object} - promise, object
         * Create a new record with defaults.
         */
        function getNew() {
            return ETWServicesUtils.resolve({
                data: {
                    roleList: [],
                },
            });
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'ids' implicitly has an 'any' type.
         * @method getSubordinatesForId
         * @param id {number}
         * @returns {object} - promise, Array
         * Get a list of ids for users that report to the user with the given ID
         */
        function getSubordinatesForId(id) {
            return $http({
                errorMessage: 'Subordinates for this user could not be retrieved.',
                method: 'GET',
                url: serviceUrl + '/' + ETWServicesUtils.asId(id) + '/subordinates',
            }).then(function (response) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                ETWServicesUtils.decodeResponse(modelDefinition)(response);
                return response;
            }, ETWServicesUtils.reject);
        }
        /**
         * @method getSuperiorsForId
         * @param id {number}
         * @param [isWithPerformance] {boolean=false}
         * @returns {object} - promise, Array
         * Returns a list of ids for the boss chain from the user with the given ID to the top (CEO)
         */
        function getSuperiorsForId(id, isWithPerformance) {
            var params = {};
            if (isWithPerformance) {
                // TODO: withPerformance is deprectated
                // @ts-ignore
                params.withPerformance = true;
                // @ts-ignore
                params.withGoalPerformance = true;
                // @ts-ignore
                params.includeEvalDueDate = true;
            }
            return $http({
                errorMessage: 'Superiors for this user could not be retrieved.',
                method: 'GET',
                params: params,
                url: serviceUrl + '/' + ETWServicesUtils.asId(id) + '/superiors',
            }).then(ETWServicesUtils.decodeResponse(modelDefinition), ETWServicesUtils.reject);
        }
        // @ts-ignore ts-migrate(2554)
        function impersonateUser(userId, client) {
            return $http({
                errorMessage: 'Unable to impersonate.',
                data: { empty: null },
                method: 'GET',
                url: impersonateUrl +
                    // @ts-ignore ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
                    '?user=' + ETWServicesUtils.asId(userId) + '&&client=' + ETWServicesUtils.asId(client)
            });
        }
        // @ts-ignore ts-migrate(2554)
        function impersonateClient(client) {
            return $http({
                errorMessage: 'Unable to impersonate. Check console log for details.',
                data: { empty: null },
                method: 'GET',
                url: impersonateUrl +
                    // @ts-ignore ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
                    '?client=' + ETWServicesUtils.asId(client)
            });
        }
        /**
         * @method moveDirectReports
         * @param fromId {number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'ids' implicitly has an 'any' type.
         * @param toId {number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'bossCandidateId' implicitly has an 'any... Remove this comment to see the full error message
         * @returns {*}
         * Moves subordinates from one person to another.
         */
        function moveDirectReports(fromId, toId) {
            return $http({
                errorMessage: 'Unable to move direct reports.',
                data: { empty: null },
                method: 'POST',
                url: serviceUrl +
                    '/' +
                    // @ts-ignore ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
                    ETWServicesUtils.asId(fromId) +
                    '/movesubordinatesto/' +
                    ETWServicesUtils.asId(toId),
            });
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'responses' implicitly has an 'any' type... Remove this comment to see the full error message
         * @function removeBlacklistedRecords
         * @param blacklist {Array} - array of ids
         * @returns {Function}
         * Returns a function to a then() method on a promise.
         * Assumes 'response' has data.records.
         * Usage:
         *   promise = promise.then(removeBlacklistedRecords([1,2,3])
         */
        function removeBlacklistedRecords(blacklist) {
            return function (response) {
                // Remove blacklisted users from the response.
                _.remove(response.data.records, function (record) {
                    // @ts-ignore
                    return blacklist.indexOf(record.id) !== -1;
                });
                return response;
            };
        }
        /**
         * @method save
         * @param person {object}
         * @param changedProperties [array]
         * @returns {object}
         */
        function save(person, changedProperties) {
            var options = {
                errorMessage: false,
                idName: 'id',
                properties: changedProperties,
                url: serviceUrl,
            }, promise;
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
            // Person object returned by the server contains arrays that are not part of POST/PUT.
            // Remove all properties that have arrays for values.
            options.data = _.omitBy(person, _.isArray);
            if (angular.isDefined(person.id)) {
                options.url = serviceUrl + '/' + ETWServicesUtils.asId(person.id);
            }
            // If the user was on a team, clear the TeamsService cache
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            if (changedProperties && changedProperties.indexOf('reportsToId') !== -1) {
                if (angular.isArray(person.userTeams) && person.userTeams.length) {
                    _.forEach(person.userTeams, function (teamId) {
                        TeamsService.getById.clear(teamId);
                    });
                }
            }
            promise = ETWServicesUtils.save(options, modelDefinition, 'PeopleService');
            return promise.catch(serviceExceptionHandler);
        }
        /**
         * @method search
         * @param query {string}
         * @param [blacklist] {Array} - array of ids
         * @returns {object} - promise
         * Note: Only returns basic details.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
        function search(query, blacklist) {
            var parameters = {}, promise;
            if (query) {
                // @ts-ignore
                parameters.query = query;
            }
            // @ts-ignore
            promise = getAll(parameters);
            if (blacklist) {
                promise = promise.then(function (response) {
                    // Remove blacklisted users from the response.
                    _.forEach(blacklist, function (blacklistPersonId) {
                        _.remove(response.data.records, { id: blacklistPersonId });
                    });
                    return response;
                });
            }
            return promise;
        }
        /**
         * @function serviceExceptionHandler
         * @param response {object}
         * @returns {object} - promise. Passes along another rejection with the response so the controller can act on it.
         * @private
         * When the API returns an error message, display to the user and pray that it's understandable by humans.
         * Note: ATM the errors for this API are non-standard
         */
        function serviceExceptionHandler(response) {
            var message = response.data && angular.isString(response.data.error)
                ? response.data.error
                : 'This person could not be saved.';
            ETWServicesUtils.notifyErrorMessage(message);
            return ETWServicesUtils.reject(response);
        }
        /**
         * @method sort
         * @param people {Array} - collection of people with at least alias, firstName, lastName
         * @returns {Array}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
         * Public method for sorting a collection of people according to a standard default sort order.
         */
        function sort(people) {
            return _.sortBy(people, sortIteratee);
        }
        /**
         * @method sortIteratee
         * @param person {object}
         * @returns {Array}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
         * Public iteratee method for sorting people. Designed to be used in ngRepeat orderBy.
         */
        function sortIteratee(person) {
            return [person.lastName, person.alias || person.firstName];
        }
        /**
         * @method unassignDirectReports
         * @param personId {number}
         * @returns {object} - promise
         * Removes subordinates from personId, and leaves them without a team lead.
         */
        function unassignDirectReports(personId) {
            return $http({
                errorMessage: 'Unable to move direct reports.',
                data: { empty: null },
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
                method: 'POST',
                url: serviceUrl + '/' + ETWServicesUtils.asId(personId) + '/removesubordinates',
            });
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'fromId' implicitly has an 'any' type.

(function () {
    angular
        .module('ETWServices')
        .factory('PermissionGroupPermissionsService', [
        '$http',
        'ETWServicesUtils',
        PermissionGroupPermissionsServiceFactory,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
    function PermissionGroupPermissionsServiceFactory($http, ETWServicesUtils) {
        var service = {
            getAllByPermissionGroupId: getAllByPermissionGroupId,
            destroy: destroy,
            reject: ETWServicesUtils.reject,
            resolve: ETWServicesUtils.resolve,
            save: save,
            subscribe: ETWServicesUtils.subscribe('PermissionGroupPermissionsService'),
            unsubscribeAll: ETWServicesUtils.unsubscribeAll('PermissionGroupPermissionsService'),
        };
        /**
         * @property serviceUrl
         * @type {string}
         * PermissionGroupPermissions are only accessible as a child of PermissionGroups
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('PERMISSION_GROUPS');
        return service;
        /**
         * @method getAllByPermissionGroupId
         * @param permissionGroupId {number}
         * @returns {object} - promise
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'permissionGroupId' implicitly has an 'a... Remove this comment to see the full error message
        function getAllByPermissionGroupId(permissionGroupId) {
            return $http({
                errorMessage: 'The settings could not be retrieved.',
                method: 'GET',
                // @ts-ignore ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
                url: makeServiceUrl(permissionGroupId),
            });
        }
        /**
         * @method destroy
         * @param permissionGroupId {number}
         * @param permissionId {number}
         * @returns {object} - promise
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'permissionGroupId' implicitly has an 'a... Remove this comment to see the full error message
        function destroy(permissionGroupId, permissionId) {
            return $http({
                errorMessage: 'This permission setting could not be removed.',
                method: 'DELETE',
                url: makeServiceUrl(permissionGroupId, permissionId),
            }).finally(function () {
                try {
                    ETWServicesUtils.notify('PermissionGroupPermissionsService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @function makeServiceUrl
         * @param permissionGroupId {number}
         * @param [permissionId] {number} - optional. Undefined would give you the PG URL
         * @returns {string}
         * @private
         * Generate an endpoint URL for PermissionGroupPermissions.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'permissionGroupId' implicitly has an 'a... Remove this comment to see the full error message
        function makeServiceUrl(permissionGroupId, permissionId) {
            return (serviceUrl +
                '/' +
                ETWServicesUtils.asId(permissionGroupId) +
                '/permissions' +
                (permissionId ? '/' + ETWServicesUtils.asId(permissionId) : ''));
        }
        /**
         * @method save
         * @param permissionGroupId {number}
         * @param permissionId {number}
         * @returns {object} - promise
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'permissionGroupId' implicitly has an 'a... Remove this comment to see the full error message
        function save(permissionGroupId, permissionId) {
            return $http({
                errorMessage: 'This permission setting could not be added.',
                data: { payload: null },
                method: 'POST',
                url: makeServiceUrl(permissionGroupId, permissionId),
            });
        }
    }
})();

(function () {
    angular
        .module('ETWServices')
        .factory('PermissionGroupsService', [
        '$cacheFactory',
        '$http',
        'ETWServicesUtils',
        'AuthenticationService',
        PermissionGroupsServiceFactory,
    ]);
    function PermissionGroupsServiceFactory($cacheFactory, $http, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$cacheFactory' implicitly has an 'any' ... Remove this comment to see the full error message
    ETWServicesUtils, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
    AuthenticationService) {
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'AuthenticationService' implicitly has a... Remove this comment to see the full error message
         * @property modelDefinition
         * @type {Object}
         * Configuration object used by ETWServicesUtils for formatting or excluding certain columns.
         * isChanged, isError, isTemporary are used to manage simultaneous asynchronous updates to the list of groups.
         */
        var modelDefinition = {
            columns: {
                _isChanged: 'excluded',
                _isError: 'excluded',
                _isTemporary: 'excluded',
            },
        };
        var service = {
            assignTo: assignTo,
            clone: clone,
            destroy: destroy,
            getAll: getAll,
            getById: getById,
            reject: ETWServicesUtils.reject,
            resolve: ETWServicesUtils.resolve,
            save: save,
            search: search,
            subscribe: ETWServicesUtils.subscribe('PermissionGroupsService'),
            unassignFrom: unassignFrom,
            unsubscribeAll: ETWServicesUtils.unsubscribeAll('PermissionGroupsService'),
        };
        /**
         * @property serviceUrl
         * @type {string}
         * @private
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('ROLES');
        /**
         * @property serviceUrlForClient
         * @type {string}
         * @private
         * Get the URL for the endpoint that includes the clientId
         */
        var serviceUrlForClient = ETWServicesUtils.getEndpointUrlForClient('PERMISSION_GROUPS', AuthenticationService.getAccount().clientId);
        /**
         * @function getAll.clear
         * @private
         * Clears the cache for the getAll() results.
         * All methods that modify Plans must call this method.
         */
        getAll.clear = function () {
            $cacheFactory.get('$http').remove(serviceUrlForClient);
            $cacheFactory.get('$http').remove(serviceUrlForClient + '?showemployeecount=true');
        };
        /**
         * @function getById.clear
         * @param id {number}
         * Clears the cache for getById(id) then calls getAll.clear()
         */
        getById.clear = function (id) {
            $cacheFactory.get('$http').remove(serviceUrlForClient + '/' + ETWServicesUtils.asId(id));
            getAll.clear();
        };
        return service;
        /**
         * @method assignTo
         * @param type {string} - Model type to assign to
         * @param {...*} n - other parameters specific to the type
         * @returns {object} - promise
         * Used to assign roles to various models
         * Usage:
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
         *   PermissionGroupsService.assignTo('Role', 1, 2)
         */
        function assignTo(type, n) {
            var args = _.tail(arguments), promise;
            switch (type) {
                case 'Role':
                    promise = assignToRole.apply(service, args);
                    break;
            }
            return promise;
        }
        /**
         * @method assignToRole
         * @param roleId {number}
         * @param permissionGroupId {number}
         * @returns {object} - promise
         * @private
         * Assigns a permission group to a role. See assignTo()
         */
        function assignToRole(roleId, permissionGroupId) {
            return $http({
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
                errorMessage: 'Could not assign the role to this permission group.',
                method: 'POST',
                data: { empty: 'post' },
                url: serviceUrl +
                    '/' +
                    ETWServicesUtils.asId(roleId) +
                    // @ts-ignore ts-migrate(2345) FIXME: Argument of type 'any[]' is not assignable to para... Remove this comment to see the full error message
                    '/permission-groups/' +
                    ETWServicesUtils.asId(permissionGroupId),
            }).finally(function () {
                try {
                    // clear cached responses
                    getById.clear(permissionGroupId);
                    // notify observers that records have changed
                    ETWServicesUtils.notify('PermissionGroupsService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method clone
         * @param id {number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'roleId' implicitly has an 'any' type.
         * @returns {object} - promise
         */
        function clone(id) {
            // TODO: UPDATE GROUPNAME REQUIREMENT (remember to update mocks)
            return $http({
                errorMessage: 'This permission could not be cloned.',
                method: 'POST',
                data: {
                    groupId: id,
                },
                url: serviceUrlForClient +
                    '?groupId=' +
                    ETWServicesUtils.asId(id) +
                    '&groupName=BAD__PERMISSIONS_SERVICE_' +
                    new Date().getTime(),
            }).finally(function () {
                try {
                    // clear cached responses
                    getAll.clear();
                    // notify observers that records have changed
                    ETWServicesUtils.notify('PermissionGroupsService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method destroy
         * @param id {number}
         * @returns {object} - promise
         */
        function destroy(id) {
            return $http({
                errorMessage: 'This permission could not be removed.',
                method: 'DELETE',
                url: serviceUrlForClient + '/' + ETWServicesUtils.asId(id),
            }).finally(function () {
                try {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
                    // clear cached responses
                    getById.clear(id);
                    // notify observers that records have changed
                    ETWServicesUtils.notify('PermissionGroupsService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method getAll
         * @param [isCountPeople] {boolean} - optional; set true to include counts of people with the Permission Group
         * @returns {object} - promise, array
         * Get all permission groups
         */
        function getAll(isCountPeople) {
            var params = {};
            if (isCountPeople) {
                // Note: all url parameter combinations used need to be explicitly added to getAll.clear.
                // @ts-ignore
                params.showemployeecount = true;
            }
            return $http({
                cache: true,
                method: 'GET',
                params: params,
                url: serviceUrlForClient,
            });
        }
        /**
         * @method getById
         * @param id {number}
         * @returns {object} - promise, object
         * TODO: API SHOULDN'T NEED THE CLIENT ID
         */
        function getById(id) {
            return $http({
                errorMessage: 'There was a problem retrieving this permission group.',
                method: 'GET',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
                url: serviceUrlForClient + '/' + ETWServicesUtils.asId(id),
            });
        }
        /**
         * @method save
         * @param permissionGroup {object}
         * @param [changedProperties] {array}
         * @returns {object}
         * NOTE: groupName needs to be unique. When autosaving a new record, generate a new groupName with generateUniqueValueForColumn();
         */
        function save(permissionGroup, changedProperties) {
            var promise;
            var options = {
                data: permissionGroup,
                errorMessage: false,
                idName: 'id',
                properties: changedProperties,
                url: serviceUrlForClient,
            };
            if (angular.isDefined(permissionGroup.id)) {
                options.url = serviceUrlForClient + '/' + ETWServicesUtils.asId(permissionGroup.id);
            }
            if (angular.isUndefined(permissionGroup.id) && !permissionGroup.groupName) {
                // New record without a groupName
                // Since groupName must be unique, compare it with existing columnName from getAll()
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'isCountPeople' implicitly has an 'any' ... Remove this comment to see the full error message
                promise = ETWServicesUtils.generateUniqueValueForColumn(getAll, 'groupName', 'Untitled Permission Group').then(function (uniqueValue) {
                    // Then save resulting uniqueValue as the new columnName
                    options.data.groupName = uniqueValue;
                    return ETWServicesUtils.save(options, modelDefinition, 'PermissionGroupsService', getAll.clear);
                });
            }
            else {
                promise = ETWServicesUtils.save(options, modelDefinition, 'PermissionGroupsService', function () {
                    // Clear the cache (before subscribers are notified)
                    if (angular.isDefined(permissionGroup.id)) {
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
                        getById.clear(permissionGroup.id);
                    }
                    else {
                        getAll.clear();
                    }
                });
            }
            return promise.catch(serviceExceptionHandler);
        }
        /**
         * @method search
         * @param query {string}
         * @returns {object} - promise, array
         * Standard search method. All searchable services should have this method, accept a string, return an array.
         */
        function search(query) {
            return $http({
                method: 'GET',
                url: serviceUrlForClient,
                params: {
                    query: query,
                },
            });
        }
        /**
         * @function serviceExceptionHandler
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'permissionGroup' implicitly has an 'any... Remove this comment to see the full error message
         * @param response {object}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'changedProperties' implicitly has an 'a... Remove this comment to see the full error message
         * @returns {object} - promise. Passes along another rejection with the response so the controller can act on it.
         * @private
         * When the API returns an error message, display to the user and pray that it's understandable by humans.
         * Note: ATM the errors for this API are non-standard
         */
        function serviceExceptionHandler(response) {
            var message = angular.isString(response.data.error)
                ? response.data.error
                : 'This permission could not be saved.';
            ETWServicesUtils.notifyErrorMessage(message);
            return ETWServicesUtils.reject(response);
        }
        /**
         * @method unassignFrom
         * @param type {string}
         * @param {...*} n - other parameters specific to the type
         * Used to remove an PermissionGroup from something.
         * See assignTo()
         */
        function unassignFrom(type, n) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'uniqueValue' implicitly has an 'any' ty... Remove this comment to see the full error message
            var args = _.tail(arguments);
            switch (type) {
                case 'Role':
                    unassignFromRole.apply(service, args);
                    break;
            }
        }
        /**
         * @function unassignFromRole
         * @param roleId {number}
         * @param permissionGroupId {number}
         * @returns {object} - promise
         * @private
         * Remove an Role from a Person.
         */
        function unassignFromRole(roleId, permissionGroupId) {
            return $http({
                errorMessage: 'Could not remove the permission group from this role.',
                method: 'DELETE',
                url: serviceUrl +
                    '/' +
                    ETWServicesUtils.asId(roleId) +
                    '/permission-groups/' +
                    ETWServicesUtils.asId(permissionGroupId),
            }).finally(function () {
                try {
                    // clear cached responses
                    getById.clear(permissionGroupId);
                    // notify observers that records have changed
                    ETWServicesUtils.notify('PermissionGroupsService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'query' implicitly has an 'any' type.

(function () {
    angular
        .module('ETWServices')
        .factory('PermissionsService', ['$http', 'ETWServicesUtils', PermissionsServiceFactory]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
    function PermissionsServiceFactory($http, ETWServicesUtils) {
        /**
         * @property serviceUrl
         * @type {string}
         * @private
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('PERMISSIONS');
        var service = {
            all: ETWServicesUtils.all,
            getAll: getAll,
            reject: ETWServicesUtils.reject,
            resolve: ETWServicesUtils.resolve,
        };
        return service;
        /**
         * @method getAll
         * @returns {object} - promise, array
         * Get all permissions
         */
        function getAll() {
            return $http({
                method: 'GET',
                url: serviceUrl,
            });
        }
    }
})();

(function () {
    angular
        .module('ETWServices')
        .factory('PersonSettingsService', [
        '$http',
        'AuthenticationService',
        'ETWServicesUtils',
        PersonSettingsServiceFactory,
    ]);
    /**
     * @service PersonSettingsServiceFactory
     * @constructor
     * Service for current user only.
     * For other users, see PeopleService.
     * For authenticated user info, see AuthenticationService
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
    function PersonSettingsServiceFactory($http, AuthenticationService, ETWServicesUtils) {
        var modelDefinition = {};
        var service = {
            save: save,
        };
        var serviceUrl = ETWServicesUtils.getEndpointUrl('USERS');
        return service;
        function generateServiceUrl() {
            var userId = AuthenticationService.getAccount().userId;
            return serviceUrl + '/' + ETWServicesUtils.asId(userId) + '/settings';
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'person' implicitly has an 'any' type.
        function save(person, changedProperties) {
            var options = {
                data: person,
                errorMessage: false,
                idName: 'id',
                properties: changedProperties,
                url: generateServiceUrl(),
            }, promise;
            promise = ETWServicesUtils.save(options, modelDefinition, 'PersonSettingsService');
            return promise.catch(serviceExceptionHandler);
        }
        /**
         * @function serviceExceptionHandler
         * @param response {object}
         * @returns {object} - promise. Passes along another rejection with the response so the controller can act on it.
         * @private
         * When the API returns an error message, display to the user and pray that it's understandable by humans.
         * Note: ATM the errors for this API are non-standard
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
        function serviceExceptionHandler(response) {
            var message = response.data && angular.isString(response.data.error)
                ? response.data.error
                : 'Your settings could not be saved.';
            ETWServicesUtils.notifyErrorMessage(message);
            return ETWServicesUtils.reject(response);
        }
    }
})();

(function () {
    /**
     * @property accessTypes
     * @type {{owner: string, participant: string, viewer: string}}
     * @private
     * Map of accessTypes to URI path
     * Used by addPerson and removePerson.
     * TODO: identical to KPIsService. Abstract out.
     */
    var accessTypes = {
        owners: 'owners',
        participants: 'participants',
        viewers: 'viewOnly',
    };
    angular
        .module('ETWServices')
        .factory('PlansService', [
        '$cacheFactory',
        '$http',
        '$rootScope',
        'CLIENT_SETTINGS',
        'ETWServicesUtils',
        PlansServiceFactory,
    ]);
    /**
     * @factory PlansServiceFactory
     * Statuses:
     NONE(0),
     DRAFT(1),
     ACTIVE(2),
     NOT COMPLETED(3),
     COMPLETED(4);
     */
    function PlansServiceFactory($cacheFactory, $http, $rootScope, CLIENT_SETTINGS, ETWServicesUtils) {
        var service = {
            ACTIVE: 2,
            // @ts-ignore ts-migrate(7006) FIXME: Parameter '$cacheFactory' implicitly has an 'any' ... Remove this comment to see the full error message
            COMPLETED: 4,
            // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
            DRAFT: 1,
            // @ts-ignore ts-migrate(7006) FIXME: Parameter '$rootScope' implicitly has an 'any' typ... Remove this comment to see the full error message
            NOT_COMPLETED: 3,
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ETWServicesUtils' implicitly has an 'an... Remove this comment to see the full error message
            addAllPeople: addAllPeople,
            addAttributeValueToPlan: addAttributeValueToPlan,
            addPerson: addPerson,
            addPinnedPlan: addPinnedPlan,
            addRoleToPlan: addRoleToPlan,
            all: ETWServicesUtils.all,
            attachmentDestroy: attachmentDestroy,
            attachmentSave: attachmentSave,
            attachmentUpload: attachmentUpload,
            cloneDrivers: cloneDrivers,
            cloneGoalsAndKpis: cloneGoalsAndKpis,
            convertPlan: convertPlan,
            createPlaceholderGoalAndKpi: createPlaceholderGoalAndKpi,
            destroy: destroy,
            getAll: getAll,
            getActiveForPerson: getActiveForPerson,
            getAllForPerson: getAllForPerson,
            getAllForOwner: getAllForOwner,
            getAllForPlan: getAllForPlan,
            getAllIdsAndTitlesForPerson: getAllIdsAndTitlesForPerson,
            getAllSupporting: getAllSupporting,
            getAllSupportingForPlan: getAllSupportingForPlan,
            getAllTopLevel: getAllTopLevel,
            getById: getById,
            getFiles: getFiles,
            getLimitedSupportingForPlan: getLimitedSupportingForPlan,
            getNew: getNew,
            getPinnedPlans: getPinnedPlans,
            getPlanAssignments: getPlanAssignments,
            getSharedKpis: getSharedKpis,
            hasSubPlans: hasSubPlans,
            movePlan: movePlan,
            reject: ETWServicesUtils.reject,
            removeAttributeValueFromPlan: removeAttributeValueFromPlan,
            removeRoleFromPlan: removeRoleFromPlan,
            removePeople: removePeople,
            removePerson: removePerson,
            removePinnedPlan: removePinnedPlan,
            resolve: ETWServicesUtils.resolve,
            save: save,
            setPlanAimStatus: setPlanAimStatus,
            subscribe: ETWServicesUtils.subscribe('PlansService'),
            toggleSharedKpi: toggleSharedKpi,
            updatePerson: updatePerson,
            unsubscribe: ETWServicesUtils.unsubscribe('PlansService'),
            unsubscribeAll: ETWServicesUtils.unsubscribeAll('PlansService'),
        };
        /**
         * @property accessTypeActions
         * @type {object}
         * Map of access types to what is used by the API.
         * Viz., the "viewOnly" action is used for "viewers"
         */
        var accessTypeActions = {
            owners: 'owners',
            participants: 'participants',
            viewers: 'viewOnly',
        };
        /**
         * @property planListUrl
         * @type {string}
         */
        var planListUrl = ETWServicesUtils.getEndpointUrl('PLANS_LIST');
        /**
         * @property serviceUrl
         * @type {string}
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('PLANS');
        /**
         * @property supportingServiceUrl
         * @type {string}
         */
        var supportingServiceUrl = ETWServicesUtils.getEndpointUrl('PLANS_SUPPORTING');
        /**
         * @property topLevelServiceUrl
         * @type {string}
         */
        var topLevelServiceUrl = ETWServicesUtils.getEndpointUrl('PLANS_TOP');
        /**
         * @property planKpiServiceUrl
         * @type {string}
         */
        var planKpiServiceUrl = ETWServicesUtils.getEndpointUrl('KPI_PLANS');
        /**
         * @property peopleServiceUrl
         * @type {string}
         */
        var peopleServiceUrl = ETWServicesUtils.getEndpointUrl('USER_PLANS');
        /**
         * @property planFilesServiceUrl
         * @type {string}
         */
        var planFilesServiceUrl = ETWServicesUtils.getEndpointUrl('PLANS_FILES');
        /**
         * @property pinnedPlanServiceUrl
         * @type {string}
         */
        var pinnedPlanServiceUrl = ETWServicesUtils.getEndpointUrl('PINNED_PLANS');
        /**
         * @property planAllowableFallingBehindThreshold
         * @type {number}
         */
        var planAllowableFallingBehindThreshold = CLIENT_SETTINGS.planAllowableFallingBehindThreshold / 100;
        /**
         * @property planCutpointMax
         * @type {number}
         */
        var planCutpointMax = CLIENT_SETTINGS.planCutpointMax / 100;
        /**
         * @property planCutpointMid
         * @type {number}
         */
        var planCutpointMid = CLIENT_SETTINGS.planCutpointMid / 100;
        /**
         * @property planCutpointMin
         * @type {number}
         */
        var planCutpointMin = CLIENT_SETTINGS.planCutpointMin / 100;
        /**
         * @method getAll.clear
         * Clears the cache for the getAll() results.
         * All methods that modify Plans must call this method.
         */
        getAll.clear = function () {
            $cacheFactory.get('$http').remove(serviceUrl);
        };
        /**
         * @method getById.clear
         * @param id {number}
         * Clears the cache for getById(id) then calls getAll.clear()
         */
        getById.clear = function (id) {
            $cacheFactory.get('$http').remove(serviceUrl + '/' + ETWServicesUtils.asId(id));
            getAll.clear();
        };
        return service;
        /**
         * @method addAllPeople
         * @param planId {number}
         * @param accessType {string}
         * @param people {Array}
         * @returns {object} - promise
         */
        function addAllPeople(planId, accessType, people) {
            var peopleList = _.map(people, function (person) {
                return {
                    id: person.id,
                    flag: Boolean(person._isSubscribed),
                };
            });
            var params = { ids: peopleList };
            return $http({
                errorMessage: '',
                method: 'POST',
                data: params,
                url: serviceUrl + '/' + ETWServicesUtils.asId(planId) + '/' + accessTypeActions[accessType],
            }).finally(function () {
                try {
                    // Clear plan cache
                    if (angular.isDefined(planId)) {
                        getById.clear(planId);
                    }
                    else {
                        getAll.clear();
                    }
                    ETWServicesUtils.notify('GoalsService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method addAttributeValueToPlan
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
         * @param planId {number}
         * @param attributeValueId {number}
         * @param type {string}
         * @returns {object} - promise
         */
        function addAttributeValueToPlan(planId, attributeValueId, type) {
            return $http({
                errorMessage: 'Attribute Value could not be added',
                method: 'POST',
                url: serviceUrl +
                    '/' +
                    ETWServicesUtils.asId(planId) +
                    '/' +
                    type +
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                    '/attributevalues/' +
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'accessType' implicitly has an 'any' typ... Remove this comment to see the full error message
                    ETWServicesUtils.asId(attributeValueId),
            }).finally(function () {
                $rootScope.$emit('notify', "Users are being added to the plan's access list. In order to display the most current status, please refresh your browser.", 'success');
            });
        }
        /**
         * @method addRoleToPlan
         * @param planId {number}
         * @param roleId {number}
         * @param type {string}
         * @returns {object} - promise
         */
        function addRoleToPlan(planId, roleId, type) {
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            return $http({
                errorMessage: 'Role could not be added',
                method: 'POST',
                url: serviceUrl +
                    '/' +
                    ETWServicesUtils.asId(planId) +
                    '/' +
                    type +
                    '/roles/' +
                    ETWServicesUtils.asId(roleId),
            }).finally(function () {
                $rootScope.$emit('notify', "Users are being added to the plan's access list. In order to display the most current status, please refresh your browser.", 'success');
            });
        }
        /**
         * @method addPerson
         * @param planId {number}
         * @param personId {number}
         * @param accessType {string} - [owner|participant|viewer], maps to accessTypes
         * @param isSubscribed {boolean=false} - whether viewNotes boolean flag should be passed in params.
         * @returns {object} - promise
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
        function addPerson(planId, personId, accessType, isSubscribed) {
            return changePerson(planId, personId, accessType, isSubscribed, 'POST');
        }
        /**
         * @method addPinnedPlan
         * @param planId {number}
         * @returns {object}
         */
        function addPinnedPlan(planId) {
            return $http({
                errorMessage: 'Could not pin plan',
                method: 'POST',
                url: pinnedPlanServiceUrl + '/' + ETWServicesUtils.asId(planId),
            }).finally(function () {
                getById.clear(planId);
            });
        }
        /**
         * @method attachmentDestroy
         * @param planId {number}
         * @returns {Function}
         * Curries the plan ID in the standard destroy method. Controllers can then just pass type and attachment.
         */
        function attachmentDestroy(planId) {
            var baseUrl = serviceUrl + '/' + ETWServicesUtils.asId(planId);
            return function (type, attachment) {
                getById.clear(planId);
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                return ETWServicesUtils.attachmentDestroy(type, baseUrl, attachment).finally(function attachmentSaveFinal() {
                    try {
                        ETWServicesUtils.notify('PlansService');
                    }
                    catch (e) {
                        console.error(e);
                    }
                });
            };
        }
        /**
         * @method attachmentSave
         * @param planId {number}
         * @returns {Function}
         * Curries the plan ID in the standard upload method. Controllers can then just pass type and attachment.
         */
        function attachmentSave(planId) {
            var baseUrl = serviceUrl + '/' + ETWServicesUtils.asId(planId);
            return function (type, attachment, isAdminEntity) {
                getById.clear(planId);
                return ETWServicesUtils.attachmentSave(type, baseUrl, attachment, isAdminEntity).finally(function attachmentSaveFinal() {
                    try {
                        ETWServicesUtils.notify('PlansService');
                    }
                    catch (e) {
                        console.error(e);
                    }
                });
            };
        }
        /**
         * @method attachmentUpload
         * @param planId {number}
         * @returns {Function}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
         * Curries the planId in the standard upload method. Controllers can then just pass type and attachment.
         */
        function attachmentUpload(planId) {
            var baseUrl = serviceUrl + '/' + ETWServicesUtils.asId(planId), baseDownloadUrl = serviceUrl + '/' + ETWServicesUtils.asId(planId);
            return function (type, attachment, isAdminEntity) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                getById.clear(planId);
                return ETWServicesUtils.attachmentUpload(baseUrl, attachment, isAdminEntity, baseDownloadUrl).finally(function attachmentSaveFinal() {
                    try {
                        ETWServicesUtils.notify('PlansService');
                    }
                    catch (e) {
                        console.error(e);
                    }
                });
            };
        }
        /**
         * @method changePerson
         * @private
         * @param planId {number}
         * @param personId {number}
         * @param accessType {string} - [owner|participant|viewer], maps to accessTypes
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
         * @param isSubscribed {boolean=false} - whether viewNotes boolean flag should be passed in params.
         * @param method {string} - [POST|DELETE]
         * @returns {object} - promise
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
         * Called by addPerson and removePerson
         */
        function changePerson(planId, personId, accessType, isSubscribed, method) {
            var parameterObject = {};
            var accessTypePath = accessTypes[accessType];
            if (!accessTypePath) {
                throw new Error('Access Type is invalid.');
            }
            if (_.isBoolean(isSubscribed)) {
                // @ts-ignore
                parameterObject.viewNotes = isSubscribed;
            }
            return $http({
                errorMessage: 'This person could not be ' + (method == 'POST' ? 'added' : 'removed') + '.',
                method: method,
                params: parameterObject,
                url: serviceUrl +
                    '/' +
                    ETWServicesUtils.asId(planId) +
                    '/' +
                    accessTypePath +
                    '/' +
                    ETWServicesUtils.asId(personId),
            }).finally(function () {
                try {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                    getById.clear(planId);
                    ETWServicesUtils.notify('PlansService');
                }
                catch (e) {
                    console.error(e);
                }
            });
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
        }
        /**
         *
         * @param sourcePlanId
         * @param targetPlanId
         */
        function cloneDrivers(sourcePlanId, targetPlanId) {
            return $http({
                errorMessage: 'Could not clone drivers',
                method: 'POST',
                url: serviceUrl +
                    '/' +
                    ETWServicesUtils.asId(sourcePlanId) +
                    '/clonedrivers/' +
                    ETWServicesUtils.asId(targetPlanId),
            }).finally(function () {
                getById.clear(targetPlanId);
                ETWServicesUtils.notify('PlansService');
            });
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'attachment' implicitly has an 'any' typ... Remove this comment to see the full error message
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'isAdminEntity' implicitly has an 'any' ... Remove this comment to see the full error message
         * @method cloneGoalsAndKpis
         * @param sourcePlanId {number}
         * @param targetPlanId {number}
         * @returns {object}
         */
        function cloneGoalsAndKpis(sourcePlanId, targetPlanId) {
            return $http({
                errorMessage: 'Could not clone plan goals and kpis',
                method: 'POST',
                url: serviceUrl +
                    '/' +
                    ETWServicesUtils.asId(sourcePlanId) +
                    '/clonegoalsandkpis/' +
                    ETWServicesUtils.asId(targetPlanId),
            }).finally(function () {
                getById.clear(targetPlanId);
                ETWServicesUtils.notify('PlansService');
            });
        }
        /**
         // @ts-ignore ts-migrate(7006) FIXME: Parameter 'isAdminEntity' implicitly has an 'any' ... Remove this comment to see the full error message
         * @method createPlaceholderGoalAndKpi
         * @param sourcePlanId {number}
         * @param targetPlanId {number}
         * @returns {object}
         */
        function createPlaceholderGoalAndKpi(sourcePlanId, targetPlanId) {
            return $http({
                errorMessage: 'Could not create placeholder goal and kpi',
                method: 'POST',
                url: serviceUrl +
                    '/' +
                    ETWServicesUtils.asId(sourcePlanId) +
                    '/create-placeholder-goal-and-kpi/' +
                    ETWServicesUtils.asId(targetPlanId),
            }).finally(function () {
                getById.clear(targetPlanId);
                ETWServicesUtils.notify('PlansService');
            });
        }
        /**
         * @method convertPlan
         * @param  planId {number}
         * @returns {object} - promise
         */
        function convertPlan(planId) {
            return $http({
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                errorMessage: 'Could not make plan top level',
                method: 'PATCH',
                url: serviceUrl + '/' + ETWServicesUtils.asId(planId) + '/makeTopLevel',
            }).finally(function () {
                getById.clear(planId);
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
                ETWServicesUtils.notify('PlansService');
            });
        }
        /**
         * @method destroy
         * @param id {number}
         * @returns {object} - promise
         */
        function destroy(id) {
            return ETWServicesUtils.destroy({
                errorMessage: 'This plan could not be removed.',
                url: serviceUrl + '/' + ETWServicesUtils.asId(id),
            }).finally(function () {
                try {
                    getById.clear(id);
                    ETWServicesUtils.notify('PlansService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method getAll
         * @returns {object} - promise, Array of Plans
         */
        function getAll() {
            return $http({
                errorMessage: 'Plans could not be retrieved.',
                method: 'GET',
                url: serviceUrl,
            });
        }
        /**
         * @method getAllForPerson
         * @param personId {number}
         * @returns {*}
         * Gets all plans that a person is owner/participant
         *   AND current user has access to.
         */
        function getAllForPerson(personId) {
            return $http({
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                errorMessage: 'Plans for this person could not be retrieved.',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'isSubscribed' implicitly has an 'any' t... Remove this comment to see the full error message
                method: 'GET',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'method' implicitly has an 'any' type.
                url: peopleServiceUrl + '/' + ETWServicesUtils.asId(personId) + '/plans',
            });
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        }
        /**
         * @method getAllForPerson
         * @param personId {number}
         * @returns {*}
         * Gets all plans that a person is owner/participant
         *   AND current user has access to.
         */
        function getActiveForPerson(personId) {
            return $http({
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                errorMessage: 'Plans for this person could not be retrieved.',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'isSubscribed' implicitly has an 'any' t... Remove this comment to see the full error message
                method: 'GET',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'method' implicitly has an 'any' type.
                url: peopleServiceUrl + '/' + ETWServicesUtils.asId(personId) + '/plans?all=false',
            });
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        }
        /**
         * @method getAllForOwner
         * @param personId {number}
         * @returns {*}
         * Gets all plans that a person is owner
         *   AND current user has access to.
         */
        function getAllForOwner(personId) {
            return $http({
                errorMessage: 'Plans for this person could not be retrieved.',
                method: 'GET',
                url: peopleServiceUrl + '/' + ETWServicesUtils.asId(personId) + '/plans?owned=true',
            });
        }
        /**
         * @method getAllIdsAndTitlesForPerson
         * @returns {*}
         * Gets all plans that a person is owner of
         */
        function getAllIdsAndTitlesForPerson(excludedPlanId) {
            var parameterObject = {};
            if (angular.isDefined(excludedPlanId)) {
                // @ts-ignore
                parameterObject.excludedPlanId = ETWServicesUtils.asId(excludedPlanId);
            }
            return $http({
                errorMessage: 'Plans for this person could not be retrieved.',
                method: 'GET',
                params: parameterObject,
                url: planListUrl,
            });
        }
        /**
         * @method getAllForPlan
         * @param planId {number} - ID of parent plan
         * @returns {object} - promise, Array of Plans
         * Get all supporting plans for a plan.
         * (To get all plans that support other plans visible to the current user, see getAllSupporting)
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'sourcePlanId' implicitly has an 'any' t... Remove this comment to see the full error message
        function getAllForPlan(planId) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'targetPlanId' implicitly has an 'any' t... Remove this comment to see the full error message
            return $http({
                errorMessage: 'Supporting plans for this plan could not be retrieved.',
                method: 'GET',
                url: serviceUrl + '/' + ETWServicesUtils.asId(planId) + '/subPlans',
            });
        }
        /**
         * @method getLimitedSupportingForPlan
         * @param planId {number} - ID of parent plan
         * @returns {object} - promise, Array of Plans
         * Get layers of defaults to 2 supporting plans for a plan.
         */
        function getLimitedSupportingForPlan(planId) {
            return $http({
                errorMessage: 'Supporting plans for this plan could not be retrieved.',
                method: 'GET',
                url: serviceUrl + '/' + ETWServicesUtils.asId(planId) + '/limitedSubPlans',
            });
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
         * @method getAllSupporting
         * @returns {object} - promise, Array of Plans
         * Gets all the plans that support other plans that are visible to the user.
         * (To get supporting plans for a particular plan, see getAllForPlan)
         * (To see all non-supporting plans -- or support plans that the user can't view -- see getAllTopLevel)
         */
        function getAllSupporting() {
            return $http({
                errorMessage: 'Supporting Plans could not be retrieved.',
                method: 'GET',
                url: supportingServiceUrl,
            });
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
         * @method getAllSupportingForPlan
         * @param  {number} planId - ID of the parent planId
         * @param  {string} includeTopPlan - 'true' or 'false' to include the plan representing planId in the results
         * @return {object} - promise, Array of Plans
         * TODO: includeTopPlan should be a boolean
         * Get all supporting plans and hierarchy for a plan.
         * For the AIM chart for supporting plans this will get a plan's supporting plan hierarchy.
         */
        function getAllSupportingForPlan(planId, includeTopPlan) {
            if (includeTopPlan === undefined) {
                includeTopPlan = 'false';
            }
            return $http({
                errorMessage: 'All supporting plans for this plan could not be retrieved.',
                method: 'GET',
                url: serviceUrl +
                    '/' +
                    ETWServicesUtils.asId(planId) +
                    '/allSubPlans?includeTopPlan=' +
                    includeTopPlan,
            });
        }
        /**
         * @method getAllTopLevel
         * @returns {object} - promise, Array of Plans
         */
        function getAllTopLevel() {
            return $http({
                errorMessage: 'Top level Plans could not be retrieved.',
                method: 'GET',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'personId' implicitly has an 'any' type.
                url: topLevelServiceUrl,
            });
        }
        /**
         * @method getById
         * @param id {number}
         * @param [isNotifyError] {boolean=true} - Show notify popup on errors if true
         * @returns {object} - promise, Plan object
         */
        function getById(id, isNotifyError) {
            if (angular.isUndefined(isNotifyError)) {
                // Set isNotifyError to true by default
                isNotifyError = true;
            }
            return $http({
                //cache: true,
                errorMessage: isNotifyError && 'This plan could not be retrieved.',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'personId' implicitly has an 'any' type.
                method: 'GET',
                url: serviceUrl + '/' + ETWServicesUtils.asId(id),
            });
        }
        /**
         * @method getFiles
         * @param planId {number}
         * @returns {object} - promise
         * Request the attached files on the plan
         */
        function getFiles(planId) {
            return $http({
                errorMessage: 'Could not retrieve attached files.',
                method: 'GET',
                url: planFilesServiceUrl + '/' + ETWServicesUtils.asId(planId),
            }).then(function (response) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'excludedPlanId' implicitly has an 'any'... Remove this comment to see the full error message
                _.forEach(response.data, function (file) {
                    file.downloadUrl = serviceUrl + '/' + ETWServicesUtils.asId(planId) + '/file/' + file.id;
                });
                return response;
            }, service.reject);
        }
        /**
         * @method getNew()
         * @param options {object}
         * Note: options.ownerId is required.
         * Creates a new (unsaved) instance with default values.
         */
        function getNew(options) {
            return ETWServicesUtils.resolve({
                data: {
                    autoGenerateRequirements: 1,
                    hasAggregateKpi: 0,
                    hasGoals: 1,
                    hasKpi: 1,
                    hasMos: 0,
                    hasDrivers: 1,
                    hasImpact: 0,
                    outcomesEnabled: false,
                    hasReadiness: 1,
                    hasStrategy: 0,
                    hasSubplans: 1,
                    defaultCommsEnabled: false,
                    ownerSet: options.ownerSet || (options.ownerId && [options.ownerId]) || [],
                    parentPlanId: options.parentPlanId,
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                    participantSet: options.participantSet || [],
                    primaryOwnerId: options.ownerId,
                    state: 2,
                    title: options.title || '',
                    viewOnlySet: options.viewOnlySet || [],
                },
            });
        }
        /**
         * Retrieve pinned plans for the current user.
         * @method getPinnedPlans
         * @returns {*}
         */
        function getPinnedPlans() {
            return $http({
                errorMessage: 'Could not retrieve pinned plans',
                method: 'GET',
                url: pinnedPlanServiceUrl,
            });
        }
        /**
         * Retrieve all owner and participant assignments for the given plan.
         * @method getPlanAssignments
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
         * @param planId plan to retrieve assignments for
         * @returns {*}
         */
        function getPlanAssignments(planId) {
            return $http({
                errorMessage: 'Could not retrieve plan assignments',
                method: 'GET',
                url: serviceUrl + '/' + ETWServicesUtils.asId(planId) + '/assignments',
            });
        }
        /**
         * returns a list of KPIs shared with this plan.
         * @method getSharedKpis
         * @param planId
         * @returns {*}
         */
        function getSharedKpis(planId) {
            return $http({
                errorMessage: 'Could not retrieve shared KPIs',
                method: 'GET',
                url: planKpiServiceUrl + '/' + ETWServicesUtils.asId(planId) + '/sharedkpis',
            });
        }
        /**
         *
         * @param planId
         */
        function hasSubPlans(planId) {
            return $http({
                method: 'GET',
                url: serviceUrl + '/' + ETWServicesUtils.asId(planId) + '/hasSubPlans',
            });
        }
        /**
         * @method movePlan
         * @param currentPlanId {number}
         * @param newPlanId {number}
         * @returns {object} - promise
         */
        function movePlan(currentPlanId, newPlanId) {
            return $http({
                errorMessage: 'Could not move Plan',
                method: 'PATCH',
                url: serviceUrl +
                    '/' +
                    ETWServicesUtils.asId(currentPlanId) +
                    '/newPlan/' +
                    ETWServicesUtils.asId(newPlanId),
            }).finally(function () {
                getById.clear(currentPlanId);
                getById.clear(newPlanId);
                ETWServicesUtils.notify('PlansService');
            });
        }
        /**
         * @method removePeople
         * @param accessType {string}
         * @param [planId] {number} - Plan ID to clear the cache
         *
         * Removes all people access via the goal service.
         */
        function removePeople(planId, accessType, people) {
            return $http({
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                errorMessage: 'This person could not be removed from the goal.',
                method: 'PATCH',
                data: { ids: people },
                url: serviceUrl + '/' + planId + '/unassigned-' + accessType,
            }).finally(function () {
                try {
                    // Clear plan cache
                    if (angular.isDefined(planId)) {
                        getById.clear(planId);
                    }
                    else {
                        getAll.clear();
                    }
                    ETWServicesUtils.notify('GoalsService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method removeAttributeValueFromPlan
         * @param planId {number}
         * @param attributeValueId
         * Removes attribute value from plan
         */
        function removeAttributeValueFromPlan(planId, attributeValueId, type) {
            return $http({
                errorMessage: 'Attribute Value could not be removed',
                method: 'DELETE',
                url: serviceUrl +
                    '/' +
                    ETWServicesUtils.asId(planId) +
                    '/' +
                    type +
                    '/attributevalues/' +
                    ETWServicesUtils.asId(attributeValueId),
            }).finally(function () {
                $rootScope.$emit('notify', 
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
                "Users are being removed from the plan's access list. In order to display the most current status, please refresh your browser.", 'success');
            });
        }
        /**
         * @method removeRoleFromPlan
         * @param planId {number}
         * @param roleId {number}
         * @param type {string}
         * Removes role from plan
         */
        function removeRoleFromPlan(planId, roleId, type) {
            return $http({
                errorMessage: 'Role could not be removed',
                method: 'DELETE',
                url: serviceUrl +
                    '/' +
                    ETWServicesUtils.asId(planId) +
                    '/' +
                    type +
                    '/roles/' +
                    ETWServicesUtils.asId(roleId),
            }).finally(function () {
                $rootScope.$emit('notify', 
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                "Users are being added to the plan's access list. In order to display the most current status, please refresh your browser.", 'success');
            });
        }
        /**
         * @method removePerson
         * @param planId {number}
         * @param personId {number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
         * @param accessType {string} - [owner|participant|viewer], maps to accessTypes
         * @returns {object} - promise
         */
        function removePerson(planId, personId, accessType) {
            return changePerson(planId, personId, accessType, false, 'DELETE');
        }
        function removePinnedPlan(planId) {
            return $http({
                errorMessage: 'Could not remove pinned plans',
                method: 'DELETE',
                url: pinnedPlanServiceUrl + '/' + ETWServicesUtils.asId(planId),
            }).finally(function () {
                getById.clear(planId);
            });
        }
        /**
         * @method save
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'options' implicitly has an 'any' type.
         * @param plan {object}
         * @param changedProperties {array} - optional. For partial updates
         * @returns {object} - promise, Plan
         * Create/update/patch a plan
         */
        function save(plan, changedProperties) {
            var options = {
                data: plan,
                errorMessage: 'This plan could not be saved.',
                idName: 'id',
                properties: changedProperties,
                url: serviceUrl,
            }, promise;
            if (angular.isDefined(plan.id)) {
                options.url = serviceUrl + '/' + ETWServicesUtils.asId(plan.id);
            }
            promise = ETWServicesUtils.save(options, undefined, 'PlansService', function () {
                // Clear the cache (before subscribers are notified)
                if (angular.isDefined(plan.id)) {
                    getById.clear(plan.id);
                }
                else {
                    getAll.clear();
                }
            });
            return promise;
        }
        function setPlanAimStatus(plan) {
            plan.aim = {};
            plan.aim.status = {};
            if (plan.state === service.DRAFT) {
                plan.aim.status.label = 'Draft';
                plan.aim.status.color = '#818A91';
            }
            else if (plan.state === service.COMPLETED) {
                plan.aim.status.label = 'Completed';
                plan.aim.status.color = '#51bfe2';
            }
            else if (plan.state === service.NOT_COMPLETED) {
                plan.aim.status.label = 'Suspended';
                plan.aim.status.color = '#000000';
            }
            else {
                //use the plan aim chart mechanism to determine status
                var totalActiveStatusGoals = plan.planOnTrackCount + plan.planAtRiskCount + plan.planFallingBehindCount;
                if (plan.hasGoals && totalActiveStatusGoals === 0) {
                    //DRAFT
                    plan.aim.status.label = 'No Active Goals';
                    plan.aim.status.color = '#D8D8D8';
                }
                else if (!plan.hasGoals) {
                    if (plan.status === 3) {
                        plan.aim.status.label = 'On Track';
                        plan.aim.status.color = '#4CAF50';
                    }
                    else if (plan.status === 2) {
                        plan.aim.status.label = 'At Risk';
                        plan.aim.status.color = '#FF9800';
                    }
                    else if (plan.status === 1) {
                        plan.aim.status.label = 'Falling Behind';
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                        plan.aim.status.color = '#F44336';
                    }
                    else {
                        plan.aim.status.label = 'No Status';
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                        plan.aim.status.color = '#D8D8D8';
                    }
                }
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                else if (totalActiveStatusGoals === 1) {
                    if (plan.planOnTrackCount === 1) {
                        plan.aim.status.label = 'On Track';
                        plan.aim.status.color = '#4CAF50';
                    }
                    else if (plan.planAtRiskCount === 1) {
                        plan.aim.status.label = 'At Risk';
                        plan.aim.status.color = '#FF9800';
                    }
                    else if (plan.planFallingBehindCount === 1) {
                        plan.aim.status.label = 'Falling Behind';
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                        plan.aim.status.color = '#F44336';
                    }
                }
                else {
                    if (plan.planFallingBehindCount / totalActiveStatusGoals >=
                        planAllowableFallingBehindThreshold) {
                        // Falling Behind
                        plan.aim.status.label = 'Falling Behind';
                        plan.aim.status.color = '#F44336';
                    }
                    else {
                        var onTrackPercentage = plan.planOnTrackCount / totalActiveStatusGoals;
                        if (onTrackPercentage >= planCutpointMax) {
                            // On Track
                            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'currentPlanId' implicitly has an 'any' ... Remove this comment to see the full error message
                            plan.aim.status.label = 'On Track';
                            plan.aim.status.color = '#4CAF50';
                        }
                        else if (onTrackPercentage < planCutpointMax && onTrackPercentage > planCutpointMid) {
                            // partial On Track
                            plan.aim.status.label = 'Almost On Track';
                            plan.aim.status.color = '#B7DFB9';
                        }
                        else if (onTrackPercentage <= planCutpointMid &&
                            onTrackPercentage > planCutpointMin) {
                            // At Risk
                            plan.aim.status.label = 'At Risk';
                            plan.aim.status.color = '#FF9800';
                        }
                        else {
                            // partial Falling Behind
                            plan.aim.status.label = 'Almost Falling Behind';
                            plan.aim.status.color = '#F9A19A';
                        }
                    }
                }
            }
        }
        //adds or removes a shared KPI from a plan
        function toggleSharedKpi(planId, kpiId, method) {
            //dial the ☎️
            return $http({
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
                errorMessage: 'Could not toggle shared KPI',
                method: method || 'POST',
                url: planKpiServiceUrl +
                    '/' +
                    ETWServicesUtils.asId(planId) +
                    '/sharedkpis/' +
                    ETWServicesUtils.asId(kpiId),
            }).finally(function () {
                try {
                    // clear cache
                    getById.clear(planId);
                    ETWServicesUtils.notify('PlansService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method updatePerson
         * @param planId {number}
         * @param personId {number}
         * @param accessType {string}
         * @param isSubscribed {boolean = false}
         * @returns {Object} - promise
         */
        function updatePerson(planId, personId, accessType, isSubscribed) {
            return changePerson(planId, personId, accessType, isSubscribed, 'PUT');
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.

(function () {
    angular
        .module('ETWServices')
        .factory('PubnubService', [
        '$http',
        '$window',
        'AuthenticationService',
        'ENVIRONMENT',
        'ETWServicesUtils',
        'PUBNUB_KEYS',
        PubnubServiceFactory,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'uuid' implicitly has an 'any' type.
    function Channel(uuid) {
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        this.uuid = uuid;
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        this.isSubscribed = false;
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        this.isHistoryFetched = false;
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        this.historicUnreadCount = 0;
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        this.historicMessages = [];
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        this.unreadMessages = [];
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        this.messages = [];
    }
    function PubnubServiceFactory(
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
    $http, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$window' implicitly has an 'any' type.
    $window, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AuthenticationService' implicitly has a... Remove this comment to see the full error message
    AuthenticationService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ENVIRONMENT' implicitly has an 'any' ty... Remove this comment to see the full error message
    ENVIRONMENT, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ETWServicesUtils' implicitly has an 'an... Remove this comment to see the full error message
    ETWServicesUtils, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'PUBNUB_KEYS' implicitly has an 'any' ty... Remove this comment to see the full error message
    PUBNUB_KEYS) {
        var service = {
            buildChannelsForCommunication: buildChannelsForCommunication,
            deregisterListener: deregisterListener,
            fetchArchivedMessages: fetchArchivedMessages,
            fetchInitialMessageHistory: fetchInitialMessageHistory,
            fetchInitialMessageHistoryForCommunication: fetchInitialMessageHistoryForCommunication,
            fetchUnreadMessagesCount: fetchUnreadMessagesCount,
            getHereNowForChannels: getHereNowForChannels,
            logout: logout,
            match: match,
            onMessageRead: onMessageRead,
            publishMessage: publishMessage,
            registerListener: registerListener,
            subscribeChannels: subscribeChannels,
            unsubscribeChannels: unsubscribeChannels,
        };
        // @ts-ignore ts-migrate(7034) FIXME: Variable 'pubnub' implicitly has type 'any' in som... Remove this comment to see the full error message
        var pubnub = null;
        var userAccount = AuthenticationService.getAccount();
        // @ts-ignore ts-migrate(7034) FIXME: Variable 'channels' implicitly has type 'any[]' in... Remove this comment to see the full error message
        var channels = [];
        // @ts-ignore ts-migrate(7034) FIXME: Variable 'communicationChannels' implicitly has ty... Remove this comment to see the full error message
        var communicationChannels = [];
        var registeredEvents = {};
        var registeredCallbacks = {};
        /**
         * @property channelsServiceUrl
         * @type {string}
         */
        var channelsServiceUrl = ETWServicesUtils.getEndpointUrl('REALTIME_MESSAGING_CHANNELS');
        init();
        return service;
        /**
         * @function init
         */
        function init() {
            userAccount = AuthenticationService.getAccount();
            getPubnubInstance();
        }
        function getPub() {
            if (!pubnub) {
                userAccount = AuthenticationService.getAccount();
                getPubnubInstance();
                return pubnub;
            }
            else {
                return pubnub;
            }
        }
        /**
         * @method getPubnubInstance
         * @returns {object}
         */
        function getPubnubInstance() {
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'pubnub' implicitly has an 'any' type.
            if (!pubnub && userAccount.userId) {
                pubnub = new $window.PubNub({
                    subscribeKey: PUBNUB_KEYS[ENVIRONMENT].subscribe,
                    publishKey: PUBNUB_KEYS[ENVIRONMENT].publish,
                    authKey: userAccount.authKey,
                    logVerbosity: false,
                    uuid: (userAccount.userId).toString(),
                    ssl: true,
                    presenceTimeout: 130,
                    heartbeatInterval: 60,
                });
                //now add listeners to pubnub
                pubnub.addListener({
                    message: onMessage,
                    presence: onPresence,
                    status: onStatus,
                });
            }
            console.log('init pubnub'); // zzmatt
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'pubnub' implicitly has an 'any' type.
            return pubnub;
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'msg' implicitly has an 'any' type.
        function onMessage(msg) {
            // get the channel this message is applicable on
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'channels' implicitly has an 'any[]' type... Remove this comment to see the full error message
            var channel = channels[msg.message.channelUuid];
            if (msg.message.messageBody) {
                msg.body = JSON.parse(msg.message.messageBody);
            }
            if (!channel) {
                //new channel we are fetching messages for
                // @ts-ignore ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
                channel = new Channel(msg.message.channelUuid);
                //add this new channel to our list of channels
                channels[msg.message.channelUuid] = channel;
            }
            if (userAccount.userId !== msg.message.userId) {
                //push the new message
                channel.unreadMessages.push(msg);
            }
            //inform the registered listeners of the new message
            publishEventToListeners('realtime-messaging:onMessage', msg);
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'p' implicitly has an 'any' type.
        function onPresence(p) {
            //inform the registered listeners of the event
            publishEventToListeners('realtime-messaging:onPresence', p);
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'eventName' implicitly has an 'any' type... Remove this comment to see the full error message
        function publishEventToListeners(eventName, data) {
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            if (registeredEvents[eventName]) {
                // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                _.forEach(registeredEvents[eventName].uids, function (uid) {
                    // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                    registeredCallbacks[uid].fn(data);
                });
            }
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'eventName' implicitly has an 'any' type... Remove this comment to see the full error message
        function registerListener(eventName, callback) {
            var uid = _.uniqueId(eventName);
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            registeredEvents[eventName] = registeredEvents[eventName] || {
                uids: [],
            };
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            registeredEvents[eventName].uids.push(uid);
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            registeredCallbacks[uid] = { fn: callback, eventName: eventName };
            return uid;
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'uid' implicitly has an 'any' type.
        function deregisterListener(uid) {
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            var eventName = registeredCallbacks[uid] && registeredCallbacks[uid].eventName;
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            registeredEvents[eventName].uids = _.reject(registeredEvents[eventName].uids, function (_uid) {
                return _uid === uid;
            });
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            delete registeredCallbacks[uid];
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 's' implicitly has an 'any' type.
        function onStatus(s) {
            //TODO what things can we do here ?
            //deal with active connection timeout need to make sure the app responds again
            //without refresh?
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'msg' implicitly has an 'any' type.
        function onMessageRead(msg, shouldPush) {
            //get the channel this message is appplicable on
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'channels' implicitly has an 'any[]' type... Remove this comment to see the full error message
            var channel = channels[msg.message.channelUuid];
            if (shouldPush) {
                //push for local history without reload
                channel.messages.push(msg);
            }
            //ok message has been read
            channel.unreadMessages = [];
            //inform the registered listeners of the message was read for unread counting
            publishEventToListeners('realtime-messaging:onMessagesRead', msg.message.channelUuid);
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'unsubscribeChannels' implicitly has an ... Remove this comment to see the full error message
        function unsubscribeChannels(unsubscribeChannels) {
            if (unsubscribeChannels && unsubscribeChannels.length > 0) {
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'pubnub' implicitly has an 'any' type.
                getPub().unsubscribe({
                    channels: unsubscribeChannels,
                });
                //remove the channels also from the channels array
                _.forEach(unsubscribeChannels, function (uuid) {
                    // @ts-ignore ts-migrate(7005) FIXME: Variable 'channels' implicitly has an 'any[]' type... Remove this comment to see the full error message
                    delete channels[uuid];
                });
            }
        }
        /**
         * @method buildChannelsForCommunication
         * @param newChannels {object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'newChannels' implicitly has an 'any' ty... Remove this comment to see the full error message
        function buildChannelsForCommunication(newChannels) {
            if (newChannels && newChannels.length > 0) {
                var channelsToSubscribeTo = [];
                communicationChannels = [];
                _.forEach(newChannels, function (ch) {
                    // @ts-ignore ts-migrate(7005) FIXME: Variable 'communicationChannels' implicitly has an... Remove this comment to see the full error message
                    var channel = communicationChannels[ch.uuid];
                    if (!channel) {
                        // @ts-ignore ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
                        channel = new Channel(ch.uuid);
                        channel.historicUnreadCount = ch.unreadMessageCount;
                        channel.isSubscribed = true;
                        channelsToSubscribeTo.push(channel.uuid);
                        communicationChannels[channel.uuid] = channel;
                    }
                    else {
                        //on the off chance we have not subscribed
                        if (!channel.isSubscribed) {
                            channelsToSubscribeTo.push(channel.uuid);
                        }
                    }
                });
            }
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'newChannels' implicitly has an 'any' ty... Remove this comment to see the full error message
        function subscribeChannels(newChannels, presence) {
            if (newChannels && newChannels.length > 0) {
                var channelsToSubscribeTo = [];
                //only subscribe to channels without a subscription
                _.forEach(newChannels, function (ch) {
                    // @ts-ignore ts-migrate(7005) FIXME: Variable 'channels' implicitly has an 'any[]' type... Remove this comment to see the full error message
                    var channel = channels[ch.uuid];
                    if (!channel) {
                        // @ts-ignore ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
                        channel = new Channel(ch.uuid);
                        channel.historicUnreadCount = ch.unreadMessageCount;
                        channel.isSubscribed = true;
                        channelsToSubscribeTo.push(channel.uuid);
                        channels[channel.uuid] = channel;
                    }
                    else {
                        //on the off chance we have not subscribed
                        // @ts-ignore ts-migrate(2693) FIXME: 'any' only refers to a type, but is being used as ... Remove this comment to see the full error message
                        if (!channel.isSubscribed) {
                            // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'channel'.
                            channelsToSubscribeTo.push(channel.uuid);
                        }
                    }
                });
                //subscribe
                getPub().subscribe({
                    // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'channelsToSubscribeTo'.
                    channels: channelsToSubscribeTo,
                    // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'presence'.
                    withPresence: presence,
                });
            }
        }
        function logout() {
            // @ts-ignore ts-migrate(7034) FIXME: Variable 'channelsToUnsubscribeTo' implicitly has ... Remove this comment to see the full error message
            var channelsToUnsubscribeTo = [];
            //grab all of the channels
            // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'channels'.
            _.forEach(channels, function (channel) {
                channelsToUnsubscribeTo.push(channel.uuid);
            });
            //ok unsubscribeChannels
            // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'unsubscribeChannels'.
            unsubscribeChannels(channelsToUnsubscribeTo);
        }
        /**
         * @method match
         * @param payload {object} - Pubnub event
         * @param type {String} - proprietary name of the event type
         * @param properties {object} - map of required properties and values
         * @returns {boolean}
         * Use this method to easily check if a given Pubnub event message is the one you are
         * looking for.
         * Tests that the message is the right type and contains the provided properties.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'payload' implicitly has an 'any' type.
        function match(payload, type, properties) {
            var isPass = true, p;
            if (payload.message.type === type && payload.body) {
                for (p in properties) {
                    if (!payload.body.hasOwnProperty(p) || payload.body[p] != properties[p]) {
                        isPass = false;
                    }
                }
            }
            else {
                isPass = false;
            }
            return isPass;
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'room' implicitly has an 'any' type.
        function publishMessage(room, message) {
            //publish to archive and then to pubnub for worse case Failure
            //the message will still be in the archive
            publishMessageToArchive(room, message).then(publishMessageToPubnub(room, message));
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'room' implicitly has an 'any' type.
        function publishMessageToPubnub(room, newMessage) {
            // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'ETWServicesUtils'.
            var deferred = ETWServicesUtils.defer();
            // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'pubnub'.
            getPub().publish({
                message: newMessage,
                channel: room.uuid,
            }, 
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'status' implicitly has an 'any' type.
            function (status) {
                if (status.error) {
                    //TODO this is fatal need to show notification error!
                    console.error('PUBNUB PUBLISH ERROR', status);
                }
                deferred.resolve();
            });
            return deferred.promise;
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'room' implicitly has an 'any' type.
        function publishMessageToArchive(room, message) {
            // @ts-ignore ts-migrate(2304) FIXME: Cannot find name '$http'.
            return $http({
                errorMessage: 'Failure to save message to archive.',
                method: 'POST',
                // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'channelsServiceUrl'.
                url: channelsServiceUrl + '/' + ETWServicesUtils.asId(room.id) + '/archive',
                data: message,
            });
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'room' implicitly has an 'any' type.
        function fetchArchivedMessages(room, count, endTimestamp) {
            var params = {};
            if (count) {
                // @ts-ignore ts-migrate(2339) FIXME: Property 'limit' does not exist on type '{}'.
                params.limit = count;
            }
            if (endTimestamp) {
                // @ts-ignore ts-migrate(2339) FIXME: Property 'end' does not exist on type '{}'.
                params.end = endTimestamp;
            }
            // @ts-ignore ts-migrate(2304) FIXME: Cannot find name '$http'.
            return $http({
                errorMessage: 'Failure to fetch messages in archive.',
                method: 'GET',
                params: params,
                // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'channelsServiceUrl'.
                url: channelsServiceUrl + '/' + ETWServicesUtils.asId(room.id) + '/archive',
            });
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'room' implicitly has an 'any' type.
        function fetchInitialMessageHistory(room, count) {
            // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'ETWServicesUtils'.
            var deferred = ETWServicesUtils.defer();
            // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'channels'.
            var channel = channels[room.uuid];
            if (channel && channel.isHistoryFetched) {
                //history has already been fetched for this channel
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                fetchUnreadMessages(room.uuid, false).then(function (response) {
                    _.forEach(response, function (msg) {
                        // notify the service we have read the message
                        // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'onMessageRead'.
                        onMessageRead(msg, true);
                        channel.historicMessages.push(msg.message);
                    });
                    deferred.resolve(channel.historicMessages);
                });
            }
            else {
                channel.historicMessages = [];
                //need to fetch the history for this channel and request unread + count
                // @ts-ignore ts-migrate(2554) FIXME: Expected 3 arguments, but got 2.
                fetchArchivedMessages(room, channel.historicUnreadCount + count).then(function (response) {
                    channel.historicMessages = response.data;
                    channel.isHistoryFetched = true;
                    channel.historicUnreadCount = 0;
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                    fetchUnreadMessages(room.uuid, false).then(function (response) {
                        _.forEach(response, function (msg) {
                            // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'onMessageRead'.
                            onMessageRead(msg, false);
                        });
                    });
                    deferred.resolve(channel.historicMessages);
                });
            }
            return deferred.promise;
        }
        /**
         * @method fetchInitialMessageHistoryForCommunication
         * @param communicationRoom {object}
         * @param communicationCount {number}
         * @returns {object} - promise
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'communicationRoom' implicitly has an 'a... Remove this comment to see the full error message
        function fetchInitialMessageHistoryForCommunication(communicationRoom, communicationCount) {
            // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'ETWServicesUtils'.
            var deferred = ETWServicesUtils.defer();
            // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'communicationChannels'.
            var channel = communicationChannels[communicationRoom.uuid];
            if (channel && channel.isHistoryFetched) {
                //history has already been fetched for this channel
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                fetchUnreadMessages(communicationRoom.uuid, true).then(function (response) {
                    _.forEach(response, function (msg) {
                        // notify the service we have read the message
                        // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'onMessageRead'.
                        onMessageRead(msg, true);
                        channel.historicMessages.push(msg.message);
                    });
                    deferred.resolve(channel.historicMessages);
                });
            }
            else {
                channel.historicMessages = [];
                //need to fetch the history for this channel and request unread + count
                // @ts-ignore ts-migrate(2554) FIXME: Expected 3 arguments, but got 2.
                fetchArchivedMessages(communicationRoom, channel.historicUnreadCount + communicationCount
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                ).then(function (response) {
                    channel.historicMessages = response.data;
                    channel.isHistoryFetched = true;
                    channel.historicUnreadCount = 0;
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                    fetchUnreadMessages(communicationRoom.uuid, true).then(function (response) {
                        _.forEach(response, function (msg) {
                            // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'onMessageRead'.
                            onMessageRead(msg, false);
                        });
                    });
                    deferred.resolve(channel.historicMessages);
                });
            }
            return deferred.promise;
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'channelUuid' implicitly has an 'any' ty... Remove this comment to see the full error message
        function fetchUnreadMessagesCount(channelUuid) {
            //get the unread messages count
            // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'channels'.
            var channel = channels[channelUuid];
            if (channel) {
                if (channel.historicUnreadCount === undefined) {
                    channel.historicUnreadCount = 0;
                }
                return channel.isHistoryFetched
                    ? channel.unreadMessages.length
                    : channel.historicUnreadCount + channel.unreadMessages.length;
            }
            return 0;
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'channelUuid' implicitly has an 'any' ty... Remove this comment to see the full error message
        function fetchUnreadMessages(channelUuid, isCommunication) {
            var unreadMessages;
            if (isCommunication) {
                //get the unread messages
                // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'communicationChannels'.
                unreadMessages = communicationChannels[channelUuid].unreadMessages;
                //now set the unread to read
                // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'communicationChannels'.
                communicationChannels[channelUuid].unreadMessages = [];
                // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'communicationChannels'.
                communicationChannels[channelUuid].unreadMessages = [];
            }
            else {
                //get the unread messages
                // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'channels'.
                unreadMessages = channels[channelUuid].unreadMessages;
                //now set the unread to read
                // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'channels'.
                channels[channelUuid].unreadMessages = [];
            }
            // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'ETWServicesUtils'.
            return ETWServicesUtils.resolve(unreadMessages);
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'channelUuids' implicitly has an 'any' t... Remove this comment to see the full error message
        function getHereNowForChannels(channelUuids) {
            // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'ETWServicesUtils'.
            var deferred = ETWServicesUtils.defer();
            // @ts-ignore ts-migrate(2304) FIXME: Cannot find name 'pubnub'.
            getPub().hereNow({
                channels: channelUuids,
            }, 
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'status' implicitly has an 'any' type.
            function (status, response) {
                if (status.error) {
                    console.error('PUBNUB GET PRESENCE ERROR', status);
                }
                else {
                    deferred.resolve(response);
                }
            });
            return deferred.promise;
        }
    }
})();

(function () {
    angular
        .module('ETWServices')
        .factory('ReportEvaluationsService', [
        '$cacheFactory',
        '$http',
        'PeopleService',
        'ETWServicesUtils',
        ReportEvaluationsService,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$cacheFactory' implicitly has an 'any' ... Remove this comment to see the full error message
    function ReportEvaluationsService($cacheFactory, $http, PeopleService, ETWServicesUtils) {
        //public methods
        var service = {
            filterPeople: filterPeople,
            getAllEvaluationsData: getAllEvaluationsData,
            getSortMenu: getSortMenu,
        };
        var sortMenu = {
            defaultColumn: 'lastName',
            isDescending: false,
            options: [
                {
                    column: 'firstName',
                    label: 'First Name',
                },
                {
                    column: 'lastName',
                    label: 'Last Name',
                },
                {
                    column: 'title',
                    label: 'Title',
                },
                {
                    column: 'emailAddress',
                    label: 'Email',
                },
                {
                    column: 'teamLeader',
                    label: 'Team Leader',
                },
                {
                    column: 'hireDate',
                    label: 'Hire Date',
                },
                {
                    column: 'userEnabled',
                    label: 'Active',
                },
                {
                    column: 'evaluation.performanceScore',
                    label: 'Performance Score',
                },
                {
                    column: 'evaluation.cultureScore',
                    label: 'Culture Score',
                },
                {
                    column: 'evaluation.leadershipScore',
                    label: 'Leadership Score',
                },
                {
                    column: 'overallScore',
                    label: 'Overall Score',
                },
            ],
        };
        /**
         * @property serviceUrl
         * @type {string}
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('REPORTS_EVALUATIONS');
        //send back the public functions
        return service;
        //////////////////////// FUNCTIONS ////////////////////////
        function getAllEvaluationsData() {
            return $http({
                errorMessage: 'The latest evaluations report data pull failed.',
                method: 'GET',
                url: serviceUrl + '/all',
            });
        }
        function getSortMenu() {
            return sortMenu;
        }
        /**
         * @method filterPeople
         * @param filters {object} - Keys of the object overwrite matching keys of vm.filters
         * Filter the people list.
         * Because of the complexity of the filters, a separate array is iterated by the template: filteredPeople
         * Filters:
         *   attributeValues {array} ids
         *   roles {array} ids
         *
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'people' implicitly has an 'any' type.
        function filterPeople(people, currentFilters, filters) {
            // @ts-ignore ts-migrate(7034) FIXME: Variable 'filteredPeople' implicitly has type 'any... Remove this comment to see the full error message
            var filteredPeople = [], 
            // @ts-ignore ts-migrate(7034) FIXME: Variable 'isAttributeValues' implicitly has type '... Remove this comment to see the full error message
            isAttributeValues, 
            // @ts-ignore ts-migrate(7034) FIXME: Variable 'isRoles' implicitly has type 'any' in so... Remove this comment to see the full error message
            isRoles;
            // Merge the filters. Leave existing filters in tact unless they exist in incoming filters.
            _.assign(currentFilters, filters);
            isAttributeValues = currentFilters.attributeValues && !!currentFilters.attributeValues.length;
            isRoles = currentFilters.roles && !!currentFilters.roles.length;
            _.forEach(people, function (person) {
                // THIS IS A HACK FROM PEOPLE SERVICE
                var searchTerms = [person.firstName, person.lastName, person.emailAddress, person.title];
                var searchText = searchTerms.join('\n').toLowerCase();
                var isPass = true, attributeValueMatchCount, roleMatchCount;
                if (currentFilters) {
                    // query
                    if (isPass && filters.query) {
                        // PeopleService decides the searchable columns
                        // They are lower case, concatenated and delimited by new lines
                        if (searchText.indexOf(filters.query.toLowerCase()) === -1) {
                            isPass = false;
                        }
                    }
                    // attributeValues
                    // @ts-ignore ts-migrate(7005) FIXME: Variable 'isAttributeValues' implicitly has an 'an... Remove this comment to see the full error message
                    if (isPass && isAttributeValues) {
                        attributeValueMatchCount = _.intersection(person._analysis.attributeValues, currentFilters.attributeValues).length;
                        if (attributeValueMatchCount !== currentFilters.attributeValues.length) {
                            // All attributes must be included in the match, so if the match count doesn't equal the filter value count, fail.
                            isPass = false;
                        }
                    }
                    // roles
                    // @ts-ignore ts-migrate(7005) FIXME: Variable 'isRoles' implicitly has an 'any' type.
                    if (isPass && isRoles) {
                        roleMatchCount = _.intersection(person._analysis.roles, currentFilters.roles).length;
                        if (!roleMatchCount) {
                            isPass = false;
                        }
                    }
                }
                if (isPass) {
                    filteredPeople.push(person);
                }
            });
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'filteredPeople' implicitly has an 'any[]... Remove this comment to see the full error message
            return filteredPeople;
        }
    }
})();

(function () {
    angular
        .module('ETWServices')
        .factory('ReportPeopleService', [
        '$cacheFactory',
        '$http',
        'PeopleService',
        'ETWServicesUtils',
        ReportPeopleService,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$cacheFactory' implicitly has an 'any' ... Remove this comment to see the full error message
    function ReportPeopleService($cacheFactory, $http, PeopleService, ETWServicesUtils) {
        //public methods
        var service = {
            filterPeople: filterPeople,
            getAllPeopleData: getAllPeopleData,
            getOrgChartData: getOrgChartData,
            getPeopleWithLateEvaluationsData: getPeopleWithLateEvaluationsData,
            getPeopleWithoutPerformanceGoalsData: getPeopleWithoutPerformanceGoalsData,
            getPeopleWithoutTeamData: getPeopleWithoutTeamData,
            getSortMenu: getSortMenu,
        };
        var sortMenu = {
            defaultColumn: 'lastName',
            isDescending: false,
            options: [
                {
                    column: 'firstName',
                    label: 'First Name',
                },
                {
                    column: 'lastName',
                    label: 'Last Name',
                },
                {
                    column: 'title',
                    label: 'Title',
                },
                {
                    column: 'emailAddress',
                    label: 'Email',
                },
                {
                    column: 'teamLeader',
                    label: 'Team Leader',
                },
                {
                    column: 'hireDate',
                    label: 'Hire Date',
                },
                {
                    column: 'userEnabled',
                    label: 'Active',
                },
                {
                    column: 'lastLoginDate',
                    label: 'Last Login',
                },
            ],
        };
        /**
         * @property serviceUrl
         * @type {string}
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('REPORTS_PEOPLE');
        //send back the public functions
        return service;
        //////////////////////// FUNCTIONS ////////////////////////
        function getAllPeopleData() {
            return $http({
                errorMessage: 'The all people report data pull failed.',
                method: 'GET',
                url: serviceUrl + '/all',
            });
        }
        function getOrgChartData() {
            return $http({
                errorMessage: 'The all org chart report data pull failed.',
                method: 'GET',
                url: serviceUrl + '/org-chart',
            });
        }
        function getPeopleWithoutTeamData() {
            return $http({
                errorMessage: 'The people without a team report data pull failed.',
                method: 'GET',
                url: serviceUrl + '/no-team',
            });
        }
        function getPeopleWithoutPerformanceGoalsData() {
            return $http({
                errorMessage: 'The people without performance goals report data pull failed.',
                method: 'GET',
                url: serviceUrl + '/no-performance-goals',
            });
        }
        function getPeopleWithLateEvaluationsData() {
            return $http({
                errorMessage: 'The people with late evaulations report data pull failed.',
                method: 'GET',
                url: serviceUrl + '/late-evaluations',
            });
        }
        function getSortMenu() {
            return sortMenu;
        }
        /**
         * @method filterPeople
         * @param filters {object} - Keys of the object overwrite matching keys of vm.filters
         * Filter the people list.
         * Because of the complexity of the filters, a separate array is iterated by the template: filteredPeople
         * Filters:
         *   attributeValues {array} ids
         *   roles {array} ids
         *
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'people' implicitly has an 'any' type.
        function filterPeople(people, currentFilters, filters) {
            // @ts-ignore ts-migrate(7034) FIXME: Variable 'filteredPeople' implicitly has type 'any... Remove this comment to see the full error message
            var filteredPeople = [], 
            // @ts-ignore ts-migrate(7034) FIXME: Variable 'isAttributeValues' implicitly has type '... Remove this comment to see the full error message
            isAttributeValues, 
            // @ts-ignore ts-migrate(7034) FIXME: Variable 'isRoles' implicitly has type 'any' in so... Remove this comment to see the full error message
            isRoles;
            // Merge the filters. Leave existing filters in tact unless they exist in incoming filters.
            _.assign(currentFilters, filters);
            isAttributeValues = currentFilters.attributeValues && !!currentFilters.attributeValues.length;
            isRoles = currentFilters.roles && !!currentFilters.roles.length;
            _.forEach(people, function (person) {
                // THIS IS A HACK FROM PEOPLE SERVICE
                var searchTerms = [person.firstName, person.lastName, person.emailAddress, person.title];
                var searchText = searchTerms.join('\n').toLowerCase();
                var isPass = true, attributeValueMatchCount, roleMatchCount;
                if (currentFilters) {
                    // query
                    if (isPass && filters.query) {
                        // PeopleService decides the searchable columns
                        // They are lower case, concatenated and delimited by new lines
                        if (searchText.indexOf(filters.query.toLowerCase()) === -1) {
                            isPass = false;
                        }
                    }
                    // attributeValues
                    // @ts-ignore ts-migrate(7005) FIXME: Variable 'isAttributeValues' implicitly has an 'an... Remove this comment to see the full error message
                    if (isPass && isAttributeValues) {
                        attributeValueMatchCount = _.intersection(person._analysis.attributeValues, currentFilters.attributeValues).length;
                        if (attributeValueMatchCount !== currentFilters.attributeValues.length) {
                            // All attributes must be included in the match, so if the match count doesn't equal the filter value count, fail.
                            isPass = false;
                        }
                    }
                    // roles
                    // @ts-ignore ts-migrate(7005) FIXME: Variable 'isRoles' implicitly has an 'any' type.
                    if (isPass && isRoles) {
                        roleMatchCount = _.intersection(person._analysis.roles, currentFilters.roles).length;
                        if (!roleMatchCount) {
                            isPass = false;
                        }
                    }
                }
                if (isPass) {
                    filteredPeople.push(person);
                }
            });
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'filteredPeople' implicitly has an 'any[]... Remove this comment to see the full error message
            return filteredPeople;
        }
    }
})();

(function () {
    angular
        .module('ETWServices')
        .factory('ResourcesService', ['$cacheFactory', '$http', '$window', 'AuthenticationService', 'ETWServicesUtils', ResourcesServiceFactory]);
    function ResourcesServiceFactory($cacheFactory, $http, $window, AuthenticationService, ETWServicesUtils) {
        var service = {
            getAllClient: getAllClient,
            getFileRedirect: getFileRedirect,
            getFileUrl: getFileUrl,
            getGlobal: getGlobal,
        };
        var serviceUrl = ETWServicesUtils.getEndpointUrl('RESOURCES');
        var fileUrl = ETWServicesUtils.getEndpointUrl('FILE');
        var fileRedirectUrl = ETWServicesUtils.getEndpointUrl('FILES');
        return service;
        function getAllClient() {
            return $http({
                errorMessage: 'There was a problem retrieving client resources.',
                method: 'GET',
                url: serviceUrl + '/clients/' + AuthenticationService.getAccount().clientIdNum,
                cache: true,
            });
        }
        function getFileUrl(id) {
            return $http({
                errorMessage: 'Could not retrieve attached files.',
                method: 'GET',
                url: fileUrl + '/' + ETWServicesUtils.asId(id),
            }).then(function (response) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'excludedPlanId' implicitly has an 'any'... Remove this comment to see the full error message
                return response;
            });
        }
        function getFileRedirect(id) {
            // @ts-ignore
            var rawResponse = function (value) {
                return value;
            };
            console.log(id);
            return $http({
                errorMessage: 'Could not retrieve attached files.',
                method: 'GET',
                transformResponse: rawResponse,
                url: serviceUrl + '/' + id + '/file/' + id,
            }).then(function (resp) {
                //location.assign(resp.data);
                console.log(resp);
                $window.open(resp.data, "_blank");
            });
        }
        function getGlobal() {
            return $http({
                errorMessage: 'There was a problem retrieving global resources.',
                method: 'GET',
                url: serviceUrl + '/global',
            });
        }
    }
})();

(function () {
    angular
        .module('ETWServices')
        .factory('ResponsibilitiesService', ['$cacheFactory', '$http', 'ETWServicesUtils', ResponsibilitiesServiceFactory]);
    function ResponsibilitiesServiceFactory($cacheFactory, $http, ETWServicesUtils) {
        /**
         * @property modelDefinition
         * @type {Object}
         * Configuration object used by ETWServicesUtils for formatting certain columns
         */
        var modelDefinition = {};
        var service = {
            assignTo: assignTo,
            deleteLesson: deleteLesson,
            destroy: destroy,
            getForRole: getForRole,
            getNew: getNew,
            getAll: getAll,
            reject: ETWServicesUtils.reject,
            resolve: ETWServicesUtils.resolve,
            save: save,
            saveLesson: saveLesson,
            search: search,
            subscribe: ETWServicesUtils.subscribe('ResponsibilityService'),
            unassignFrom: unassignFrom,
            unsubscribeAll: ETWServicesUtils.unsubscribeAll('ResponsibilityService'),
            updateRoleSort: updateRoleSort,
        };
        /**
         * @property serviceUrl
         * @type {string}
         * @private
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('RESPONSIBILITIES');
        var roleServiceUrl = ETWServicesUtils.getEndpointUrl('ROLES');
        /**
         * @function getAll.clear
         * @private
         * Clears the cache for the getAll() results.
         * Call this in any methods that change the list of roles.
         */
        getAll.clear = function clearCacheForGetAll() {
            $cacheFactory.get('$http').remove(serviceUrl);
        };
        return service;
        /**
         * @method assignTo
         * @param type {string} - Model type to assign to
         * @param {...*} n - other parameters specific to the type
         * @returns {object} - promise
         * Used to assign responsibilities to various models
         * Usage:
         *   RolesResponsibilityService.assignTo('Person', 1, 2)
         */
        function assignTo(type, n) {
            var args = _.tail(arguments), promise;
            switch (type) {
                case 'Role':
                    promise = assignToRole.apply(service, args);
                    // @ts-ignore ts-migrate(2345) FIXME: Argument of type 'any[]' is not assignable to para... Remove this comment to see the full error message
                    break;
            }
            return promise;
        }
        /**
         * @method assignToRole
         * @param roleId {number}
         * @param responsibilityId {number}
         * @returns {object} - promise
         * @private
         * Assigns a responsibility a role. See assignTo()
         */
        function assignToRole(roleId, responsibilityId) {
            return $http({
                errorMessage: 'Could not assign the role to this person.',
                method: 'POST',
                data: { empty: 'post' },
                url: serviceUrl +
                    '/' +
                    ETWServicesUtils.asId(responsibilityId) +
                    '/roles/' +
                    ETWServicesUtils.asId(roleId),
            }).finally(function () {
                try {
                    //getById.clear(roleId);
                    ETWServicesUtils.notify('ResponsibilityService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        function updateRoleSort(roleId, responsibilityId, sortId) {
            return $http({
                errorMessage: 'Could not update sorting on this responsibility.',
                method: 'PATCH',
                data: { sortId: sortId },
                url: serviceUrl +
                    '/' +
                    ETWServicesUtils.asId(responsibilityId) +
                    '/roles/' +
                    ETWServicesUtils.asId(roleId),
            }).finally(function () {
                try {
                    //getById.clear(roleId);
                    ETWServicesUtils.notify('ResponsibilityService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method destroy
         * @param id {number}
         * (delete is a reserved word.)
         */
        function destroy(id) {
            return $http({
                errorMessage: 'This role could not be deleted.',
                method: 'DELETE',
                url: serviceUrl + '/' + ETWServicesUtils.asId(id),
            }).finally(function () {
                try {
                    getAll.clear();
                    ETWServicesUtils.notify('ResponsibilityService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        function generateServiceUrl(responsibilityId) {
            var url = serviceUrl;
            if (angular.isDefined(responsibilityId)) {
                url += '/' + ETWServicesUtils.asId(responsibilityId);
            }
            return url;
        }
        function generateRoleResponsibilityUrl(roleId) {
            var url = roleServiceUrl;
            if (angular.isDefined(roleId)) {
                url += '/' + ETWServicesUtils.asId(roleId) + '/responsibilities';
            }
            return url;
        }
        /**
         * @method getAll
         * @param [isShowHidden] {boolean}
         * @returns {object} - promise, array
         * Get all roles
         */
        function getAll(isShowHidden) {
            return $http({
                errorMessage: 'There was a problem retrieving responsibilities.',
                method: 'GET',
                url: serviceUrl,
                cache: true,
            });
        }
        function getNew(options) {
            _.defaults(options = {
                // @ts-ignore
                id: _.uniqueId(115464215),
                description: '',
                // @ts-ignore ts-migrate(2345) FIXME: Argument of type '115464215' is not assignable to ... Remove this comment to see the full error message
                isTemporary: true,
                title: '',
            });
            return ETWServicesUtils.resolve({ data: options, });
        }
        function save(responsibility, responsibilityId, changedProperties) {
            var options = {
                data: responsibility,
                errorMessage: 'This responsibility could not be saved.',
                idName: 'id',
                properties: changedProperties,
                // @ts-ignore
                url: generateServiceUrl(),
            };
            // @ts-ignore ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
            if (angular.isDefined(responsibility.id)) {
                options.url = generateServiceUrl(responsibility.id);
            }
            return ETWServicesUtils.save(options, undefined);
        }
        function saveLesson(responsibility, lesson) {
            var options = {
                data: lesson,
                errorMessage: 'This lesson could not be saved.',
                idName: 'id',
                url: generateServiceUrl(responsibility.id) + '/lessons',
            };
            if (angular.isDefined(lesson.id)) {
                options.url += '/' + lesson.id;
            }
            return ETWServicesUtils.save(options, undefined);
        }
        function deleteLesson(responsibility, lesson) {
            var options = {
                errorMessage: 'This lesson could not be removed.',
                idName: 'id',
                url: generateServiceUrl(responsibility.id) + '/lessons',
            };
            if (angular.isDefined(lesson.id)) {
                options.url += '/' + lesson.id;
            }
            return ETWServicesUtils.destroy(options, undefined);
        }
        /**
         * @method search
         * @param query {string}
         * @param general {int} - 1: general, 0: specific
         * @returns {object} - promise, array
         * Standard search method. All searchable services should have this method, accept a string, return an array.
         */
        function search(query, general) {
            return $http({
                method: 'GET',
                // @ts-ignore
                url: generateServiceUrl(),
                params: {
                    query: query,
                    general: general,
                    // @ts-ignore ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
                },
            });
        }
        function getForRole(roleId) {
            return $http({
                method: 'GET',
                url: generateRoleResponsibilityUrl(roleId),
            });
        }
        /**
         * @method unassignFrom
         * @param type {string}
         * @param {...*} n - other parameters specific to the type
         * Used to remove an PermissionGroup from something.
         * See assignTo()
         */
        function unassignFrom(type, n) {
            var args = _.tail(arguments);
            switch (type) {
                case 'Role':
                    unassignFromRole.apply(service, args);
                    break;
            }
        }
        function unassignFromRole(roleId, responsibilityId) {
            // @ts-ignore ts-migrate(2345) FIXME: Argument of type 'any[]' is not assignable to para... Remove this comment to see the full error message
            return $http({
                errorMessage: 'Could not remove the role from this person.',
                method: 'DELETE',
                url: serviceUrl +
                    '/' +
                    ETWServicesUtils.asId(responsibilityId) +
                    '/roles/' +
                    ETWServicesUtils.asId(roleId),
            }).finally(function () {
                try {
                    //getById.clear(roleId);
                    //ETWServicesUtils.notify('RolesService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @function serviceExceptionHandler
         * @param response {object}
         * @returns {object} - promise. Passes along another rejection with the response so the controller can act on it.
         * @private
         * When the API returns an error message, display to the user and pray that it's understandable by humans.
         */
        function serviceExceptionHandler(response, defaultResponse) {
            var message = angular.isString(response.data.error) ? response.data.error : defaultResponse;
            ETWServicesUtils.notifyErrorMessage(message);
            return ETWServicesUtils.reject(response);
        }
    }
})();

(function () {
    angular
        .module('ETWServices')
        .factory('RolesService', ['$cacheFactory', '$http', 'ETWServicesUtils', RolesServiceFactory]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$cacheFactory' implicitly has an 'any' ... Remove this comment to see the full error message
    function RolesServiceFactory($cacheFactory, $http, ETWServicesUtils) {
        /**
         * @property modelDefinition
         * @type {Object}
         * Configuration object used by ETWServicesUtils for formatting certain columns
         */
        var modelDefinition = {
            columns: {
                evaluationStartDate: 'date',
            },
        };
        var service = {
            assignTo: assignTo,
            attachmentDestroy: attachmentDestroy,
            attachmentSave: attachmentSave,
            attachmentUpload: attachmentUpload,
            clone: clone,
            destroy: destroy,
            getAll: getAll,
            getById: getById,
            getBasicById: getBasicById,
            reject: ETWServicesUtils.reject,
            resolve: ETWServicesUtils.resolve,
            save: save,
            search: search,
            subscribe: ETWServicesUtils.subscribe('RolesService'),
            unassignFrom: unassignFrom,
            unsubscribeAll: ETWServicesUtils.unsubscribeAll('RolesService'),
        };
        /**
         * @property serviceUrl
         * @type {string}
         * @private
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('ROLES');
        /**
         * @function getAll.clear
         * @private
         * Clears the cache for the getAll() results.
         * Call this in any methods that change the list of roles.
         */
        getAll.clear = function clearCacheForGetAll() {
            $cacheFactory.get('$http').remove(serviceUrl);
            $cacheFactory.get('$http').remove(serviceUrl + '?includeHidden=true');
        };
        /**
         * @function getById.clear
         * @private
         * Clears the cache for the getById() results.
         * Call this in any methods that change a role.
         * Also clears cache for getAll
         */
        getById.clear = function clearCacheForGetById(id) {
            if (id) {
                $cacheFactory.get('$http').remove(serviceUrl + '/' + ETWServicesUtils.asId(id));
            }
            getAll.clear();
        };
        return service;
        /**
         * @method assignTo
         * @param type {string} - Model type to assign to
         * @param {...*} n - other parameters specific to the type
         * @returns {object} - promise
         * Used to assign roles to various models
         * Usage:
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
         *   RolesService.assignTo('Person', 1, 2)
         */
        function assignTo(type, n) {
            var args = _.tail(arguments), promise;
            switch (type) {
                case 'Person':
                    promise = assignToPerson.apply(service, args);
                    break;
            }
            return promise;
        }
        /**
         * @method assignToPerson
         * @param personId {number}
         * @param roleId {number}
         * @returns {object} - promise
         * @private
         * Assigns a role to a person. See assignTo()
         */
        function assignToPerson(personId, roleId) {
            return $http({
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
                errorMessage: 'Could not assign the role to this person.',
                method: 'POST',
                data: { empty: 'post' },
                url: serviceUrl +
                    '/' +
                    ETWServicesUtils.asId(roleId) +
                    '/users/' +
                    // @ts-ignore ts-migrate(2345) FIXME: Argument of type 'any[]' is not assignable to para... Remove this comment to see the full error message
                    ETWServicesUtils.asId(personId),
            }).finally(function () {
                try {
                    getById.clear(roleId);
                    ETWServicesUtils.notify('RolesService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method attachmentDestroy
         * @param roleId {number}
         * @returns {Function}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'personId' implicitly has an 'any' type.
         * Curries the roleId in the standard destroy method. Controllers can then just pass type and attachment.
         */
        function attachmentDestroy(roleId) {
            return function (type, attachment) {
                var baseUrl = serviceUrl + '/' + ETWServicesUtils.asId(roleId);
                getById.clear(roleId);
                return ETWServicesUtils.attachmentDestroy(type, baseUrl, attachment).finally(function attachmentSaveFinal() {
                    try {
                        ETWServicesUtils.notify('RolesService');
                    }
                    catch (e) {
                        console.error(e);
                    }
                });
            };
        }
        /**
         * @method attachmentSave
         * @param roleId {number}
         * @returns {Function}
         * Curries the roleId in the standard upload method. Controllers can then just pass type and attachment.
         */
        function attachmentSave(roleId) {
            return function (type, attachment, isAdminEntity) {
                var baseUrl = serviceUrl + '/' + ETWServicesUtils.asId(roleId);
                getById.clear(roleId);
                return ETWServicesUtils.attachmentSave(type, baseUrl, attachment, isAdminEntity).finally(
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'roleId' implicitly has an 'any' type.
                function attachmentSaveFinal() {
                    try {
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
                        ETWServicesUtils.notify('RolesService');
                    }
                    catch (e) {
                        console.error(e);
                    }
                });
            };
        }
        /**
         * @method attachmentUpload
         * @param roleId {number}
         * @returns {Function}
         * Curries the roleId in the standard upload method. Controllers can then just pass type and attachment.
         */
        function attachmentUpload(roleId) {
            return function (type, attachment, isAdminEntity) {
                var baseUrl = serviceUrl + '/' + ETWServicesUtils.asId(roleId), baseDownloadUrl = serviceUrl + '/' + ETWServicesUtils.asId(roleId);
                getById.clear(roleId);
                return ETWServicesUtils.attachmentUpload(baseUrl, attachment, isAdminEntity, baseDownloadUrl).finally(function attachmentSaveFinal() {
                    try {
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'roleId' implicitly has an 'any' type.
                        ETWServicesUtils.notify('RolesService');
                    }
                    catch (e) {
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
                        console.error(e);
                    }
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'isAdminEntity' implicitly has an 'any' ... Remove this comment to see the full error message
                });
            };
        }
        /**
         * @method clone
         * @param sourceId {number}
         * @returns {object} - promise, object
         */
        function clone(sourceId) {
            var options = {
                data: {},
                errorMessage: 'There was a problem cloning this role.',
                idName: 'id',
                url: serviceUrl + '?sourceRoleId=' + ETWServicesUtils.asId(sourceId),
            };
            return ETWServicesUtils.save(options, modelDefinition, 'RolesService', getAll.clear);
        }
        /**
         * @method destroy
         * @param id {number}
         * (delete is a reserved word.)
         */
        function destroy(id) {
            return $http({
                errorMessage: 'This role could not be deleted.',
                method: 'DELETE',
                url: serviceUrl + '/' + ETWServicesUtils.asId(id),
            }).finally(function () {
                try {
                    getAll.clear();
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'roleId' implicitly has an 'any' type.
                    ETWServicesUtils.notify('RolesService');
                }
                catch (e) {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
                    console.error(e);
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'attachment' implicitly has an 'any' typ... Remove this comment to see the full error message
                }
            });
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'isAdminEntity' implicitly has an 'any' ... Remove this comment to see the full error message
        }
        /**
         * @method getAll
         * @param [isShowHidden] {boolean}
         * @returns {object} - promise, array
         * Get all roles
         */
        function getAll(isShowHidden) {
            var params = {};
            // @ts-ignore
            params.includeHidden = !!isShowHidden;
            return $http({
                errorMessage: 'There was a problem retrieving roles.',
                method: 'GET',
                params: params,
                url: serviceUrl,
                cache: true,
            }).then(ETWServicesUtils.decodeResponse(modelDefinition), ETWServicesUtils.reject);
        }
        /**
         * @method getById
         * @param id {string}
         * @returns {object} - promise, object
         * Get a specific role's details
         */
        function getById(id) {
            return $http({
                errorMessage: 'There was a problem retrieving this role.',
                method: 'GET',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'sourceId' implicitly has an 'any' type.
                url: serviceUrl + '/' + ETWServicesUtils.asId(id) + '?details=true',
            })
                .then(ETWServicesUtils.decodeResponse(modelDefinition))
                .then(function (response) {
                _.forEach(response.data.s3Resources, function (file) {
                    file.downloadUrl = file.downloadUrl =
                        serviceUrl + '/' + ETWServicesUtils.asId(id) + '/file/' + file.id;
                });
                return response;
            }, service.reject);
        }
        /**
         * @method getBasicById
         * @param id {string}
         * @returns {object} - promise, object
         * Get basic info for a specific role
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
        function getBasicById(id) {
            return $http({
                errorMessage: 'There was a problem retrieving this role.',
                method: 'GET',
                url: serviceUrl + '/' + ETWServicesUtils.asId(id),
            }).then(ETWServicesUtils.decodeResponse(modelDefinition), ETWServicesUtils.reject);
        }
        /**
         * @method save
         * @param role {object}
         * @param changedProperties {array} - optional. For partial updates
         * @returns {object} - promise, role
         * Create/update/patch a role
         */
        function save(role, changedProperties) {
            var options = {
                data: role,
                errorMessage: false,
                idName: 'id',
                properties: changedProperties,
                url: serviceUrl,
            }, 
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'isShowHidden' implicitly has an 'any' t... Remove this comment to see the full error message
            promise;
            if (role.id) {
                options.url = serviceUrl + '/' + ETWServicesUtils.asId(role.id);
            }
            if (!role.id && !role.title) {
                // Role doesn't exist AND title is empty
                // Since title must be unique, compare it with existing columnName from getAll()
                getAll.clear();
                promise = ETWServicesUtils.generateUniqueValueForColumn(getAll, 'title', 'Untitled Role').then(function (uniqueValue) {
                    // Then save resulting uniqueValue as the new columnName
                    options.data.title = uniqueValue;
                    return ETWServicesUtils.save(options, modelDefinition, 'RolesService', function () {
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
                        getById.clear(role.id);
                    });
                });
            }
            else {
                // Role exists OR title not empty
                promise = ETWServicesUtils.save(options, modelDefinition, 'RolesService', function () {
                    // Clear the cache (before subscribers are notified)
                    if (role.id) {
                        getById.clear(role.id);
                    }
                    else {
                        getAll.clear();
                    }
                });
            }
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            // return promise with catch
            return promise.catch(function (response) {
                return serviceExceptionHandler(response, 'This role could not be saved.');
            });
        }
        /**
         * @method search
         * @param query {string}
         * @returns {object} - promise, array
         * Standard search method. All searchable services should have this method, accept a string, return an array.
         */
        function search(query) {
            query = String(query).toLowerCase();
            return $http({
                method: 'GET',
                url: serviceUrl,
                params: {
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
                    includeHidden: true,
                    title: query,
                    description: query,
                    outline: query,
                },
            }).then(function searchGetAll(response) {
                // TODO: Until search API filters,
                _.remove(response.data, function (row) {
                    return (
                    // @ts-ignore
                    String(row.title)
                        .toLowerCase()
                        .indexOf(query) +
                        // @ts-ignore
                        String(row.description)
                            .toLowerCase()
                            .indexOf(query) +
                        // @ts-ignore
                        String(row.outline)
                            .toLowerCase()
                            .indexOf(query) ===
                        -3);
                });
                return response;
            }, ETWServicesUtils.reject);
        }
        /**
         * @method unassignFrom
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'role' implicitly has an 'any' type.
         * @param type {string}
         * @param {...*} n - other parameters specific to the type
         * Used to remove a Role from something.
         * See assignTo()
         */
        function unassignFrom(type, n) {
            var args = _.tail(arguments);
            switch (type) {
                case 'Person':
                    unassignFromPerson.apply(service, args);
                    break;
            }
        }
        /**
         * @function unassignFromPerson
         * @param personId {number}
         * @param roleId {number}
         * @returns {object} - promise
         * @private
         * Remove an Role from a Person.
         */
        function unassignFromPerson(personId, roleId) {
            return $http({
                errorMessage: 'Could not remove the role from this person.',
                method: 'DELETE',
                url: serviceUrl +
                    '/' +
                    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'uniqueValue' implicitly has an 'any' ty... Remove this comment to see the full error message
                    ETWServicesUtils.asId(roleId) +
                    '/users/' +
                    ETWServicesUtils.asId(personId),
            }).finally(function () {
                try {
                    getById.clear(roleId);
                    ETWServicesUtils.notify('RolesService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @function serviceExceptionHandler
         * @param response {object}
         * @returns {object} - promise. Passes along another rejection with the response so the controller can act on it.
         * @private
         * When the API returns an error message, display to the user and pray that it's understandable by humans.
         */
        function serviceExceptionHandler(response, defaultResponse) {
            var message = angular.isString(response.data.error) ? response.data.error : defaultResponse;
            ETWServicesUtils.notifyErrorMessage(message);
            return ETWServicesUtils.reject(response);
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.

(function () {
    angular
        .module('ETWServices')
        .factory('ScoresService', ['$http', 'ETWServicesUtils', ScoresServiceFactory]);
    /**
     * @factory ScoresService
     * @constructor
     * Scores are currently retrieved through the past evaluations:
     * /score/v1/evaluations/1/pastgoalscores
     */
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
    function ScoresServiceFactory($http, ETWServicesUtils) {
        var serviceUrl = ETWServicesUtils.getEndpointUrl('EVALUATION_SCORES');
        var service = {
            all: ETWServicesUtils.all,
            getAllForEvaluation: getAllForEvaluation,
            reject: ETWServicesUtils.reject,
            resolve: ETWServicesUtils.resolve,
            save: save,
            subscribe: ETWServicesUtils.subscribe('ScoresService'),
            unsubscribeAll: ETWServicesUtils.unsubscribeAll('ScoresService'),
            updateScore: updateScore,
        };
        return service;
        /**
         * @method getAllForEvaluation
         * @param evaluationId {number}
         * @param isCompleted {boolean}
         * @returns {object} - promise, Object
         * Note: These goalScores are grouped by goal type
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'evaluationId' implicitly has an 'any' t... Remove this comment to see the full error message
        function getAllForEvaluation(evaluationId, isCompleted) {
            var scoresPath = isCompleted ? '/pastgoalscores' : '/goalscores';
            return $http({
                errorMessage: 'The scores for this goal could not be retrieved.',
                method: 'GET',
                url: serviceUrl + '/' + ETWServicesUtils.asId(evaluationId) + scoresPath,
            }).then(isCompleted ? groupCompletedGoalScoresByType : groupGoalScoresByType, ETWServicesUtils.reject);
        }
        /**
         * @function groupCompletedGoalScoresByType
         * @param response {object} - http response
         * @returns {object} - http response
         * Groups goal scores by goal type. See getAllForEvaluation()
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
        function groupCompletedGoalScoresByType(response) {
            var sortedGoalsScores = _.groupBy(response.data, function (gs) {
                var group;
                if (['PLAN', 'PERSONAL', 'MANAGER_ASSIGNED'].indexOf(gs.goalType) !== -1) {
                    group = 'Performance';
                }
                else {
                    group = _.startCase(String(gs.goalType).toLowerCase());
                }
                return group;
            });
            response.data = {
                Performance: sortGoals(sortedGoalsScores.Performance),
                Role: sortGoals(sortedGoalsScores.Role),
                Leadership: sortGoals(sortedGoalsScores.Leadership),
                Culture: sortGoals(sortedGoalsScores.Culture),
            };
            return response;
        }
        /**
         * @function groupGoalScoresByType
         * @param response {object} - http response
         * @returns {object} - http response
         * @private
         * Groups goal scores by goal type. See getAllForEvaluation()
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
        function groupGoalScoresByType(response) {
            var sortedGoalScores = _.groupBy(response.data, function (gs) {
                var group;
                if (gs.goal.performanceGoalType) {
                    if (['PLAN', 'PERSONAL', 'MANAGER_ASSIGNED'].indexOf(gs.goal.performanceGoalType) !== -1) {
                        group = 'Performance';
                    }
                    else {
                        group = gs.goal.performanceGoalType;
                    }
                }
                else {
                    group = gs.goal.alignmentGoalType;
                }
                return _.startCase(String(group).toLowerCase());
            });
            response.data = {
                Performance: sortGoals(sortedGoalScores.Performance),
                Role: sortGoals(sortedGoalScores.Role),
                Leadership: sortGoals(sortedGoalScores.Leadership),
                Culture: sortGoals(sortedGoalScores.Culture),
            };
            return response;
        }
        /**
         * @method save
         * @param score {object}
         * @param [changedProperties] {Array}
         * @param evaluationId {number}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'score' implicitly has an 'any' type.
        function save(score, changedProperties, evaluationId) {
            var options = {
                data: score,
                errorMessage: 'This score could not be saved.',
                idName: 'id',
                properties: changedProperties,
                url: serviceUrl + '/' + ETWServicesUtils.asId(evaluationId) + '/scores',
            };
            if (score.id) {
                options.url += '/' + ETWServicesUtils.asId(score.id);
            }
            return ETWServicesUtils.save(options, undefined, 'ScoresService');
        }
        /**
         * @function sortGoals
         * @param goals {Array} - Array of Scores
         * @return {Array}
         * @private
         * Sort an array of GoalScores
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'goals' implicitly has an 'any' type.
        function sortGoals(goals) {
            return _(goals || [])
                .compact()
                .sortBy(sortGoalsIterator)
                .value();
        }
        /**
         * @function sortGoalsIterator
         * @param score {object} - Score (completed) or Goal Score (incomplete)
         * @returns {string}
         * @private
         * Used by _.sortBy to do a case insensitive sort of goal titles for scores.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'score' implicitly has an 'any' type.
        function sortGoalsIterator(score) {
            var title = (score.goal && score.goal.title) || score.goalTitle;
            return title && String(title).toLowerCase();
        }
        /**
         * @method updateScore
         * @param score {object}
         * @param evaluationId {number}
         * @returns {object} - promise, object
         * Method updates goal score in an evaluation
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'score' implicitly has an 'any' type.
        function updateScore(score, evaluationId) {
            var completedScoresUrl = ETWServicesUtils.getEndpointUrl('EVALUATION_COMPLETED_SCORES');
            return $http({
                data: score,
                errorMessage: 'This goal score could not be updated.',
                method: 'PATCH',
                url: completedScoresUrl +
                    '/' +
                    ETWServicesUtils.asId(evaluationId) +
                    '/scores/' +
                    ETWServicesUtils.asId(score.id),
            });
        }
    }
})();

(function () {
    angular
        .module('ETWServices')
        .factory('StrategiesService', ['$http', 'ETWServicesUtils', StrategiesServiceFactory]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
    function StrategiesServiceFactory($http, ETWServicesUtils) {
        var service = {
            destroy: destroy,
            getAllByPlanId: getAllByPlanId,
            getById: getById,
            reject: ETWServicesUtils.reject,
            resolve: ETWServicesUtils.resolve,
            saveForPlan: saveForPlan,
            subscribe: ETWServicesUtils.subscribe('StrategiesService'),
            unsubscribeAll: ETWServicesUtils.unsubscribeAll('StrategiesService'),
        };
        /**
         * @property plansServiceUrl
         * @type {string}
         */
        var plansServiceUrl = ETWServicesUtils.getEndpointUrl('STRATEGY_PLANS');
        /**
         * @property serviceUrl
         * @type {string}
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('STRATEGIES');
        return service;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'strategyId' implicitly has an 'any' typ... Remove this comment to see the full error message
        function destroy(strategyId) {
            console.error('DESTROY METHOD HAS NOT BEEN IMPLEMENTED');
            return service.reject('Destroy method has not been implemented.');
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
        function getAllByPlanId(planId) {
            return $http({
                errorMessage: 'Strategies for this plan could not be retrieved.',
                method: 'GET',
                url: plansServiceUrl + '/' + ETWServicesUtils.asId(planId) + '/strategies',
            });
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
        function getById(id) {
            return $http({
                errorMessage: 'The strategy could not be retrieved.',
                method: 'GET',
                url: serviceUrl + '/' + ETWServicesUtils.asId(id),
            });
        }
        /**
         * @method saveForPlan
         * @param planId {number}
         * @param strategy {object}
         * @param [changedProperties] {array} - optional. For partial updates
         * @returns {object} - promise, Strategy
         * Create/update/patch a strategy
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
        function saveForPlan(planId, strategy, changedProperties) {
            var options = {
                data: strategy,
                errorMessage: 'This strategy could not be saved.',
                idName: 'id',
                properties: changedProperties,
                url: plansServiceUrl + '/' + ETWServicesUtils.asId(planId) + '/strategies',
            };
            if (angular.isDefined(strategy.id)) {
                options.url =
                    plansServiceUrl +
                        '/' +
                        ETWServicesUtils.asId(planId) +
                        '/strategies/' +
                        ETWServicesUtils.asId(strategy.id);
            }
            return ETWServicesUtils.save(options, undefined, 'StrategiesService');
        }
    }
})();

(function () {
    angular.module('ETWServices').factory('StrategyElementsService', [
        '$http',
        'ETWServicesUtils',
        // TODO: Temporary?
        'StrategiesService',
        StrategyElementsServiceFactory,
    ]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
    function StrategyElementsServiceFactory($http, ETWServicesUtils, StrategiesService) {
        var service = {
            destroy: destroy,
            getAllStrategies: getAllStrategies,
            reject: ETWServicesUtils.reject,
            remove: remove,
            resolve: ETWServicesUtils.resolve,
            save: save,
            saveForStrategy: saveForStrategy,
            search: search,
            subscribe: ETWServicesUtils.subscribe('StrategyElementsService'),
            unsubscribeAll: ETWServicesUtils.unsubscribeAll('StrategyElementsService'),
            update: update,
        };
        /**
         * @property serviceUrl
         * @type {string}
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('STRATEGY_ELEMENTS');
        /**
         * @property serviceUrl
         * @type {string}
         */
        var strategyServiceUrl = ETWServicesUtils.getEndpointUrl('STRATEGIES');
        return service;
        //////////////// FUNCTIONS ////////////////
        //removes a stratefy element from the service
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'strat' implicitly has an 'any' type.
        function remove(strat) {
            var options = {
                errorMessage: 'Could not remove strategy',
                method: 'DELETE',
                url: serviceUrl + '/' + ETWServicesUtils.asId(strat.id),
            };
            return ETWServicesUtils.save(options, undefined, 'StrategyElementsService');
        }
        //returns all the strategies for a given plan
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
        function getAllStrategies(planId) {
            return $http({
                errorMessage: 'Could not retrieve strategies.',
                method: 'GET',
                url: strategyServiceUrl + '/' + ETWServicesUtils.asId(planId) + '/strategies',
            });
        }
        //save a strategy element
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
        function save(planId, strat) {
            var options = {
                data: strat,
                errorMessage: 'Could not add this strategy.',
                url: strategyServiceUrl + '/' + ETWServicesUtils.asId(planId) + '/strategies',
            };
            return ETWServicesUtils.save(options, undefined, 'StrategyElementsService');
        }
        //update a strategy element
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
        function update(planId, strat) {
            var options = {
                errorMessage: 'Could not update strategy',
                method: 'PATCH',
                data: strat,
                url: serviceUrl + '/' + ETWServicesUtils.asId(strat.id),
            };
            return ETWServicesUtils.save(options, undefined, 'StrategyElementsService');
        }
        /**
         * @method destroy
         * @param strategyId {number}
         * @returns {object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'strategyId' implicitly has an 'any' typ... Remove this comment to see the full error message
        function destroy(strategyId) {
            console.error('DESTROY METHOD HAS NOT BEEN IMPLEMENTED');
            return service.reject('Destroy method has not been implemented.');
        }
        /**
         * @method saveForStrategy
         * @param strategyId {number}
         * @param strategyElement {object}
         * @param [changedProperties] {array} - optional. For partial updates
         * @returns {object} - promise, Strategy
         * Create/update/patch a strategy element
         */
        /** possibly @deprecated */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'strategyId' implicitly has an 'any' typ... Remove this comment to see the full error message
        function saveForStrategy(strategyId, strategyElement, changedProperties) {
            var options = {
                data: strategyElement,
                errorMessage: 'This strategy could not be saved.',
                idName: 'id',
                properties: changedProperties,
                url: strategyServiceUrl + '/' + strategyId + '/strategyelements',
            };
            if (angular.isDefined(strategyElement.id)) {
                if (angular.isDefined(strategyElement.parentElement)) {
                    options.url =
                        serviceUrl +
                            '/' +
                            strategyElement.parentElement +
                            '/subelements/' +
                            ETWServicesUtils.asId(strategyElement.id);
                }
                else {
                    options.url =
                        strategyServiceUrl +
                            '/' +
                            strategyId +
                            '/strategyelements/' +
                            ETWServicesUtils.asId(strategyElement.id);
                }
            }
            return ETWServicesUtils.save(options, undefined, 'StrategyElementsService');
        }
        /**
         * @method search
         * @param planId {number}
         * @param query {string}
         * @returns {object} - promise, Array
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'planId' implicitly has an 'any' type.
        function search(planId, query) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            return StrategiesService.getAllByPlanId(planId).then(function getAllSuccess(response) {
                // @ts-ignore ts-migrate(7034) FIXME: Variable 'elements' implicitly has type 'any[]' in... Remove this comment to see the full error message
                var elements = [];
                // Combine all the matching elements from one or more strategies
                _.map(response.data, function (strategy) {
                    _.map(strategy.strategyElements, function (element) {
                        if (element.title.toLowerCase().indexOf(query.toLowerCase()) !== -1) {
                            elements.push(element);
                        }
                    });
                });
                // @ts-ignore ts-migrate(7005) FIXME: Variable 'elements' implicitly has an 'any[]' type... Remove this comment to see the full error message
                response.data = elements;
                return response;
            });
        }
    }
})();

(function () {
    angular
        .module('ETWServices')
        .factory('TeamsService', ['$cacheFactory', '$http', 'ETWServicesUtils', TeamsServiceFactory]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$cacheFactory' implicitly has an 'any' ... Remove this comment to see the full error message
    function TeamsServiceFactory($cacheFactory, $http, ETWServicesUtils) {
        /**
         * @property serviceUrl
         * @type {string}
         * @private
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('TEAMS');
        /**
         * @property usersTeamServiceUrl
         * @type {string}
         */
        var usersTeamServiceUrl = ETWServicesUtils.getEndpointUrl('USERS_TEAM');
        var service = {
            addPerson: addPerson,
            all: ETWServicesUtils.all,
            attachmentDestroy: attachmentDestroy,
            attachmentSave: attachmentSave,
            attachmentUpload: attachmentUpload,
            destroy: destroy,
            getAll: getAll,
            getById: getById,
            getFiles: getFiles,
            getManagedTeams: getManagedTeams,
            getNew: getNew,
            getTeam: getTeam,
            getTeamMembers: getTeamMembers,
            reject: ETWServicesUtils.reject,
            removePerson: removePerson,
            resolve: ETWServicesUtils.resolve,
            save: save,
            subscribe: ETWServicesUtils.subscribe('TeamsService'),
            unsubscribe: ETWServicesUtils.unsubscribe('TeamsService'),
        };
        /**
         * @function getAll.clear
         * @private
         * Clears the cache for the getAll() results.
         * All methods that modify Teams must call this method.
         */
        getAll.clear = function () {
            $cacheFactory.get('$http').remove(serviceUrl);
        };
        /**
         * @function getById.clear
         * @param id {number}
         * Clears the cache for getById(id) then calls getAll.clear()
         */
        getById.clear = function (id) {
            $cacheFactory.get('$http').remove(serviceUrl + '/' + ETWServicesUtils.asId(id));
            getAll.clear();
        };
        /**
         * @function getManagedTeams.clear
         * @param leadPersonId {number}
         * Clears the cache of managed teams for a team lead
         */
        getManagedTeams.clear = function (leadPersonId) {
            $cacheFactory
                .get('$http')
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
                .remove(usersTeamServiceUrl + '/' + ETWServicesUtils.asId(leadPersonId) + '/teams');
        };
        getTeam.clear = function (userId) {
            $cacheFactory
                .get('$http')
                .remove(usersTeamServiceUrl + '/' + ETWServicesUtils.asId(userId) + '/team');
        };
        return service;
        /**
         * @method addPerson
         * @param teamId {number}
         * @param personId {number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'leadPersonId' implicitly has an 'any' t... Remove this comment to see the full error message
         * @param [leadPersonId] {number}
         * @returns {object} - promise
         */
        function addPerson(teamId, personId, leadPersonId) {
            return changePerson(teamId, personId, leadPersonId, 'POST');
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'userId' implicitly has an 'any' type.
         * @method changePerson
         * @private
         * @param teamId {number}
         * @param personId {number}
         * @param leadPersonId {number}
         * @param method {string} - [POST|DELETE]
         * @returns {object} - promise
         * Called by addMember and removeMember
         */
        function changePerson(teamId, personId, leadPersonId, method) {
            return $http({
                errorMessage: 'This member could not be ' + (method == 'POST' ? 'added' : 'removed') + '.',
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'teamId' implicitly has an 'any' type.
                method: method,
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'leadPersonId' implicitly has an 'any' t... Remove this comment to see the full error message
                url: serviceUrl +
                    '/' +
                    ETWServicesUtils.asId(teamId) +
                    '/users/' +
                    ETWServicesUtils.asId(personId),
            }).finally(function () {
                try {
                    getById.clear(teamId);
                    if (leadPersonId) {
                        getManagedTeams.clear(leadPersonId);
                    }
                    if (personId) {
                        getTeam.clear(personId);
                    }
                    ETWServicesUtils.notify('TeamsService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'teamId' implicitly has an 'any' type.
         * @method destroy
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'personId' implicitly has an 'any' type.
         * @param id {number}
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'method' implicitly has an 'any' type.
         * @param leaderId {number}
         * @returns {object} - promise
         */
        function destroy(id, leaderId) {
            return ETWServicesUtils.destroy({
                errorMessage: 'This team could not be removed.',
                url: serviceUrl + '/' + ETWServicesUtils.asId(id),
            }).finally(function () {
                try {
                    getById.clear(id);
                    getManagedTeams.clear(leaderId);
                    ETWServicesUtils.notify('TeamsService');
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
        /**
         * @method getAll
         * @returns {object} - promise, Array of Teams
         */
        function getAll() {
            return $http({
                errorMessage: 'Teams could not be retrieved.',
                method: 'GET',
                url: serviceUrl,
            });
        }
        /**
         * @method getById
         * @param id {number}
         * @returns {object} - promise, Team object
         */
        function getById(id) {
            return $http({
                cache: true,
                errorMessage: 'This team could not be retrieved.',
                method: 'GET',
                url: serviceUrl + '/' + ETWServicesUtils.asId(id),
            });
        }
        function getNew(options) {
            // TODO: is anything is required: _.defaults(options, {});
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
            return ETWServicesUtils.resolve({ data: options });
        }
        /**
         * @method getTeam
         * @returns {object} - promise, Team with Members object
         */
        function getTeam(userId) {
            return $http({
                cache: true,
                errorMessage: 'Users Team could not be retrieved.',
                method: 'GET',
                url: usersTeamServiceUrl + '/' + ETWServicesUtils.asId(userId) + '/team',
            });
        }
        /**
         * @method getManagedTeams
         * @returns {object} - promise, List of Team with Members object
         */
        function getManagedTeams(userId) {
            return $http({
                cache: true,
                errorMessage: 'Users Managed Teams could not be retrieved.',
                method: 'GET',
                url: usersTeamServiceUrl + '/' + ETWServicesUtils.asId(userId) + '/teams',
            });
        }
        /**
         * Retrieve list of users that are members of the given team.
         * @param teamId {number}
         * @param [isWithPerformance] {boolean=false}
         * @returns {object} promise
         */
        function getTeamMembers(teamId, isWithPerformance) {
            var params = {};
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
            if (isWithPerformance) {
                // @ts-ignore
                params.withGoalPerformance = true;
                // @ts-ignore
                params.includeEvalDueDate = true;
            }
            return $http({
                errorMessage: 'Team members could not be retrieved for team ' + teamId,
                method: 'GET',
                params: params,
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'options' implicitly has an 'any' type.
                url: serviceUrl + '/' + ETWServicesUtils.asId(teamId) + '/users',
            });
        }
        /**
         * @method removePerson
         * @param teamId {number}
         * @param personId {number}
         * @param [leadPersonId] {number}
         * @returns {object} - promise
         */
        function removePerson(teamId, personId, leadPersonId) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'userId' implicitly has an 'any' type.
            return changePerson(teamId, personId, leadPersonId, 'DELETE');
        }
        /**
         * @method save
         * @param team {object}
         * @param changedProperties {array} - optional. For partial updates
         * @returns {object} - promise, Team
         * Create/update/patch a team
         */
        function save(team, changedProperties) {
            var options = {
                data: team,
                errorMessage: 'This team could not be saved.',
                idName: 'id',
                properties: changedProperties,
                url: serviceUrl,
            }, 
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'userId' implicitly has an 'any' type.
            promise;
            if (angular.isDefined(team.id)) {
                options.url = serviceUrl + '/' + ETWServicesUtils.asId(team.id);
            }
            promise = ETWServicesUtils.save(options, undefined, 'TeamsService', function () {
                // Clear the cache (before subscribers are notified)
                getManagedTeams.clear(team.teamLeaderId);
                // Clear the cache for when the user is updating team name in settings screen and going back to team page.
                if (angular.isDefined(team.id)) {
                    getById.clear(team.id);
                }
            });
            return promise;
        }
        /**
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'teamId' implicitly has an 'any' type.
         * @method getFiles
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'isWithPerformance' implicitly has an 'a... Remove this comment to see the full error message
         * @param teamId {number}
         * @returns {object} - promise
         * Request the attached files on the team
         */
        function getFiles(teamId) {
            return $http({
                errorMessage: 'Could not retrieve attached files.',
                method: 'GET',
                url: serviceUrl + '/' + ETWServicesUtils.asId(teamId) + '/files',
            }).then(function (response) {
                _.forEach(response.data, function (file) {
                    file.downloadUrl = serviceUrl + '/' + ETWServicesUtils.asId(teamId) + '/file/' + file.id;
                });
                return response;
            }, service.reject);
        }
        /**
         * @method attachmentDestroy
         * @param teamId {number}
         * @returns {Function}
         * Curries the teamId in the standard destroy method. Controllers can then just pass type and attachment.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'teamId' implicitly has an 'any' type.
        function attachmentDestroy(teamId) {
            var baseUrl = serviceUrl + '/' + ETWServicesUtils.asId(teamId);
            return function (type, attachment) {
                getById.clear(teamId);
                return ETWServicesUtils.attachmentDestroy(type, baseUrl, attachment).finally(function attachmentSaveFinal() {
                    try {
                        ETWServicesUtils.notify('TeamsService');
                    }
                    catch (e) {
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'team' implicitly has an 'any' type.
                        console.error(e);
                    }
                });
            };
        }
        /**
         * @method attachmentSave
         * @param teamId {number}
         * @returns {Function}
         * Curries the teamId in the standard upload method. Controllers can then just pass type and attachment.
         */
        function attachmentSave(teamId) {
            var baseUrl = serviceUrl + '/' + ETWServicesUtils.asId(teamId);
            return function (type, attachment, isAdminEntity) {
                getById.clear(teamId);
                return ETWServicesUtils.attachmentSave(type, baseUrl, attachment, isAdminEntity).finally(function attachmentSaveFinal() {
                    try {
                        ETWServicesUtils.notify('TeamsService');
                    }
                    catch (e) {
                        console.error(e);
                    }
                });
            };
        }
        /**
         * @method attachmentUpload
         * @param teamId {number}
         * @returns {Function}
         * Curries the teamId in the standard upload method. Controllers can then just pass type and attachment.
         */
        function attachmentUpload(teamId) {
            var baseUrl = serviceUrl + '/' + ETWServicesUtils.asId(teamId), baseDownloadUrl = serviceUrl + '/' + ETWServicesUtils.asId(teamId);
            return function (type, attachment, isAdminEntity) {
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'teamId' implicitly has an 'any' type.
                getById.clear(teamId);
                return ETWServicesUtils.attachmentUpload(baseUrl, attachment, isAdminEntity, baseDownloadUrl).finally(function attachmentSaveFinal() {
                    try {
                        ETWServicesUtils.notify('TeamsService');
                        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
                    }
                    catch (e) {
                        console.error(e);
                    }
                });
            };
        }
    }
})();
// @ts-ignore ts-migrate(7006) FIXME: Parameter 'teamId' implicitly has an 'any' type.

(function () {
    angular
        .module('ETWServices')
        .factory('TopicsService', ['$http', 'ETWServicesUtils', TopicsServiceFactory]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$http' implicitly has an 'any' type.
    function TopicsServiceFactory($http, ETWServicesUtils) {
        /**
         * @property modelDefinition
         * @type {object}
         */
        var modelDefinition = {};
        var service = {
            addDiscussionComment: addDiscussionComment,
            addDiscussionCommentReply: addDiscussionCommentReply,
            attachmentDestroy: attachmentDestroy,
            attachmentSave: attachmentSave,
            attachmentUpload: attachmentUpload,
            copyAllFromInstance: copyAllFromInstance,
            destroy: destroy,
            destroyForInstance: destroyForInstance,
            destroyDiscussionPoint: destroyDiscussionPoint,
            getAllForInstance: getAllForInstance,
            getAllForSeries: getAllForSeries,
            getFiles: getFiles,
            getNew: getNew,
            getNewDiscussionPoint: getNewDiscussionPoint,
            resolve: ETWServicesUtils.resolve,
            reject: ETWServicesUtils.reject,
            save: save,
            saveDiscussionPoint: saveDiscussionPoint,
            saveNote: saveNote,
            subscribe: ETWServicesUtils.subscribe('TopicsService'),
            unsubscribe: ETWServicesUtils.unsubscribe('TopicsService'),
        };
        /**
         * @property fileServiceUrl
         * @type {string}
         */
        var fileServiceUrl = ETWServicesUtils.getEndpointUrl('TOPIC_FILES');
        /**
         * @property serviceUrl
         * @type {string}
         */
        var serviceUrl = ETWServicesUtils.getEndpointUrl('TOPICS');
        /**
         * @property serviceUrlForInstances
         * @type {string}
         */
        var serviceUrlForInstances = ETWServicesUtils.getEndpointUrl('MEETING_INSTANCES');
        /**
         * @property serviceUrlForSeries
         * @type {string}
         */
        var serviceUrlForSeries = ETWServicesUtils.getEndpointUrl('MEETING_SERIES');
        return service;
        /**
         * @method addDiscussionComment
         * @param instanceId {number}
         * @param topicId {number}
         * @param discussionId {string}
         * @param comment {string}
         * @returns {object} - promise
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'instanceId' implicitly has an 'any' typ... Remove this comment to see the full error message
        function addDiscussionComment(instanceId, topicId, discussionId, comment) {
            var promise = $http({
                method: 'POST',
                data: {
                    comment: comment,
                },
                url: serviceUrlForInstances +
                    '/' +
                    ETWServicesUtils.asId(instanceId) +
                    '/topics/' +
                    ETWServicesUtils.asId(topicId) +
                    '/discussionpoints/' +
                    discussionId +
                    '/comment',
            });
            ETWServicesUtils.showSaveStatus(promise);
            return promise;
        }
        /**
         * @method addDiscussionCommentReply
         * @param instanceId {number}
         * @param topicId {number}
         * @param discussionId {string}
         * @param commentId {string}
         * @param reply {string}
         * @returns {object} - promise
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'instanceId' implicitly has an 'any' typ... Remove this comment to see the full error message
        function addDiscussionCommentReply(instanceId, topicId, discussionId, commentId, reply) {
            var promise = $http({
                method: 'POST',
                data: {
                    comment: reply,
                },
                url: serviceUrlForInstances +
                    '/' +
                    ETWServicesUtils.asId(instanceId) +
                    '/topics/' +
                    ETWServicesUtils.asId(topicId) +
                    '/discussionpoints/' +
                    discussionId +
                    '/comments/' +
                    commentId +
                    '/reply',
            });
            ETWServicesUtils.showSaveStatus(promise);
            return promise;
        }
        /**
         * @function attachmentDestroy
         * @param topicId {number}
         * @returns {Function}
         * Returns a function that has a common signature will all services that support attachments.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'topicId' implicitly has an 'any' type.
        function attachmentDestroy(topicId) {
            var baseUrl = serviceUrl + '/' + ETWServicesUtils.asId(topicId);
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
            return function (type, attachment) {
                return ETWServicesUtils.attachmentDestroy(type, baseUrl, attachment, modelDefinition, 'TopicsService');
            };
        }
        /**
         * @function attachmentSave
         * @param topicId {number}
         * @returns {Function}
         * Returns a function with a common signature to be used by attachment directives that are service agnostic.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'topicId' implicitly has an 'any' type.
        function attachmentSave(topicId) {
            var baseUrl = serviceUrl + '/' + ETWServicesUtils.asId(topicId);
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
            return function (type, attachment, isAdminEntity) {
                return ETWServicesUtils.attachmentSave(type, baseUrl, attachment, isAdminEntity, modelDefinition, 'TopicsService');
            };
        }
        /**
         * @function attachmentUpload
         * @param topicId {number}
         * @returns {Function}
         * Returns a function for use with attachment directives.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'topicId' implicitly has an 'any' type.
        function attachmentUpload(topicId) {
            var baseUrl = serviceUrl + '/' + ETWServicesUtils.asId(topicId), baseDownloadUrl = serviceUrl + '/' + ETWServicesUtils.asId(topicId);
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
            return function (type, attachment, isAdminEntity) {
                return ETWServicesUtils.attachmentUpload(baseUrl, attachment, isAdminEntity, baseDownloadUrl, modelDefinition, 'TopicsService');
            };
        }
        /**
         * @method copyAllFromInstance
         * @param previousInstanceId {number}
         * @returns {object} - promise
         * Get the topics from an instance.
         * Remove the not-recurring topics.
         * Clear the note.
         * Set isVisible to true.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'previousInstanceId' implicitly has an '... Remove this comment to see the full error message
        function copyAllFromInstance(previousInstanceId) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            return getAllForInstance(previousInstanceId).then(function (response) {
                response.data = _.reduce(response.data, copyTopicsIteratee, []);
                return response;
            });
        }
        /**
         * @function copyTopicsIteratee
         * @param finalTopics {Array}
         * @param topic {object}
         * @returns {Array}
         * @private
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'finalTopics' implicitly has an 'any' ty... Remove this comment to see the full error message
        function copyTopicsIteratee(finalTopics, topic) {
            if (topic.state !== 1) {
                topic.isVisible = true;
                if (topic.note != null) {
                    topic.previousNote = topic.note;
                }
                topic.note = null;
                // topic.previousDiscussionPoints = [];
                if (topic.discussionPoints.length) {
                    topic.previousDiscussionPoints = topic.discussionPoints.slice();
                }
                topic.discussionPoints.length = 0;
                finalTopics.push(topic);
            }
            return finalTopics;
        }
        /**
         * @method destroy
         * @param topic {object}
         * @returns {object} - promise
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'topic' implicitly has an 'any' type.
        function destroy(topic) {
            var options = {
                errorMessage: 'This topic could not be removed.',
                url: serviceUrl + '/' + ETWServicesUtils.asId(topic.id),
            };
            return ETWServicesUtils.destroy(options, modelDefinition, 'TopicsService');
        }
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'topic' implicitly has an 'any' type.
        function destroyForInstance(instanceId, topic) {
            var options = {
                errorMessage: 'This topic could not be removed.',
                url: serviceUrlForInstances +
                    '/' +
                    ETWServicesUtils.asId(instanceId) +
                    '/topics/' +
                    ETWServicesUtils.asId(topic.id),
            };
            return ETWServicesUtils.destroy(options, modelDefinition, 'TopicsService');
        }
        /**
         * @method destroyDiscussionPoint
         * @param instanceId {number}
         * @param topicId {number}
         * @param discussionId {string}
         * @returns {object} - promise
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'instanceId' implicitly has an 'any' typ... Remove this comment to see the full error message
        function destroyDiscussionPoint(instanceId, topicId, discussionId) {
            var options = {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                },
                url: serviceUrlForInstances +
                    '/' +
                    ETWServicesUtils.asId(instanceId) +
                    '/topics/' +
                    ETWServicesUtils.asId(topicId) +
                    '/discussionpoints/' +
                    discussionId,
            };
            return ETWServicesUtils.destroy(options, modelDefinition, 'TopicsService');
        }
        /**
         * @method getAllForInstance
         * @param instanceId {number}
         * @returns {object} - promise, Array
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'instanceId' implicitly has an 'any' typ... Remove this comment to see the full error message
        function getAllForInstance(instanceId) {
            return $http({
                method: 'GET',
                url: serviceUrlForInstances + '/' + ETWServicesUtils.asId(instanceId) + '/topics',
            });
        }
        /**
         * @method getAllForSeries
         * @param seriesId {number}
         * @returns {object} - promise, Array
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'seriesId' implicitly has an 'any' type.
        function getAllForSeries(seriesId) {
            return $http({
                method: 'GET',
                params: { activeOnly: true },
                url: serviceUrlForSeries + '/' + ETWServicesUtils.asId(seriesId) + '/topics',
            });
        }
        /**
         * @method getFiles
         * @param topicId {number}
         * @returns {object} - promise
         * Request the attached files on the plan
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'topicId' implicitly has an 'any' type.
        function getFiles(topicId) {
            return $http({
                errorMessage: 'Could not retrieve attached files.',
                method: 'GET',
                url: fileServiceUrl + '/' + ETWServicesUtils.asId(topicId),
                // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            }).then(function (response) {
                _.forEach(response.data, function (file) {
                    file.downloadUrl = serviceUrl + '/' + ETWServicesUtils.asId(topicId) + '/file/' + file.id;
                });
                return response;
            }, service.reject);
        }
        /**
         * @method getNew
         * @param options {object}
         * @returns {object} - promise, Object
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'options' implicitly has an 'any' type.
        function getNew(options) {
            var newTopic = _.defaultsDeep(options, { sortId: 0 });
            return ETWServicesUtils.resolve({
                data: newTopic,
            });
        }
        /**
         * @method getNewDiscussionPoint
         * @param authorId {Number} - author user id
         * @param instanceId {Number}
         * @param topicId {Number}
         * @param instanceParticipants {Array} - list of ids
         * @returns {Object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'authorId' implicitly has an 'any' type.
        function getNewDiscussionPoint(authorId, instanceId, topicId, instanceParticipants) {
            return {
                discussionPoint: '<p></p>',
                meetingId: instanceId,
                meetingParticipants: instanceParticipants,
                topicId: topicId,
                userId: authorId,
            };
        }
        /**
         * @method save
         * @param instanceId {number}
         * @param topic {object}
         * @param [changedProperties] {Array}
         * @returns {object} - promise, Object
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'instanceId' implicitly has an 'any' typ... Remove this comment to see the full error message
        function save(instanceId, topic, changedProperties) {
            var options = {
                data: _.cloneDeep(topic),
                errorMessage: 'This topic could not be saved.',
                idName: 'id',
                properties: changedProperties,
                url: serviceUrlForInstances + '/' + ETWServicesUtils.asId(instanceId) + '/topics',
            };
            if (topic.id) {
                options.url =
                    serviceUrlForInstances +
                        '/' +
                        ETWServicesUtils.asId(instanceId) +
                        '/topics/' +
                        ETWServicesUtils.asId(topic.id);
            }
            return ETWServicesUtils.save(options, modelDefinition, 'TopicsService');
        }
        /**
         * @method saveNote
         * @param instanceId {number}
         * @param topicId {number}
         * @param note {string}
         * @param isNoteExtant {boolean} - true if note is PATCH'd, otherwise POST
         * @returns {object} - promise
         * Currently, a topic has one note, that note doesn't have an ID, yet has its own endpoint.
         * isNoteExtant is true if the topic's note is not null. Caller checks topic, then saves note separately.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'instanceId' implicitly has an 'any' typ... Remove this comment to see the full error message
        function saveNote(instanceId, topicId, note, isNoteExtant) {
            // The ID is in the URL, not the body, so not a candidate for using ETWServicesUtils.save()
            var promise = $http({
                method: isNoteExtant ? 'PATCH' : 'POST',
                data: { note: note },
                url: serviceUrlForInstances +
                    '/' +
                    ETWServicesUtils.asId(instanceId) +
                    '/topics/' +
                    ETWServicesUtils.asId(topicId) +
                    '/notes',
            });
            // Show the "Saving…" box. This has to be done manually since we can't use ETWServicesUtils.save().
            ETWServicesUtils.showSaveStatus(promise);
            return promise;
        }
        /**
         * @method saveDiscussionPoint
         * @param instanceId {number}
         * @param topicId {number}
         * @param discussionPoint {string}
         * @param [discussionId] {number}
         * @returns {object} - promise
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'instanceId' implicitly has an 'any' typ... Remove this comment to see the full error message
        function saveDiscussionPoint(instanceId, topicId, discussionPoint, discussionId) {
            var promise = $http({
                method: discussionId ? 'PATCH' : 'POST',
                data: {
                    discussionPoint: discussionPoint,
                },
                url: discussionId
                    ? serviceUrlForInstances +
                        '/' +
                        ETWServicesUtils.asId(instanceId) +
                        '/topics/' +
                        ETWServicesUtils.asId(topicId) +
                        '/discussionpoints/' +
                        discussionId
                    : serviceUrlForInstances +
                        '/' +
                        ETWServicesUtils.asId(instanceId) +
                        '/topics/' +
                        ETWServicesUtils.asId(topicId) +
                        '/discussionpoints',
            });
            ETWServicesUtils.showSaveStatus(promise);
            return promise;
        }
    }
})();

(function () {
    angular.module('App.TrayNav', ['oc.lazyLoad', 'App']);
})();

(function () {
    angular.module('App.TrayNav').component('trayNav', {
        controller: ['$location', 'ETWServicesUtils', 'TrayRouter', '$scope', TrayNavComponentController],
        bindings: {
            closeTray: '&',
            selectedTray: '='
        },
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return TEMPLATE_PATH + '/tray-nav/tray-nav.html';
            },
        ],
    });
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$location' implicitly has an 'any' type... Remove this comment to see the full error message
    function TrayNavComponentController($location, ETWServicesUtils, TrayRouter, $scope) {
        /**
         * @property router
         * @type {object}
         * Use special 'all' name to be notified for all links that need to open a drawer.
         */
        var router = TrayRouter('all');
        /**
         * @property routerSubscribeIndex
         * @type {number}
         * Unique ID used to unsubscribe from the router.
         */
        // @ts-ignore ts-migrate(7034) FIXME: Variable 'routerSubscribeIndex' implicitly has typ... Remove this comment to see the full error message
        var routerSubscribeIndex;
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        /**
         * @listener $onDestroy
         */
        vm.$onDestroy = destroyComponent;
        /**
         * @listener $onInit
         */
        vm.$onInit = init;
        /**
         * @property isShowFab
         * @type {bool}
         */
        vm.isShowFab = true;
        vm.fn = {
            goToNew: goToNew,
            toggleFab: toggleFab,
            toggleTray: toggleTray,
            close: close,
        };
        /**
         * @function destroyComponent
         * @private
         */
        function destroyComponent() {
            // Remove callback from the router
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'routerSubscribeIndex' implicitly has an ... Remove this comment to see the full error message
            router.unsubscribe(routerSubscribeIndex);
        }
        /**
         * @function init
         * @private
         */
        function init() {
            // Register a callback for when the router changes.
            routerSubscribeIndex = router.subscribe(openIfDrawerCalled);
            openOnInit();
        }
        /**
         * @function goToNew
         */
        function goToNew() {
            router = TrayRouter('meetings');
            router.go('meeting-series-settings', {});
        }
        /**
         * @function openIfDrawerCalled
         * @param component {string}
         * @param params {object}
         * @param [drawerName] {string}
         * @returns {object} - promise
         * To close the drawer, don't pass the drawerName.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'component' implicitly has an 'any' type... Remove this comment to see the full error message
        function openIfDrawerCalled(component, params, drawerName) {
            if (params && params.location) {
                vm.tab = params.location;
            }
            var promise;
            if (!drawerName) {
                close();
            }
            else if (vm.selectedTray != drawerName) {
                promise = toggleTray(drawerName);
            }
            // 'all' subscribers are expected to return a promise.
            return promise;
        }
        function openOnInit() {
            var trayParams = $location.search(), seriesId, tray, trayComponent;
            if (trayParams.tray) {
                seriesId = parseInt(trayParams['tray-component-id']);
                tray = trayParams.tray;
                trayComponent = trayParams['tray-component'];
                if (tray === 'action-items') {
                    if (trayComponent) {
                        TrayRouter(tray).open('action-items', { location: trayComponent });
                    }
                    else {
                        TrayRouter(tray).open();
                    }
                }
                else {
                    $location.search('tray', null);
                    $location.search('tray-component', null);
                    $location.search('tray-component-id', null);
                    if (seriesId) {
                        TrayRouter(tray).open(trayComponent, { seriesId: seriesId });
                    }
                    else {
                        TrayRouter(tray).open();
                    }
                }
            }
        }
        /**
         * @function openTray
         * @private
         * @param name {string}
         * Attempts to lazy load a module if drawer is not loaded.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'name' implicitly has an 'any' type.
        function openTray(name) {
            vm.selectedTray = name;
            if (vm.selectedTray === 'meetings') {
                ETWServicesUtils.notify('TrayOpen');
            }
        }
        /**
         * @method toggleFab
         * @param name {bool}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'value' implicitly has an 'any' type.
        function toggleFab(value) {
            vm.isShowFab = value;
        }
        /**
         * @method toggleTray
         * @param name {string}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'name' implicitly has an 'any' type.
        function toggleTray(name) {
            if (vm.selectedTray === name) {
                $location.search('tray', null);
                $location.search('tray-component', null);
                $location.search('tray-component-id', null);
                close();
            }
            else {
                if (name === 'meetings') {
                    $location.search('tray', 'meetings');
                }
                else {
                    $location.search('tray', null);
                    $location.search('tray-component', null);
                    $location.search('tray-component-id', null);
                }
                openTray(name);
            }
        }
        function close() {
            vm.selectedTray = "";
            vm.closeTray();
        }
    }
})();

(function () {
    angular
        .module('App.TrayNav')
        .factory('TrayRouter', ['$ocLazyLoad', '$q', '$timeout', TrayRouterFactory]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$ocLazyLoad' implicitly has an 'any' ty... Remove this comment to see the full error message
    function TrayRouterFactory($ocLazyLoad, $q, $timeout) {
        var drawers = {};
        var subscriptions = {};
        return get;
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'drawerName' implicitly has an 'any' typ... Remove this comment to see the full error message
        function get(drawerName) {
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            if (!drawers[drawerName]) {
                // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                drawers[drawerName] = {
                    component: '',
                    close: close,
                    go: go(drawerName),
                    init: init(drawerName),
                    lazyLoad: lazyLoad,
                    open: open(drawerName),
                    params: {},
                    resolve: $q.resolve,
                    subscribe: subscribe(drawerName),
                    unsubscribe: unsubscribe(drawerName),
                };
            }
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            return drawers[drawerName];
        }
        /**
         * @method close
         * Closes all drawers.
         * Note: This is done indirectly by tray-nav that subscribes to 'all'.
         * Since no drawerName is defined, tray-nav closes the drawers.
         */
        function close() {
            // @ts-ignore ts-migrate(2554) FIXME: Expected 4 arguments, but got 3.
            notify('all', '', {});
        }
        /**
         * @function go
         * @param {string} drawerName
         * @returns {Function}
         * @private
         * Curries the drawerName.
         * Sets the component and params, notifies subscribers to the given drawerName.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'drawerName' implicitly has an 'any' typ... Remove this comment to see the full error message
        function go(drawerName) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'component' implicitly has an 'any' type... Remove this comment to see the full error message
            return function (component, params) {
                // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                drawers[drawerName].component = component;
                // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                drawers[drawerName].params = params;
                // @ts-ignore ts-migrate(2554) FIXME: Expected 4 arguments, but got 3.
                notify(drawerName, component, params);
            };
        }
        /**
         * @method init
         * @param {string} drawerName
         * @returns {Function}
         * Curries a function that sets a default route.
         * If the component/params for the router are not set, set them with defaultComponent/defaultParams
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'drawerName' implicitly has an 'any' typ... Remove this comment to see the full error message
        function init(drawerName) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'defaultComponent' implicitly has an 'an... Remove this comment to see the full error message
            return function (defaultComponent, defaultParams) {
                // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                if (!drawers[drawerName].component) {
                    // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                    drawers[drawerName].component = defaultComponent;
                }
                // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                if (drawers[drawerName].params == undefined || Object.keys(drawers[drawerName].params).length === 0) {
                    // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                    drawers[drawerName].params = defaultParams;
                }
                // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                notify(drawerName, drawers[drawerName].component, drawers[drawerName].params, drawerName);
            };
        }
        /**
         * @method lazyLoad
         * @param $ocConfigModuleName {string}
         * @returns {object} - promise
         * Lazy Load a module.
         * Mappings for $ocConfigModuleName are in app.js
         * Returns a promise so that a component can wait until a module is loaded and initialized.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter '$ocConfigModuleName' implicitly has an ... Remove this comment to see the full error message
        function lazyLoad($ocConfigModuleName) {
            return $ocLazyLoad.load($ocConfigModuleName);
        }
        /**
         * @function notify
         * @param {string} group - drawerName or 'all'
         * @param {string} component
         * @param {object} params
         * @param {string} [targetDrawer] - only needed for subscribers to 'all'
         * @returns {Array}
         * Iterate through all the subscribed callbacks.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'group' implicitly has an 'any' type.
        function notify(group, component, params, targetDrawer) {
            var promises = [];
            // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            if (subscriptions[group]) {
                // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                promises = _.map(subscriptions[group], function (callback) {
                    // Pass 'targetDrawer' only used by the 'all' group
                    return callback(component, params, targetDrawer);
                });
            }
            return promises;
        }
        /**
         * @method open
         * @param {string} drawerName
         * @returns {Function}
         * Curries a function used to open a particular drawer, then navigate to a component.
         * Temporarily navigates to a blank component to clear out any existing drawer components.
         * Usage:
         *   var router = TrayRouter('myDrawer');
         *   router.open('my-component-name', {myParam: 1});
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'drawerName' implicitly has an 'any' typ... Remove this comment to see the full error message
        function open(drawerName) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'component' implicitly has an 'any' type... Remove this comment to see the full error message
            return function (component, params) {
                var promises = notify('all', component, params, drawerName);
                $q.all(promises).then(function () {
                    // Clear out the existing component
                    go(drawerName)('', {});
                    $timeout(function () {
                        // After waiting, load the component
                        go(drawerName)(component, params);
                    });
                });
            };
        }
        /**
         * @method subscribe
         * @param {string} drawerName
         * @returns {Function}
         * Curries a function used to subscribe to the router.
         * Pass in a function and that function will be invoked when the router changes.
         * Note: 3rd param, `targetDrawer`, is only necessary when subscribing to 'all'.
         * Usage:
         *   var router = TrayRouter('myDrawer');
         *   var index = router.subscribe(myFunc);
         *   function myFunc(component, params, targetDrawer) {
         *     ...
         *   }
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'drawerName' implicitly has an 'any' typ... Remove this comment to see the full error message
        function subscribe(drawerName) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'callback' implicitly has an 'any' type.
            return function (callback) {
                var subscriptionId = _.uniqueId();
                if (!subscriptions.hasOwnProperty(drawerName)) {
                    // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                    subscriptions[drawerName] = {};
                }
                // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                subscriptions[drawerName][subscriptionId] = callback;
                return subscriptionId;
            };
        }
        /**
         * @method unsubscribe
         * @param {string} drawerName
         * @returns {Function}
         * Curries a function used to unsubscribe to the router.
         * Used when a component is destroyed.
         * Usage:
         *   var router = TrayRouter('myDrawer');
         *   var index = router.subscribe(myFunc);
         *   vm.$onDestroy = function () {
         *     router.unsubscribe(index);
         *   };
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'drawerName' implicitly has an 'any' typ... Remove this comment to see the full error message
        function unsubscribe(drawerName) {
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'subscriptionId' implicitly has an 'any'... Remove this comment to see the full error message
            return function (subscriptionId) {
                // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                delete subscriptions[drawerName][subscriptionId];
            };
        }
    }
})();

(function () {
    angular.module('App.TrayNav').component('trayTabActionItems', {
        bindings: {
            isOpen: '<',
            onClick: '&',
        },
        controller: [
            '$scope',
            'ActionItemsService',
            'AuthenticationService',
            'TrayRouter',
            TrayTabActionItemsComponentController,
        ],
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return TEMPLATE_PATH + '/tray-nav/tray-tab-action-items/tray-tab-action-items.html';
            },
        ],
    });
    function TrayTabActionItemsComponentController(
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$scope' implicitly has an 'any' type.
    $scope, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'ActionItemsService' implicitly has an '... Remove this comment to see the full error message
    ActionItemsService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AuthenticationService' implicitly has a... Remove this comment to see the full error message
    AuthenticationService, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter
    TrayRouter) {
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        /**
         * @property router
         * @type {object}
         */
        var router = TrayRouter('action-items');
        /**
         * @listener $onChanges
         */
        vm.$onChanges = onBindingsChange;
        vm.$onChanges = change;
        vm.$onInit = init;
        vm.$onDestroy = destroy;
        /**
         * @function onBindingsChange
         * @param bindings {object}
         * If isOpen has changed, determine if the blue pulsing dot should be shown or hidden.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'bindings' implicitly has an 'any' type.
        function onBindingsChange(bindings) {
            if (bindings.isOpen) {
                // isShowInstanceActive is true if:
                // + drawer is closed
                // + current screen is the Meeting Instance detail
                // + that Meeting Instance is not 'completed' (state == 1)
                vm.isShowInstanceActive =
                    !vm.isOpen && router.component == 'action-items' && router.params.state !== 1;
            }
        }
        /**
         * @property listeners
         * @type {array}
         * Hold on to callbacks for unsubscribing.
         */
        // @ts-ignore ts-migrate(7034) FIXME: Variable 'listeners' implicitly has type 'any[]' i... Remove this comment to see the full error message
        var listeners = [];
        /**
         * @property currentUserId
         * @type {number}
         */
        var currentUserId = AuthenticationService.getAccount().userId;
        /**
         * @property status
         * @type {string}
         */
        vm.status = null;
        /**
         * @function init
         */
        function init() {
            listeners = [
                ActionItemsService.subscribeToProperty('completed', getCurrentStatus),
                ActionItemsService.subscribeToProperty('dueDate', getCurrentStatus),
                ActionItemsService.subscribeToOperation('create', unseenActionItem),
                ActionItemsService.subscribeToOperation('destroy', getCurrentStatus),
            ];
        }
        /**
         * @function @change
         * @param bindings {object}
         * @private
         * Note: change runs before init
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'bindings' implicitly has an 'any' type.
        function change(bindings) {
            if (bindings.isOpen && !vm.isOpen) {
                // Tray drawer is closing
                getCurrentStatus();
            }
        }
        /**
         * @function destroy
         */
        function destroy() {
            // @ts-ignore ts-migrate(7005) FIXME: Variable 'listeners' implicitly has an 'any[]' typ... Remove this comment to see the full error message
            _.forEach(listeners, function (listener) {
                listener();
            });
        }
        /**
         * @function getCurrentStatus
         * @private
         */
        function getCurrentStatus() {
            ActionItemsService.getUsersStatus(currentUserId).then(userStatusSuccess, userStatusError);
        }
        /**
         * @function userStatusSuccess
         * @private
         * @param status {object}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'status' implicitly has an 'any' type.
        function userStatusSuccess(status) {
            vm.status = null;
            if (status.itemsOverdue) {
                vm.status = 'pulse-danger';
            }
            else if (status.itemsDueToday) {
                vm.status = 'pulse-warning';
            }
            else if (status.hasNewItems) {
                vm.status = 'pulse-info';
            }
        }
        /**
         * @function unseenActionItem
         * @private
         * @param {object} actionItem
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'actionItem' implicitly has an 'any' typ... Remove this comment to see the full error message
        function unseenActionItem(actionItem) {
            if (actionItem.user === currentUserId) {
                $scope.$applyAsync(function () {
                    vm.status = 'pulse-info';
                });
            }
        }
        /**
         * @function userStatusError
         * @private
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'error' implicitly has an 'any' type.
        function userStatusError(error) {
            console.error('USER STATUS ERROR:', error);
        }
    }
})();

(function () {
    angular.module('App.TrayNav').component('trayTabMeetings', {
        bindings: {
            isOpen: '<',
            onClick: '&',
        },
        controller: ['TrayRouter', TrayTabMeetingsComponentController],
        controllerAs: 'tabVm',
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return TEMPLATE_PATH + '/tray-nav/tray-tab-meetings/tray-tab-meetings.html';
            },
        ],
    });
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'TrayRouter' implicitly has an 'any' typ... Remove this comment to see the full error message
    function TrayTabMeetingsComponentController(TrayRouter) {
        /**
         * @property router
         * @type {object}
         */
        var router = TrayRouter('meetings');
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        /**
         * @listener $onChanges
         */
        vm.$onChanges = onBindingsChange;
        /**
         * @property isShowInstanceActive
         * @type {boolean}
         * Whether or not the template should show the blue pulsing dot.
         */
        vm.isShowInstanceActive = false;
        /**
         * @function onBindingsChange
         * @param bindings {object}
         * If isOpen has changed, determine if the blue pulsing dot should be shown or hidden.
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'bindings' implicitly has an 'any' type.
        function onBindingsChange(bindings) {
            if (bindings.isOpen) {
                // isShowInstanceActive is true if:
                // + drawer is closed
                // + current screen is the Meeting Instance detail
                // + that Meeting Instance is not 'completed' (state == 1)
                vm.isShowInstanceActive =
                    !vm.isOpen && router.component == 'meeting-instance' && router.params.state !== 1;
            }
        }
    }
})();

(function () {
    angular.element(document.body).ready(boot);
    /**
     * @function boot
     * Bootstrap the Angular App.
     * Note: Do this asynchronously (via a timeout) since this file is included before the
     * constants are defined in the index.
     */
    function boot() {
        angular.bootstrap(document.body, ['App'], {
            // Enforce annotations with strictDi
            strictDi: true
        });
    }
})();

(function () {
    angular.module('App').config(['$stateProvider', AuthorizationRoutesConfig]);
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$stateProvider' implicitly has an 'any'... Remove this comment to see the full error message
    function AuthorizationRoutesConfig($stateProvider) {
        // AUTH
        // Note: Internal use only. dev/test/stage/prod do NOT use these routes.
        $stateProvider
            .state('signin', {
            title: 'Sign In',
            public: true,
            url: '/signin?{from}',
            template: '<layout-header></layout-header><signin class="component fullscreen"></signin>',
        })
            .state('reset', {
            title: 'Reset Password',
            public: true,
            url: '/reset?{code}',
            template: '<layout-header></layout-header><reset class="component fullscreen"></reset>',
        })
            .state('set-password', {
            title: 'Set Password',
            public: true,
            url: '/set-password?{token}',
            template: '<layout-header></layout-header><set-password class="component fullscreen"></set-password>',
        });
    }
})();

(function () {
    angular.module('App').component('reset', {
        controller: ['$rootScope', '$state', 'AuthenticationService', AuthorizationResetController],
        controllerAs: 'resetVm',
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return TEMPLATE_PATH + '/authorization/reset/authorization.reset.html';
            },
        ],
    });
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$rootScope' implicitly has an 'any' typ... Remove this comment to see the full error message
    function AuthorizationResetController($rootScope, $state, AuthenticationService) {
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        /**
         * @property
         * @type {boolean}
         */
        vm.emailSent = false;
        vm.fn = {
            sendEmail: sendEmail,
            sendSpecificEmail: sendSpecificEmail,
        };
        /**
         * @property isInProgress
         * @type {boolean}
         * Disables the send button when true.
         */
        vm.isInProgress = false;
        /**
         * @property isSetPassword
         * @type {boolean}
         */
        vm.isSetPassword = $state.params.code;
        /**
         * @method sendEmail
         * When the user clicks the button to reset their password
         */
        function sendEmail() {
            // block form submission
            vm.isInProgress = true;
            AuthenticationService.passwordReset(vm.email, vm.company).then(function resetSuccess(response) {
                if (response.data.length) {
                    vm.possibleUsers = response.data;
                    return;
                }
                //let the user know the request was sent
                $rootScope.$emit('notify', 'Your request has been sent. Please check your email.', 'info');
                vm.emailSent = true;
                //take the user to the signin screen
                $state.go('signin');
                vm.isInProgress = false;
            }, 
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            function resetError(response) {
                console.error('RESET PASSWORD ERROR', response);
                $rootScope.$emit('notify', response.data.error, 'error');
                vm.isInProgress = false;
            });
        }
        /**
         * @method sendSpecificEmail
         * Send email to the chosen account if there are multiple accounts
         */
        // @ts-ignore
        function sendSpecificEmail(user) {
            vm.company = user.clientId;
            sendEmail();
        }
    }
})();

(function () {
    angular.module('App').component('setPassword', {
        controller: [
            '$rootScope',
            '$state',
            'AuthenticationService',
            AuthorizationSetPasswordController,
        ],
        controllerAs: 'passwordVm',
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return TEMPLATE_PATH + '/authorization/set-password/authorization.set-password.html';
            },
        ],
    });
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$rootScope' implicitly has an 'any' typ... Remove this comment to see the full error message
    function AuthorizationSetPasswordController($rootScope, $state, AuthenticationService) {
        /**
         * @property token
         */
        var token = $state.params.token;
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        /**
         * @listener $onInit
         */
        vm.$onInit = init;
        vm.fn = {
            onSubmit: onSubmit,
            onChange: onChange,
        };
        /**
         * @property hasLowercase
         * @type {boolean}
         */
        vm.hasLowercase = false;
        /**
         * @property hasNumberOrSymbol
         * @type {boolean}
         */
        vm.hasNumberOrSymbol = false;
        /**
         * @property hasUppercase
         * @type {boolean}
         */
        vm.hasUppercase = false;
        /**
         * @property hasUsername
         * @type {boolean}
         */
        vm.hasUsername = false;
        /**
         * @property hasValidLength
         * @type {boolean}
         */
        vm.hasValidLength = false;
        /**
         * @property invalidPassword
         * @type {boolean}
         */
        vm.invalidPassword = true;
        /**
         * @property password
         * @type {object}
         */
        vm.password = {
            content: '',
            confirmation: '',
        };
        /**
         * @function init
         * @private
         */
        function init() {
            AuthenticationService.checkToken(token).then(
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            function tokenExpiredSuccess(response) {
                //valid token
            }, function tokenExpiredError() {
                //expired token
                //redirect to password reset
                $state.go('reset', { code: 'true' });
            });
        }
        /**
         * @method onSubmit
         * @param event {Event}
         * @returns {boolean}
         */
        // @ts-ignore ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
        function onSubmit(event) {
            if (!validate()) {
                event.preventDefault();
                event.stopPropagation();
                return false;
            }
            AuthenticationService.setPassword(token, vm.password.content).then(function setPasswordSuccess() {
                vm.hasUsername = false;
                // User is assumed to not be signed in. No need to reload the app.
                // Sign out just in case, but without redirect.
                AuthenticationService.logout(false);
                $state.go('signin').then(function () {
                    $rootScope.$emit('notify', 'Your password was successfully changed, please use your new password to login.', 'success');
                });
            }, 
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            function setPasswordError(response) {
                // If response contains message about using username highlight Note about not using username in password
                vm.hasUsername = _.includes(response.data.error, 'username');
                vm.password.confirmation = '';
                console.error('SET PASSWORD ERROR', response);
            });
        }
        /**
         * @method onChange
         */
        function onChange() {
            vm.invalidPassword = !quickValidate();
        }
        function quickValidate() {
            var isValid = false, password = vm.password.content ? vm.password.content : '';
            vm.hasLowercase = false;
            vm.hasUppercase = false;
            vm.hasNumberOrSymbol = false;
            vm.hasValidLength = false;
            vm.hasUsername = false;
            // Validation: requirements
            if (password.length >= 8 && password.length <= 255) {
                vm.hasValidLength = true;
            }
            if (password.match(/[a-z]/)) {
                vm.hasLowercase = true;
            }
            if (password.match(/[A-Z]/)) {
                vm.hasUppercase = true;
            }
            if (password.match(/[!@#$%^&*()]/) || password.match(/\d/)) {
                vm.hasNumberOrSymbol = true;
            }
            if (vm.hasLowercase && vm.hasUppercase && vm.hasNumberOrSymbol && vm.hasValidLength) {
                isValid = true;
            }
            return isValid;
        }
        /**
         * @function validate
         * @returns {boolean}
         */
        function validate() {
            var isValid = true, password = vm.password.content, charTypeCount = 0;
            // Validation: requirements
            if (password != vm.password.confirmation) {
                $rootScope.$emit('notify', 'The two passwords you entered do not match.', 'error');
                isValid = false;
            }
            if ((isValid && password.length < 8) || password.length > 255) {
                $rootScope.$emit('notify', 'Your password must be between 8 and 255 characters long.', 'error');
                isValid = false;
            }
            if (password.match(/\d/)) {
                charTypeCount += 1;
            }
            if (password.match(/[a-z]/)) {
                charTypeCount += 1;
            }
            if (password.match(/[A-Z]/)) {
                charTypeCount += 1;
            }
            if (password.match(/[!@#$%^&*()]/)) {
                charTypeCount += 1;
            }
            // Validation: violations
            if (isValid && charTypeCount < 3) {
                $rootScope.$emit('notify', 'Your password needs at least three of a lowercase letter, uppercase letter, number or symbol.', 'error');
                isValid = false;
            }
            return isValid;
        }
    }
})();

(function () {
    angular.module('App').component('signin', {
        controller: [
            '$location',
            '$rootScope',
            '$state',
            '$timeout',
            '$window',
            'AuthenticationService',
            AuthorizationSignInController,
        ],
        controllerAs: 'signinVm',
        templateUrl: [
            'TEMPLATE_PATH',
            function (TEMPLATE_PATH) {
                return TEMPLATE_PATH + '/authorization/signin/authorization.signin.html';
            },
        ],
    });
    function AuthorizationSignInController(
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$location' implicitly has an 'any' type... Remove this comment to see the full error message
    $location, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$rootScope' implicitly has an 'any' typ... Remove this comment to see the full error message
    $rootScope, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$state' implicitly has an 'any' type.
    $state, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$timeout' implicitly has an 'any' type.
    $timeout, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter '$window' implicitly has an 'any' type.
    $window, 
    // @ts-ignore ts-migrate(7006) FIXME: Parameter 'AuthenticationService' implicitly has a... Remove this comment to see the full error message
    AuthenticationService) {
        /**
         * @property subdomains
         * @type {Array}
         * Used to grab the customer name if using a vanity domain.
         * There will always be a hostname, even if it is 'localhost'.
         * Splitting a string will always result in an array with length.
         */
        var subdomains = $location.host().split('.');
        // @ts-ignore ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        var vm = this;
        /**
         * @listener $onInit
         */
        vm.$onInit = init;
        /**
         * @property redirectAfterSignIn
         * @type String
         * Base64 encoded string of the AngularJS url when the user signed out
         */
        var redirectAfterSignIn = $state.params && $state.params.from;
        /**
         * @property companyAutoPopulated
         * @type {boolean}
         */
        vm.companyAutoPopulated = !!vm.company;
        /**
         * @property closedAccount
         * @type {boolean}
         * Shows closed account card.
         * Set to true to view until service is built.
         */
        vm.closedAccount = false;
        vm.fn = {
            validateLogin: validateLogin,
        };
        /**
         * @property
         * @type {boolean}
         */
        // TODO: Eventually remove the check for 'app'
        vm.hasSubdomain = subdomains.length > 1 && subdomains[0] !== 'align' && subdomains[0] !== 'app';
        /**
         * @method reload
         * Wrap location.reload for the sake of unit tests
         * This is a work around because stubbing window.location.reload doesn't seem to work.
         */
        vm.reload = function () {
            $window.location.reload();
        };
        /**
         * @function init
         */
        function init() {
            var companyId = $window.localStorage.getItem('login.companyId');
            if (companyId && companyId != 'null') {
                vm.company = companyId;
            }
        }
        /**
         * @function rememberCompanyId
         * Saves the company id to local storage.
         */
        function rememberCompanyId() {
            if (vm.company) {
                $window.localStorage.setItem('login.companyId', vm.company);
            }
        }
        /**
         * @method validateLogin
         * After the user submits login information.
         */
        function validateLogin() {
            var subdomain;
            if (vm.hasSubdomain) {
                subdomain = subdomains[0];
            }
            //update the UI
            vm.sendingRequest = true;
            //request login
            AuthenticationService.authenticate(vm.username, vm.password, vm.company, subdomain)
                .then(
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'token' implicitly has an 'any' type.
            function authenticateSuccess(token) {
                // @ts-ignore ts-migrate(7034) FIXME: Variable 'deferred' implicitly has type 'any' in s... Remove this comment to see the full error message
                var deferred, promise, target;
                //remember the company id
                rememberCompanyId();
                //go the app's landing page
                if (redirectAfterSignIn) {
                    target = AuthenticationService.decodeReferrer(redirectAfterSignIn);
                    if (target.path && (target.userId === 0 || target.userId === token.userId)) {
                        // User ID is the same as the redirect, so go there.
                        $location.url(target.path);
                        deferred = AuthenticationService.defer();
                        $timeout(function () {
                            // @ts-ignore ts-migrate(7005) FIXME: Variable 'deferred' implicitly has an 'any' type.
                            deferred.resolve();
                        }, 1);
                        promise = deferred.promise;
                    }
                    else {
                        // User ID is not the same, so go to the home page.
                        promise = $state.go('app.stream.index', {}, { notify: false });
                    }
                }
                else {
                    // No redirect; go to the home page.
                    promise = $state.go('app.stream.index', {}, { notify: false });
                }
                if (promise) {
                    // Note: Unit test doesn't work if this promise is chained.
                    promise.finally(function () {
                        try {
                            // Reload the browser. Wrapped in a public method for unit testing.
                            vm.reload();
                        }
                        catch (e) {
                            console.error(e);
                        }
                    });
                }
            }, 
            // @ts-ignore ts-migrate(7006) FIXME: Parameter 'response' implicitly has an 'any' type.
            function authenticateError(response) {
                var errorMsg = 'Please check your login credentials.';
                switch (response.status) {
                    case 400:
                        //400 - Non existent client_id, etc.
                        $rootScope.$emit('notify', errorMsg, 'error');
                        break;
                    case 401:
                        //401 - User entered bad credentials
                        var msg = response.data.message;
                        if (msg.indexOf('disabled') !== -1) {
                            errorMsg =
                                'The associated user account is currently disabled, please see your system admin for further help.';
                        }
                        $rootScope.$emit('notify', errorMsg, 'error');
                        break;
                    case 500:
                    // 500 and everything else are the same for now. "falls through" is for jshint.
                    /* falls through */
                    default:
                        //50x - Server errors
                        $rootScope.$emit('notify', 'Error accessing server to login.', 'error');
                }
            })
                .finally(function authenticateDone() {
                try {
                    vm.sendingRequest = false;
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
    }
})();
